import { createI18n } from 'vue-i18n'
const i18n = createI18n({
  // default locale
  locale: 'EN',
  pluralizationRules: {
    /**
     * @param choice {number} индекс выбора, переданный в $tc: `$tc('path.to.rule', choiceIndex)`
     * @param choicesLength {number} общее количество доступных вариантов
     * @returns финальный индекс для выбора соответственного варианта слова
     */
    'UA': function(choice, choicesLength) {
      if (choice === 0) {
        return 0;
      }
      const teen = choice > 10 && choice < 20;
      const endsWithOne = choice % 10 === 1;
      if (choicesLength < 4) {
        return (!teen && endsWithOne) ? 1 : 2;
      }
      if (!teen && endsWithOne) {
        return 1;
      }
      if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
        return 2;
      }
      return (choicesLength < 4) ? 2 : 3;
    },
    'RU': function(choice, choicesLength) {
      if (choice === 0) {
        return 0;
      }
      const teen = choice > 10 && choice < 20;
      const endsWithOne = choice % 10 === 1;
      if (choicesLength < 4) {
        return (!teen && endsWithOne) ? 1 : 2;
      }
      if (!teen && endsWithOne) {
        return 1;
      }
      if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
        return 2;
      }
      return (choicesLength < 4) ? 2 : 3;
    }
  },
  // translations
  messages: {
    UA: {
      tariffLockBadgeLabel: "Pro",
      tariffLockBadgeReadOnlyLabel: "Лише читання",
      tariffLockBadgeQuotaLabel: "Ліміт досягнуто",
      tariffLockBadgeAriaLabel: "{label}: функція обмежена вашим тарифом",
      tariffUpgradeActionLabel: "Покращити тариф",
      tariffLockBadgeOwnerAriaLabel: "{label}: функція обмежена тарифом власника квізу",
      tariffLockBadgeOwnerUnverifiedLabel: "Тариф не перевірено",
      tariffLockBadgeOwnerUnverifiedAriaLabel: "{label}: не вдалося перевірити тариф власника квізу",
      tariffOwnerPlanFeatureUnavailableMessage: "Ця функція недоступна на тарифі власника квізу. Попросіть власника перейти на тариф, який її підтримує.",
      tariffOwnerAccessUnavailableMessage: "Не вдалося перевірити тариф власника квізу. Оновіть сторінку.",
      tariffGateCollaborationForbiddenMessage: "У вас немає прав для цієї дії в цьому квізі.",
      tariffGateQuotaExhaustedMessage: "Ви використали ліміт, доступний на поточному тарифі. Перейдіть на тариф із більшим лімітом.",
      tariffGateGrandfatheredMessage: "Ця функція не доступна на вашому поточному тарифі. Існуючі дані залишаються видимими та можуть бути видалені, але додавання чи редагування вимкнено. Перейдіть на тариф, який підтримує цю функцію.",
      tariffGateReadOnlyMessage: "Ця функція не доступна на вашому поточному тарифі і показана в режимі лише читання. Перейдіть на тариф, який підтримує цю функцію.",
      tariffGateUsageUnavailableMessage: "Не вдалося визначити використання цієї функції. Спробуйте оновити сторінку.",
      tariffGateLoadingMessage: "Перевіряємо доступ за вашим тарифом…",
      tariffGateUnavailableMessage: "Ця функція не доступна на вашому поточному тарифі. Перейдіть на тариф, який підтримує цю функцію.",
      tariffUpgradeModalDescription: "Оберіть тариф, який підтримує цю функцію.",
      tariffUpgradeModalLoading: "Завантаження підходящих тарифів…",
      tariffUpgradeModalError: "Не вдалося завантажити підходящі тарифи. Спробуйте ще раз.",
      tariffUpgradeModalEmpty: "Річні підписки з’являться найближчим часом.",
      tariffUpgradeModalRecommended: "Рекомендований",
      tariffUsageUnlimitedLabel: "Безлімітно",
      tariffUsageUsedOfLimitLabel: "Використано {used} з {limit}",
      tariffUsageUnavailableLabel: "Використання недоступне",
      tariffUsageLoadingLabel: "Завантаження використання…",
      tariffUsageUnknownLabel: "Використання невідоме",
      notFoundEyebrow: 'Сторінку не знайдено',
      notFoundTitle: 'Здається, цей квіз загубився',
      notFoundDescription: 'Посилання може бути неправильним або сторінку вже перемістили. Поверніться до робочого столу та продовжіть створювати квізи.',
      notFoundPrimaryAction: 'На головну',
      notFoundSecondaryAction: 'Назад',
      serverErrorEyebrow: 'Помилка сервера',
      serverErrorTitle: 'Щось пішло не так',
      serverErrorDescription: 'Не хвилюйтеся, ми вже працюємо над цим. Спробуйте оновити сторінку або поверніться до робочого столу.',
      serverErrorPrimaryAction: 'Оновити сторінку',
      serverErrorSecondaryAction: 'На головну',
      madeInUkr: "made in Ukraine",
      upProVersion: "Перейти на PRO",
      getLeads: "Купити Ліди",
      poperBillings: "Платежі",
      poperTemplates: "Шаблони",
      poperPartnership: "Партнерська програма",
      poperProfile: "Профайл",
      poperTeam: "Команда",
      teamDelegatedAccessTitle: 'Передав доступ далі',
      teamAccessTreeRootLabel: 'Джерело доступу',
      teamAccessVia: 'через',
      teamNoQuizNamesAvailable: 'Назви квізів недоступні',
      teamSharedShareTargetPrefix: 'Доступ від',
      teamSharedOwnerFallback: 'власник',
      teamMembersTab: 'Кому я надав доступ',
      teamAccessSourceTab: 'Хто надав доступ мені',
      teamAccessSourceTitle: 'Хто надав доступ мені',
      teamAccessTreeTab: 'Ланцюжки доступу',
      teamAccessTreeTitle: 'Ланцюжки доступу',
      teamAccessTreeDescription: 'Показує шлях доступу: власник → хто запросив → ви → кому ви передали доступ далі',
      teamAccessOwnerLabel: 'Власник',
      teamAccessInviterLabel: 'Надав доступ',
      teamAccessPath: 'Ланцюжок доступу',
      teamAccessYouLabel: 'ви',
      teamSharedByYou: 'Надали ви',
      teamCanReshare: 'Може ділитися далі',
      teamCannotReshare: 'Не може ділитися далі',
      teamPartialReshare: 'Частково може ділитися',
      teamMixedRoles: 'Змішані ролі',
      teamNoAccessTree: 'Ланцюжки зʼявляться, коли ви передасте доступ далі',
      poperLogout: "Вихід",
      poperIdea: "Запропонувати ідею",
      poperIdeaTitle: "Маєте ідею для покращення платформи?",
      poperIdeaText: "Поділіться нею з нами! Ваші пропозиції допомагають нам розвиватися та створювати кращий досвід для вас.",
      poperIdeaTextPlaceholder: "Детально опишіть свою ідею",
      poperIdeaSendButton: "Відправити пропозицію",
      defaultNewQuestion: "Нове запитання",
      defaultNewQuestionDescription: "Сюди ви можете вставити короткий опис запитання (до 80 символів)",
      defaultNewVariant: "Новий варіант",
      defaultBtnText: "Розпочати",
      navBillings: "Платежі",
      navPartnership: "Партнерська програма",
      navProfile: "Профайл",
      navTariffs: "Тарифи",
      holidayBannerTitleLastOffer: "Фінальна пропозиція року:",
      holidayBannerDefaultTitle: "Обмежена пропозиція",
      holidayBannerFrom: "з",
      holidayBannerTo: "по",
      holidayBannerCta: "Отримати знижку",
      holidayBannerAuthTitle: "Увійдіть, щоб отримати знижку",
      holidayBannerAuthText: "Авторизуйтеся, щоб застосувати цю пропозицію та зберегти її для вашого акаунта.",
      holidayBannerAuthAction: "Зрозуміло",
      holidayBannerClose: "Закрити банер",
      welcomeBack: "З поверненням!",
      loginHeader: "Увійти",
      loginHeader2Part: "щоб продовжити",
      loginEmailPlaceholder: "E-mail",
      loginPasswordlPlaceholder: "○ ○ ○ ○ ○ ○ ○ ○ ○",
      loginBtnValue: "Увійти",
      loginWith: "Увійти за допомогою",
      loginSignup: "Зареєструватись",
      passwordAreForgetPassword: "Забули пароль?",
      passwordResetPasswordHeader: "Відновлення паролю",
      passwordResetPassword: "Відновити пароль",
      passwordWeSentReset: "Ми надіслали вам посилання на відновлення паролю на електронну пошту.",
      passwordInputNewPassword: "Введіть новий пароль",
      passwordConfirmPassword: "Підтвердіть пароль",
      passwordCreatePassword: "Створіть пароль",
      passwordChangePassword: "Змінити пароль",
      passwordResetedPasswordCompleted: "Ваш пароль успішно змінено!",
      passwordGoToWorkboard: "Перейти в акаунт",
      helloHeader: "Вітаємо!",
      signupHeader: "Зареєструватись",
      signupHeader2Part: "щоб продовжити",
      signupNamePlaceholder: "Олександр",
      signupPhonePlaceholder: "номер телефону",
      signupEmailPlaceholder: "E-mail",
      signupPasswordlPlaceholder: "○ ○ ○ ○ ○ ○ ○ ○ ○",
      signupBtnValue: "Створити аккаунт",
      signupWith: "Зареєструватись за допомогою",
      signupLogin: "Увійти в мій аккаунт",
      signupTariffHeader: "Тарифи",
      signupTariffFree: "Free.",
      signupTariffPro: "Pro.",
      signupTariffFreeDescription: "Безлімітна кількість створення нових квізів (веб сторінок). Можливість генерувати до 300 заявок в місяць безкоштовно.",
      signupTariffProPrice: "$20 / місяць",
      signupTariffProDescription: "Безлімітна кількість створення нових квізів (веб сторінок). Можливість генерувати",
      signupTariffProDescriptionBold: "понад 300 заявок.",
      userBackToQuiz: "Повернутись на воркборд",
      userBackToSettings: "Повернутись до налаштувань",
      learningCenterTitle: "Навчальний центр",
      learningCenterTraining: "Навчання",
      learningCenterIntroText: "Перегляньте всі обов'язкові відеогіди по черзі, підтвердьте кожен урок після завершення та запросіть сертифікат після фінального уроку.",
      learningCenterVideoUnsupported: "Ваш браузер не підтримує HTML5 відео.",
      learningCenterAvailable: "Доступно",
      learningCenterLessonsComplete: "Уроків завершено",
      learningCenterBackToLearningCenter: "Повернутись до Learning center",
      learningCenterCertificate: "Сертифікат",
      learningCenterCourseCompleted: "Курс завершено",
      learningCenterCertificateSentText: "Усі уроки завершено. Запит на сертифікат відправлено на бекенд.",
      learningCenterCertificateLabel: "Adsquiz Learning Center",
      learningCenterCertificateOfCompletion: "Сертифікат про завершення",
      learningCenterDownloadCertificate: "Завантажити сертифікат",
      learningCenterDownloadUnavailable: "Завантаження поки недоступне",
      learningCenterOpenCertificate: "Відкрити сертифікат",
      learningCenterAbout: "Про урок",
      learningCenterOpenFallbackLink: "Відкрити резервне посилання",
      learningCenterBack: "Назад",
      learningCenterCompleted: "Завершено",
      learningCenterWatchVideoToEnd: "Перегляньте відео до кінця",
      learningCenterSaving: "Збереження...",
      learningCenterMarkAsCompleted: "Позначити як завершене",
      learningCenterWatchedPercent: "{percent}% переглянуто",
      learningCenterDefaultUserName: "Користувач Adsquiz",
      learningCenterCertificateReadyMessage: "Бекенд повернув файл сертифіката. Використайте кнопку вище, щоб відкрити його.",
      learningCenterCertificatePendingMessage: "Запит на сертифікат відправлено. Додайте URL для завантаження з бекенду, коли він буде доступний.",
      learningCenterCertificateNoUrlMessage: "Запит на сертифікат виконано, але URL файлу ще не повернувся.",
      learningCenterCertificateErrorMessage: "Поки не вдалося підтвердити запит на сертифікат через бекенд. Локальне завершення збережено.",
      learningCenterSectionGeneral: "Загальні",
      learningCenterSectionIterationsIntro: "Вступ до ітерацій",
      learningCenterSectionIterationIntro: "Вступ до ітерації",
      billingYourTariff: "Ваш тарифний план",
      billingYourTariffShortForm: "Ваш план",
      billingYourPro: "Pro",
      billingYorFree: "Free",
      billingFreeLeads: "Безкоштовних заявок",
      billingInfinity: "безліміт",
      billingTariffRenewData: "Дата оновлення тарифу",
      billingTariffEndData: "Дата закінчення тарифу",
      billingOtherTariffFree: "Free.",
      billingOtherTariffPro: "Pro.",
      billingTariffFreeDescription: "Безлімітна кількість створення нових квізів (веб сторінок). Можливість генерувати до 300 заявок безкоштовно.",
      billingYouHavePro: "Зараз ви на Pro версії. Навіщо робити крок назад?",
      billingYouHasFreeLeads: "Залишилось безкоштовних заявок",
      billingYouHasLeads: "Залишилось заявок",
      billingTariffProDescription: "Безлімітна кількість створення нових квізів (веб сторінок). Можливість генерувати",
      billingTariffProDescriptionBold: "понад 300 заявок.",
      billingYourFutureTariff: "Ваш майбутній тариф",
      billingBtnChangeToPro: "Перейти",
      billingBtnRenewPro: "Оновити",
      billingBillings: "Оплати",
      billingYouHaveNotBillings: "У вас поки що немає оплат",
      billingPaymentsMethod: "Метод оплати",
      billingPaymentCard: "Карта",
      billingChangeData: "Змінити дані",
      billingDeletePayMethod: "Видалити",
      billingModalDeleteShure: "Ви дійсно хочете видалити цей спосіб оплати?",
      billingModalDeleteCancel: "Відмінити",
      billingModalDeleteOk: "Видалити",
      billingModalDeleteSuccess: "Ви успішно видалили свою карту",
      billingModalRegularPaymentDeleteSuccess: "Регулярні платежі відмінено",
      billingModalRegularPaymentDeleteOk: "ОК",
      billingYourMonthPlan: "Ваш щомісячний план",
      billingLeads: "заявок",
      billingChangePlan: "Змінити план",
      billingChangePlanDescription: "Прайс буде відповідним до бажаної кількості заявок з усіх квізів у вашому аккаунті.",
      billingSelectPeriod: "Обрати період",
      billingChangePlanDescriptionImportant: "Важливо:",
      billingChangePlanDescriptionImportantMonth: "Ліди можна використовувати 1 місяць після покупки",
      billingChangePlanDescriptionImportantMonthAfterBuy: " після покупки.",
      subscriptionTariffLable: "Підпишіться на нашу автоматичну підписку.",
      billingChangePlanWarning: "Придбані ліди будуть ",
      billingTariffMonth: "міс.",
      billingChangePlanPay: "Придбати",
      profileName: "Ім’я",
      profilePhone: "Номер",
      profileEmail: "E-mail",
      profileStatus: "Статус",
      profileStatusAgency: "Агенція",
      profileStatusPlaceholder: "Виберіть що вас найкраще описує",
      profileStatusFreelancer: "Фрілансер",
      profileStatusBuisines: "Власник бізнесу",
      profilePassword: "Пароль",
      profileChangePassword: "Змінити пароль",
      profileNewPassword: "Новий пароль",
      profileSaveNewData: "Оновити дані",
      workboardStartTooltip: "Тут ви можете створити свій перший квіз",
      workboardAddNewQuiz: "Створити проєкт",
      workboardModalGiveQuizName: "Дайте назву квізу",
      workboardModalQuizNamePlaceholder: "Новий квіз",
      workboardModalNewQuizBtnValue: "додати",
      workboardAlertGiveAnyName: "Введіть хоч якусь назву",
      workboardAlertNextTimeAddQuiz: "Що ж, наступного разу наважитесь)",
      workboardChangeQuizName: "Змінити назву",
      workboardQuizLink: "лінк",
      workboardQuizLinkCopied: "Посилання скопійовано в буфер",
      workboardEditQuiz: "Редагувати",
      workboardCopyQuiz: "Скопіювати квіз",
      workboardQuizCopied: "Квіз успішно скопійовано",
      workboardDeleteQuiz: "Видалити",
      workboardTransferQuizPlaceholderInput: "Введіть електронну адресу користувача",
      workboardTextAllQuizes: "Усі квізи",
      workboardTextProjects: "Проєкти",
      workboardTransferQuiz: "Перенести квіз на інший аккаунт",
      workboardTransferProject: "Додати до проєкту",
      workboardTransferQuizCancel: "Скасувати",
      workboardTransferQuizLabel: "Назва квіза",
      workboardTransferQuizTitle: "Перевірте свої знання про збереження навколишнього середовища!",
      workboardTransferQuizHintTitle: "При перенесенні квіза всі заявки будуть перенесені разом із ним.",
      workboardTransferQuizHintTitleSecond: "Щоб перенести квіз із заявками, один із користувачів повинен мати будь-який ",
      workboardTransferQuizHintTitleSecondLink: "https://app.adsquiz.io/tariffs",
      workboardTransferQuizHintTitleSecondLinkText: "платний пакет.",
      workboardTransferQuizConfirm: "Перенести",
      workboardTransferQuizNoValidEmail: "Невірна електронна адреса",
      workboardTransferQuizStatus200: "Квіз успішно перенесено на:",
      workboardTransferQuizStatus401: "Неавторизовано — Користувач не автентифікований.",
      workboardTransferQuizStatus403: "Заборонено — У вас немає доступу для перенесення цього квіза.",
      workboardTransferQuizStatus404: "Не знайдено — Квіз або користувач-отримувач не знайдені.",
      workboardTransferQuizStatus422: "Неможливо обробити — Принаймні один з користувачів повинен мати платний акаунт.",
      workboardTransferQuizStatusError: "Неочікуваний статус помилки",
      workboardModalRemoveQuizTrash: "Цей квіз буде переміщена до кошика і остаточно видалено через 1 місяць.",
      workboardModalRemoveQuizSure: "Ви впевнені, що хочете перемістити цей квіз до кошика?",
      workboardModalRemoveProjectTrash: "Проєкт і всі його квізи буде повністю видалено.",
      workboardModalRemoveProjectSure: "Ви впевнені, що хочете видалити цей проєкт?",
      workboardModalDeleteQuizCancel: "Відмінити",
      workboardModalDeleteQuizDelete: "Видалити",
      workboardModalDeleteQuizSuccess: "Квіз успішно видалено",
      workboardModalDeleteProjectSuccess: "Проєкт успішно видалено",
      workboardModalQuizDeleteOk: "ОК",
      workboardStatsTitle: "Статистика",
      workboardModalLeadsAnswersCount: "Відповіді на квіз ",
      workboardModalLeadsLeadSerial: "№",
      workboardModalLeadsLeadDate: "Дата",
      workboardModalLeadsLeadEmail: "Email",
      workboardModalLeadsLeadName: "Ім'я",
      workboardModalLeadsLeadPhone: "Телефон",
      workboardModalLeadsLeadPoints: "Бали",
      workboardModalLeadsLeadActions: "Дії",
      workboardModalLeadsLeadShowMore: "Показати більше",
      workboardModalLeadsLeadHideMore: "Приховати",
      workboardModalLeadsLeadAnswerScipped: "Пропущено",
      workboardModalNoLeads: "Поки що заявок немає",
      constructorLink: "лінк",
      constructorLinkCopied: "Скопійовано в буфер обміну:",
      constructorNavSteps: "Кроки",
      constructorNavDesign: "Дизайн",
      constructorNavSettings: "Налаштування",
      constructorStep: "крок",
      cancel: "Відмінити",
      constructorCancel: "Відмінити",
      constructorSave: "Зберегти",
      constructorextraNavStart: "С",
      constructorextraNavContact: "К",
      constructorextraNavFinish: "Ф",
      cstepsSection: "Секції",
      cstepsStartPage: "Стартова сторінка",
      cstepsContactPage: "Форма контактів",
      cstepsFinishPage: "Фінішна сторінка",
      cstepsEdit: "Редагувати",
      cstepsMove: "Перемістити",
      cstepsDeleteStep: "Видалити крок",
      cstepsAddSection: "Додати секцію",
      cdesignColorTheme: "Схема кольорів",
      cdesignCustomTheme: "Власна схема кольорів",
      cdesignDefaultThemes: "Готові схеми кольорів",
      cdesignThemeStandart: "Стандарт",
      cdesignThemeDark: "Дарк",
      cdesignThemeNud: "Нюд",
      cdesignThemeGradient: "Градієнт",
      cdesignShapeDesign: "Форма дизайну",
      cdesignShapeRound: "Заокруглена",
      cdesignShapeSquare: "Кутова",
      cdesignShapeRectangle: "Прямокутник",
      cdesignShapeCircle: "Коло",
      cdesignPositionLeft: "Ліворуч",
      cdesignPositionRight: "Праворуч",
      cdesignPositionMiddle: "Посередині",
      cdesignPositionTop: "Зверху",
      cdesignPositionBottom: "Знизу",
      csettingsIntegration: "Інтеграції",
      csettingsOweDomain: "Підключення власного домену",
      csettingsDocs: "Юридичні документи",
      cintegrationIntegration: "Інтеграції",
      cintegrationShareLeads: "Передача заявок",
      cintegrationTitleEmail: "E-MAIL",
      cintegrationInstruction: "Інструкція",
      cintegrationInstructionDetail: "Деталі",
      cintegrationEmailInstruction: "Вставте в поле знизу потрібну електронну адресу, на яку необхідно відправляти інформацію. Кожна заявка з цього квіза буде дублюватися на вказану вами пошту.",
      cintegrationPublishAfterEdit: "Збережіть квіз після редагування",
      cintegrationSendNewLeadsTo: "Надсилати повідомлення про нові заявки на:",
      cintegrationInputEmail: "Введіть адресу електронної скриньки",
      cintegrationAddEmail: "Додати email",
      cintegrationEmailSaved: "Дані Email інтеграції збережено",
      cintegrationEmailDeleted: "Дані Email інтеграції видалено",
      cintegrationTitleFB: "FB pixel",
      cintegrationIDPixel: "Pixel ID",
      cintegrationFBInstruction1: "Зайдіть до рекламного кабінету Facebook Ads і у розділі Event Manager скопіюйте ID Facebook Pixel.",
      cintegrationFBInstruction2: "Не копіюйте весь код, лише ідентифікатор із 15-16 цифр.",
      cintegrationFBInstruction3: "Скопіюйте та вставте в поле нижче.",
      cintegrationFBInstruction: 'Подія на яку потрібно налаштовувати конверсію це "Lead". Ця подія буде викликана як тільки користувач усішно відправить заявку в квізі.',
      cintegrationFBInstructionTextTitle: "Перелік усіх подій, які ми надсилаємо:",
      cintegrationFBInstructionTextTextStart: " – відвідування стартової сторінки;",
      cintegrationFBInstructionTextQuestionN: " – відвідування кроку N;",
      cintegrationFBInstructionTextOpenContactPage: " – відвідування сторінки контактів;",
      cintegrationFBInstructionTextLead: " – успішне відправлення форми з контактними даними;",
      cintegrationFBInstructionTextThankYou: " – відвідування фінальної сторінки.",
      bold_adsquiz_Start: "adsquiz_Start",
      bold_adsquiz_QuestionN: "Question_N",
      bold_adsquiz_OpenContactPage: "Open_Contact-Page",
      bold_adsquiz_Lead: "Lead",
      bold_adsquiz_ThankYou: "adsquiz_ThankYou",
      cintegrationInputIDPixel: "Введіть ID пікселя",
      cintegrationDataFBSaved: "Дані FB пікселя збережено",
      cintegrationAccesToken: "ACCES TOKEN",
      cintegrationTitleGA: "Google analytics",
      cintegrationGAInstructionDescription: "Дізнайтеся, як люди знаходять ваш квіз та взаємодіють з ним. Отримайте дані, необхідні для аналізу кампаній, покращення конверсій тощо. ",
      cintegrationGAInstruction: 'При отриманні заявки в квізі в Google Analitics буде викликана подія "generate_lead".',
      cintegrationIDFolow: "ID відстеження",
      cintegrationInputID: "Введіть ID",
      cintegrationDataGASaved: "Дані Google analytics збережено",
      cintegrationTitleGTM: "Google Tag Manager",
      cintegrationGTMInstructionDescription: "Опис для Google Tag Manager. (не використовується)",
      cintegrationGTMInstruction: "Скопіюйте індификатор Google Tag Manager та вставте в поле нижче.",
      cintegrationDataGTMSaved: "Дані Google Tag Manager збережено",
      cintegrationTitleTG: "Telegram",
      cintegrationHowReciveTGLeadBot: "Як отримати заявки в Телеграм бот?",
      cintegrationTGInstructionBot1: "1. Скопіюйте token у полі нижче.",
      cintegrationTGInstructionBot2: "2. Перейдіть за посиланням в бот, натисніть кнопку «ПОЧАТИ».",
      cintegrationTGInstructionBot3: "3. Скопійований token надішліть повідомленням в наш бот.",
      cintegrationHowReciveTGLeadChat: "Як отримати заявки в чат-телеграм?",
      cintegrationTGInstructionChat1: "1. Додайте наш бот в потрібний чат та виставте боту статус адміністратора.",
      cintegrationTGInstructionChat2: "2. Скопіюйте token у полі нижче і відправте його в потрібний чат.",
      cintegrationTGInstructionChat3: "3. Дочекайтесь відповіді `OK! Your quiz token was saved!”",
      cintegrationTGInstructionChat4: "4. Тепер заявки будуть надходити в цей чат.",
      cintegrationTGInstructionWarning: "Важливо:",
      cintegrationTGInstructionWarningText: "Зверніть увагу що це повинна бути саме група, а не Telegram канал. В Telegram канал заявки надходити не будуть.",
      cintegrationTGBotLink: "лінк на чатбот",
      cintegrationTGTitleToken: "TOKEN",
      cintegrationInputTGToken: "Введіть телеграм токен чатботу",
      cintegrationAddIntegration: "Додати інтеграцію",
      cintegrationDataTGSaved: "Дані Telegram інтеграції збережено",
      cintegrationTitleTT: "TT pixel",
      cintegrationTTInstruction: "Для відстеження подій у рекламному кабінеті Tik-Tok Ads скопіюйте ідентифікатор пікселя та вставте в поле нижче.",
      cintegrationDataTTSaved: "Дані TT пікселя збережено",
      cintegrationTitleWH: "WebHook",
      cintegrationWHInstruction1: "Ви можете сповіщати сторонні додатки про заяви, що надійшли. Для цього вкажіть URL, на який буде надіслано WebHook.",
      cintegrationWHInstruction2: "Ми підготували",
      cintegrationWHInstruction3: "відео інструкцію",
      cintegrationWHInstruction4: "з докладним описом даного функціоналу.",
      cintegrationWHInstruction5: "Переглянути відео.",
      cintegrationWHInstruction6: "У цьому відео ми розглянемо передачу хука на основі відправлення даних до Google таблиці та відправлення даних до CRM-системи Trello.",
      cintegrationWHInstruction7: "Ми рекомендуємо використовувати для цього сервіс",
      cintegrationWHInstruction8: "При реєстрації за цим посиланням, для наших користувачів діють бонус - 10 000 безкоштовних дій для будь-яких інтеграцій.",
      cintegrationWHInstruction9: "Посилання",
      cintegrationWHInstruction10: "для реєстрації з бонусом.",
      cintegrationWHUrl: "Адреса вебхуку",
      cintegrationInputWHUrl: "Введіть адресу вебхуку",
      cintegrationAddWH: "Додати Web-hook",
      cintegrationWebHookDataSaved: "WebHook дані збережено",


      cintegrationComonWHInstructionShort: "Ви можете сповіщати сторонні програми про надходження лідів. Вкажіть URL-адресу вебхука для відправки даних.",
      cintegrationComonWHInstruction1Title: "1. Вставте URL-адресу вебхука в поле для введення:",
      cintegrationComonWHInstruction1Description: "Вставте URL-адресу вебхука, наданого вашим сервісом або додатком, в поле для введення.",
      cintegrationComonWHInstruction2Title: "2. Збережіть зміни:",
      cintegrationComonWHInstruction2Description: 'Натисніть кнопку "Зберегти зміни", щоб зберегти налаштування вебхука.',
      cintegrationComonWHInstruction3Title: "3. Готово:",
      cintegrationComonWHInstruction3Description: "Тепер ваш вебхук налаштований для відправки даних на обраний вами сервіс.",
      cintegrationComonWHInstructionAdditional: "Дані будуть відсилатися на вебхук при кожному отриманні ліда. Метод відправки - POST. Приклад даних, які будуть відправлені, розташований ",
      cintegrationComonWHInstructionAdditionalLink: "тут",
      cintegrationComonWHInstructionVideo: "Детальна відео-інструкція",
      
      cintegrationApixDriveWHInstructionShort: "Ви можете сповіщати ApixDrive про надходження лідів. Для цього вкажіть URL-адресу, на яку буде відправлено вебхук.",
      cintegrationApixDriveWHInstructionShort1: "При реєстрації за ",
      cintegrationApixDriveWHInstructionShort2: "цим посиланням",
      cintegrationApixDriveWHInstructionShort3: " наші користувачі отримують бонус - 10 000 безкоштовних дій для будь-яких інтеграцій.",
      cintegrationApixDriveWHInstruction1Title: "1. Зареєструйтеся або відкрийте свій акаунт ApixDrive:",
      cintegrationApixDriveWHInstruction1Description1: "Посилання ",
      cintegrationApixDriveWHInstruction1Description2: "для реєстрації з бонусом.",
      cintegrationApixDriveWHInstruction2Title: "2. Отримайте URL-адресу для вебхука:",
      cintegrationApixDriveWHInstruction2Description1: "Зайдіть в налаштування необхідного зв'язку і скопіюйте адресу для відправки вебхука:",
      cintegrationApixDriveWHInstruction2Description2: 'Ви можете створити новий зв\'язок, натисканням кнопки "Створити зв\'язок", і на кроці вибору системи оберіть "ADSQuiz".',
      cintegrationApixDriveWHInstruction3Title: "3. Вставте URL-адресу вебхука:",
      cintegrationApixDriveWHInstruction3Description: "Вставте URL-адресу вебхука, наданого ApixDrive, в поле для введення.",
      cintegrationApixDriveWHInstruction4Title: "4. Збережіть зміни:",
      cintegrationApixDriveWHInstruction4Description: 'Натисніть кнопку "Зберегти зміни", щоб зберегти налаштування вебхука.',
      cintegrationApixDriveWHInstruction5Title: "5. Готово:",
      cintegrationApixDriveWHInstruction5Description: "Тепер ваш вебхук налаштований для відправки даних на ApixDrive.",
      cintegrationApixDriveWHInstructionAdditional: "Дані будуть відсилатися на вебхук при кожному отриманні ліда. Метод відправки - POST. Приклад даних, які будуть відправлені, розташований ",
      cintegrationApixDriveWHInstructionAdditionalLink: "тут",
      cintegrationApixDriveWHInstructionVideo: "Детальна відео-інструкція",
      



      cintegrationConnectOweDomain: "Підключення власного домену",
      cintegrationOweDomainInstruction1: "1. Щоб розмістити ваш квіз на необхідному домені, зайдіть в обліковий запис вашого хостингу. Перейдіть в DNS-налаштування та створіть A-запис з параметром IP: 185.25.117.21",
      cintegrationOweDomainInstruction2: "2. В полі вищще вкажіть домен і збережіть квіз.",
      cintegrationDomain: "Домен",
      cintegrationInputYourDomain: "Введіть ваш домен",
      cintegrationCheckDomenIsCorrect: "Перевірьте правильність введеного домену",
      cintegrationDomainWhichCorrect: "Введіть домен без протоколів. наприклад: some.site.com",
      cintegrationInsertedDefaultDomain: "Домен встановлено за замовчуванням",
      cintegrationDomainDataSaved: "Дані домену збережено",
      cintegrationPrivacyPolicy: "Політика конфіденційності",
      cintegrationPrivacyPolicyByDefault: "За умовчанням ми використовуємо нашу стандартну політику конфіденційності. Ми рекомендуємо додати вашу політику конфіденційності, яка буде актуальною для вашого бізнесу.",
      cintegrationPrivacyPolicyAdventage: "Це дасть зрозуміти вашим потенційним клієнтам, як ви використовуєте отримані контактні дані. Також цього вимагають деякі рекламні майданчики.",
      cintegrationPrivacyPolicyUrl: "Посилання на ваші документи",
      cintegrationPrivacyPolicyInputYourDocsLink: "Вставте посилання на документи",
      cintegrationDocsDataSaved: "Посилання на ваші документи збережено",
      allstepsUpploadPhoto: "Завантажити фото",
      unsplashSelectorButtonText: "Обрати з Unsplash",
      unsplashSelectorTitle: "Завантажити зображення",
      unsplashSelectorDragImage: "Перетягніть зображення сюди або",
      unsplashSelectorUploadFile: "завантажте файл",
      unsplashSelectorSearchPlaceholder: "Пошук зображення на Unsplash",
      unsplashSelectorLoadingImages: "Завантаження зображень...",
      unsplashSelectorLoadingMoreImages: "Завантаження додаткових зображень...",
      unsplashSelectorNoImagesFound: "Зображень не знайдено",
      unsplashSelectorUnavailable: "Unsplash зараз недоступний. Ви можете завантажити файл.",
      unsplashSelectorClose: "Закрити",
      allstepsChangePhoto: "Змінити фото",
      allstepsDeletePhoto: "Видалити фото",
      allstepsTitle: "Заголовок",
      allstepsDescription: "Опис",
      allstepsButtonText: "Текст кнопки",
      allstepsOtherSettings: "Інші налаштування",
      allstepsIsSaveBeforeRoute: "Зберегти данні перед переходом?",
      cfirstFormat: "Формат",
      cfirstHeaderStartText: "Ваш заголовок має бути тут. Мотивуйте користувачів пройти квіз до кінця",
      cfirstAddMediafile: "Додати медіафайл (фото)",
      cfirstBonus: "Бонус",
      cfirstAddBonus: "Додати бонус",
      cfirstStartPageDataUpdated: "Дані стартової сторінки оновлені",
      csanyAnswerType: "Тип запитання",
      csanyATCard: "картка",
      csanyATList: "список",
      csanyATCustom: "вільне поле",
      csanyQuestion: "Запитання",
      csanyAnswers: "Відповіді",
      csanyAddAnswer: "Додати",
      csanyTitleForModalConfirm: "Ця дія незворотна!",
      csanyQuestionForModalConfirm: "Ви дійсно хочете видалити це питання?",
      csanyRequiredStep: "Обов'язковий крок",
      csanyAlowMultiple: "Дозволити декілька відповідей",
      csanyAutoRedirect: "Автоматичний перехід далі",
      csanyQuestionLogic: "Налаштування логіки питань",
      csanyDataStepUpdated: "Дані сторінки з запитанням оновлені",
      cformForm: "Форма",
      cformValueName: "Ім'я",
      cformValueSurname: "Прізвище",
      cformValuePhone: "Номер телефону",
      cformValueEmail: "E-mail",
      cformDataContactsPageUpdated: "Дані контактної сторінки оновлені",
      cformRequiredInput: "Обов'язкове",
      cfinishFinishPageTitle: "Фінішна сторінка",
      cfinishText: "Текст",
      cfinishDescription: "Опис",
      cfinishAddImage: "Додати зображення",
      cfinishImageAdded: "Зображення додано",
      cfinishURL: "URL",
      cfinishButtonText: "Текст кнопки",
      cfinishInsertNikname: "Вставте сюди ваш нікнейм",
      cfinishCheckDataIsCorrect: "Перевірьте правильність введеного ідентифікатора",
      cfinishFbWhichCorrect: "Введіть ідентифікатор (нікнейм) без адреси. Наприклад: some.name",
      cfinishIgWhichCorrect: "Введіть ідентифікатор (нікнейм) без адреси. Наприклад: some.name",
      cfinishTgWhichCorrect: "Введіть ідентифікатор (нікнейм) без адреси. Наприклад: some.name",
      cfinishFinishPageDataUpdated: "Дані фінішної сторінки оновлені",
      adminUsersReg: "Користувачів в системі",
      adminNewUsers: "Нових користувачів за місяць",
      adminProAccounts: "PRO accounts",
      adminLTV: "LTV",
      adminSharePro: "PRO відносно усіх",
      adminReciveLeads: "Отримано заявок",
      adminLeadsForOne: "На одного юзера",
      adminMadeQuiz: "Зроблено квізів",
      adminQuizForOne: "На одного юзера",
      adminAvarageUsed: "Середня кількість місяців використання",
      adminProfitMonth: "Зароблено за місяць",
      adminProfitAlltime: "Зароблено за весь час",
      adminUsersList: "База користувачів",
      notificationErrorLogin: "Помилка авторизації:",
      notificationLogin: "Вхід...",
      notificationWrongLoginData: "Неправильні дані для входу",
      notificationLoginAccountBlocked: "Ваш обліковий запис заблоковано",
      notificationCanContactSupport: "Ви можете звернутися до служби підтримки",
      notificationEmailExistsMessage: "Обліковий запис із такою поштою вже зареєстровано",
      notificationNetworkError: "Перевірте з'єднання з інтернетом",
      notificationInputLoginData: "Введіть данні для входу",
      notificationCheckInputEmail: "Перевірте правильність електронної пошти",
      notificationCheckInputEmailOrUserNotFound: "Перевірте правильність електронної пошти. Користувача не знайдено",
      notificationCheckInputPhone: "Перевірте правильність номеру телефону",
      notificationInputAllInputs: "Заповніть всі поля для реєстрації",
      notificationAgreePrivacyPolicy: "Погодьтесь з політикою конфіденційності",
      adminEditorForPartnership: "Редактор партнерської програми",
      developmentPage: "Розділ знаходиться в розробці",
      signupAgreeIAgreeWith: "Я ознайомився та погоджуюсь з",
      signupAgreePolicy: "політикою конфіденційності",
      signupAgreeAnd: "та",
      signupAgreeOffer: "умовами користування",
      signupAgreeService: "сервісу",
      workboardModalLeadsLeadReferrer: "Не визначено",
      workboardEditTitle: "Редагувати назву",
      workboardEditIcon: "Редагувати іконку",
      workboardSaveChange: "Зберегти зміни",
      workboardModalLeadsLeadReferrerClarification: "Дані про джерело переходу заблоковані або не визначені",
      workboardModalLeadsLeadEmailCopied: "Email скопійовано до буферу",
      workboardModalLeadsLeadPhoneCopied: "Номер телефону скопійовано до буферу",
      workboardModalLeadsHaveNotSended: "Ви маєте неотримані ліди",
      workboardModalLeadsLeadReload: "Отримати",
      workboardModalLeadsLeadReloadedTitle: "Запит отримано",
      workboardModalLeadsLeadReloaded: "Якщо у вас залишились ліди, неотримані ліди будуть завантажені зверху списку. Також, вони будуть відправлені в додані інтеграції",
      cfirstStartPagePhotoUpdated: "Фото стартової сторінки оновлене",
      allstepsPhotoTooBig: "Файл занадто великий!",
      allstepsPhotoMustBeLess: "Фото повинно бути меньше",
      cfirstStartPageBonusPhotoUpdated: "Фото бонусу оновлене",
      cstepsQuestionsOrderSaved: "Порядок запитань збережено",
      csanyAnswerOrderSaved: "Порядок відповідей збережено",
      allstepsPhotoAdaptation: "Адаптувати фото під пристрої",
      allstepsPhotoFit: "Співвідношення сторін",
      constructorYouHideStep: "Ви сховали цей крок",
      cstepsHiddenStep: "Приховати крок",
      cstepsShowStep: "Відобразити крок",
      cstepNo_animation: "Без анімації",
      cstepAnimation: "Анімація",
      cstepKick_animation: "Поштовх",
      cstepFlip_animation: "Переворот",
      cstepBlur_animation: "Розмиття",
      cfinishFinishPageHiddenUpdated: "Фінішна сторінка прихована.",
      cfinishFinishPageHiddenUpdatedGoContact: "Перейдіть на сторінку Форми контактів",
      cfinishFinishPageHiddenUpdatedSetRedirect: "та налаштуйте редирект після відправки даних",
      cformActionAfterContactRecive: "Дії після отримання контактів",
      cformActionAfterContactThankyou: "Сторінка подяки",
      cformActionAfterContactRedirect: "Переадресація",
      cformAdditionalSettings: "Додаткові налаштування",
      cformRedirectURL: "URL",
      cintegrationOweDomainInstructionImportant: "Важливо: Адреса у вашому хостинг обліковому записі і полі нижче, повинні збігатися. Час застосування змін DNS-налаштуваннь, та виписки SSL сертифікату - до 3-х годин після збереження.",
      cintegrationOweDomainInstructionVideo: "Переглянути відео інструкцію",
      workboardModalLeadsLeadLimit: "Ліміт ваших лідів вичерпаний.",
      workboardModalLeadsLeadLimitInstruction1: "Щоб побачити нові ліди,",
      workboardModalLeadsLeadLimitInstruction2: "перейдіть на інший тариф",
      workboardModalLeadsLeadLimitInstruction3: "оновіть поточній тариф",
      workboardModalLeadsLeadLimitInstruction4: '(не стосується "Free") або дочекайтеся оновлення тарифу, якщо у вас підключене автопродовження тарифу',
      workboardModalLeadsLeadLimitNewText: "У вас є неотримані ліди, до яких неможливо отримати доступ через поточний ліміт пакету. Щоб отримати ці ліди, придбайте або оновіть свій пакет. ",
      billingBonusesTitle: 'Промокод',
      billingBonusesDescription: 'Введіть отриманий промокод у полі поруч',
      billingBonusesPlaceholder: 'Промокод',
      billingBonusesBtn: 'Активувати',
      billingBonusesActivated: 'Промокод активовано!',
      billingBonusesLeadIncreased: 'Кількість доступних лідів збільшено.',
      billingBonusesInvalid: 'Неправильний промокод',
      billingBonusesNotAvailable: 'Ви вже активували цей промокод',
      billingBonusesAlreadyActivated: 'Даний купон недійсний',
      createQuizSPDescription: "Це місце для короткого опису",
      createQuizCPTitle: "Як ми можемо з вами зв'язатися?",
      createQuizCPDescription: "Будь ласка, заповніть форму нижче",
      createQuizCPButton: "Готово!",
      createQuizFPTitle: "Дякуємо!",
      createQuizFPDescription: "Тепер ми підберемо найкраще рішення для вас!",
      createQuizFPButton: "Покажи мені щось!",
      selectInternationalPrefix: "Обрати міжнародний формат",
      autoInternationalPrefix: "Визначати країну автоматично",
      dovnloadCsvTitle: "Експортувати данні за вибраний період",
      dovnloadCsvSelectAllPeriod: "Обрати за весь період",
      dovnloadCsvCancel: "Відмінити",
      dovnloadCsvExport: "Експортувати",
      domainEmpty: "Будь ласка, введіть домен",
      domainInvalid: "Введіть коректний домен, наприклад: example.com",
      domainAlreadyExists: "Цей домен уже є у списку",
      domainAdded: "Домен успішно додано",
      domainAdd: "Додати домен",
      domainAddFailed: "Не вдалося додати домен",
      domainRemoved: "Домен успішно видалено",
      domainRemoveFailed: "Не вдалося видалити домен",
      


      widgetEmbedVidgetToSite: "Встановлення квіза на сайті",
      widgetEmbedVidgetSelectEmbedVariant: "Оберіть варіант інтеграції",
      EmbedQuizCardLabelStandard: "Стандартна",
      EmbedSettingsPreviewPopupHint: "Натисніть кнопку, щоб побачити своє спливаюче вікно в дії",
      EmbedQuizCardLabelPopup: "Спливаюче вікно",
      EmbedQuizCardLabelChatButton: "Кнопка чату",
      EmbedQuizCardLabelFullscreen: "На весь екран",
      EmbedQuizCardLabelFeedback: "Зворотний зв'язок",
      EmbedQuizCardLabelSidebar: "Бічна панель",
      EmbedStandardSettingsTitle: "Встановіть розміри (необов'язково)",
      tipStandardEmbedQuizStepHead:
          "1. Скопіюйте код для <head> і вставте його перед закриваючим тегом </head>.",
      tipStandardEmbedQuizStepBody:
          "2. Скопіюйте другий код і вставте div <div id=\"adsquiz_embed_standard_ .... саме в те місце сторінки, де повинен відображатися квіз.",
      tipStandardEmbedQuizParent:
          "3. Розмір квіза залежить від розмірів батьківського блоку. Якщо для батьківського елемента не задана висота, квіз автоматично буде відображатися в адаптивному форматі.",
      tipStandardEmbedQuizPercent:
          "4. Width і height у % працюють відносно розмірів батьківського блоку.",
      EmbedStandardSettingsTooltip: `
      Ширина та висота — визначають розмір квізу (px, %, auto).

      Auto — квіз адаптивний, висота визначається автоматично.

      На весь екран — квіз займає 100% ширини з пропорцією 16:9. Ширина і висота ігноруються.

      Висота:
      • auto / 0 → пропорція 16:9
      • значення → фіксована висота

      Ширина:
      • auto / 0 → 100% ширини
      • значення → в межах контейнера

      Радіус — задає округлення кутів.

      Відступ — додає внутрішній відступ контейнера.

      На ПК / На мобільному пристрої — визначає, де відображається квіз.
      Якщо вимкнено — квіз не буде показуватись на цьому пристрої.
      `,
      EmbedFeedbackSettingsTooltip: `
      Розмір вікна задає базовий пресет:
  • S → 360 × 520
  • M → 480 × 640
  • L → 640 × 760
  • XL → 780 × 860
  
  Форма вікна:
  • angular → кутова
  • rounded → заокруглена
  
  Ширина:
  • auto / 0 / порожньо → використовується пресет
  • значення → перевизначає пресет
  
  Висота:
  • auto / 0 / порожньо → використовується пресет
  • значення → перевизначає пресет
  
  Розмір кнопки задає пресет кнопки відкриття.
  
  Форма кнопки:
  • angular → кутова
  • rounded → заокруглена
  
  Позиція кнопки:
  • left → зліва
  • right → справа
  • top → зверху
  • bottom → знизу
  
  Текст кнопки — змінює текст.
  
  Іконка — вибір іконки кнопки.
  
  Колір кнопки — фон кнопки.
  
  Колір тексту — колір тексту.
  
  Колір іконки — колір іконки.
  
  Заборонити закриття до проходження квізу — якщо увімкнено, користувач не зможе закрити вікно, поки не завершить квіз.
  
  Перестати показувати після завершення — після проходження квізу кнопка і вікно більше не будуть з’являтися повторно.
  
  ПК / Мобільний — де показується віджет.
      `,
      EmbedPopupSettingsTooltip: `
      Ширина та висота задають розмір спливаючого вікна.

      Розмір вікна задає базовий пресет розміру:
      • S → 360 × 520
      • M → 480 × 640
      • L → 640 × 760
      • XL → 780 × 860

      Ширина та висота можуть перевизначити вибраний пресет Розміру вікна.

      Ширина:
      • auto / 0 / порожньо → використовується ширина з Розміру вікна
      • значення → власна ширина перевизначає пресет

      Висота:
      • auto / 0 / порожньо → використовується висота з Розміру вікна
      • значення → власна висота перевизначає пресет

      Умова показу визначає, коли відкривається спливаюче вікно:
      • Клік по кнопці — відкривається по кліку
      • При виході зі сторінки — відкривається, коли користувач залишає сторінку
      • Після завантаження сторінки — відкривається одразу після завантаження
      • Через затримку — відкривається через вибрану кількість секунд

      Поле секунд з’являється лише для “Через затримку”.

      Текст кнопки, Розмір кнопки, форма кнопки, позиція кнопки, Автоколір (шаблон), Колір кнопки та Колір тексту працюють лише для “Клік по кнопці”.

      Розмір кнопки задає пресет розміру кнопки відкриття.

      Автоколір (шаблон):
      • якщо увімкнено — автоматично застосовуються кольори шаблону
      • якщо увімкнути ручні кольори — Автоколір вимикається

      Заборонити закриття до проходження квізу — якщо увімкнено, користувач не зможе закрити вікно, поки не завершить квіз.
  
      Перестати показувати після завершення — після проходження квізу кнопка і вікно більше не будуть з’являтися повторно.

      На ПК / На мобільному пристрої — визначає, де показується спливаюче вікно.
      Якщо вимкнено — вікно не буде показуватись на цьому пристрої.
      `,
      EmbedChatButtonSettingsTooltip: `
      Ширина та висота задають розмір вікна чату.

      Розмір вікна задає базовий пресет розміру:
      • S → 360 × 520
      • M → 480 × 640
      • L → 640 × 760
      • XL → 780 × 860

      Ширина та висота можуть перевизначити вибраний пресет Розміру вікна.

      Ширина:
      • auto / 0 / порожньо → використовується ширина з Розміру вікна
      • значення → власна ширина перевизначає пресет

      Висота:
      • auto / 0 / порожньо → використовується висота з Розміру вікна
      • значення → власна висота перевизначає пресет

      Форма вікна визначає, чи буде вікно з гострими або заокругленими кутами.

      Розмір кнопки задає пресет розміру кнопки відкриття чату.

      Форма кнопки визначає вигляд кнопки:
      • прямокутна
      • кругла

      Позиція кнопки визначає, де буде розташована кнопка:
      • ліворуч
      • праворуч

      Іконки дозволяють вибрати іконку кнопки чату.

      Колір кнопки задає фоновий колір кнопки.

      Колір іконки задає колір іконки всередині кнопки.

      Закривати спливаюче вікно після завершення — дозволяє користувачу закрити вікно після проходження квізу.

      Припинити показ після завершення — зупиняє повторний показ після завершення квізу.

      На ПК / На мобільному пристрої — визначає, де показується кнопка чату та саме вікно.
      Якщо вимкнено — чат-кнопка не буде показуватись на цьому пристрої.
      `,
      EmbedSidebarSettingsTooltip: `
      Ширина і висота задають розмір бічної панелі.
      
      Розмір вікна задає базовий пресет:
      • S → 360 × 520
      • M → 480 × 640
      • L → 640 × 760
      • XL → 780 × 860
      
      Позиція панелі:
      • left → зліва
      • right → справа
      
      Ширина:
      • auto / 0 / порожньо → використовується значення з пресету
      • значення → перевизначає пресет
      
      Висота:
      • auto / 0 / порожньо → використовується значення з пресету
      • значення → перевизначає пресет
      
      Умова показу визначає, коли відкривається бічна панель:
      • Клік по кнопці — відкривається по кліку
      • При виході зі сторінки — відкривається, коли користувач залишає сторінку
      • Після завантаження сторінки — відкривається одразу після завантаження
      • Через затримку — відкривається через обрану кількість секунд
      
      Поле секунд з’являється лише для “Через затримку”.
      
      Текст кнопки, Розмір кнопки, форма кнопки, позиція кнопки, Колір кнопки і Колір тексту працюють лише для “Клік по кнопці”.
      
      Розмір кнопки задає пресет кнопки відкриття.
      
      Форма кнопки:
      • angular → кутова
      • rounded → заокруглена
      
      Позиція кнопки:
      • left → зліва
      • middle → по центру
      • right → справа
      
      Колір кнопки — фон кнопки відкриття.
      
      Колір тексту — колір тексту кнопки.
      
      Заборонити закриття до проходження квізу — якщо увімкнено, користувач не зможе закрити панель, поки не завершить квіз.
      
      Перестати показувати після завершення — після проходження квізу кнопка і панель більше не будуть з’являтися повторно.
      
      На ПК / На мобільному пристрої — визначає, де показується бічна панель.
      Якщо вимкнено — панель не буде показуватися на цьому пристрої.
      `,
      EmbedModalStandardInstruction: `
      Скопіюйте код із блоку Head і вставте його перед </head> на вашому сайті.
      
      Скопіюйте код із блоку Body та вставте його в те місце, де має відображатися квіз.
      
      Як це працює:
      • Квіз буде вбудований прямо в сторінку
      • Він адаптується під ширину контейнера
      
      На що звернути увагу:
      • Якщо квіз виглядає занадто вузьким або широким — перевірте контейнер
      • Якщо висота некоректна — задайте фіксовану висоту в налаштуваннях
      • В адаптивному режимі висота підлаштовується автоматично
      • Перевірте, чи немає обмежень стилями (overflow, display)
      
      Після встановлення:
      1. Збережіть зміни
      2. Оновіть сторінку
      3. Перевірте відображення на ПК і мобільному
      `,
      EmbedModalPopupInstruction: `
      Скопіюйте код із блоку Head і вставте його перед </head>.
      
      Скопіюйте код із блоку Body і вставте його перед </body> або будь-де.
      
      Як це працює:
      • Квіз відкривається як popup
      • Він може відкриватися автоматично або по кліку
      
      На що звернути увагу:
      • Якщо обрано кнопку — вона з’явиться в місці вставки
      • Якщо авто-режим — popup відкриється сам
      • Якщо popup не з’являється — перевірте налаштування для пристрою
      • Якщо розмір неправильний — змініть у налаштуваннях
      
      Після встановлення:
      1. Збережіть
      2. Оновіть сторінку
      3. Перевірте роботу popup
      `,
      EmbedSettingsWindowSize: "Розмір вікна",
      EmbedPreviewFallbackTitle: "Попередній перегляд завантажується довше, ніж очікувалося",
      EmbedPreviewFallbackDescription: "Попередній перегляд квізу ще не вдалося відобразити. Спробуйте знову відкрити попередній перегляд або перезавантажити фрейм.",
      EmbedPreviewFallbackReasonsTitle: "Можливі причини:",
      EmbedPreviewFallbackReasonDomain: "Вибраний домен може бути недоступним або введеним неправильно.",
      EmbedPreviewFallbackReasonDomainSettings: "Будь ласка, перевірте налаштування домену та переконайтеся, що домен підключено правильно.",
      EmbedPreviewFallbackReasonSlow: "Сторінка квізу все ще може завантажуватися або повільно відповідати.",
      EmbedPreviewFallbackReasonBlocked: "Попередній перегляд може блокуватися вашим браузером або мережевим середовищем.",
      EmbedPreviewFallbackReload: "Перезавантажити попередній перегляд",
      EmbedSizePresetDisabledHint: "Пресет розміру недоступний, поки задано власну ширину або висоту.",
      EmbedPopupSettingsTitleButton: "Розмір кнопки",
      EmbedStandardSettingsHeightLabel: "Висота",
      EmbedStandardSettingsWidthLabel: "Ширина",
      EmbedStandardSettingsRadiusLabel: "Радіус",
      EmbedStandardSettingsPaddingLabel: "Відступ",
      EmbedStandardSettingsFullscreenToggle: "На весь екран",
      EmbedStandardSettingsDesktopToggle: "На ПК",
      EmbedPopupSettingsTextColorToggle: "Колір тексту",
      EmbedPopupSettingsButtonColorToggle: "Колір кнопки",
      EmbedSettingsIconColor: "Колір іконки",
      EmbedPopupSettingsAutoColorToggle: "Автоколір (шаблон)",
      EmbedPopupSettingsCloseOnCompletionToggle: "Заборонити закриття до проходження квізу",
      EmbedSettingsStopShowing: "Припинити показ після завершення",
      EmbedStandardSettingsMobileToggle: "На мобільному пристрої",
      EmbedSettingsAutoOpenToggle: "Автовідкриття",
      EmbedSettingsPreviewDelayHint: "Спливаюче вікно з’явиться через ",
      EmbedSettingsPreviewOpenAgain: "Відкрити превʼю спливаючого вікна",
      EmbedReOpenSettingsMobileToggle: "Відкрити превʼю",
      widgetEmbedVidgetSitecode: "В коді сайта",
      widgetEmbedVidgetPopup: "Поп-ап",
      widgetEmbedVidgetChat: "Квіз-кнопка",
      widgetEmbedVidgetInProgres: "В розробці",
      widgetEmbedVidgetToSiteCode: "Встановлення квіза на сайті",
      widgetSiteCodeInstruction0: "Щоб встановити квіз на вашому сайті, додайте код з першого поля в тег `<head>` на вашому сайті або Google Tag Manager, якщо він інтегрований у ваш сайт. Якщо після того, як ви вже вставите квіз на сайт, ви зміните домен у квіза Вам потрібно буде оновити код інтеграції на вашому сайті.",
      widgetSiteCodeInstruction1: "В місце куди ви хочете інтегрувати квіз вставте код з другого поля.",
      widgetSiteCodeInstruction2: "Квіз можна інтегрувати в контейнер будь-якого розміру, навіть, в сайдбари! Максимальный розмір квізу, так само як і при проходженні на окремому домені - 900х552 пікселя. Його можна додавати в контейнери і більшого розміру, в такому випадку квіз буде відцентровано.",
      widgetSiteCodeInstruction3: "Не соромтеся - експерементуйте!",
      widgetSiteCodeCopyToHead: "Скопіюйте та вставьте в `<head>` вашого сайту",
      widgetSiteCodeCopyToBody: "Вставте код в те місце, де повинен бути квіз",
      workboardModalAddQuizHeader: "Створення нового Quiz",
      workboardModalGiveQuizNameAndMethod: "Придумайте назву вашого квізу та виберіть бажаний спосіб створення",
      workboardModalNewQuizFromStart: "Створити з нуля",
      workboardModalNewQuizFromTemplates: "Готові шаблони",
      QuizTemplatesSearchInput: "Назва шаблону та/або категорій",
      QuizTemplatesSearchBtn: "Пошук",
      QuizTemplatesReadyTemplates: "Готові шаблони",
      QuizTemplateView: "Переглянути",
      QuizTemplateSelect: "Обрати",
      widgetPopupInstruction0: "Щоб встановити квіз на вашому сайті, додайте код з поля з кодом в тег `<head>` на вашому сайті або Google Tag Manager, якщо він інтегрований у ваш сайт. Якщо після того, як ви вже вставите квіз на сайт, ви зміните домен у квіза або тригери відкриття (відсоток скрола або таймінг), вам потрібно буде оновити код інтеграції на вашому сайті.",
      widgetPopupInstruction1: "Відразу перед закриттям тега `</footer>` вставте код з другого поля.",
      widgetPopupInstruction2: "Для програмістів чи просунутих користувачів",
      widgetPopupInstruction3: "Якщо вам з якихось причин незручно вставляти квіз перед закриваючим тегом `</footer>` ви можете вставити код з другого поля в будь-яке зручне місце, але враховуйте, що контейнер, в який ви вставляєте код з другого поля, повинен бути поверх всіх вікон і вкрай бажано повинен мати висоту та ширину максимально можливу для дисплея.",
      widgetPopupCopyToHead: "Скопіюйте та вставте в `<head>` вашого сайту",
      widgetPopupCopyToBody: "Скопіюйте та вставте код перед закриваючим тегом `</footer>`",
      widgetPopupTimeToOpen: "Проміжок часу",
      secondReduction: "сек",
      widgetPopupTimeClarification: "Попап з’явиться з затримкою зазначеного вище часу у секундах",
      widgetPopupScrollToOpen: "Відсоток прогортування сайту",
      widgetPopupScrollClarification: "Попап з’явиться після зазначеного вище відсотку прогортування вашого сайту",
      quizzesTemplatesAllTags: "Всі шаблони",
      widgetEmbedVidgetButton: "Конструктор кнопки",
      widgetButtonInstruction0: "Ви можете встановити на вашому сайті квіз який буде відкриватись при кліку по кнопці.",
      widgetButtonInstruction1: "Додайте заокруглення, тінь, та текст кнопки. Також, ви можете змінити колір кнопки та тексту всередині.",
      widgetButtonInstruction2: "Скопіюйте скрипт розміщений в першому полі з кодом та вставте його перед закриваючим тегом `</head>`.",
      widgetButtonInstruction3: "Скопіюйте згенерований код кнопки, з другого поля з кодом та вставте в будь-яке місце вашого сайту.",
      widgetButtonInstruction4: 'Ви можете не використовувати код з другого поля з кнопкою а просто додати `id="button_open_quiz_popup"` до будь-якого єлемента `<input type="button">` або єлемента `<button></button>` на сайті.',
      widgetRealTimeChange: "Ви можете бачити зміни в реальному часі у правій частині екрану",
      widgetButtonCornerRound: "Заокруглення кнопки",
      widgetButtonShadow: "Тінь кнопки",
      widgetButtonBgColor: "Колір кнопки",
      widgetButtonTextColor: "Колір тексту",
      widgetButtonTextValue: "Текст кнопки",
      openPopupQuizText: "Розпочати квіз",
      widgetButtonInsertBeforeAfterBody: "Вставте код квіза одразу після відкриваючого тега `<body>` або перед одразу перед закриваючим тегом `</body>`",
      widgetSiteCodeCopyButton: "Вставте код кнопки в будь-яке місце на сайті",
      footerContactUs: "Маєте питання? Можете з нами зв'язатись:",
      enterYourName: "Введіть ваше ім'я",
      enterYourPhone: "Введіть номер телефону",
      enterYourEmail: "Введіть ваш email",
      enterYourPassword: "Введіть ваш пароль",
      selectOption: "Оберіть варіант",
      createNewGroup: "Створити нову групу",
      dontHaveAccount: "Не маєте облікового запису?",
      haveQuestions: "Є питання?",
      resetPasswordTip: "Якщо у вас виникли додаткові проблеми чи запитання, будь ласка, не соромтеся зв’язатися з нашою командою підтримки клієнтів. Ми тут, щоб допомогти.",
      getBackAccount: "Поверніться до свого облікового запису",
      inMinutes: "за хвилину",
      alreadyHaveAccount: "Вже маєте обліковий запис?",
      quizSlotLastEdit: "Остання зміна",
      workboardQuizzesTitle: "Мої квізи",
      allstepsBack: "Назад",
      constructorGetLink: "Посилання",
      allOr: "або",
      allAnd: "і",
      acceptedFileType: "Прийнятні формати: ",
      quizLoaderLoadingQuiz: "Завантажуємо квіз...",
      quizLoaderPreparingQuestions: "Готуємо персональні питання...",
      quizLoaderSettingInterface: "Налаштовуємо інтерфейс...",
      quizLoaderAlmostReady: "Майже готово...",
      conjunctionAnd: "та",
      acceptedFileSize: "Максимальний розмір: ",
      acceptedFileSizeMeasure: "МБ",
      cfirstBonusDisabled: "Вимкнено",
      cfirstBonusAvailable: "Доступно",
      allstepsResetInHeader: "Скинути",
      placeholderText: "Введіть тут",
      constructorSaveChanges: "Зберегти",
      constructorCreateIntegrations: "Створити інтеграцію",
      cformInputAvailable: "Доступно",
      cformInputDisabled: "Вимкнено",
      Disabled: "Вимкнено",
      constructorBack: "Назад",
      videoInstruction: "Відеоінструкція",
      csettingsIntegrationFB: "Інтеграція - Facebook Pixel",
      csettingsIntegrationTT: "Інтеграція - TikTok",
      csettingsIntegrationGA: "Інтеграція - Google Analytics",
      csettingsIntegrationGTM: "Інтеграція - Google Tag Manager",
      csettingsIntegrationWH: "Інтеграція - WebHook",
      csettingsIntegrationTG: "Інтеграція - Telegram",
      csettingsIntegrationApixDrive: "Інтеграція - APIxDrive",
      csettingsIntegrationEmail: "Інтеграція - Email",
      csettingsIntegrationAbout: "Докладно",
      csettingsIntegrationFBAbout: "Перейдіть в рекламний кабінет Facebook Ads та скопіюйте ідентифікатор Facebook Pixel в розділі Менеджер подій. Скопіюйте лише ідентифікатор, а не весь код, та вставте його у поле нижче.",
      csettingsIntegrationTTAbout: "Перейдіть в рекламний кабінет TikTok Ads та скопіюйте ідентифікатор TikTok Pixel в розділі \"Event\". Скопіюйте лише ідентифікатор, та вставте його у поле нижче.",
      csettingsIntegrationGAAbout: "Скопіюйте ідентифікатор Google Analytics та вставте його у поле нижче.",
      csettingsIntegrationGTMAbout: "Скопіюйте ідентифікатор Google Tag Manager та вставте його у поле нижче.",
      csettingsIntegrationWHAbout1: "Ви можете сповіщати сторонні програми про надходження потенційних клієнтів. Для цього вкажіть URL-адресу, на яку буде відправлено вебхук. Ми рекомендуємо використовувати цю послугу. ",
      csettingsIntegrationWHAboutApix: "Apix-Drive ",
      csettingsIntegrationWHAbout2: "При реєстрації за цим посиланням нашим користувачам надається бонус - 10 000 безкоштовних дій для будь-яких інтеграцій.",
      csettingsIntegrationTGAbout: "Важливо: зауважте, що це повинна бути група, а не канал у Telegram. Потенційні клієнти не будуть надсилатися до каналу в Telegram.",
      csettingsIntegrationADAbout: "Щось про APIxDrive",
      csettingsIntegrationEmailAbout: "Активуйте електронний лист для вашого респондента та повідомте свою команду. Співпрацюйте зі своєю командою.",
      cSettingsIntegrationNeedHelp: "Потрібна допомога?",
      cSettingsIntegrationRefreshToken: "Оновити токен",
      csettingsSettingASettings: "Додаткові налаштування",
      cSettingsSettingQuizLangTitle: "Мова квізу",
      cSettingsSettingQuizLangDescription: "Щоб забезпечити вам найкращий досвід, будь ласка, виберіть потрібну мову квізу з варіантів нижче. Цією мовою будуть відображатись системні сповіщення та деякі інші незмінні тексти при проходженні квізу.",
      selectQuizLanguage: "Оберіть мову квізу",
      cSettingsSettingQuizHideLabelTitle: "Приховати мітку",
      cSettingsSettingQuizHideLabelDescription: 'Увімкнувши цей параметр, ви зможете насолоджуватися вільним від мітки "made by adsquiz" інтерфейсом, що дозволить вам та вашим відвідувачам зосередитися виключно на питаннях.',
      cSettingDataSaved: "Додаткові налаштування збережено",
      userAccountInfo: "Інформація про обліковий запис",
      userGeneralInfoHeader: "Загальна інформація",
      userGeneralInfoDescription1: "Ваш профіль користувача - це місце, де ви можете керувати своїм обліковим записом та налаштуваннями.",
      userGeneralInfoDescription2: "Оновлюйте свою особисту інформацію, змінюйте пароль та налаштовуйте свої відомості про сповіщення.",
      profileNameFirst: "Ім'я",
      profileNameLast: "Прізвище",
      profileChangePhoto: "Змінити фото",
      profileRemovePhoto: "Видалити",
      userSecuritySettingsHeader: "Налаштування безпеки",
      userSecuritySettingsDescription: "Для зміни пароля просто двічі введіть новий пароль для підтвердження.",
      profileEmailCurent: "Поточна адреса електронної пошти",
      profileEmailNew: "Нова адреса електронної пошти",
      profileNewPasswordConfirm: "Підтвердіть новий пароль",
      profileDeleteAccount: "Видалити обліковий запис",
      profileDeleteAccountPopupHeader: "Видалити обліковий запис?",
      profileDeleteAccountPopupDescription: 'Ви впевнені, що хочете видалити свій обліковий запис? Ця дія неможлива до скасування. Для підтвердження видалення, будь ласка, введіть слово "ВИДАЛИТИ" у поле нижче.',
      profileDeleteAccountCheckedWord: "ВИДАЛИТИ",
      profileDeleteAccountPopupPlaceholder: "Введіть тут",
      notificationSuccess: "Успішно!",
      notificationSuccessSaveAccount: "Ваш пароль успішно змінено! Використовуйте новий пароль для входу",
      notificationOnlyEmailMask: "Дозволено лише правильну адресу електронної пошти.",
      notificationOnlyNumbersMask: "Дозволено лише цифри та пробіли.",
      notificationOnlyLinkMask: "Допускаються лише безпечні посилання (https, http або mailto).",
      notificationOnlyLettersMask: "Дозволено лише літери, пробіли, дефіси, апострофи та підкреслення.",
      notificationSuccessDeleteAccount: "Ваш обліковий запис успішно видалено! Використовуйте новий пароль для входу",
      notificationSuccessDeletePhoto: "Фото успішно видалено",
      notificationSuccessChangePhoto: "Фото успішно змінено",
      notificationErrorChangePhoto: "Сталася помилка під час зміни фото",
      notificationErrorRemovePhoto: "Сталася помилка під час видалення фото",
      notificationWarnLimitText: "Перевищено ліміт символів. Ви не можете додати більше символів.",
      cardPanUnspecified: "Не вказано",
      userBillingsDate: "Дата",
      userBillingsCost: "Вартість",
      userBillingsId: "ID",
      userBillingsMethod: "Спосіб оплати",
      RateSymbolForDropdown: "Символ оцінки",
      NumberOfSymbolsForDropdown: "Кількість символів",
      optionIconLabelForDropdown_thumbnail: "Палець вгору",
      optionIconLabelForDropdown_stars: "Зірки",
      optionIconLabelForDropdown_flags: "Прапори",
      optionIconLabelForDropdown_smiley_faces: "Смайлики",
      labelTextYesNoPack1: "Так/Ні Пакет - 1",
      labelTextYesNoPack2: "Так/Ні Пакет - 2",
      labelTextYesNoPack3: "Так/Ні Пакет - 3",
      labelTextYesNoEmojiPack: "Так/Ні Емодзі Пакет",
      labelTextEmojiPackage1: "Пакет Емодзі - 1",
      labelTextEmojiPackage2: "Пакет Емодзі - 2",
      labelTextEmojiPackage3: "Пакет Емодзі - 3",
      labelTextNumberPack1: "Пакет чисел - 1",
      labelTextNumberPack2: "Пакет чисел - 2",
      labelTextClassicNumbers1: "Класичні числа - 1",
      labelTextClassicNumbers2: "Класичні числа - 2",
      labelTextRatingMarkers: "Маркер оцінки",
      textPackagePlaceholder: "Пакет ...",
      labelEmojiNumberSets: "Набори емодзі та чисел",
      labelSelectCountForSymbols: "Виберіть діапазон від 1 до",
      labelButtonColorButtonText: "Колір кнопки та текст кнопки",
      color: "Колір",
      paymentSwitchToProHeader: "Перейти на Pro",
      paymentSwitchToProDescription: "Знайдіть план, який підходить саме вам! Оновлюйте або знижуйте план у будь-який час - ми полегшуємо вибір потрібного плану.",
      paymentYourCurrentPlan: "Ваш поточний план:",
      paymentYourFuturePlan: "Ваш новий план:",
      billingCurrentPlanLeadLimit: "Ліміт заявок на місяць",
      billingCurrentPlanLeadsRemaining: "Залишилось заявок",
      billingSpecialOffersHeading: "Спеціальні пропозиції",
      billingAllPlansHeading: "Усі тарифи",
      billingBillingPeriodToggleAria: "Період оплати",
      billingPeriodMonthly: "Щомісячно",
      billingPeriodYearly: "Щорічно",
      billingPaymentUnavailableNotification: "Оплата для цього тарифу зараз недоступна. Спробуйте пізніше або зв'яжіться з нами.",
      billingRequisitesButton: "Реквізити",
      billingPayAsBusiness: "Оплатити як компанія",
      billingIbanModalTitle: "Реквізити",
      billingIbanModalMethodTitle: "Банківський переказ IBAN",
      billingIbanModalDisclaimer: "Щоб отримати рахунок на оплату, напишіть у чат техпідтримки.",
      billingIbanModalRecipient: "Найменування отримувача",
      billingIbanModalRecipientCode: "Код отримувача",
      billingIbanModalIban: "IBAN",
      billingIbanModalBankName: "Назва банку",
      billingIbanModalCopy: "Скопіювати IBAN",
      billingIbanModalClose: "Закрити",
      billingIbanCopyAllButton: "Скопіювати реквізити",
      billingIbanCopiedNotification: "IBAN скопійовано в буфер обміну",
      billingIbanAllCopiedNotification: "Реквізити скопійовано в буфер обміну",
      billingWhatsIncluded: "Що входить",
      billingComparePlans: "Порівняти тарифи",
      billingComparePlanA: "Тариф А для порівняння",
      billingComparePlanB: "Тариф Б для порівняння",
      billingFeatureSectionMain: "Основне",
      billingFeatureSectionAdvanced: "Розширені",
      billingFeatureSectionIntegrations: "Інтеграції",
      billingAnalyticsRowLabel: "Аналітика",
      billingLeadsRowLabel: "Ліди",
      billingFeatureProjectsRowLabel: "Проекти",
      billingFeatureCustomDomainRowLabel: "Кастомний домен",
      billingFeatureAnalyticsRowLabel: "Аналітика",
      billingFeatureSiteInstallRowLabel: "Установка на сайт",
      billingFeatureAiBuilderRowLabel: "AI білдер",
      billingFeatureRedirectRowLabel: "Редірект",
      billingFeatureUtmTrackingRowLabel: "UTM Tracking",
      billingFeatureFaviconRowLabel: "Favicon",
      billingFeatureLogicRowLabel: "Логіка",
      billingFeatureResultPageRowLabel: "Сторінка результату",
      billingFeaturePointsRowLabel: "Бали",
      billingFeatureFileUploadRowLabel: "Завантаження файлів",
      billingFeatureNotYetAvailableLabel: "Скоро",
      billingFeatureTeamRowLabel: "Команда",
      billingFeatureCrmRowLabel: "CRM",
      billingPartnershipOfferHeading: "Партнерська пропозиція",
      paymentPlanLeadsLimit: "Ліміт лідів на місяць:",
      paymentPlanLeadsLimitForTest: "Ваш ліміт для тесту квізів:",
      paymentPlanLeadsLeft: "Залишилося лідів:",
      paymentPlanPrice: "Ціна:",
      paymentPlanRenew: "Дата продовження тарифу:",
      addNewSectionHeader: "Додати новий розділ",
      addNewSectionList: "Список",
      addNewSectionCustom: "Поле вводу",
      addNewSectionMultiInput: "Мультиввід",
      addNewSectionUploadFile: "Завантаження файлу",
      addNewSectionCard: "Картки з фото",
      addNewSectionWithEmoji: "Список з емодзі",
      addNewSectionTags: "Теги",
      addNewSectionSlider: "Повзунок",
      templatesBackToQuiz: "Повернутися до воркборда",
      constructorStepsSaved: "Всі дані квіза успішно збережено",
      constructorDesignSaved: "Дизайн квіза успішно збережено",
      azureBlueWhite: "Стандартний",
      azureBlue: "Зимова ніч",
      moderatePurplishRed: "Червоний оксамит",
      multiInputPlaceholderLink: "https:",
      multiInputPlaceholderName: "Ім'я або повне ім'я",
      multiInputAddInput: "Додати поле",
      multiInputPlaceholderAddress: "Адреса",
      multiInputPlaceholderNumbers: "Заповніть (тільки цифри)",
      violetBlueCrayola: "Зимовий бриз ",
      wetRainforest: "Літній клен",
      lavender: "Космос",
      blueLilac: "Темна лаванда",
      opalGreen: "Карпатській ліс",
      dustyBlue: "Тіффані",
      almondCrayola: "Кораловий риф",
      periwinkleCrayolaLilac: "Бузок",
      periwinkleCrayolaAqua: "Синевір",
      jazzJam: "Джаз",
      slateGrayBlue: "Мгла",
      turquoiseBlueCrayola: "Дія",
      blackPearlescentOpal: "Попіл",
      pearlescentGentianBlue: "Сапфір",
      sapphireBlue: "Темний сапфір",
      errorUserDataUpdate: "Помилка в оновлені даних: ",
      completeUserDataUpdate: "Дані користувача оновлені",
      passwordDoNotCoincidence: "Паролі не співпадають",
      passwordDoNotCoincidenceAgain: "Спробуйте ще раз",
      nonBillingsYet: "У вас ще немає історії платежів.",
      youCanChangePlan: "Ви можете змінити поточний план, натиснувши кнопку «Перейти на PRO»",
      rangeMin: "Мін",
      rangeMax: "Макс",
      rangePositionStart: "Початкова позиція",
      rangePositionEnd: "Кінцева позиція",
      rangeStep: "Крок",
      rangeIsRange: "Діапазон",
      rangeIsRangeTrue: "Увімкнено",
      rangeIsRangeFalse: "Вимкнено",
      recivePromotionNewsletter: "Отримувати імейл розсилки",
      reciveEmailCheckbox: "Чекбокс отримання Імейлів",
      additionalCheckbox: "Додатковий чекбокс",
      contactPrivacyPolicyCheckbox: "Чекбокс згоди з приватністю",
      contactAgreeIAgreeWith: "Я погоджуюсь з",
      contactAgreePolicy: "політикою конфіденційності",
      contactAgreeAnd: "та",
      contactAgreeTermsOfUse: "правилами використання",
      contactAgreeAgreementAdditionalWord: "",
      contactFillRequiredInput: "Заповніть обов'язкові поля",
      langEN: "Англійська",
      langDE: "Німецька",
      langSP: "Іспанська",
      langPL: "Польська",
      langIT: "Італійська",
      langKK: "Казахська",
      langRU: "Російська",
      langUA: "Українська",
      langSV: "Шведська",
      langLT: "Литовська",
      langLV: "Латвійська",
      langET: "Естонська",
      langRO: "Румунська",
      leadsLeft: "Залишилось лідів",
      generateDomainTitle: "Введіть ім'я домену",
      generateCodeForEmbedQuiz: "Згенерувати код",
      generateDomainDescription: "Це унікальна адреса, за якою буде доступна ваша сторінка. Ви можете будь-коли змінити адресу або підключити свою.",
      generateDomainDomainNameLabel: "Доменне ім'я",
      cancelAllAction: "Відмінити",
      confirmAllAction: "Підтвердити",
      fieldDataTypeLabel: "Тип данных в поле",
      falseHasValidCharacters: "Недопустимі символи в домені. Допустимими символами є літери латинської абетки, цифри і дефіси.",
      falseHasValidLength: "Довжина домену повинна бути від 6 до 20 буквено-цифрових символів.",
      falseDoesNotStartOrEndWithSpecialChar: "Домен не повинен починатися або закінчуватися спеціальним символом.",
      falseDoesNotHaveConsecutiveSpecialChar: "Домен не повинен містити два або більше підряд спеціальних символа.",
      falseDoesNotHaveConsecutiveSameChar: "Домен не повинен містити три або більше підряд однакових символа.",
      falseDoesNotContainForbiddenSubstrings: "Домен не повинен містити заборонені підстроки.",
      generateDomainTaken: "Цей домен вже зайнято. Спробуйте інший",
      temporarilyUnavailable: "Тимчасово недоступно",
      csettingsAdmin: "Налаштування для адмінів",
      questionLogicSetupTitle: "Налаштування логіки питання",
      questionLogicSetupDescription: "Додайте умови, щоб налаштувати опитування для кожного респондента і збирати більш точні дані.",
      questionLogicConditionTitle: "Умова",
      questionLogicQuestion: "Питання",
      questionLogicSetupQuestionDisableOption: "Оберіть питання",
      questionLogicSetupAnswer: "Відповідь",
      questionLogicSetupLogicType: "Тип",
      questionLogicSetupAnswerDisableOption: "Оберіть тип умови",
      questionLogicSetupRangeRatingBetween: "Між",
      questionLogicSetupRangeRatingLess: "Менше",
      questionLogicSetupRangeRatingMore: "Більше",
      questionLogicSetupRangeRatingEqualTo: "Дорівнює",
      questionLogicSetupRangeRatingFrom: "Від",
      questionLogicSetupRangeRatingTo: "До",
      questionLogicSetupVariantAll: "Обрані всі",
      questionLogicSetupVariantAny: "Обрано один з",
      questionLogicSetupVariantNot: "Жоден з обраних",
      questionLogicSetupCustomEqual: "Дорівнює",
      questionLogicSetupCustomContains: "Містить",
      questionLogicSetupCustomNotContains: "Не містить",
      questionLogicSetupRangeRatingValue: "Значення",
      questionLogicSetupExpectedAnswer: "Очікувані відповіді",
      questionLogicSetupPlaceholder: "Введіть тут",
      questionLogicAllMandatory: "Всі наведені умови обов'язкові",
      questionLogicAddConditionBtn: "Додати умову",
      questionLogicNotAvailable: "Налаштування логіки недоступні для першого питання",
      pointsSettingsNotAvailableForQuestionType: "Цей тип питання не передбачає оцінювання відповідей балами",
      questionLogicSaved: "Налаштування логіки відображення кроку збережені",
      questionLogicDeleteAll: "Видалити логіку",
      questionLogicDeleted: "Логіку відображення кроку видалено",
      questionLogicRatingSelectedLeftBtn: "ліва кнопка",
      questionLogicRatingSelectedRightBtn: "права кнопка",
      QR_code: "QR код",
      QRCodeDownloadPdf: "Завантажити Pdf",
      QRCodeDownloadPng: "Завантажити Png",
      qrGenerateTitle: "Створити QR-код",
      qrGenerateDescription: "Створіть персоналізований QR-код з UTM-мітками для легкого відстеження джерел трафіку. Коли користувачі скануватимуть код, вони потраплятимуть у вашу вікторину з збереженими параметрами кампанії для точної аналітики.",
      qrUtmSource: "Джерело (наприклад, google, newsletter)",
      qrUtmMedium: "Маркетинговий канал (наприклад, cpc, banner, email)",
      qrUtmCampaign: "Продукт, промокод або слоган (наприклад, spring_sale). Потрібна назва кампанії або ідентифікатор кампанії.",
      qrUtmTerm: "Ідентифікація платних ключових слів",
      qrUtmContent: "Використовується для розрізнення оголошень",
      billingPaymentInfoTitle: "Тарифна інформація",
      billingPaymentInfoChangeTarrif: "Змінити тариф",
      billingPaymentInfoDescription: "При оплаті  будь-якого платного тарифу ви отримуєте певну кількість заявок які входить в обраний вами пакет. Ці заявки надаються на місяць. Якщо ви не витратили вашу кількість заявок на через місяць  моменту оплати - заявки анулюються.",
      billingGeneralName: "Ваш тариф",
      billingGeneralCost: "Вартість",
      billingMonth: "місяць",
      billingGeneralExpired: "Дійсний до",
      billingGeneralLeadsLeft: "Заявок залишилось",
      billingGeneralAllTarifExpired: "Термін дії тарифів закінчено",
      billingGeneralBonus: "Бонусні ліди",
      billingGeneralLeadsFromOtherTarifs: "Ліди з інших тарифів",
      billingGeneralNoActiveTariff: "Немає активного тарифу",
      billingLeadsAvailableLabel: "Доступно лідів",
      billingLeadsTariffSourceLabel: "Тариф",
      billingLeadsRemainingOfLabel: "{remaining} / {total} залишилось",
      planUsageTeamMembersLabel: "Учасники команди",
      planUsageManagePlanLabel: "Керувати планом",
      billingAcordeonPaymentInfoTitle: "Платіжна інформація",
      billingAcordeonPaymentInfoFormat: "Формат",
      billingAcordeonPaymentInfoSubscription: "Підписка",
      billingAcordeonPaymentInfoPay: "Оплата",
      billingAcordeonPaymentInfoPayMethod: "Платіжний метод",
      billingAcordeonPaymentInfoCancelSubscription: "Скасувати підписку",
      billingAcordeonPromocode: "Промокод",
      billingAcordeonPromocodeLabel: "Введіть промокод",
      billingAcordeonPayHistory: "Історія транзакцій",
      paymentAllTarifInactive: "тариф неактивний",
      subscriptionUnsubscribeModalTitle: "Відписатись",
      subscriptionUnsubscribeModalDescription: "Ви впевнені що хочете відписатись? Нараховані за підпискою ліди ви зможете використовувати протягом місяця з дня останнього списання коштів за підпискою.",
      subscriptionIsNotDeleteTitle: "Підписка не була видалена",
      subscriptionIsNotDeleteDescription: "Зверніться в службу підтримки",
      subscriptionCanceledTitle: "Підписка анулована",
      embedQuizTitleGetLinkModal: "Вставити квіз на сайт як:",
      QRCodeTitleGetLinkModal: "Використати QR-код:",
      modalSureUnsavedChangesTitle: "У вас є незбережені зміни",
      modalSureUnsavedChangesDescription: "Перед тим як покинути поточну сторінку, будь ласка, вирішіть що зробити з незбереженими змінами",
      modalSureUnsavedChangesDontSave: "Не зберігати",
      modalSureUnsavedChangesSave: "Зберегти",
      modalSuggestIdeaNotificationSuccess: "Успішно! Дякуємо за вашу ідею",
      modalSuggestIdeaNotificationUnsuccess: "Упс! Щось пішло не так. Будь ласка, спробуйте пізніше.",
      telegramTokenCopied: "Токен квізу скопійовано в буфер обміну",
      cSettingsSettingQuizBackButtonTitle: "Кнопка назад",
      cSettingsSettingQuizBackButtonDescription: "Ви можете увімкнути або вимкнути кнопку повернення на попередній крок. Це надасть можливість змінювати дану раніше відповідь.",
      cSettingsCustomThemePrimaryColor: "Колір акцентів",
      cSettingsCustomThemeSecondaryColor: "Фоновий колір",
      cSettingsCustomThemeAdditionalColor: "Колір тексту",
      cSettingsCustomThemeButtonTextColor: "Текст в кнопках",
      cSettingsCustomThemeModeDark: "Темна",
      cSettingsCustomThemeModeLight: "Світла",
      allstepsPlaceholder: "Плейсхолдер",
      allstepsCustomInput: "Свій варіант",
      allstepsCustomInputOn: "Увімкнути",
      allstepsCustomPlaceholder: "Власний варіант ",
      trashcanTitle: "Кошик",
      trashcanImportant: "Важливо!",
      trashcanDescription: "Квіз буде автоматично видалено назавжди через 30 днів після переміщення в кошик.",
      trashcanClearAll: "Очистити все",
      quizSlotDeletedData: "Видалено",
      workboardLeads: "Ліди",
      filterOptionLabelCreatedDesc: "від нових до старих",
      filterOptionLabelCreatedAsc: "від старих до нових",
      filterOptionLabelLeadsDesc: "По лідам (від більшого)",
      filterOptionLabelLeadsAsc: "По лідам (від меншого)",
      filterOptionLabelWithProject: "Квізи у проєктах",
      filterOptionLabelWithoutProject: "Квізи без проєкту",
      workboardDuplicate: "Дублювати",
      leadsTable: "Список лідів",
      exportInfo: "Експорт лідів",
      leadHide: "Сховати",
      leadShowMore: "Детальніше",
      poperTrashcan: "Кошик",
      restoreQuizSendedTitle: "Запущена задача відновлення",
      restoreSuizSendedImportant: "Важливо",
      restoreQuizSendedDescription: "В залежності від того, як багато лідів було у вашому квізі, відновлення квізу може зайняти від декількох секунд до 2-х хвилин. Після відновлення квіз з'явиться на вашому основному воркборді.",
      ok: "Зрозуміло",
      month: "0 місяців | {n} місяць | {n} місяці | {n} місяців",
      discount: "Знижка до",
      saveMoney: "Підписка на рік",
      upProVersionMobile: "На PRO",
      upProVersionDesktop: "Перейти на PRO",



      
      csettingsIntegrationSendPulse: "Інтеграція - Send Pulse",
      csettingsIntegrationMailchimp: "Інтеграція - Mailchimp",
      csettingsIntegrationMake: "Інтеграція - Make",
      csettingsIntegrationZapier: "Інтеграція - Zapier",
      csettingsIntegrationCRMBitrix: "Інтеграція - CRM Bitrix",
      csettingsIntegrationPipeDrive: "Інтеграція - Pipe Drive",
      csettingsIntegrationRemOnline: "Інтеграція - Rem Online",
      csettingsIntegrationKeyCRM: "Інтеграція - Key CRM",
      csettingsIntegrationGoogleSpreadsheets: "Інтеграція - Google Spreadsheets",
      
      csettingsIntegrationZapierAbout: "Вставте URL-адресу для відправки данних, надану Zapier, в поле для вводу.",
      csettingsIntegrationMakeAbout: "Вставте URL-адресу для відправки данних, надану Make, в поле для вводу.",
      csettingsIntegrationMakeAboutTextStep1: "Для налаштування інтеграції з",
      csettingsIntegrationMakeAboutTextStep2: "перегляньте",
      csettingsIntegrationMakeAboutTextStep3: "Для налаштування виберіть серед інтеграцій на стороні Make – “Webhooks”, далі “Custom webhook”.",
      csettingsIntegrationMakeAboutTextStep4: "Скопіюйте отримане посилання та вставте в поле нижче в ADS Quiz.",
      csettingsIntegrationMakeAboutTextStep5: "Для тестування поверніться в Make, натисніть кнопку “Run” і пройдіть квіз, надіславши одну заявку.",
      csettingsIntegrationMakeAboutTextStep6: "У разі успішного тестування збережіть інтеграцію та не забудьте активувати оновлення.",
      csettingsIntegrationMakeAboutLinkVideoText: "відео",
      csettingsIntegrationCRMBitrixAbout: "Вставте URL-адресу для відправки данних, надану CRM Bitrix, в поле для вводу.",

      csettingsIntegrationSendPulseAboutStart: "Ви можете налаштувати інтеграцію з сервісом ",
      csettingsIntegrationSendPulseAboutMiddle: " Для цього перейдіть у налаштування вашого облікового запису та відкрийте вкладку ",
      csettingsIntegrationSendPulseAboutEnd: " Скопіюйте значення параметрів 'ID' і 'Secret', а потім вставте їх у відповідні поля в сервісі ADS Quiz (у поля нижче). Далі потрібно вставити ID адресної книги. Для цього перейдіть до потрібної адресної книги та скопіюйте з URL-адреси сторінки значення після id/. Потрібні лише цифри без додаткових символів. Збережіть зміни. Більш детальна інструкція у ",
      csettingsIntegrationSendPulseAboutLinkSendPulse: "https://sendpulse.ua/#60c9ccfd55f4b",
      csettingsIntegrationSendPulseAboutLinkAPI: "https://login.sendpulse.com/login/#api",
      csettingsIntegrationSendPulseAboutLinkVideo: "https://www.youtube.com/watch?v=4mnhpbKkePs",
      csettingsIntegrationSendPulseAboutLinkVideoText: "відео",

      csettingsIntegrationKeyCRMAbout: "Вставте API ключ та PipelineID, у відповідні поля для вводу.",
      csettingsIntegrationPipeDriveAbout: "Вставте токен та домен компанії, у відповідні поля для вводу.",
      csettingsIntegrationRemOnlineAbout: "Вставте API ключ Rem Online у відповідне поле для вводу.",
      csettingsIntegrationGoogleSheetsAbout: "Увійдіть у Google Sheets (якщо ваш обліковий запис зареєстровано на адресу Gmail, ви можете підключити лише цей обліковий запис Gmail; спроба підключити інший обліковий запис призведе до помилки), оберіть лист таблиці та зіставте поля, щоб почати передавання даних.",
      csettingsIntegrationMailchimpAbout: "Підключіть Mailchimp, виберіть аудиторію та за потреби налаштуйте меппінг полів.",
      csettingsIntegrationKeepinCrmAbout: "Вставте API ключ KeepinCRM, оберіть воронку, статус, менеджера та джерело. За потреби увімкніть меппінг полів.",
      csettingsIntegrationActiveIntegration: "Активна інтеграція",
      cintegrationIntegrationData: "Дані інтеграції",
      cintegrationMailchimpAudience: "Аудиторія",
      cintegrationMailchimpAudiencePlaceholder: "Оберіть аудиторію",
      cintegrationMailchimpStatus: "Статус підписки",
      cintegrationMailchimpStatusOptionSubscribed: "subscribed (Підписаний)",
      cintegrationMailchimpStatusOptionPending: "pending (Очікує підтвердження)",
      cintegrationMailchimpStatusOptionUnsubscribed: "unsubscribed (Відписаний)",
      cintegrationMailchimpStatusOptionCleaned: "cleaned (Видалений)",
      cintegrationMailchimpStatusOptionTransactional: "transactional (Лише транзакційні)",
      cintegrationMailchimpStatusDescriptionSubscribed: "контакт зможе отримувати ваші розсилки.",
      cintegrationMailchimpStatusDescriptionPending: "користувач ще не підтвердив підписку через email.",
      cintegrationMailchimpStatusDescriptionUnsubscribed: "контакт відмовився від розсилок.",
      cintegrationMailchimpStatusDescriptionCleaned: "листи не доставляються.",
      cintegrationMailchimpStatusDescriptionTransactional: "використовується тільки для сервісних листів, не для маркетингових розсилок.",
      cintegrationMailchimpConnect: "Підключити Mailchimp",
      cintegrationMailchimpConnectTo: "Підключіть Mailchimp",
      cintegrationMailchimpConnectedTo: "Підключено до Mailchimp",
      cintegrationMailchimpUseMapping: "Налаштування полів",
      cintegrationMailchimpDataSaved: "Дані інтеграції з Mailchimp збережено",
      cintegrationDataMailchimpError: "Вкажіть аудиторію Mailchimp",
      cintegrationMailchimpMappingError: "Заповніть меппінг полів",
      cintegrationMailchimpNoTags: "У Mailchimp немає тегів",
      cintegrationIntegrationUrl: "URL інтеграції",
      cintegrationWriteUrl: "Введіть URL",
      cintegrationDataFBError: "Неправильний ідентифікатор пікселя",
      cintegrationDataWebHookError: "Неможлива адреса вебхуку",
      cintegrationZapierDataSaved: "Дані інтеграції з Zapier збережено",
      cintegrationDataZapierError: "Неможлива адреса інтеграції",
      cintegrationAPIxDriveDataSaved: "Дані інтеграції з APIxDrive збережено",
      cintegrationDataAPIxDriveError: "Рядок не є адресою інтеграції APIxDrive ",
      cintegrationMakeDataSaved: "Дані інтеграції з Make збережено",
      cintegrationDataMakeError: "Неможлива адреса інтеграції",
      cintegrationSendPulseDataSaved: "Дані інтеграції з SendPulse збережено",
      cintegrationDataSendPulseError: "Неможливі або порожні дані інтеграції",
      cintegrationPipeDriveDataSaved: "Дані інтеграції з PipeDrive збережено",
      cintegrationDataPipeDriveError: "Неможливі або порожні дані інтеграції",
      cintegrationRemOnlineDataSaved: "Дані інтеграції з RemOnline збережено",
      cintegrationDataRemOnlineError: "Неможливі або порожні дані ключ",
      cintegrationKeyCRMDataSaved: "Дані інтеграції з KeyCRM збережено",
      cintegrationDataKeyCRMError: "Неможливі або порожні дані інтеграції",
      cintegrationInputEmailUrl: "Введіть Email",
      cintegrationEmailDataSaved: "Email збережено",
      cintegrationDataEmailError: "Введений рядок не є Імейлом",
      cintegrationCRMBitrixDataSaved: "Email збережено",
      cintegrationDataCRMBitrixError: "Введений рядок не є Імейлом",
      cintegrationTelegramBotDataSaved: "Налаштування Telegram інтеграції збережено",
      cintegrationDataTelegramBotError: "Помилка збереження",
      cintegrationGTMDataSaved: "Ідентифікатор Google Tag Manager збережено",
      cintegrationDataGTMError: "Невірний ідентифікатор",
      cintegrationDataGTMErrorDescription: "Ідентифікатор повинен мати вигляд GTM-XXXXXX",
      cintegrationGoogleAnalyticsDataSaved: "Ідентифікатор Google Analytics збережено",
      cintegrationDataGoogleAnalyticsError: "Неправильний ідентифікатор",
      cintegrationDataGoogleAnalyticsErrorDescription: 'Ідентифікатор повинен мати вигляд "UA-XXXXXXX-X" або "G-XXXXXXXXXX-XX"',
      cintegrationTikTokDataSaved: "Tik-Tok піксель збережено",
      cintegrationDataTikTokError: "Введений рядок не є Tik-Tok пікселем",
      cintegrationIntegrationToken: "Токен інтеграції",
      cintegrationWriteToken: "Введіть токен інтеграції",
      cintegrationDataYourAPIKey: "Введіть ваш API ключ",
      viewQuizInMobile: "Переглянути квіз",
      notificationCSRFTokenMismatch: "Невідповідність CSRF токену",
      notificationReloadPage: "Перезавантажте сторінку та спробуйте ще раз",
      csettingsIntegrationKeyRemOnline: "Вставте токен та ідентифікатор каналу у відповідні поля",
      cintegrationDataYourIntegrationToken: "API ключ",
      cintegrationDataLeadTypeId: "Ідентифікатор каналу",
      send_utm: "Відправляти UTM мітки",
      send_quiz: "Відправляти дані квізу",
      send_answers: "Відправляти питання і відповіді",
      csettingsIntegrationKeyCrm: "Інтеграція KeyCRM",
      cintegrationSendPulseClientId: "ID клієнта",
      cintegrationSendPulseClientSecret: "Secret",
      cintegrationSendPulseAddressBookId: "ID адресної книги",
      cintegrationSendPulseAction: "Дія з контактом",
      sendpulseActionAddContact: "Додати контакт",
      sendpulseActionDeleteContact: "Видалити контакт",
      cintegrationPipeDriveToken: "API токен",
      cintegrationPipeDriveDomain: "Ваш унікальний субдомен",
      cintegrationKeyCrmApiKey: "API ключ",
      cintegrationKeyCrmPipelineId: "Ідентифікатор воронки",
      cintegrationMenuGoogleTagManager:"Google Tag Manager",
      cintegrationMenuGoogleAnalytics:"Google Analytics",
      cintegrationMenuGoogleSpreadsheets:"Google таблиці",
      cintegrationMenuKeepinCRM:"KeepinCRM",
      cintegrationMenuFacebookPixel:"Facebook pixel",
      cintegrationMenuTikTokPixel:"TikTok Pixel",
      cintegrationMenuWebHook:"Webhook",
      cintegrationMenuZapier:"Zapier",
      cintegrationMenuAPIxDrive:"APIx Drive",
      cintegrationMenuMake:"Make",
      cintegrationMenuSendPulse:"Send Pulse",
      cintegrationMenuMailchimp:"Mailchimp",
      cintegrationMenuEmail:"Email",
      cintegrationMenuTelegramBot:"Telegram-бот",
      cintegrationMenuPipeDrive:"PipeDrive",
      cintegrationMenuRemOnline:"Rem Online",
      cintegrationMenuKeyCRM:"Key CRM",
      cintegrationMenuCRMBitrix:"CRM Bitrix",
      googleSignIn: "Увійти через Google",
      googleSignInHint: "Авторизуйтеся, щоб продовжити налаштування інтеграції.",
      cintegrationGoogleSpreadsheetID: "ID таблиці",
      cintegrationGoogleSheetName: "Назва листа",
      googleSheetNameTip: "Використовуйте назву листа так, як вона вказана у Google Sheets.",
      googleSheetsMappingTitle: "Меппінг полів",
      cintegrationGoogleSheetsSaved: "Дані Google Spreadsheets збережено",
      googleSheetsSelectSheet: "Оберіть лист таблиці",
      googleSheetsSelectSheetPlaceholder: "Оберіть лист",
      googleSheetsSelectSheetFirst: "Спочатку оберіть лист, щоб налаштувати меппінг",
      csettingsIntegrationKeepinCrm: "Інтеграція - KeepinCRM",
      cintegrationKeepinPipelineId: "Воронка",
      cintegrationKeepinPipelineIdPlaceholder: "Оберіть воронку",
      cintegrationKeepinStatusId: "Статус",
      cintegrationKeepinStatusIdPlaceholder: "Оберіть статус",
      cintegrationKeepinManagerId: "Менеджер",
      cintegrationKeepinManagerIdPlaceholder: "Оберіть менеджера",
      cintegrationKeepinSourceId: "Джерело",
      cintegrationKeepinSourceIdPlaceholder: "Оберіть джерело",
      cintegrationKeepinUseMapping: "Використовувати меппінг полів",
      cintegrationKeepinDataSaved: "Дані KeepinCRM збережено",
      trashcanRestoreQuiz: "Відновити квіз",
      cformValuePromotionAccepted: "Погоджуюсь на емейл розсилку",


      constructorAddIntegration: "Додати нову інтеграцію",
      cintegrationKeyCrmSourceId: "Ідентифікатор джерела (необов'язково)",
      cintegrationKeyCrmManagerId: "Ідентифікатор менеджера (необов'язково)",
      cSettingsSettingQuizSpamFilterTitle: "Захист від спаму",
      cSettingsSettingQuizSpamFilterDescription: "Функціонал за замовчуванням вимкнутий. Якщо ви зіштовхнулись з проблемою спамових лідів - увімкніть захист. Після цього, один користувач не зможе відправити більше вказаної кількості лідів на цей квіз.",
      cSettingsSettingQuizSpamFilterLimitPlaceholder: "Кількість лідів",
      langNO: "Норвезька",
      loadMoreLeads: "Переглянути більше лідів",
      userAdditionalSettingsHeader: "Додаткові налаштування",
      userAdditionalSettingsDescription1: "Тут ви можете налаштувати нові додаткові параметри профілю.",
      userAdditionalSettingsPagination: "Пагінація на воркборді",
      
      benefitType: "Тип бонусу",
      benefitLabelPlaceholder: "Текст бонусу",
      benefitDescriptionPlaceholderDiscount: "Промокод або інструкція",
      benefitDescriptionPlaceholderVideo: "Посилання на відео",
      benefitDescriptionPlaceholderTextfile: "Посилання на текстовий файл",
      benefitDescriptionPlaceholderGift: "Розшифровка бонусу",
      benefitDescriptionPlaceholderPDF: "Посилання на PDF",
      benefitDescriptionPlaceholderLink: "Посилання",
      benefitDescriptionPlaceholderFile: "Посилання на файл",
      benefitDescriptionPlaceholderCustom: "Посилання",
      benefitLabelDiscount: "Знижка",
      benefitLabelVideo: "Відео",
      benefitLabelTextfile: "Текстовий файл",
      benefitLabelGift: "Подарунок",
      benefitLabelPDF: "PDF файл",
      benefitLabelLink: "Посилання",
      benefitLabelFile: "Файл",
      benefitLabelCustom: "Індивідуальний бонус",
      addBenefit: "Додати бонус",
      saveBenefit: "Зберегти бонус",
      cfinishSocialNetworks: "Соціальні мережі",
      
      saveSocialNet: "Зберегти соціальну мережу",
      networkLabelFacebook: "Facebook",
      networkLabelInstagram: "Instagram",
      networkLabelTelegram: "Telegram",
      networkLabelTiktok: "Tik-Tok",
      networkLabelYoutube: "Youtube",
      networkLabelLinkedin: "LinkedIn",
      networkLabelWhatsapp: "WhatsApp",
      socialNetDescriptionPlaceholderFacebook: "нікнейм",
      socialNetDescriptionPlaceholderInstagram: "нікнейм",
      socialNetDescriptionPlaceholderTelegram: "нікнейм / канал",
      socialNetDescriptionPlaceholderTiktok: "нікнейм",
      socialNetDescriptionPlaceholderYoutube: "нікнейм_каналу",
      socialNetDescriptionPlaceholderLinkedin: '"in/name" або "company/name"',
      socialNetDescriptionPlaceholderWhatsapp: "+15555551234",

      addNewSectionEmptyPage: "Текстова сторінка",
      csanyMakeImpasse: "Зробити тупиковим кроком",
      impaseIsImpaseTrue: "Увімкнено",
      impaseIsImpaseFalse: "Вимкнено",
      defaultNewEmptyQuestionDescription: "Тут можна вставляти та форматувати довгий текст (ми не рекомендуємо вставляти більше 3000 символів).",
      cSettingsSettingQuizTimezoneTitle: "Таймзона квізу",
      cSettingsSettingQuizTimezoneDescription: "Впишіть таймзону відповідно якої буде вказуватись час заповнення лідів. Це зручно використовувати, особливо тоді, коли ви знаходитесь в одному часовому поясі, а клієнт в іншому. В такому разі, ви можете вказати часовий пояс клієнта і в лідах які будуть приходити, буде вказано час згідно часового поясу клієнта.",
      cSettingsSettingQuizTimezonePlaceholder: "Часовий пояс",
      userAdditionalSettingsTimezone: "Часовий пояс користувача",
      userAdditionalSettingsTimezonePlaceholder: "Часовий пояс",
      langHE: "Іврит",
      langCS: "Чеська",
      cintegrationCAPIFBInstruction: "Щоб налаштувати інтеграцію з Facebook Conversion API, вам необхідно ввести ідентифікатор пікселя та маркер доступу. Ці дані можна отримати в налаштуваннях Facebook Business Manager. Після введення необхідної інформації збережіть інтеграцію.",
      cintegrationCAPIFBInstructionTextTitle: "Назви подій для FB Conversions:",
      cintegrationCAPIFBInstructionTextStart: " – відвідування стартової сторінки;",
      cintegrationCAPIFBInstructionTextQuestionN: "– відвідування кроку N (номер кроку підставляється динамічно);",
      cintegrationCAPIFBInstructionTextOpenContactPage: " – відвідування сторінки контактів;",
      cintegrationCAPIFBInstructionTextLead: " – успішне відправлення форми з контактними даними;",
      cintegrationCAPIFBInstructionTextThankYou: "– відвідування фінальної сторінки.",
      cintegrationCAPIFBInstructionTextOptimizationAdvice: "Ми рекомендуємо запускати рекламу з оптимізацією на подію",
      cintegrationCAPIFBInstructionTextLeadTriggerCondition: "Ця подія відправляється",
      bold_capi_adsquiz_Start: "capi_adsquiz_Start",
      bold_capi_adsquiz_QuestionN: "capi_adsquiz_Question-N",
      bold_capi_adsquiz_OpenContactPage: "capi_adsquiz_OpenContactPage",
      bold_capi_adsquiz_Lead: "capi_adsquiz_Lead",
      bold_capi_adsquiz_ThankYou: "capi_adsquiz_ThankYou",
      bold_capi_adsquiz_OptimizationAdvice: "“capi_adsquiz_Lead”.",
      bold_capi_adsquiz_LeadTriggerCondition: "тільки у разі успішного отримання заявки від користувача.",
      csettingsIntegrationFbCapiAbout: "Інтеграція з Facebook Conversion API дозволяє передавати дані про взаємодії користувачів безпосередньо в Facebook для підвищення ефективності рекламних кампаній.",
      cintegrationInputCapiAccessToken: "Введіть маркер доступу",
      cintegrationInputCapiCustomparameter: "Введіть кастомні параметри подій",
      cintegrationDataFbCapiSaved: "Інтеграція з Facebook Conversion API успішно збережена",
      cintegrationComonRenovateHubInstructionTitle: "Інструкція з налаштування інтеграції з «Міністерство Ремонту»",
      cintegrationComonRenovateHubInstructionDescription1: "Для налаштування інтеграції з «Міністерство Ремонту» вкажіть URL вебхука, на який будуть надсилатися дані.",
      cintegrationComonRenovateHubInstructionDescription2: "Для цього перейдіть в «Адмін-панель», далі відкрийте розділ «Інтеграції» та оберіть ADS Quiz. Натисніть «Створити webhook URL», скопіюйте його та вставте в сервісі ADS Quiz у поле вводу нижче.",
      cintegrationComonRenovateHubInstructionDescription3: "Після цього пройдіть квіз для тестування або надішліть тестовий лід за допомогою кнопки «Тест».",
      cintegrationComonRenovateHubInstructionDescription4: "Після цього збережіть та активуйте інтеграцію. Усі ліди будуть надходити в «Міністерство Ремонту» в розділ «Запити».",
      cintegrationComonRenovateHubInstructionShort: "Інтеграція з «Міністерство Ремонту» дозволяє передавати дані в CRM через вебхук для автоматизації процесів.",
      cintegrationRenovateHubUrl: "Введіть URL «Міністерство Ремонту»",
      cintegrationInputRenovateHubUrl: "Вкажіть URL вебхука для «Міністерство Ремонту»",
      cintegrationRenovateHubDataSaved: "Інтеграція з «Міністерство Ремонту» успішно збережена",
      cintegrationDataRenovateHubError: "Помилка при збереженні інтеграції з «Міністерство Ремонту». Перевірте правильність введених даних.",
      cintegrationMenuFacebookConvAPI: "Facebook Conversions API",
      cintegrationMenuRenovateHub: "Міністерство Ремонту",
      csettingsIntegrationRenovateHub: "Інтеграція з «Міністерство Ремонту»",
      csettingsIntegrationCAPIFB: "Інтеграція з Facebook Conversions API",
      paymentPlanEnd: "Дата закінчення тарифу",
      paymentPlanNextPayment: "Наступний платіж",
      paymentPlanLeadsLimitForYear: "Ліміт лідів на рік:",
      paymentPlanLeadsLimitForPeriod: "Ліміт лідів на період:",
      EditTags: "Змінити теги",
      quizzesTemplatesNoTags: "Без тегів",
      Monday: "Понеділок",
      Tuesday: "Вівторок",
      Wednesday: "Середа",
      Thursday: "Четвер",
      Friday: "П’ятниця",
      Saturday: "Субота",
      Sunday: "Неділя",
      datetimeDisplayMode: "Тип вибору",
      datetimeDisplayModeSelect: "Оберіть тип",
      datetimeDisplayModeDate: "Дата",
      datetimeDisplayModeTime: "Час",
      datetimeDisplayModeDatetime: "Дата і час",
      datetimeMinDate: "Мін. дата",
      datetimeMinDateCustom: "Вкажіть мін. дату",
      datetimeMaxDate: "Макс. дата",
      datetimeMaxDateCustom: "Вкажіть макс. дату",
      datetimeProhibitDaysOfWeek: "Обмежити дні",
      datetimeIsRange: "Діапазон",
      datetimeIsRangeTrue: "Діапазон увімкнено",
      datetimeIsRangeFalse: "Діапазон вимкнено",
      datetimeMinTime: "Мін. час",
      datetimeMaxTime: "Макс. час",
      datetimeIs24: "Формат 24 години",
      datetimeIs24True: "Формат 24 год увімкнено",
      datetimeIs24False: "Формат 24 год вимкнено",
      csanyIsExactDate: "Як ви бажаете налаштовувати дату",
      csanyIsExactDateTrue: "Точна дата",
      csanyIsExactDateFalse: "Відносна дата",
      csanyDatetimeMinMaxNotExactPlaceholder: '"x" або "-x" днів від сьогодні',
      addNewSectionDatetime: "Дата/час",
      tariffsPromo: "Акційні пропозиції",
      pricingComparisonEyebrow: 'Тарифи Adsquiz',
      pricingComparisonTitle: 'Оберіть один із наших планів',
      pricingComparisonMobileHint: 'Гортайте картки тарифів і оберіть два з них нижче, щоб порівняти детально.',
      pricingComparisonTableAria: 'Таблиця порівняння тарифів',
      pricingComparisonMonthShort: 'місяць',
      billingPromoPeriodYearly: "рік",
      billingPromoPeriodMonths: "{count} місяців",
      billingPromoDescription: "Без обмежень у квізах та функціоналі",
      pricingComparisonTryFree: 'Спробувати безкоштовно',
      pricingComparisonGetStarted: 'Покращити',
      pricingComparisonCurrentPlan: 'Ваш тариф',
      pricingComparisonBuyAgain: 'Купити повторно',
      pricingComparisonLeadsPerMonth: '{count} лідів /місяць',
      pricingComparisonUnlimited: 'Без обмежень',
      pricingComparisonTeamUsers: '0 користувачів | +{n} користувач | +{n} користувачі | +{n} користувачів',
      pricingComparisonRequired: 'Обовʼязковий',
      pricingComparisonOptional: 'Опціонально',
      tariffsMonth: "Щомісячно",
      tariffsAnual: "Щорічно",
      leadsOn1Month: "на місяць",
      leadsOn2Month: "на 2 місяці",
      leadsOn3Month: "на 3 місяці",
      leadsOn4Month: "на 4 місяці",
      leadsOn5Month: "на 5 місяців",
      leadsOn6Month: "на 6 місяців",
      leadsOn7Month: "на 7 місяців",
      leadsOn8Month: "на 8 місяців",
      leadsOn9Month: "на 9 місяців",
      leadsOn10Month: "на 10 місяців",
      leadsOn11Month: "на 11 місяців",
      leadsOn12Month: "на рік",
      leadsOn24Month: "на 2 роки",
      leads: "лідів",
      tariffsWordPrice: "Ціна",
      tariffsNoLimits: "Без обмежень",
      tariffsNoLimitsQuizzes: "у квізах",
      tariffsAndFunctions: "та функціоналі",
      billingTariffYear: "рік",
      billingChangePlanSubscribe: "Підписатись",
      paymentAllTariffInactive: "Тариф не активний",
      subscriptionTariffLableOnly: "Доступно лише для підписки",
      notExactBeforeYear: "рік тому",
      notExactBeforeHalfYear: "пів року тому",
      notExactBeforeQuarter: "чверть року тому",
      notExactBeforeMonth: "місяць тому",
      notExactBeforeWeek: "тиждень тому",
      notExactBeforeYesterday: "позавчора",
      notExactYesterday: "вчора",
      notExactToday: "сьогодні",
      notExactTomorrow: "завтра",
      notExactAfterTomorrow: "післязавтра",
      notExactAfterWeek: "за тиждень",
      notExactAfterMonth: "за місяць",
      notExactAfterQuarter: "за чверть року",
      notExactAfterHalfYear: "за пів року",
      notExactAfterYear: "за рік",
      tipDefaultDateHeader: "За замовчуванням",
      tipDefaultDateText: "Якщо обидва перемикачі 'Точна дата' та 'Відносна дата' вимкнені, календар дозволятиме вибирати дати в діапазоні від 1800 до 2200 року за замовчуванням.",
      tipExactDateHeader: "Перемикач точної дати",
      tipExactDateText: "Увімкнення цього перемикача обмежить календар фіксованим діапазоном дат, які вибрані в полях введення нижче.",
      tipRelativeDateHeader: "Перемикач відносної дати",
      tipRelativeDateText: "Увімкнення цього перемикача динамічно встановить обмеження календаря на основі відносних дат, які обчислюються під час завантаження сторінки. Ці обмеження персоналізовані та перераховуються для кожного користувача окремо.",
      langPT: "Португальська",
      placeholderCompanyContactText: 'Наприклад: "Телефон компанії: +380993322211"',
      integrationConnectService: "Підключити",
      Connect: "Підключити",
      Connected: "Підключено",
      Disconnect: "Відключити",
      cintegrationOauthDisconnectModalTitle: "Відключити {provider}?",
      cintegrationOauthDisconnectModalDescription: "Відключення {provider} відключить цю інтеграцію від УСІХ квізів. Якщо ви хочете вимкнути її лише для цього квізу, видаліть інтеграцію нижче.",
      cintegrationOauthDisconnectModalDescriptionBase: "Відключення {provider} відключить цю інтеграцію від УСІХ квізів.",
      cintegrationOauthDisconnectModalDescriptionDeleteHint: "Якщо ви хочете вимкнути її лише для цього квізу, видаліть інтеграцію нижче.",
      cintegrationOauthDisconnectDeleteQuizOnly: "Видалити тільки в цьому квізі",
      cintegrationOauthDisconnectAllQuizzes: "Відключити для всіх квізів",
      leadtype_id: "Тип дії",
      selectVariant: "Оберіть",
      sfirstAddCompanyContacts: "Текст з контактами",
      addNewSectionTextarea: "Великий інпут",
      allstepsVariantView: "Формат зображення",
      tariffsDiscountSave: "Економія",
      cAdminSettingsTitle: "Адмін налаштування",
      cAdminSettingsInstruction: "Впишіть в поле нижче теги для квізу. Теги можуть складатися з декількох слів, кожен тег відділяється комою. Теги 'Послуги' і 'послуги' - це різні теги. Варто використовувати теги які починаються з великої літери. Також, можна виключити квіз зі списку шаблонів.",
      cAdminSettingsIsTemplate: "Чи являється шаблоном",
      cIsTemplateStateAreSaved: "Стан шаблону збережено",


      sfirstAddLogotype: "Додайте логотип",
      logotypeSizeTip: "Логотип буде вставлено в реальному розмірі, але не більше 120 пікселів по більшій зі сторін.",
      cfirstLogotypeUpdated: "Логотип додано",
      cfirstLogotypeDeleted: "Логотип успішно видалено!",


      cOffersPageSettings: "Налаштування",
      offerPageTitlePlaceholder: "Введіть заголовок",
      offerPageDescriptionPlaceholder: "Введіть опис для сторінки",
      offerPageButtonTextPlaceholder: "Введіть текст кнопки (необов'язково)",
      allstepsOffers: "Список офферів",
      offerProposalHeader: "Оффер",
      offerAttachAddImg: "Додати зображення",
      offerAttachAddVideo: "Додати відео",
      offerItemImg: "Зображення",
      offerItemTitle: "Заголовок офферів",
      offerTitlePlaceholder: "Введіть заголовок тут",
      offerItemSubtitle: "Підзаголовок (наприклад ціна)",
      offerSubtitlePlaceholder: "Введіть текст тут",
      offerItemDescription: "Опис оффера",
      offerDescriptionPlaceholder: "Введіть опис тут",
      offerItemButtonText: "Текст кнопки оффера",
      offerBtnTextPlaceholder: "Введіть текст кнопки",
      offerItemButtonLink: "Посилання для кнопки",
      offerBtnLinkPlaceholder: "Посилання починайте з https://",
      csanyOfferLogic: "Логіка відображення",
      offerAddNewOffer: "Додати новий оффер",

      offerLogicSetupTitle: "Налаштування логіки",
      OfferLogicSetupDescription: "Тут ви можете налаштувати при яких відповідях будуть відображатись ті чи інші офферри",
      cstepsOffersPage: "Сторінка результатів",
      addNewSectionResultsByLogic: "Сторінка результатів",
      cformActionAfterContactOffersOr: "Сторінка з офферами / ",
      tolltipOffersAfterContact: "Якщо після проходження квізу, логіка відображення, хоча б одного офферу буде виконана, буде відображено сторінку з офферами, інакше - Сторінку подяки",
      videoCircleTextQuestion: "Відеоінструкція",
      offerPhotoOptimalRatio: "Для оптимального відображення зображення радимо використовувати пропорції 16:9",
      tolltipThankYouAfterContact: "Після проходження квізу, буде відображено сторінку вдячності",
      cformActionAfterContactOffers: "Сторінка результатів",
      addOfferPageInContact: "Увімкнути сторінку результатів",
      offerPageHeader: "Заголовок для сторінки офферів",
      pumkinOrange: "Помаранчевий",
      invalidSocialNetworkURL: "Неправильне посилання",
      itMustBeFullLink: 'Перевірте правильність введеного посилання. Воно повинно починатись з протоколу "https://" і відповідати зберігаємій соціальній мережі.',
      addSocialLinks: "Додати соціальну мережу",
      questionAttachAddImg: "Фото",
      questionAttachAddVideo: "Відео",
      questionChooseLineInput: "Лінійне поле вводу",
      questionChooseClassicInput: "Класичне поле вводу",
      questionChooseOneColumn: "1 колонка",
      questionChooseTwoColumns: "2 колонки",
      allStepsVideoUrl: "Посилання на відео",
      allStepsPhotoHeader: "Фото",
      
      cintegrationMenuSalesDrive: "SalesDrive",
      csettingsIntegrationSalesDrive: "Інтеграція - SalesDrive",
      csettingsIntegrationSalesDriveAbout: "Ви можете надсилати ліди в CRM SalesDrive",
      cintegrationSalesDriveApiKey: "Вставте API ключ",
      cintegrationSalesDriveDomain: "Вставте домен наданий SalesDrive",
      cintegrationSalesDriveDataSaved: "SalesDrive інтеграцію збережено",
      send_offers: "Надсилати офери які відобразились відвідувачу",
      cformShowConsultant: "Відображати консультанта",
      consultantPhoto: "Фото консультанта",
      consultantName: "Ім'я консультанта",
      consultantJobTitle: "Посада консультанта або інша інформація",
      consultantRating: "Рейтинг консультанта",
      signinIWouldLikeReciveEmail: "Я хочу отримувати новини та спеціальні пропозиції від ADS QUIZ (Ви можете відмовитися від цих розсилок у будь-який час).",
      acceptedFileSizeUpTo: "до",
      customDesignColorTags: "Теги",
      customDesignColorActiveButton: "Колір активного елемента",
      customDesignColorInactiveButton: "Колір не активного елемента",
      customDesignColorActiveText: "Колір активного тексту",
      customDesignColorInactiveText: "Колір неактивного тексту",
      addNewSectionDropdown: "Випадаючий список",
      langFR: "Французська",
      addNewSectionRatePage: "Сторінка з оцінкою",
      bold_adsquiz_Offers_page: "adsquiz_Open-Offers-Page",
      cintegrationFBInstructionTextOffersPage: "Перехід на сторінку оферів",
      defaultNewQuestionDropdownPlaceholder: "Клікніть тут, щоб відкрити список варіантів",
      allStepsVideoUrlPlaceholder: "https://youtube, vimeo або wistia",
      addListOfAnswersButton: "Додати декілька",
      addListOfAnswersTitle: "Масове додавання варіантів відповідей",
      addListOfAnswersInstruction: "Вставте список варіантів відповідей у це поле, щоб додати їх. Варіанти можуть бути розділені за рядками [↵], крапкою з комою [;], комою [,] або пробілом [ ]. Розділення відбувається за роздільником з найвищим пріоритетом: [↵] → [;] → [,] → [ ].",
      addListOfAnswersPlaceholder1: "Відповідь 1",
      addListOfAnswersPlaceholder2: "Відповідь 2",
      addListOfAnswersSendButton: "Додати",
      addNewPerson: "Додати учасника",
      cfirstGradientOverlay: "Градієнтний фоновий шар",
      cfirstGradientOverlayTip: "Градієнтний фоновий шар корисний, якщо у вас не дуже контрастне, до кольору тексту, фонове зображення",
      cfirstContentBorder: "Розділювальна межа контенту",
      workboardDuplicateToOthers: "Скопіювати на інший акаунт",
      workboardDuplicateAndTransferQuiz: "Дублювати квіз на інший акаунт",
      workboardDuplicateAndTransferQuizHintTitle: "При дублюванні квізу, він буде продубльований на акаунт отримувача як шаблон.",
      workboardDuplicateAndTransferQuizHintTitleSecond: "Квіз на акаунті отримувача, буде чистим, без лідів і інтеграцій. Поточний квіз залишиться без змін. Щоб скопіювати квіз на інший акаунт, один із користувачів повинен мати будь-який",
      workboardDuplicateAndTransferQuizConfirm: "Здублювати",
      workboardDuplicateAndTransferQuizStatus200: "Квіз успішно скопійовано на акаунт:",
      delOffersPageQuestionForModalConfirm: "Вы впевнені, що хочете видалити сторінку з оферами?",
      offerPageDefaultDescription: "Введіть сюди опис сторінки з результатами",
      offerPageDefaultButtonText: "Завершити",
      cintegrationMenuKommo: "Kommo",
      csettingsIntegrationKommo: "Інтеграція - Kommo",
      csettingsIntegrationKommoAbout: "Ви можете надсилати ліди в CRM Kommo",
      cintegrationKommoToken: 'Вставте "Long-lived Token"',
      cintegrationKommoDomain: "Вставте ваш субдомен",
      cintegrationKommoDataSaved: "Kommo інтеграцію збережено",
      cintegrationKommoPipelineId: "Вставте PipelineID",
      cintegrationKommoPipelineIdPlaceholder: "Оберіть Воронку",
      cintegrationKommoStatusID: "Вставте StatusID",
      cintegrationKommoStatusIDPlaceholder: "Оберіть статус нового ліда (необов'язково)",
      cintegrationKommoTagId: "Вставте TagID",
      cintegrationKommoTagIdPlaceholder: "Оберіть тег для нового ліда (необов'язково)",
      cintegrationKommoError: "Помилка при збереженні інтеграції з Kommo. Перевірте правильність введених даних.",
      cintegrationKommoDeleted: "Інтеграція з Kommo видалена",
      cintegrationKommoDeletedError: "Помилка при видаленні інтеграції з Kommo",
      cintegrationKommoCreateNote: "Створювати примітку з відповідями",
      cintegrationKommoUseMapping: "Використовувати мапінг полів",
      mappingValue: "Поле в CRM",
      mappingValueMailchimp: "Поле в Mailchimp",
      mappingKey: "Поле в ліді",
      addMappingRow: "Додати зв'язок полів",
      DELETE: "Видалити",
      mappingAnswer: "Відповідь на питання",
      testIntegration: "Тест",
      testIntegrationLast10Leads: "Тест інтеграції (останні 10 лідів)",
      testIntegrationNeedRealLeadTooltip: "Тест доступний лише якщо у квізі є хоча б один реальний лід.",
      loading: "Завантаження...",
      sentAt: "Відправлено",
      phone: "Телефон",
      email: "Email",
      action: "Дія",
      send: "Відправити",
      sending: "Відправлення...",
      success: "Успіх",
      failed: "Невдача",
      error: "Помилка",
      displayCondition: "Умова відображення",
      selectDisplayCondition: "Виберіть умову відображення",
      seconds: "Секунди",
      button: "Кнопка",
      buttonContainerSelector: "Селектор контейнера кнопки",
      buttonContainerSelectorPlaceholder: ".quiz-buttons або #quiz-button-place",
      clickHere: "Натисніть тут",
      buttonClick: "Клік по кнопці",
      clickOnWidget: "Клік по віджету",
      exitIntent: "При виході зі сторінки",
      pageLoad: "Після завантаження сторінки",
      delay: "Через певний час",
      resultPageSectionTitle: "Результати за балами",
      resultPageSectionAccordion: "Сторінка результатів за балами",
      resultPageShowCondition: "Показувати умову",
      resultPageShowCollectedPoints: "Показувати набрані бали",
      resultPageShowMaxPoints: "Показувати максимальні бали",
      resultPageShowProgressBar: "Показувати прогрес-бар",
      resultPageSelectFormat: "Обрати формат результату",
      resultPageScenarios: "Сценарії",
      resultPageAddScenario: "Додати сценарій",
      resultPageScenarioPhoto: "Додати фото",
      resultPageScenarioTitle: "Заголовок",
      resultPageScenarioTitlePlaceholder: "Введіть заголовок сценарію",
      resultPageScenarioDescription: "Опис",
      resultPageScenarioDescriptionPlaceholder: "Введіть опис сценарію",
      resultPageScenarioUrlPlaceholder: "Посилання (https://)",
      resultPageScenarioButtonText: "Текст кнопки",
      resultPageScenarioButtonTextPlaceholder: "Введіть текст кнопки",
      resultPagePointsCondition: "Умова відображення за балами",
      resultPagePointsBetween: "Між",
      resultPagePointsMoreThan: "Більше ніж",
      resultPagePointsLessThan: "Менше ніж",
      resultPagePointsEqual: "Дорівнює",
      resultPageErrorAddNewScenario: "Не вдалося додати новий сценарій",
      resultPageErrorRangeExplanation: "Будь ласка, додайте більше балів або перерозподіліть їх між сценаріями",
      resultPageErrorFullRange: "Сценарії покривають усі діапазони балів",
      resultPageErrorOutOfRange: "Бали в сценаріях виходять за допустимий діапазон",
      resultPageErrorSaving: "Помилка збереження сценаріїв",
      resultPageErrorOverlap: "Бали в сценаріях не повинні перемежатись між собою",
      resultPageAutoRedirectWarningTitle: "Автоперенаправлення вимкнено",
      resultPageAutoRedirectWarningText: "Щоб увімкнути автоперенаправлення, додайте посилання в кожному сценарії результатів.",
      resultPageAutoRedirectWarningButton: "Зрозуміло",
      AddTags: "Додати теги",
      resultPageModalDescription: "Призначте бали за кожну відповідь",
      resultPageYourOptions: "Ваші варіанти",
      placeholderDefaultValue: "Значення",
      resultPageByPointsTitle: "Результати по балам",
      resultPageConditionSettingsButton: "Логіка по балам",
      resultPageConditionSettingsSaved: "Збережено",
      resultPageConditionSettingsUnsaved: "Зберегти",
      resultPagePlaceholderScenarioTitle: "Заголовок сценарію",
      resultPagePlaceholderScenarioDescription: "Тут ви можете вставити короткий опис результатів",
      resultPageLabelScenarioCti: "Заклик до дії",
      resultPagePlaceholderScenarioCti: "Текст в кнопці",
      resultPagePlaceholderScenarioUrl: "Посилання на кнопку",
      resultPagePlaceholderRedirectUrl: "Посилання для переадресації",
      resultPageScenarioSaveChanges: "Зберегти зміни",
      resultPageScenarioSaveChangesComplete: "Зміни збережено",
      resultPageConditionSettingsTitle: "Налаштування результатів за балами",
      resultPageConditionSettingsDescription: "Надайте діапазон балів для кожного сценарію",
      resultPageConditionResultsColumn: "Результати",
      resultPageConditionRangeSummary: "Максимальний діапазон балів:",
      addNewSectionSubHeaderChoise: "Введення/вибір відповіді",
      addNewSectionSubHeaderResults: "Результати",
      noTeamRole: "-",
      viewerTeamRole: "Переглядач",
      noAccessTeamRole: "Без дій",
      editorTeamRole: "Редактор",
      managerTeamRole: "Менеджер",
      adminTeamRole: "Адміністратор",
      teamRoleGuideTitle: "Що означають ролі",
      teamRoleGuideDescription: "Роль автоматично вмикає набір прав. Після вибору роль одразу оновлюється в інтерфейсі, а кнопка Send надсилає вибраний доступ.",
      teamRoleGuideFlowOwner: "Власник",
      teamRoleGuideFlowOwnerText: "надає доступ",
      teamRoleGuideFlowRole: "Роль",
      teamRoleGuideFlowRoleText: "обирає preset",
      teamRoleGuideFlowPermissions: "Права",
      teamRoleGuideFlowPermissionsText: "відкривають дії",
      teamRoleGuideFlowResult: "Доступний UI",
      teamRoleGuideFlowResultText: "показує кнопки",
      teamRoleGuideViewerDescription: "Може переглядати ліди та відповіді у вибраних квізах.",
      teamRoleGuideEditorDescription: "Може редагувати квіз, копіювати його та працювати з публікацією.",
      teamRoleGuideManagerDescription: "Може редагувати квіз, бачити CRM, керувати інтеграціями та ділитися доступом далі.",
      teamRoleGuideAdminDescription: "Отримує всі права: керування, інтеграції, CRM, доступи, передача, видалення та публікація.",
      canViewLeadsLabel: "Перегляд лідів",
      canViewLeadsDescription: "Може переглядати заявки, відповіді та контакти",
      canCopyQuizLabel: "Копіювання квіза",
      canCopyQuizDescription: "Може створювати копії вибраного квіза",
      canManageQuestionsLabel: "Редагування квіза",
      canManageQuestionsDescription: "Може редагувати квіз, сторінки, питання, варіанти, консультантів, переваги, контактні поля, соцмережі та options",
      canManageIntegrationsLabel: "Інтеграції",
      canManageIntegrationsDescription: "Може керувати інтеграціями, ключами та вебхуками",
      canManageSettingsLabel: "Налаштування",
      canManageSettingsDescription: "Може змінювати домени, сторінки та контактні поля",
      canShareLabel: "Доступи",
      canShareDescription: "Може запрошувати інших користувачів",
      canTransferLabel: "Передача квіза",
      canTransferDescription: "Може передати квіз іншому користувачу",
      canDeleteLabel: "Видалення",
      canDeleteDescription: "Може видаляти та відновлювати квіз",
      canPublishLabel: "Публікація",
      canPublishDescription: "Може керувати публікацією та доменами",
      descriptionTeamView: "Додайте учасників та налаштуйте доступи до проєктів і квізів",
      addedUserInTeam: "У команді",
      teamAccessGivenTab: "Учасники",
      teamAccessReceivedTab: "Джерело доступу",
      teamAccessReceivedTitle: "Джерело доступу",
      teamAccessSharedBy: "Власник",
      teamAccessInvitedBy: "Надав доступ",
      teamAccessRoleLabel: "Роль",
      teamAccessScopeLabel: "Доступ",
      teamNoReceivedAccess: "Поки ніхто не надав вам доступ",
      teamNoGivenAccess: "Ви поки нікому не надали доступ",
      teamAccessFrozen: "Доступ заморожено",
      teamFreezeAccess: "Заморозити доступ",
      teamUnfreezeAccess: "Розморозити доступ",
      teamPermissionDeniedTransfer: "Недостатньо прав для перенесення квізу",
      teamPermissionDeniedDelete: "Недостатньо прав для видалення або відновлення квізу",
      teamPermissionDeniedShare: "Недостатньо прав для керування доступом",
      teamPermissionDeniedManageQuiz: "Недостатньо прав для редагування квізу",
      teamPermissionDeniedCopy: "Недостатньо прав для копіювання квізу",
      teamPermissionDeniedIntegrations: "Недостатньо прав для керування інтеграціями",
      teamPermissionDeniedCrm: "Недостатньо прав для перегляду CRM",
      teamPermissionDeniedPublish: "Недостатньо прав для публікації квізу",
      teamPermissionDeniedSettings: "У вас немає прав для цього розділу налаштувань",
      teamPermissionDeniedOpenQuiz: "У вас немає доступних дій для цього квізу",
      teamAccessDeniedTitle: "Розділ недоступний",
      teamAccessDeniedDescription: "У вас немає прав для цієї дії. Зверніться до власника проєкту, щоб отримати доступ",
      teamPermissionDeniedDefault: "Недостатньо прав для цієї дії",
      teamQuizzesWithoutProject: "Квізи не в проєкті",
      quickInviteTitle: "Запросити учасника",
      quickInviteEmailLabel: "Email",
      quickInviteQuizzesLabel: "Квізи, до яких надати доступ",
      quickInviteLoadingQuizzes: "Завантаження квізів…",
      quickInviteLoadQuizzesError: "Не вдалося завантажити квізи.",
      quickInviteRetry: "Повторити",
      quickInviteNoQuizzes: "Немає квізів, якими ви можете поділитися.",
      quickInviteRoleHint: "Учасник отримає вибрану роль у вибраних квізах. Змінити її можна пізніше на {link}.",
      quickInviteRoleHintLink: "сторінці Команда",
      quickInviteSubmit: "Запросити",
      quickInviteSubmitting: "Надсилання…",
      quickInviteSelfError: "Не можна запросити самого себе",
      quickInviteSelectQuiz: "Виберіть хоча б один квіз",
      quickInviteSuccess: "Запрошення надіслано: {email}",
      projectNoQuizzes: "0 квізів",
      quizzes: "квізів",
      sharedQuizzes: "Пошарені квізи",
      sharedQuizzesWithoutProject: "Квізи не в проєкті",
    },
    EN: {
      tariffLockBadgeLabel: "Pro",
      tariffLockBadgeReadOnlyLabel: "Read-only",
      tariffLockBadgeQuotaLabel: "Limit reached",
      tariffLockBadgeAriaLabel: "{label}: feature restricted by your plan",
      tariffUpgradeActionLabel: "Upgrade plan",
      tariffLockBadgeOwnerAriaLabel: "{label}: feature restricted by the quiz owner's plan",
      tariffLockBadgeOwnerUnverifiedLabel: "Plan unverified",
      tariffLockBadgeOwnerUnverifiedAriaLabel: "{label}: the quiz owner's plan couldn't be verified",
      tariffOwnerPlanFeatureUnavailableMessage: "This feature isn't available on the quiz owner's plan. Ask the owner to upgrade to a plan that includes it.",
      tariffOwnerAccessUnavailableMessage: "We couldn't check the quiz owner's plan. Refresh the page.",
      tariffGateCollaborationForbiddenMessage: "You don't have permission to do this on this quiz.",
      tariffGateQuotaExhaustedMessage: "You've used up the limit included in your current plan. Upgrade to a plan that includes more.",
      tariffGateGrandfatheredMessage: "This feature is not available on your current plan. Existing data stays visible and can be deleted, but adding or editing is disabled. Upgrade to a plan that includes it.",
      tariffGateReadOnlyMessage: "This feature is not available on your current plan and is shown as read-only. Upgrade to a plan that includes it.",
      tariffGateUsageUnavailableMessage: "We couldn't determine usage for this feature. Try refreshing the page.",
      tariffGateLoadingMessage: "Checking your plan access…",
      tariffGateUnavailableMessage: "This feature is not available on your current plan. Upgrade to a plan that includes it.",
      tariffUpgradeModalDescription: "Choose a plan that includes this feature.",
      tariffUpgradeModalLoading: "Loading suitable plans…",
      tariffUpgradeModalError: "Couldn't load suitable plans. Please try again.",
      tariffUpgradeModalEmpty: "Annual subscriptions will be available soon.",
      tariffUpgradeModalRecommended: "Recommended",
      tariffUsageUnlimitedLabel: "Unlimited",
      tariffUsageUsedOfLimitLabel: "{used} of {limit} used",
      tariffUsageUnavailableLabel: "Usage unavailable",
      tariffUsageLoadingLabel: "Loading usage…",
      tariffUsageUnknownLabel: "Usage unknown",
      notFoundEyebrow: 'Page not found',
      notFoundTitle: 'Looks like this quiz got lost',
      notFoundDescription: 'The link may be incorrect, or the page has been moved. Go back to your workboard and keep building quizzes.',
      notFoundPrimaryAction: 'Go home',
      notFoundSecondaryAction: 'Go back',
      serverErrorEyebrow: 'Server error',
      serverErrorTitle: 'Something went wrong',
      serverErrorDescription: 'Don’t worry, we’re already working on it. Try refreshing the page or return to your workboard.',
      serverErrorPrimaryAction: 'Refresh page',
      serverErrorSecondaryAction: 'Go home',
      madeInUkr: "made in Ukraine",
      upProVersion: "Switch to PRO",
      getLeads: "Get Leads",
      poperBillings: "Billings",
      poperTemplates: "Templates",
      poperPartnership: "Partnership",
      poperProfile: "Profile",
      poperLogout: "Log Out",
      poperTeam: "Team",
      teamDelegatedAccessTitle: 'Shared access further',
      teamAccessTreeRootLabel: 'Access source',
      teamAccessVia: 'via',
      teamNoQuizNamesAvailable: 'Quiz names are unavailable',
      teamSharedShareTargetPrefix: 'Shared from',
      teamSharedOwnerFallback: 'owner',
      teamMembersTab: 'Access I gave',
      teamAccessSourceTab: 'Access given to me',
      teamAccessSourceTitle: 'Access given to me',
      teamAccessTreeTab: 'Access chains',
      teamAccessTreeTitle: 'Access chains',
      teamAccessTreeDescription: 'Shows the access path: owner → inviter → you → people you reshared with',
      teamAccessOwnerLabel: 'Owner',
      teamAccessInviterLabel: 'Shared by',
      teamAccessPath: 'Access path',
      teamAccessYouLabel: 'you',
      teamSharedByYou: 'Shared by you',
      teamCanReshare: 'Can reshare',
      teamCannotReshare: 'Cannot reshare',
      teamPartialReshare: 'Partially can reshare',
      teamMixedRoles: 'Mixed roles',
      teamNoAccessTree: 'Chains will appear when you reshare access',
      poperIdea: "Suggest an idea",
      poperIdeaTitle: "Have an idea to improve our platform?",
      poperIdeaText: "Share it with us! Your feedback helps us grow and create better experiences for you.",
      poperIdeaTextPlaceholder: "Provide details about your suggestion",
      poperIdeaSendButton: "Send your suggestion",
      defaultNewQuestion: "New Question",
      defaultNewQuestionDescription: "Here you can insert a short description of the question (up to 80 characters)",
      defaultNewVariant: "New Option",
      defaultBtnText: "Start",
      navBillings: "Billings",
      navPartnership: "Partnership",
      navProfile: "Profile",
      navTariffs: "Tariffs",
      holidayBannerTitleLastOffer: "Final offer of the year:",
      holidayBannerDefaultTitle: "Limited offer",
      holidayBannerFrom: "from",
      holidayBannerTo: "to",
      holidayBannerCta: "Recive discount",
      holidayBannerAuthTitle: "Sign in to get the discount",
      holidayBannerAuthText: "Log in to claim this offer and keep it tied to your account.",
      holidayBannerAuthAction: "Got it",
      holidayBannerClose: "Close banner",
      welcomeBack: "Welcome Back!",
      loginHeader: "Sign In",
      loginHeader2Part: "to Continue",
      loginEmailPlaceholder: "E-mail",
      loginPasswordlPlaceholder: "○ ○ ○ ○ ○ ○ ○ ○ ○",
      loginBtnValue: "Sign In",
      loginWith: "Login with",
      passwordAreForgetPassword: "Forgot your password?",
      passwordResetPasswordHeader: "Password reset",
      passwordResetPassword: "Reset password",
      passwordWeSentReset: "Follow the instructions in the email we send you to reset your password",
      passwordInputNewPassword: "Enter a new password",
      passwordConfirmPassword: "Confirm password",
      passwordCreatePassword: "Create password",
      passwordChangePassword: "Save password",
      passwordResetedPasswordCompleted: "Your password has been successfully changed!",
      passwordGoToWorkboard: "Go to Workboard",
      loginSignup: "Sign up",
      helloHeader: "Hello!",
      signupHeader: "Sign up",
      signupHeader2Part: "to Continue",
      signupNamePlaceholder: "Oleksander",
      signupPhonePlaceholder: "phone number",
      signupEmailPlaceholder: "E-mail",
      signupPasswordlPlaceholder: "○ ○ ○ ○ ○ ○ ○ ○ ○",
      signupBtnValue: "Create an account",
      signupWith: "Sign up with",
      signupLogin: "Login to an account",
      signupTariffHeader: "Tarif",
      signupTariffFree: "Free.",
      signupTariffPro: "Pro.",
      signupTariffFreeDescription: "Unlimited number of creation of new quizzes (web pages). Ability to generate up to 300 applications per month for free.",
      signupTariffProPrice: "$20/month",
      signupTariffProDescription: "Unlimited number of creation of new quizzes (web pages). Ability to generate ",
      signupTariffProDescriptionBold: "up to 300 applications per month.",
      userBackToQuiz: "Back to Workboard",
      userBackToSettings: "Back to Settings",
      learningCenterTitle: "Learning center",
      learningCenterTraining: "Training",
      learningCenterIntroText: "Watch all required video guides in order, confirm each lesson after it ends, and request your certificate after the final lesson is completed.",
      learningCenterVideoUnsupported: "Your browser does not support HTML5 video.",
      learningCenterAvailable: "Available",
      learningCenterLessonsComplete: "Lessons complete",
      learningCenterBackToLearningCenter: "Back to Learning center",
      learningCenterCertificate: "Certificate",
      learningCenterCourseCompleted: "Course completed",
      learningCenterCertificateSentText: "All lessons are complete. The certificate request has been sent to the backend.",
      learningCenterCertificateLabel: "Adsquiz Learning Center",
      learningCenterCertificateOfCompletion: "Certificate of completion",
      learningCenterDownloadCertificate: "Download certificate",
      learningCenterDownloadUnavailable: "Download unavailable yet",
      learningCenterOpenCertificate: "Open certificate",
      learningCenterAbout: "About",
      learningCenterOpenFallbackLink: "Open fallback link",
      learningCenterBack: "Back",
      learningCenterCompleted: "Completed",
      learningCenterWatchVideoToEnd: "Watch the video to the end",
      learningCenterSaving: "Saving...",
      learningCenterMarkAsCompleted: "Mark as completed",
      learningCenterWatchedPercent: "{percent}% watched",
      learningCenterDefaultUserName: "Adsquiz user",
      learningCenterCertificateReadyMessage: "The backend returned a certificate file. Use the button above to open it.",
      learningCenterCertificatePendingMessage: "The certificate request was submitted. Attach the backend download URL when it becomes available.",
      learningCenterCertificateNoUrlMessage: "Certificate request completed, but no file URL was returned yet.",
      learningCenterCertificateErrorMessage: "Certificate request could not be confirmed by the backend yet. Local completion is saved.",
      learningCenterSectionGeneral: "General",
      learningCenterSectionIterationsIntro: "Introduction to iterations",
      learningCenterSectionIterationIntro: "Introduction to iteration",
      billingYourTariff: "Your plan",
      billingYourTariffShortForm: "Your plan",
      billingYourPro: "Pro",
      billingYorFree: "Free",
      billingFreeLeads: "Free leads",
      billingInfinity: "unlimited",
      billingTariffRenewData: "Tariff renew date",
      billingTariffEndData: "End date of the plan",
      billingOtherTariffFree: "Free.",
      billingOtherTariffPro: "Pro.",
      billingTariffFreeDescription: "Unlimited number of creation of new quizzes (web pages). Ability to generate up to 300 applications per month for free.",
      billingYouHavePro: "If you're currently on the Pro version, why take a step back?",
      billingYouHasFreeLeads: "Free leads",
      billingYouHasLeads: "Leads left",
      billingTariffProDescription: "Unlimited number of new quizzes (web pages). Ability to generate ",
      billingTariffProDescriptionBold: "more than 300 applications.",
      billingYourFutureTariff: "Your future plan",
      billingBtnChangeToPro: "switch to ",
      billingBtnRenewPro: "Renew",
      billingBillings: "Billings",
      billingYouHaveNotBillings: "You have no payments yet",
      billingPaymentsMethod: "Payment method",
      billingPaymentCard: "Card",
      billingChangeData: "Change data",
      billingDeletePayMethod: "Delete",
      billingModalDeleteShure: "Are you sure you want to remove this payment method?",
      billingModalDeleteCancel: "Cancel",
      billingModalDeleteOk: "Delete",
      billingModalDeleteSuccess: "You have successfully deleted your card",
      billingModalRegularPaymentDeleteSuccess: "Regular payments are cancelled",
      billingModalRegularPaymentDeleteOk: "ОК",
      billingYourMonthPlan: "Your monthly tarif",
      billingLeads: "leads",
      billingChangePlan: "Change the tarif",
      billingChangePlanDescription: "The price will correspond to the desired number of applications from all quizzes in your account.",
      billingSelectPeriod: "Select period",
      billingChangePlanDescriptionImportant: "Important:",
      billingChangePlanDescriptionImportantMonth: "Leads can be used 1 month after purchase.",
      subscriptionTariffLable: "Subscribe for our automatic subscription.",
      billingChangePlanWarning: "",
      billingTariffMonth: "mon.",
      billingChangePlanPay: "Buy",
      profileName: "Name",
      profilePhone: "Phone number",
      profileEmail: "E-mail",
      profileStatus: "Status",
      profileStatusAgency: "Agency",
      profileStatusPlaceholder: "What described you better?",
      profileStatusFreelancer: "Freelancer",
      profileStatusBuisines: "Business owner",
      profilePassword: "Пароль",
      profileChangePassword: "Change password",
      profileNewPassword: "New password",
      profileSaveNewData: "Update data",
      workboardStartTooltip: "Here you can create your first quiz",
      workboardAddNewQuiz: "Create Project",
      workboardModalGiveQuizName: "Give a name to the quiz",
      workboardModalQuizNamePlaceholder: "New quiz",
      workboardModalNewQuizBtnValue: "add",
      workboardAlertGiveAnyName: "Enter any name",
      workboardAlertNextTimeAddQuiz: "Well, next time, dare)",
      workboardChangeQuizName: "Change the name",
      workboardQuizLink: "link",
      workboardQuizLinkCopied: "The link is copied to the clipboard",
      workboardEditQuiz: "Edit",
      workboardCopyQuiz: "Copy the quiz",
      workboardQuizCopied: "Quiz successfully copied",
      workboardDeleteQuiz: "Delete",
      workboardTransferQuizPlaceholderInput: "Enter the user's email address",
      workboardTextAllQuizes: "All Quizzes",
      workboardTextProjects: "Projects",
      workboardTransferQuiz: "Transfer quiz to another account",
      workboardTransferProject: "Add to project",
      workboardTransferQuizCancel: "Cancel",
      workboardTransferQuizLabel: "Quiz Title",
      workboardTransferQuizTitle: "Test your knowledge about environmental protection!",
      workboardTransferQuizHintTitle: "When transferring the quiz, all submissions will be moved with it.",
      workboardTransferQuizHintTitleSecond: "To transfer the quiz with submissions, one of the users must have any ",
      workboardTransferQuizHintTitleSecondLink: "https://app.adsquiz.io/tariffs",
      workboardTransferQuizHintTitleSecondLinkText: "paid plan.",
      workboardTransferQuizConfirm: "Transfer",
      workboardTransferQuizNoValidEmail: "Invalid email address",
      workboardTransferQuizStatus200: "Quiz has been successfully transferred to:",
      workboardTransferQuizStatus401: "Unauthorized — The user is not authenticated.'",
      workboardTransferQuizStatus403: "Forbidden — You do not have access to transfer this quiz.",
      workboardTransferQuizStatus404: "Not Found — Quiz or recipient user not found.",
      workboardTransferQuizStatus422: "Unprocessable Entity — At least one user must have a paid account.",
      workboardTransferQuizStatusError: "Unexpected error status",
      workboardModalRemoveQuizTrash: "This quiz will be moved to the trash and permanently deleted after 1 month.",
      workboardModalRemoveQuizSure: "Are you sure you want to move this quiz to the trash?",
      workboardModalRemoveProjectTrash: "The project and all its quizzes will be permanently deleted.",
      workboardModalRemoveProjectSure: "Are you sure you want to delete this project?",
      workboardModalDeleteQuizCancel: "Cancel",
      workboardModalDeleteQuizDelete: "Delete",
      workboardModalDeleteQuizSuccess: "You have successfully deleted this quiz",
      workboardModalDeleteProjectSuccess: "The project has been successfully deleted",
      workboardModalQuizDeleteOk: "ОК",
      workboardStatsTitle: "Statistics",
      workboardModalLeadsAnswersCount: "Answers to questions",
      workboardModalLeadsLeadSerial: "№",
      workboardModalLeadsLeadDate: "Date",
      workboardModalLeadsLeadEmail: "Email",
      workboardModalLeadsLeadName: "Name",
      workboardModalLeadsLeadPhone: "Phone",
      workboardModalLeadsLeadPoints: "Points",
      workboardModalLeadsLeadActions: "Actions",
      workboardModalLeadsLeadShowMore: "See more",
      workboardModalLeadsLeadHideMore: "Hide",
      workboardModalLeadsLeadAnswerScipped: "Skipped",
      workboardModalNoLeads: "Пока лидов нет",
      constructorLink: "link",
      constructorLinkCopied: "Copied to clipboard:",
      constructorNavSteps: "Steps",
      constructorNavDesign: "Design",
      constructorNavSettings: "Settings",
      constructorStep: "Step",
      cancel: "Cancel",
      constructorCancel: "Cancel",
      constructorSave: "Save",
      constructorextraNavStart: "S",
      constructorextraNavContact: "C",
      constructorextraNavFinish: "F",
      cstepsSection: "Sections",
      cstepsStartPage: "Start page",
      cstepsContactPage: "Contact form",
      cstepsFinishPage: "Final page",
      cstepsEdit: "Edit",
      cstepsMove: "Move",
      cstepsDeleteStep: "Delete step",
      cstepsAddSection: "Add section",
      cdesignColorTheme: "Color Theme",
      cdesignCustomTheme: "Custom Color Theme",
      cdesignDefaultThemes: "Our Color Themes",
      cdesignThemeStandart: "Default",
      cdesignThemeDark: "Dark",
      cdesignThemeNud: "Nude",
      cdesignThemeGradient: "Gradient",
      cdesignShapeDesign: "Design form",
      cdesignShapeRound: "Rounded",
      cdesignShapeSquare: "Angular",
      cdesignShapeRectangle: "Rectangle",
      cdesignShapeCircle: "Circle",
      cdesignPositionLeft: "Left",
      cdesignPositionMiddle: "Middle",
      cdesignPositionRight: "Right",
      cdesignPositionTop: "Top",
      cdesignPositionBottom: "Bottom",
      csettingsIntegration: "Integration",
      csettingsOweDomain: "Connecting own domain",
      csettingsDocs: "Legal documents",
      cintegrationIntegration: "Integration",
      cintegrationShareLeads: "Share Leads",
      cintegrationTitleEmail: "E-MAIL",
      cintegrationInstruction: "Instruction",
      cintegrationInstructionDetail: "Details",
      cintegrationEmailInstruction: "Trigger an email to your respondent and notify your team. Collaborate with your team.",
      cintegrationPublishAfterEdit: "Save the quiz after editing",
      cintegrationSendNewLeadsTo: "Send messages about new leads to:",
      cintegrationInputEmail: "Input Email",
      cintegrationAddEmail: "Add Email",
      cintegrationEmailSaved: "Email Saved",
      cintegrationEmailDeleted: "Email Deleted",
      cintegrationTitleFB: "FB pixel",
      cintegrationIDPixel: "Pixel ID",
      cintegrationFBInstruction1: "Go to the Facebook Ads advertising cabinet and copy the Facebook Pixel ID in the Event Manager section.",
      cintegrationFBInstruction2: "Don't copy the whole code, just the 15-16 digit ID.",
      cintegrationFBInstruction3: "Copy and paste into the box below.",
      cintegrationFBInstruction: 'The event for which you need to configure the conversion is "Lead". This event will be called as soon as the user submits an application in the quiz.',
      cintegrationFBInstructionTextTitle: "List of all events we send:",
      cintegrationFBInstructionTextTextStart: " – visit to the start page;",
      cintegrationFBInstructionTextQuestionN: " – visit to step N;",
      cintegrationFBInstructionTextOpenContactPage: " – visit to the contact page;",
      cintegrationFBInstructionTextLead: " – successful submission of the contact form;",
      cintegrationFBInstructionTextThankYou: " – visit to the final page.",
      bold_adsquiz_Start: "adsquiz_Start",
      bold_adsquiz_QuestionN: "Question_N",
      bold_adsquiz_OpenContactPage: "Open_Contact-Page",
      bold_adsquiz_Lead: "Lead",
      bold_adsquiz_ThankYou: "adsquiz_ThankYou",
      cintegrationInputIDPixel: "Input Pixel ID",
      cintegrationDataFBSaved: "Pixel FB data saved",
      cintegrationAccesToken: "ACCES TOKEN",
      cintegrationTitleGA: "Google analytics",
      cintegrationGAInstructionDescription: "Learn how people are finding and interacting with your quiz. Get the data you need to analyze campaigns, improve conversions, and more.",
      cintegrationGAInstruction: 'When a quiz application is received in Google Analytics, the "generate_lead" event will be triggered.',
      cintegrationIDFolow: "Tracking ID",
      cintegrationInputID: "Input ID",
      cintegrationDataGASaved: "Google analytics data saved",
      cintegrationTitleGTM: "Google Tag Manager",
      cintegrationGTMInstructionDescription: "Description for Google Tag Manager.",
      cintegrationGTMInstruction: "Copy the Google Tag Manager id and paste it into the field below.",
      cintegrationDataGTMSaved: "Google Tag Manager data saved",
      cintegrationTitleTG: "Telegram",
      cintegrationHowReciveTGLeadBot: "How to get leads in Telegram?",
      cintegrationTGInstructionBot1: "1. Copy the token in the input below.",
      cintegrationTGInstructionBot2: '2. Follow the link to the bot, click the "START" button.',
      cintegrationTGInstructionBot3: "3. Send the copied token as a message to our bot.",
      cintegrationHowReciveTGLeadChat: "How to get applications in Telegram chat?",
      cintegrationTGInstructionChat1: "1. Add our bot to the desired chat and set the bot to administrator status.",
      cintegrationTGInstructionChat2: "2. Copy the token in the field below and send it to the desired chat.",
      cintegrationTGInstructionChat3: "3. Wait for the answer `OK! Your quiz token was saved!”",
      cintegrationTGInstructionChat4: "4. Leads will now be sent to this chat.",
      cintegrationTGInstructionWarning: "Importantly:",
      cintegrationTGInstructionWarningText: "Please note that this should be a group, not a Telegram channel. Leads will not be sent to the Telegram channel.",
      cintegrationTGBotLink: "chatbot link",
      cintegrationTGTitleToken: "TOKEN",
      cintegrationInputTGToken: "Enter Telegram chatbot token",
      cintegrationAddIntegration: "Add integration",
      cintegrationDataTGSaved: "Telegram integration data saved",
      cintegrationTitleTT: "TT pixel",
      cintegrationTTInstruction: "To track events in your Tik-Tok ad account, copy the pixel ID and paste it into the box below. ",
      cintegrationDataTTSaved: "Pixel TT data saved",
      cintegrationTitleWH: "WebHook",
      cintegrationWHInstruction1: "You can notify third-party applications about incoming leads. To do this, specify the URL to which the WebHook will be sent.",
      cintegrationWHInstruction2: "We have prepared",
      cintegrationWHInstruction3: "video instruction",
      cintegrationWHInstruction4: "with a detailed description of this functionality.",
      cintegrationWHInstruction5: "View video.",
      cintegrationWHInstruction6: "In this video, we will look at passing a hook based on sending data to a Google spreadsheet and sending data to a Trello CRM system.",
      cintegrationWHInstruction7: "We recommend using the service for this purpose.",
      cintegrationWHInstruction8: "When registering using this link, for our users, there is a bonus - 10,000 free actions for any integrations.",
      cintegrationWHInstruction9: "Link",
      cintegrationWHInstruction10: "to register with a bonus.",
      cintegrationWHUrl: "The webhook URL's",
      cintegrationInputWHUrl: "Input the webhook URL",
      cintegrationAddWH: "Add a Web-hook",
      cintegrationWebHookDataSaved: "WebHook data saved",


      cintegrationComonWHInstructionShort: "You can notify third-party applications about incoming leads. Specify the webhook URL for data transmission.",
      cintegrationComonWHInstruction1Title: "1. Insert the webhook URL into the input field:",
      cintegrationComonWHInstruction1Description: "Paste the webhook URL provided by your service or application into the input field.",
      cintegrationComonWHInstruction2Title: "2. Save changes:",
      cintegrationComonWHInstruction2Description: 'Click the "Save Changes" button to save the webhook settings.',
      cintegrationComonWHInstruction3Title: "3. Done:",
      cintegrationComonWHInstruction3Description: "Now your webhook is configured to send data to the service you have selected.",
      cintegrationComonWHInstructionAdditional: "Data will be sent to the webhook with each lead received. POST method is used for transmission. An example of the data that will be sent is located ",
      cintegrationComonWHInstructionAdditionalLink: "here",
      cintegrationComonWHInstructionVideo: "Detailed video instruction",
      
      cintegrationApixDriveWHInstructionShort: "You can notify ApixDrive about incoming leads. To do this, specify the URL to which the WebHook will be sent.",
      cintegrationApixDriveWHInstructionShort1: "Upon registration through ",
      cintegrationApixDriveWHInstructionShort2: "this link",
      cintegrationApixDriveWHInstructionShort3: " our users receive a bonus - 10,000 free actions for any integrations.",
      cintegrationApixDriveWHInstruction1Title: "1. Register or open your ApixDrive account:",
      cintegrationApixDriveWHInstruction1Description1: "Link ",
      cintegrationApixDriveWHInstruction1Description2: "for registration with a bonus.",
      cintegrationApixDriveWHInstruction2Title: "2. Get the URL address for the webhook:",
      cintegrationApixDriveWHInstruction2Description1: "Go to the settings of the necessary connection and copy the address for sending the webhook:",
      cintegrationApixDriveWHInstruction2Description2: 'You can create a new connection by clicking the "Create Connection" button and at the system selection step, choose "ADSQuiz".',
      cintegrationApixDriveWHInstruction3Title: "3. Insert the webhook URL:",
      cintegrationApixDriveWHInstruction3Description: "Paste the webhook URL provided by ApixDrive into the input field.",
      cintegrationApixDriveWHInstruction4Title: "4. Save changes:",
      cintegrationApixDriveWHInstruction4Description: 'Click the "Save Changes" button to save the webhook settings.',
      cintegrationApixDriveWHInstruction5Title: "5. Done:",
      cintegrationApixDriveWHInstruction5Description: "Now your webhook is configured to send data to ApixDrive.",
      cintegrationApixDriveWHInstructionAdditional: "Data will be sent to the webhook with each lead received. POST method is used for transmission. An example of the data that will be sent is located ",
      cintegrationApixDriveWHInstructionAdditionalLink: "here",
      cintegrationApixDriveWHInstructionVideo: "Detailed video instruction",
      



      cintegrationConnectOweDomain: "Connecting your own domain",
      cintegrationOweDomainInstruction1: "1. To place your quiz on the required domain, log into your hosting account. Go to DNS settings and create an A record with the IP parameter: 185.25.117.21",
      cintegrationOweDomainInstruction2: "2. Input your domain above and save the quiz.",
      cintegrationDomain: "Domain",
      cintegrationInputYourDomain: "Input your domain",
      cintegrationCheckDomenIsCorrect: "Check that the entered domain is correct",
      cintegrationDomainWhichCorrect: "Enter a domain without protocols. For example: some.site.com",
      cintegrationInsertedDefaultDomain: "The domain is set by default",
      cintegrationDomainDataSaved: "Domain data saved",
      cintegrationPrivacyPolicy: "Privacy policy",
      cintegrationPrivacyPolicyByDefault: "By default, we use our standard privacy policy.  We recommend adding your privacy policy that is relevant to your business.",
      cintegrationPrivacyPolicyAdventage: "This will make it clear to your potential customers how you use the received contact information.  This is also required by some advertising platforms.",
      cintegrationPrivacyPolicyUrl: "Link to documents",
      cintegrationPrivacyPolicyInputYourDocsLink: "Insert link to documents",
      cintegrationDocsDataSaved: "Link to your documents saved",
      allstepsUpploadPhoto: "Upload a image",
      unsplashSelectorButtonText: "Choose from Unsplash",
      unsplashSelectorTitle: "Upload image",
      unsplashSelectorDragImage: "Drag an image here or",
      unsplashSelectorUploadFile: "upload a file",
      unsplashSelectorSearchPlaceholder: "Search image on Unsplash",
      unsplashSelectorLoadingImages: "Loading images...",
      unsplashSelectorLoadingMoreImages: "Loading more images...",
      unsplashSelectorNoImagesFound: "No images found",
      unsplashSelectorUnavailable: "Unsplash is currently unavailable. You can upload a file.",
      unsplashSelectorClose: "Close",
      allstepsChangePhoto: "Change the image",
      allstepsDeletePhoto: "Delete image",
      allstepsTitle: "Title",
      allstepsDescription: "Description",
      allstepsButtonText: "Button text",
      allstepsOtherSettings: "Other settings",
      allstepsIsSaveBeforeRoute: "Save data before changing route?",
      cfirstFormat: "Format",
      cfirstHeaderStartText: "Your headline should be here. Motivate users to complete the quiz to the end",
      cfirstAddMediafile: "Add media (image)",
      cfirstBonus: "Bonus",
      cfirstAddBonus: "Add bonus",
      cfirstStartPageDataUpdated: "The start page data has been updated",
      csanyAnswerType: "Question type",
      csanyATCard: "card",
      csanyATList: "list",
      csanyATCustom: "free field",
      csanyQuestion: "Question",
      csanyAnswers: "Answers",
      csanyAddAnswer: "Add option",
      csanyTitleForModalConfirm: "This action is irreversible!",
      csanyQuestionForModalConfirm: "Are you sure you want to delete this question?",
      csanyRequiredStep: "Required step",
      csanyAlowMultiple: "Allow multiple answers",
      csanyAutoRedirect: "Auto next question",
      csanyQuestionLogic: "Question logic setup",
      csanyDataStepUpdated: "Data Step Updated",
      cformForm: "Form",
      cformValueName: "Name",
      cformValueSurname: "Surname",
      cformValuePhone: "Phone number",
      cformValueEmail: "E-mail",
      cformDataContactsPageUpdated: "Data Contacts Page Updated",
      cformRequiredInput: "Mandatory",
      cfinishFinishPageTitle: "Finish Page",
      cfinishText: "Text",
      cfinishDescription: "Description",
      cfinishAddImage: "Add an image",
      cfinishImageAdded: "Image Added",
      cfinishURL: "URL",
      cfinishButtonText: "Button Text",
      cfinishInsertNikname: "Insert Nikname",
      cfinishCheckDataIsCorrect: "Check that the entered id is correct",
      cfinishFbWhichCorrect: "Enter a id without oter adress. For example: some.name",
      cfinishIgWhichCorrect: "Enter a id without oter adress. For example: some.name",
      cfinishTgWhichCorrect: "Enter a id without oter adress. For example: some.name",
      cfinishFinishPageDataUpdated: "The finish page data has been updated",
      adminUsersReg: "Users in the system",
      adminNewUsers: "New users per month",
      adminProAccounts: "PRO accounts",
      adminLTV: "LTV",
      adminSharePro: "PRO relative to all",
      adminReciveLeads: "Leads received",
      adminLeadsForOne: "Leads Per user",
      adminMadeQuiz: "Made Quizzes",
      adminQuizForOne: "Quiz Per user",
      adminAvarageUsed: "Average usage months",
      adminProfitMonth: "Profit Month",
      adminProfitAlltime: "Earned for all time",
      adminUsersList: "User base",
      notificationErrorLogin: "Authorization error:",
      notificationLogin: "Login...",
      notificationWrongLoginData: "Incorrect login details",
      notificationLoginAccountBlocked: "Your account has been blocked",
      notificationCanContactSupport: "You can contact support",
      notificationEmailExistsMessage: "An account with this email is already registered",
      notificationNetworkError: "Check your internet connection",
      notificationInputLoginData: "Input login data",
      notificationCheckInputEmail: "Verify that your email address is correct",
      notificationCheckInputEmailOrUserNotFound: "Check that the email is correct. User not found",
      notificationCheckInputPhone: "Check that the phone number is correct",
      notificationInputAllInputs: "Fill in all fields for registration",
      notificationAgreePrivacyPolicy: "Agree to the privacy policy",
      adminEditorForPartnership: "Affiliate program editor",
      developmentPage: "Section is under development",
      signupAgreeIAgreeWith: "I have read and agree to",
      signupAgreePolicy: "the privacy policy",
      signupAgreeAnd: "and",
      signupAgreeOffer: "terms of use",
      signupAgreeService: "of the service",
      workboardModalLeadsLeadReferrer: "Unclear",
      workboardEditTitle: "Edit title",
      workboardEditIcon: "Edit icon",
      workboardSaveChange: "Save change",
      workboardModalLeadsLeadReferrerClarification: "Referrer data blocked by source or undefined",
      workboardModalLeadsLeadEmailCopied: "Email copied to clipboard",
      workboardModalLeadsLeadPhoneCopied: "Phone copied to clipboard",
      workboardModalLeadsHaveNotSended: "You have the not-sended leads",
      workboardModalLeadsLeadReload: "Recive",
      workboardModalLeadsLeadReloadedTitle: "Request recived",
      workboardModalLeadsLeadReloaded: "",
      cfirstStartPagePhotoUpdated: "The start page photo has been updated",
      allstepsPhotoTooBig: "File is too big!",
      allstepsPhotoMustBeLess: "Must be less than",
      cfirstStartPageBonusPhotoUpdated: "The bonus photo has been updated",
      cstepsQuestionsOrderSaved: "Question order saved",
      csanyAnswerOrderSaved: "Answer order saved",
      allstepsPhotoAdaptation: "Photo adaptation for devices",
      allstepsPhotoFit: "Aspect ratio",
      constructorYouHideStep: "You are hidden this step",
      cstepsHiddenStep: "Hide Step",
      cstepNo_animation: "No animation",
      cstepAnimation: "Animation",
      cstepKick_animation: "Kick",
      cstepFlip_animation: "Flip",
      cstepBlur_animation: "Blur",
      cstepsShowStep: "Show Step",
      cfinishFinishPageHiddenUpdated: "Фінішна сторінка прихована.",
      cfinishFinishPageHiddenUpdatedGoContact: "Перейдіть на сторінку Форми контактів",
      cfinishFinishPageHiddenUpdatedSetRedirect: "та налаштуйте редирект після відправки даних",
      cformActionAfterContactRecive: "Follow-up on Contact Information",
      cformActionAfterContactThankyou: "Thank you Page",
      cformActionAfterContactRedirect: "Redirect",
      cformAdditionalSettings: "Additional settings",
      cformRedirectURL: "URL",
      cintegrationOweDomainInstructionImportant: "Important: The address in your hosting account and the field above must match. The time of applying changes to DNS settings and extracting the SSL certificate is up to 3 hours after saving.",
      cintegrationOweDomainInstructionVideo: "Watch video instruction",
      workboardModalLeadsLeadLimit: "Your lead limit has been reached.",
      workboardModalLeadsLeadLimitInstruction1: "To see new leads,",
      workboardModalLeadsLeadLimitInstruction2: "switch to a another tariff",
      workboardModalLeadsLeadLimitInstruction3: "renew the current tariff",
      workboardModalLeadsLeadLimitInstruction4: '(does not apply to "Free") or wait for the tariff to be updated if you have an auto-renewal of the tariff connected',
      workboardModalLeadsLeadLimitNewText: "You have unreceived leads that are inaccessible due to your current package limit. To access these leads, please purchase or upgrade your package.",
      billingBonusesTitle: 'Promo code',
      billingBonusesDescription: 'Enter the promo code you received in the next field',
      billingBonusesPlaceholder: 'Promo code',
      billingBonusesBtn: 'Activate',
      billingBonusesActivated: 'Promo code activated!',
      billingBonusesLeadIncreased: 'The number of available leads has been increased.',
      billingBonusesInvalid: 'Wrong promo code',
      billingBonusesNotAvailable: 'Promo code is no longer available',
      billingBonusesAlreadyActivated: 'This coupon is invalid',
      createQuizSPDescription: "There is place for the short description",
      createQuizCPTitle: "How can we contact with you?",
      createQuizCPDescription: "Please fill the form below",
      createQuizCPButton: "Done!",
      createQuizFPTitle: "Thank you!",
      createQuizFPDescription: "Now we looking for a best solution for you!",
      createQuizFPButton: "Show me something!",
      selectInternationalPrefix: "Select international prefix",
      autoInternationalPrefix: "Determine the country automatically",
      dovnloadCsvTitle: "Export data for the selected period",
      dovnloadCsvSelectAllPeriod: "Choose for the entire period",
      dovnloadCsvCancel: "Cancel",
      dovnloadCsvExport: "Export",
      domainEmpty: "Please enter a domain",
      domainInvalid: "Enter a valid domain, for example: example.com",
      domainAlreadyExists: "This domain is already in the list",
      domainAdded: "Domain added successfully",
      domainAdd: "Add domain",
      domainAddFailed: "Could not add domain",
      domainRemoved: "Domain removed successfully",
      domainRemoveFailed: "Could not remove domain",
      
      
      
      
      widgetEmbedVidgetToSite: "Embed quiz to the own website",
      widgetEmbedVidgetSelectEmbedVariant: "Select embed variant",
      EmbedQuizCardLabelStandard: "Standard",
      EmbedSettingsPreviewPopupHint: "Click the button to see your popup in action",
      EmbedQuizCardLabelPopup: "Popup",
      EmbedQuizCardLabelChatButton: "Chat Button",
      EmbedQuizCardLabelFullscreen: "Fullscreen",
      EmbedQuizCardLabelFeedback: "Feedback",
      EmbedQuizCardLabelSidebar: "Sidebar",
      EmbedStandardSettingsTitle: "Set dimensions (optional)",
      tipStandardEmbedQuizStepHead:
          "1. Copy the code for <head> and paste it before the closing </head> tag.",
      tipStandardEmbedQuizStepBody:
          "2. Copy the second code and paste the div <div id=\"adsquiz_embed_standard_ .... exactly in the place on the page where the quiz should appear.",
      tipStandardEmbedQuizParent:
          "3. The quiz size depends on the dimensions of the parent block. If the parent element has no height set, the quiz will automatically be displayed in a responsive format.",
      tipStandardEmbedQuizPercent:
          "4. Width and height in % work relative to the size of the parent block.",
      EmbedStandardSettingsTooltip: `
        Width & Height — control the quiz size (px, %, auto).

        Auto — the quiz is responsive, height is calculated automatically.
  
        Fullscreen — the quiz takes 100% width with a 16:9 ratio. Width and height are ignored.
  
        Height:
        • auto / 0 → 16:9 ratio
        • value → fixed height
  
        Width:
        • auto / 0 → 100% width
        • value → within container
  
        Radius — controls corner rounding.
  
        Padding — adds inner spacing inside the container.
  
        Desktop / Mobile device — controls where the quiz is shown.
        If disabled — the quiz will not be displayed on that device.
       `,
      EmbedFeedbackSettingsTooltip: `
       Window size sets a base preset:
  • S → 360 × 520
  • M → 480 × 640
  • L → 640 × 760
  • XL → 780 × 860
  
  Window shape:
  • angular → sharp corners
  • rounded → rounded corners
  
  Width:
  • auto / 0 / empty → preset is used
  • value → overrides preset
  
  Height:
  • auto / 0 / empty → preset is used
  • value → overrides preset
  
  Button size defines the trigger button preset.
  
  Button shape:
  • angular → sharp corners
  • rounded → rounded corners
  
  Button position:
  • left → left
  • right → right
  • top → top
  • bottom → bottom
  
  Button text — changes the text.
  
  Icon — select button icon.
  
  Button color — button background.
  
  Text color — text color.
  
  Icon color — icon color.
  
  Prevent closing before completing the quiz — if enabled, the user cannot close the window until the quiz is completed.
  
  Stop showing after completion — after finishing the quiz, the button and window will no longer appear again.
  
  Desktop / Mobile — where the widget is displayed.
  `,
      EmbedPopupSettingsTooltip: `
      Width and Height define the popup window size.

      Window size sets the default popup size preset:
      • S → 360 × 520
      • M → 480 × 640
      • L → 640 × 760
      • XL → 780 × 860

      Width and Height can override the selected Window size preset.

      Width:
      • auto / 0 / empty → width from Window size is used
      • value → custom width overrides the preset

      Height:
      • auto / 0 / empty → height from Window size is used
      • value → custom height overrides the preset

      Display condition determines when the popup opens:
      • Button click — opens by button click
      • On page exit — opens when user leaves the page
      • After page load — opens right after loading
      • After a delay — opens after selected seconds

      Seconds appears only for “After a delay”.

      Button text, Button size, button shape, button position, Auto color (template), Button color and Text color work only for “Button click”.

      Button size sets the popup button size preset.

      Auto color (template):
      • if enabled — template colors are applied automatically
      • if manual colors are enabled — Auto color is turned off

     Prevent closing before completing the quiz — if enabled, the user cannot close the window until the quiz is completed.
  
      Stop showing after completion — after finishing the quiz, the button and window will no longer appear again.
      
      Close popup on completion — allows the user to close the popup after quiz completion.

      Desktop / Mobile device — controls where the popup is shown.
      If disabled — the popup will not be displayed on that device.
      `,
      EmbedChatButtonSettingsTooltip: `
      Width and Height define the chat window size.

      Window size sets the default chat window size preset:
      • S → 360 × 520
      • M → 480 × 640
      • L → 640 × 760
      • XL → 780 × 860

      Width and Height can override the selected Window size preset.

      Width:
      • auto / 0 / empty → width from Window size is used
      • value → custom width overrides the preset

      Height:
      • auto / 0 / empty → height from Window size is used
      • value → custom height overrides the preset

      Window shape defines whether the chat window has sharp or rounded corners.

      Button size sets the size preset of the chat trigger button.

      Button shape defines the button style:
      • rectangle
      • circle

      Button position defines where the trigger button is placed:
      • left
      • right

      Icons let you choose the icon for the chat button.

      Button color sets the background color of the button.

      Icon color sets the color of the icon inside the button.

      Prevent closing before completing the quiz — if enabled, the user cannot close the window until the quiz is completed.
  
       Stop showing after completion — after finishing the quiz, the button and window will no longer appear again.

      Desktop / Mobile device — controls where the chat button and chat window are shown.
      If disabled — the chat button will not be displayed on that device.
      `,
      EmbedSidebarSettingsTooltip: `
      Width and height define the size of the sidebar.
      
      Window size sets a base preset:
      • S → 360 × 520
      • M → 480 × 640
      • L → 640 × 760
      • XL → 780 × 860
      
      Panel position:
      • left → left side
      • right → right side
      
      Width:
      • auto / 0 / empty → preset value is used
      • value → overrides preset
      
      Height:
      • auto / 0 / empty → preset value is used
      • value → overrides preset
      
      Display condition defines when the sidebar opens:
      • Button click — opens on click
      • Exit intent — opens when the user is about to leave the page
      • On page load — opens immediately after loading
      • Delay — opens after selected seconds
      
      Seconds field appears only for “Delay”.
      
      Button text, Button size, button shape, button position, Button color and Text color work only for “Button click”.
      
      Button size defines the trigger button preset.
      
      Button shape:
      • angular → sharp corners
      • rounded → rounded corners
      
      Button position:
      • left → left
      • middle → center
      • right → right
      
      Button color — background of the trigger button.
      
      Text color — button text color.
      
      Prevent closing before completing the quiz — if enabled, the user cannot close the panel until the quiz is completed.
      
      Stop showing after completion — after finishing the quiz, the button and panel will no longer appear again.
      
      On desktop / On mobile — defines where the sidebar is displayed.
      If disabled — it will not be shown on that device.
      `,
      EmbedModalStandardInstruction: `
      Copy the code from the Head block and paste it before the closing </head> tag on your website.
      
      Copy the code from the Body block and paste it where the quiz should appear on the page.
      
      How it works:
      • The quiz will be embedded directly into the page
      • It adapts to the width of its container
      
      What to pay attention to:
      • If the quiz looks too narrow or too wide — check the container where you placed it
      • If the height looks incorrect — try setting a fixed height in settings
      • In responsive mode — height adjusts automatically based on width
      • Make sure there are no CSS restrictions like overflow:hidden
      
      After installation:
      1. Save changes
      2. Refresh the page
      3. Check how the quiz looks on desktop and mobile
      `,
      EmbedModalPopupInstruction: `
      Copy the code from the Head block and paste it before the closing </head> tag on your website.
      
      Copy the code from the Body block and paste it before the closing </body> tag or anywhere on the page.
      
      How it works:
      • The quiz opens as a popup window
      • It can open automatically or by user action depending on settings
      
      What to pay attention to:
      • If button mode is selected — the button will appear where you insert the code
      • If automatic mode is selected — the popup will open on its own (on load, delay or exit)
      • If the popup does not appear — check if it is enabled for the current device
      • If the popup size looks wrong — adjust it in settings
      
      After installation:
      1. Save changes
      2. Refresh the page
      3. Check how the popup opens
      4. Test on desktop and mobile
      `,
      EmbedSettingsWindowSize: "Window size",
      EmbedPreviewFallbackTitle: "Preview is taking longer than expected",
      EmbedPreviewFallbackDescription: "The quiz preview could not be displayed yet. Try reopening the preview or reloading the frame.",
      EmbedPreviewFallbackReasonsTitle: "Possible reasons:",
      EmbedPreviewFallbackReasonDomain: "The selected domain may be unavailable or entered incorrectly.",
      EmbedPreviewFallbackReasonDomainSettings: "Please check your domain settings and make sure the domain is connected correctly.",
      EmbedPreviewFallbackReasonSlow: "The quiz page may still be loading or responding slowly.",
      EmbedPreviewFallbackReasonBlocked: "The preview may be blocked by your browser or network environment.",
      EmbedPreviewFallbackReload: "Reload preview",
      EmbedSizePresetDisabledHint: "Preset size is unavailable while custom width or height is set.",
      EmbedPopupSettingsTitleButton: "Button size",
      EmbedStandardSettingsHeightLabel: "Height",
      EmbedStandardSettingsWidthLabel: "Width",
      EmbedStandardSettingsRadiusLabel: "Radius",
      EmbedStandardSettingsPaddingLabel: "Padding",
      EmbedStandardSettingsFullscreenToggle: "Fullscreen",
      EmbedStandardSettingsDesktopToggle: "Desktop",
      EmbedPopupSettingsTextColorToggle: "Text color",
      EmbedPopupSettingsButtonColorToggle: "Button color",
      EmbedSettingsIconColor: "Icon color",
      EmbedPopupSettingsAutoColorToggle: "Auto color (template)",
      EmbedPopupSettingsCloseOnCompletionToggle: "Prevent closing before completing the quiz",
      EmbedSettingsStopShowing: "Stop showing once completed",
      EmbedStandardSettingsMobileToggle: "Mobile device",
      EmbedSettingsAutoOpenToggle: "Auto open",
      EmbedSettingsPreviewDelayHint: "The popup will appear after ",
      EmbedSettingsPreviewOpenAgain: "Open popup preview",
      EmbedReOpenSettingsMobileToggle: "Open preview",
      widgetEmbedVidgetSitecode: "In the site code",
      widgetEmbedVidgetPopup: "Pop-up",
      widgetEmbedVidgetChat: "Quiz-button",
      widgetEmbedVidgetInProgres: "Under development",
      widgetEmbedVidgetToSiteCode: "Embed quiz to the website",
      widgetSiteCodeInstruction0: "To embed the quiz on your site, add the code from the first field to the `<head>` tag on your site or in Google Tag Manager if it is integrated into your site. If after you have already embeded the quiz on your site you change the domain of the quiz you will need to update the integration code on your site.",
      widgetSiteCodeInstruction1: "In the place where you want to integrate the quiz, insert the code from the second field.",
      widgetSiteCodeInstruction2: "The quiz can be integrated into a container of any size, even into sidebars! The maximum size of the quiz, as well as when taking it on a separate domain, is 900x552 pixels. It can be added to larger containers, in which case the quiz will be centered.",
      widgetSiteCodeInstruction3: "Do not be shy - experiment!",
      widgetSiteCodeCopyToHead: "Copy and paste into the `<head>` of your site",
      widgetSiteCodeCopyToBody: "Paste the code where the quiz should be",
      workboardModalAddQuizHeader: "Create new Quiz",
      workboardModalGiveQuizNameAndMethod: "Come up with a name for your quiz and choose the way you want to create it",
      workboardModalNewQuizFromStart: "Create from blank",
      workboardModalNewQuizFromTemplates: "Ready templates",
      QuizTemplatesSearchInput: "Name of the template and/or categories",
      QuizTemplatesSearchBtn: "Search",
      QuizTemplatesReadyTemplates: "Ready templates",
      QuizTemplateView: "View",
      QuizTemplateSelect: "Choose",
      widgetPopupInstruction0: "To install a quiz on your site, add the code from the code box to the `<head>` tag on your site or in Google Tag Manager if it is integrated into your site. If, after you have already inserted a quiz on your site, you change the quiz domain or open triggers (scroll percentage or timing), you will need to update the integration code on your site.",
      widgetPopupInstruction1: "Just before the closing `</footer>` tag, paste the code from the second field.",
      widgetPopupInstruction2: "For programmers or advanced users",
      widgetPopupInstruction3: "If, for some reason, you are uncomfortable inserting a quiz before the closing `</footer>` tag, you can paste the code from the second field in any convenient place, but keep in mind that the container in which you paste the code from the second field must be on top of all windows and highly desirable, should have the maximum height and width possible for the display.",
      widgetPopupCopyToHead: "Copy and paste into the `<head>` of your site",
      widgetPopupCopyToBody: "Paste the code before the closing `</footer>` tag",
      widgetPopupTimeToOpen: "A period of time",
      secondReduction: "sec",
      widgetPopupTimeClarification: "The popup will appear with a delay of the above time in seconds",
      widgetPopupScrollToOpen: "Site scrolling percentage",
      widgetPopupScrollClarification: "The popup will appear after the scrolling percentage of your site specified above",
      quizzesTemplatesAllTags: "All Templates",
      widgetEmbedVidgetButton: "Button constructor",
      widgetButtonInstruction0: "You can set a quiz on your website that will open when you click on the button.",
      widgetButtonInstruction1: "Add a border, shadow, and text to the button. Also, you can change the color of the button and the text inside.",
      widgetButtonInstruction2: "Copy the script placed in the first code box and paste it before the closing tag `</head>`.",
      widgetButtonInstruction3: "Copy the generated button code from the second code field and paste it anywhere on your site.",
      widgetButtonInstruction4: 'You can skip the code from the second button field and simply add `id="button_open_quiz_popup"` to any `<input type="button">` or `<button></button>` element on the site.',
      widgetRealTimeChange: "You can see the changes in real time on the right side of the screen",
      widgetButtonCornerRound: "Button corner rounding",
      widgetButtonShadow: "Button shadow",
      widgetButtonBgColor: "Button color",
      widgetButtonTextColor: "Text color",
      widgetButtonTextValue: "Button text",
      openPopupQuizText: "Start Quiz",
      widgetButtonInsertBeforeAfterBody: "Insert the quiz code immediately after the opening `<body>` tag or immediately before the closing `</body>` tag",
      widgetSiteCodeCopyButton: "Paste the button code anywhere on the site",
      footerContactUs: "Have questions? Feel free to contact us:",
      enterYourName: "Enter your name",
      enterYourPhone: "Enter your phone number",
      enterYourEmail: "Enter your email",
      enterYourPassword: "Enter your password",
      selectOption: "Select option",
      createNewGroup: "Create new group",
      dontHaveAccount: "Don’t have an account?",
      haveQuestions: "Any questions?",
      resetPasswordTip: "If you have any further issues or questions, please don't hesitate to contact our customer support team. We're here to help.",
      getBackAccount: "Get Back to Your Account",
      inMinutes: "in Minutes",
      alreadyHaveAccount: "Already have an account?",
      quizSlotLastEdit: "Last edit",
      workboardQuizzesTitle: "My Quizzes",
      allstepsBack: "Back",
      constructorGetLink: "Link",
      allOr: "or",
      allAnd: "and",
      acceptedFileType: "Accepted formats: ",
      quizLoaderLoadingQuiz: "Loading quiz...",
      quizLoaderPreparingQuestions: "Preparing personal questions...",
      quizLoaderSettingInterface: "Setting up the interface...",
      quizLoaderAlmostReady: "Almost ready...",
      conjunctionAnd: "and",
      acceptedFileSize: "Maximum size: ",
      acceptedFileSizeMeasure: "MB",
      cfirstBonusDisabled: "Disabled",
      cfirstBonusAvailable: "Available",
      allstepsResetInHeader: "Reset",
      placeholderText: "Type here",
      constructorSaveChanges: "Save",
      constructorCreateIntegrations: "Create integration",
      cformInputAvailable: "Available",
      cformInputDisabled: "Disabled",
      Disabled: "Disabled",
      constructorBack: "Back",
      videoInstruction: "Video Instruction",
      csettingsIntegrationFB: "Integration - Facebook Pixel",
      csettingsIntegrationTT: "Integration - TikTok",
      csettingsIntegrationGA: "Integration - Google Analytics",
      csettingsIntegrationGTM: "Integration - Google Tag Manager",
      csettingsIntegrationWH: "Integration - WebHook",
      csettingsIntegrationTG: "Integration - Telegram",
      csettingsIntegrationApixDrive: "Integration - APIxDrive",
      csettingsIntegrationEmail: "Integration - Email",
      csettingsIntegrationAbout: "About",
      csettingsIntegrationFBAbout: "Go to the Facebook Ads advertising cabinet and copy the Facebook Pixel ID in the Event Manager section.Don't copy the whole code, just the ID Copy and paste into the box below.",
      csettingsIntegrationTTAbout: "Go to your TikTok Ads manager and copy the TikTok Pixel ID from the \"Event\" section. Copy only the ID and paste it into the field below.",
      csettingsIntegrationGAAbout: "Copy the Google Analytics id and paste it into the field below.",
      csettingsIntegrationGTMAbout: "Copy the Google Tag Manager id and paste it into the field below.",
      csettingsIntegrationWHAbout1: "You can notify third-party applications about incoming leads. To do this, specify the URL to which the WebHook will be sent.We recommend using the service for this purpose.",
      csettingsIntegrationWHAboutApix: "Apix-Drive",
      csettingsIntegrationWHAbout2: "When registering using this link, for our users, there is a bonus - 10,000 free actions for any integrations.",
      csettingsIntegrationTGAbout: "Importantly: Please note that this should be a group, not a Telegram channel. Leads will not be sent to the Telegram channel.",
      csettingsIntegrationADAbout: "Something about APIxDrive",
      csettingsIntegrationEmailAbout: "Trigger an email to your respondent and notify your team. Collaborate with your team.",
      cSettingsIntegrationNeedHelp: "Need Help?",
      cSettingsIntegrationRefreshToken: "Refresh Token",
      csettingsSettingASettings: "Advanced settings",
      cSettingsSettingQuizLangTitle: "Quiz Language",
      cSettingsSettingQuizLangDescription: "To ensure you have the best experience, please select your desired quiz language from the options below. System notifications and some other constant texts will be displayed in this language when passing the quiz.",
      selectQuizLanguage: "Select Quiz language",
      cSettingsSettingQuizHideLabelTitle: "Hide label",
      cSettingsSettingQuizHideLabelDescription: 'By enabling this option, you can enjoy an interface free of the "made by adsquiz" label, allowing you and your visitors to focus solely on the questions.',
      cSettingDataSaved: "Additional settings are saved",
      userAccountInfo: "Account info",
      userGeneralInfoHeader: "General info",
      userGeneralInfoDescription1: "Your user profile is where you can manage your account and settings.",
      userGeneralInfoDescription2: "Update your personal information, change your password, and adjust your notification preferences.",
      profileNameFirst: "First Name",
      profileNameLast: "Last Name",
      profileChangePhoto: "Change photo",
      profileRemovePhoto: "Remove",
      userSecuritySettingsHeader: "Security settings",
      userSecuritySettingsDescription: "To change your password, simply enter your new password twice to confirm.",
      profileEmailCurent: "Current Email Address",
      profileEmailNew: "New Email Address",
      profileNewPasswordConfirm: "Confirm New Password",
      profileDeleteAccount: "Delete account",
      profileDeleteAccountPopupHeader: "Delete Account?",
      profileDeleteAccountPopupDescription: 'Are you sure you want to delete your account? This action cannot be undone. To confirm deletion, please type the word "DELETE" in the field below.',
      profileDeleteAccountCheckedWord: "DELETE",
      profileDeleteAccountPopupPlaceholder: "Type here",
      notificationSuccess: "Success!",
      notificationSuccessSaveAccount: "Your password has been successfully changed! Use a new password to log in again",
      notificationOnlyEmailMask: "Only a valid email address is allowed.",
      notificationOnlyNumbersMask: "Only numbers and spaces are allowed.",
      notificationOnlyLinkMask: "Only safe links are allowed (https, http or mailto).",
      notificationOnlyLettersMask: "Only letters, spaces, hyphens, apostrophes, and underscores are allowed.",
      notificationSuccessDeleteAccount: "Your password has been successfully changed! Use a new password to log in again",
      notificationSuccessDeletePhoto: "Photo successfully deleted",
      notificationSuccessChangePhoto: "Photo successfully changed",
      notificationErrorChangePhoto: "An error occurred while changing the photo",
      notificationErrorRemovePhoto: "An error occurred while removing the photo",
      notificationWarnLimitText: "Character limit exceeded. You cannot add more characters.",
      cardPanUnspecified: "Unspecified",
      userBillingsDate: "Date",
      userBillingsCost: "Cost",
      userBillingsId: "ID",
      userBillingsMethod: "Payment Method",
      RateSymbolForDropdown: "Number of symbols",
      NumberOfSymbolsForDropdown: "Rate symbol",
      optionIconLabelForDropdown_thumbnail: "Thumb up",
      optionIconLabelForDropdown_stars: "Stars",
      optionIconLabelForDropdown_flags: "Flags",
      optionIconLabelForDropdown_smiley_faces: "Smiley faces",
      labelTextYesNoPack1: "Yes/No Pack - 1",
      labelTextYesNoPack2: "Yes/No Pack - 2",
      labelTextYesNoPack3: "Yes/No Pack - 3",
      labelTextYesNoEmojiPack: "Yes/No Emoji Pack",
      labelTextEmojiPackage1: "Emoji Package - 1",
      labelTextEmojiPackage2: "Emoji Package - 2",
      labelTextEmojiPackage3: "Emoji Package - 3",
      labelTextNumberPack1: "Number pack - 1",
      labelTextNumberPack2: "Number pack - 2",
      labelTextClassicNumbers1: "Classic Numbers - 1",
      labelTextClassicNumbers2: "Classic Numbers - 2",
      labelTextRatingMarkers: "Rating markers",
      textPackagePlaceholder: "Package ...",
      labelEmojiNumberSets: "Emoji & Number Sets",
      labelSelectCountForSymbols: "Select a range from 1 to",
      labelButtonColorButtonText: "Button color & Button text",
      color: "Color",
      paymentSwitchToProHeader: "Switch to Pro",
      paymentSwitchToProDescription: "Find the plan that's right for you! Upgrade or downgrade at any time - we make it easy to get the plan you need.",
      paymentYourCurrentPlan: "Your current plan:",
      paymentYourFuturePlan: "Your new plan:",
      billingCurrentPlanLeadLimit: "Monthly lead limit",
      billingCurrentPlanLeadsRemaining: "Leads remaining",
      billingSpecialOffersHeading: "Special offers",
      billingAllPlansHeading: "All Plans",
      billingBillingPeriodToggleAria: "Billing period",
      billingPeriodMonthly: "Monthly",
      billingPeriodYearly: "Yearly",
      billingPaymentUnavailableNotification: "Payment for this plan isn't available right now. Please try again later or contact us.",
      billingRequisitesButton: "Requisites",
      billingPayAsBusiness: "Pay as a business",
      billingIbanModalTitle: "Requisites",
      billingIbanModalMethodTitle: "Bank transfer via IBAN",
      billingIbanModalDisclaimer: "To receive an invoice, contact our support chat.",
      billingIbanModalRecipient: "Recipient",
      billingIbanModalRecipientCode: "Recipient code",
      billingIbanModalIban: "IBAN",
      billingIbanModalBankName: "Bank name",
      billingIbanModalCopy: "Copy IBAN",
      billingIbanModalClose: "Close",
      billingIbanCopyAllButton: "Copy requisites",
      billingIbanCopiedNotification: "IBAN copied to clipboard",
      billingIbanAllCopiedNotification: "Requisites copied to clipboard",
      billingWhatsIncluded: "What's included",
      billingComparePlans: "Compare our plans",
      billingComparePlanA: "Plan A to compare",
      billingComparePlanB: "Plan B to compare",
      billingFeatureSectionMain: "Main",
      billingFeatureSectionAdvanced: "Advanced",
      billingFeatureSectionIntegrations: "Integrations",
      billingAnalyticsRowLabel: "Analytics",
      billingLeadsRowLabel: "Leads",
      billingFeatureProjectsRowLabel: "Projects",
      billingFeatureCustomDomainRowLabel: "Custom domain",
      billingFeatureAnalyticsRowLabel: "Analytics",
      billingFeatureSiteInstallRowLabel: "Install on site",
      billingFeatureAiBuilderRowLabel: "AI Builder",
      billingFeatureRedirectRowLabel: "Redirect",
      billingFeatureUtmTrackingRowLabel: "UTM Tracking",
      billingFeatureFaviconRowLabel: "Favicon",
      billingFeatureLogicRowLabel: "Logic",
      billingFeatureResultPageRowLabel: "Result page",
      billingFeaturePointsRowLabel: "Points",
      billingFeatureFileUploadRowLabel: "File upload",
      billingFeatureNotYetAvailableLabel: "Soon",
      billingFeatureTeamRowLabel: "Team",
      billingFeatureCrmRowLabel: "CRM",
      billingPartnershipOfferHeading: "Partnership Offer",
      paymentPlanLeadsLimit: "Limit of leads per month:",
      paymentPlanLeadsLimitForTest: "Your quiz test limit:",
      paymentPlanLeadsLeft: "Leads left:",
      paymentPlanPrice: "Price:",
      paymentPlanRenew: "Tarif renew date:",
      addNewSectionHeader: "Add New Section",
      addNewSectionList: "List",
      addNewSectionCustom: "Input field",
      addNewSectionMultiInput: "Multi input",
      addNewSectionUploadFile: "File Upload",
      addNewSectionCard: "Cards with photo",
      addNewSectionWithEmoji: "List with emoji",
      addNewSectionTags: "Tags",
      addNewSectionSlider: "Slider",
      templatesBackToQuiz: "Back to Workboard",
      constructorStepsSaved: "All quiz data has been successfully saved",
      constructorDesignSaved: "The quiz design has been successfully saved",
      azureBlueWhite: "Standard",
      azureBlue: "Winter night",
      moderatePurplishRed: "Red velvet",
      multiInputPlaceholderLink: "https:",
      multiInputPlaceholderName: "Name or full name",
      multiInputAddInput: "Add input",
      multiInputPlaceholderAddress: "Address",
      multiInputPlaceholderNumbers: "Placeholder (only numbers)",
      violetBlueCrayola: "Winter breeze",
      wetRainforest: "Summer maple",
      lavender: "Space",
      blueLilac: "Dark lavender",
      opalGreen: "Carpathian forest",
      dustyBlue: "Tiffany",
      almondCrayola: "Coral reef",
      periwinkleCrayolaLilac: "Lilac",
      periwinkleCrayolaAqua: "Synevir",
      jazzJam: "Jazz",
      slateGrayBlue: "Mist",
      turquoiseBlueCrayola: "Diia",
      blackPearlescentOpal: "Ash",
      pearlescentGentianBlue: "Sapphire",
      sapphireBlue: "Dark sapphire",
      errorUserDataUpdate: "Error in updated data: ",
      completeUserDataUpdate: "User data updated",
      passwordDoNotCoincidence: "Passwords do not match",
      passwordDoNotCoincidenceAgain: "Try again",
      nonBillingsYet: "You don't have any billing history yet. ",
      youCanChangePlan: "You can change current plan by clicking “Switch to PRO” button",
      rangeMin: "Min",
      rangeMax: "Max",
      rangePositionStart: "Position Start",
      rangePositionEnd: "Position End",
      rangeStep: "Step",
      rangeIsRange: "Range",
      rangeIsRangeTrue: "Available",
      rangeIsRangeFalse: "Disable",
      recivePromotionNewsletter: "Receive email newsletters",
      reciveEmailCheckbox: "Receive Email Checkbox",
      additionalCheckbox: "Additional Checkbox",
      contactPrivacyPolicyCheckbox: "Contact Privacy Policy Checkbox",
      contactAgreeIAgreeWith: "I agree with",
      contactAgreePolicy: "the privacy policy",
      contactAgreeAnd: "and",
      contactAgreeTermsOfUse: "the terms of use",
      contactAgreeAgreementAdditionalWord: "",
      contactFillRequiredInput: "Fill in the required fields",
      langDE: "German",
      langEN: "English",
      langIT: "Italian",
      langKK: "Kazakh",
      langPL: "Polish",
      langRU: "Russian",
      langSP: "Spanish",
      langUA: "Ukrainian",
      langSV: "Swedish",
      langLT: "Lithuanian",
      langLV: "Latvian",
      langET: "Estonian",
      langRO: "Romanian",
      leadsLeft: "Leads left",
      generateDomainTitle: "Enter the domain name",
      generateCodeForEmbedQuiz: "Generate code",
      generateDomainDescription: "This is the unique address where your page will be accessible. You can change the address at any time or connect your own one.",
      generateDomainDomainNameLabel: "Domain name",
      cancelAllAction: "Cancel",
      confirmAllAction: "Confirm",
      fieldDataTypeLabel: "Data type in the field",
      falseHasValidCharacters: "Invalid characters in the domain. Valid characters are letters, numbers and hyphens.",
      falseHasValidLength: "Domain length should be between 6 and 20 alphanumeric characters.",
      falseDoesNotStartOrEndWithSpecialChar: "Domain should not start or end with a special character.",
      falseDoesNotHaveConsecutiveSpecialChar: "Domain should not contain two or more consecutive special characters.",
      falseDoesNotHaveConsecutiveSameChar: "Domain should not contain three or more consecutive identical characters.",
      falseDoesNotContainForbiddenSubstrings: "Domain should not contain forbidden substrings.",
      generateDomainTaken: "This domain is already taken. Try another one",
      temporarilyUnavailable: "Temporarily unavailable",
      csettingsAdmin: "Settings for admins",
      questionLogicSetupTitle: "Question logic setup",
      questionLogicSetupDescription: "Add conditions to help you tailor the survey to each respondent and collect more accurate data.",
      questionLogicConditionTitle: "Condition",
      questionLogicQuestion: "Question",
      questionLogicSetupQuestionDisableOption: "Select Question",
      questionLogicSetupAnswer: "Answer",
      questionLogicSetupLogicType: "Type",
      questionLogicSetupAnswerDisableOption: "Select type of condition",
      questionLogicSetupRangeRatingBetween: "Between",
      questionLogicSetupRangeRatingLess: "Less",
      questionLogicSetupRangeRatingMore: "More",
      questionLogicSetupRangeRatingEqualTo: "Equal to",
      questionLogicSetupRangeRatingFrom: "From",
      questionLogicSetupRangeRatingTo: "To",
      questionLogicSetupVariantAll: "All",
      questionLogicSetupVariantAny: "Any",
      questionLogicSetupVariantNot: "None",
      questionLogicSetupCustomEqual: "Equal",
      questionLogicSetupCustomContains: "Contains",
      questionLogicSetupCustomNotContains: "Not contains",
      questionLogicSetupRangeRatingValue: "Value",
      questionLogicSetupExpectedAnswer: "Expected answers",
      questionLogicSetupPlaceholder: "Type here",
      questionLogicAllMandatory: "All of the above conditions are mandatory",
      questionLogicAddConditionBtn: "Add Condition",
      questionLogicNotAvailable: "Logic settings are not available for the first question",
      pointsSettingsNotAvailableForQuestionType: "This type of question does not involve scoring answers",
      questionLogicSaved: "Step display logic settings are saved",
      questionLogicDeleteAll: "Delete logic",
      questionLogicDeleted: "Step display logic deleted",
      questionLogicRatingSelectedLeftBtn: "left button",
      questionLogicRatingSelectedRightBtn: "right button",
      QR_code: "QR code",
      QRCodeDownloadPdf: "Download Pdf",
      QRCodeDownloadPng: "Download Png",
      qrGenerateTitle: "Generate QR Code",
      qrGenerateDescription: "Generate a personalized QR code with UTM tags to easily track traffic sources. When users scan the code, they’ll be directed to your quiz with campaign parameters preserved for accurate analytics.",
      qrUtmSource: "The referrer (e.g. google, newsletter)",
      qrUtmMedium: "Marketing medium (e.g. cpc, banner, email)",
      qrUtmCampaign: "Product, promo code, or slogan (e.g. spring_sale). One of campaign name or campaign ID is required.",
      qrUtmTerm: "Identify the paid keywords",
      qrUtmContent: "Use to differentiate ads",
      billingPaymentInfoTitle: "Tariff Information",
      billingPaymentInfoChangeTarrif: "Change tariff",
      billingPaymentInfoDescription: "When you pay for any paid tariff, you receive a certain number of leads included in the package you have chosen. These leads are provided for a month. If you haven't used your leads within a month from the moment of payment, they will be canceled.",
      billingGeneralName: "Your Tariff",
      billingGeneralCost: "Cost",
      billingMonth: "month",
      billingGeneralExpired: "Valid until",
      billingGeneralLeadsLeft: "Leads left",
      billingGeneralAllTarifExpired: "Tariff expiration date",
      billingGeneralBonus: "Bonus leads",
      billingGeneralLeadsFromOtherTarifs: "Leads from other tariffs",
      billingGeneralNoActiveTariff: "No active tariff",
      billingLeadsAvailableLabel: "Available leads",
      billingLeadsTariffSourceLabel: "Tariff",
      billingLeadsRemainingOfLabel: "{remaining} / {total} remaining",
      planUsageTeamMembersLabel: "Team members",
      planUsageManagePlanLabel: "Manage plan",
      billingAcordeonPaymentInfoTitle: "Payment information",
      billingAcordeonPaymentInfoFormat: "Format",
      billingAcordeonPaymentInfoSubscription: "Subscription",
      billingAcordeonPaymentInfoPay: "Payment",
      billingAcordeonPaymentInfoPayMethod: "Payment Method",
      billingAcordeonPaymentInfoCancelSubscription: "Cancel Subscription",
      billingAcordeonPromocode: "Promo Code",
      billingAcordeonPromocodeLabel: "Enter promo code",
      billingAcordeonPayHistory: "Transaction History",
      paymentAllTarifInactive: "tariff is inactive",
      subscriptionUnsubscribeModalTitle: "Unsubscribe",
      subscriptionUnsubscribeModalDescription: "Are you sure you want to unsubscribe? Leads accrued for the subscription will be available to you for a month from the last billing date.",
      subscriptionIsNotDeleteTitle: "Subscription Not cancelled",
      subscriptionIsNotDeleteDescription: "Please contact customer support",
      subscriptionCanceledTitle: "Subscription cancelled",
      embedQuizTitleGetLinkModal: "Embed the quiz on the website as:",
      QRCodeTitleGetLinkModal: "Use QR code:",
      modalSureUnsavedChangesTitle: "You have unsaved changes",
      modalSureUnsavedChangesDescription: "Before leaving the current page, please decide what to do with the unsaved changes",
      modalSureUnsavedChangesDontSave: "Don't Save",
      modalSureUnsavedChangesSave: "Save",
      modalSuggestIdeaNotificationSuccess: "Success! Thank you for your idea",
      modalSuggestIdeaNotificationUnsuccess: "Oops! Something went wrong. Please try again later.",
      telegramTokenCopied: "The quiz token has been copied to the clipboard",
      cSettingsSettingQuizBackButtonTitle: "Back button",
      cSettingsSettingQuizBackButtonDescription: "You can enable or disable the back button. This will provide an opportunity to change the previously given answer.",
      cSettingsCustomThemePrimaryColor: "Color of accents",
      cSettingsCustomThemeSecondaryColor: "Background color",
      cSettingsCustomThemeAdditionalColor: "Text color",
      cSettingsCustomThemeButtonTextColor: "Text in button",
      cSettingsCustomThemeModeDark: "Dark",
      cSettingsCustomThemeModeLight: "Light",
      allstepsPlaceholder: "Placeholder",
      allstepsCustomInput: "Custom input",
      allstepsCustomInputOn: "Available",
      allstepsCustomPlaceholder: "Other",
      trashcanTitle: "Trashcan",
      trashcanImportant: "Important!",
      trashcanDescription: "The quiz will be automatically deleted permanently 30 days after it is moved to the trashcan.",
      trashcanClearAll: "Clear all",
      quizSlotDeletedData: "Deleted at",
      workboardLeads: "Leads",
      filterOptionLabelCreatedDesc: "from new to old",
      filterOptionLabelCreatedAsc: "from old to new",
      filterOptionLabelLeadsDesc: "By leads (from highest)",
      filterOptionLabelLeadsAsc: "By leads (from lowest)",
      filterOptionLabelWithProject: "Quizzes in projects",
      filterOptionLabelWithoutProject: "Quizzes without project",
      workboardDuplicate: "Duplicate",
      leadsTable: "Leads List",
      exportInfo: "Export Leads",
      leadHide: "Hide",
      leadShowMore: "Show More",
      poperTrashcan: "Trashcan",
      restoreQuizSendedTitle: "A recovery task is running",
      restoreSuizSendedImportant: "Important",
      restoreQuizSendedDescription: "Depending on how many leads there were in your quiz, restoring the quiz may take from a few seconds to 2 minutes. After restoration, the quiz will appear on your main workboard.",
      ok: "Okay",
      month: "0 month | {n} month | {n} months",
      discount: "Discount up to",
      saveMoney: "Subscription for a year",
      upProVersionMobile: "To PRO",
      upProVersionDesktop: "Switch to PRO",




      csettingsIntegrationSendPulse: "Integration - Send Pulse",
      csettingsIntegrationMailchimp: "Integration - Mailchimp",
      csettingsIntegrationMake: "Integration - Make",
      csettingsIntegrationZapier: "Integration - Zapier",
      csettingsIntegrationCRMBitrix: "Integration - CRM Bitrix",
      csettingsIntegrationPipeDrive: "Integration - Pipe Drive",
      csettingsIntegrationRemOnline: "Integration - Rem Online",
      csettingsIntegrationKeyCRM: "Integration - Key CRM",
      csettingsIntegrationGoogleSpreadsheets: "Integration - Google Spreadsheets",
      csettingsIntegrationKeepinCrm: "Integration - KeepinCRM",
            
      csettingsIntegrationZapierAbout: "Paste the data sending URL provided by Zapier into the input field.",
      csettingsIntegrationMakeAbout: "Paste the data sending URL provided by Make into the input field.",
      csettingsIntegrationMakeAboutTextStep1: "To set up the integration with",
      csettingsIntegrationMakeAboutTextStep2: "watch the",
      csettingsIntegrationMakeAboutTextStep3: "For setup, select “Webhooks” among the integrations on the Make side, then choose “Custom webhook”.",
      csettingsIntegrationMakeAboutTextStep4: "Copy the generated link and paste it into the field below in ADS Quiz.",
      csettingsIntegrationMakeAboutTextStep5: "To test, go back to Make, click “Run”, and complete the quiz by submitting a lead.",
      csettingsIntegrationMakeAboutTextStep6: "If the test is successful, save the integration and don’t forget to activate updates.",
      csettingsIntegrationMakeAboutLinkVideoText: "video",
      csettingsIntegrationCRMBitrixAbout: "Paste the data sending URL provided by CRM Bitrix into the input field.",

      csettingsIntegrationSendPulseAboutStart: "You can set up integration with the ",
      csettingsIntegrationSendPulseAboutMiddle: " service. To do this, go to your account settings and open the ",
      csettingsIntegrationSendPulseAboutEnd: " tab. Copy the values of the 'ID' and 'Secret' parameters, then paste them into the corresponding fields in the ADS Quiz service (in the fields below). Next, you need to enter the address book ID. To do this, go to the required address book and copy the value from the URL after id/. Only numbers are needed, without any additional characters. Save the changes. A more detailed guide is available in the ",
      csettingsIntegrationSendPulseAboutLinkSendPulse: "https://sendpulse.com/en/#60c9ccfd55f4b",
      csettingsIntegrationSendPulseAboutLinkAPI: "https://login.sendpulse.com/login/#api",
      csettingsIntegrationSendPulseAboutLinkVideo: "https://www.youtube.com/watch?v=4mnhpbKkePs",
      csettingsIntegrationSendPulseAboutLinkVideoText: "video",

      csettingsIntegrationKeyCRMAbout: "Paste the API key and PipelineID into the respective input fields.",
      csettingsIntegrationPipeDriveAbout: "Paste the token and company domain into the respective input fields.",
      csettingsIntegrationRemOnlineAbout: "Paste the Rem Online API key into the respective input field.",
      csettingsIntegrationGoogleSheetsAbout: "Log in to Google Sheets (if your account is registered with a Gmail address, you can only connect that Gmail account; attempting to connect a different account will result in an error), select the sheet, and map the fields to start transferring data.",
      csettingsIntegrationMailchimpAbout: "Connect Mailchimp, choose an audience, and map fields if needed.",
      csettingsIntegrationActiveIntegration: "Active Integration",
      cintegrationIntegrationData: "Integration Data",
      cintegrationMailchimpAudience: "Audience",
      cintegrationMailchimpAudiencePlaceholder: "Select audience",
      cintegrationMailchimpStatus: "Subscriber status",
      cintegrationMailchimpStatusOptionSubscribed: "subscribed (Subscribed)",
      cintegrationMailchimpStatusOptionPending: "pending (Pending confirmation)",
      cintegrationMailchimpStatusOptionUnsubscribed: "unsubscribed (Unsubscribed)",
      cintegrationMailchimpStatusOptionCleaned: "cleaned (Cleaned)",
      cintegrationMailchimpStatusOptionTransactional: "transactional (Transactional only)",
      cintegrationMailchimpStatusDescriptionSubscribed: "the contact will be able to receive your newsletters.",
      cintegrationMailchimpStatusDescriptionPending: "the user has not yet confirmed the subscription via email.",
      cintegrationMailchimpStatusDescriptionUnsubscribed: "the contact has opted out of your newsletters.",
      cintegrationMailchimpStatusDescriptionCleaned: "emails cannot be delivered.",
      cintegrationMailchimpStatusDescriptionTransactional: "used only for service emails, not for marketing campaigns.",
      cintegrationMailchimpConnect: "Connect Mailchimp",
      cintegrationMailchimpConnectTo: "Connect to Mailchimp",
      cintegrationMailchimpConnectedTo: "Connected to Mailchimp",
      cintegrationMailchimpUseMapping: "Field Settings",
      cintegrationMailchimpDataSaved: "Mailchimp integration data saved",
      cintegrationDataMailchimpError: "Select a Mailchimp audience",
      cintegrationMailchimpMappingError: "Fill in field mapping",
      cintegrationMailchimpNoTags: "Mailchimp has no tags",
      cintegrationIntegrationUrl: "Integration URL",
      cintegrationWriteUrl: "Enter URL",
      cintegrationDataFBError: "Incorrect pixel identifier",
      cintegrationDataWebHookError: "Invalid webhook address",
      cintegrationZapierDataSaved: "Zapier integration data saved",
      cintegrationDataZapierError: "Invalid integration address",
      cintegrationAPIxDriveDataSaved: "APIxDrive integration data saved",
      cintegrationDataAPIxDriveError: "The string is not an APIxDrive integration address",
      cintegrationMakeDataSaved: "Make integration data saved",
      cintegrationDataMakeError: "Invalid integration address",
      cintegrationSendPulseDataSaved: "SendPulse integration data saved",
      cintegrationDataSendPulseError: "Invalid or empty integration data",
      cintegrationPipeDriveDataSaved: "PipeDrive integration data saved",
      cintegrationDataPipeDriveError: "Invalid or empty integration data",
      cintegrationRemOnlineDataSaved: "RemOnline integration data saved",
      cintegrationDataRemOnlineError: "Invalid or empty integration data",
      cintegrationKeyCRMDataSaved: "KeyCRM integration data saved",
      cintegrationDataKeyCRMError: "Invalid or empty integration data",
      cintegrationInputEmailUrl: "Enter Email",
      cintegrationEmailDataSaved: "Email saved",
      cintegrationDataEmailError: "The entered string is not an Email",
      cintegrationCRMBitrixDataSaved: "Email saved",
      cintegrationDataCRMBitrixError: "The entered string is not an Email",
      cintegrationTelegramBotDataSaved: "Telegram integration settings saved",
      cintegrationDataTelegramBotError: "Save error",
      cintegrationGTMDataSaved: "Google Tag Manager ID saved",
      cintegrationDataGTMError: "Invalid ID",
      cintegrationDataGTMErrorDescription: "The ID should have the format GTM-XXXXXX",
      cintegrationGoogleAnalyticsDataSaved: "Google Analytics ID saved",
      cintegrationDataGoogleAnalyticsError: "Incorrect ID",
      cintegrationDataGoogleAnalyticsErrorDescription: 'The ID should have the format "UA-XXXXXXX-X" or "G-XXXXXXXXXX-XX"',
      cintegrationTikTokDataSaved: "Tik-Tok pixel saved",
      cintegrationDataTikTokError: "The entered string is not a Tik-Tok pixel",
      cintegrationIntegrationToken: "Integration Token",
      cintegrationWriteToken: "Enter integration token",
      cintegrationDataYourAPIKey: "Enter your API key",
      viewQuizInMobile: "View Quiz",
      notificationCSRFTokenMismatch: "CSRF Token Mismatch",
      notificationReloadPage: "Please reload the page and try again",
      csettingsIntegrationKeyRemOnline: "Paste the token and channel ID in the appropriate fields",
      cintegrationDataYourIntegrationToken: "API key",
      cintegrationDataLeadTypeId: "Channel ID",
      send_utm: "Send UTM tags",
      send_quiz: "Send quiz data",
      send_answers: "Send answers",
      csettingsIntegrationKeyCrm: "KeyCRM integration",
      cintegrationSendPulseClientId: "Client ID",
      cintegrationSendPulseClientSecret: "Secret",
      cintegrationSendPulseAddressBookId: "Address book ID",
      cintegrationSendPulseAction: "Action with contact",
      sendpulseActionAddContact: "Add contact",
      sendpulseActionDeleteContact: "Delete contact",
      cintegrationPipeDriveToken: "API token",
      cintegrationPipeDriveDomain: "Your unique subdomain",
      cintegrationKeyCrmApiKey: "API key",
      cintegrationKeyCrmPipelineId: "Pipeline ID",
      cintegrationMenuGoogleTagManager:"Google Tag Manager",
      cintegrationMenuGoogleAnalytics:"Google Analytics",
      cintegrationMenuGoogleSpreadsheets:"Google Spreadsheets",
      cintegrationMenuKeepinCRM:"KeepinCRM",
      cintegrationMenuFacebookPixel:"Facebook pixel",
      cintegrationMenuTikTokPixel:"TikTok Pixel",
      cintegrationMenuWebHook:"Webhook",
      cintegrationMenuZapier:"Zapier",
      cintegrationMenuAPIxDrive:"APIx Drive",
      cintegrationMenuMake:"Make",
      cintegrationMenuSendPulse:"Send Pulse",
      cintegrationMenuMailchimp:"Mailchimp",
      cintegrationMenuEmail:"Email",
      cintegrationMenuTelegramBot:"Telegram-bot",
      cintegrationMenuPipeDrive:"PipeDrive",
      cintegrationMenuRemOnline:"Rem Online",
      cintegrationMenuKeyCRM:"Key CRM",
      cintegrationMenuCRMBitrix:"CRM Bitrix",
      googleSignIn: "Sign in with Google",
      googleSignInHint: "Authorize to continue configuring the integration.",
      cintegrationGoogleSpreadsheetID: "Spreadsheet ID",
      cintegrationGoogleSheetName: "Sheet name",
      googleSheetNameTip: "Use the sheet name exactly as it appears in Google Sheets.",
      googleSheetsMappingTitle: "Field mapping",
      cintegrationGoogleSheetsSaved: "Google Spreadsheets data saved",
      googleSheetsSelectSheet: "Choose a sheet",
      googleSheetsSelectSheetPlaceholder: "Select sheet",
      googleSheetsSelectSheetFirst: "Select a sheet first to configure mapping",
      csettingsIntegrationKeepinCrmAbout: "Paste the KeepinCRM API key, choose pipeline, status, manager, source, and enable field mapping if needed.",
      cintegrationKeepinPipelineId: "Pipeline",
      cintegrationKeepinPipelineIdPlaceholder: "Select pipeline",
      cintegrationKeepinStatusId: "Status",
      cintegrationKeepinStatusIdPlaceholder: "Select status",
      cintegrationKeepinManagerId: "Manager",
      cintegrationKeepinManagerIdPlaceholder: "Select manager",
      cintegrationKeepinSourceId: "Source",
      cintegrationKeepinSourceIdPlaceholder: "Select source",
      cintegrationKeepinUseMapping: "Use field mapping",
      cintegrationKeepinDataSaved: "KeepinCRM data saved",
      trashcanRestoreQuiz: "Restore Quiz",
      cformValuePromotionAccepted: "I agree to the email newsletter",


      constructorAddIntegration: "Add a new integration",
      cintegrationKeyCrmSourceId: "Source ID (optional)",
      cintegrationKeyCrmManagerId: "Manager ID (optional)",
      cSettingsSettingQuizSpamFilterTitle: "Spam Protection",
      cSettingsSettingQuizSpamFilterDescription: "This feature is disabled by default. If you encounter spam leads, enable protection. After that, a single user will not be able to submit more than the specified number of leads for this quiz.",
      cSettingsSettingQuizSpamFilterLimitPlaceholder: "Number of leads",
      langNO: "Norwegian",
      loadMoreLeads: "See more leads",
      userAdditionalSettingsHeader: "Additionat settings",
      userAdditionalSettingsDescription1: "Here you can configure new advanced profile settings.",
      userAdditionalSettingsPagination: "Pagination on the workboard",

      benefitType: "Benefit Type",
      benefitLabelPlaceholder: "Bonus text",
      benefitDescriptionPlaceholderDiscount: "Promo code or instruction",
      benefitDescriptionPlaceholderVideo: "Link to video",
      benefitDescriptionPlaceholderTextfile: "Link to text file",
      benefitDescriptionPlaceholderGift: "Bonus description",
      benefitDescriptionPlaceholderPDF: "Link to PDF",
      benefitDescriptionPlaceholderLink: "Link",
      benefitDescriptionPlaceholderFile: "Link to file",
      benefitDescriptionPlaceholderCustom: "Link",
      benefitLabelDiscount: "Discount",
      benefitLabelVideo: "Video",
      benefitLabelTextfile: "Textfile",
      benefitLabelGift: "Gift",
      benefitLabelPDF: "PDF file",
      benefitLabelLink: "Link",
      benefitLabelFile: "File",
      benefitLabelCustom: "Custom bonus",
      addBenefit: "Add benefit",
      saveBenefit: "Save bonus",
      cfinishSocialNetworks: "Social networks",

      saveSocialNet: "Save Social Network",
      networkLabelFacebook: "Facebook",
      networkLabelInstagram: "Instagram",
      networkLabelTelegram: "Telegram",
      networkLabelTiktok: "Tik-Tok",
      networkLabelYoutube: "Youtube",
      networkLabelLinkedin: "LinkedIn",
      networkLabelWhatsapp: "WhatsApp",
      socialNetDescriptionPlaceholderFacebook: "profile_nikname",
      socialNetDescriptionPlaceholderInstagram: "profile_nikname",
      socialNetDescriptionPlaceholderTelegram: "profile/chanel_nikname",
      socialNetDescriptionPlaceholderTiktok: "profile_nikname",
      socialNetDescriptionPlaceholderYoutube: "chanel_name",
      socialNetDescriptionPlaceholderLinkedin: '"in/name" or "company/name"',
      socialNetDescriptionPlaceholderWhatsapp: "+15555551234",

      addNewSectionEmptyPage: "Simple Text Page",
      csanyMakeImpasse: "Impasse",
      impaseIsImpaseTrue: "ON",
      impaseIsImpaseFalse: "OFF",
      defaultNewEmptyQuestionDescription: "You can paste and format long text here (we do not recommend pasting more than 3000 characters).",
      cSettingsSettingQuizTimezoneTitle: "Quiz Timezone",
      cSettingsSettingQuizTimezoneDescription: "Enter the timezone in which the time for lead submission will be recorded. This is especially useful when you are in one timezone, and the client is in another. In this case, you can set the client's timezone, and the leads you receive will show the time according to the client's timezone.",
      cSettingsSettingQuizTimezonePlaceholder: "Timezone",
      userAdditionalSettingsTimezone: "User's time zone",
      userAdditionalSettingsTimezonePlaceholder: "Timezone",
      langHE: "Hebrew",
      langCS: "Czech",
      cintegrationCAPIFBInstruction: "To set up integration with Facebook Conversion API, you need to enter the pixel ID and access token. These details can be obtained in the Facebook Business Manager settings. After entering the required information, save the integration.",
      cintegrationCAPIFBInstructionTextTitle: "Event Names for FB Conversions:",
      cintegrationCAPIFBInstructionTextStart: " – visit to the start page;",
      cintegrationCAPIFBInstructionTextQuestionN: " – visit to step N (step number is dynamically inserted);",
      cintegrationCAPIFBInstructionTextOpenContactPage: " – visit to the contact page;",
      cintegrationCAPIFBInstructionTextLead: " – successful submission of the contact form;",
      cintegrationCAPIFBInstructionTextThankYou: " – visit to the final page.",
      cintegrationCAPIFBInstructionTextOptimizationAdvice: "We recommend running ads optimized for the event called",
      cintegrationCAPIFBInstructionTextLeadTriggerCondition: "This event is triggered",
      bold_capi_adsquiz_Start: "capi_adsquiz_Start",
      bold_capi_adsquiz_QuestionN: "capi_adsquiz_Question-N",
      bold_capi_adsquiz_OpenContactPage: "capi_adsquiz_OpenContactPage",
      bold_capi_adsquiz_Lead: "capi_adsquiz_Lead",
      bold_capi_adsquiz_ThankYou: "capi_adsquiz_ThankYou",
      bold_capi_adsquiz_OptimizationAdvice: "“capi_adsquiz_Lead”.",
      bold_capi_adsquiz_LeadTriggerCondition: "only when a user successfully submits a lead form.",
      csettingsIntegrationFbCapiAbout: "Integration with Facebook Conversion API allows you to send user interaction data directly to Facebook to improve the effectiveness of advertising campaigns.",
      cintegrationInputCapiAccessToken: "Enter access token",
      cintegrationInputCapiCustomparameter: "Enter custom event parameters",
      cintegrationDataFbCapiSaved: "Facebook Conversion API integration successfully saved",
      cintegrationComonRenovateHubInstructionTitle: "Instructions for setting up integration with «Міністерство Ремонту»",
      cintegrationComonRenovateHubInstructionDescription1: "To set up the integration with “Ministerstvo Remontu,” specify the webhook URL to which the data will be sent.",
      cintegrationComonRenovateHubInstructionDescription2: "To do this, go to the “Admin Panel,” then open the “Integrations” section and select ADS Quiz. Click “Create webhook URL,” copy it, and paste it into the input field below in the ADS Quiz service.",
      cintegrationComonRenovateHubInstructionDescription3: "After that, complete the quiz for testing or send a test lead using the “Test” button.",
      cintegrationComonRenovateHubInstructionDescription4: "Then save and activate the integration. All leads will be sent to “Ministerstvo Remontu” in the “Requests” section.",
      cintegrationComonRenovateHubInstructionShort: "Integration with «Міністерство Ремонту» allows you to send data to CRM through a webhook for process automation.",
      cintegrationRenovateHubUrl: "Enter the «Міністерство Ремонту» URL",
      cintegrationInputRenovateHubUrl: "Specify the webhook URL for «Міністерство Ремонту»",
      cintegrationRenovateHubDataSaved: "Integration with «Міністерство Ремонту» successfully saved",
      cintegrationDataRenovateHubError: "Error saving integration with «Міністерство Ремонту». Please check the entered data for accuracy.",
      cintegrationMenuFacebookConvAPI: "Facebook Conversions API",
      cintegrationMenuRenovateHub: "Міністерство Ремонту",
      csettingsIntegrationRenovateHub: "Integration with «Міністерство Ремонту»",
      csettingsIntegrationCAPIFB: "Facebook Conversions API integration",
      paymentPlanEnd: "End date of the plan",
      paymentPlanNextPayment: "Next payment",
      paymentPlanLeadsLimitForYear: "Limit of leads per year:",
      paymentPlanLeadsLimitForPeriod: "Limit of leads per period:",
      EditTags: "Edit tags",
      quizzesTemplatesNoTags: "No Tags",
      Monday: "Monday",
      Tuesday: "Tuesday",
      Wednesday: "Wednesday",
      Thursday: "Thursday",
      Friday: "Friday",
      Saturday: "Saturday",
      Sunday: "Sunday",
      datetimeDisplayMode: "Picker type",
      datetimeDisplayModeSelect: "Select type",
      datetimeDisplayModeDate: "Date",
      datetimeDisplayModeTime: "Time",
      datetimeDisplayModeDatetime: "Date & Time",
      datetimeMinDate: "Min. date",
      datetimeMinDateCustom: "Select min. date",
      datetimeMaxDate: "Max. date",
      datetimeMaxDateCustom: "Select max. date",
      datetimeProhibitDaysOfWeek: "Restrict days",
      datetimeIsRange: "Enable range",
      datetimeIsRangeTrue: "Range enabled",
      datetimeIsRangeFalse: "Range disabled",
      datetimeMinTime: "Min. time",
      datetimeMaxTime: "Max. time",
      datetimeIs24: "24-hour format",
      datetimeIs24True: "24-hour enabled",
      datetimeIs24False: "24-hour disabled",
      csanyIsExactDate: "How would you like to set the date",
      csanyIsExactDateTrue: "Exact Date",
      csanyIsExactDateFalse: "Relative Date",
      csanyDatetimeMinMaxNotExactPlaceholder: '"x" or "-x" days from today',
      addNewSectionDatetime: "Date/time",
      tariffsPromo: "Promotional offers",
      pricingComparisonEyebrow: 'Adsquiz pricing',
      pricingComparisonTitle: 'Choose one of our plans',
      pricingComparisonMobileHint: 'Swipe through the plan cards, then pick two below to compare in detail.',
      pricingComparisonTableAria: 'Pricing plans comparison table',
      pricingComparisonMonthShort: 'month',
      billingPromoPeriodYearly: "year",
      billingPromoPeriodMonths: "{count} months",
      billingPromoDescription: "No limits on quizzes or features",
      pricingComparisonTryFree: 'Try for Free',
      pricingComparisonGetStarted: 'Upgrade',
      pricingComparisonCurrentPlan: 'Your plan',
      pricingComparisonBuyAgain: 'Buy again',
      pricingComparisonLeadsPerMonth: '{count} leads /month',
      pricingComparisonUnlimited: 'Unlimited',
      pricingComparisonTeamUsers: '+{n} user | +{n} users',
      pricingComparisonRequired: 'Required',
      pricingComparisonOptional: 'Optional',
      tariffsMonth: "Monthly",
      tariffsAnual: "Annually",
      leadsOn1Month: "per month",
      leadsOn2Month: "for 2 months",
      leadsOn3Month: "for 3 months",
      leadsOn4Month: "for 4 months",
      leadsOn5Month: "for 5 months",
      leadsOn6Month: "for 6 months",
      leadsOn7Month: "for 7 months",
      leadsOn8Month: "for 8 months",
      leadsOn9Month: "for 9 months",
      leadsOn10Month: "for 10 months",
      leadsOn11Month: "for 11 months",
      leadsOn12Month: "per year",
      leadsOn24Month: "for 2 years",
      leads: "leads",
      tariffsWordPrice: "Price",
      tariffsNoLimits: "No restrictions",
      tariffsNoLimitsQuizzes: "on quizzes",
      tariffsAndFunctions: "and functionality",
      billingTariffYear: "year",
      billingChangePlanSubscribe: "Subscribe",
      paymentAllTariffInactive: "Tariff is not active",
      subscriptionTariffLableOnly: "Available by subscription only",
      notExactBeforeYear: "before Year",
      notExactBeforeHalfYear: "before Half year",
      notExactBeforeQuarter: "before Quarter",
      notExactBeforeMonth: "before Month",
      notExactBeforeWeek: "before Week",
      notExactBeforeYesterday: "before Yesterday",
      notExactYesterday: "Yesterday",
      notExactToday: "Today",
      notExactTomorrow: "Tomorrow",
      notExactAfterTomorrow: "after Tomorrow",
      notExactAfterWeek: "after Week",
      notExactAfterMonth: "after Month",
      notExactAfterQuarter: "after Quarter",
      notExactAfterHalfYear: "after Half year",
      notExactAfterYear: "after Year",
      tipDefaultDateHeader: "Default",
      tipDefaultDateText: "If both the 'Exact Date' and 'Relative Date' toggles are turned off, the calendar will allow selecting dates from the year 1800 to 2200 by default.",
      tipExactDateHeader: "Exact Date Toggle",
      tipExactDateText: "Enabling this toggle will limit the calendar to a fixed date range defined by the exact date(s) selected in the input fields below.",
      tipRelativeDateHeader: "Relative Date Toggle",
      tipRelativeDateText: "Enabling this toggle will dynamically set the calendar limits based on relative dates calculated at the moment of page load. These limits are personalized and recalculated for each user individually.",
      langPT: "Portuguese",
      placeholderCompanyContactText: 'For example: "Company phone: +180993322211"',
      integrationConnectService: "Connect",
      Connect: "Connect",
      Connected: "Connected",
      Disconnect: "Disconnect",
      cintegrationOauthDisconnectModalTitle: "Disconnect {provider}?",
      cintegrationOauthDisconnectModalDescription: "Disconnecting {provider} will disconnect this integration from ALL quizzes. If you only want to disable it for this quiz, delete the integration below.",
      cintegrationOauthDisconnectModalDescriptionBase: "Disconnecting {provider} will disconnect this integration from ALL quizzes.",
      cintegrationOauthDisconnectModalDescriptionDeleteHint: "If you only want to disable it for this quiz, delete the integration below.",
      cintegrationOauthDisconnectDeleteQuizOnly: "Delete from this quiz",
      cintegrationOauthDisconnectAllQuizzes: "Disconnect for all quizzes",
      leadtype_id: "Action type",
      selectVariant: "Select",
      sfirstAddCompanyContacts: "Text with contacts",
      addNewSectionTextarea: "Long input",
      allstepsVariantView: "Image format",
      tariffsDiscountSave: "Save",
      cAdminSettingsTitle: "Admin settings",
      cAdminSettingsInstruction: "Enter the tags for the quiz in the field below. Tags can consist of multiple words, each tag is separated by a comma. Tags 'Services' and 'services' are different tags. It is recommended to use tags that start with a capital letter. You can also exclude the quiz from the list of templates.",
      cAdminSettingsIsTemplate: "Is it a template",
      cIsTemplateStateAreSaved: "The template status has been saved",
      sfirstAddLogotype: "Add a logo",
      logotypeSizeTip: "The logo will be inserted at its actual size but no larger than 120 pixels on the longer side.",
      cfirstLogotypeUpdated: "The logo has been added",
      cfirstLogotypeDeleted: "The logo has been successfully deleted!",

      cOffersPageSettings: "Settings",
      offerPageTitlePlaceholder: "Enter title",
      offerPageDescriptionPlaceholder: "Enter page description",
      offerPageButtonTextPlaceholder: "Enter button text (optional)",
      allstepsOffers: "List of offers",
      offerProposalHeader: "Offer",
      offerAttachAddImg: "Add image",
      offerAttachAddVideo: "Add video",
      offerItemImg: "Image",
      offerItemTitle: "Offer title",
      offerTitlePlaceholder: "Enter title here",
      offerItemSubtitle: "Subtitle (e.g., price)",
      offerSubtitlePlaceholder: "Enter text here",
      offerItemDescription: "Offer description",
      offerDescriptionPlaceholder: "Enter description here",
      offerItemButtonText: "Offer button text",
      offerBtnTextPlaceholder: "Enter button text",
      offerItemButtonLink: "Button link",
      offerBtnLinkPlaceholder: "Start link with https://",
      csanyOfferLogic: "Display logic",
      offerAddNewOffer: "Add new offer",
      offerLogicSetupTitle: "Logic settings",
      OfferLogicSetupDescription: "Here you can set up which answers will display specific offers",
      cstepsOffersPage: "Results page",
      addNewSectionResultsByLogic: "Offers",
      cformActionAfterContactOffersOr: "Offers page / ",
      tolltipOffersAfterContact: "If, after completing the quiz, the logic for displaying at least one offer is met, the offers page will be shown; otherwise, the Thank You page will be displayed.",
      videoCircleTextQuestion: "Video instruction",
      offerPhotoOptimalRatio: "For optimal image display, we recommend using a 16:9 ratio.",
      tolltipThankYouAfterContact: "After completing the quiz, a thank-you page will be displayed.",
      cformActionAfterContactOffers: "Results page",
      addOfferPageInContact: "Enable results page",
      offerPageHeader: "Header for the offers page",
      pumkinOrange: "Orange",
      invalidSocialNetworkURL: "Invalid link", 
      itMustBeFullLink: 'Please check the entered link. It must start with the protocol "https://" and match the stored social network.',
      addSocialLinks: "Add social links",
      questionAttachAddImg: "Add Photo",
      questionAttachAddVideo: "Add Video",
      questionChooseLineInput: "Line input",
      questionChooseClassicInput: "Classic input",
      questionChooseOneColumn: "1 column",
      questionChooseTwoColumns: "2 columns",
      allStepsVideoUrl: "Video link",
      allStepsPhotoHeader: "Photo",
      cintegrationMenuSalesDrive: "SalesDrive",
      csettingsIntegrationSalesDrive: "Integration - SalesDrive",
      csettingsIntegrationSalesDriveAbout: "You can send leads to the SalesDrive CRM",
      cintegrationSalesDriveApiKey: "Insert API key",
      cintegrationSalesDriveDomain: "Insert the domain provided by SalesDrive",
      cintegrationSalesDriveDataSaved: "SalesDrive integration saved",
      send_offers: "Send offers shown to the visitor",
      cformShowConsultant: "Show consultant",
      consultantPhoto: "Consultant's photo",
      consultantName: "Consultant's name",
      consultantJobTitle: "Consultant's position or other information",
      consultantRating: "Consultant's rating",
      signinIWouldLikeReciveEmail: "I would like to receive news and special offers from ADS QUIZ (You may unsubscribe from these communications at any time).",
      acceptedFileSizeUpTo: "up to",
      customDesignColorTags: "Tags",
      customDesignColorActiveButton: "Active element color",
      customDesignColorInactiveButton: "Inactive element color",
      customDesignColorActiveText: "Active text color",
      customDesignColorInactiveText: "Inactive text color",
      addNewSectionDropdown: "Dropdown",
      langFR: "French",
      addNewSectionRatePage: "Rate Page",
      bold_adsquiz_Offers_page: "adsquiz_Open-Offers-Page",
      cintegrationFBInstructionTextOffersPage: "Go to the offers page",
      defaultNewQuestionDropdownPlaceholder: "Click here to open the list of options",
      allStepsVideoUrlPlaceholder: "https://youtube, vimeo or wistia",
      addListOfAnswersButton: "Add multiple",
      addListOfAnswersTitle: "Bulk add answer options",
      addListOfAnswersInstruction: "Paste the list of answer options into this field to add them. Options can be separated by line breaks [↵], semicolons [;], commas [,], or spaces [ ]. Splitting occurs by the separator with the highest priority: [↵] → [;] → [,] → [ ].",
      addListOfAnswersPlaceholder1: "Answer 1",
      addListOfAnswersPlaceholder2: "Answer 2",
      addListOfAnswersSendButton: "Add",
      addNewPerson: "Add participant",
      cfirstGradientOverlay: "Gradient background overlay",
      cfirstGradientOverlayTip: "A gradient background overlay is helpful if your background image lacks strong contrast with the text color.",
      cfirstContentBorder: "Content divider border",
      workboardDuplicateToOthers: "Copy to another account",
      workboardDuplicateAndTransferQuiz: "Duplicate quiz to another account",
      workboardDuplicateAndTransferQuizHintTitle: "When duplicating a quiz, it will be duplicated to the recipient's account as a template.",
      workboardDuplicateAndTransferQuizHintTitleSecond: "The quiz on the recipient's account will be clean, without leads or integrations. The current quiz will remain unchanged. To copy a quiz to another account, one of the users must have any ",
      workboardDuplicateAndTransferQuizConfirm: "Duplicate",
      workboardDuplicateAndTransferQuizStatus200: "Quiz successfully copied to account:",
      delOffersPageQuestionForModalConfirm: "Are you sure you want to delete the offers page?",
      offerPageDefaultDescription: "Enter the description of the results page here",
      offerPageDefaultButtonText: "Finish",
      cintegrationMenuKommo: "Kommo",
      csettingsIntegrationKommo: "Integration - Kommo",
      csettingsIntegrationKommoAbout: "You can send leads to the Kommo CRM",
      cintegrationKommoToken: 'Insert "Long-lived Token"',
      cintegrationKommoDomain: "Insert your subdomain",
      cintegrationKommoDataSaved: "Kommo integration saved",
      cintegrationKommoPipelineId: "Insert PipelineID",
      cintegrationKommoPipelineIdPlaceholder: "Select Pipeline",
      cintegrationKommoStatusID: "Insert StatusID",
      cintegrationKommoStatusIDPlaceholder: "Select new lead status (optional)",
      cintegrationKommoTagId: "Insert TagID",
      cintegrationKommoTagIdPlaceholder: "Select tag for new lead (optional)",
      cintegrationKommoError: "Error saving Kommo integration. Please check the entered data.",
      cintegrationKommoDeleted: "Kommo integration deleted",
      cintegrationKommoDeletedError: "Error deleting Kommo integration. Please try again later.",
      cintegrationKommoCreateNote: "Create a note with responses",
      cintegrationKommoUseMapping: "Use field mapping",
      mappingValue: "Field in CRM",
      mappingValueMailchimp: "Mailchimp Field",
      mappingKey: "Field in lead",
      addMappingRow: "Add field link",
      DELETE: "Delete",
      mappingAnswer: "Answer to question",
      testIntegration: "Test",
      testIntegrationLast10Leads: "Integration test (last 10 leads)",
      testIntegrationNeedRealLeadTooltip: "Test is available only if the quiz has at least one real lead.",
      loading: "Loading...",
      sentAt: "Sent",
      phone: "Phone",
      email: "Email",
      action: "Action",
      send: "Send",
      sending: "Sending...",
      success: "Success",
      failed: "Failed",
      error: "Error",
      displayCondition: "Display condition",
      selectDisplayCondition: "Select display condition",
      seconds: "Seconds",
      button: "Button",
      buttonContainerSelector: "Button container selector",
      buttonContainerSelectorPlaceholder: ".quiz-buttons or #quiz-button-place",
      clickHere: "Click here",
      buttonClick: "Button click",
      clickOnWidget: "Click on widget",
      exitIntent: "On page exit",
      pageLoad: "After page load",
      delay: "After a delay",
      resultPageSectionTitle: "Results by score",
      resultPageSectionAccordion: "Results page by score",
      resultPageShowCondition: "Show condition",
      resultPageShowCollectedPoints: "Show collected points",
      resultPageShowMaxPoints: "Show maximum points",
      resultPageShowProgressBar: "Show progress bar",
      resultPageSelectFormat: "Select result format",
      resultPageScenarios: "Scenarios",
      resultPageAddScenario: "Add scenario",
      resultPageScenarioPhoto: "Add photo",
      resultPageScenarioTitle: "Title",
      resultPageScenarioTitlePlaceholder: "Enter scenario title",
      resultPageScenarioDescription: "Description",
      resultPageScenarioDescriptionPlaceholder: "Enter scenario description",
      resultPageScenarioUrlPlaceholder: "URL (https://)",
      resultPageScenarioButtonText: "Button text",
      resultPageScenarioButtonTextPlaceholder: "Enter button text",
      resultPagePointsCondition: "Display condition by points",
      resultPagePointsBetween: "Between",
      resultPagePointsMoreThan: "More than",
      resultPagePointsLessThan: "Less than",
      resultPagePointsEqual: "Equal to",
      resultPageErrorAddNewScenario: "Failed to add new scenario",
      resultPageErrorRangeExplanation: "Please add more points or redistribute them across scenarios",
      resultPageErrorFullRange: "All score ranges are already covered",
      resultPageErrorOutOfRange: "Scenario points are outside the allowed range",
      resultPageErrorSaving: "Error saving scenarios",
      resultPageErrorOverlap: "Scores in scenarios must not overlap",
      resultPageAutoRedirectWarningTitle: "Auto redirect disabled",
      resultPageAutoRedirectWarningText: "To enable auto redirect, add a URL to every result scenario.",
      resultPageAutoRedirectWarningButton: "OK",
      AddTags: "Add tags",
      resultPageModalDescription: "Assign points to each answer",
      resultPageYourOptions: "Your options",
      placeholderDefaultValue: "Value",
      resultPageByPointsTitle: "Results by points",
      resultPageConditionSettingsButton: "Points logic",
      resultPageConditionSettingsSaved: "Saved",
      resultPageConditionSettingsUnsaved: "Save",
      resultPagePlaceholderScenarioTitle: "Scenario title",
      resultPagePlaceholderScenarioDescription: "Here you can enter a short description of the results",
      resultPageLabelScenarioCti: "Call to action",
      resultPagePlaceholderScenarioCti: "Button text",
      resultPagePlaceholderScenarioUrl: "Button link",
      resultPagePlaceholderRedirectUrl: "Redirect URL",
      resultPageScenarioSaveChanges: "Save changes",
      resultPageScenarioSaveChangesComplete: "Changes saved",
      resultPageConditionSettingsTitle: "Results settings by points",
      resultPageConditionSettingsDescription: "Set a score range for each scenario",
      resultPageConditionResultsColumn: "Results",
      resultPageConditionRangeSummary: "Maximum score range:",
      addNewSectionSubHeaderChoise: "Answer input/selection",
      addNewSectionSubHeaderResults: "Results",
      noTeamRole: "-",
      viewerTeamRole: "Viewer",
      noAccessTeamRole: "No actions",
      editorTeamRole: "Editor",
      managerTeamRole: "Manager",
      adminTeamRole: "Admin",
      teamRoleGuideTitle: "What roles mean",
      teamRoleGuideDescription: "A role automatically enables a permission set. After selection, the role updates in the UI immediately, and Send submits the selected access.",
      teamRoleGuideFlowOwner: "Owner",
      teamRoleGuideFlowOwnerText: "grants access",
      teamRoleGuideFlowRole: "Role",
      teamRoleGuideFlowRoleText: "selects preset",
      teamRoleGuideFlowPermissions: "Permissions",
      teamRoleGuideFlowPermissionsText: "enable actions",
      teamRoleGuideFlowResult: "Available UI",
      teamRoleGuideFlowResultText: "opens controls",
      teamRoleGuideViewerDescription: "Can view leads and answers for selected quizzes.",
      teamRoleGuideEditorDescription: "Can edit the quiz, copy it, and manage publishing.",
      teamRoleGuideManagerDescription: "Can edit the quiz, view CRM, manage integrations, and share access further.",
      teamRoleGuideAdminDescription: "Gets all permissions: management, integrations, CRM, sharing, transfer, deletion, and publishing.",
      canViewLeadsLabel: "View leads",
      canViewLeadsDescription: "Can view submissions, responses, and contacts",
      canCopyQuizLabel: "Copy quiz",
      canCopyQuizDescription: "Can create copies of the selected quiz",
      canManageQuestionsLabel: "Quiz editing",
      canManageQuestionsDescription: "Can edit the quiz, pages, questions, variants, consultants, benefits, contact fields, social networks, and options",
      canManageIntegrationsLabel: "Integrations",
      canManageIntegrationsDescription: "Can manage integrations, keys, and webhooks",
      canManageSettingsLabel: "Settings",
      canManageSettingsDescription: "Can change domains, pages, and contact fields",
      canShareLabel: "Access",
      canShareDescription: "Can invite other users",
      canTransferLabel: "Quiz transfer",
      canTransferDescription: "Can transfer the quiz to another user",
      canDeleteLabel: "Deletion",
      canDeleteDescription: "Can delete and restore the quiz",
      canPublishLabel: "Publishing",
      canPublishDescription: "Can manage publishing and domains",
      descriptionTeamView: "Add members and configure access to projects and quizzes",
      addedUserInTeam: "In team",
      teamAccessGivenTab: "Team members",
      teamAccessReceivedTab: "Access source",
      teamAccessReceivedTitle: "Access source",
      teamAccessSharedBy: "Owner",
      teamAccessInvitedBy: "Shared by",
      teamAccessRoleLabel: "Role",
      teamAccessScopeLabel: "Access",
      teamNoReceivedAccess: "No one has given you access yet",
      teamNoGivenAccess: "You have not given access to anyone yet",
      teamAccessFrozen: "Access frozen",
      teamFreezeAccess: "Freeze access",
      teamUnfreezeAccess: "Unfreeze access",
      teamPermissionDeniedTransfer: "You do not have permission to move this quiz",
      teamPermissionDeniedDelete: "You do not have permission to delete or restore this quiz",
      teamPermissionDeniedShare: "You do not have permission to manage sharing",
      teamPermissionDeniedManageQuiz: "You do not have permission to edit this quiz",
      teamPermissionDeniedCopy: "You do not have permission to copy this quiz",
      teamPermissionDeniedIntegrations: "You do not have permission to manage integrations",
      teamPermissionDeniedCrm: "You do not have permission to view CRM",
      teamPermissionDeniedPublish: "You do not have permission to publish this quiz",
      teamPermissionDeniedSettings: "You do not have permission to open this settings section",
      teamPermissionDeniedOpenQuiz: "You do not have available actions for this quiz",
      teamAccessDeniedTitle: "Section unavailable",
      teamAccessDeniedDescription: "You do not have permission for this action. Ask the project owner to grant access",
      teamPermissionDeniedDefault: "You do not have permission for this action",
      teamQuizzesWithoutProject: "Quizzes without project",
      quickInviteTitle: "Invite a team member",
      quickInviteEmailLabel: "Email",
      quickInviteQuizzesLabel: "Quizzes to share",
      quickInviteLoadingQuizzes: "Loading quizzes…",
      quickInviteLoadQuizzesError: "Couldn't load your quizzes.",
      quickInviteRetry: "Retry",
      quickInviteNoQuizzes: "You have no quizzes you can share yet.",
      quickInviteRoleHint: "They’ll get the selected role in the selected quizzes. You can change it later on the {link}.",
      quickInviteRoleHintLink: "Team page",
      quickInviteSubmit: "Invite",
      quickInviteSubmitting: "Sending…",
      quickInviteSelfError: "You can't invite yourself",
      quickInviteSelectQuiz: "Select at least one quiz",
      quickInviteSuccess: "Invitation sent to {email}",
      projectNoQuizzes: "0 quizzes",
      quizzes: "quizzes",
      sharedQuizzes: "Shared quizzes",
      sharedQuizzesWithoutProject: "Quizzes without project",
    },
    RU: {
      tariffLockBadgeLabel: "Pro",
      tariffLockBadgeReadOnlyLabel: "Только чтение",
      tariffLockBadgeQuotaLabel: "Лимит достигнут",
      tariffLockBadgeAriaLabel: "{label}: функция ограничена вашим тарифом",
      tariffUpgradeActionLabel: "Улучшить тариф",
      tariffLockBadgeOwnerAriaLabel: "{label}: функция ограничена тарифом владельца квиза",
      tariffLockBadgeOwnerUnverifiedLabel: "Тариф не проверен",
      tariffLockBadgeOwnerUnverifiedAriaLabel: "{label}: не удалось проверить тариф владельца квиза",
      tariffOwnerPlanFeatureUnavailableMessage: "Эта функция недоступна на тарифе владельца квиза. Попросите владельца перейти на тариф, который её поддерживает.",
      tariffOwnerAccessUnavailableMessage: "Не удалось проверить тариф владельца квиза. Обновите страницу.",
      tariffGateCollaborationForbiddenMessage: "У вас нет прав для этого действия в этом квизе.",
      tariffGateQuotaExhaustedMessage: "Вы использовали лимит, доступный на текущем тарифе. Перейдите на тариф с большим лимитом.",
      tariffGateGrandfatheredMessage: "Эта функция недоступна на вашем текущем тарифе. Существующие данные остаются видимыми и могут быть удалены, но добавление и редактирование отключены. Перейдите на тариф, который её поддерживает.",
      tariffGateReadOnlyMessage: "Эта функция недоступна на вашем текущем тарифе и показана в режиме только чтения. Перейдите на тариф, который её поддерживает.",
      tariffGateUsageUnavailableMessage: "Не удалось определить использование этой функции. Попробуйте обновить страницу.",
      tariffGateLoadingMessage: "Проверяем доступ по вашему тарифу…",
      tariffGateUnavailableMessage: "Эта функция недоступна на вашем текущем тарифе. Перейдите на тариф, который её поддерживает.",
      tariffUpgradeModalDescription: "Выберите тариф, который поддерживает эту функцию.",
      tariffUpgradeModalLoading: "Загрузка подходящих тарифов…",
      tariffUpgradeModalError: "Не удалось загрузить подходящие тарифы. Попробуйте снова.",
      tariffUpgradeModalEmpty: "Годовые подписки появятся в ближайшее время.",
      tariffUpgradeModalRecommended: "Рекомендуемый",
      tariffUsageUnlimitedLabel: "Безлимитно",
      tariffUsageUsedOfLimitLabel: "Использовано {used} из {limit}",
      tariffUsageUnavailableLabel: "Использование недоступно",
      tariffUsageLoadingLabel: "Загрузка использования…",
      tariffUsageUnknownLabel: "Использование неизвестно",
      notFoundEyebrow: 'Страница не найдена',
      notFoundTitle: 'Кажется, этот квиз потерялся',
      notFoundDescription: 'Ссылка может быть неправильной или страницу уже переместили. Вернитесь на рабочую доску и продолжайте создавать квизы.',
      notFoundPrimaryAction: 'На главную',
      notFoundSecondaryAction: 'Назад',
      serverErrorEyebrow: 'Ошибка сервера',
      serverErrorTitle: 'Что-то пошло не так',
      serverErrorDescription: 'Не переживайте, мы уже занимаемся этим. Попробуйте обновить страницу или вернитесь на рабочий стол.',
      serverErrorPrimaryAction: 'Обновить страницу',
      serverErrorSecondaryAction: 'На главную',
      madeInUkr: "made in Ukraine",
      upProVersion: "Перейти на PRO",
      getLeads: "Купить Лиды",
      poperBillings: "Платежи",
      poperTemplates: "Шаблоны",
      poperPartnership: "Партнерская программа",
      poperProfile: "Профиль",
      poperLogout: "Выход",
      poperTeam: "Команда",
      teamDelegatedAccessTitle: 'Передал доступ дальше',
      teamAccessTreeRootLabel: 'Источник доступа',
      teamAccessVia: 'через',
      teamNoQuizNamesAvailable: 'Названия квизов недоступны',
      teamSharedShareTargetPrefix: 'Расшарено от',
      teamSharedOwnerFallback: 'владелец',
      teamMembersTab: 'Кому я дал доступ',
      teamAccessSourceTab: 'Кто дал доступ мне',
      teamAccessSourceTitle: 'Кто дал доступ мне',
      teamAccessTreeTab: 'Цепочки доступа',
      teamAccessTreeTitle: 'Цепочки доступа',
      teamAccessTreeDescription: 'Показывает путь доступа: владелец → кто пригласил → вы → кому вы передали доступ дальше',
      teamAccessOwnerLabel: 'Владелец',
      teamAccessInviterLabel: 'Предоставил доступ',
      teamAccessPath: 'Цепочка доступа',
      teamAccessYouLabel: 'вы',
      teamSharedByYou: 'Предоставили вы',
      teamCanReshare: 'Может делиться дальше',
      teamCannotReshare: 'Не может делиться дальше',
      teamPartialReshare: 'Частично может делиться',
      teamMixedRoles: 'Смешанные роли',
      teamNoAccessTree: 'Цепочки появятся, когда вы передадите доступ дальше',
      poperIdea: "Предложить идею",
      poperIdeaTitle: "Есть идея для улучшения платформы?",
      poperIdeaText: "Поделитесь ею с нами! Ваши предложения помогают нам развиваться и создавать лучший опыт для вас.",
      poperIdeaTextPlaceholder: "Подробно опишите свою идею",
      poperIdeaSendButton: "Отправить предложение",
      defaultNewQuestion: "Новый вопрос",
      defaultNewQuestionDescription: "Сюда можно вставить краткое описание вопроса (до 80 символов)",
      defaultNewVariant: "Новый вариант",
      defaultBtnText: "Начать",
      navBillings: "Платежи",
      navPartnership: "Партнерская программа",
      navProfile: "Профиль",
      navTariffs: "Тарифы",
      holidayBannerTitleLastOffer: "Финальное предложение года:",
      holidayBannerDefaultTitle: "Ограниченное предложение",
      holidayBannerFrom: "с",
      holidayBannerTo: "по",
      holidayBannerCta: "Получить скидку",
      holidayBannerAuthTitle: "Войдите, чтобы получить скидку",
      holidayBannerAuthText: "Авторизуйтесь, чтобы применить это предложение и сохранить его за вашим аккаунтом.",
      holidayBannerAuthAction: "Понятно",
      holidayBannerClose: "Закрыть баннер",
      welcomeBack: "С возвращением!",
      loginHeader: "Войти",
      loginHeader2Part: "чтобы продолжить",
      loginEmailPlaceholder: "E-mail",
      loginPasswordlPlaceholder: "○ ○ ○ ○ ○ ○ ○ ○ ○",
      loginBtnValue: "Войти",
      loginWith: "Войти с помощью",
      loginSignup: "Регистрация",
      passwordAreForgetPassword: "Забыли пароль?",
      passwordResetPasswordHeader: "Восстановление пароля",
      passwordResetPassword: "Восстановить пароль",
      passwordWeSentReset: "Мы отправили вам ссылку на восстановление пароля по электронной почте.",
      passwordInputNewPassword: "Введите новый пароль",
      passwordConfirmPassword: "Подтвердите пароль",
      passwordCreatePassword: "Создайте пароль",
      passwordChangePassword: "Изменить пароль",
      passwordResetedPasswordCompleted: "Ваш пароль успешно изменен!",
      passwordGoToWorkboard: "Перейти в акаунт",
      helloHeader: "Здравствуйте!",
      signupHeader: "Зарегистрироваться",
      signupHeader2Part: "чтобы продолжить",
      signupNamePlaceholder: "Александр",
      signupPhonePlaceholder: "номер телефона",
      signupEmailPlaceholder: "E-mail",
      signupPasswordlPlaceholder: "○ ○ ○ ○ ○ ○ ○ ○ ○",
      signupBtnValue: "Создать аккаунт",
      signupWith: "Регистрация с помощью",
      signupLogin: "Войти в мой аккаунт",
      signupTariffHeader: "Тарифы",
      signupTariffFree: "Free.",
      signupTariffPro: "Pro.",
      signupTariffFreeDescription: "Безлимитное количество новых квизов (веб страниц). Возможность генерировать до 300 заявок в месяц бесплатно.",
      signupTariffProPrice: "$20/месяц",
      signupTariffProDescription: "Безлимитное количество новых квизов (веб страниц). Возможность генерировать",
      signupTariffProDescriptionBold: "более 300 заявок в месяц бесплатно.",
      userBackToQuiz: "Вернуться на воркборд",
      userBackToSettings: "Вернуться к настройкам",
      learningCenterTitle: "Учебный центр",
      learningCenterTraining: "Обучение",
      learningCenterIntroText: "Посмотрите все обязательные видеогайды по порядку, подтвердите каждый урок после завершения и запросите сертификат после финального урока.",
      learningCenterVideoUnsupported: "Ваш браузер не поддерживает HTML5 видео.",
      learningCenterAvailable: "Доступно",
      learningCenterLessonsComplete: "Уроков завершено",
      learningCenterBackToLearningCenter: "Вернуться в Learning center",
      learningCenterCertificate: "Сертификат",
      learningCenterCourseCompleted: "Курс завершен",
      learningCenterCertificateSentText: "Все уроки завершены. Запрос на сертификат отправлен на бекенд.",
      learningCenterCertificateLabel: "Adsquiz Learning Center",
      learningCenterCertificateOfCompletion: "Сертификат о завершении",
      learningCenterDownloadCertificate: "Скачать сертификат",
      learningCenterDownloadUnavailable: "Скачивание пока недоступно",
      learningCenterOpenCertificate: "Открыть сертификат",
      learningCenterAbout: "Об уроке",
      learningCenterOpenFallbackLink: "Открыть резервную ссылку",
      learningCenterBack: "Назад",
      learningCenterCompleted: "Завершено",
      learningCenterWatchVideoToEnd: "Посмотрите видео до конца",
      learningCenterSaving: "Сохранение...",
      learningCenterMarkAsCompleted: "Отметить как завершенное",
      learningCenterWatchedPercent: "{percent}% просмотрено",
      learningCenterDefaultUserName: "Пользователь Adsquiz",
      learningCenterCertificateReadyMessage: "Бекенд вернул файл сертификата. Используйте кнопку выше, чтобы открыть его.",
      learningCenterCertificatePendingMessage: "Запрос на сертификат отправлен. Добавьте URL для загрузки с бекенда, когда он будет доступен.",
      learningCenterCertificateNoUrlMessage: "Запрос на сертификат выполнен, но URL файла еще не вернулся.",
      learningCenterCertificateErrorMessage: "Пока не удалось подтвердить запрос на сертификат через бекенд. Локальное завершение сохранено.",
      learningCenterSectionGeneral: "Общие",
      learningCenterSectionIterationsIntro: "Вступление к итерациям",
      learningCenterSectionIterationIntro: "Вступление к итерации",
      billingYourTariff: "Ваш план",
      billingYourTariffShortForm: "Ваш план",
      billingYourPro: "Pro",
      billingYorFree: "Free",
      billingFreeLeads: "Бесплатных заявок",
      billingInfinity: "безлимит",
      billingTariffRenewData: "Дата обновлення тарифа",
      billingTariffEndData: "Дата окончания тарифа",
      billingOtherTariffFree: "Free.",
      billingOtherTariffPro: "Pro.",
      billingTariffFreeDescription: "Безлимитное количество новых квизов (веб страниц). Возможность генерировать до 300 заявок в месяц бесплатно.",
      billingYouHavePro: "Теперь вы на Pro версии. Зачем делать шаг назад?",
      billingYouHasFreeLeads: "Бесплатных заявок",
      billingYouHasLeads: "Осталось заявок",
      billingTariffProDescription: "Безлимитное количество новых квизов (веб страниц). Возможность генерировать ",
      billingTariffProDescriptionBold: "более 300 заявок.",
      billingYourFutureTariff: "Ваш будущий тариф",
      billingBtnChangeToPro: "Перейти",
      billingBtnRenewPro: "Обновить",
      billingBillings: "Оплаты",
      billingYouHaveNotBillings: "У вас пока нет оплат",
      billingPaymentsMethod: "Способ оплаты",
      billingPaymentCard: "Карта",
      billingChangeData: "Изменить данные",
      billingDeletePayMethod: "Удалить",
      billingModalDeleteShure: "Вы действительно хотите удалить этот способ оплаты?",
      billingModalDeleteCancel: "Отменить",
      billingModalDeleteOk: "Удалить",
      billingModalDeleteSuccess: "Вы успешно удалили свою карту",
      billingModalRegularPaymentDeleteSuccess: "Регулярные платежи отменены",
      billingModalRegularPaymentDeleteOk: "ОК",
      billingYourMonthPlan: "Ваш ежемесячный план",
      billingLeads: "заявок",
      billingChangePlan: "Изменить план",
      billingChangePlanDescription: "Прайс будет соответствующим к желаемому количеству заявок со всех квизов в вашом аккаунте.",
      billingSelectPeriod: "Выбрать период",
      billingChangePlanDescriptionImportant: "Важно:",
      billingChangePlanDescriptionImportantMonth: "Лиды можно использовать 1 месяц после покупки.",
      subscriptionTariffLable: "Подпишитесь на нашу автоматическую подписку.",
      billingChangePlanWarning: "",
      billingTariffMonth: "мес.",
      billingChangePlanPay: "Купить",
      profileName: "Имя",
      profilePhone: "Номер телефона",
      profileEmail: "E-mail",
      profileStatus: "Статус",
      profileStatusAgency: "Агенство",
      profileStatusPlaceholder: "Что описывает вас лучше всего?",
      profileStatusFreelancer: "Фрилансер",
      profileStatusBuisines: "Владелец бизнеса",
      profilePassword: "Password",
      profileChangePassword: "Изменить пароль",
      profileNewPassword: "Новый пароль",
      profileSaveNewData: "Обновить данные",
      workboardStartTooltip: "Здесь вы можете создать ваш первый квиз",
      workboardAddNewQuiz: "Создать проект",
      workboardModalGiveQuizName: "Дайте название квиза",
      workboardModalQuizNamePlaceholder: "Новый квиз",
      workboardModalNewQuizBtnValue: "добавить",
      workboardAlertGiveAnyName: "Введите хотя бы какое-нибудь название",
      workboardAlertNextTimeAddQuiz: "Что ж, в следующий раз решитесь)",
      workboardChangeQuizName: "Сменить название",
      workboardQuizLink: "ссылка",
      workboardQuizLinkCopied: "Ссылка скопирована в буфер",
      workboardEditQuiz: "Редактировать",
      workboardCopyQuiz: "Скопировать квиз",
      workboardQuizCopied: "Квиз успешно скопирован",
      workboardDeleteQuiz: "Удалить",
      workboardTransferQuizPlaceholderInput: "Введите адрес электронной почты пользователя",
      workboardTextAllQuizes: "Все квизы",
      workboardTextProjects: "Проекты",
      workboardTransferQuiz: "Перенести квиз на другой аккаунт",
      workboardTransferProject: "Добавить в проект",
      workboardTransferQuizCancel: "Отмена",
      workboardTransferQuizLabel: "Название квиза",
      workboardTransferQuizTitle: "Проверьте свои знания об охране окружающей среды!",
      workboardTransferQuizHintTitle: "При переносе квиза все заявки будут перенесены вместе с ним.",
      workboardTransferQuizHintTitleSecond: "Чтобы перенести квиз с заявками, один из пользователей должен иметь любой ",
      workboardTransferQuizHintTitleSecondLink: "https://app.adsquiz.io/tariffs",
      workboardTransferQuizHintTitleSecondLinkText: "платный пакет.",
      workboardTransferQuizConfirm: "Перенести",
      workboardTransferQuizNoValidEmail: "Неверный адрес электронной почты",
      workboardTransferQuizStatus200: "Квиз успешно перенесен на:",
      workboardTransferQuizStatus401: "Неавторизованно — Пользователь не аутентифицирован.",
      workboardTransferQuizStatus403: "Запрещено — У вас нет доступа для переноса этого квиза.",
      workboardTransferQuizStatus404: "Не найдено — Квиз или пользователь-получатель не найден.",
      workboardTransferQuizStatus422: "Необрабатываемый объект — По крайней мере, один из пользователей должен иметь платный аккаунт.",
      workboardTransferQuizStatusError: "Неожиданный статус ошибки",
      workboardModalRemoveQuizTrash: "Этот квиз будет перемещён в корзину и удалён окончательно через 1 месяц.",
      workboardModalRemoveQuizSure: "Вы уверены, что хотите переместить этот квиз в корзину?",
      workboardModalRemoveProjectTrash: "Проект и все его квизы будут полностью удалены.",
      workboardModalRemoveProjectSure: "Вы уверены, что хотите удалить этот проект?",
      workboardModalDeleteQuizCancel: "Отменить",
      workboardModalDeleteQuizDelete: "Удалить",
      workboardModalDeleteQuizSuccess: "Квиз успешно удалён",
      workboardModalDeleteProjectSuccess: "Проект успешно удалён",
      workboardModalQuizDeleteOk: "ОК",
      workboardStatsTitle: "Статистика",
      workboardModalLeadsAnswersCount: "Ответы на квиз",
      workboardModalLeadsLeadSerial: "№",
      workboardModalLeadsLeadDate: "Дата",
      workboardModalLeadsLeadEmail: "Email",
      workboardModalLeadsLeadName: "Имя",
      workboardModalLeadsLeadPhone: "Телефон",
      workboardModalLeadsLeadPoints: "Баллы",
      workboardModalLeadsLeadActions: "Действия",
      workboardModalLeadsLeadShowMore: "Показать больше",
      workboardModalLeadsLeadHideMore: "Скрыть",
      workboardModalLeadsLeadAnswerScipped: "Пропущено",
      workboardModalNoLeads: "Пока заявок нет",
      constructorLink: "ссылка",
      constructorLinkCopied: "Скопировано в буфер обмена:",
      constructorNavSteps: "Шаги",
      constructorNavDesign: "Дизайн",
      constructorNavSettings: "Настройка",
      constructorStep: "Шаг",
      cancel: "Отменить",
      constructorCancel: "Отменить",
      constructorSave: "Сохранить",
      constructorextraNavStart: "С",
      constructorextraNavContact: "К",
      constructorextraNavFinish: "Ф",
      cstepsSection: "Секции",
      cstepsStartPage: "Стартовая страница",
      cstepsContactPage: "Форма контактов",
      cstepsFinishPage: "Финишная страница",
      cstepsEdit: "Редактировать",
      cstepsMove: "Переместить",
      cstepsDeleteStep: "Удалить шаг",
      cstepsAddSection: "Добавить секцию",
      cdesignColorTheme: "Цветовая схема",
      cdesignCustomTheme: "Пользовательская цветовая схема",
      cdesignDefaultThemes: "Готовые цветовые схемы",
      cdesignThemeStandart: "Стандарт",
      cdesignThemeDark: "Дарк",
      cdesignThemeNud: "Нюд",
      cdesignThemeGradient: "Градиент",
      cdesignShapeDesign: "Форма дизайна",
      cdesignShapeRound: "Закругленная",
      cdesignShapeSquare: "Угловая",
      cdesignShapeRectangle: "Прямоугольник",
      cdesignShapeCircle: "Круг",
      cdesignPositionLeft: "Слева",
      cdesignPositionMiddle: "По центру",
      cdesignPositionRight: "Справа",
      cdesignPositionTop: "Сверху",
      cdesignPositionBottom: "Снизу",
      csettingsIntegration: "Интеграция",
      csettingsOweDomain: "Подключение личного домена",
      csettingsDocs: "Юридические документы",
      cintegrationIntegration: "Интеграция",
      cintegrationShareLeads: "Передача заявок",
      cintegrationTitleEmail: "E-MAIL",
      cintegrationInstruction: "Инструкция",
      cintegrationInstructionDetail: "Детали",
      cintegrationEmailInstruction: "Вставьте в поле снизу нужную электронную почту, на которую необходимо отправлять информацию. Каждая заявка с этого квизу будет дублироваться на указанную вами почту.",
      cintegrationPublishAfterEdit: "Сохраните квиз после редактирования",
      cintegrationSendNewLeadsTo: "Отправлять сообщения о новых заявках на:",
      cintegrationInputEmail: "Введите адрес электронной почты",
      cintegrationAddEmail: "Добавить email",
      cintegrationEmailSaved: "Данные Email интеграции сохранены",
      cintegrationEmailDeleted: "Данные Email интеграции удалены",
      cintegrationTitleFB: "FB pixel",
      cintegrationIDPixel: "Pixel ID",
      cintegrationFBInstruction1: "Зайдите в рекламный кабинете Facebook Ads и в разделе Event Manager скопируйте ID Facebook Pixel. ",
      cintegrationFBInstruction2: "Не копируйте весь код, только идентификатор из 15-16 цифр. ",
      cintegrationFBInstruction3: "Скопируйте и вставьте в поле ниже.",
      cintegrationFBInstruction: 'Событие, на которое нужно настраивать конверсию это "Lead". Это событие будет вызвано как только пользователь отправит заявку в квизе.',
      cintegrationFBInstructionTextTitle: "Название событий для FB Conversions:",
      cintegrationFBInstructionTextTextStart: " – посещение стартовой страницы;",
      cintegrationFBInstructionTextQuestionN: " – посещение шага N",
      cintegrationFBInstructionTextOpenContactPage: " – посещение страницы контактов;",
      cintegrationFBInstructionTextLead: " – успешная отправка формы с контактными данными;",
      cintegrationFBInstructionTextThankYou: " – посещение финальной страницы.",
      bold_adsquiz_Start: "adsquiz_Start",
      bold_adsquiz_QuestionN: "Question_N",
      bold_adsquiz_OpenContactPage: "Open_Contact-Page",
      bold_adsquiz_Lead: "Lead",
      bold_adsquiz_ThankYou: "adsquiz_ThankYou",
      cintegrationInputIDPixel: "Введите ID пикселя",
      cintegrationDataFBSaved: "Данные FB пикселя сохранены",
      cintegrationAccesToken: "ACCES TOKEN",
      cintegrationTitleGA: "Google analytics",
      cintegrationGAInstructionDescription: "Узнайте, как люди находят ваш квиз и взаимодействуют с ним.  ",
      cintegrationGAInstruction: 'При получении заявки в квизе, в Google Analitics будет вызвано событие "generate_lead".',
      cintegrationIDFolow: "ID отслеживания",
      cintegrationInputID: "Ввести ID",
      cintegrationDataGASaved: "Данные Google Tag Manager сохранены",
      cintegrationTitleGTM: "Google Tag Manager",
      cintegrationGTMInstructionDescription: "Узнайте, как люди находят ваш квиз и взаимодействуют с ним.  ",
      cintegrationGTMInstruction: "Скопируйте идентификатор Google Tag Manager и вставьте его в поле ниже.",
      cintegrationDataGTMSaved: "Данные Google Tag Manager сохранены",
      cintegrationTitleTG: "Telegram",
      cintegrationHowReciveTGLeadBot: "Как получить заявки в Телеграм?",
      cintegrationTGInstructionBot1: "1. Скопируйте token находящийся в поле ниже.",
      cintegrationTGInstructionBot2: "2. Перейдите по ссылке в бот, нажмите кнопку «СТАРТ».",
      cintegrationTGInstructionBot3: "3. Скопированный token отправьте сообщением в наш бот.",
      cintegrationHowReciveTGLeadChat: "Как получить заявки в чат-телеграм?",
      cintegrationTGInstructionChat1: "1. Разместите наш бот в нужный чат и выставьте боту статус администратора.",
      cintegrationTGInstructionChat2: "2. Скопируйте token в поле ниже и отправьте его в нужный чат.",
      cintegrationTGInstructionChat3: "3. Дождитесь ответа `OK! Your quiz token was saved!”",
      cintegrationTGInstructionChat4: "4. Тепер заявки будут приходить в этот чат.",
      cintegrationTGInstructionWarning: "Важно:",
      cintegrationTGInstructionWarningText: "Обратите внимание, что это должна быть именно группа, а не Telegram канал. В Telegram канал заявки поступать не будут.",
      cintegrationTGBotLink: "ссылка на чатбот",
      cintegrationTGTitleToken: "TOKEN",
      cintegrationInputTGToken: "Введите телеграмм токен чат",
      cintegrationAddIntegration: "Добавить интеграцию",
      cintegrationDataTGSaved: "Данные Telegram интеграции сохранены",
      cintegrationTitleTT: "TT pixel",
      cintegrationTTInstruction: "Для отслеживания событий в рекламном кабинете Tik-Tok Ads, скопируйте идентификатор пикселя и вставьте в поле ниже. ",
      cintegrationDataTTSaved: "Данные TT пикселя сохранены",
      cintegrationTitleWH: "WebHook",
      cintegrationWHInstruction1: "Вы можете уведомлять посторонние приложения о поступивших заявках. Для этого укажите URL, на который будет отправлен WebHook.",
      cintegrationWHInstruction2: "Мы подготовили",
      cintegrationWHInstruction3: "видео инструкцию",
      cintegrationWHInstruction4: "с подробным описанием данного функционала.",
      cintegrationWHInstruction5: "Просмотреть видео.",
      cintegrationWHInstruction6: "В этом видео мы рассмотрим передачу хука на основе отправки данных в Google таблицу и отправку данных в CRM-систему Trello.",
      cintegrationWHInstruction7: "Мы рекомендуем использовать для этих целей сервис",
      cintegrationWHInstruction8: "При регистрации по данной ссылки, для наших пользователей, действуют бонус - 10 000 бесплатных действия для любых интеграций.",
      cintegrationWHInstruction9: "Ссылка",
      cintegrationWHInstruction10: "для регистрации с бонусом.",
      cintegrationWHUrl: "Адреса вебхука",
      cintegrationInputWHUrl: "Введите адрес вебхука",
      cintegrationAddWH: "Добавить Web-hook",
      cintegrationWebHookDataSaved: "WebHook данные сохранены",


      cintegrationComonWHInstructionShort: "Вы можете уведомлять сторонние приложения о поступающих лидах. Укажите URL-адрес вебхука для отправки данных.",
      cintegrationComonWHInstruction1Title: "1. Вставьте URL-адрес вебхука в поле для ввода:",
      cintegrationComonWHInstruction1Description: "Вставьте URL-адрес вебхука, предоставленный вашим сервисом или приложением, в поле для ввода.",
      cintegrationComonWHInstruction2Title: "2. Сохраните изменения:",
      cintegrationComonWHInstruction2Description: 'Нажмите кнопку "Сохранить изменения" для сохранения настроек вебхука.',
      cintegrationComonWHInstruction3Title: "3. Готово:",
      cintegrationComonWHInstruction3Description: "Теперь ваш вебхук настроен для отправки данных на выбранный вами сервис.",
      cintegrationComonWHInstructionAdditional: "Данные будут отправлятся на вебхук при каждом получении лида. Метод отправки POST. Пример данных которые будут отправлены находится ",
      cintegrationComonWHInstructionAdditionalLink: "тут",
      cintegrationComonWHInstructionVideo: "Подробная видео-инструкция",

      cintegrationApixDriveWHInstructionShort: "Вы можете уведомлять ApixDrive о поступающих лидах. Для этого укажите URL-адрес, на который будет отправлен WebHook.",
      cintegrationApixDriveWHInstructionShort1: "При регистрации по ",
      cintegrationApixDriveWHInstructionShort2: "этой ссылке",
      cintegrationApixDriveWHInstructionShort3: " наши пользователи получают бонус - 10 000 бесплатных действий для любых интеграций.",
      cintegrationApixDriveWHInstruction1Title: "Зарегистрируйтесь или откройте ваш акаунт ApixDrive:",
      cintegrationApixDriveWHInstruction1Description1: "Ссылка ",
      cintegrationApixDriveWHInstruction1Description2: "для регистрации с бонусом.",
      cintegrationApixDriveWHInstruction2Title: "Получите URL адрес для вебхука:",
      cintegrationApixDriveWHInstruction2Description1: "Зайдите в настройки необходимой связи и скопируйте адрес для отправки вебхука:",
      cintegrationApixDriveWHInstruction2Description2: 'Вы можете создать новую связь нажав кнопку "Создать связь" и на шаге выбора системы выберите "ADSQuiz".',
      cintegrationApixDriveWHInstruction3Title: "Вставьте URL-адрес вебхука:",
      cintegrationApixDriveWHInstruction3Description: "Вставьте URL-адрес вебхука, предоставленный ApixDrive, в поле для ввода.",
      cintegrationApixDriveWHInstruction4Title: "Сохраните изменения:",
      cintegrationApixDriveWHInstruction4Description: 'Нажмите кнопку "Сохранить изменения" для сохранения настроек вебхука.',
      cintegrationApixDriveWHInstruction5Title: "Готово:",
      cintegrationApixDriveWHInstruction5Description: "Теперь ваш вебхук настроен для отправки данных на ApixDrive.",
      cintegrationApixDriveWHInstructionAdditional: "Данные будут отправлятся на вебхук при каждом получении лида. Метод отправки POST. Пример данных которые будут отправлены находится ",
      cintegrationApixDriveWHInstructionAdditionalLink: "тут",
      cintegrationApixDriveWHInstructionVideo: "Подробная видео-инструкция",



      cintegrationConnectOweDomain: "Подключение личного домена",
      cintegrationOweDomainInstruction1: "1. Чтобы разместить ваш квиз на необходимом домене, зайдите в аккаунт вашего хостинга. Выделите DNS-настройки и создайте A-запись с параметром IP: 185.25.117.21",
      cintegrationOweDomainInstruction2: "2. Укажите домен в поле выше и сохраните квиз.",
      cintegrationDomain: "Домен",
      cintegrationInputYourDomain: "Введите ваш домен",
      cintegrationCheckDomenIsCorrect: "Проверьте правильность введенного домена",
      cintegrationDomainWhichCorrect: "Введите домен без протоколов. Например: some.site.com",
      cintegrationInsertedDefaultDomain: "Домен установлен по умолчанию",
      cintegrationDomainDataSaved: "Данные домена сохранены",
      cintegrationPrivacyPolicy: "Политика конфиденциальности",
      cintegrationPrivacyPolicyByDefault: "По умолчанию мы используем нашу стандартную политику конфиденциальности. Мы рекомендует добавить вашу политику конфиденциальности, которая будет актуальна для вашего бизнеса. ",
      cintegrationPrivacyPolicyAdventage: "Это даст понять вашим потенциальным клиентам как вы используете полученные контактные данные. Также этого требуют некоторые рекламные площадки.",
      cintegrationPrivacyPolicyUrl: "Ссылка на документы",
      cintegrationPrivacyPolicyInputYourDocsLink: "Вставте ссылку на документы",
      cintegrationDocsDataSaved: "Ссылка на ваши документы сохранена",
      allstepsUpploadPhoto: "Загрузить фото",
      unsplashSelectorButtonText: "Выбрать из Unsplash",
      unsplashSelectorTitle: "Загрузить изображение",
      unsplashSelectorDragImage: "Перетащите изображение сюда или",
      unsplashSelectorUploadFile: "загрузите файл",
      unsplashSelectorSearchPlaceholder: "Поиск изображения на Unsplash",
      unsplashSelectorLoadingImages: "Загрузка изображений...",
      unsplashSelectorLoadingMoreImages: "Загрузка дополнительных изображений...",
      unsplashSelectorNoImagesFound: "Изображения не найдены",
      unsplashSelectorUnavailable: "Unsplash сейчас недоступен. Вы можете загрузить файл.",
      unsplashSelectorClose: "Закрыть",
      allstepsChangePhoto: "Изменить фото",
      allstepsDeletePhoto: "Удалить фото",
      allstepsTitle: "Заголовок",
      allstepsDescription: "Описание",
      allstepsButtonText: "Текст кнопки",
      allstepsOtherSettings: "Другие настройки",
      allstepsIsSaveBeforeRoute: "Сохранить данные перед переходом?",
      cfirstFormat: "Формат",
      cfirstHeaderStartText: "Ваш заголовок должен быть здесь. Мотивируйте пользователей пройти тест до конца",
      cfirstAddMediafile: "Добавить медиафайл (фото)",
      cfirstBonus: "Бонус",
      cfirstAddBonus: "Добавить бонус",
      cfirstStartPageDataUpdated: "Данные стартовой страницы обновлены",
      csanyAnswerType: "Тип вопроса",
      csanyATCard: "карта",
      csanyATList: "список",
      csanyATCustom: "свободное поле",
      csanyQuestion: "Вопрос",
      csanyAnswers: "Ответы",
      csanyAddAnswer: "Добавить",
      csanyTitleForModalConfirm: "Это действие необратимо!",
      csanyQuestionForModalConfirm: "Вы уверены, что хотите удалить этот вопрос?",
      csanyRequiredStep: "Обязательный шаг",
      csanyAlowMultiple: "Разрешить несколько ответов",
      csanyAutoRedirect: "Автопереход далее",
      csanyQuestionLogic: "Настройки логики вопросов",
      csanyDataStepUpdated: "Данные страницы с вопросом обновлены",
      cformForm: "Форма",
      cformValueName: "Имя",
      cformValueSurname: "Фамилия",
      cformValuePhone: "Номер телефона",
      cformValueEmail: "E-mail",
      cformDataContactsPageUpdated: "Данные контактной страницы обновлены",
      cformRequiredInput: "Обязательный",
      cfinishFinishPageTitle: "Финишная страница",
      cfinishText: "Текст",
      cfinishDescription: "Описание",
      cfinishAddImage: "Добавить изображение",
      cfinishImageAdded: "Изображение добавлено",
      cfinishURL: "URL",
      cfinishButtonText: "Текст кнопки",
      cfinishInsertNikname: "Вставьте здесь ваш никнейм",
      cfinishCheckDataIsCorrect: "Проверьте правильность введенного идентификатора",
      cfinishFbWhichCorrect: "Введите идентификатор (никнейм) без остального адреса. Нпример: some.name",
      cfinishIgWhichCorrect: "Введите идентификатор (никнейм) без остального адреса. Нпример: some.name",
      cfinishTgWhichCorrect: "Введите идентификатор (никнейм) без остального адреса. Нпример: some.name",
      cfinishFinishPageDataUpdated: "Данные  финишной страницы обновлены",
      adminUsersReg: "Пользователей в системе",
      adminNewUsers: "Новых пользователей за месяц",
      adminProAccounts: "PRO accounts",
      adminLTV: "LTV",
      adminSharePro: "PRO сравнительно со всеми",
      adminReciveLeads: "Получено заявок",
      adminLeadsForOne: "На одного пользователя",
      adminMadeQuiz: "Сделано квизов",
      adminQuizForOne: "На одного пользователя",
      adminAvarageUsed: "Среднее количество месяцев использования",
      adminProfitMonth: "Заработан за месяц",
      adminProfitAlltime: "Заработано за все время",
      adminUsersList: "База пользователей",
      notificationErrorLogin: "Ошибка авторизации:",
      notificationLogin: "Вход...",
      notificationWrongLoginData: "Неправильные данные входа",
      notificationLoginAccountBlocked: "Ваш аккаунт заблокирован",
      notificationCanContactSupport: "Вы можете обратиться в службу поддержки",
      notificationEmailExistsMessage: "Аккаунт с такой почтой уже зарегистрирован",
      notificationNetworkError: "Проверьте подключение к Интернету",
      notificationInputLoginData: "Введите данные для входа",
      notificationCheckInputEmail: "Проверьте правильность электронной почты",
      notificationCheckInputEmailOrUserNotFound: "Проверьте правильность электронной почты. Пользователь не найден",
      notificationCheckInputPhone: "Проверьте правильность номера телефона",
      notificationInputAllInputs: "Заполните все поля для регистрации",
      notificationAgreePrivacyPolicy: "Согласитесь с политикой конфиденциальности",
      adminEditorForPartnership: "Редактор партнерской программы",
      developmentPage: "Раздел находится в разработке",
      signupAgreeIAgreeWith: "Я ознакомился и соглашаюсь с",
      signupAgreePolicy: "политикой конфиденциальности",
      signupAgreeAnd: "и",
      signupAgreeOffer: "условиями использования",
      signupAgreeService: "сервиса",
      workboardModalLeadsLeadReferrer: "Не определено",
      workboardEditTitle: "Редактировать название",
      workboardEditIcon: "Редактировать иконку",
      workboardSaveChange: "Сохранить изменения",
      workboardModalLeadsLeadReferrerClarification: "Данные об источнике перехода заблокированы или не определены",
      workboardModalLeadsLeadEmailCopied: "Email скопирован в буфер",
      workboardModalLeadsLeadPhoneCopied: "Номер телефона скопирован в буфер",
      workboardModalLeadsHaveNotSended: "У вас есть неполученные лиды",
      workboardModalLeadsLeadReload: "Получить",
      workboardModalLeadsLeadReloadedTitle: "Запрос получен",
      workboardModalLeadsLeadReloaded: "If you have available leads in your tarif - the requested leads will be loaded at the top of the list and sent to your integrations",
      cfirstStartPagePhotoUpdated: "Фото стартовой страницы обновлено",
      allstepsPhotoTooBig: "Файл слишком большой",
      allstepsPhotoMustBeLess: "Фото должно быть меньше",
      cfirstStartPageBonusPhotoUpdated: "Фото бонуса обновлено",
      cstepsQuestionsOrderSaved: "Порядок вопросов сохранён",
      csanyAnswerOrderSaved: "Порядок ответов сохранён",
      allstepsPhotoAdaptation: "Адаптация фото под устройства",
      allstepsPhotoFit: "Соотношение сторон",
      constructorYouHideStep: "Вы спрятали этот шаг",
      cstepsHiddenStep: "Спрятать шаг",
      cstepNo_animation: "Без анимации",
      cstepAnimation: "Анимация",
      cstepKick_animation: "Толчок",
      cstepFlip_animation: "Переворот",
      cstepBlur_animation: "Размытие",
      cstepsShowStep: "Отобразить шаг",
      cfinishFinishPageHiddenUpdated: "Фінішна сторінка прихована.",
      cfinishFinishPageHiddenUpdatedGoContact: "Перейдіть на сторінку Форми контактів",
      cfinishFinishPageHiddenUpdatedSetRedirect: "та налаштуйте редирект після відправки даних",
      cformActionAfterContactRecive: "Действия после отправки формы",
      cformActionAfterContactThankyou: "Страница благодарности",
      cformActionAfterContactRedirect: "Переадресация",
      cformAdditionalSettings: "Дополнительные настройки",
      cformRedirectURL: "URL",
      cintegrationOweDomainInstructionImportant: "Важно: Адрес в вашем хостинг аккаунте и поле ниже, должны совпадать. Время применения изменений DNS-настроек и выписки SSL сертификата - до 3-х часов после сохранения.",
      cintegrationOweDomainInstructionVideo: "Посмотреть видео инструкцию",
      workboardModalLeadsLeadLimit: "Лимит ваших лидов исчерпан.",
      workboardModalLeadsLeadLimitInstruction1: "Чтобы увидеть новые лиды,",
      workboardModalLeadsLeadLimitInstruction2: "перейдите на другой тариф",
      workboardModalLeadsLeadLimitInstruction3: "обновите текущий тариф",
      workboardModalLeadsLeadLimitInstruction4: '(не касается "Free") или дождитесь обновления тарифа, если у вас подключено автопродление тарифа',
      workboardModalLeadsLeadLimitNewText: "У вас есть не полученные лиды, к которым нет доступа из-за текущего лимита пакета. Чтобы получить доступ к этим лидам, приобретите или обновите свой пакет.",
      billingBonusesTitle: 'Промокод',
      billingBonusesDescription: 'Введите полученный промокод в поле рядом',
      billingBonusesPlaceholder: 'Промокод',
      billingBonusesBtn: 'Активировать',
      billingBonusesActivated: 'Промокод активирован!',
      billingBonusesLeadIncreased: 'Количество доступных лидов увеличено.',
      billingBonusesInvalid: 'Неправильный промокод',
      billingBonusesNotAvailable: 'Промокод больше недоступен',
      billingBonusesAlreadyActivated: 'Данный купон недействителен',
      createQuizSPDescription: "Это место для краткого описания",
      createQuizCPTitle: "Как мы можем связаться с вами?",
      createQuizCPDescription: "Пожалуйста, заполните форму ниже",
      createQuizCPButton: "Готово!",
      createQuizFPTitle: "Спасибо!",
      createQuizFPDescription: "Теперь мы подберём лучшее решение для вас!",
      createQuizFPButton: "Покажите мне что-нибудь!",
      selectInternationalPrefix: "Выбрать международный префикс",
      autoInternationalPrefix: "Определять страну автоматически",
      dovnloadCsvTitle: "Экспортировать данные за вибраный период",
      dovnloadCsvSelectAllPeriod: "Выбрать за весь период",
      dovnloadCsvCancel: "Отменить",
      dovnloadCsvExport: "Экспортировать",
      domainEmpty: "Пожалуйста, введите домен",
      domainInvalid: "Введите корректный домен, например: example.com",
      domainAlreadyExists: "Этот домен уже есть в списке",
      domainAdded: "Домен успешно добавлен",
      domainAdd: "Добавить домен",
      domainAddFailed: "Не удалось добавить домен",
      domainRemoved: "Домен успешно удалён",
      domainRemoveFailed: "Не удалось удалить домен",
      
      
      
      widgetEmbedVidgetToSite: "Установка квиза на сайте",
      widgetEmbedVidgetSelectEmbedVariant: "Выберите вариант интеграции",
      EmbedQuizCardLabelStandard: "Стандартная",
      mbedSettingsPreviewPopupHint: "Нажмите кнопку, чтобы увидеть ваше всплывающее окно в действии",
      EmbedQuizCardLabelPopup: "Всплывающее окно",
      EmbedQuizCardLabelChatButton: "Кнопка чата",
      EmbedQuizCardLabelFullscreen: "На весь экран",
      EmbedQuizCardLabelFeedback: "Обратная связь",
      EmbedQuizCardLabelSidebar: "Боковая панель",
      EmbedStandardSettingsTitle: "Установите размеры (необязательно)",
      tipStandardEmbedQuizStepHead:
          "1. Скопируйте код для <head> и вставьте его перед закрывающим тегом </head>.",
      tipStandardEmbedQuizStepBody:
          "2. Скопируйте второй код и вставьте div <div id=\"adsquiz_embed_standard_ .... именно в то место страницы, где должен отображаться квиз.",
      tipStandardEmbedQuizParent:
          "3. Размер квиза зависит от размеров родительского блока. Если родительскому элементу не задана высота, квиз автоматически будет отображаться в адаптивном формате.",
      tipStandardEmbedQuizPercent:
          "4. Width и height в % работают относительно размеров родительского блока.",
      EmbedStandardSettingsTooltip: `
        Ширина и высота — задают размер квиза (px, %, auto).
  
        Auto — квиз адаптивный, высота рассчитывается автоматически.
  
        На весь экран — квиз занимает 100% ширины с соотношением 16:9. Ширина и высота игнорируются.
  
        Высота:
        • auto / 0 → соотношение 16:9
        • значение → фиксированная высота
  
        Ширина:
        • auto / 0 → 100% ширины
        • значение → в пределах контейнера
  
        Радиус — задаёт скругление углов.
  
        Отступ — добавляет внутренний отступ контейнера.
  
        На ПК / На мобильном устройстве — определяет, где отображается квиз.
        Если выключено — квиз не будет показываться на этом устройстве.
      `,
      EmbedFeedbackSettingsTooltip: `
        Размер окна задаёт базовый пресет:
  • S → 360 × 520
  • M → 480 × 640
  • L → 640 × 760
  • XL → 780 × 860
  
  Форма окна:
  • angular → угловая
  • rounded → скруглённая
  
  Ширина:
  • auto / 0 / пусто → используется пресет
  • значение → переопределяет пресет
  
  Высота:
  • auto / 0 / пусто → используется пресет
  • значение → переопределяет пресет
  
  Размер кнопки задаёт пресет кнопки открытия.
  
  Форма кнопки:
  • angular → угловая
  • rounded → скруглённая
  
  Позиция кнопки:
  • left → слева
  • right → справа
  • top → сверху
  • bottom → снизу
  
  Текст кнопки — изменяет текст.
  
  Иконка — выбор иконки кнопки.
  
  Цвет кнопки — фон кнопки.
  
  Цвет текста — цвет текста.
  
  Цвет иконки — цвет иконки.
  
  Запретить закрытие до прохождения квиза — если включено, пользователь не сможет закрыть окно, пока не завершит квиз.
  
  Перестать показывать после завершения — после прохождения квиза кнопка и окно больше не будут отображаться повторно.
  
  ПК / Мобильный — где показывается виджет.
  `,
      EmbedPopupSettingsTooltip: `
      Ширина и высота задают размер всплывающего окна.

      Размер окна задаёт базовый пресет размера:
      • S → 360 × 520
      • M → 480 × 640
      • L → 640 × 760
      • XL → 780 × 860

      Ширина и высота могут переопределить выбранный пресет Размера окна.

      Ширина:
      • auto / 0 / пусто → используется ширина из Размера окна
      • значение → собственная ширина переопределяет пресет

      Высота:
      • auto / 0 / пусто → используется высота из Размера окна
      • значение → собственная высота переопределяет пресет

      Условие показа определяет, когда открывается всплывающее окно:
      • Клик по кнопке — открывается по клику
      • При выходе со страницы — открывается, когда пользователь покидает страницу
      • После загрузки страницы — открывается сразу после загрузки
      • Через задержку — открывается через выбранное количество секунд

      Поле секунд появляется только для “Через задержку”.

      Текст кнопки, Размер кнопки, форма кнопки, позиция кнопки, Автоцвет (шаблон), Цвет кнопки и Цвет текста работают только для “Клик по кнопке”.

      Размер кнопки задаёт пресет размера кнопки открытия.

      Автоцвет (шаблон):
      • если включён — автоматически применяются цвета шаблона
      • если включить ручные цвета — Автоцвет выключается

      Запретить закрытие до прохождения квиза — если включено, пользователь не сможет закрыть окно, пока не завершит квиз.
  
      Перестать показывать после завершения — после прохождения квиза кнопка и окно больше не будут отображаться повторно.

      На ПК / На мобильном устройстве — определяет, где показывается всплывающее окно.
      Если выключено — окно не будет показываться на этом устройстве.
      `,
      EmbedChatButtonSettingsTooltip: `
      Ширина и высота задают размер окна чата.

      Размер окна задаёт базовый пресет размера:
      • S → 360 × 520
      • M → 480 × 640
      • L → 640 × 760
      • XL → 780 × 860

      Ширина и высота могут переопределить выбранный пресет Размера окна.

      Ширина:
      • auto / 0 / пусто → используется ширина из Размера окна
      • значение → собственная ширина переопределяет пресет

      Высота:
      • auto / 0 / пусто → используется высота из Размера окна
      • значение → собственная высота переопределяет пресет

      Форма окна определяет, будет ли окно с острыми или скруглёнными углами.

      Размер кнопки задаёт пресет размера кнопки открытия чата.

      Форма кнопки определяет вид кнопки:
      • прямоугольная
      • круглая

      Позиция кнопки определяет, где будет расположена кнопка:
      • слева
      • справа

      Иконки позволяют выбрать иконку кнопки чата.

      Цвет кнопки задаёт фоновый цвет кнопки.

      Цвет иконки задаёт цвет иконки внутри кнопки.

      Запретить закрытие до прохождения квиза — если включено, пользователь не сможет закрыть окно, пока не завершит квиз.
  
      Перестать показывать после завершения — после прохождения квиза кнопка и окно больше не будут отображаться повторно.

      На ПК / На мобильном устройстве — определяет, где показываются кнопка чата и само окно.
      Если выключено — чат-кнопка не будет показываться на этом устройстве.
      `,
      EmbedSidebarSettingsTooltip: `
      Ширина и высота задают размер боковой панели.
      
      Размер окна задаёт базовый пресет:
      • S → 360 × 520
      • M → 480 × 640
      • L → 640 × 760
      • XL → 780 × 860
      
      Позиция панели:
      • left → слева
      • right → справа
      
      Ширина:
      • auto / 0 / пусто → используется значение из пресета
      • значение → переопределяет пресет
      
      Высота:
      • auto / 0 / пусто → используется значение из пресета
      • значение → переопределяет пресет
      
      Условие показа определяет, когда открывается боковая панель:
      • Клик по кнопке — открывается по клику
      • При выходе со страницы — открывается, когда пользователь покидает страницу
      • После загрузки страницы — открывается сразу после загрузки
      • Через задержку — открывается через выбранное количество секунд
      
      Поле секунд появляется только для “Через задержку”.
      
      Текст кнопки, Размер кнопки, форма кнопки, позиция кнопки, Цвет кнопки и Цвет текста работают только для “Клик по кнопке”.
      
      Размер кнопки задаёт пресет кнопки открытия.
      
      Форма кнопки:
      • angular → угловая
      • rounded → скруглённая
      
      Позиция кнопки:
      • left → слева
      • middle → по центру
      • right → справа
      
      Цвет кнопки — фон кнопки открытия.
      
      Цвет текста — цвет текста кнопки.
      
      Запретить закрытие до прохождения квиза — если включено, пользователь не сможет закрыть панель, пока не завершит квиз.
      
      Перестать показывать после завершения — после прохождения квиза кнопка и панель больше не будут отображаться повторно.
      
      На ПК / На мобильном устройстве — определяет, где показывается боковая панель.
      Если выключено — панель не будет показываться на этом устройстве.
      `,

      EmbedModalStandardInstruction: `
      Скопируйте код из блока Head и вставьте его перед закрывающим тегом </head> на вашем сайте.
      
      Скопируйте код из блока Body и вставьте его в то место страницы, где должен отображаться квиз.
      
      Как это работает:
      • Квиз будет встроен прямо в страницу в том месте, куда вы вставили код
      • Он адаптируется под ширину родительского блока
      
      На что обратить внимание:
      • Если квиз выглядит слишком узким или широким — проверьте контейнер, в который вы его вставили
      • Если высота кажется неправильной — попробуйте задать фиксированную высоту в настройках
      • Если используется адаптивный режим — высота будет автоматически подстраиваться под ширину
      • Убедитесь, что на странице нет ограничений по overflow или скрытия контента
      
      После установки:
      1. Сохраните изменения
      2. Обновите страницу
      3. Проверьте отображение квиза на компьютере и телефоне
      `,
      EmbedModalPopupInstruction: `
      Скопируйте код из блока Head и вставьте его перед закрывающим тегом </head> на вашем сайте.
      
      Скопируйте код из блока Body и вставьте его перед закрывающим тегом </body> или в любое место страницы.
      
      Как это работает:
      • Квиз будет открываться в виде всплывающего окна (popup)
      • Он может открываться автоматически или по клику — в зависимости от выбранных настроек
      
      На что обратить внимание:
      • Если выбран вариант с кнопкой — кнопка появится в том месте, куда вы вставили код
      • Если выбран автоматический показ — popup откроется сам (при загрузке, задержке или попытке выхода)
      • Если popup не появляется — проверьте, включён ли он для нужного устройства (ПК или мобильный)
      • Если popup выглядит слишком большим или маленьким — измените размер в настройках
      
      После установки:
      1. Сохраните изменения
      2. Обновите страницу
      3. Проверьте, как открывается popup
      4. Убедитесь, что всё работает на компьютере и телефоне
        `,
      EmbedSettingsWindowSize: "Размер окна",
      EmbedPreviewFallbackTitle: "Предпросмотр загружается дольше, чем ожидалось",
      EmbedPreviewFallbackDescription: "Предпросмотр квиза пока не удалось отобразить. Попробуйте снова открыть предпросмотр или перезагрузить фрейм.",
      EmbedPreviewFallbackReasonsTitle: "Возможные причины:",
      EmbedPreviewFallbackReasonDomain: "Выбранный домен может быть недоступен или введён неправильно.",
      EmbedPreviewFallbackReasonDomainSettings: "Пожалуйста, проверьте настройки домена и убедитесь, что домен подключён корректно.",
      EmbedPreviewFallbackReasonSlow: "Страница квиза всё ещё может загружаться или медленно отвечать.",
      EmbedPreviewFallbackReasonBlocked: "Предпросмотр может блокироваться вашим браузером или сетевым окружением.",
      EmbedPreviewFallbackReload: "Перезагрузить предпросмотр",
      EmbedSizePresetDisabledHint: "Пресет размера недоступен, пока задана собственная ширина или высота.",
      EmbedPopupSettingsTitleButton: "Размер кнопки",
      EmbedStandardSettingsHeightLabel: "Высота",
      EmbedStandardSettingsWidthLabel: "Ширина",
      EmbedStandardSettingsRadiusLabel: "Радиус",
      EmbedStandardSettingsPaddingLabel: "Отступ",
      EmbedStandardSettingsFullscreenToggle: "На весь экран",
      EmbedStandardSettingsDesktopToggle: "На ПК",
      EmbedPopupSettingsTextColorToggle: "Цвет текста",
      EmbedPopupSettingsButtonColorToggle: "Цвет кнопки",
      EmbedSettingsIconColor: "Цвет иконки",
      EmbedPopupSettingsAutoColorToggle: "Автоцвет (шаблон)",
      EmbedPopupSettingsCloseOnCompletionToggle: "Запретить закрытие до прохождения квиза",
      EmbedSettingsStopShowing: "Перестать показывать после завершения",
      EmbedStandardSettingsMobileToggle: "На мобильном устройстве",
      EmbedSettingsAutoOpenToggle: "Автооткрытие",
      EmbedSettingsPreviewDelayHint: "Всплывающее окно появится через ",
      EmbedSettingsPreviewOpenAgain: "Открыть превью всплывающего окна",
      EmbedReOpenSettingsMobileToggle: "Open preview",
      widgetEmbedVidgetSitecode: "В коде сайта",
      widgetEmbedVidgetPopup: "Поп-ап",
      widgetEmbedVidgetChat: "Квиз-кнопка",
      widgetEmbedVidgetInProgres: "В разработке",
      widgetEmbedVidgetToSiteCode: "Установка квиза в код сайта",
      widgetSiteCodeInstruction0: "Чтобы установить квиз на вашем сайте, добавьте код с первого поля в тег `<head>` на вашем сайте или в Google Tag Manager, если он интегрирован в ваш сайт. Если после того как вы уже вставите квиз на сайт вы измените домен у квиза Вам нужно будет обновить код интеграции на вашем сайте.",
      widgetSiteCodeInstruction1: "В место куда вы хотите интегрировать квиз, вставьте код со второго поля.",
      widgetSiteCodeInstruction2: "Квиз можно интегрировать в контейнер любого размера, даже в сайдбары! Максимальный размер квиза, также как и при прямом входе на домен - 900х552 пикселя. Его можно добавлять в контейнеры и большего размера, в таком случае квиз будет отцентрирован.",
      widgetSiteCodeInstruction3: "Не стесняйтесь – экспериментируйте!",
      widgetSiteCodeCopyToHead: "Скопируйте и вставьте в `<head>` вашего сайта",
      widgetSiteCodeCopyToBody: "Вставьте код в место, где должен быть квиз",
      workboardModalAddQuizHeader: "Создание нового Quiz",
      workboardModalGiveQuizNameAndMethod: "Придумайте название вашего квиза и виберите желаемый способ создания",
      workboardModalNewQuizFromStart: "Создать с нуля",
      workboardModalNewQuizFromTemplates: "Готовые шаблоны",
      QuizTemplatesSearchInput: "Название шаблона и/или категорий",
      QuizTemplatesSearchBtn: "Поиск",
      QuizTemplatesReadyTemplates: "Готовые шаблоны",
      QuizTemplateView: "Посмотреть",
      QuizTemplateSelect: "Выбрать",
      widgetPopupInstruction0: "Чтобы установить квиз на вашем сайте, добавьте код из поля с кодом в тег `<head>` на вашем сайте или в Google Tag Manager, если он интегрирован в ваш сайт. Если после того как вы уже вставите квиз на сайт вы измените домен у квиза или тригеры открытия (процент скрола или тайминг), вам нужно будет обновить код интеграции на вашем сайте.",
      widgetPopupInstruction1: "Сразу перед закрывающим тегом </footer> вставьте код из второго поля.",
      widgetPopupInstruction2: "Для программистов или продвинутых пользователей",
      widgetPopupInstruction3: "Если вам, по каким-либо причинам, неудобно вставлять квиз перед закрывающим тегом `</footer>` вы можете вставить код из второго поля в любое удобное место, но учитывайте, что контейнер в который вы вставляете код из второго поля, должен быть поверх всех окон и крайне желательно, должен иметь высоту и ширину максимально возможную для дисплея.",
      widgetPopupCopyToHead: "Скопируйте и вставьте в `<head>` вашего сайта",
      widgetPopupCopyToBody: "Скопируйте и вставьте код перед закрывающим тегом `</footer>`",
      widgetPopupTimeToOpen: "Промежуток времени",
      secondReduction: "сек",
      widgetPopupTimeClarification: "Попап появится с задержкой указанного выше времени в секундах",
      widgetPopupScrollToOpen: "Процент пролистывания сайта",
      widgetPopupScrollClarification: "Попап появится после указанного выше процента пролистывания вашего сайта",
      quizzesTemplatesAllTags: "Все шаблоны",
      widgetEmbedVidgetButton: "Конструктор кнопки",
      widgetButtonInstruction0: "Ви можете установить на вашем сайте квиз который будет открываться при клике по кнопке.",
      widgetButtonInstruction1: "Додайте заокруглення, тінь, та текст кнопки. Також, ви можете змінити колір кнопки та тексту всередині.",
      widgetButtonInstruction2: "Скопируйте скрипт, расположенный в первом поле с кодом, и вставьте его перед закрывающим тегом `</head>`.",
      widgetButtonInstruction3: "Скопируйте сгенерированный код кнопки со второго поля с кодом и вставьте в любое место вашего сайта.",
      widgetButtonInstruction4: 'Вы можете не использовать код со второго поля с кнопкой, а просто добавить `id="button_open_quiz_popup"` к любому элементу `<input type="button">` или элементу `<button></button>` на сайте.',
      widgetRealTimeChange: "Вы можете видеть изменения в реальном времени в правой части экрана",
      widgetButtonCornerRound: "Скругления кнопки",
      widgetButtonShadow: "Тень кнопки",
      widgetButtonBgColor: "Цвет кнопки",
      widgetButtonTextColor: "Цвет текста",
      widgetButtonTextValue: "Текст кнопки",
      openPopupQuizText: "Начать квиз",
      widgetButtonInsertBeforeAfterBody: "Вставьте код квиза сразу после открывающего тега `<body>` или перед сразу закрывающим тегом `</body>`",
      widgetSiteCodeCopyButton: "Вставьте код кнопки в любое место на сайте",
      footerContactUs: "Возникли вопросы? Вы можете связаться с нами:",
      enterYourName: "Введите ваше имя",
      enterYourPhone: "Введите номер телефона",
      enterYourEmail: "Введите ваш email",
      enterYourPassword: "Введите ваш пароль",
      selectOption: "Выберите вариант",
      createNewGroup: "Создать новую групу",
      dontHaveAccount: "У вас нету акаунта?",
      haveQuestions: "Есть вопросы?",
      resetPasswordTip: "Если у вас есть какие-либо дополнительные проблемы или вопросы, пожалуйста, не стесняйтесь обращаться в нашу службу поддержки клиентов. Мы здесь, чтобы помочь.",
      getBackAccount: "Вернитесь к своей учетной записи",
      inMinutes: "за минуту",
      alreadyHaveAccount: "Уже есть акаунт?",
      quizSlotLastEdit: "Последнее изменение",
      workboardQuizzesTitle: "Мои квизы",
      allstepsBack: "Назад",
      constructorGetLink: "Ссылка",
      allOr: "или",
      allAnd: "и",
      acceptedFileType: "Допустимые форматы: ",
      quizLoaderLoadingQuiz: "Загружаем квиз...",
      quizLoaderPreparingQuestions: "Готовим персональные вопросы...",
      quizLoaderSettingInterface: "Настраиваем интерфейс...",
      quizLoaderAlmostReady: "Почти готово...",
      conjunctionAnd: "и",
      acceptedFileSize: "Максимальный размер: ",
      acceptedFileSizeMeasure: "МБ",
      cfirstBonusDisabled: "Отключено",
      cfirstBonusAvailable: "Доступно",
      allstepsResetInHeader: "Сбросить",
      placeholderText: "Введите здесь",
      constructorSaveChanges: "Сохранить",
      constructorCreateIntegrations: "Создать интеграцию",
      cformInputAvailable: "Доступно",
      cformInputDisabled: "Отключено",
      Disabled: "Отключено",
      constructorBack: "Назад",
      videoInstruction: "Видеоинструкция",
      csettingsIntegrationFB: "Интеграция - Facebook Pixel",
      csettingsIntegrationTT: "Интеграция - TikTok",
      csettingsIntegrationGA: "Интеграция - Google Analytics",
      csettingsIntegrationGTM: "Интеграция - Google Tag Manager",
      csettingsIntegrationWH: "Интеграция - WebHook",
      csettingsIntegrationTG: "Интеграция - Telegram",
      csettingsIntegrationApixDrive: "Интеграция - APIxDrive",
      csettingsIntegrationEmail: "Интеграция - Эл. почта",
      csettingsIntegrationAbout: "Описание",
      csettingsIntegrationFBAbout: "Перейдите в рекламный кабинет Facebook Ads и скопируйте идентификатор пикселя Facebook в разделе Менеджер событий. Не копируйте весь код, только идентификатор. Скопируйте и вставьте его в поле ниже.",
      csettingsIntegrationTTAbout: "Перейдите в рекламный кабинет TikTok Ads и скопируйте идентификатор TikTok Pixel в разделе \"Event\". Скопируйте только идентификатор и вставьте его в поле ниже.",
      csettingsIntegrationGAAbout: "Скопируйте идентификатор Google Analytics и вставьте его в поле ниже.",
      csettingsIntegrationGTMAbout: "Скопируйте идентификатор Google Tag Manager и вставьте его в поле ниже.",
      csettingsIntegrationWHAbout1: "Вы можете уведомлять сторонние приложения о поступающих лидах. Для этого укажите URL-адрес, на который будет отправлен WebHook. Мы рекомендуем использовать эту службу для этой цели.",
      csettingsIntegrationWHAboutApix: "Apix-Drive",
      csettingsIntegrationWHAbout2: "При регистрации по этой ссылке наши пользователи получают бонус - 10 000 бесплатных действий для любых интеграций.",
      csettingsIntegrationTGAbout: "Важно: обратите внимание, что это должна быть группа, а не канал Telegram. Лиды не будут отправляться на канал Telegram.",
      csettingsIntegrationADAbout: "Что-то о APIxDrive",
      csettingsIntegrationEmailAbout: "Инициируйте отправку электронной почты вашему респонденту и уведомьте свою команду. Сотрудничайте с вашей командой.",
      cSettingsIntegrationNeedHelp: "Нужна помощь?",
      cSettingsIntegrationRefreshToken: "Обновить токен",
      csettingsSettingASettings: "Расширенные настройки",
      cSettingsSettingQuizLangTitle: "Язык квиза",
      cSettingsSettingQuizLangDescription: "Чтобы обеспечить наилучший опыт, пожалуйста, выберите нужный язык квиза из вариантов ниже. На этом языке отображаются системные оповещения и некоторые другие неизменные тексты при прохождении квиза.",
      selectQuizLanguage: "Выберите язык квиза",
      cSettingsSettingQuizHideLabelTitle: "Спрятать метку",
      cSettingsSettingQuizHideLabelDescription: 'Включив этот параметр, вы сможете наслаждаться свободным от метки "made by adsquiz" интерфейсом, который позволит вам и вашим посетителям сосредоточиться исключительно на вопросах.',
      cSettingDataSaved: "Дополнительные настройки сохранены",
      userAccountInfo: "Информация об учетной записи",
      userGeneralInfoHeader: "Общая информация",
      userGeneralInfoDescription1: "Ваш профиль пользователя - это место, где вы можете управлять своей учетной записью и настройками.",
      userGeneralInfoDescription2: "Обновите свои личные данные, смените пароль и настройте предпочтения по уведомлениям.",
      profileNameFirst: "Имя",
      profileNameLast: "Фамилия",
      profileChangePhoto: "Изменить фото",
      profileRemovePhoto: "Удалить",
      userSecuritySettingsHeader: "Настройки безопасности",
      userSecuritySettingsDescription: "Чтобы изменить пароль, просто введите ваш новый пароль дважды для подтверждения.",
      profileEmailCurent: "Текущий адрес эл. почты",
      profileEmailNew: "Новый адрес эл. почты",
      profileNewPasswordConfirm: "Подтвердите новый пароль",
      profileDeleteAccount: "Удалить учетную запись",
      profileDeleteAccountPopupHeader: "Удалить учетную запись?",
      profileDeleteAccountPopupDescription: 'Вы уверены, что хотите удалить свою учетную запись? Это действие нельзя отменить. Для подтверждения удаления введите слово "УДАЛИТЬ" в поле ниже.',
      profileDeleteAccountCheckedWord: "УДАЛИТЬ",
      profileDeleteAccountPopupPlaceholder: "Введите здесь",
      notificationSuccess: "Успех!",
      notificationSuccessSaveAccount: "Ваш пароль успешно изменен! Используйте новый пароль для входа",
      notificationOnlyEmailMask: "Допускается только действительный адрес электронной почты.",
      notificationOnlyNumbersMask: "Разрешены только цифры и пробелы.",
      notificationOnlyLinkMask: "Допускаются только безопасные ссылки (https, http или mailto).",
      notificationOnlyLettersMask: "Разрешены только буквы, пробелы, дефисы, апострофы и подчёркивания.",
      notificationSuccessDeleteAccount: "Ваш пароль успешно изменен! Используйте новый пароль для входа",
      notificationSuccessDeletePhoto: "Успешно удалено фото",
      notificationSuccessChangePhoto: "Успешно изменено фото",
      notificationErrorChangePhoto: "Произошла ошибка при изменении фото",
      notificationErrorRemovePhoto: "Произошла ошибка при удалении фото",
      notificationWarnLimitText: "Превышен лимит символов. Вы не можете добавить больше символов.",
      cardPanUnspecified: "Не указано",
      userBillingsDate: "Дата",
      userBillingsCost: "Стоимость",
      userBillingsId: "ID",
      userBillingsMethod: "Способ оплаты",
      RateSymbolForDropdown: "Символ рейтинга",
      NumberOfSymbolsForDropdown: "Количество символов",
      optionIconLabelForDropdown_thumbnail: "Палец вверх",
      optionIconLabelForDropdown_stars: "Звёзды",
      optionIconLabelForDropdown_flags: "Флаги",
      optionIconLabelForDropdown_smiley_faces: "Смайлики",
      labelTextYesNoPack1: "Да/Нет Пакет - 1",
      labelTextYesNoPack2: "Да/Нет Пакет - 2",
      labelTextYesNoPack3: "Да/Нет Пакет - 3",
      labelTextYesNoEmojiPack: "Да/Нет Эмодзи Пакет",
      labelTextEmojiPackage1: "Пакет Эмодзи - 1",
      labelTextEmojiPackage2: "Пакет Эмодзи - 2",
      labelTextEmojiPackage3: "Пакет Эмодзи - 3",
      labelTextNumberPack1: "Пакет чисел - 1",
      labelTextNumberPack2: "Пакет чисел - 2",
      labelTextClassicNumbers1: "Классические числа - 1",
      labelTextClassicNumbers2: "Классические числа - 2",
      labelTextRatingMarkers: "Рейтинговые маркеры",
      textPackagePlaceholder: "Пакет ...",
      labelEmojiNumberSets: "Наборы эмодзи и чисел",
      labelSelectCountForSymbols: "Выберите диапазон от 1 до",
      labelButtonColorButtonText: "Цвет кнопки и текст кнопки",
      color: "Цвет",
      paymentSwitchToProHeader: "Переключиться на Pro",
      paymentSwitchToProDescription: "Найдите подходящий для вас план! Повышайте или понижайте уровень в любое время - мы упрощаем получение нужного плана.",
      paymentYourCurrentPlan: "Ваш текущий план:",
      paymentYourFuturePlan: "Ваш новый план:",
      billingCurrentPlanLeadLimit: "Лимит заявок в месяц",
      billingCurrentPlanLeadsRemaining: "Осталось заявок",
      billingSpecialOffersHeading: "Специальные предложения",
      billingAllPlansHeading: "Все тарифы",
      billingBillingPeriodToggleAria: "Период оплаты",
      billingPeriodMonthly: "Ежемесячно",
      billingPeriodYearly: "Ежегодно",
      billingPaymentUnavailableNotification: "Оплата для этого тарифа сейчас недоступна. Попробуйте позже или свяжитесь с нами.",
      billingRequisitesButton: "Реквизиты",
      billingPayAsBusiness: "Оплатить как компания",
      billingIbanModalTitle: "Реквизиты",
      billingIbanModalMethodTitle: "Банковский перевод IBAN",
      billingIbanModalDisclaimer: "Чтобы получить счет на оплату, напишите в чат техподдержки.",
      billingIbanModalRecipient: "Наименование получателя",
      billingIbanModalRecipientCode: "Код получателя",
      billingIbanModalIban: "IBAN",
      billingIbanModalBankName: "Название банка",
      billingIbanModalCopy: "Скопировать IBAN",
      billingIbanModalClose: "Закрыть",
      billingIbanCopyAllButton: "Скопировать реквизиты",
      billingIbanCopiedNotification: "IBAN скопирован в буфер обмена",
      billingIbanAllCopiedNotification: "Реквизиты скопированы в буфер обмена",
      billingWhatsIncluded: "Что входит",
      billingComparePlans: "Сравнить тарифы",
      billingComparePlanA: "Тариф А для сравнения",
      billingComparePlanB: "Тариф Б для сравнения",
      billingFeatureSectionMain: "Основное",
      billingFeatureSectionAdvanced: "Расширенные",
      billingFeatureSectionIntegrations: "Интеграции",
      billingAnalyticsRowLabel: "Аналитика",
      billingLeadsRowLabel: "Лиды",
      billingFeatureProjectsRowLabel: "Проекты",
      billingFeatureCustomDomainRowLabel: "Кастомный домен",
      billingFeatureAnalyticsRowLabel: "Аналитика",
      billingFeatureSiteInstallRowLabel: "Установка на сайт",
      billingFeatureAiBuilderRowLabel: "AI билдер",
      billingFeatureRedirectRowLabel: "Редирект",
      billingFeatureUtmTrackingRowLabel: "UTM Tracking",
      billingFeatureFaviconRowLabel: "Favicon",
      billingFeatureLogicRowLabel: "Логика",
      billingFeatureResultPageRowLabel: "Страница результата",
      billingFeaturePointsRowLabel: "Баллы",
      billingFeatureFileUploadRowLabel: "Загрузка файла",
      billingFeatureNotYetAvailableLabel: "Скоро",
      billingFeatureTeamRowLabel: "Команда",
      billingFeatureCrmRowLabel: "CRM",
      billingPartnershipOfferHeading: "Партнёрское предложение",
      paymentPlanLeadsLimit: "Лимит лидов на месяц:",
      paymentPlanLeadsLimitForTest: "Ваш лимит для теста квизов:",
      paymentPlanLeadsLeft: "Осталось лидов:",
      paymentPlanPrice: "Цена:",
      paymentPlanRenew: "Дата продления тарифа:",
      addNewSectionHeader: "Добавить новый раздел",
      addNewSectionList: "Список",
      addNewSectionCustom: "Поле ввода",
      addNewSectionMultiInput: "Мультиввод",
      addNewSectionUploadFile: "Загрузка файла",
      addNewSectionCard: "Карточки",
      addNewSectionWithEmoji: "Список с эмодзи",
      addNewSectionTags: "Теги",
      addNewSectionSlider: "Ползунок",
      templatesBackToQuiz: "Вернуться к воркборду",
      constructorStepsSaved: "Все данные квиза успешно сохранены",
      constructorDesignSaved: "Дизайн квиза успешно сохранен",
      azureBlueWhite: "Стандартный",
      azureBlue: "Зимняя ночь",
      moderatePurplishRed: "Красный бархат",
      multiInputPlaceholderLink: "https:",
      multiInputPlaceholderName: "Имя или полное имя",
      multiInputAddInput: "Добавить поле",
      multiInputPlaceholderAddress: "Адрес",
      multiInputPlaceholderNumbers: "Заполнитель (только цифры)",
      violetBlueCrayola: "Зимний бриз",
      wetRainforest: "Летний клен",
      lavender: "Космос",
      blueLilac: "Темная лаванда",
      opalGreen: "Карпатский лес",
      dustyBlue: "Тиффани",
      almondCrayola: "Кораловий риф",
      periwinkleCrayolaLilac: "Сирень",
      periwinkleCrayolaAqua: "Синевир",
      jazzJam: "Джаз",
      slateGrayBlue: "Мгла",
      turquoiseBlueCrayola: "Дия",
      blackPearlescentOpal: "Зола",
      pearlescentGentianBlue: "Сапфир",
      sapphireBlue: "Темный сапфир",
      errorUserDataUpdate: "Ошибка в обновленных данных: ",
      completeUserDataUpdate: "Данные пользователя обновлены",
      passwordDoNotCoincidence: "Пароли не совпадают",
      passwordDoNotCoincidenceAgain: "Спробуйте ще раз",
      nonBillingsYet: "У вас пока нет истории платежей",
      youCanChangePlan: "Вы можете изменить текущий план, нажав кнопку «Переключиться на PRO»",
      rangeMin: "Мин",
      rangeMax: "Макс",
      rangePositionStart: "Начальное положение",
      rangePositionEnd: "Конечное положение",
      rangeStep: "Шаг",
      rangeIsRange: "Диапазон",
      rangeIsRangeTrue: "Включено",
      rangeIsRangeFalse: "Выключено",
      recivePromotionNewsletter: "Получать имейл рассылки",
      reciveEmailCheckbox: "Чекбокс получения электронной почты",
      additionalCheckbox: "Дополнительный чекбокс",
      contactPrivacyPolicyCheckbox: "Чекбокс политики конфиденциальности",
      contactAgreeIAgreeWith: "Я согласен с",
      contactAgreePolicy: "политикой конфиденциальности",
      contactAgreeAnd: "и",
      contactAgreeTermsOfUse: "правилами использования",
      contactAgreeAgreementAdditionalWord: "",
      contactFillRequiredInput: "Заполните обязательные поля",
      langEN: "Английский",
      langDE: "Немецкий",
      langSP: "Испанский",
      langPL: "Польский",
      langIT: "Итальянский",
      langKK: "Казахский",
      langRU: "Русский",
      langUA: "Украинский",
      langSV: "Шведский",
      langLT: "Литовский",
      langLV: "Латвийский",
      langET: "Эстонский",
      langRO: "Румынский",
      leadsLeft: "Осталось лидов",
      generateDomainTitle: "Введите доменное имя",
      generateCodeForEmbedQuiz: "Сгенерировать код",
      generateDomainDescription: "Это уникальный адрес, по которому будет доступна ваша страница. Вы можете изменить адрес в любой момент или подключить свой.",
      generateDomainDomainNameLabel: "Доменное имя",
      cancelAllAction: "Отменить",
      confirmAllAction: "Подтвердить",
      fieldDataTypeLabel: "Тип данных в поле",
      falseHasValidCharacters: "Недопустимые символы в домене. Допустимыми символами являются буквы латинского алфавита, цифры и дефисы.",
      falseHasValidLength: "Длина домена должна быть от 6 до 20 буквенно-цифровых символов.",
      falseDoesNotStartOrEndWithSpecialChar: "Домен не должен начинаться или заканчиваться специальным символом.",
      falseDoesNotHaveConsecutiveSpecialChar: "Домен не должен содержать два или более подряд специальных символа.",
      falseDoesNotHaveConsecutiveSameChar: "Домен не должен содержать три или более подряд одинаковых символа.",
      falseDoesNotContainForbiddenSubstrings: "Домен не должен содержать запрещенные подстроки.",
      generateDomainTaken: "Этот домен уже занят. Попробуйте другой",
      temporarilyUnavailable: "Временно недоступно",
      csettingsAdmin: "Настройки для админов",
      questionLogicSetupTitle: "Настройка логики вопроса",
      questionLogicSetupDescription: "Добавьте условия, чтобы настроить опрос для каждого респондента и собирать более точные данные.",
      questionLogicConditionTitle: "Условие",
      questionLogicQuestion: "Вопрос",
      questionLogicSetupQuestionDisableOption: "Выберите вопрос",
      questionLogicSetupAnswer: "Ответ",
      questionLogicSetupLogicType: "Тип",
      questionLogicSetupAnswerDisableOption: "Выберите тип условия",
      questionLogicSetupRangeRatingBetween: "Между",
      questionLogicSetupRangeRatingLess: "Меньше",
      questionLogicSetupRangeRatingMore: "Больше",
      questionLogicSetupRangeRatingEqualTo: "Равно",
      questionLogicSetupRangeRatingFrom: "От",
      questionLogicSetupRangeRatingTo: "До",
      questionLogicSetupVariantAll: "Все из выбранных",
      questionLogicSetupVariantAny: "Один из",
      questionLogicSetupVariantNot: "Ни одного из",
      questionLogicSetupCustomEqual: "Равно",
      questionLogicSetupCustomContains: "Содержит",
      questionLogicSetupCustomNotContains: "Не содержит",
      questionLogicSetupRangeRatingValue: "Значение",
      questionLogicSetupExpectedAnswer: "Ожидаемые ответы",
      questionLogicSetupPlaceholder: "Введите здесь",
      questionLogicAllMandatory: "Все указанные условия обязательны",
      questionLogicAddConditionBtn: "Добавить условие",
      questionLogicNotAvailable: "Настройки логики недоступны для первого вопроса",
      pointsSettingsNotAvailableForQuestionType: "Этот тип вопроса не предполагает оценки ответов баллами",
      questionLogicSaved: "Настройки логики отображения шага сохранены",
      questionLogicDeleteAll: "Удалить логику",
      questionLogicDeleted: "Логика отображения шага удалена",
      questionLogicRatingSelectedLeftBtn: "левая кнопка",
      questionLogicRatingSelectedRightBtn: "правая кнопка",
      QR_code: "QR код",
      QRCodeDownloadPdf: "Скачать Pdf",
      QRCodeDownloadPng: "Скачать Png",
      qrGenerateTitle: "Создать QR-код",
      qrGenerateDescription: "Создайте персонализированный QR-код с UTM-метками для удобного отслеживания источников трафика. Когда пользователи сканируют код, они переходят в вашу викторину с сохранёнными параметрами кампании для точной аналитики.",
      qrUtmSource: "Источник (например, google, newsletter)",
      qrUtmMedium: "Маркетинговый канал (например, cpc, banner, email)",
      qrUtmCampaign: "Продукт, промокод или слоган (например, spring_sale). Требуется название или ID кампании.",
      qrUtmTerm: "Определение платных ключевых слов",
      qrUtmContent: "Используется для различения объявлений",
      billingPaymentInfoTitle: "Информация о тарифе",
      billingPaymentInfoChangeTarrif: "Сменить тариф",
      billingPaymentInfoDescription: "При оплате любого платного тарифа вы получаете определенное количество лидов, включенных в выбранный вами пакет. Эти лиды предоставляются на месяц. Если вы не использовали свои лиды в течение месяца с момента оплаты, они будут аннулированы.",
      billingGeneralName: "Ваш тариф",
      billingGeneralCost: "Стоимость",
      billingMonth: "месяц",
      billingGeneralExpired: "Действителен до",
      billingGeneralLeadsLeft: "Лидов осталось",
      billingGeneralAllTarifExpired: "Срок действия тарифов истек",
      billingGeneralBonus: "Бонусные лиды",
      billingGeneralLeadsFromOtherTarifs: "Лиды с других тарифов",
      billingGeneralNoActiveTariff: "Нет активного тарифа",
      billingLeadsAvailableLabel: "Доступно лидов",
      billingLeadsTariffSourceLabel: "Тариф",
      billingLeadsRemainingOfLabel: "{remaining} / {total} осталось",
      planUsageTeamMembersLabel: "Участники команды",
      planUsageManagePlanLabel: "Управлять планом",
      billingAcordeonPaymentInfoTitle: "Платежная информация",
      billingAcordeonPaymentInfoFormat: "Формат",
      billingAcordeonPaymentInfoSubscription: "Подписка",
      billingAcordeonPaymentInfoPay: "Оплата",
      billingAcordeonPaymentInfoPayMethod: "Способ оплаты",
      billingAcordeonPaymentInfoCancelSubscription: "Отменить подписку",
      billingAcordeonPromocode: "Промокод",
      billingAcordeonPromocodeLabel: "Введите промокод",
      billingAcordeonPayHistory: "История транзакций",
      paymentAllTarifInactive: "тариф неактивен",
      subscriptionUnsubscribeModalTitle: "Отписаться",
      subscriptionUnsubscribeModalDescription: "Вы уверены, что хотите отписаться? Начисленные лиды по подписке будут доступны вам в течение месяца с момента последнего списания средств по подписке.",
      subscriptionIsNotDeleteTitle: "Подписка не удалена",
      subscriptionIsNotDeleteDescription: "Пожалуйста, обратитесь в службу поддержки",
      subscriptionCanceledTitle: "Подписка аннулирована",
      embedQuizTitleGetLinkModal: "Вставить квиз на сайт как:",
      QRCodeTitleGetLinkModal: "Использовать QR-код:",
      modalSureUnsavedChangesTitle: "У вас есть несохраненные изменения",
      modalSureUnsavedChangesDescription: "Прежде чем покинуть текущую страницу, пожалуйста, решите, что делать с несохраненными изменениями",
      modalSureUnsavedChangesDontSave: "Не сохранять",
      modalSureUnsavedChangesSave: "Сохранить",
      modalSuggestIdeaNotificationSuccess: "Успешно! Спасибо за вашу идею",
      modalSuggestIdeaNotificationUnsuccess: "Упс! Что-то пошло не так. Пожалуйста, попробуйте позже.",
      telegramTokenCopied: "Токен квиза скопирован в буфер обмена",
      cSettingsSettingQuizBackButtonTitle: "Кнопка назад",
      cSettingsSettingQuizBackButtonDescription: "Вы можете включить или выключить кнопку возврата на предыдущий шаг. Это позволит изменять данный ранее ответ.",
      cSettingsCustomThemePrimaryColor: "Цвет акцентов",
      cSettingsCustomThemeSecondaryColor: "Фоновый цвет",
      cSettingsCustomThemeAdditionalColor: "Цвет текста",
      cSettingsCustomThemeButtonTextColor: "Текст в кнопках",
      cSettingsCustomThemeModeDark: "Тёмная",
      cSettingsCustomThemeModeLight: "Светлая",
      allstepsPlaceholder: "Плейсхолдер",
      allstepsCustomInput: "Свой вариант",
      allstepsCustomInputOn: "Включить",
      allstepsCustomPlaceholder: "Введите свой вариант",
      trashcanTitle: "Корзина",
      trashcanImportant: "Важно!",
      trashcanDescription: "Квиз будет автоматически удалена без возможности восстановления через 30 дней после того, как он был перемещён в корзину.",
      trashcanClearAll: "Очистить всё",
      quizSlotDeletedData: "Удалено",
      workboardLeads: "Лиды",
      filterOptionLabelCreatedDesc: "от новых к старым",
      filterOptionLabelCreatedAsc: "от старых к новым",
      filterOptionLabelLeadsDesc: "По лидам (по убыванию)",
      filterOptionLabelLeadsAsc: "По лидам (по возрастанию)",
      filterOptionLabelWithProject: "Квизы в проектах",
      filterOptionLabelWithoutProject: "Квизы без проекта",
      workboardDuplicate: "Дублировать",
      leadsTable: "Список лидов",
      exportInfo: "Экспорт лидов",
      leadHide: "Скрыть",
      leadShowMore: "Подробнее",
      poperTrashcan: "Корзина",
      restoreQuizSendedTitle: "Запущена задача восстановления",
      restoreSuizSendedImportant: "Важно",
      restoreQuizSendedDescription: "В зависимости от того, как много лидов было в вашем квизе, восстановление квиза, может занять от нескольких секунд до 2-х минут. После восстановления квиз появится на вашем основном воркборде.",
      ok: "Хорошо",
      month: "0 месяцев | {n} месяц | {n} месяца | {n} месяцев",
      discount: "Скидка до",
      saveMoney: "Подписка на год",
      upProVersionMobile: "На PRO",
      upProVersionDesktop: "Перейти на PRO",




      csettingsIntegrationSendPulse: "Интеграция - Send Pulse",
      csettingsIntegrationMailchimp: "Интеграция - Mailchimp",
      csettingsIntegrationMake: "Интеграция - Make",
      csettingsIntegrationZapier: "Интеграция - Zapier",
      csettingsIntegrationCRMBitrix: "Интеграция - CRM Bitrix",
      csettingsIntegrationPipeDrive: "Интеграция - Pipe Drive",
      csettingsIntegrationRemOnline: "Интеграция - Rem Online",
      csettingsIntegrationKeyCRM: "Интеграция - Key CRM",
      csettingsIntegrationGoogleSpreadsheets: "Интеграция - Google Spreadsheets",
      csettingsIntegrationKeepinCrm: "Интеграция - KeepinCRM",
            
      csettingsIntegrationZapierAbout: "Вставьте URL-адрес для отправки данных, предоставленный Zapier, в поле для ввода.",
      csettingsIntegrationMakeAbout: "Вставьте URL-адрес для отправки данных, предоставленный Make, в поле для ввода.",
      csettingsIntegrationMakeAboutTextStep1: "Для настройки интеграции с",
      csettingsIntegrationMakeAboutTextStep2: "посмотрите",
      csettingsIntegrationMakeAboutTextStep3: "Для настройки выберете среди интеграций на стороне make - “Webhooks”, далее “Custom webhook”.",
      csettingsIntegrationMakeAboutTextStep4: "Скопируйте полученную ссылку и вставьте в поле ниже в ADS Quiz.",
      csettingsIntegrationMakeAboutTextStep5: "Для тестирования, вернитесь в Make, нажмете кнопку “Run” и пройдите квиз отправив одну заявку.",
      csettingsIntegrationMakeAboutTextStep6: "В случае успешного тестирования сохраните интеграцию и не забудьте активировать обновления.",
      csettingsIntegrationMakeAboutLinkVideoText: "видео",
      csettingsIntegrationCRMBitrixAbout: "Вставьте URL-адрес для отправки данных, предоставленный CRM Bitrix, в поле для ввода.",

      csettingsIntegrationSendPulseAboutStart: "Вы можете настроить интеграцию с сервисом ",
      csettingsIntegrationSendPulseAboutMiddle: ". Для этого вам нужно перейти в настройки вашего аккаунта, и далее перейти на вкладку ",
      csettingsIntegrationSendPulseAboutEnd: ". Скопируйте значение параметра 'ID' и 'Secret' и вставьте их в соответствующие поля в сервисе ADS Quiz (в поля ниже). Далее необходимо вставить id адресной книги. Для этого перейдите в нужную адресную книгу и скопируйте в адресе страницы (в URL поле адреса сайта) значение после id/. Необходимы только цифры без дополнительных символов. Сохраните изменения. Более детальная инструкция в ",
      csettingsIntegrationSendPulseAboutLinkSendPulse: "https://sendpulse.com/ru#60c9ccfd55f4b",
      csettingsIntegrationSendPulseAboutLinkAPI: "https://login.sendpulse.com/login/#api",
      csettingsIntegrationSendPulseAboutLinkVideo: "https://www.youtube.com/watch?v=4mnhpbKkePs",
      csettingsIntegrationSendPulseAboutLinkVideoText: "видео",

      csettingsIntegrationKeyCRMAbout: "Вставьте API ключ и PipelineID, в соответствующие поля для ввода.",
      csettingsIntegrationPipeDriveAbout: "Вставьте токен и домен компании, в соответствующие поля для ввода.",
      csettingsIntegrationRemOnlineAbout: "Вставьте API ключ Rem Online в соответствующее поле для ввода.",
      csettingsIntegrationGoogleSheetsAbout: "Войдите в Google Sheets (если ваша учётная запись зарегистрирована на адрес Gmail, вы можете подключить только эту учётную запись Gmail; попытка подключить другую учётную запись приведёт к ошибке), выберите лист таблицы и сопоставьте поля, чтобы начать передачу данных.",
      csettingsIntegrationMailchimpAbout: "Подключите Mailchimp, выберите аудиторию и при необходимости настройте маппинг полей.",
      csettingsIntegrationKeepinCrmAbout: "Вставьте API ключ KeepinCRM, выберите воронку, статус, менеджера и источник. При необходимости включите маппинг полей.",
      csettingsIntegrationActiveIntegration: "Активная интеграция",
      cintegrationIntegrationData: "Данные интеграции",
      cintegrationMailchimpAudience: "Аудитория",
      cintegrationMailchimpAudiencePlaceholder: "Выберите аудиторию",
      cintegrationMailchimpStatus: "Статус подписки",
      cintegrationMailchimpStatusOptionSubscribed: "subscribed (Подписан)",
      cintegrationMailchimpStatusOptionPending: "pending (Ожидает подтверждения)",
      cintegrationMailchimpStatusOptionUnsubscribed: "unsubscribed (Отписан)",
      cintegrationMailchimpStatusOptionCleaned: "cleaned (Удалён)",
      cintegrationMailchimpStatusOptionTransactional: "transactional (Только транзакционные)",
      cintegrationMailchimpStatusDescriptionSubscribed: "контакт сможет получать ваши рассылки.",
      cintegrationMailchimpStatusDescriptionPending: "пользователь ещё не подтвердил подписку по email.",
      cintegrationMailchimpStatusDescriptionUnsubscribed: "контакт отказался от рассылок.",
      cintegrationMailchimpStatusDescriptionCleaned: "письма не доставляются.",
      cintegrationMailchimpStatusDescriptionTransactional: "используется только для сервисных писем, не для маркетинговых рассылок.",
      cintegrationMailchimpConnect: "Подключить Mailchimp",
      cintegrationMailchimpConnectTo: "Подключите Mailchimp",
      cintegrationMailchimpConnectedTo: "Подключено к Mailchimp",
      cintegrationMailchimpUseMapping: "Настройка полей",
      cintegrationMailchimpDataSaved: "Данные интеграции с Mailchimp сохранены",
      cintegrationDataMailchimpError: "Укажите аудиторию Mailchimp",
      cintegrationMailchimpMappingError: "Заполните маппинг полей",
      cintegrationMailchimpNoTags: "В Mailchimp нет тегов",
      cintegrationIntegrationUrl: "URL интеграции",
      cintegrationWriteUrl: "Введите URL",
      cintegrationDataFBError: "Неверный идентификатор пикселя",
      cintegrationDataWebHookError: "Неверный адрес вебхука",
      cintegrationZapierDataSaved: "Данные интеграции с Zapier сохранены",
      cintegrationDataZapierError: "Неверный адрес интеграции",
      cintegrationAPIxDriveDataSaved: "Данные интеграции с APIxDrive сохранены",
      cintegrationDataAPIxDriveError: "Строка не является адресом интеграции APIxDrive ",
      cintegrationMakeDataSaved: "Данные интеграции с Make сохранены",
      cintegrationDataMakeError: "Неверный адрес интеграции",
      cintegrationSendPulseDataSaved: "Данные интеграции с SendPulse сохранены",
      cintegrationDataSendPulseError: "Невозможные или пустые данные интеграции",
      cintegrationPipeDriveDataSaved: "Данные интеграции с PipeDrive сохранены",
      cintegrationDataPipeDriveError: "Невозможные или пустые данные интеграции",
      cintegrationRemOnlineDataSaved: "Данные интеграции с RemOnline сохранены",
      cintegrationDataRemOnlineError: "Невозможные или пустые данные интеграции",
      cintegrationKeyCRMDataSaved: "Данные интеграции с KeyCRM сохранены",
      cintegrationDataKeyCRMError: "Невозможные или пустые данные интеграции",
      cintegrationInputEmailUrl: "Введите Email",
      cintegrationEmailDataSaved: "Email сохранен",
      cintegrationDataEmailError: "Введенная строка не является Email",
      cintegrationCRMBitrixDataSaved: "Email сохранен",
      cintegrationDataCRMBitrixError: "Введенная строка не является Email",
      cintegrationTelegramBotDataSaved: "Настройки Telegram интеграции сохранены",
      cintegrationDataTelegramBotError: "Ошибка сохранения",
      cintegrationGTMDataSaved: "Идентификатор Google Tag Manager сохранен",
      cintegrationDataGTMError: "Неверный идентификатор",
      cintegrationDataGTMErrorDescription: "Идентификатор должен иметь вид GTM-XXXXXX",
      cintegrationGoogleAnalyticsDataSaved: "Идентификатор Google Analytics сохранен",
      cintegrationDataGoogleAnalyticsError: "Неверный идентификатор",
      cintegrationDataGoogleAnalyticsErrorDescription: 'Идентификатор должен иметь вид "UA-XXXXXXX-X" или "G-XXXXXXXXXX-XX"',
      cintegrationTikTokDataSaved: "Tik-Tok пиксель сохранен",
      cintegrationDataTikTokError: "Введенная строка не является Tik-Tok пикселем",
      cintegrationIntegrationToken: "Токен интеграции",
      cintegrationWriteToken: "Введите токен интеграции",
      cintegrationDataYourAPIKey: "Введите ваш API ключ",
      viewQuizInMobile: "Просмотреть квиз",
      notificationCSRFTokenMismatch: "Несоответствие CSRF токена",
      notificationReloadPage: "Перезагрузите страницу и попробуйте снова",
      csettingsIntegrationKeyRemOnline: "Вставьте токен и идентификатор канала в соответствующие поля",
      cintegrationDataYourIntegrationToken: "API ключ",
      cintegrationDataLeadTypeId: "Идентификатор канала",
      send_utm: "Отправлять UTM метки",
      send_quiz: "Отправлять данные квиза",
      send_answers: "Отправлять ответы",
      csettingsIntegrationKeyCrm: "Интеграция KeyCRM",
      cintegrationSendPulseClientId: "ID клиента",
      cintegrationSendPulseClientSecret: "Secret",
      cintegrationSendPulseAddressBookId: "ID адресной книги",
      cintegrationSendPulseAction: "Действия с контактом",
      sendpulseActionAddContact: "Добавить контакт",
      sendpulseActionDeleteContact: "Удалить контакт",
      cintegrationPipeDriveToken: "API токен",
      cintegrationPipeDriveDomain: "Ваш уникальный субдомен",
      cintegrationKeyCrmApiKey: "API ключ",
      cintegrationKeyCrmPipelineId: "Идентификатор воронки",
      cintegrationMenuGoogleTagManager:"Google Tag Manager",
      cintegrationMenuGoogleAnalytics:"Google Analytics",
      cintegrationMenuGoogleSpreadsheets:"Google Spreadsheets",
      cintegrationMenuKeepinCRM:"KeepinCRM",
      cintegrationMenuFacebookPixel:"Facebook pixel",
      cintegrationMenuTikTokPixel:"TikTok Pixel",
      cintegrationMenuWebHook:"Webhook",
      cintegrationMenuZapier:"Zapier",
      cintegrationMenuAPIxDrive:"APIx Drive",
      cintegrationMenuMake:"Make",
      cintegrationMenuSendPulse:"Send Pulse",
      cintegrationMenuMailchimp:"Mailchimp",
      cintegrationMenuEmail:"Email",
      cintegrationMenuTelegramBot:"Telegram-бот",
      cintegrationMenuPipeDrive:"PipeDrive",
      cintegrationMenuRemOnline:"Rem Online",
      cintegrationMenuKeyCRM:"Key CRM",
      cintegrationMenuCRMBitrix:"CRM Bitrix",
      googleSignIn: "Войти через Google",
      googleSignInHint: "Авторизуйтесь, чтобы продолжить настройку интеграции.",
      cintegrationGoogleSpreadsheetID: "ID таблицы",
      cintegrationGoogleSheetName: "Название листа",
      googleSheetNameTip: "Используйте название листа точно как в Google Sheets.",
      googleSheetsMappingTitle: "Маппинг полей",
      cintegrationGoogleSheetsSaved: "Данные Google Spreadsheets сохранены",
      googleSheetsSelectSheet: "Выберите лист",
      googleSheetsSelectSheetPlaceholder: "Выберите лист",
      googleSheetsSelectSheetFirst: "Сначала выберите лист, чтобы настроить маппинг",
      cintegrationKeepinPipelineId: "Воронка",
      cintegrationKeepinPipelineIdPlaceholder: "Выберите воронку",
      cintegrationKeepinStatusId: "Статус",
      cintegrationKeepinStatusIdPlaceholder: "Выберите статус",
      cintegrationKeepinManagerId: "Менеджер",
      cintegrationKeepinManagerIdPlaceholder: "Выберите менеджера",
      cintegrationKeepinSourceId: "Источник",
      cintegrationKeepinSourceIdPlaceholder: "Выберите источник",
      cintegrationKeepinUseMapping: "Использовать маппинг полей",
      cintegrationKeepinDataSaved: "Данные KeepinCRM сохранены",
      trashcanRestoreQuiz: "Восстановить квиз",
      cformValuePromotionAccepted: "Соглашаюсь на Email рассылку",


      constructorAddIntegration: "Добавить новую интеграцию",
      cintegrationKeyCrmSourceId: "Идентификатор источника (необязательно)",
      cintegrationKeyCrmManagerId: "Идентификатор менеджера (необязательно)",
      cSettingsSettingQuizSpamFilterTitle: "Защита от спама",
      cSettingsSettingQuizSpamFilterDescription: "Функция по умолчанию отключена. Если вы столкнулись с проблемой спамовых лидов, включите защиту. После этого один пользователь не сможет отправить больше указанного количества лидов на этот квиз.",
      cSettingsSettingQuizSpamFilterLimitPlaceholder: "Количество лидов",
      langNO: "Норвежский",
      loadMoreLeads: "Загрузить больше лидов",
      userAdditionalSettingsHeader: "Дополнительные настройки",
      userAdditionalSettingsDescription1: "Здесь можно настроить новые дополнительные параметры профиля.",
      userAdditionalSettingsPagination: "Пагинация на воркборде",

      benefitType: "Тип бонуса",
      benefitLabelPlaceholder: "Текст бонуса",
      benefitDescriptionPlaceholderDiscount: "Промокод или инструкция",
      benefitDescriptionPlaceholderVideo: "Ссылка на видео",
      benefitDescriptionPlaceholderTextfile: "Ссылка на текстовый файл",
      benefitDescriptionPlaceholderGift: "Описание бонуса",
      benefitDescriptionPlaceholderPDF: "Ссылка на PDF",
      benefitDescriptionPlaceholderLink: "Ссылка",
      benefitDescriptionPlaceholderFile: "Ссылка на файл",
      benefitDescriptionPlaceholderCustom: "Ссылка",
      benefitLabelDiscount: "Скидка",
      benefitLabelVideo: "Видео",
      benefitLabelTextfile: "Текстовый файл",
      benefitLabelGift: "Подарок",
      benefitLabelPDF: "PDF файл",
      benefitLabelLink: "Ссылка",
      benefitLabelFile: "Файл",
      benefitLabelCustom: "Индивидуальный бонус",
      addBenefit: "Добавить бонус",
      saveBenefit: "Сохранить бонус",
      cfinishSocialNetworks: "Социальные сети",

      saveSocialNet: "Сохранить социальную сеть",
      networkLabelFacebook: "Facebook",
      networkLabelInstagram: "Instagram",
      networkLabelTelegram: "Telegram",
      networkLabelTiktok: "Tik-Tok",
      networkLabelYoutube: "Youtube",
      networkLabelLinkedin: "LinkedIn",
      networkLabelWhatsapp: "WhatsApp",
      socialNetDescriptionPlaceholderFacebook: "имя_профиля",
      socialNetDescriptionPlaceholderInstagram: "имя_профиля",
      socialNetDescriptionPlaceholderTelegram: "имя_профиля/канала",
      socialNetDescriptionPlaceholderTiktok: "имя_профиля",
      socialNetDescriptionPlaceholderYoutube: "имя_канала",
      socialNetDescriptionPlaceholderLinkedin: '"in/name" или "company/name"',
      socialNetDescriptionPlaceholderWhatsapp: "+15555551234",

      addNewSectionEmptyPage: "Текстовая страница",
      csanyMakeImpasse: "Сделать тупиком",
      impaseIsImpaseTrue: "Включено",
      impaseIsImpaseFalse: "Выключено",
      defaultNewEmptyQuestionDescription: "Сюда можно вставить и отформатировать длинный текст (не рекомендуем вставлять более 3000 символов).",
      cSettingsSettingQuizTimezoneTitle: "Часовой пояс квиза",
      cSettingsSettingQuizTimezoneDescription: "Введите часовой пояс, по которому будет указан время заполнения лидов. Это особенно удобно, если вы находитесь в одном часовом поясе, а клиент — в другом. В таком случае вы можете указать часовой пояс клиента, и в лидах будет указан время по его часовому поясу.",
      cSettingsSettingQuizTimezonePlaceholder: "Часовой пояс",
      userAdditionalSettingsTimezone: "Часовой пояс пользователя",
      userAdditionalSettingsTimezonePlaceholder: "Часовой пояс",
      langHE: "Иврит",
      langCS: "Чешский",

      cintegrationCAPIFBInstruction: "Чтобы настроить интеграцию с Facebook Conversion API, вам необходимо ввести идентификатор пикселя и маркер доступа. Эти данные можно получить в настройках Facebook Business Manager. После того как вы ввели необходимые данные, сохраните интеграцию.",
      cintegrationCAPIFBInstructionTextTitle: "Название событий для FB Conversions:",
      cintegrationCAPIFBInstructionTextStart: " – посещение стартовой страницы;",
      cintegrationCAPIFBInstructionTextQuestionN: " – посещение шага N (номер шага подставляется динамически);",
      cintegrationCAPIFBInstructionTextOpenContactPage: " – посещение страницы контактов;",
      cintegrationCAPIFBInstructionTextLead: " – успешная отправка формы с контактными данными;",
      cintegrationCAPIFBInstructionTextThankYou: " – посещение финальной страницы.",
      cintegrationCAPIFBInstructionTextOptimizationAdvice: "Мы рекомендуем запускать рекламу с оптимизацией на событие",
      cintegrationCAPIFBInstructionTextLeadTriggerCondition: "Это событие отправляется",
      bold_capi_adsquiz_Start: "capi_adsquiz_Start",
      bold_capi_adsquiz_QuestionN: "capi_adsquiz_Question-N",
      bold_capi_adsquiz_OpenContactPage: "capi_adsquiz_OpenContactPage",
      bold_capi_adsquiz_Lead: "capi_adsquiz_Lead",
      bold_capi_adsquiz_ThankYou: "capi_adsquiz_ThankYou",
      bold_capi_adsquiz_OptimizationAdvice: "“capi_adsquiz_Lead”.",
      bold_capi_adsquiz_LeadTriggerCondition: "только при успешном получении заявки от пользователя.",
      csettingsIntegrationFbCapiAbout: "Интеграция с Facebook Conversion API позволяет передавать данные о взаимодействиях пользователей напрямую в Facebook для улучшения эффективности рекламных кампаний.",
      cintegrationInputCapiAccessToken: "Введите маркер доступа",
      cintegrationInputCapiCustomparameter: "Введите кастомные параметры событий",
      cintegrationDataFbCapiSaved: "Интеграция с Facebook Conversion API успешно сохранена",
      cintegrationComonRenovateHubInstructionTitle: "Инструкция по настройке интеграции с «Міністерство Ремонту»",
      cintegrationComonRenovateHubInstructionDescription1: "Для настройки интеграции с «Міністерство Ремонту» укажите URL-адрес веб-перехватчика, на который будут отправляться данные.",
      cintegrationComonRenovateHubInstructionDescription2: "Для этого перейдите в «Панель администратора», затем откройте раздел «Интеграции» и выберите ADS Quiz. Нажмите «Создать URL-адрес веб-перехватчика», скопируйте его и вставьте в поле ввода ниже в сервисе ADS Quiz.",
      cintegrationComonRenovateHubInstructionDescription3: "После этого пройдите викторину для тестирования или отправьте тестовый лид, используя кнопку «Тест».",
      cintegrationComonRenovateHubInstructionDescription4: "Затем сохраните и активируйте интеграцию. Все лиды будут отправляться в «Міністерство Ремонту» в раздел «Запросы».",
      cintegrationComonRenovateHubInstructionShort: "Интеграция с «Міністерство Ремонту» позволяет передавать данные в СРМ через вебхук для автоматизации процессов.",
      cintegrationRenovateHubUrl: "Введите URL «Міністерство Ремонту»",
      cintegrationInputRenovateHubUrl: "Укажите URL вебхука для «Міністерство Ремонту»",
      cintegrationRenovateHubDataSaved: "Интеграция с «Міністерство Ремонту» успешно сохранена",
      cintegrationDataRenovateHubError: "Ошибка при сохранении интеграции с «Міністерство Ремонту». Проверьте правильность введённых данных.",
      cintegrationMenuFacebookConvAPI: "Facebook Conversions API",
      cintegrationMenuRenovateHub: "Міністерство Ремонту",
      csettingsIntegrationRenovateHub: "Интеграция с «Міністерство Ремонту»",
      csettingsIntegrationCAPIFB: "Интеграция с Facebook Conversions API",
      paymentPlanEnd: "Дата окончания тарифа",
      paymentPlanNextPayment: "Следующий платёж",
      paymentPlanLeadsLimitForYear: "Лимит лидов на год:",
      paymentPlanLeadsLimitForPeriod: "Лимит лидов на период:",
      EditTags: "Изменить теги",
      quizzesTemplatesNoTags: "Без тегов",


      Monday: "Понедельник",
      Tuesday: "Вторник",
      Wednesday: "Среда",
      Thursday: "Четверг",
      Friday: "Пятница",
      Saturday: "Суббота",
      Sunday: "Воскресенье",
      datetimeDisplayMode: "Тип выбора",
      datetimeDisplayModeSelect: "Выберите тип",
      datetimeDisplayModeDate: "Дата",
      datetimeDisplayModeTime: "Время",
      datetimeDisplayModeDatetime: "Дата и время",
      datetimeMinDate: "Минимальная дата",
      datetimeMinDateCustom: "Укажите минимальную дату",
      datetimeMaxDate: "Максимальная дата",
      datetimeMaxDateCustom: "Укажите максимальную дату",
      datetimeProhibitDaysOfWeek: "Запретить дни",
      datetimeIsRange: "Диапазон",
      datetimeIsRangeTrue: "Диапазон включен",
      datetimeIsRangeFalse: "Диапазон выключен",
      datetimeMinTime: "Минимальное время",
      datetimeMaxTime: "Максимальное время",
      datetimeIs24: "24-часовой формат",
      datetimeIs24True: "Формат 24 ч включен",
      datetimeIs24False: "Формат 24 ч выключен",
      csanyIsExactDate: "Как вы хотите настроить дату",
      csanyIsExactDateTrue: "Точная дата",
      csanyIsExactDateFalse: "Относительная дата",
      csanyDatetimeMinMaxNotExactPlaceholder: '"x" или "-x" дней от сегодня',
      addNewSectionDatetime: "Дата/время",
      tariffsPromo: "Акционные предложения",
      pricingComparisonEyebrow: 'Тарифы Adsquiz',
      pricingComparisonTitle: 'Выберите один из наших планов',
      pricingComparisonMobileHint: 'Пролистайте карточки тарифов и выберите два ниже, чтобы сравнить подробно.',
      pricingComparisonTableAria: 'Таблица сравнения тарифов',
      pricingComparisonMonthShort: 'месяц',
      billingPromoPeriodYearly: "год",
      billingPromoPeriodMonths: "{count} месяцев",
      billingPromoDescription: "Без ограничений в квизах и функционале",
      pricingComparisonTryFree: 'Попробовать бесплатно',
      pricingComparisonGetStarted: 'Улучшить',
      pricingComparisonCurrentPlan: 'Ваш тариф',
      pricingComparisonBuyAgain: 'Купить повторно',
      pricingComparisonLeadsPerMonth: '{count} лидов /месяц',
      pricingComparisonUnlimited: 'Без ограничений',
      pricingComparisonTeamUsers: '0 пользователей | +{n} пользователь | +{n} пользователя | +{n} пользователей',
      pricingComparisonRequired: 'Обязательный',
      pricingComparisonOptional: 'Опционально',
      tariffsMonth: "Ежемесячно",
      tariffsAnual: "Ежегодно",
      leadsOn1Month: "в месяц",
      leadsOn2Month: "на 2 месяца",
      leadsOn3Month: "на 3 месяца",
      leadsOn4Month: "на 4 месяца",
      leadsOn5Month: "на 5 месяцев",
      leadsOn6Month: "на 6 месяцев",
      leadsOn7Month: "на 7 месяцев",
      leadsOn8Month: "на 8 месяцев",
      leadsOn9Month: "на 9 месяцев",
      leadsOn10Month: "на 10 месяцев",
      leadsOn11Month: "на 11 месяцев",
      leadsOn12Month: "на год",
      leadsOn24Month: "на 2 года",
      leads: "лидов",
      tariffsWordPrice: "Цена",
      tariffsNoLimits: "Без ограничений",
      tariffsNoLimitsQuizzes: "в квизах",
      tariffsAndFunctions: "и функционале",
      billingTariffYear: "год",
      billingChangePlanSubscribe: "Подписаться",
      paymentAllTariffInactive: "Тариф не активен",
      subscriptionTariffLableOnly: "Доступно только для подписки",
      notExactBeforeYear: "год назад",
      notExactBeforeHalfYear: "полгода назад",
      notExactBeforeQuarter: "квартал назад",
      notExactBeforeMonth: "месяц назад",
      notExactBeforeWeek: "неделю назад",
      notExactBeforeYesterday: "позавчера",
      notExactYesterday: "вчера",
      notExactToday: "сегодня",
      notExactTomorrow: "завтра",
      notExactAfterTomorrow: "послезавтра",
      notExactAfterWeek: "через неделю",
      notExactAfterMonth: "через месяц",
      notExactAfterQuarter: "через квартал",
      notExactAfterHalfYear: "через полгода",
      notExactAfterYear: "через год",
      tipDefaultDateHeader: "По умолчанию",
      tipDefaultDateText: "Если оба переключателя 'Точная дата' и 'Относительная дата' отключены, календарь позволит выбирать даты в диапазоне от 1800 до 2200 года по умолчанию.",
      tipExactDateHeader: "Переключатель точной даты",
      tipExactDateText: "Включение этого переключателя ограничит календарь фиксированным диапазоном дат, которые выбраны в полях ввода ниже.",
      tipRelativeDateHeader: "Переключатель относительной даты",
      tipRelativeDateText: "Включение этого переключателя динамически установит ограничения календаря на основе относительных дат, которые рассчитываются во время загрузки страницы. Эти ограничения персонализированы и пересчитываются для каждого пользователя отдельно.",
      langPT: "Португальский",
      placeholderCompanyContactText: 'Например: "Телефон компании: +380993322211"',
      integrationConnectService: "Подключить",
      Connect: "Подключить",
      Connected: "Подключено",
      Disconnect: "Отключить",
      cintegrationOauthDisconnectModalTitle: "Отключить {provider}?",
      cintegrationOauthDisconnectModalDescription: "Отключение {provider} отключит эту интеграцию от ВСЕХ квизов. Если вы хотите отключить её только для этого квиза, удалите интеграцию ниже.",
      cintegrationOauthDisconnectModalDescriptionBase: "Отключение {provider} отключит эту интеграцию от ВСЕХ квизов.",
      cintegrationOauthDisconnectModalDescriptionDeleteHint: "Если вы хотите отключить её только для этого квиза, удалите интеграцию ниже.",
      cintegrationOauthDisconnectDeleteQuizOnly: "Удалить только в этом квизе",
      cintegrationOauthDisconnectAllQuizzes: "Отключить для всех квизов",
      leadtype_id: "Тип действия",
      selectVariant: "Выберите",
      sfirstAddCompanyContacts: "Текст с контактами",
      addNewSectionTextarea: "Большое поле ввода",
      allstepsVariantView: "Формат изображения",
      tariffsDiscountSave: "Экономия",
      cAdminSettingsTitle: "Админ настройки",
      cAdminSettingsInstruction: "Введите теги для квиза в поле ниже. Теги могут состоять из нескольких слов, каждый тег отделяется запятой. Теги 'Услуги' и 'услуги' — это разные теги. Рекомендуется использовать теги, начинающиеся с заглавной буквы. Также можно исключить квиз из списка шаблонов.",
      cAdminSettingsIsTemplate: "Является ли шаблоном",
      cIsTemplateStateAreSaved: "Статус шаблона сохранён",
      sfirstAddLogotype: "Добавьте логотип",
      logotypeSizeTip: "Логотип будет вставлен в реальном размере, но не больше 120 пикселей по большей из сторон.",
      cfirstLogotypeUpdated: "Логотип добавлен",
      cfirstLogotypeDeleted: "Логотип успешно удалён!",

      cOffersPageSettings: "Настройки",
      offerPageTitlePlaceholder: "Введите заголовок",
      offerPageDescriptionPlaceholder: "Введите описание страницы",
      offerPageButtonTextPlaceholder: "Введите текст кнопки (необязательно)",
      allstepsOffers: "Список офферов",
      offerProposalHeader: "Оффер",
      offerAttachAddImg: "Добавить изображение",
      offerAttachAddVideo: "Добавить видео",
      offerItemImg: "Изображение",
      offerItemTitle: "Заголовок оффера",
      offerTitlePlaceholder: "Введите заголовок здесь",
      offerItemSubtitle: "Подзаголовок (например, цена)",
      offerSubtitlePlaceholder: "Введите текст здесь",
      offerItemDescription: "Описание оффера",
      offerDescriptionPlaceholder: "Введите описание здесь",
      offerItemButtonText: "Текст кнопки оффера",
      offerBtnTextPlaceholder: "Введите текст кнопки",
      offerItemButtonLink: "Ссылка для кнопки",
      offerBtnLinkPlaceholder: "Ссылка должна начинаться с https://",
      csanyOfferLogic: "Логика отображения",
      offerAddNewOffer: "Добавить новый оффер",
      offerLogicSetupTitle: "Настройки логики",
      OfferLogicSetupDescription: "Здесь вы можете настроить, при каких ответах будут отображаться те или иные офферы",
      cstepsOffersPage: "Страница результатов",
      addNewSectionResultsByLogic: "Офферы",
      cformActionAfterContactOffersOr: "Страница с офферами / ",
      tolltipOffersAfterContact: "Если после прохождения квиза будет выполнена логика отображения хотя бы одного оффера, отобразится страница с офферами, иначе – страница благодарности.",
      videoCircleTextQuestion: "Видеоинструкция",
      offerPhotoOptimalRatio: "Для оптимального отображения изображения рекомендуем использовать соотношение 16:9.",
      tolltipThankYouAfterContact: "После прохождения квиза будет отображена страница благодарности.",
      cformActionAfterContactOffers: "Страница результатов",
      addOfferPageInContact: "Включить страницу результатов",
      offerPageHeader: "Заголовок для страницы офферов",
      pumkinOrange: "Оранжевый",
      invalidSocialNetworkURL: "Неверная ссылка", 
      itMustBeFullLink: 'Проверьте правильность введённой ссылки. Она должна начинаться с протокола "https://" и соответствовать сохранённой социальной сети.',
      addSocialLinks: "Добавить соцсеть",
      questionAttachAddImg: "Фото",
      questionAttachAddVideo: "Видео",
      questionChooseLineInput: "Линейное",
      questionChooseClassicInput: "Классическое",
      questionChooseOneColumn: "1 колонка",
      questionChooseTwoColumns: "2 колонки",
      allStepsVideoUrl: "Ссылка на видео",
      allStepsPhotoHeader: "Фото",
      cintegrationMenuSalesDrive: "SalesDrive",
      csettingsIntegrationSalesDrive: "Интеграция - SalesDrive",
      csettingsIntegrationSalesDriveAbout: "Вы можете отправлять лиды в CRM SalesDrive",
      cintegrationSalesDriveApiKey: "Вставьте API ключ",
      cintegrationSalesDriveDomain: "Вставьте домен, предоставленный SalesDrive",
      cintegrationSalesDriveDataSaved: "Интеграция с SalesDrive сохранена",
      send_offers: "Отправлять офферы, показанные посетителю",
      cformShowConsultant: "Показать консультанта",
      consultantPhoto: "Фото консультанта",
      consultantName: "Имя консультанта",
      consultantJobTitle: "Должность консультанта или другая информация",
      consultantRating: "Рейтинг консультанта",
      signinIWouldLikeReciveEmail: "Я хочу получать новости и специальные предложения от ADS QUIZ (Вы можете отказаться от этих рассылок в любое время).",
      acceptedFileSizeUpTo: "до",
      customDesignColorTags: "Теги",
      customDesignColorActiveButton: "Цвет активного элемента",
      customDesignColorInactiveButton: "Цвет неактивного элемента",
      customDesignColorActiveText: "Цвет активного текста",
      customDesignColorInactiveText: "Цвет неактивного текста",
      addNewSectionDropdown: "Выпадающий список",
      langFR: "Французский",
      addNewSectionRatePage: "Страница с оценкой",
      bold_adsquiz_Offers_page: "adsquiz_Open-Offers-Page",
      cintegrationFBInstructionTextOffersPage: "Перейти на страницу офферов",
      defaultNewQuestionDropdownPlaceholder: "Нажмите здесь, чтобы открыть список вариантов",
      allStepsVideoUrlPlaceholder: "https://youtube, vimeo или wistia",
      addListOfAnswersButton: "Добавить несколько",
      addListOfAnswersTitle: "Массовое добавление вариантов ответов",
      addListOfAnswersInstruction: "Вставьте список вариантов ответов в это поле, чтобы добавить их. Варианты могут быть разделены по строкам [↵], точкой с запятой [;], запятой [,] или пробелом [ ]. Разделение происходит по разделителю с наивысшим приоритетом: [↵] → [;] → [,] → [ ].",
      addListOfAnswersPlaceholder1: "Ответ 1",
      addListOfAnswersPlaceholder2: "Ответ 2",
      addListOfAnswersSendButton: "Добавить",
      addNewPerson: "Добавить участника",
      cfirstGradientOverlay: "Градиентный фоновый слой",
      cfirstGradientOverlayTip: "Градиентный фоновый слой полезен, если фоновое изображение слабо контрастирует с цветом текста.",
      cfirstContentBorder: "Разделительная граница контента",
      workboardDuplicateToOthers: "Скопировать на другой аккаунт",
      workboardDuplicateAndTransferQuiz: "Дублировать квиз на другой аккаунт",
      workboardDuplicateAndTransferQuizHintTitle: "При дублировании квиза он будет продублирован на аккаунт получателя как шаблон.",
      workboardDuplicateAndTransferQuizHintTitleSecond: "Квиз на аккаунте получателя будет чистым, без лидов и интеграций. Текущий квиз останется без изменений. Чтобы скопировать квиз на другой аккаунт, один из пользователей должен иметь любой ",
      workboardDuplicateAndTransferQuizConfirm: "Дублировать",
      workboardDuplicateAndTransferQuizStatus200: "Квиз успешно скопирован на аккаунт:",
      delOffersPageQuestionForModalConfirm: "Вы уверены, что хотите удалить страницу с офферами?",
      offerPageDefaultDescription: "Введите здесь описание страницы с результатами",
      offerPageDefaultButtonText: "Завершить",
      cintegrationMenuKommo: "Kommo",
      csettingsIntegrationKommo: "Интеграция - Kommo",
      csettingsIntegrationKommoAbout: "Вы можете отправлять лиды в CRM Kommo",
      cintegrationKommoToken: 'Вставьте "Long-lived Token"',
      cintegrationKommoDomain: "Вставьте ваш субдомен",
      cintegrationKommoDataSaved: "Интеграция с Kommo сохранена",
      cintegrationKommoPipelineId: "Вставьте PipelineID",
      cintegrationKommoPipelineIdPlaceholder: "Выберите Воронку",
      cintegrationKommoStatusID: "Вставьте StatusID",
      cintegrationKommoStatusIDPlaceholder: "Выберите статус нового лида (необязательно)",
      cintegrationKommoTagId: "Вставьте TagID",
      cintegrationKommoTagIdPlaceholder: "Выберите тег для нового лида (необязательно)",
      cintegrationKommoError: "Ошибка при сохранении интеграции с Kommo. Проверьте правильность введённых данных.",
      cintegrationKommoDeleted: "Интеграция с Kommo удалена",
      cintegrationKommoDeletedError: "Ошибка при удалении интеграции с Kommo",
      cintegrationKommoCreateNote: "Создавать примечание с ответами",
      cintegrationKommoUseMapping: "Использовать маппинг полей",
      mappingValue: "Поле в CRM",
      mappingValueMailchimp: "Поле в Mailchimp",
      mappingKey: "Поле в лиде",
      addMappingRow: "Добавить связь полей",
      DELETE: "Удалить",
      mappingAnswer: "Ответ на вопрос",
      testIntegration: "Тест",
      testIntegrationLast10Leads: "Тест интеграции (последние 10 лидов)",
      testIntegrationNeedRealLeadTooltip: "Тест доступен только если в квизе есть хотя бы один реальный лид.",
      loading: "Загрузка...",
      sentAt: "Отправлено",
      phone: "Телефон",
      email: "Email",
      action: "Действие",
      send: "Отправить",
      sending: "Отправка...",
      success: "Успех",
      failed: "Неудача",
      error: "Ошибка",
      displayCondition: "Условие отображения",
      selectDisplayCondition: "Выберите условие отображения",
      seconds: "Секунды",
      button: "Кнопка",
      buttonContainerSelector: "Селектор контейнера кнопки",
      buttonContainerSelectorPlaceholder: ".quiz-buttons или #quiz-button-place",
      clickHere: "Нажмите здесь",
      buttonClick: "Клик по кнопке",
      clickOnWidget: "Клик по виджету",
      exitIntent: "При выходе со страницы",
      pageLoad: "После загрузки страницы",
      delay: "Через некоторое время",
      resultPageSectionTitle: "Результаты по баллам",
      resultPageSectionAccordion: "Страница результатов по баллам",
      resultPageShowCondition: "Показывать условие",
      resultPageShowCollectedPoints: "Показывать набранные баллы",
      resultPageShowMaxPoints: "Показывать максимальные баллы",
      resultPageShowProgressBar: "Показывать прогресс-бар",
      resultPageSelectFormat: "Выбрать формат результата",
      resultPageScenarios: "Сценарии",
      resultPageAddScenario: "Добавить сценарий",
      resultPageScenarioPhoto: "Добавить фото",
      resultPageScenarioTitle: "Заголовок",
      resultPageScenarioTitlePlaceholder: "Введите заголовок сценария",
      resultPageScenarioDescription: "Описание",
      resultPageScenarioDescriptionPlaceholder: "Введите описание сценария",
      resultPageScenarioUrlPlaceholder: "Ссылка (https://)",
      resultPageScenarioButtonText: "Текст кнопки",
      resultPageScenarioButtonTextPlaceholder: "Введите текст кнопки",
      resultPagePointsCondition: "Условие отображения по баллам",
      resultPagePointsBetween: "Между",
      resultPagePointsMoreThan: "Больше чем",
      resultPagePointsLessThan: "Меньше чем",
      resultPagePointsEqual: "Равно",
      resultPageErrorAddNewScenario: "Не удалось добавить новый сценарий",
      resultPageErrorRangeExplanation: "Пожалуйста, добавьте больше баллов или перераспределите их между сценариями",
      resultPageErrorFullRange: "Все диапазоны баллов уже покрыты",
      resultPageErrorOutOfRange: "Баллы в сценариях выходят за допустимый диапазон",
      resultPageErrorSaving: "Ошибка сохранения сценариев",
      resultPageErrorOverlap: "Баллы в сценариях не должны пересекаться",
      resultPageAutoRedirectWarningTitle: "Автоперенаправление отключено",
      resultPageAutoRedirectWarningText: "Чтобы включить автоперенаправление, добавьте ссылку в каждом сценарии результата.",
      resultPageAutoRedirectWarningButton: "Понятно",
      AddTags: "Добавить теги",
      resultPageModalDescription: "Присвойте баллы каждому ответу.",
      resultPageYourOptions: "Ваши варианты",
      placeholderDefaultValue: "Значение",
      resultPageByPointsTitle: "Результаты по баллам",
      resultPageConditionSettingsButton: "Логика по баллам",
      resultPageConditionSettingsSaved: "Сохранено",
      resultPageConditionSettingsUnsaved: "Сохранить",
      resultPagePlaceholderScenarioTitle: "Заголовок сценария",
      resultPagePlaceholderScenarioDescription: "Здесь вы можете вставить краткое описание результатов",
      resultPageLabelScenarioCti: "Призыв к действию",
      resultPagePlaceholderScenarioCti: "Текст в кнопке",
      resultPagePlaceholderScenarioUrl: "Ссылка на кнопку",
      resultPagePlaceholderRedirectUrl: "Ссылка для переадресации",
      resultPageScenarioSaveChanges: "Сохранить изменения",
      resultPageScenarioSaveChangesComplete: "Изменения сохранены",
      resultPageConditionSettingsTitle: "Настройки результатов по баллам",
      resultPageConditionSettingsDescription: "Задайте диапазон баллов для каждого сценария",
      resultPageConditionResultsColumn: "Результаты",
      resultPageConditionRangeSummary: "Максимальный диапазон баллов:",
      addNewSectionSubHeaderChoise: "Ввод/выбор ответа",
      addNewSectionSubHeaderResults: "Результаты",
      noTeamRole: "-",
      viewerTeamRole: "Наблюдатель",
      noAccessTeamRole: "Нет действий",
      editorTeamRole: "Редактор",
      managerTeamRole: "Менеджер",
      adminTeamRole: "Администратор",
      teamRoleGuideTitle: "Что означают роли",
      teamRoleGuideDescription: "Роль автоматически включает набор прав. После выбора роль сразу обновляется в интерфейсе, а кнопка Send отправляет выбранный доступ.",
      teamRoleGuideFlowOwner: "Владелец",
      teamRoleGuideFlowOwnerText: "выдаёт доступ",
      teamRoleGuideFlowRole: "Роль",
      teamRoleGuideFlowRoleText: "выбирает preset",
      teamRoleGuideFlowPermissions: "Права",
      teamRoleGuideFlowPermissionsText: "открывают действия",
      teamRoleGuideFlowResult: "Доступный UI",
      teamRoleGuideFlowResultText: "показывает кнопки",
      teamRoleGuideViewerDescription: "Может просматривать лиды и ответы по выбранным квизам.",
      teamRoleGuideEditorDescription: "Может редактировать квиз, копировать его и работать с публикацией.",
      teamRoleGuideManagerDescription: "Может редактировать квиз, видеть CRM, управлять интеграциями и делиться доступом дальше.",
      teamRoleGuideAdminDescription: "Получает все права: управление, интеграции, CRM, доступы, перенос, удаление и публикация.",
      canViewLeadsLabel: "Просмотр лидов",
      canViewLeadsDescription: "Может просматривать заявки, ответы и контакты",
      canCopyQuizLabel: "Копирование квиза",
      canCopyQuizDescription: "Может создавать копии выбранного квиза",
      canManageQuestionsLabel: "Редактирование квиза",
      canManageQuestionsDescription: "Может редактировать квиз, страницы, вопросы, варианты, консультантов, преимущества, контактные поля, соцсети и options",
      canManageIntegrationsLabel: "Интеграции",
      canManageIntegrationsDescription: "Может управлять интеграциями, ключами и вебхуками",
      canManageSettingsLabel: "Настройки",
      canManageSettingsDescription: "Может изменять домены, страницы и контактные поля",
      canShareLabel: "Доступы",
      canShareDescription: "Может приглашать других пользователей",
      canTransferLabel: "Передача квиза",
      canTransferDescription: "Может передать квиз другому пользователю",
      canDeleteLabel: "Удаление",
      canDeleteDescription: "Может удалять и восстанавливать квиз",
      canPublishLabel: "Публикация",
      canPublishDescription: "Может управлять публикацией и доменами",
      descriptionTeamView: "Добавьте участников и настройте доступы к проектам и квизам",
      addedUserInTeam: "В команде",
      teamAccessGivenTab: "Участники",
      teamAccessReceivedTab: "Источник доступа",
      teamAccessReceivedTitle: "Источник доступа",
      teamAccessSharedBy: "Владелец",
      teamAccessInvitedBy: "Предоставил доступ",
      teamAccessRoleLabel: "Роль",
      teamAccessScopeLabel: "Доступ",
      teamNoReceivedAccess: "Пока никто не дал вам доступ",
      teamNoGivenAccess: "Вы пока никому не предоставили доступ",
      teamAccessFrozen: "Доступ заморожен",
      teamFreezeAccess: "Заморозить доступ",
      teamUnfreezeAccess: "Разморозить доступ",
      teamPermissionDeniedTransfer: "Недостаточно прав для переноса квиза",
      teamPermissionDeniedDelete: "Недостаточно прав для удаления или восстановления квиза",
      teamPermissionDeniedShare: "Недостаточно прав для управления доступом",
      teamPermissionDeniedManageQuiz: "Недостаточно прав для редактирования квиза",
      teamPermissionDeniedCopy: "Недостаточно прав для копирования квиза",
      teamPermissionDeniedIntegrations: "Недостаточно прав для управления интеграциями",
      teamPermissionDeniedCrm: "Недостаточно прав для просмотра CRM",
      teamPermissionDeniedPublish: "Недостаточно прав для публикации квиза",
      teamPermissionDeniedSettings: "У вас нет прав для этого раздела настроек",
      teamPermissionDeniedOpenQuiz: "У вас нет доступных действий для этого квиза",
      teamAccessDeniedTitle: "Раздел недоступен",
      teamAccessDeniedDescription: "У вас нет прав для этого действия. Обратитесь к владельцу проекта, чтобы получить доступ",
      teamPermissionDeniedDefault: "Недостаточно прав для этого действия",
      teamQuizzesWithoutProject: "Квизы не в проекте",
      quickInviteTitle: "Пригласить участника",
      quickInviteEmailLabel: "Email",
      quickInviteQuizzesLabel: "Квизы, к которым дать доступ",
      quickInviteLoadingQuizzes: "Загрузка квизов…",
      quickInviteLoadQuizzesError: "Не удалось загрузить квизы.",
      quickInviteRetry: "Повторить",
      quickInviteNoQuizzes: "Нет квизов, которыми вы можете поделиться.",
      quickInviteRoleHint: "Участник получит выбранную роль в выбранных квизах. Изменить её можно позже на {link}.",
      quickInviteRoleHintLink: "странице Команда",
      quickInviteSubmit: "Пригласить",
      quickInviteSubmitting: "Отправка…",
      quickInviteSelfError: "Нельзя пригласить самого себя",
      quickInviteSelectQuiz: "Выберите хотя бы один квиз",
      quickInviteSuccess: "Приглашение отправлено: {email}",
      projectNoQuizzes: "0 квизов",
      quizzes: "квизов",
      sharedQuizzes: "Расшаренные квизы",
      sharedQuizzesWithoutProject: "Квизы не в проекте",
    },
    DE: {
      tariffLockBadgeLabel: "Pro",
      tariffLockBadgeReadOnlyLabel: "Nur lesen",
      tariffLockBadgeQuotaLabel: "Limit erreicht",
      tariffLockBadgeAriaLabel: "{label}: Funktion durch Ihren Tarif eingeschränkt",
      tariffUpgradeActionLabel: "Tarif upgraden",
      tariffLockBadgeOwnerAriaLabel: "{label}: Funktion durch den Tarif des Quiz-Inhabers eingeschränkt",
      tariffOwnerPlanFeatureUnavailableMessage: "Diese Funktion ist im Tarif des Quiz-Inhabers nicht enthalten. Bitte den Inhaber, auf einen Tarif mit dieser Funktion zu wechseln.",
      tariffOwnerAccessUnavailableMessage: "Der Tarif des Quiz-Inhabers konnte nicht geprüft werden. Lade die Seite neu.",
      tariffGateCollaborationForbiddenMessage: "Sie haben keine Berechtigung für diese Aktion in diesem Quiz.",
      tariffGateQuotaExhaustedMessage: "Sie haben das in Ihrem aktuellen Tarif enthaltene Limit ausgeschöpft. Wechseln Sie zu einem Tarif mit mehr Limit.",
      tariffGateGrandfatheredMessage: "Diese Funktion ist in Ihrem aktuellen Tarif nicht verfügbar. Vorhandene Daten bleiben sichtbar und können gelöscht werden, das Hinzufügen oder Bearbeiten ist jedoch deaktiviert. Wechseln Sie zu einem Tarif, der diese Funktion enthält.",
      tariffGateReadOnlyMessage: "Diese Funktion ist in Ihrem aktuellen Tarif nicht verfügbar und wird nur lesend angezeigt. Wechseln Sie zu einem Tarif, der diese Funktion enthält.",
      tariffGateUsageUnavailableMessage: "Die Nutzung dieser Funktion konnte nicht ermittelt werden. Bitte laden Sie die Seite neu.",
      tariffGateLoadingMessage: "Tarifzugang wird geprüft…",
      tariffGateUnavailableMessage: "Diese Funktion ist in Ihrem aktuellen Tarif nicht verfügbar. Wechseln Sie zu einem Tarif, der diese Funktion enthält.",
      tariffUpgradeModalDescription: "Wählen Sie einen Tarif, der diese Funktion enthält.",
      tariffUpgradeModalLoading: "Passende Tarife werden geladen…",
      tariffUpgradeModalError: "Passende Tarife konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
      tariffUpgradeModalEmpty: "Jahresabonnements werden in Kürze verfügbar sein.",
      tariffUpgradeModalRecommended: "Empfohlen",
      tariffUsageUnlimitedLabel: "Unbegrenzt",
      tariffUsageUsedOfLimitLabel: "{used} von {limit} verwendet",
      tariffUsageUnavailableLabel: "Nutzung nicht verfügbar",
      tariffUsageLoadingLabel: "Nutzung wird geladen…",
      tariffUsageUnknownLabel: "Nutzung unbekannt",
      notFoundEyebrow: 'Seite nicht gefunden',
      notFoundTitle: 'Dieses Quiz scheint verloren gegangen zu sein',
      notFoundDescription: 'Der Link ist möglicherweise falsch oder die Seite wurde verschoben. Kehren Sie zum Workboard zurück und erstellen Sie weiter Quizze.',
      notFoundPrimaryAction: 'Zur Startseite',
      notFoundSecondaryAction: 'Zurück',
      serverErrorEyebrow: 'Serverfehler',
      serverErrorTitle: 'Etwas ist schiefgelaufen',
      serverErrorDescription: 'Keine Sorge, wir arbeiten bereits daran. Aktualisieren Sie die Seite oder kehren Sie zu Ihrem Workboard zurück.',
      serverErrorPrimaryAction: 'Seite aktualisieren',
      serverErrorSecondaryAction: 'Zur Startseite',
      madeInUkr: "In Ukraine hergestellt",
      upProVersion: "Wechsel zu Pro",
      getLeads: "Kaufen Sie Leads",
      poperBillings: "Zahlung",
      poperTemplates: "Vorlagen",
      poperPartnership: "Partnerschaft",
      poperProfile: "Profil",
      poperLogout: "Abmelden",
      poperTeam: "Team",
      teamDelegatedAccessTitle: 'Zugriff weitergegeben',
      teamAccessTreeRootLabel: 'Zugriffsquelle',
      teamAccessVia: 'über',
      teamNoQuizNamesAvailable: 'Quiznamen sind nicht verfügbar',
      teamSharedShareTargetPrefix: 'Geteilt von',
      teamSharedOwnerFallback: 'Besitzer',
      teamMembersTab: 'Von mir geteilter Zugriff',
      teamAccessSourceTab: 'Mir gewährter Zugriff',
      teamAccessSourceTitle: 'Mir gewährter Zugriff',
      teamAccessTreeTab: 'Zugriffsketten',
      teamAccessTreeTitle: 'Zugriffsketten',
      teamAccessTreeDescription: 'Zeigt den Zugriffspfad: Besitzer → Einladender → Sie → Personen, mit denen Sie geteilt haben',
      teamAccessOwnerLabel: 'Besitzer',
      teamAccessInviterLabel: 'Geteilt von',
      teamAccessPath: 'Zugriffspfad',
      teamAccessYouLabel: 'Sie',
      teamSharedByYou: 'Von Ihnen geteilt',
      teamCanReshare: 'Kann weiterteilen',
      teamCannotReshare: 'Kann nicht weiterteilen',
      teamPartialReshare: 'Kann teilweise weiterteilen',
      teamMixedRoles: 'Gemischte Rollen',
      teamNoAccessTree: 'Ketten erscheinen, wenn Sie Zugriff weiterteilen',
      poperIdea: "Vorschlag machen",
      poperIdeaTitle: "Haben Sie eine Idee zur Verbesserung der Plattform?",
      poperIdeaText: "Teilen Sie sie mit uns! Ihre Vorschläge helfen uns, uns weiterzuentwickeln und ein besseres Erlebnis für Sie zu schaffen.",
      poperIdeaTextPlaceholder: "Beschreiben Sie Ihre Idee im Detail",
      poperIdeaSendButton: "Vorschlag senden",
      defaultNewQuestion: "Neue Frage",
      defaultNewQuestionDescription: "Hier können Sie eine kurze Beschreibung der Frage einfügen (bis zu 80 Zeichen)",
      defaultNewVariant: "Neue Option",
      defaultBtnText: "Start",
      navBillings: "Zahlung",
      navPartnership: "Partnerschaft",
      navProfile: "Profil",
      navTariffs: "Tarife",
      holidayBannerTitleLastOffer: "Finales Angebot des Jahres:",
      holidayBannerDefaultTitle: "Begrenztes Angebot",
      holidayBannerFrom: "vom",
      holidayBannerTo: "bis",
      holidayBannerCta: "Rabatt erhalten",
      holidayBannerAuthTitle: "Melde dich an, um den Rabatt zu erhalten",
      holidayBannerAuthText: "Logge dich ein, um dieses Angebot zu nutzen und es mit deinem Konto zu verknüpfen.",
      holidayBannerAuthAction: "Alles klar",
      holidayBannerClose: "Banner schließen",
      welcomeBack: "Willkommen zurück!",
      loginHeader: "Anmeldung zu meinem Koto",
      loginHeader2Part: "to Continue",
      loginEmailPlaceholder: "E-mail",
      loginPasswordlPlaceholder: "○ ○ ○ ○ ○ ○ ○ ○ ○",
      loginBtnValue: "Anmelden",
      loginWith: "Anmelden mit",
      passwordAreForgetPassword: "Haben Sie Ihr Passwort vergessen?",
      passwordResetPasswordHeader: "Passwort zurücksetzen",
      passwordResetPassword: "Zurücksetzen Passwort",
      passwordWeSentReset: "Wir haben Ihnen eine E-Mail zum Zurücksetzen Ihres Passwortes geschickt.",
      passwordInputNewPassword: "Neues Passwort eingeben",
      passwordConfirmPassword: "Passwort bestätigen",
      passwordCreatePassword: "Passwort erstellen",
      passwordChangePassword: "Passwort speichern",
      passwordResetedPasswordCompleted: "Ihr Passwort wurde erfolgreich geändert!",
      passwordGoToWorkboard: "Zum Workboard gehen",
      loginSignup: "Registrieren Sie sich",
      helloHeader: "Hallo!",
      signupHeader: "Registrieren",
      signupHeader2Part: "weitermachen",
      signupNamePlaceholder: "Oleksander",
      signupPhonePlaceholder: "Telefonnummer",
      signupEmailPlaceholder: "E-mail",
      signupPasswordlPlaceholder: "○ ○ ○ ○ ○ ○ ○ ○ ○",
      signupBtnValue: "Ein Konto erstellen",
      signupWith: "Anmelden mit",
      signupLogin: "Anmeldung zum Konto",
      signupTariffHeader: "Tarif",
      signupTariffFree: "Kostenslos.",
      signupTariffPro: "Pro.",
      signupTariffFreeDescription: "Unbegrenzte Anzahl der Erstellung von neuen Quizzen (Webseiten). Die Möglichkeit kostenlos bis zu 300 Anwendungen pro Monat zu erstellen.",
      signupTariffProPrice: "$20/Monat",
      signupTariffProDescription: "Unbegrenzte Anzahl der Erstellung von neuen Quizzen (Webseiten). Die Möglichkeit zum Erstellen",
      signupTariffProDescriptionBold: "von bis zu 300 Anwendungen pro Monat. ",
      userBackToQuiz: "Zurück zur Arbeitstafel",
      userBackToSettings: "Zurück zu den Einstellungen",
      learningCenterTitle: "Learning Center",
      learningCenterTraining: "Training",
      learningCenterIntroText: "Sehen Sie sich alle erforderlichen Videoanleitungen der Reihe nach an, bestätigen Sie jede Lektion nach dem Ende und fordern Sie Ihr Zertifikat nach der letzten Lektion an.",
      learningCenterVideoUnsupported: "Ihr Browser unterstützt kein HTML5-Video.",
      learningCenterAvailable: "Verfügbar",
      learningCenterLessonsComplete: "Lektionen abgeschlossen",
      learningCenterBackToLearningCenter: "Zurück zum Learning Center",
      learningCenterCertificate: "Zertifikat",
      learningCenterCourseCompleted: "Kurs abgeschlossen",
      learningCenterCertificateSentText: "Alle Lektionen sind abgeschlossen. Die Zertifikatsanfrage wurde an das Backend gesendet.",
      learningCenterCertificateLabel: "Adsquiz Learning Center",
      learningCenterCertificateOfCompletion: "Abschlusszertifikat",
      learningCenterDownloadCertificate: "Zertifikat herunterladen",
      learningCenterDownloadUnavailable: "Download noch nicht verfügbar",
      learningCenterOpenCertificate: "Zertifikat öffnen",
      learningCenterAbout: "Über die Lektion",
      learningCenterOpenFallbackLink: "Fallback-Link öffnen",
      learningCenterBack: "Zurück",
      learningCenterCompleted: "Abgeschlossen",
      learningCenterWatchVideoToEnd: "Sehen Sie das Video bis zum Ende an",
      learningCenterSaving: "Speichern...",
      learningCenterMarkAsCompleted: "Als abgeschlossen markieren",
      learningCenterWatchedPercent: "{percent}% angesehen",
      learningCenterDefaultUserName: "Adsquiz-Benutzer",
      learningCenterCertificateReadyMessage: "Das Backend hat eine Zertifikatsdatei zurückgegeben. Verwenden Sie die Schaltfläche oben, um sie zu öffnen.",
      learningCenterCertificatePendingMessage: "Die Zertifikatsanfrage wurde gesendet. Fügen Sie die Backend-Download-URL hinzu, sobald sie verfügbar ist.",
      learningCenterCertificateNoUrlMessage: "Die Zertifikatsanfrage wurde abgeschlossen, aber es wurde noch keine Datei-URL zurückgegeben.",
      learningCenterCertificateErrorMessage: "Die Zertifikatsanfrage konnte vom Backend noch nicht bestätigt werden. Der lokale Abschluss wurde gespeichert.",
      learningCenterSectionGeneral: "Allgemein",
      learningCenterSectionIterationsIntro: "Einführung in Iterationen",
      learningCenterSectionIterationIntro: "Einführung in die Iteration",
      billingYourTariff: "Ihr Plan",
      billingYourTariffShortForm: "Ihr Plan",
      billingYourPro: "Pro",
      billingYorFree: "Kostenlos",
      billingFreeLeads: "Kostenlose Leads",
      billingInfinity: "unbegrenzt",
      billingTariffRenewData: "Datum der Verlängerung des Tarifs",
      billingTariffEndData: "Enddatum des Plans",
      billingOtherTariffFree: "Kostenlos.",
      billingOtherTariffPro: "Pro.",
      billingTariffFreeDescription: "Unbegrenzte Anzahl der Erstellung von neuen Quizzen (Webseiten). Die Möglichkeit kostenlos bis zu 300 Anwendungen pro Monat zu erstellen.",
      billingYouHavePro: "Wenn Sie derzeit die Pro-Version verwenden, warum sollten Sie einen Schritt zurück gehen?",
      billingYouHasFreeLeads: "Kostenlose Leads",
      billingYouHasLeads: "Verbleibende Leads",
      billingTariffProDescription: "Unbegrenzte Anzahl der Erstellung von neuen Quizzen (Webseiten). Die Möglichkeit zum Erstellen",
      billingTariffProDescriptionBold: "von mehr als 300 Anwendungen",
      billingYourFutureTariff: "Ihr zukünftiger Plan",
      billingBtnChangeToPro: "Wechsel zu Pro",
      billingBtnRenewPro: "Verlängern",
      billingBillings: "Zahlung",
      billingYouHaveNotBillings: "Sie haben noch keine Zahlung",
      billingPaymentsMethod: "Zahlungsweise",
      billingPaymentCard: "Karte",
      billingChangeData: "Daten ändern",
      billingDeletePayMethod: "Löschen",
      billingModalDeleteShure: "Sind Sie sicher, dass Sie diese Zahlungsmethode entfernen möchten?",
      billingModalDeleteCancel: "Abbrechen",
      billingModalDeleteOk: "Löschen",
      billingModalDeleteSuccess: "Wir haben Ihre Karte erfolgreich gelöscht",
      billingModalRegularPaymentDeleteSuccess: "Regelmäßige Zahlungen werden eingestellt",
      billingModalRegularPaymentDeleteOk: "Ok",
      billingYourMonthPlan: "Dein monatlicher Tarif",
      billingLeads: "Leads",
      billingChangePlan: "Ändere den Tarif",
      billingChangePlanDescription: "Der Preis richtet sich nach der gewünschten Anzahl von Bewerbern aus alle Quizzen Ihres Kontos",
      billingSelectPeriod: "Zeitraum auswählen",
      billingChangePlanDescriptionImportant: "Wichtig:",
      billingChangePlanDescriptionImportantMonth: "Die Leads können 1 Monat nach dem Kauf verwendet werden. ",
      subscriptionTariffLable: "Abonnieren Sie unser automatisches Abonnement.",
      billingChangePlanWarning: "",
      billingTariffMonth: "mon.",
      billingChangePlanPay: "Kupić",
      profileName: "Name",
      profilePhone: "Telefonnummer",
      profileEmail: "E-Mails",
      profileStatus: "Status",
      profileStatusAgency: "Agentur",
      profileStatusPlaceholder: "Was beschreibt Sie besser?",
      profileStatusFreelancer: "Freiberufler",
      profileStatusBuisines: "Geschäftsinhaber",
      profilePassword: "Passwort",
      profileChangePassword: "Passwort ändern",
      profileNewPassword: "Neues Passwort",
      profileSaveNewData: "Daten aktualisieren",
      workboardStartTooltip: "Hier kannst du dein erstes Quiz erstellen",
      workboardAddNewQuiz: "Projekt erstellen",
      workboardModalGiveQuizName: "Geben Sie dem Quiz einen Namen",
      workboardModalQuizNamePlaceholder: "Neues Quiz",
      workboardModalNewQuizBtnValue: "Hinzufügen",
      workboardAlertGiveAnyName: "Tragen Sie einen beliebigen Namen ein",
      workboardAlertNextTimeAddQuiz: "Na ja, nächstes Mal sollten Sie sich trauen.",
      workboardChangeQuizName: "Ändern Sie den Namen ",
      workboardQuizLink: "Link",
      workboardQuizLinkCopied: "Der Link wird in die Zwischenablage kopiert",
      workboardEditQuiz: "Bearbeiten",
      workboardCopyQuiz: "Quiz kopieren",
      workboardQuizCopied: "Quiz erfolgreich kopiert",
      workboardDeleteQuiz: "Löschen",
      workboardTransferQuizPlaceholderInput: "Geben Sie die E-Mail-Adresse des Benutzers ein",
      workboardTextAllQuizes: "Alle Quizze",
      workboardTextProjects: "Projekte",
      workboardTransferQuiz: "Quiz auf ein anderes Konto übertragen",
      workboardTransferProject: "Zum Projekt hinzufügen",
      workboardTransferQuizCancel: "Abbrechen",
      workboardTransferQuizLabel: "Quiz-Titel",
      workboardTransferQuizTitle: "Testen Sie Ihr Wissen über Umweltschutz!",
      workboardTransferQuizHintTitle: "Beim Übertragen des Quizzes werden alle Anfragen mitübertragen.",
      workboardTransferQuizHintTitleSecond: "Um das Quiz mit den Einsendungen zu übertragen, muss einer der Nutzer über ein beliebiges kostenpflichtiges ",
      workboardTransferQuizHintTitleSecondLink: "https://app.adsquiz.io/tariffs",
      workboardTransferQuizHintTitleSecondLinkText: "Paket verfügen.",
      workboardTransferQuizConfirm: "Übertragen",
      workboardTransferQuizNoValidEmail: "Ungültige E-Mail-Adresse",
      workboardTransferQuizStatus200: "Quiz wurde erfolgreich übertragen auf:",
      workboardTransferQuizStatus401: "Nicht autorisiert — Der Benutzer ist nicht authentifiziert.",
      workboardTransferQuizStatus403: "Verboten — Sie haben keinen Zugriff, um dieses Quiz zu übertragen.",
      workboardTransferQuizStatus404: "Nicht gefunden — Quiz oder Empfänger-Benutzer nicht gefunden.",
      workboardTransferQuizStatus422: "Nicht verarbeitbare Entität — Mindestens ein Benutzer muss ein kostenpflichtiges Konto haben.",
      workboardTransferQuizStatusError: "Unerwarteter Fehlerstatus",
      workboardModalRemoveQuizTrash: "Dieses Quiz wird in den Papierkorb verschoben und nach 1 Monat dauerhaft gelöscht.",
      workboardModalRemoveQuizSure: "Sind Sie sicher, dass Sie dieses Quiz in den Papierkorb verschieben möchten?",
      workboardModalRemoveProjectTrash: "Das Projekt und alle dazugehörigen Quizze werden dauerhaft gelöscht.",
      workboardModalRemoveProjectSure: "Sind Sie sicher, dass Sie dieses Projekt löschen möchten?",
      workboardModalDeleteQuizCancel: "Abbrechen",
      workboardModalDeleteQuizDelete: "Löschen",
      workboardModalDeleteQuizSuccess: "Sie haben das Quiz erfolgreich gelöscht",
      workboardModalDeleteProjectSuccess: "Das Projekt wurde erfolgreich gelöscht",
      workboardModalQuizDeleteOk: "Ok",
      workboardStatsTitle: "Statistik",
      workboardModalLeadsAnswersCount: "Antworten auf die Frage",
      workboardModalLeadsLeadSerial: "№",
      workboardModalLeadsLeadDate: "Datum",
      workboardModalLeadsLeadEmail: "Email",
      workboardModalLeadsLeadName: "Namen",
      workboardModalLeadsLeadPhone: "Telefonnummer",
      workboardModalLeadsLeadPoints: "Punkte",
      workboardModalLeadsLeadActions: "Aktionen",
      workboardModalLeadsLeadShowMore: "Mehr sehen",
      workboardModalLeadsLeadHideMore: "Ausblenden",
      workboardModalLeadsLeadAnswerScipped: "Übersprungen",
      workboardModalNoLeads: "Bsiher keine Hinweise",
      constructorLink: "Link",
      constructorLinkCopied: "In die Zwischenablage kopiert: ",
      constructorNavSteps: "Schritte",
      constructorNavDesign: "Entwurf",
      constructorNavSettings: "Einstellungen",
      constructorStep: "Schritte",
      cancel: "Abbrechen",
      constructorCancel: "Abbrechen",
      constructorSave: "Sichern",
      constructorextraNavStart: "S",
      constructorextraNavContact: "C",
      constructorextraNavFinish: "F",
      cstepsSection: "Abschnitte",
      cstepsStartPage: "Startseite",
      cstepsContactPage: "Kontaktformular",
      cstepsFinishPage: "Letzte Seite",
      cstepsEdit: "Bearbeiten",
      cstepsMove: "Verschieben",
      cstepsDeleteStep: "Schritt löschen",
      cstepsAddSection: "Abschnitt hinzufügen",
      cdesignColorTheme: "Farb Design",
      cdesignCustomTheme: "Kundenfarbthema",
      cdesignDefaultThemes: "Unsere Farbthemen",
      cdesignThemeStandart: "Standard",
      cdesignThemeDark: "Schwarz",
      cdesignThemeNud: "Hautfarbe",
      cdesignThemeGradient: "Farbverlauf",
      cdesignShapeDesign: "Design Vorlage",
      cdesignShapeRound: "Gerundet",
      cdesignShapeSquare: "Eckig",
      cdesignShapeRectangle: "Rechteck",
      cdesignShapeCircle: "Kreis",
      cdesignPositionLeft: "Links",
      cdesignPositionMiddle: "Mitte",
      cdesignPositionRight: "Rechts",
      cdesignPositionTop: "Oben",
      cdesignPositionBottom: "Unten",
      csettingsIntegration: "Integration",
      csettingsOweDomain: "Eigene Domain verknüpfen",
      csettingsDocs: "Rechtliche Dokumente",
      cintegrationIntegration: "Integration",
      cintegrationShareLeads: "Leads teilen",
      cintegrationTitleEmail: "E-Mail",
      cintegrationInstruction: "Anleitung",
      cintegrationInstructionDetail: "Einzelheiten",
      cintegrationEmailInstruction: "Schicken Sie eine E-Mail an Ihren Befrgaten aus und banachrichtigenb Sie Ihr Team. Arbeiten Sie mit Ihrem Team zusammen.",
      cintegrationPublishAfterEdit: "Speichern Sie das Quiz nach der Bearbeitung",
      cintegrationSendNewLeadsTo: "Sende Sie eine Nachricht über neue Leads an: ",
      cintegrationInputEmail: "Eingabe E-Mail",
      cintegrationAddEmail: "E-Mail hinzufügen",
      cintegrationEmailSaved: "E-Mail sichern",
      cintegrationEmailDeleted: "E-Mail löschen",
      cintegrationTitleFB: "FB pixel ",
      cintegrationIDPixel: "Pixel ID",
      cintegrationFBInstruction1: "Gehen Sie zum Facebook Ads-Bereich und kopieren Sie die Facebook Pixel-ID in den Event Manager-Bereich.",
      cintegrationFBInstruction2: "Kopieren Sie nicht den gesamten Code, sondern nur die 15-16-stellige ID.",
      cintegrationFBInstruction3: "Kopieren und in das unten stehende Feld einfügen. ",
      cintegrationFBInstruction: 'Das Ereignis, für das Sie die Konvertierung konfigurieren müssen, ist "Lead". Diese Veranstaltung wird aufgerufen, sobald der Benutzer eine Bewerbung im Quiz abgibt.',
      cintegrationFBInstructionTextTitle: "Liste aller gesendeten Ereignisse:",
      cintegrationFBInstructionTextTextStart: " – Besuch der Startseite;",
      cintegrationFBInstructionTextQuestionN: " – Besuch von Schritt N;",
      cintegrationFBInstructionTextOpenContactPage: " – Besuch der Kontaktseite;",
      cintegrationFBInstructionTextLead: " – erfolgreiche Übermittlung des Kontaktformulars;",
      cintegrationFBInstructionTextThankYou: " – Besuch der Abschlussseite.",
      bold_adsquiz_Start: "adsquiz_Start",
      bold_adsquiz_QuestionN: "Question_N",
      bold_adsquiz_OpenContactPage: "Open_Contact-Page",
      bold_adsquiz_Lead: "Lead",
      bold_adsquiz_ThankYou: "adsquiz_ThankYou",
      cintegrationInputIDPixel: "Eingabe Pixel-ID",
      cintegrationDataFBSaved: "Pixel FB-Daten gespeichert",
      cintegrationAccesToken: "Zugangstoken",
      cintegrationTitleGA: "Google Analytics",
      cintegrationGAInstructionDescription: "Erfahren Sie, wie Nutzer Ihr Quiz finden und damit interagieren. Erhalten Sie hierzu die Daten, die Sie benötigen, um Ihre Kampagnen zu analysieren, Konversionen zu verbessern und vieles mehr.",
      cintegrationGAInstruction: 'Wenn eine Quiz-Bewerbung in Google Analytics eingeht, wird das Ereignis "generate_lead" ausgelöst.',
      cintegrationIDFolow: "Tracking-ID",
      cintegrationInputID: "Eingabe-ID",
      cintegrationDataGASaved: "Gespeicherte Google-Analytics-Daten",
      cintegrationTitleGTM: "Google Tag Manager",
      cintegrationGTMInstructionDescription: "Beschreibung für Google Tag Manager.",
      cintegrationGTMInstruction: "Kopieren Sie die Google Tag Manager-ID und fügen Sie diese in das unten stehende Feld ein.",
      cintegrationDataGTMSaved: "Google Tag Manager Daten gespeichert",
      cintegrationTitleTG: "Telegram",
      cintegrationHowReciveTGLeadBot: "Wie bekommt man Leads in Telegram?",
      cintegrationTGInstructionBot1: "1. Kopieren Sie das Token in das unten stehende Eingabefeld.",
      cintegrationTGInstructionBot2: '2. Folgen Sie dem Link zum Bot, klicken Sie auf den "Start" Button.',
      cintegrationTGInstructionBot3: "3. Senden Sie das kopierte Token als Nachricht an unseren Bot.",
      cintegrationHowReciveTGLeadChat: "Wie bekommen Sie Bewerbungen im Telegram-Chat?",
      cintegrationTGInstructionChat1: "1. Fügen Sie unseren Bot zum gewünschten Chat hinzu und setzen Sie den Bot auf den Administratorstatus.",
      cintegrationTGInstructionChat2: "2. Kopieren Sie den Token in das unten stehende Feld und senden Sie ihn an den gewünschten Chat.",
      cintegrationTGInstructionChat3: '3. Warten Sie auf die Antwort "OK! Ihr Quiz-Token wurde gespeichert!"',
      cintegrationTGInstructionChat4: "4. Die Leads werden nun an diesen Chat gesendet.",
      cintegrationTGInstructionWarning: "Wichtig:",
      cintegrationTGInstructionWarningText: "Bitte beachten Sie, dass es sich um eine Gruppe und nicht um einen Telegram-Kanal handeln sollte. Leads werden nicht an den Telegram-Kanal gesendet.",
      cintegrationTGBotLink: "Chatbot Link",
      cintegrationTGTitleToken: "Token",
      cintegrationInputTGToken: "Telegram Chatbot Token eingeben",
      cintegrationAddIntegration: "Integration hinzufügen",
      cintegrationDataTGSaved: "Telegram-Integrationsdaten gespeichert",
      cintegrationTitleTT: "TT Pixel",
      cintegrationTTInstruction: "Um Ereignisse in Ihrem Tik-Tok-Konto zu verfolgen, kopieren Sie die Pixel-ID und fügen Sie diese in das unten sthendde Feld ein.",
      cintegrationDataTTSaved: "Pixel TT-Daten gespeichert",
      cintegrationTitleWH: "WebHook",
      cintegrationWHInstruction1: "Sie können Anwendungen von Drittanbeitern über eingehende Leads benachrichtigen. Geben Sie dazu die URL an, an die der WebHooker gesendet werden soll. ",
      cintegrationWHInstruction2: "Wir haben vorbereitet",
      cintegrationWHInstruction3: "Video Anleitung",
      cintegrationWHInstruction4: "mit einer ausführlichen Beschreibung dieser Funktionalität. ",
      cintegrationWHInstruction5: "Siehe Video.",
      cintegrationWHInstruction6: "In diesem Video sehen wir die Übergabe eines Hooks, der afu dem Senden von Daten an ein Google Spreadsheet und dem Senden von Daten an ein Trello CRM-System basiert.",
      cintegrationWHInstruction7: "Wir empfehlen, den Dienst zu diesem Zweck zu nutzen.",
      cintegrationWHInstruction8: "Wenn Sie sich über diesen Link registrieren, gibt es für Sie als Nutzer einen Bonus von 10.000 kostenlosen Aktionen für alle Integrationen. ",
      cintegrationWHInstruction9: "Link",
      cintegrationWHInstruction10: "um sich für den Bonus zu registrieren. ",
      cintegrationWHUrl: "Die Webhook-URLs",
      cintegrationInputWHUrl: "Eingabe der Webhook-URL",
      cintegrationAddWH: "Hinzufügen eines Web-Hook",
      cintegrationWebHookDataSaved: "Web-Hook Daten gesichert",


      cintegrationComonWHInstructionShort: "Sie können Drittanbieteranwendungen über eingehende Leads informieren. Geben Sie die Webhook-URL für die Datenübermittlung an.",
      cintegrationComonWHInstruction1Title: "1. Fügen Sie die Webhook-URL in das Eingabefeld ein:",
      cintegrationComonWHInstruction1Description: "Fügen Sie die Webhook-URL, die Ihr Service oder Ihre Anwendung bereitstellt, in das Eingabefeld ein.",
      cintegrationComonWHInstruction2Title: "2. Änderungen speichern:",
      cintegrationComonWHInstruction2Description: 'Klicken Sie auf die Schaltfläche "Änderungen speichern", um die Einstellungen des Webhooks zu speichern.',
      cintegrationComonWHInstruction3Title: "3. Fertig:",
      cintegrationComonWHInstruction3Description: "Ihr Webhook ist jetzt so konfiguriert, dass Daten an den von Ihnen ausgewählten Service gesendet werden.",
      cintegrationComonWHInstructionAdditional: "Daten werden bei jedem empfangenen Lead an den Webhook gesendet. Die Übertragung erfolgt über die POST-Methode. Ein Beispiel für die gesendeten Daten finden Sie ",
      cintegrationComonWHInstructionAdditionalLink: "hier",
      cintegrationComonWHInstructionVideo: "Ausführliche Videoanleitung",
      
      cintegrationApixDriveWHInstructionShort: "Sie können ApixDrive über eingehende Leads informieren. Geben Sie dazu die URL an, an die der WebHook gesendet wird.",
      cintegrationApixDriveWHInstructionShort1: "Bei der Anmeldung über ",
      cintegrationApixDriveWHInstructionShort2: "diesen Link",
      cintegrationApixDriveWHInstructionShort3: " erhalten unsere Benutzer einen Bonus von 10.000 kostenlosen Aktionen für beliebige Integrationen.",
      cintegrationApixDriveWHInstruction1Title: "1. Registrieren Sie sich oder öffnen Sie Ihr ApixDrive-Konto:",
      cintegrationApixDriveWHInstruction1Description1: "Link ",
      cintegrationApixDriveWHInstruction1Description2: "für die Anmeldung mit Bonus.",
      cintegrationApixDriveWHInstruction2Title: "2. Holen Sie sich die URL-Adresse für den Webhook:",
      cintegrationApixDriveWHInstruction2Description1: "Gehen Sie zu den Einstellungen der erforderlichen Verbindung und kopieren Sie die Adresse für den Versand des Webhooks:",
      cintegrationApixDriveWHInstruction2Description2: 'Sie können eine neue Verbindung erstellen, indem Sie auf die Schaltfläche "Verbindung erstellen" klicken und im Schritt zur Auswahl des Systems "ADSQuiz" auswählen.',
      cintegrationApixDriveWHInstruction3Title: "3. Fügen Sie die URL des Webhooks ein:",
      cintegrationApixDriveWHInstruction3Description: "Fügen Sie die vom ApixDrive bereitgestellte URL des Webhooks in das Eingabefeld ein.",
      cintegrationApixDriveWHInstruction4Title: "4. Speichern Sie die Änderungen:",
      cintegrationApixDriveWHInstruction4Description: 'Klicken Sie auf die Schaltfläche "Änderungen speichern", um die Einstellungen des Webhooks zu speichern.',
      cintegrationApixDriveWHInstruction5Title: "5. Fertig:",
      cintegrationApixDriveWHInstruction5Description: "Ihr Webhook ist jetzt so konfiguriert, dass Daten an ApixDrive gesendet werden.",
      cintegrationApixDriveWHInstructionAdditional: "Daten werden bei jedem empfangenen Lead an den Webhook gesendet. Die Übertragung erfolgt über die POST-Methode. Ein Beispiel für die gesendeten Daten finden Sie ",
      cintegrationApixDriveWHInstructionAdditionalLink: "hier",
      cintegrationApixDriveWHInstructionVideo: "Ausführliche Videoanleitung",
      



      cintegrationConnectOweDomain: "Veerknüpfung mit Ihrer eigenen Domain",
      cintegrationOweDomainInstruction1: "1. Um Ihr Quiz auf der gewünschten Domain zu platzieren, loggen Sie sich in Ihr Hostiung-Konto ein. Gehen Sie zu den DNS-Einstellung und erstellen Sie einen A-Eintrag mit dem IP-Parameter: 185.25.117.21",
      cintegrationOweDomainInstruction2: "2. Geben Sie die Domain in das Feld oben ein und speichern Sie das Quiz.",
      cintegrationDomain: "Domain",
      cintegrationInputYourDomain: "Eingabe Ihrer Domain",
      cintegrationCheckDomenIsCorrect: "Prüfen Sie, ob die eingegebene Domain korrekt ist",
      cintegrationDomainWhichCorrect: "Geben Sie eine Domain ohne Protokolle ein. Zum Beispiel: some.site.com",
      cintegrationInsertedDefaultDomain: "Die Domain ist standardmäßig eingestellt",
      cintegrationDomainDataSaved: "Domaindaten gesichert",
      cintegrationPrivacyPolicy: "Datenschutzbestimmungen",
      cintegrationPrivacyPolicyByDefault: "Standardmäßig verwenden wir unsere Standard-Datenschutzrichtlinie. Wir empfehlen Ihnen, Ihre eigene Datenschutzrichtlinie hinzuzufügen, die für Ihr Unternehmen relevant ist.",
      cintegrationPrivacyPolicyAdventage: "Dadruch wird Ihren potenziellen Kunden deutlich, wie Sie die erhaltenen Kontaktinformationen verwenden. Dies wird auch von einigen Werbeplattformen verlangt.",
      cintegrationPrivacyPolicyUrl: "Link zu Dokumenten",
      cintegrationPrivacyPolicyInputYourDocsLink: "Link zu Doumenten einfügen ",
      cintegrationDocsDataSaved: "Link zu Ihren Dokumenten speichern",
      allstepsUpploadPhoto: "Laden Sie ein Bild hoch",
      unsplashSelectorButtonText: "Aus Unsplash wählen",
      unsplashSelectorTitle: "Bild hochladen",
      unsplashSelectorDragImage: "Ziehen Sie ein Bild hierher oder",
      unsplashSelectorUploadFile: "laden Sie eine Datei hoch",
      unsplashSelectorSearchPlaceholder: "Bild auf Unsplash suchen",
      unsplashSelectorLoadingImages: "Bilder werden geladen...",
      unsplashSelectorLoadingMoreImages: "Weitere Bilder werden geladen...",
      unsplashSelectorNoImagesFound: "Keine Bilder gefunden",
      unsplashSelectorUnavailable: "Unsplash ist derzeit nicht verfügbar. Sie können eine Datei hochladen.",
      unsplashSelectorClose: "Schließen",
      allstepsChangePhoto: "Ändern Sie das Bild",
      allstepsDeletePhoto: "Löschen Sie das Bild",
      allstepsTitle: "Titel",
      allstepsDescription: "Beschreibung",
      allstepsButtonText: "Button Text",
      allstepsOtherSettings: "Andere Einstellungen",
      allstepsIsSaveBeforeRoute: "Daten vor dem Ändern der Route speichern?",
      cfirstFormat: "Format",
      cfirstHeaderStartText: "Hier sollte Ihre Überschrift stehen. Motivieren Sie die Nutzer, das Quiz bis zum Ende auszufüllen ",
      cfirstAddMediafile: "Medium (Bild) hinzufügen",
      cfirstBonus: "Bonus",
      cfirstAddBonus: "Bonus hinzufügen",
      cfirstStartPageDataUpdated: "Die Daten auf Ihrer Startseite wurden aktualisiert",
      csanyAnswerType: "Fragen-Typ",
      csanyATCard: "Karte",
      csanyATList: "Liste",
      csanyATCustom: "Freies Feld",
      csanyQuestion: "Frage ",
      csanyAnswers: "Antworten",
      csanyAddAnswer: "Antworten hinzufügen",
      csanyTitleForModalConfirm: "Diese Aktion ist unwiderruflich!",
      csanyQuestionForModalConfirm: "Sind Sie sicher, dass Sie diese Frage löschen möchten?",
      csanyRequiredStep: "Erforderlicher Schritt",
      csanyAlowMultiple: "Mehrfachantworten erlaubt",
      csanyAutoRedirect: "Automatische nächste Frage",
      csanyQuestionLogic: "Einrichtung der Fragelogik",
      csanyDataStepUpdated: "Datenschritt aktualisieren",
      cformForm: "Formular",
      cformValueName: "Name",
      cformValueSurname: "Nachname",
      cformValuePhone: "Telefonnummer",
      cformValueEmail: "E-Mail",
      cformDataContactsPageUpdated: "Datenkontakte-Seite aktualisiert",
      cformRequiredInput: "Pflichtfeld",
      cfinishFinishPageTitle: "Letzte Seite",
      cfinishText: "Text",
      cfinishDescription: "Beschreibung",
      cfinishAddImage: "Fügen Sie ein Bild hinzu",
      cfinishImageAdded: "Bild hinzugefügt",
      cfinishURL: "URL",
      cfinishButtonText: "Button Text",
      cfinishInsertNikname: "Spitznamen einfügen",
      cfinishCheckDataIsCorrect: "Prüfen Sie, ob die eingegebene ID korrekt ist",
      cfinishFbWhichCorrect: "Geben Sie eine ID ohne weitere Adresse ein. Zum Beispiel: some.name",
      cfinishIgWhichCorrect: "Geben Sie eine ID ohne weitere Adresse ein. Zum Beispiel: some.name",
      cfinishTgWhichCorrect: "Geben Sie eine ID ohne weitere Adresse ein. Zum Beispiel: some.name",
      cfinishFinishPageDataUpdated: "Die Daten der letzten Seite wurden aktualisiert",
      adminUsersReg: "Nutzer im System",
      adminNewUsers: "Neuer Nutzer pro Monat",
      adminProAccounts: "Pro Account",
      adminLTV: "LTV",
      adminSharePro: "Pro im Vergleich zu allen anderen",
      adminReciveLeads: "Erhaltende Leads",
      adminLeadsForOne: "Leads pro Nutzer",
      adminMadeQuiz: "Gemachte Quizze",
      adminQuizForOne: "Quiz pro Nutzer",
      adminAvarageUsed: "Durchschnittliche Nutzer pro Monat",
      adminProfitMonth: "Gewinn im Monat",
      adminProfitAlltime: "Verdienst über die gesamte Zeit",
      adminUsersList: "Nutzerbasis",
      notificationErrorLogin: "Autorisierungsfehler:",
      notificationLogin: "Login…",
      notificationWrongLoginData: "Falsche Anmeldedaten",
      notificationLoginAccountBlocked: "Ihr Konto wurde gesperrt",
      notificationCanContactSupport: "Sie k?nnen den Support kontaktieren",
      notificationEmailExistsMessage: "Ein Konto mit dieser E-Mail ist bereits registriert",
      notificationNetworkError: "Überprüfen Sie Ihre Internetverbindung",
      notificationInputLoginData: "Anmeldedaten eingeben",
      notificationCheckInputEmail: "Überprüfen Sie , ob Ihre E-Mail-Adresse korrekt ist",
      notificationCheckInputEmailOrUserNotFound: "Überprüfen Sie die E-Mail-Adresse. Benutzer nicht gefunden",
      notificationCheckInputPhone: "Prüfen Sie, ob Ihre Telefonnummer korrekt ist",
      notificationInputAllInputs: "Füllen Sie alle Felder für die Registrierung aus",
      notificationAgreePrivacyPolicy: "Akzeptieren Sie die Datenschutzbestimmungen",
      adminEditorForPartnership: "Editor für Partnerprogramme",
      developmentPage: "Abschnitt befindet sich in der Entwicklung",
      signupAgreeIAgreeWith: "Ich habe",
      signupAgreePolicy: "die Datenschutzrichtlinie",
      signupAgreeAnd: "und",
      signupAgreeOffer: "die Nutzungsbedingungen",
      signupAgreeService: "gelesen und stimme ihnen zu.",
      workboardModalLeadsLeadReferrer: "Unklar",
      workboardEditTitle: "Titel bearbeiten",
      workboardEditIcon: "Symbol bearbeiten",
      workboardSaveChange: "Änderungen speichern",
      workboardModalLeadsLeadReferrerClarification: "Verweis-Daten durch Quelle blockiert oder undefiniert",
      workboardModalLeadsLeadEmailCopied: "E-Mail in die Zwischenablage kopiert",
      workboardModalLeadsLeadPhoneCopied: "Telefonnummer in die Zwischenablage kopiert",
      workboardModalLeadsHaveNotSended: "Sie haben die nicht gesendeten Leads",
      workboardModalLeadsLeadReload: "Empfangen Sie",
      workboardModalLeadsLeadReloadedTitle: "Anfrage erhalten",
      workboardModalLeadsLeadReloaded: "",
      cfirstStartPagePhotoUpdated: "Das Foto auf der Startseite wurde aktualisiert",
      allstepsPhotoTooBig: "Datei ist zu groß!",
      allstepsPhotoMustBeLess: "Muss kleiner sein als",
      cfirstStartPageBonusPhotoUpdated: "Das Bonusfoto wurde aktualisiert",
      cstepsQuestionsOrderSaved: "Reihenfolge der Frage gespeichert",
      csanyAnswerOrderSaved: "Reihenfolgen der Antworten gespeichert",
      allstepsPhotoAdaptation: "Fotoanpassung für Geräte",
      allstepsPhotoFit: "Seitenverhältnis",
      constructorYouHideStep: "Dieser Schritt wurde übersprungen",
      cstepsHiddenStep: "Schritt überspringen",
      cstepNo_animation: "Keine Animation",
      cstepAnimation: "Animation",
      cstepKick_animation: "Stoß",
      cstepFlip_animation: "Drehung",
      cstepBlur_animation: "Unschärfe",
      cstepsShowStep: "Schritt zeigen",
      cfinishFinishPageHiddenUpdated: "Die Zielseite ist ausgeblendet.",
      cfinishFinishPageHiddenUpdatedGoContact: "Gehen Sie zur Seite Kontakte",
      cfinishFinishPageHiddenUpdatedSetRedirect: "und eine Umleitung nach dem Senden der Daten einrichten",
      cformActionAfterContactRecive: "Aktion nach Erhalt von Kontakten",
      cformActionAfterContactThankyou: "Dankeschön Seite",
      cformActionAfterContactRedirect: "Umleitung",
      cformAdditionalSettings: "Zusätzliche Einstellungen",
      cformRedirectURL: "URL",
      cintegrationOweDomainInstructionImportant: "Wichtig: Die Adresse in Ihrem Hosting-Konto und das obige Feld müssen übereinstimmen. Die Anwendung der Änderung an den DNS-Einstellungen und das Extrahieren des SSL-Zertifikats kann  bis zu 3 Stunden nach dem Speichern in Anspruch nehmen.",
      cintegrationOweDomainInstructionVideo: "Sehen Sie die Video-Anleitung",
      workboardModalLeadsLeadLimit: "Das Limit für die Anzahl der Anfragen wurden erreicht. ",
      workboardModalLeadsLeadLimitInstruction1: "Um neue Leads zu sehen, ",
      workboardModalLeadsLeadLimitInstruction2: "wechseln Sie zu eienm anderen Tarif",
      workboardModalLeadsLeadLimitInstruction3: "den derzeitigen Tarif verlängern",
      workboardModalLeadsLeadLimitInstruction4: "(gilt nicht für „Kostenlos“) oder warten Sie auf die Aktualisierung des Tarifs, wenn Sie eine automatische Verlängerung des Tarifs angeschlossen haben",
      workboardModalLeadsLeadLimitNewText: "Sie haben nicht abgerufene Leads, auf die Sie aufgrund Ihres aktuellen Paketlimits keinen Zugriff haben. Um auf diese Leads zuzugreifen, kaufen oder aktualisieren Sie bitte Ihr Paket.",
      billingBonusesTitle: "Promo-Code",
      billingBonusesDescription: "Geben Sie den Promo-Code, den Sie erhalten haben, in das Feld daneben ein",
      billingBonusesPlaceholder: 'Promocode',
      billingBonusesBtn: "Aktivieren",
      billingBonusesActivated: "Promo-Code aktiviert",
      billingBonusesLeadIncreased: "Die Zahl der verfügbaren Leads wurde erhöht.",
      billingBonusesInvalid: "Flascher Promo-Code",
      billingBonusesNotAvailable: "Promo-Code ist abgelaufen",
      billingBonusesAlreadyActivated: "Dieser Gutschein ist ungültig",
      createQuizSPDescription: "Hier ist Platz für die Kurzbeschreibung",
      createQuizCPTitle: "Wie können wir mit Ihnen Konatkt aufnehmen?",
      createQuizCPDescription: "Bitte füllen Sie das unten stehende Formular aus",
      createQuizCPButton: "Fertig!",
      createQuizFPTitle: "Vielen Dank!",
      createQuizFPDescription: "Jetzt suchen wir nach der besten Lösung für Sie!",
      createQuizFPButton: "Zeigen Sie mir etwas!",
      selectInternationalPrefix: "Internationale Vorwahl wählen",
      autoInternationalPrefix: "Bestimmen Sie das Land automatisch",
      dovnloadCsvTitle: "Daten für den ausgewählten Zeitraum exportieren",
      dovnloadCsvSelectAllPeriod: "Wählen Sie für den gesamten Zeitraum ",
      dovnloadCsvCancel: "Abbrechen",
      dovnloadCsvExport: "Exportieren",
      domainEmpty: "Bitte geben Sie eine Domain ein",
      domainInvalid: "Geben Sie eine gültige Domain ein, zum Beispiel: example.com",
      domainAlreadyExists: "Diese Domain ist bereits in der Liste",
      domainAdded: "Domain erfolgreich hinzugefügt",
      domainAdd: "Domain hinzufügen",
      domainAddFailed: "Domain konnte nicht hinzugefügt werden",
      domainRemoved: "Domain erfolgreich entfernt",
      domainRemoveFailed: "Domain konnte nicht entfernt werden",
      
      
      
      widgetEmbedVidgetToSite: "Quiz auf der eigenen Webseite einbetten",
      widgetEmbedVidgetSelectEmbedVariant: "Einbettungsvariante auswählen",
      EmbedQuizCardLabelStandard: "Standard",
      EmbedSettingsPreviewPopupHint: "Klicken Sie auf die Schaltfläche, um Ihr Popup in Aktion zu sehen",
      EmbedQuizCardLabelPopup: "Popup-Fenster",
      EmbedQuizCardLabelChatButton: "Chat-Schaltfläche",
      EmbedQuizCardLabelFullscreen: "Vollbild",
      EmbedQuizCardLabelFeedback: "Feedback",
      EmbedQuizCardLabelSidebar: "Seitenleiste",
      EmbedStandardSettingsTitle: "Abmessungen festlegen (optional)",
      tipStandardEmbedQuizStepHead:
          "1. Kopieren Sie den Code für <head> und fügen Sie ihn vor dem schließenden </head>-Tag ein.",
      tipStandardEmbedQuizStepBody:
          "2. Kopieren Sie den zweiten Code und fügen Sie das div <div id=\"adsquiz_embed_standard_ .... genau an der Stelle der Seite ein, an der das Quiz angezeigt werden soll.",
      tipStandardEmbedQuizParent:
          "3. Die Größe des Quiz hängt von den Abmessungen des übergeordneten Blocks ab. Wenn für das Elternelement keine Höhe festgelegt ist, wird das Quiz automatisch in einem responsiven Format angezeigt.",
      tipStandardEmbedQuizPercent:
          "4. Width und height in % funktionieren relativ zur Größe des übergeordneten Blocks.",
      EmbedStandardSettingsTooltip: `
      Breite und Höhe — bestimmen die Größe des Quiz (px, %, auto).

      Auto — das Quiz ist responsiv, die Höhe wird automatisch berechnet.

      Vollbild — das Quiz nimmt 100% der Breite mit einem 16:9 Verhältnis ein. Breite und Höhe werden ignoriert.

      Höhe:
      • auto / 0 → 16:9 Verhältnis
      • Wert → feste Höhe

      Breite:
      • auto / 0 → 100% Breite
      • Wert → innerhalb des Containers

      Radius — steuert die Rundung der Ecken.

      Innenabstand — fügt Abstand innerhalb des Containers hinzu.

      Desktop / Mobilgerät — steuert, wo das Quiz angezeigt wird.
      Wenn deaktiviert — wird das Quiz auf diesem Gerät nicht angezeigt.
      `,
      EmbedFeedbackSettingsTooltip: `
       Fenstergröße legt ein Basis-Preset fest:
  • S → 360 × 520
  • M → 480 × 640
  • L → 640 × 760
  • XL → 780 × 860
  
  Fensterform:
  • angular → eckig
  • rounded → abgerundet
  
  Breite:
  • auto / 0 / leer → Preset wird verwendet
  • Wert → überschreibt Preset
  
  Höhe:
  • auto / 0 / leer → Preset wird verwendet
  • Wert → überschreibt Preset
  
  Button-Größe definiert das Preset.
  
  Button-Form:
  • angular → eckig
  • rounded → abgerundet
  
  Button-Position:
  • left → links
  • right → rechts
  • top → oben
  • bottom → unten
  
  Button-Text — ändert den Text.
  
  Icon — Icon auswählen.
  
  Button-Farbe — Hintergrund.
  
  Textfarbe — Textfarbe.
  
  Icon-Farbe — Icon-Farbe.
  
  Schließen vor Abschluss verhindern — wenn aktiviert, kann das Fenster erst nach Abschluss geschlossen werden.
  
  Nach Abschluss nicht mehr anzeigen — nach dem Quiz werden Button und Fenster nicht erneut angezeigt.
  
  Desktop / Mobil — wo das Widget angezeigt wird.
  `,
      EmbedPopupSettingsTooltip: `
        Breite und Höhe definieren die Größe des Popups.
        
        Fenstergröße legt eine Standardgröße fest:
        • S → 360 × 520
        • M → 480 × 640
        • L → 640 × 760
        • XL → 780 × 860
        
        Breite und Höhe können die gewählte Fenstergröße überschreiben.
        
        Breite:
        • auto / 0 / leer → Breite aus der Fenstergröße wird verwendet
        • Wert → eigene Breite überschreibt den Preset
        
        Höhe:
        • auto / 0 / leer → Höhe aus der Fenstergröße wird verwendet
        • Wert → eigene Höhe überschreibt den Preset
        
        Anzeigebedingung bestimmt, wann das Popup erscheint:
        • Klick auf Button — öffnet beim Klick
        • Beim Verlassen der Seite — öffnet beim Exit
        • Nach dem Laden der Seite — öffnet sofort
        • Mit Verzögerung — öffnet nach Sekunden
        
        Sekunden erscheint nur bei „Mit Verzögerung“.
        
        Button-Text, Buttongröße, Form, Position, Auto-Farbe (Template), Buttonfarbe und Textfarbe funktionieren nur bei „Klick auf Button“.
        
        Buttongröße legt den Größen-Preset für den Button fest.
        
        Auto-Farbe (Template):
        • aktiviert — Template-Farben werden automatisch verwendet
        • bei manuellen Farben wird Auto-Farbe deaktiviert
        
        Schließen vor Abschluss verhindern — wenn aktiviert, kann das Fenster erst nach Abschluss geschlossen werden.
  
        Nach Abschluss nicht mehr anzeigen — nach dem Quiz werden Button und Fenster nicht erneut angezeigt.
        
        Desktop / Mobil — steuert, wo das Popup angezeigt wird.
        `,
      EmbedChatButtonSettingsTooltip: `
      Breite und Höhe definieren die Größe des Chatfensters.

      Fenstergröße legt die Standardgröße des Chatfensters fest:
      • S → 360 × 520
      • M → 480 × 640
      • L → 640 × 760
      • XL → 780 × 860

      Breite und Höhe können die gewählte Fenstergröße überschreiben.

      Breite:
      • auto / 0 / leer → die Breite aus der Fenstergröße wird verwendet
      • Wert → eigene Breite überschreibt den Preset

      Höhe:
      • auto / 0 / leer → die Höhe aus der Fenstergröße wird verwendet
      • Wert → eigene Höhe überschreibt den Preset

      Fensterform bestimmt, ob das Chatfenster scharfe oder abgerundete Ecken hat.

      Buttongröße legt den Größen-Preset der Chat-Schaltfläche fest.

      Buttonform bestimmt den Stil der Schaltfläche:
      • rechteckig
      • rund

      Buttonposition bestimmt, wo die Schaltfläche angezeigt wird:
      • links
      • rechts

      Über Icons können Sie das Symbol der Chat-Schaltfläche auswählen.

      Schaltflächenfarbe legt die Hintergrundfarbe der Schaltfläche fest.

      Symbolfarbe legt die Farbe des Symbols innerhalb der Schaltfläche fest.

      Schließen vor Abschluss verhindern — wenn aktiviert, kann das Fenster erst nach Abschluss geschlossen werden.
  
      Nach Abschluss nicht mehr anzeigen — nach dem Quiz werden Button und Fenster nicht erneut angezeigt.

      Desktop / Mobilgerät — bestimmt, wo Chat-Schaltfläche und Chatfenster angezeigt werden.
      Wenn deaktiviert — wird die Chat-Schaltfläche auf diesem Gerät nicht angezeigt.
      `,
      EmbedSidebarSettingsTooltip: `
      Breite und Höhe bestimmen die Größe der Seitenleiste.
      
      Fenstergröße legt ein Basis-Preset fest:
      • S → 360 × 520
      • M → 480 × 640
      • L → 640 × 760
      • XL → 780 × 860
      
      Position der Leiste:
      • left → links
      • right → rechts
      
      Breite:
      • auto / 0 / leer → Preset wird verwendet
      • Wert → überschreibt Preset
      
      Höhe:
      • auto / 0 / leer → Preset wird verwendet
      • Wert → überschreibt Preset
      
      Anzeige-Bedingung:
      • Klick auf Button — öffnet bei Klick
      • Exit Intent — öffnet beim Verlassen der Seite
      • Nach Seitenladung — öffnet sofort
      • Verzögerung — öffnet nach gewählten Sekunden
      
      Sekundenfeld erscheint nur bei “Verzögerung”.
      
      Button-Text, Größe, Form, Position, Farbe und Textfarbe gelten nur für “Klick auf Button”.
      
      Button-Größe definiert das Preset.
      
      Button-Form:
      • angular → eckig
      • rounded → abgerundet
      
      Button-Position:
      • left → links
      • middle → zentriert
      • right → rechts
      
      Button-Farbe — Hintergrund.
      
      Textfarbe — Textfarbe des Buttons.
      
      Schließen vor Abschluss verhindern — wenn aktiviert, kann der Nutzer das Panel erst nach Abschluss schließen.
      
      Nach Abschluss nicht mehr anzeigen — nach dem Quiz werden Button und Panel nicht erneut angezeigt.
      
      Auf Desktop / Mobil — bestimmt die Anzeige.
      `,
      EmbedModalStandardInstruction: `
      Kopieren Sie den Code aus dem Head-Bereich und fügen Sie ihn vor </head> ein.
      
      Fügen Sie den Body-Code an der gewünschten Stelle ein.
      
      Wie es funktioniert:
      • Das Quiz wird direkt in die Seite eingebettet
      • Es passt sich der Breite des Containers an
      
      Worauf achten:
      • Bei falscher Breite Container prüfen
      • Höhe ggf. fest einstellen
      • Responsive Höhe passt sich automatisch an
      • CSS-Einschränkungen prüfen
      
      Nach dem Einfügen:
      1. Speichern
      2. Seite neu laden
      3. Darstellung prüfen
      `,
      EmbedModalPopupInstruction: `
      Head-Code vor </head> einfügen.
      
      Body-Code vor </body> oder beliebig.
      
      Wie es funktioniert:
      • Quiz öffnet sich als Popup
      • Öffnet automatisch oder per Klick
      
      Worauf achten:
      • Button erscheint an Einfüge-Stelle
      • Auto-Modus öffnet Popup selbst
      • Geräte-Einstellungen prüfen
      • Größe ggf. anpassen
      
      Nach dem Einfügen:
      1. Speichern
      2. Neu laden
      3. Popup testen
      `,
      EmbedSettingsWindowSize: "Fenstergröße",
      EmbedPreviewFallbackTitle: "Die Vorschau lädt länger als erwartet",
      EmbedPreviewFallbackDescription: "Die Quiz-Vorschau konnte noch nicht angezeigt werden. Versuchen Sie, die Vorschau erneut zu öffnen oder den Frame neu zu laden.",
      EmbedPreviewFallbackReasonsTitle: "Mögliche Gründe:",
      EmbedPreviewFallbackReasonDomain: "Die ausgewählte Domain ist möglicherweise nicht verfügbar oder wurde falsch eingegeben.",
      EmbedPreviewFallbackReasonDomainSettings: "Bitte überprüfen Sie Ihre Domaineinstellungen und stellen Sie sicher, dass die Domain korrekt verbunden ist.",
      EmbedPreviewFallbackReasonSlow: "Die Quiz-Seite lädt möglicherweise noch oder reagiert nur langsam.",
      EmbedPreviewFallbackReasonBlocked: "Die Vorschau wird möglicherweise von Ihrem Browser oder Ihrer Netzwerkumgebung blockiert.",
      EmbedPreviewFallbackReload: "Vorschau neu laden",
      EmbedSizePresetDisabledHint: "Voreingestellte Größe ist nicht verfügbar, solange eine eigene Breite oder Höhe festgelegt ist.",
      EmbedPopupSettingsTitleButton: "Buttongröße",
      EmbedStandardSettingsHeightLabel: "Höhe",
      EmbedStandardSettingsWidthLabel: "Breite",
      EmbedStandardSettingsRadiusLabel: "Radius",
      EmbedStandardSettingsPaddingLabel: "Innenabstand",
      EmbedStandardSettingsFullscreenToggle: "Vollbild",
      EmbedStandardSettingsDesktopToggle: "Desktop",
      EmbedPopupSettingsTextColorToggle: "Textfarbe",
      EmbedPopupSettingsButtonColorToggle: "Schaltflächenfarbe",
      EmbedSettingsIconColor: "Symbolfarbe",
      EmbedPopupSettingsAutoColorToggle: "Automatische Farbe (Vorlage)",
      EmbedPopupSettingsCloseOnCompletionToggle: "Das Schließen vor Abschluss des Quiz verhindern",
      EmbedSettingsStopShowing: "Nach Abschluss nicht mehr anzeigen",
      EmbedStandardSettingsMobileToggle: "Mobilgerät",
      EmbedSettingsAutoOpenToggle: "Automatisches Öffnen",
      EmbedSettingsPreviewDelayHint: "Das Popup erscheint nach ",
      EmbedSettingsPreviewOpenAgain: "Popup-Vorschau öffnen",
      EmbedReOpenSettingsMobileToggle: "Vorschau öffnen",
      widgetEmbedVidgetSitecode: "Im Code der Website",
      widgetEmbedVidgetPopup: "Pop-Up",
      widgetEmbedVidgetChat: "Quiz-Taste",
      widgetEmbedVidgetInProgres: "In Entwicklung",
      widgetEmbedVidgetToSiteCode: "Quiz auf der Webseite einbetten",
      widgetSiteCodeInstruction0: "Um das Quiz auf Ihrer Website einzubinden, fügen Sie den Code aus dem ersten Feld ind en `<head>`-Tag auf Ihrer Webseite oder in Google Tag Manager ein, wenn auf Ihrer Webseite integriert ist. Wenn Sie das Quiz bereits auf ihrer Webseite eingebettet haben und die Domain des Quizzes ändern, müssen Sie den Integrationscode auf Ihrer Webseite aktualisieren.",
      widgetSiteCodeInstruction1: "Fügen Sie an der Stelle, an der Sie das Quiz integrieren möchten, den Code aus dem zweiten Feld ein. ",
      widgetSiteCodeInstruction2: "Das Quiz kann in einen Container beliebiger Größe integriert werden, sogar in Seitenleisten. Die maximale Größe des Quizzes, auch wenn es auf einer separaten Domain stattfindet, beträgt 900x552 Pixel. Es kann in größere Container eingefügt weerden, in diesem Fall wird das Quiz zentriert.",
      widgetSiteCodeInstruction3: "Seien Sie nicht schüchtern - Experimentieren Sie!",
      widgetSiteCodeCopyToHead: "Kopieren und in den `<head>` Ihrer Webseite einfügen",
      widgetSiteCodeCopyToBody: "Fügen Sie den Code dort ein, wo das Quiz stehen soll",
      workboardModalAddQuizHeader: "Neuen Quiz erstellen",
      workboardModalGiveQuizNameAndMethod: "Überlegen Sie sich einen Namen für Ihr Quiz und wählen Sie, wie Sie es erstellen möchten",
      workboardModalNewQuizFromStart: "Leeres Quiz erstellen",
      workboardModalNewQuizFromTemplates: "Fertige Vorlagen",
      QuizTemplatesSearchInput: "Name der Vorlage und/oder Kategorien",
      QuizTemplatesSearchBtn: "Suche",
      QuizTemplatesReadyTemplates: "Fertige Vorlagen",
      QuizTemplateView: "Anzeigen",
      QuizTemplateSelect: "Auswählen",
      widgetPopupInstruction0: "Um ein Quiz auf Ihrer Website zu installieren, fügen Sie den Code aus dem Codefeld zum Tag `<head>` auf Ihrer Website ein oder in den Google Tag Manager, wenn er in Ihre Website integriert ist. Wenn Sie nach dem Einfügen eines Quiz auf Ihrer Website die Quiz-Domain ändern oder Trigger öffnen (Scroll-Prozentsatz oder Timing), müssen Sie den Integrationscode auf Ihrer Website aktualisieren.",
      widgetPopupInstruction1: "Fügen Sie den Code aus dem zweiten Feld direkt vor dem Abschluss-Tag `</footer>` ein.",
      widgetPopupInstruction2: "Für Programmierer oder fortgeschrittene Benutzer",
      widgetPopupInstruction3: "Falls Sie aus irgendeinem Grund nicht den Code vor dem Abschluss-Tag `</footer>` einfügen möchten, können Sie den Code aus dem zweiten Feld an einer beliebigen passenden Stelle einfügen. Beachten Sie jedoch, dass der Container, in den Sie den Code aus dem zweiten Feld einfügen, sich über allen Fenstern befinden und möglichst die maximale Höhe und Breite für die Anzeige haben sollte.",
      widgetPopupCopyToHead: "Kopieren und in das `<head>` Ihrer Website einfügen",
      widgetPopupCopyToBody: "Fügen Sie den Code vor dem Abschluss-Tag `</footer>` ein",
      widgetPopupTimeToOpen: "Zeitspanne",
      secondReduction: "Sek",
      widgetPopupTimeClarification: "Das Popup erscheint mit einer Verzögerung von oben angegebener Zeit in Sekunden",
      widgetPopupScrollToOpen: "Scroll-Prozentsatz der Website",
      widgetPopupScrollClarification: "Das Popup erscheint nach dem angegebenen Scroll-Prozentsatz Ihrer Website",
      quizzesTemplatesAllTags: "Alle Vorlagen",
      widgetEmbedVidgetButton: "Schaltflächenkonstruktor",
      widgetButtonInstruction0: "Sie können auf Ihrer Website ein Quiz einrichten, das geöffnet wird, wenn Sie auf die Schaltfläche klicken.",
      widgetButtonInstruction1: "Fügen Sie der Schaltfläche einen Rahmen, Schatten und Text hinzu. Außerdem können Sie die Farbe der Schaltfläche und den darin enthaltenen Text ändern.",
      widgetButtonInstruction2: "Kopieren Sie das im ersten Codefeld platzierte Skript und fügen Sie es vor dem schließenden Tag `</head>` ein.",
      widgetButtonInstruction3: "Kopieren Sie den generierten Schaltflächencode aus dem zweiten Codefeld und fügen Sie ihn an einer beliebigen Stelle auf Ihrer Website ein.",
      widgetButtonInstruction4: 'Sie können den Code aus dem zweiten Schaltflächenfeld überspringen und einfach `id="button_open_quiz_popup"` zu jedem `<input type="button">`- oder `<button></button>`-Element auf der Website hinzufügen.',
      widgetRealTimeChange: "Sie können die Änderungen in Echtzeit auf der rechten Seite des Bildschirms sehen",
      widgetButtonCornerRound: "Abrundung der Knopfecken",
      widgetButtonShadow: "Knopfschatten",
      widgetButtonBgColor: "Knopffarbe",
      widgetButtonTextColor: "Textfarbe",
      widgetButtonTextValue: "Schaltflächentext",
      openPopupQuizText: "Start",
      widgetButtonInsertBeforeAfterBody: "Fügen Sie den Quizcode unmittelbar nach dem öffnenden Tag `<body>` oder unmittelbar vor dem schließenden Tag `</body>` ein",
      widgetSiteCodeCopyButton: "Fügen Sie den Schaltflächencode an einer beliebigen Stelle auf der Website ein",
      footerContactUs: "Habe Fragen? Fühlen Sie sich frei uns zu kontaktieren:",
      enterYourName: "Gib deinen Namen ein",
      enterYourPhone: "Gib deine Handynummer ein",
      enterYourEmail: "Geben sie ihre E-Mail Adresse ein",
      enterYourPassword: "Geben Sie Ihr Passwort ein",
      selectOption: "Wähle eine Option",
      createNewGroup: "Neue Gruppe erstellen",
      dontHaveAccount: "Sie haben noch kein Konto?",
      haveQuestions: "Haben Sie Fragen?",
      resetPasswordTip: "Wenn Sie weitere Probleme oder Fragen haben, wenden Sie sich bitte an unser Kundensupport-Team. Wir sind hier um zu helfen.",
      getBackAccount: "Gehen Sie zurück zu Ihrem Konto",
      inMinutes: "in Minuten",
      alreadyHaveAccount: "Sie haben bereits ein Konto?",
      quizSlotLastEdit: "Letzte Bearbeitung",
      workboardQuizzesTitle: "Meine Quizze",
      allstepsBack: "Zurück",
      constructorGetLink: "Link",
      allOr: "oder",
      allAnd: "und",
      acceptedFileType: "Akzeptierte Formate: ",
      quizLoaderLoadingQuiz: "Quiz wird geladen...",
      quizLoaderPreparingQuestions: "Persönliche Fragen werden vorbereitet...",
      quizLoaderSettingInterface: "Oberfläche wird eingerichtet...",
      quizLoaderAlmostReady: "Fast fertig...",
      conjunctionAnd: "und",
      acceptedFileSize: "Maximale Größe: ",
      acceptedFileSizeMeasure: "MB",
      cfirstBonusDisabled: "Deaktiviert",
      cfirstBonusAvailable: "Verfügbar",
      allstepsResetInHeader: "Zurücksetzen",
      placeholderText: "Hier eingeben",
      constructorSaveChanges: "Speichern",
      constructorCreateIntegrations: "Integration erstellen",
      cformInputAvailable: "Verfügbar",
      cformInputDisabled: "Deaktiviert",
      Disabled: "Deaktiviert",
      constructorBack: "Zurück",
      videoInstruction: "Videoanleitung",
      csettingsIntegrationFB: "Integration - Facebook Pixel",
      csettingsIntegrationTT: "Integration - TikTok",
      csettingsIntegrationGA: "Integration - Google Analytics",
      csettingsIntegrationGTM: "Integration - Google Tag Manager",
      csettingsIntegrationWH: "Integration - WebHook",
      csettingsIntegrationTG: "Integration - Telegram",
      csettingsIntegrationApixDrive: "Integration - APIxDrive",
      csettingsIntegrationEmail: "Integration - E-Mail",
      csettingsIntegrationAbout: "Über",
      csettingsIntegrationFBAbout: "Gehen Sie zum Werbekonto von Facebook Ads und kopieren Sie die Facebook Pixel ID im Bereich Event Manager. Kopieren Sie nur die ID und fügen Sie sie unten ein.",
      csettingsIntegrationTTAbout: "Gehe zum Werbekonto von TikTok Ads und kopiere die TikTok-Pixel-ID im Bereich „Event“. Kopiere nur die ID und füge sie in das Feld unten ein.",
      csettingsIntegrationGAAbout: "Kopieren Sie die Google Analytics-ID und fügen Sie sie in das Feld unten ein.",
      csettingsIntegrationGTMAbout: "Kopieren Sie die Google Tag Manager-ID und fügen Sie sie in das Feld unten ein.",
      csettingsIntegrationWHAbout1: "Sie können Drittanbieteranwendungen über eingehende Leads informieren. Geben Sie dazu die URL an, an die der WebHook gesendet werden soll. Wir empfehlen, diesen Dienst zu diesem Zweck zu verwenden.",
      csettingsIntegrationWHAboutApix: "Apix-Drive",
      csettingsIntegrationWHAbout2: "Bei der Registrierung über diesen Link erhalten unsere Benutzer einen Bonus von 10.000 kostenlosen Aktionen für beliebige Integrationen.",
      csettingsIntegrationTGAbout: "Wichtig: Beachten Sie, dass es sich hierbei um eine Gruppe handeln sollte, nicht um einen Telegram-Kanal. Leads werden nicht an den Telegram-Kanal gesendet.",
      csettingsIntegrationADAbout: "Etwas über APIxDrive",
      csettingsIntegrationEmailAbout: "Lösen Sie eine E-Mail an Ihren Befragten aus und informieren Sie Ihr Team. Arbeiten Sie mit Ihrem Team zusammen.",
      cSettingsIntegrationNeedHelp: "Hilfe benötigt?",
      cSettingsIntegrationRefreshToken: "Token aktualisieren",
      csettingsSettingASettings: "Erweiterte Einstellungen",
      cSettingsSettingQuizLangTitle: "Quizsprache",
      cSettingsSettingQuizLangDescription: "Um sicherzustellen, dass Sie das beste Erlebnis haben, wählen Sie bitte die gewünschte Quizsprache aus den folgenden Optionen aus. Systembenachrichtigungen und einige andere ständige Texte werden beim Bestehen des Quiz in dieser Sprache angezeigt.",
      selectQuizLanguage: "Wählen Sie die Quizsprache aus",
      cSettingsSettingQuizHideLabelTitle: "Etikett ausblenden",
      cSettingsSettingQuizHideLabelDescription: 'Wenn Sie diese Option aktivieren, können Sie eine Benutzeroberfläche nutzen, die nicht mit dem Label „made by adsquiz“ versehen ist, sodass Sie und Ihre Besucher sich ausschließlich auf die Fragen konzentrieren können.',
      cSettingDataSaved: "Zusätzliche Einstellungen werden gespeichert",
      userAccountInfo: "Konto-Info",
      userGeneralInfoHeader: "Allgemeine Informationen",
      userGeneralInfoDescription1: "Ihr Benutzerprofil ist der Ort, an dem Sie Ihr Konto und Ihre Einstellungen verwalten können.",
      userGeneralInfoDescription2: "Aktualisieren Sie Ihre persönlichen Informationen, ändern Sie Ihr Passwort und passen Sie Ihre Benachrichtigungseinstellungen an.",
      profileNameFirst: "Vorname",
      profileNameLast: "Nachname",
      profileChangePhoto: "Foto ändern",
      profileRemovePhoto: "Entfernen",
      userSecuritySettingsHeader: "Sicherheitseinstellungen",
      userSecuritySettingsDescription: "Um Ihr Passwort zu ändern, geben Sie einfach Ihr neues Passwort zweimal ein, um es zu bestätigen.",
      profileEmailCurent: "Aktuelle E-Mail-Adresse",
      profileEmailNew: "Neue E-Mail-Adresse",
      profileNewPasswordConfirm: "Neues Passwort bestätigen",
      profileDeleteAccount: "Konto löschen",
      profileDeleteAccountPopupHeader: "Konto löschen?",
      profileDeleteAccountPopupDescription: 'Sind Sie sicher, dass Sie Ihr Konto löschen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden. Um die Löschung zu bestätigen, geben Sie das Wort "LÖSCHEN" in das Feld unten ein.',
      profileDeleteAccountCheckedWord: "LÖSCHEN",
      profileDeleteAccountPopupPlaceholder: "Hier eingeben",
      notificationSuccess: "Erfolg!",
      notificationSuccessSaveAccount: "Ihr Passwort wurde erfolgreich geändert! Verwenden Sie ein neues Passwort, um sich erneut anzumelden",
      notificationOnlyEmailMask: "Nur eine gültige E-Mail-Adresse ist erlaubt.",
      notificationOnlyNumbersMask: "Nur Zahlen und Leerzeichen sind erlaubt.",
      notificationOnlyLinkMask: "Es sind nur sichere Links erlaubt (https, http oder mailto).",
      notificationOnlyLettersMask: "Nur Buchstaben, Leerzeichen, Bindestriche, Apostrophe und Unterstriche sind erlaubt.",
      notificationSuccessDeleteAccount: "Ihr Passwort wurde erfolgreich geändert! Verwenden Sie ein neues Passwort, um sich erneut anzumelden",
      notificationSuccessDeletePhoto: "Foto erfolgreich gelöscht",
      notificationSuccessChangePhoto: "Foto erfolgreich geändert",
      notificationErrorChangePhoto: "Beim Ändern des Fotos ist ein Fehler aufgetreten",
      notificationErrorRemovePhoto: "Beim Entfernen des Fotos ist ein Fehler aufgetreten",
      notificationWarnLimitText: "Zeichenlimit überschritten. Sie können keine weiteren Zeichen hinzufügen.",
      cardPanUnspecified: "Nicht angegeben",
      userBillingsDate: "Datum",
      userBillingsCost: "Kosten",
      userBillingsId: "ID",
      userBillingsMethod: "Zahlungsmethode",
      RateSymbolForDropdown: "Ratenzeichen",
      NumberOfSymbolsForDropdown: "Anzahl der Zeichen",
      optionIconLabelForDropdown_thumbnail: "Daumen hoch",
      optionIconLabelForDropdown_stars: "Sterne",
      optionIconLabelForDropdown_flags: "Flaggen",
      optionIconLabelForDropdown_smiley_faces: "Smileys",
      labelTextYesNoPack1: "Ja/Nein Paket - 1",
      labelTextYesNoPack2: "Ja/Nein Paket - 2",
      labelTextYesNoPack3: "Ja/Nein Paket - 3",
      labelTextYesNoEmojiPack: "Ja/Nein Emoji Paket",
      labelTextEmojiPackage1: "Emoji Paket - 1",
      labelTextEmojiPackage2: "Emoji Paket - 2",
      labelTextEmojiPackage3: "Emoji Paket - 3",
      labelTextNumberPack1: "Zahlenpaket - 1",
      labelTextNumberPack2: "Zahlenpaket - 2",
      labelTextClassicNumbers1: "Klassische Zahlen - 1",
      labelTextClassicNumbers2: "Klassische Zahlen - 2",
      labelTextRatingMarkers: "Bewertungsmarker",
      textPackagePlaceholder: "Paket ...",
      labelEmojiNumberSets: "Emoji- und Zahlensets",
      labelSelectCountForSymbols: "Wählen Sie einen Bereich von 1 bis",
      labelButtonColorButtonText: "Button-Farbe & Button-Text",
      color: "Farbe",
      paymentSwitchToProHeader: "Zu Pro wechseln",
      paymentSwitchToProDescription: "Finden Sie den Plan, der zu Ihnen passt! Steigen Sie jederzeit auf oder ab - wir machen es Ihnen leicht, den gewünschten Plan zu erhalten.",
      paymentYourCurrentPlan: "Ihr aktueller Plan:",
      paymentYourFuturePlan: "Ihr neuer Plan:",
      billingCurrentPlanLeadLimit: "Monatliches Lead-Limit",
      billingCurrentPlanLeadsRemaining: "Verbleibende Leads",
      billingSpecialOffersHeading: "Sonderangebote",
      billingAllPlansHeading: "Alle Tarife",
      billingBillingPeriodToggleAria: "Abrechnungszeitraum",
      billingPeriodMonthly: "Monatlich",
      billingPeriodYearly: "Jährlich",
      billingPaymentUnavailableNotification: "Die Zahlung für diesen Tarif ist derzeit nicht möglich. Bitte versuchen Sie es später erneut oder kontaktieren Sie uns.",
      billingRequisitesButton: "Bankverbindung",
      billingPayAsBusiness: "Als Unternehmen bezahlen",
      billingIbanModalTitle: "Bankverbindung",
      billingIbanModalMethodTitle: "Banküberweisung per IBAN",
      billingIbanModalDisclaimer: "Um eine Rechnung zur Zahlung zu erhalten, schreiben Sie uns im Support-Chat.",
      billingIbanModalRecipient: "Empfänger",
      billingIbanModalRecipientCode: "Empfängercode",
      billingIbanModalIban: "IBAN",
      billingIbanModalBankName: "Bankname",
      billingIbanModalCopy: "IBAN kopieren",
      billingIbanModalClose: "Schließen",
      billingIbanCopyAllButton: "Bankverbindung kopieren",
      billingIbanCopiedNotification: "IBAN in die Zwischenablage kopiert",
      billingIbanAllCopiedNotification: "Bankverbindung in die Zwischenablage kopiert",
      billingWhatsIncluded: "Was ist enthalten",
      billingComparePlans: "Tarife vergleichen",
      billingComparePlanA: "Tarif A zum Vergleich",
      billingComparePlanB: "Tarif B zum Vergleich",
      billingFeatureSectionMain: "Haupt",
      billingFeatureSectionAdvanced: "Erweitert",
      billingFeatureSectionIntegrations: "Integrationen",
      billingAnalyticsRowLabel: "Analytics",
      billingLeadsRowLabel: "Leads",
      billingFeatureProjectsRowLabel: "Projekte",
      billingFeatureCustomDomainRowLabel: "Eigene Domain",
      billingFeatureAnalyticsRowLabel: "Analytics",
      billingFeatureSiteInstallRowLabel: "Installation auf der Website",
      billingFeatureAiBuilderRowLabel: "KI-Builder",
      billingFeatureRedirectRowLabel: "Weiterleitung",
      billingFeatureUtmTrackingRowLabel: "UTM-Tracking",
      billingFeatureFaviconRowLabel: "Favicon",
      billingFeatureLogicRowLabel: "Logik",
      billingFeatureResultPageRowLabel: "Ergebnisseite",
      billingFeaturePointsRowLabel: "Punkte",
      billingFeatureFileUploadRowLabel: "Datei-Upload",
      billingFeatureNotYetAvailableLabel: "Bald",
      billingFeatureTeamRowLabel: "Team",
      billingFeatureCrmRowLabel: "CRM",
      billingPartnershipOfferHeading: "Partnerangebot",
      paymentPlanLeadsLimit: "Begrenzung der Leads pro Monat:",
      paymentPlanLeadsLimitForTest: "Ihr Quiz-Testlimit:",
      paymentPlanLeadsLeft: "Verbleibende Leads:",
      paymentPlanPrice: "Preis:",
      paymentPlanRenew: "Tarifverlängerungsdatum:",
      addNewSectionHeader: "Neuen Abschnitt hinzufügen",
      addNewSectionList: "Liste",
      addNewSectionCustom: "Eingabefeld",
      addNewSectionMultiInput: "Mehrfacheingabe",
      addNewSectionUploadFile: "Datei-Upload",
      addNewSectionCard: "Karten mit Fotos",
      addNewSectionWithEmoji: "Liste mit Emoji",
      addNewSectionTags: "Tags",
      addNewSectionSlider: "Schieberegler",
      templatesBackToQuiz: "Zurück zur Arbeitsfläche",
      constructorStepsSaved: "Alle Quizdaten wurden erfolgreich gespeichert",
      constructorDesignSaved: "Das Quizdesign wurde erfolgreich gespeichert",
      azureBlueWhite: "Standard",
      azureBlue: "Winternacht",
      moderatePurplishRed: "Roter Samt",
      multiInputPlaceholderLink: "https:",
      multiInputPlaceholderName: "Name oder vollständiger Name",
      multiInputAddInput: "Eingabe hinzufügen",
      multiInputPlaceholderAddress: "Adresse",
      multiInputPlaceholderNumbers: "Platzhalter (nur Zahlen)",
      violetBlueCrayola: "Winterbrise",
      wetRainforest: "Sommerahorn",
      lavender: "Raum",
      blueLilac: "Dunkler Lavendel",
      opalGreen: "Karpatenwald",
      dustyBlue: "Tiffany",
      almondCrayola: "Korallenriff",
      periwinkleCrayolaLilac: "Lila",
      periwinkleCrayolaAqua: "Synevir",
      jazzJam: "Jazz",
      slateGrayBlue: "Nebel",
      turquoiseBlueCrayola: "Diia",
      blackPearlescentOpal: "Asche",
      pearlescentGentianBlue: "Saphir",
      sapphireBlue: "Dunkler Saphir",
      errorUserDataUpdate: "Fehler in den aktualisierten Daten: ",
      completeUserDataUpdate: "Benutzerdaten aktualisiert",
      passwordDoNotCoincidence: "Passwörter stimmen nicht überein",
      passwordDoNotCoincidenceAgain: "Versuchen Sie es erneut",
      nonBillingsYet: "Sie haben noch keinen Abrechnungsverlauf",
      youCanChangePlan: "Sie können den aktuellen Plan ändern, indem Sie auf die Schaltfläche „Wechsel zu Pro“ klicken",
      rangeMin: "Min",
      rangeMax: "Max",
      rangePositionStart: "Positionsanfang",
      rangePositionEnd: "Positionsende",
      rangeStep: "Schritt",
      rangeIsRange: "Bereich",
      rangeIsRangeTrue: "Aktiviert",
      rangeIsRangeFalse: "Deaktiviert",
      recivePromotionNewsletter: "Erhalten Sie E-Mail-Newsletter",
      reciveEmailCheckbox: "E-Mail-Checkbox empfangen",
      additionalCheckbox: "Zusätzliche Checkbox",
      contactPrivacyPolicyCheckbox: "Kontakt Datenschutzrichtlinie Checkbox",
      contactAgreeIAgreeWith: "Ich stimme",
      contactAgreePolicy: "der Datenschutzrichtlinie",
      contactAgreeAnd: "und",
      contactAgreeTermsOfUse: "den Nutzungsbedingungen",
      contactAgreeAgreementAdditionalWord: "zu.",
      contactFillRequiredInput: "Füllen Sie die erforderlichen Felder aus",
      langEN: "Englisch",
      langDE: "Deutsch",
      langSP: "Spanisch",
      langPL: "Polnisch",
      langIT: "Italienisch",
      langKK: "Kasachisch",
      langRU: "Russisch",
      langUA: "Ukrainisch",
      langSV: "Schwedisch",
      langLT: "Litauisch",
      langLV: "Lettisch",
      langET: "Estnisch",
      langRO: "Rumänisch",
      leadsLeft: "Bleibt übrig",
      generateDomainTitle: "Geben Sie den Domänennamen ein",
      generateCodeForEmbedQuiz: "Code generieren",
      generateDomainDescription: "Dies ist die eindeutige Adresse, unter der auf Ihre Seite zugegriffen werden kann. Sie können die Adresse jederzeit ändern oder eine eigene anschließen.",
      generateDomainDomainNameLabel: "Domainname",
      cancelAllAction: "Stornieren",
      confirmAllAction: "Bestätigen",
      fieldDataTypeLabel: "Datentyp im Feld",
      falseHasValidCharacters: "Ungültige Zeichen im Domänennamen. Erlaubte Zeichen sind Buchstaben, Zahlen und Bindestriche.",
      falseHasValidLength: "Die Länge des Domänennamen sollte zwischen 6 und 20 alphanumerischen Zeichen liegen.",
      falseDoesNotStartOrEndWithSpecialChar: "Der Domänennamen darf nicht mit einem Sonderzeichen beginnen oder enden.",
      falseDoesNotHaveConsecutiveSpecialChar: "Der Domänennamen darf keine zwei oder mehr aufeinanderfolgenden Sonderzeichen enthalten.",
      falseDoesNotHaveConsecutiveSameChar: "Der Domänennamen darf nicht drei oder mehr aufeinanderfolgende identische Zeichen enthalten.",
      falseDoesNotContainForbiddenSubstrings: "Der Domänennamen darf keine verbotenen Teilzeichenfolgen enthalten.",
      generateDomainTaken: "Dieses Haus ist noch nicht fertig. Versuchen Sie es",
      temporarilyUnavailable: "Vorübergehend nicht erreichbar",
      csettingsAdmin: "Einstellungen für Administratoren",
      questionLogicSetupTitle: "Einstellung der Fragelogik",
      questionLogicSetupDescription: "Fügen Sie Bedingungen hinzu, um die Umfrage für jeden Befragten anzupassen und genauere Daten zu sammeln.",
      questionLogicConditionTitle: "Bedingung",
      questionLogicQuestion: "Frage",
      questionLogicSetupQuestionDisableOption: "Frage auswählen",
      questionLogicSetupAnswer: "Antwort",
      questionLogicSetupLogicType: "Typ",
      questionLogicSetupAnswerDisableOption: "Bedingungstyp auswählen",
      questionLogicSetupRangeRatingBetween: "Zwischen",
      questionLogicSetupRangeRatingLess: "Weniger",
      questionLogicSetupRangeRatingMore: "Mehr",
      questionLogicSetupRangeRatingEqualTo: "Gleich",
      questionLogicSetupRangeRatingFrom: "Von",
      questionLogicSetupRangeRatingTo: "Bis",
      questionLogicSetupVariantAll: "Alle sind ausgewählt",
      questionLogicSetupVariantAny: "Обрано один з",
      questionLogicSetupVariantNot: "Einer der Auserwählten",
      questionLogicSetupCustomEqual: "Ist gleich",
      questionLogicSetupCustomContains: "Enthält",
      questionLogicSetupCustomNotContains: "Beinhaltet nicht",
      questionLogicSetupRangeRatingValue: "Wert",
      questionLogicSetupExpectedAnswer: "Erwartete Antworten",
      questionLogicSetupPlaceholder: "Hier eingeben",
      questionLogicAllMandatory: "Alle oben genannten Bedingungen sind obligatorisch",
      questionLogicAddConditionBtn: "Bedingung hinzufügen",
      questionLogicNotAvailable: "Die für den ersten Schritt erforderlichen Logik-Logiken",
      pointsSettingsNotAvailableForQuestionType: "Bei dieser Art von Frage werden die Antworten nicht bewertet",
      questionLogicSaved: "Die Einstellungen der Schrittanzeigelogik werden gespeichert",
      questionLogicDeleteAll: "Logik löschen",
      questionLogicDeleted: "Die Schrittanzeigelogik wurde gelöscht",
      questionLogicRatingSelectedLeftBtn: "linke Schaltfläche",
      questionLogicRatingSelectedRightBtn: "rechte Schaltfläche",
      QR_code: "QR code",
      QRCodeDownloadPdf: "Pdf herunterladen",
      QRCodeDownloadPng: "Png herunterladen",
      qrGenerateTitle: "QR-Code erstellen",
      qrGenerateDescription: "Erstellen Sie einen personalisierten QR-Code mit UTM-Tags, um Traffic-Quellen einfach nachzuverfolgen. Wenn Nutzer den Code scannen, werden sie zu Ihrem Quiz weitergeleitet, wobei Kampagnenparameter für genaue Analysen erhalten bleiben.",
      qrUtmSource: "Verweisquelle (z. B. Google, Newsletter)",
      qrUtmMedium: "Marketingmedium (z. B. CPC, Banner, E-Mail)",
      qrUtmCampaign: "Produkt, Promo-Code oder Slogan (z. B. spring_sale). Kampagnenname oder Kampagnen-ID ist erforderlich.",
      yrUtmTerm: "Bezahlte Keywords identifizieren",
      qrUtmContent: "Zur Unterscheidung von Anzeigen verwenden",
      billingPaymentInfoTitle: "Tarifinformation",
      billingPaymentInfoChangeTarrif: "Tarif ändern",
      billingPaymentInfoDescription: "Wenn Sie einen kostenpflichtigen Tarif bezahlen, erhalten Sie eine bestimmte Anzahl von Leads, die im von Ihnen gewählten Paket enthalten sind. Diese Leads werden für einen Monat bereitgestellt. Wenn Sie Ihre Leads innerhalb eines Monats ab dem Zeitpunkt der Zahlung nicht genutzt haben, werden sie storniert.",
      billingGeneralName: "Ihr Tarif",
      billingGeneralCost: "Kosten",
      billingMonth: "Monat",
      billingGeneralExpired: "Gültig bis",
      billingGeneralLeadsLeft: "Übrige Leads",
      billingGeneralAllTarifExpired: "Ablaufdatum des Tarifs",
      billingGeneralBonus: "Bonus-Leads",
      billingGeneralLeadsFromOtherTarifs: "Leads aus anderen Tarifen",
      billingGeneralNoActiveTariff: "Kein aktiver Tarif",
      billingLeadsAvailableLabel: "Verfügbare Leads",
      billingLeadsTariffSourceLabel: "Tarif",
      billingLeadsRemainingOfLabel: "{remaining} / {total} übrig",
      planUsageTeamMembersLabel: "Teammitglieder",
      planUsageManagePlanLabel: "Plan verwalten",
      billingAcordeonPaymentInfoTitle: "Zahlungsinformationen",
      billingAcordeonPaymentInfoFormat: "Format",
      billingAcordeonPaymentInfoSubscription: "Abonnement",
      billingAcordeonPaymentInfoPay: "Zahlung",
      billingAcordeonPaymentInfoPayMethod: "Zahlungsmethode",
      billingAcordeonPaymentInfoCancelSubscription: "Abonnement kündigen",
      billingAcordeonPromocode: "Promo-Code",
      billingAcordeonPromocodeLabel: "Geben Sie den Aktionscode ein",
      billingAcordeonPayHistory: "Transaktionsverlauf",
      paymentAllTarifInactive: "Tarif ist inaktiv",
      subscriptionUnsubscribeModalTitle: "Abbestellen",
      subscriptionUnsubscribeModalDescription: "Sind Sie sicher, dass Sie sich abmelden möchten? Die für das Abonnement berechneten Leads stehen Ihnen einen Monat ab dem letzten Abbuchungstag zur Verfügung.",
      subscriptionIsNotDeleteTitle: "Abonnement nicht gelöscht",
      subscriptionIsNotDeleteDescription: "Bitte kontaktieren Sie den Kundensupport",
      subscriptionCanceledTitle: "Abonnement gekündigt",
      embedQuizTitleGetLinkModal: "Quiz auf der Website einfügen als:",
      QRCodeTitleGetLinkModal: "QR-Code verwenden:",
      modalSureUnsavedChangesTitle: "Sie haben ungespeicherte Änderungen",
      modalSureUnsavedChangesDescription: "Bevor Sie die aktuelle Seite verlassen, entscheiden Sie bitte, was mit den ungespeicherten Änderungen geschehen soll",
      modalSureUnsavedChangesDontSave: "Nicht speichern",
      modalSureUnsavedChangesSave: "Speichern",
      modalSuggestIdeaNotificationSuccess: "Erfolg! Vielen Dank für Ihre Idee",
      modalSuggestIdeaNotificationUnsuccess: "Hoppla! Etwas ist schiefgelaufen. Bitte versuchen Sie es später erneut.",
      telegramTokenCopied: "Der Quiz-Token wurde in die Zwischenablage kopiert",
      cSettingsSettingQuizBackButtonTitle: "Zurück-Button",
      cSettingsSettingQuizBackButtonDescription: "Sie können die Zurück-Schaltfläche aktivieren oder deaktivieren. Dies bietet die Möglichkeit, die zuvor gegebene Antwort zu ändern.",
      cSettingsCustomThemePrimaryColor: "Farbe der Akzente",
      cSettingsCustomThemeSecondaryColor: "Hintergrundfarbe",
      cSettingsCustomThemeAdditionalColor: "Textfarbe",
      cSettingsCustomThemeButtonTextColor: "Text in Schaltflächen",
      cSettingsCustomThemeModeDark: "Dunkel",
      cSettingsCustomThemeModeLight: "Licht",
      allstepsPlaceholder: "Platzhalter",
      allstepsCustomInput: "Ihre Option",
      allstepsCustomInputOn: "Anmachen",
      allstepsCustomPlaceholder: "Eigene Option ",
      trashcanTitle: "Korb",
      trashcanImportant: "Wichtig!",
      trashcanDescription: "Das Quiz wird 30 Tage nach dem Verschieben in den Papierkorb automatisch endgültig gelöscht.",
      trashcanClearAll: "Alles löschen",
      quizSlotDeletedData: "Gelöscht um",
      workboardLeads: "Führt",
      filterOptionLabelCreatedDesc: "von neu nach alt",
      filterOptionLabelCreatedAsc: "von alt nach neu",
      filterOptionLabelLeadsDesc: "Nach Leads (absteigend)",
      filterOptionLabelLeadsAsc: "Nach Leads (aufsteigend)",
      filterOptionLabelWithProject: "Quizze in Projekten",
      filterOptionLabelWithoutProject: "Quizze ohne Projekt",
      workboardDuplicate: "Duplikat",
      leadsTable: "Leads-Liste",
      exportInfo: "Leads exportieren",
      leadHide: "Ausblenden",
      leadShowMore: "Mehr",
      poperTrashcan: "Korb",
      restoreQuizSendedTitle: "Eine Wiederherstellungsaufgabe wird ausgeführt",
      restoreSuizSendedImportant: "Wichtig",
      restoreQuizSendedDescription: "Je nachdem, wie viele Leads es in Ihrem Quiz gab, kann die Wiederherstellung des Quiz einige Sekunden bis 2 Minuten dauern. Nach der Wiederherstellung wird das Quiz auf Ihrem Hauptarbeitsbrett angezeigt.",
      ok: "Okay",
      month: "0 Monat | {n} Monat | {n} Monate",
      discount: "Rabatt bis zu",
      saveMoney: "Abonnement für ein Jahr",
      upProVersionMobile: "Zu Pro",
      upProVersionDesktop: "Wechsel zu Pro",




      csettingsIntegrationSendPulse: "Integration - Send Pulse",
      csettingsIntegrationMailchimp: "Integration - Mailchimp",
      csettingsIntegrationMake: "Integration - Make",
      csettingsIntegrationZapier: "Integration - Zapier",
      csettingsIntegrationCRMBitrix: "Integration - CRM Bitrix",
      csettingsIntegrationPipeDrive: "Integration - Pipe Drive",
      csettingsIntegrationRemOnline: "Integration - Rem Online",
      csettingsIntegrationKeyCRM: "Integration - Key CRM",
            
      csettingsIntegrationZapierAbout: "Geben Sie die URL ein, um die Daten, die von Zapier bereitgestellt werden, in das Eingabefeld zu senden.",
      csettingsIntegrationMakeAbout: "Geben Sie die URL ein, um die Daten, die von Make bereitgestellt werden, in das Eingabefeld zu senden.",
      csettingsIntegrationMakeAboutTextStep1: "Um die Integration mit",
      csettingsIntegrationMakeAboutTextStep2: "einzurichten, sehen Sie sich das",
      csettingsIntegrationMakeAboutTextStep3: "Wählen Sie zur Einrichtung in Make die Integration “Webhooks”, dann “Custom webhook”.",
      csettingsIntegrationMakeAboutTextStep4: "Kopieren Sie den generierten Link und fügen Sie ihn in das Feld unten in ADS Quiz ein.",
      csettingsIntegrationMakeAboutTextStep5: "Zum Testen kehren Sie zu Make zurück, klicken auf “Run” und durchlaufen das Quiz, indem Sie eine Anfrage absenden.",
      csettingsIntegrationMakeAboutTextStep6: "Wenn der Test erfolgreich war, speichern Sie die Integration und vergessen Sie nicht, die Aktualisierungen zu aktivieren.",
      csettingsIntegrationMakeAboutLinkVideoText: "Video",
      csettingsIntegrationCRMBitrixAbout: "Geben Sie die URL ein, um die Daten, die von CRM Bitrix bereitgestellt werden, in das Eingabefeld zu senden.",

      csettingsIntegrationSendPulseAboutStart: "Sie können die Integration mit dem Dienst ",
      csettingsIntegrationSendPulseAboutMiddle: " einrichten. Dazu gehen Sie zu den Kontoeinstellungen und öffnen die Registerkarte ",
      csettingsIntegrationSendPulseAboutEnd: ". Kopieren Sie die Werte der Parameter 'ID' und 'Secret' und fügen Sie sie in die entsprechenden Felder im Dienst ADS Quiz ein (in die Felder unten). Als Nächstes müssen Sie die Adressbuch-ID eingeben. Gehen Sie dazu zum gewünschten Adressbuch und kopieren Sie aus der URL den Wert nach id/. Es werden nur Zahlen benötigt, ohne zusätzliche Zeichen. Speichern Sie die Änderungen. Eine detailliertere Anleitung finden Sie im ",
      csettingsIntegrationSendPulseAboutLinkSendPulse: "https://sendpulse.com/de#60c9ccfd55f4b",
      csettingsIntegrationSendPulseAboutLinkAPI: "https://login.sendpulse.com/login/#api",
      csettingsIntegrationSendPulseAboutLinkVideo: "https://www.youtube.com/watch?v=4mnhpbKkePs",
      csettingsIntegrationSendPulseAboutLinkVideoText: "Video",

      csettingsIntegrationKeyCRMAbout: "Geben Sie den API-Schlüssel und die Pipeline-ID in die entsprechenden Eingabefelder ein.",
      csettingsIntegrationPipeDriveAbout: "Geben Sie den Token und die Domain des Unternehmens in die entsprechenden Eingabefelder ein.",
      csettingsIntegrationRemOnlineAbout: "Geben Sie den Rem Online API-Schlüssel in das entsprechende Eingabefeld ein.",
      csettingsIntegrationGoogleSheetsAbout: "Melden Sie sich bei Google Sheets an (wenn Ihr Konto mit einer Gmail-Adresse registriert ist, können Sie nur dieses Gmail-Konto verbinden; der Versuch, ein anderes Konto zu verbinden, führt zu einem Fehler), wählen Sie eine Tabelle aus und ordnen Sie die Felder zu, um die Datenübertragung zu starten.",
      csettingsIntegrationMailchimpAbout: "Verbinden Sie Mailchimp, wählen Sie eine Zielgruppe und ordnen Sie bei Bedarf Felder zu.",
      csettingsIntegrationKeepinCrmAbout: "Fügen Sie den KeepinCRM API-Schlüssel ein, wählen Sie Pipeline, Status, Manager und Quelle und aktivieren Sie bei Bedarf das Feldmapping.",
      csettingsIntegrationActiveIntegration: "Aktive Integration",
      cintegrationIntegrationData: "Integrationsdaten",
      cintegrationMailchimpAudience: "Zielgruppe",
      cintegrationMailchimpAudiencePlaceholder: "Zielgruppe auswählen",
      cintegrationMailchimpStatus: "Abonnentenstatus",
      cintegrationMailchimpStatusOptionSubscribed: "subscribed (Abonniert)",
      cintegrationMailchimpStatusOptionPending: "pending (Bestätigung ausstehend)",
      cintegrationMailchimpStatusOptionUnsubscribed: "unsubscribed (Abgemeldet)",
      cintegrationMailchimpStatusOptionCleaned: "cleaned (Bereinigt)",
      cintegrationMailchimpStatusOptionTransactional: "transactional (Nur transaktional)",
      cintegrationMailchimpStatusDescriptionSubscribed: "der Kontakt kann Ihre Newsletter erhalten.",
      cintegrationMailchimpStatusDescriptionPending: "der Nutzer hat das Abonnement noch nicht per E-Mail bestätigt.",
      cintegrationMailchimpStatusDescriptionUnsubscribed: "der Kontakt hat sich von den Newslettern abgemeldet.",
      cintegrationMailchimpStatusDescriptionCleaned: "E-Mails können nicht zugestellt werden.",
      cintegrationMailchimpStatusDescriptionTransactional: "nur für Service-E-Mails, nicht für Marketing-Kampagnen.",
      cintegrationMailchimpConnect: "Mailchimp verbinden",
      cintegrationMailchimpConnectTo: "Verbinden Sie Mailchimp",
      cintegrationMailchimpConnectedTo: "Mit Mailchimp verbunden",
      cintegrationMailchimpUseMapping: "Feldeinstellungen",
      cintegrationMailchimpDataSaved: "Mailchimp-Integrationsdaten gespeichert",
      cintegrationDataMailchimpError: "Mailchimp-Zielgruppe auswählen",
      cintegrationMailchimpMappingError: "Feldzuordnung ausfüllen",
      cintegrationMailchimpNoTags: "Mailchimp hat keine Tags",
      cintegrationIntegrationUrl: "URL der Integration",
      cintegrationWriteUrl: "URL eingeben",
      cintegrationDataFBError: "Ungültige Pixel-ID",
      cintegrationDataWebHookError: "Ungültige Webhook-Adresse",
      cintegrationZapierDataSaved: "Integrationsdaten mit Zapier gespeichert",
      cintegrationDataZapierError: "Ungültige Integrationsadresse",
      cintegrationAPIxDriveDataSaved: "Integrationsdaten mit APIxDrive gespeichert",
      cintegrationDataAPIxDriveError: "Der String ist keine APIxDrive-Integrationsadresse",
      cintegrationMakeDataSaved: "Integrationsdaten mit Make gespeichert",
      cintegrationDataMakeError: "Ungültige Integrationsadresse",
      cintegrationSendPulseDataSaved: "Integrationsdaten mit SendPulse gespeichert",
      cintegrationDataSendPulseError: "Integrationsdaten nicht möglich oder leer",
      cintegrationPipeDriveDataSaved: "Integrationsdaten mit PipeDrive gespeichert",
      cintegrationDataPipeDriveError: "Integrationsdaten nicht möglich oder leer",
      cintegrationRemOnlineDataSaved: "Integrationsdaten mit RemOnline gespeichert",
      cintegrationDataRemOnlineError: "Integrationsdaten nicht möglich oder leer",
      cintegrationKeyCRMDataSaved: "Integrationsdaten mit KeyCRM gespeichert",
      cintegrationDataKeyCRMError: "Integrationsdaten nicht möglich oder leer",
      cintegrationInputEmailUrl: "E-Mail eingeben",
      cintegrationEmailDataSaved: "E-Mail gespeichert",
      cintegrationDataEmailError: "Der eingegebene String ist keine E-Mail-Adresse",
      cintegrationCRMBitrixDataSaved: "E-Mail gespeichert",
      cintegrationDataCRMBitrixError: "Der eingegebene String ist keine E-Mail-Adresse",
      cintegrationTelegramBotDataSaved: "Telegram-Integrationseinstellungen gespeichert",
      cintegrationDataTelegramBotError: "Fehler beim Speichern",
      cintegrationGTMDataSaved: "Google Tag Manager-ID gespeichert",
      cintegrationDataGTMError: "Ungültige ID",
      cintegrationDataGTMErrorDescription: "Die ID sollte im Format GTM-XXXXXX sein",
      cintegrationGoogleAnalyticsDataSaved: "Google Analytics-ID gespeichert",
      cintegrationDataGoogleAnalyticsError: "Ungültige ID",
      cintegrationDataGoogleAnalyticsErrorDescription: 'Die ID sollte im Format "UA-XXXXXXX-X" oder "G-XXXXXXXXXX-XX" sein',
      cintegrationTikTokDataSaved: "TikTok-Pixel gespeichert",
      cintegrationDataTikTokError: "Der eingegebene String ist kein TikTok-Pixel",
      cintegrationIntegrationToken: "Integrations-Token",
      cintegrationWriteToken: "Token eingeben",
      cintegrationDataYourAPIKey: "Geben Sie Ihren API-Schlüssel ein",
      viewQuizInMobile: "Quiz ansehen",
      notificationCSRFTokenMismatch: "CSRF-Token stimmt nicht überein",
      notificationReloadPage: "Bitte laden Sie die Seite neu und versuchen Sie es erneut",
      csettingsIntegrationKeyRemOnline: "Geben Sie den Token und die Kanal-ID in die entsprechenden Felder ein",
      cintegrationDataYourIntegrationToken: "API-Schlüssel",
      cintegrationDataLeadTypeId: "Kanal-ID",
      send_utm: "UTM-Tags senden",
      send_quiz: "Quiz-Daten senden",
      send_answers: "Fragen und Antworten senden",
      csettingsIntegrationKeyCrm: "KeyCRM-Integration",
      cintegrationSendPulseClientId: "Kunden-ID",
      cintegrationSendPulseClientSecret: "Geheimnis",
      cintegrationSendPulseAddressBookId: "Adressbuch-ID",
      cintegrationSendPulseAction: "Aktion mit Kontakt",
      sendpulseActionAddContact: "Kontakt hinzufügen",
      sendpulseActionDeleteContact: "Kontakt löschen",
      cintegrationPipeDriveToken: "API-Token",
      cintegrationPipeDriveDomain: "Ihre einzigartige Subdomain",
      cintegrationKeyCrmApiKey: "API-Schlüssel",
      cintegrationKeyCrmPipelineId: "Trichter-ID",
      cintegrationMenuGoogleTagManager:"Google Tag Manager",
      cintegrationMenuGoogleAnalytics:"Google Analytics",
      cintegrationMenuGoogleSpreadsheets:"Google Spreadsheets",
      cintegrationMenuKeepinCRM:"KeepinCRM",
      cintegrationMenuFacebookPixel:"Facebook pixel",
      cintegrationMenuTikTokPixel:"TikTok Pixel",
      cintegrationMenuWebHook:"Webhook",
      cintegrationMenuZapier:"Zapier",
      cintegrationMenuAPIxDrive:"APIx Drive",
      cintegrationMenuMake:"Make",
      cintegrationMenuSendPulse:"Send Pulse",
      cintegrationMenuMailchimp:"Mailchimp",
      cintegrationMenuEmail:"Email",
      cintegrationMenuTelegramBot:"Telegram-bot",
      cintegrationMenuPipeDrive:"PipeDrive",
      cintegrationMenuRemOnline:"Rem Online",
      cintegrationMenuKeyCRM:"Key CRM",
      cintegrationMenuCRMBitrix:"CRM Bitrix",
      googleSignIn: "Mit Google anmelden",
      googleSignInHint: "Autorisieren Sie sich, um die Integration weiter zu konfigurieren.",
      cintegrationGoogleSpreadsheetID: "Tabellen-ID",
      cintegrationGoogleSheetName: "Name des Tabellenblatts",
      googleSheetNameTip: "Verwenden Sie den Blattnamen genau wie in Google Sheets.",
      googleSheetsMappingTitle: "Feldzuordnung",
      cintegrationGoogleSheetsSaved: "Google Spreadsheets Daten gespeichert",
      googleSheetsSelectSheet: "Blatt auswählen",
      googleSheetsSelectSheetPlaceholder: "Blatt wählen",
      googleSheetsSelectSheetFirst: "Wählen Sie zuerst ein Blatt aus, um das Mapping zu konfigurieren",
      cintegrationKeepinPipelineId: "Pipeline",
      cintegrationKeepinPipelineIdPlaceholder: "Pipeline auswählen",
      cintegrationKeepinStatusId: "Status",
      cintegrationKeepinStatusIdPlaceholder: "Status auswählen",
      cintegrationKeepinManagerId: "Manager",
      cintegrationKeepinManagerIdPlaceholder: "Manager auswählen",
      cintegrationKeepinSourceId: "Quelle",
      cintegrationKeepinSourceIdPlaceholder: "Quelle auswählen",
      cintegrationKeepinUseMapping: "Feldzuordnung verwenden",
      cintegrationKeepinDataSaved: "KeepinCRM Daten gespeichert",
      trashcanRestoreQuiz: "Quiz wiederherstellen",
      cformValuePromotionAccepted: "Ich stimme dem E-Mail-Newsletter zu",


      constructorAddIntegration: "Integration hinzufügen",
      cintegrationKeyCrmSourceId: "Quellen-ID (optional)",
      cintegrationKeyCrmManagerId: "Manager-ID (optional)",
      cSettingsSettingQuizSpamFilterTitle: "Spamschutz",
      cSettingsSettingQuizSpamFilterDescription: "Die Funktion ist standardmäßig deaktiviert. Wenn Sie auf das Problem von Spam-Leads stoßen, aktivieren Sie den Schutz. Danach kann ein Benutzer nicht mehr als die angegebene Anzahl von Leads für dieses Quiz einreichen.",
      cSettingsSettingQuizSpamFilterLimitPlaceholder: "Anzahl der Leads",
      langNO: "Norwegisch",
      loadMoreLeads: "Mehr Leads anzeigen",
      userAdditionalSettingsHeader: "Erweiterte Profileinstellungen",
      userAdditionalSettingsDescription1: "Hier können Sie neue erweiterte Profileinstellungen konfigurieren.",
      userAdditionalSettingsPagination: "Paginierung auf der Arbeitstafel",

      benefitType: "Bonustyp",
      benefitLabelPlaceholder: "Bonustext",
      benefitDescriptionPlaceholderDiscount: "Gutscheincode oder Anweisung",
      benefitDescriptionPlaceholderVideo: "Link zum Video",
      benefitDescriptionPlaceholderTextfile: "Link zur Textdatei",
      benefitDescriptionPlaceholderGift: "Bonusbeschreibung",
      benefitDescriptionPlaceholderPDF: "Link zum PDF",
      benefitDescriptionPlaceholderLink: "Link",
      benefitDescriptionPlaceholderFile: "Link zur Datei",
      benefitDescriptionPlaceholderCustom: "Link",
      benefitLabelDiscount: "Rabatt",
      benefitLabelVideo: "Video",
      benefitLabelTextfile: "Textdatei",
      benefitLabelGift: "Geschenk",
      benefitLabelPDF: "PDF-Datei",
      benefitLabelLink: "Link",
      benefitLabelFile: "Datei",
      benefitLabelCustom: "Individueller Bonus",
      addBenefit: "Bonus hinzufügen",
      saveBenefit: "Bonus speichern",
      cfinishSocialNetworks: "Soziale Netzwerke",

      saveSocialNet: "Soziales Netzwerk speichern",
      networkLabelFacebook: "Facebook",
      networkLabelInstagram: "Instagram",
      networkLabelTelegram: "Telegram",
      networkLabelTiktok: "Tik-Tok",
      networkLabelYoutube: "Youtube",
      networkLabelLinkedin: "LinkedIn",
      networkLabelWhatsapp: "WhatsApp",
      socialNetDescriptionPlaceholderFacebook: "profil_nikname",
      socialNetDescriptionPlaceholderInstagram: "profil_nikname",
      socialNetDescriptionPlaceholderTelegram: "profil/kanal_nikname",
      socialNetDescriptionPlaceholderTiktok: "profil_nikname",
      socialNetDescriptionPlaceholderYoutube: "kanal_name",
      socialNetDescriptionPlaceholderLinkedin: '"in/name" oder "company/name"',
      socialNetDescriptionPlaceholderWhatsapp: "+15555551234",

      addNewSectionEmptyPage: "Textseite",
      csanyMakeImpasse: "Sackgasse",
      impaseIsImpaseTrue: "Ermöglicht",
      impaseIsImpaseFalse: "Deaktiviert",
      defaultNewEmptyQuestionDescription: "Sie können hier langen Text einfügen und formatieren (wir empfehlen, nicht mehr als 3000 Zeichen einzufügen).",
      cSettingsSettingQuizTimezoneTitle: "Quiz-Zeitzone",
      cSettingsSettingQuizTimezoneDescription: "Geben Sie die Zeitzone ein, in der die Zeit für die Lead-Eingabe angegeben wird. Dies ist besonders nützlich, wenn Sie sich in einer Zeitzone befinden und der Kunde in einer anderen. In diesem Fall können Sie die Zeitzone des Kunden einstellen, und die Leads, die Sie erhalten, zeigen die Zeit entsprechend der Zeitzone des Kunden an.",
      cSettingsSettingQuizTimezonePlaceholder: "Zeitzone",
      userAdditionalSettingsTimezone: "Zeitzone des Benutzers",
      userAdditionalSettingsTimezonePlaceholder: "Zeitzone",
      langHE: "Hebräisch",
      langCS: "Tschechisch",
      cintegrationCAPIFBInstruction: "Um die Integration mit Facebook Conversion API einzurichten, müssen Sie die Pixel-ID und den Zugriffstoken eingeben. Diese Informationen finden Sie in den Einstellungen des Facebook Business Managers. Nachdem Sie die erforderlichen Daten eingegeben haben, speichern Sie die Integration.",
      cintegrationCAPIFBInstructionTextTitle: "Ereignisnamen für FB Conversions:",
      cintegrationCAPIFBInstructionTextStart: " – Besuch der Startseite;",
      cintegrationCAPIFBInstructionTextQuestionN: " – Besuch von Schritt N (die Schrittzahl wird dynamisch eingefügt);",
      cintegrationCAPIFBInstructionTextOpenContactPage: " – Besuch der Kontaktseite;",
      cintegrationCAPIFBInstructionTextLead: " – erfolgreiche Übermittlung des Kontaktformulars;",
      cintegrationCAPIFBInstructionTextThankYou: " – Besuch der Abschlussseite.",
      cintegrationCAPIFBInstructionTextOptimizationAdvice: "Wir empfehlen, Anzeigen mit der Optimierung für das Ereignis zu schalten:",
      cintegrationCAPIFBInstructionTextLeadTriggerCondition: "Dieses Ereignis wird",
      bold_capi_adsquiz_Start: "capi_adsquiz_Start",
      bold_capi_adsquiz_QuestionN: "capi_adsquiz_Question-N",
      bold_capi_adsquiz_OpenContactPage: "capi_adsquiz_OpenContactPage",
      bold_capi_adsquiz_Lead: "capi_adsquiz_Lead",
      bold_capi_adsquiz_ThankYou: "capi_adsquiz_ThankYou",
      bold_capi_adsquiz_OptimizationAdvice: "“capi_adsquiz_Lead”.",
      bold_capi_adsquiz_LeadTriggerCondition: " nur ausgelöst, wenn eine Anfrage erfolgreich eingereicht wurde.",
      csettingsIntegrationFbCapiAbout: "Die Integration mit Facebook Conversion API ermöglicht es Ihnen, Nutzerdaten direkt an Facebook zu senden, um die Wirksamkeit von Werbekampagnen zu verbessern.",
      cintegrationInputCapiAccessToken: "Zugriffstoken eingeben",
      cintegrationInputCapiCustomparameter: "Benutzerdefinierte Ereignisparameter eingeben",
      cintegrationDataFbCapiSaved: "Facebook Conversion API-Integration erfolgreich gespeichert",
      cintegrationComonRenovateHubInstructionTitle: "Anleitung zur Einrichtung der Integration mit «Міністерство Ремонту»",
      cintegrationComonRenovateHubInstructionDescription1: "Um die Integration mit „Ministerstvo Remontu“ einzurichten, geben Sie die Webhook-URL an, an die die Daten gesendet werden.",
      cintegrationComonRenovateHubInstructionDescription2: "Gehen Sie dazu in das „Admin-Panel“, öffnen Sie anschließend den Bereich „Integrationen“ und wählen Sie ADS Quiz aus. Klicken Sie auf „Webhook-URL erstellen“, kopieren Sie diese und fügen Sie sie im ADS Quiz-Service in das Eingabefeld unten ein.",
      cintegrationComonRenovateHubInstructionDescription3: "Führen Sie danach das Quiz zu Testzwecken aus oder senden Sie einen Test-Lead über die Schaltfläche „Test“.",
      cintegrationComonRenovateHubInstructionDescription4: "Speichern und aktivieren Sie anschließend die Integration. Alle Leads werden in „Ministerstvo Remontu“ im Bereich „Anfragen“ erfasst.",
      cintegrationComonRenovateHubInstructionShort: "Die Integration mit «Міністерство Ремонту» ermöglicht es Ihnen, Daten zur Prozessautomatisierung über einen Webhook an das CRM zu senden.",
      cintegrationRenovateHubUrl: "URL von «Міністерство Ремонту» eingeben",
      cintegrationInputRenovateHubUrl: "Geben Sie die Webhook-URL für «Міністерство Ремонту» an",
      cintegrationRenovateHubDataSaved: "Integration mit «Міністерство Ремонту» erfolgreich gespeichert",
      cintegrationDataRenovateHubError: "Fehler beim Speichern der Integration mit «Міністерство Ремонту». Bitte überprüfen Sie die eingegebenen Daten.",
      cintegrationMenuFacebookConvAPI: "Facebook Conversions API",
      cintegrationMenuRenovateHub: "Міністерство Ремонту",
      csettingsIntegrationRenovateHub: "Integration mit «Міністерство Ремонту»",
      csettingsIntegrationCAPIFB: "Facebook Conversions API - Integration",
      paymentPlanEnd: "Enddatum des Plans",
      paymentPlanNextPayment: "Nächste Zahlung",
      paymentPlanLeadsLimitForYear: "Begrenzung der Leads pro Jahr:",
      paymentPlanLeadsLimitForPeriod: "Begrenzung der Leads pro Zeitraum:",
      EditTags: "Tags bearbeiten",
      quizzesTemplatesNoTags: "Keine Tags",
    
      Monday: "Montag",
      Tuesday: "Dienstag",
      Wednesday: "Mittwoch",
      Thursday: "Donnerstag",
      Friday: "Freitag",
      Saturday: "Samstag",
      Sunday: "Sonntag",
      datetimeDisplayMode: "Typ auswählen",
      datetimeDisplayModeSelect: "Typ auswählen",
      datetimeDisplayModeDate: "Datum",
      datetimeDisplayModeTime: "Uhrzeit",
      datetimeDisplayModeDatetime: "Datum & Uhrzeit",
      datetimeMinDate: "Min. Datum",
      datetimeMinDateCustom: "Min. Datum wählen",
      datetimeMaxDate: "Max. Datum",
      datetimeMaxDateCustom: "Max. Datum wählen",
      datetimeProhibitDaysOfWeek: "Tage sperren",
      datetimeIsRange: "Bereich aktivieren",
      datetimeIsRangeTrue: "Bereich aktiviert",
      datetimeIsRangeFalse: "Bereich deaktiviert",
      datetimeMinTime: "Min. Uhrzeit",
      datetimeMaxTime: "Max. Uhrzeit",
      datetimeIs24: "24-Stunden-Format",
      datetimeIs24True: "24-Stunden aktiviert",
      datetimeIs24False: "24-Stunden deaktiviert",
      csanyIsExactDate: "Wie möchten Sie das Datum einstellen",
      csanyIsExactDateTrue: "Genaues Datum",
      csanyIsExactDateFalse: "Relatives Datum",
      csanyDatetimeMinMaxNotExactPlaceholder: '"x" oder "-x" Tage ab heute',
      addNewSectionDatetime: "Datum/Uhrzeit",
      tariffsPromo: "Werbeangebote",
      pricingComparisonEyebrow: 'Adsquiz Tarife',
      pricingComparisonTitle: 'Wählen Sie einen unserer Pläne',
      pricingComparisonMobileHint: 'Wischen Sie durch die Tarifkarten und wählen Sie unten zwei zum Vergleichen aus.',
      pricingComparisonTableAria: 'Pricing plans comparison table',
      pricingComparisonMonthShort: 'Monat',
      billingPromoPeriodYearly: "Jahr",
      billingPromoPeriodMonths: "{count} Monate",
      billingPromoDescription: "Keine Grenzen bei Quiz und Funktionen",
      pricingComparisonTryFree: 'Kostenlos testen',
      pricingComparisonGetStarted: 'Upgraden',
      pricingComparisonCurrentPlan: 'Aktueller Tarif',
      pricingComparisonBuyAgain: 'Erneut kaufen',
      pricingComparisonLeadsPerMonth: '{count} Leads /Monat',
      pricingComparisonUnlimited: 'Unbegrenzt',
      pricingComparisonTeamUsers: '+{n} Nutzer | +{n} Nutzer',
      pricingComparisonRequired: 'Erforderlich',
      pricingComparisonOptional: 'Optional',
      tariffsMonth: "Monatlich",
      tariffsAnual: "Jährlich",
      leadsOn1Month: "pro Monat",
      leadsOn2Month: "für 2 Monate",
      leadsOn3Month: "für 3 Monate",
      leadsOn4Month: "für 4 Monate",
      leadsOn5Month: "für 5 Monate",
      leadsOn6Month: "für 6 Monate",
      leadsOn7Month: "für 7 Monate",
      leadsOn8Month: "für 8 Monate",
      leadsOn9Month: "für 9 Monate",
      leadsOn10Month: "für 10 Monate",
      leadsOn11Month: "für 11 Monate",
      leadsOn12Month: "pro Jahr",
      leadsOn24Month: "für 2 Jahre",
      leads: "Leitungen",
      tariffsWordPrice: "Preis",
      tariffsNoLimits: "Keine Einschränkungen",
      tariffsNoLimitsQuizzes: "bei Tests",
      tariffsAndFunctions: "und Funktionalität",
      billingTariffYear: "Jahr",
      billingChangePlanSubscribe: "Abonnieren",
      paymentAllTariffInactive: "Der Tarif ist nicht aktiv",
      subscriptionTariffLableOnly: "Nur im Abonnement verfügbar",
      notExactBeforeYear: "vor einem Jahr",
      notExactBeforeHalfYear: "vor einem halben Jahr",
      notExactBeforeQuarter: "vor einem Quartal",
      notExactBeforeMonth: "vor einem Monat",
      notExactBeforeWeek: "vor einer Woche",
      notExactBeforeYesterday: "vorgestern",
      notExactYesterday: "gestern",
      notExactToday: "heute",
      notExactTomorrow: "morgen",
      notExactAfterTomorrow: "übermorgen",
      notExactAfterWeek: "in einer Woche",
      notExactAfterMonth: "in einem Monat",
      notExactAfterQuarter: "in einem Quartal",
      notExactAfterHalfYear: "in einem halben Jahr",
      notExactAfterYear: "in einem Jahr",
      tipDefaultDateHeader: "Standard",
      tipDefaultDateText: "Wenn sowohl der Schalter 'Genaues Datum' als auch 'Relatives Datum' ausgeschaltet sind, erlaubt der Kalender standardmäßig die Auswahl von Daten im Bereich von Jahr 1800 bis 2200.",
      tipExactDateHeader: "Schalter für genaues Datum",
      tipExactDateText: "Wenn dieser Schalter aktiviert ist, wird der Kalender auf einen festen Datumsbereich beschränkt, der in den unten stehenden Eingabefeldern ausgewählt wird.",
      tipRelativeDateHeader: "Schalter für relatives Datum",
      tipRelativeDateText: "Wenn dieser Schalter aktiviert ist, werden die Kalendergrenzen dynamisch basierend auf relativen Daten festgelegt, die zum Zeitpunkt des Seitenladevorgangs berechnet werden. Diese Grenzen sind personalisiert und werden für jeden Benutzer individuell neu berechnet.",
      langPT: "Portugiesisch",
      placeholderCompanyContactText: 'Zum Beispiel: "Firmentelefon: +490993322211"',
      integrationConnectService: "Verbinden",
      Connect: "Verbinden",
      Connected: "Verbunden",
      Disconnect: "Trennen",
      cintegrationOauthDisconnectModalTitle: "Verbindung mit {provider} trennen?",
      cintegrationOauthDisconnectModalDescription: "Das Trennen von {provider} trennt diese Integration von ALLEN Quizzen. Wenn Sie sie nur für dieses Quiz deaktivieren möchten, löschen Sie die Integration unten.",
      cintegrationOauthDisconnectModalDescriptionBase: "Das Trennen von {provider} trennt diese Integration von ALLEN Quizzen.",
      cintegrationOauthDisconnectModalDescriptionDeleteHint: "Wenn Sie sie nur für dieses Quiz deaktivieren möchten, löschen Sie die Integration unten.",
      cintegrationOauthDisconnectDeleteQuizOnly: "Nur in diesem Quiz löschen",
      cintegrationOauthDisconnectAllQuizzes: "Für alle Quizze trennen",
      leadtype_id: "Aktionstyp",
      selectVariant: "Wählen",
      sfirstAddCompanyContacts: "Text mit Kontakten",
      addNewSectionTextarea: "Großes Eingabefeld",
      allstepsVariantView: "Bildformat",
      tariffsDiscountSave: "Spare",
      cAdminSettingsTitle: "Administrative Einstellungen",
      cAdminSettingsInstruction: "Geben Sie die Tags für das Quiz in das untenstehende Feld ein. Tags können aus mehreren Wörtern bestehen, jedes Tag wird durch ein Komma getrennt. Tags 'Dienstleistungen' und 'dienstleistungen' sind unterschiedliche Tags. Es wird empfohlen, Tags zu verwenden, die mit einem Großbuchstaben beginnen. Sie können das Quiz auch aus der Liste der Vorlagen ausschließen.",
      cAdminSettingsIsTemplate: "Ist es eine Vorlage",
      cIsTemplateStateAreSaved: "Der Vorlagenstatus wurde gespeichert",
      sfirstAddLogotype: "Fügen Sie ein Logo hinzu",
      logotypeSizeTip: "Das Logo wird in seiner tatsächlichen Größe eingefügt, jedoch nicht größer als 120 Pixel auf der längeren Seite.",
      cfirstLogotypeUpdated: "Das Logo wurde hinzugefügt",
      cfirstLogotypeDeleted: "Das Logo wurde erfolgreich gelöscht!",


      cOffersPageSettings: "Einstellungen",
      offerPageTitlePlaceholder: "Titel eingeben",
      offerPageDescriptionPlaceholder: "Seitenbeschreibung eingeben",
      offerPageButtonTextPlaceholder: "Button-Text eingeben (optional)",
      allstepsOffers: "Liste der Angebote",
      offerProposalHeader: "Angebot",
      offerAttachAddImg: "Bild hinzufügen",
      offerAttachAddVideo: "Video hinzufügen",
      offerItemImg: "Bild",
      offerItemTitle: "Angebotstitel",
      offerTitlePlaceholder: "Titel hier eingeben",
      offerItemSubtitle: "Untertitel (z. B. Preis)",
      offerSubtitlePlaceholder: "Text hier eingeben",
      offerItemDescription: "Angebotsbeschreibung",
      offerDescriptionPlaceholder: "Beschreibung hier eingeben",
      offerItemButtonText: "Button-Text des Angebots",
      offerBtnTextPlaceholder: "Button-Text eingeben",
      offerItemButtonLink: "Button-Link",
      offerBtnLinkPlaceholder: "Link muss mit https:// beginnen",
      csanyOfferLogic: "Anzeigelogik",
      offerAddNewOffer: "Neues Angebot hinzufügen",
      offerLogicSetupTitle: "Logikeinstellungen",
      OfferLogicSetupDescription: "Hier können Sie einstellen, welche Antworten welche Angebote anzeigen",
      cstepsOffersPage: "Ergebnisseite",
      addNewSectionResultsByLogic: "Angebote",
      cformActionAfterContactOffersOr: "Angebotsseite / ",
      tolltipOffersAfterContact: "Wenn nach dem Abschluss des Quiz die Logik zur Anzeige von mindestens einem Angebot erfüllt ist, wird die Angebotsseite angezeigt, andernfalls die Dankeseite.",
      videoCircleTextQuestion: "Videoanleitung",
      offerPhotoOptimalRatio: "Für eine optimale Bildanzeige empfehlen wir ein Seitenverhältnis von 16:9.",
      tolltipThankYouAfterContact: "Nach Abschluss des Quiz wird eine Dankeseite angezeigt.",
      cformActionAfterContactOffers: "Ergebnisseite",
      addOfferPageInContact: "Ergebnisseite aktivieren",
      offerPageHeader: "Überschrift für die Angebotsseite",
      pumkinOrange: "Orange",
      invalidSocialNetworkURL: "Ungültiger Link", 
      itMustBeFullLink: 'Überprüfen Sie den eingegebenen Link. Er muss mit dem Protokoll "https://" beginnen und dem gespeicherten sozialen Netzwerk entsprechen.',
      addSocialLinks: "Fügen Sie soziale Links hinzu",
      questionAttachAddImg: "Foto",
      questionAttachAddVideo: "Video",
      questionChooseLineInput: "Zeile",
      questionChooseClassicInput: "Klassisch",
      questionChooseOneColumn: "1 Spalte",
      questionChooseTwoColumns: "2 Spalten",
      allStepsVideoUrl: "Videolink",
      allStepsPhotoHeader: "Foto",
      cintegrationMenuSalesDrive: "SalesDrive",
      csettingsIntegrationSalesDrive: "Integration - SalesDrive",
      csettingsIntegrationSalesDriveAbout: "Sie können Leads an das CRM SalesDrive senden",
      cintegrationSalesDriveApiKey: "API-Schlüssel einfügen",
      cintegrationSalesDriveDomain: "Fügen Sie die von SalesDrive bereitgestellte Domain ein",
      cintegrationSalesDriveDataSaved: "SalesDrive-Integration gespeichert",
      send_offers: "Angebote senden, die dem Besucher angezeigt wurden",
      cformShowConsultant: "Berater anzeigen",
      consultantPhoto: "Foto des Beraters",
      consultantName: "Name des Beraters",
      consultantJobTitle: "Position des Beraters oder andere Informationen",
      consultantRating: "Bewertung des Beraters",
      signinIWouldLikeReciveEmail: "Ich möchte Neuigkeiten und Sonderangebote von ADS QUIZ erhalten (Sie können sich jederzeit von diesen Mitteilungen abmelden).",
      acceptedFileSizeUpTo: "bis zu",
      customDesignColorTags: "Tags",
      customDesignColorActiveButton: "Farbe des aktiven Elements",
      customDesignColorInactiveButton: "Farbe des inaktiven Elements",
      customDesignColorActiveText: "Farbe des aktiven Textes",
      customDesignColorInactiveText: "Farbe des inaktiven Textes",
      addNewSectionDropdown: "Dropdown",
      addNewSectionRatePage: "Bewertungsseite",
      langFR: "Französisch",
      bold_adsquiz_Offers_page: "adsquiz_Open-Offers-Page",
      cintegrationFBInstructionTextOffersPage: "Zur Angebotsseite wechseln",
      defaultNewQuestionDropdownPlaceholder: "Klicken Sie hier, um die Optionen anzuzeigen",
      allStepsVideoUrlPlaceholder: "https://youtube, vimeo oder wistia",
      addListOfAnswersButton: "Mehrere hinzufügen",
      addListOfAnswersTitle: "Mehrere Antwortoptionen hinzufügen",
      addListOfAnswersInstruction: "Fügen Sie die Liste der Antwortoptionen in dieses Feld ein, um sie hinzuzufügen. Optionen können durch Zeilenumbrüche [↵], Semikolons [;], Kommas [,] oder Leerzeichen [ ] getrennt werden. Die Trennung erfolgt anhand des Trennzeichens mit der höchsten Priorität: [↵] → [;] → [,] → [ ].",
      addListOfAnswersPlaceholder1: "Antwort 1",
      addListOfAnswersPlaceholder2: "Antwort 2",
      addListOfAnswersSendButton: "Hinzufügen",
      addNewPerson: "Teilnehmer hinzufügen",
      cfirstGradientOverlay: "Gradient-Hintergrundüberlagerung",
      cfirstGradientOverlayTip: "Eine Gradient-Hintergrundüberlagerung ist hilfreich, wenn das Hintergrundbild wenig Kontrast zur Textfarbe aufweist.",
      cfirstContentBorder: "Trennrahmen für den Inhalt",
      workboardDuplicateToOthers: "In ein anderes Konto kopieren",
      workboardDuplicateAndTransferQuiz: "Quiz in ein anderes Konto duplizieren",
      workboardDuplicateAndTransferQuizHintTitle: "Beim Duplizieren eines Quiz wird es als Vorlage in das Konto des Empfängers kopiert.",
      workboardDuplicateAndTransferQuizHintTitleSecond: "Das Quiz im Konto des Empfängers ist leer, ohne Leads und Integrationen. Das aktuelle Quiz bleibt unverändert. Um ein Quiz auf ein anderes Konto zu kopieren, muss einer der Benutzer ein beliebiges ",
      workboardDuplicateAndTransferQuizConfirm: "Duplizieren",
      workboardDuplicateAndTransferQuizStatus200: "Quiz erfolgreich auf das Konto kopiert:",
      delOffersPageQuestionForModalConfirm: "Sind Sie sicher, dass Sie die Angebotsseite löschen möchten?",
      offerPageDefaultDescription: "Geben Sie hier die Beschreibung der Ergebnisseite ein",
      offerPageDefaultButtonText: "Beenden",
      cintegrationMenuKommo: "Kommo",
      csettingsIntegrationKommo: "Integration - Kommo",
      csettingsIntegrationKommoAbout: "Sie können Leads an das Kommo CRM senden",
      cintegrationKommoToken: 'Fügen Sie den "Long-lived Token" ein',
      cintegrationKommoDomain: "Fügen Sie Ihre Subdomain ein",
      cintegrationKommoDataSaved: "Kommo-Integration gespeichert",
      cintegrationKommoPipelineId: "Fügen Sie die PipelineID ein",
      cintegrationKommoPipelineIdPlaceholder: "Pipeline auswählen",
      cintegrationKommoStatusID: "Fügen Sie die StatusID ein",
      cintegrationKommoStatusIDPlaceholder: "Status für neuen Lead auswählen (optional)",
      cintegrationKommoTagId: "Fügen Sie die TagID ein",
      cintegrationKommoTagIdPlaceholder: "Tag für neuen Lead auswählen (optional)",
      cintegrationKommoError: "Fehler beim Speichern der Kommo-Integration. Überprüfen Sie die eingegebenen Daten.",
      cintegrationKommoDeleted: "Kommo-Integration gelöscht",
      cintegrationKommoDeletedError: "Fehler beim Löschen der Kommo-Integration",
      cintegrationKommoCreateNote: "Notiz mit Antworten erstellen",
      cintegrationKommoUseMapping: "Feldzuordnung verwenden",
      mappingValue: "Feld im CRM",
      mappingValueMailchimp: "Feld in Mailchimp",
      mappingKey: "Feld im Lead",
      addMappingRow: "Feldverknüpfung hinzufügen",
      DELETE: "Löschen",
      mappingAnswer: "Antwort auf die Frage",
      testIntegration: "Test",
      testIntegrationLast10Leads: "Integrationstest (letzte 10 Leads)",
      testIntegrationNeedRealLeadTooltip: "Der Test ist nur verfügbar, wenn im Quiz mindestens ein echter Lead vorhanden ist.",
      loading: "Wird geladen...",
      sentAt: "Gesendet",
      phone: "Telefon",
      email: "E-Mail",
      action: "Aktion",
      send: "Senden",
      sending: "Senden...",
      success: "Erfolg",
      failed: "Fehlgeschlagen",
      error: "Fehler",
      displayCondition: "Anzeigebedingung",
      selectDisplayCondition: "Anzeigebedingung auswählen",
      seconds: "Sekunden",
      button: "Schaltfläche",
      buttonContainerSelector: "Selektor des Button-Containers",
      buttonContainerSelectorPlaceholder: ".quiz-buttons oder #quiz-button-place",
      clickHere: "Hier klicken",
      buttonClick: "Klick auf die Schaltfläche",
      clickOnWidget: "Klick auf das Widget",
      exitIntent: "Beim Verlassen der Seite",
      pageLoad: "Nach dem Laden der Seite",
      delay: "Nach einer bestimmten Zeit",
      resultPageSectionTitle: "Ergebnisse nach Punkten",
      resultPageSectionAccordion: "Ergebnisseite nach Punkten",
      resultPageShowCondition: "Bedingung anzeigen",
      resultPageShowCollectedPoints: "Erreichte Punkte anzeigen",
      resultPageShowMaxPoints: "Maximale Punkte anzeigen",
      resultPageShowProgressBar: "Fortschrittsbalken anzeigen",
      resultPageSelectFormat: "Ergebnisformat auswählen",
      resultPageScenarios: "Szenarien",
      resultPageAddScenario: "Szenario hinzufügen",
      resultPageScenarioPhoto: "Foto hinzufügen",
      resultPageScenarioTitle: "Titel",
      resultPageScenarioTitlePlaceholder: "Szenariotitel eingeben",
      resultPageScenarioDescription: "Beschreibung",
      resultPageScenarioDescriptionPlaceholder: "Szenariobeschreibung eingeben",
      resultPageScenarioUrlPlaceholder: "Link (https://)",
      resultPageScenarioButtonText: "Button-Text",
      resultPageScenarioButtonTextPlaceholder: "Button-Text eingeben",
      resultPagePointsCondition: "Anzeigebedingung nach Punkten",
      resultPagePointsBetween: "Zwischen",
      resultPagePointsMoreThan: "Mehr als",
      resultPagePointsLessThan: "Weniger als",
      resultPagePointsEqual: "Gleich",
      resultPageErrorAddNewScenario: "Neues Szenario konnte nicht hinzugefügt werden",
      resultPageErrorRangeExplanation: "Bitte mehr Punkte hinzufügen oder auf Szenarien verteilen",
      resultPageErrorFullRange: "Alle Punktbereiche sind bereits abgedeckt",
      resultPageErrorOutOfRange: "Punkte liegen außerhalb des zulässigen Bereichs",
      resultPageErrorSaving: "Fehler beim Speichern der Szenarien",
      resultPageErrorOverlap: "Punktwerte in den Szenarien dürfen sich nicht überschneiden",
      resultPageAutoRedirectWarningTitle: "Automatische Weiterleitung deaktiviert",
      resultPageAutoRedirectWarningText: "Um die automatische Weiterleitung zu aktivieren, fügen Sie in jedem Ergebnisszenario eine URL hinzu.",
      resultPageAutoRedirectWarningButton: "OK",
      AddTags: "Tags hinzufügen",
      resultPageModalDescription: "Vergeben Sie Punkte für jede Antwort.",
      resultPageYourOptions: "Ihre Möglichkeiten",
      placeholderDefaultValue: "Wert",
      resultPageByPointsTitle: "Ergebnisse nach Punkten",
      resultPageConditionSettingsButton: "Punktelogik",
      resultPageConditionSettingsSaved: "Gespeichert",
      resultPageConditionSettingsUnsaved: "Speichern",
      resultPagePlaceholderScenarioTitle: "Szenariotitel",
      resultPagePlaceholderScenarioDescription: "Hier können Sie eine kurze Beschreibung der Ergebnisse eingeben",
      resultPageLabelScenarioCti: "Call-to-Action",
      resultPagePlaceholderScenarioCti: "Buttontext",
      resultPagePlaceholderScenarioUrl: "Button-Link",
      resultPagePlaceholderRedirectUrl: "Weiterleitungslink",
      resultPageScenarioSaveChanges: "Änderungen speichern",
      resultPageScenarioSaveChangesComplete: "Änderungen gespeichert",
      resultPageConditionSettingsTitle: "Ergebniseinstellungen nach Punkten",
      resultPageConditionSettingsDescription: "Legen Sie für jedes Szenario einen Punktebereich fest",
      resultPageConditionResultsColumn: "Ergebnisse",
      resultPageConditionRangeSummary: "Maximaler Punktebereich:",
      addNewSectionSubHeaderChoise: "Antwort eingeben/auswählen",
      addNewSectionSubHeaderResults: "Ergebnisse",
      noTeamRole: "-",
      viewerTeamRole: "Betrachter",
      noAccessTeamRole: "Keine Aktionen",
      editorTeamRole: "Redakteur",
      managerTeamRole: "Manager",
      adminTeamRole: "Administrator",
      teamRoleGuideTitle: "Was Rollen bedeuten",
      teamRoleGuideDescription: "Eine Rolle aktiviert automatisch einen Berechtigungssatz. Nach der Auswahl wird die Rolle sofort in der Oberfläche aktualisiert, und Send sendet den gewählten Zugriff.",
      teamRoleGuideFlowOwner: "Inhaber",
      teamRoleGuideFlowOwnerText: "gewährt Zugriff",
      teamRoleGuideFlowRole: "Rolle",
      teamRoleGuideFlowRoleText: "wählt Vorlage",
      teamRoleGuideFlowPermissions: "Berechtigungen",
      teamRoleGuideFlowPermissionsText: "aktivieren Aktionen",
      teamRoleGuideFlowResult: "Verfügbare Oberfläche",
      teamRoleGuideFlowResultText: "öffnet Bedienelemente",
      teamRoleGuideViewerDescription: "Kann Leads und Antworten für ausgewählte Quizze ansehen.",
      teamRoleGuideEditorDescription: "Kann das Quiz bearbeiten, kopieren und die Veröffentlichung verwalten.",
      teamRoleGuideManagerDescription: "Kann das Quiz bearbeiten, CRM ansehen, Integrationen verwalten und Zugriff weitergeben.",
      teamRoleGuideAdminDescription: "Erhält alle Rechte: Verwaltung, Integrationen, CRM, Zugriffe, Übertragung, Löschen und Veröffentlichung.",
      canViewLeadsLabel: "Leads anzeigen",
      canViewLeadsDescription: "Kann Anfragen, Antworten und Kontakte anzeigen",
      canCopyQuizLabel: "Quiz kopieren",
      canCopyQuizDescription: "Kann Kopien des ausgewählten Quiz erstellen",
      canManageQuestionsLabel: "Quiz bearbeiten",
      canManageQuestionsDescription: "Kann Quiz, Seiten, Fragen, Varianten, Berater, Vorteile, Kontaktfelder, soziale Netzwerke und Optionen bearbeiten",
      canManageIntegrationsLabel: "Integrationen",
      canManageIntegrationsDescription: "Kann Integrationen, Schlüssel und Webhooks verwalten",
      canManageSettingsLabel: "Einstellungen",
      canManageSettingsDescription: "Kann Domains, Seiten und Kontaktfelder ändern",
      canShareLabel: "Zugriffe",
      canShareDescription: "Kann andere Benutzer einladen",
      canTransferLabel: "Quiz übertragen",
      canTransferDescription: "Kann das Quiz an einen anderen Benutzer übertragen",
      canDeleteLabel: "Löschen",
      canDeleteDescription: "Kann das Quiz löschen und wiederherstellen",
      canPublishLabel: "Veröffentlichung",
      canPublishDescription: "Kann Veröffentlichung und Domains verwalten",
      descriptionTeamView: "Fügen Sie Mitglieder hinzu und konfigurieren Sie Zugriffe auf Projekte und Quizze",
      addedUserInTeam: "Im Team",
      teamAccessGivenTab: "Teammitglieder",
      teamAccessReceivedTab: "Zugriffsquelle",
      teamAccessReceivedTitle: "Zugriff, der Ihnen gegeben wurde",
      teamAccessSharedBy: "Besitzer",
      teamAccessInvitedBy: "Eingeladen von",
      teamAccessRoleLabel: "Rolle",
      teamAccessScopeLabel: "Zugriff",
      teamNoReceivedAccess: "Noch niemand hat Ihnen Zugriff gegeben",
      teamNoGivenAccess: "Sie haben noch niemandem Zugriff gegeben",
      teamAccessFrozen: "Zugriff eingefroren",
      teamFreezeAccess: "Zugriff einfrieren",
      teamUnfreezeAccess: "Zugriff auftauen",
      teamPermissionDeniedTransfer: "You do not have permission to move this quiz",
      teamPermissionDeniedDelete: "You do not have permission to delete or restore this quiz",
      teamPermissionDeniedShare: "You do not have permission to manage sharing",
      teamPermissionDeniedManageQuiz: "You do not have permission to edit this quiz",
      teamPermissionDeniedCopy: "You do not have permission to copy this quiz",
      teamPermissionDeniedIntegrations: "You do not have permission to manage integrations",
      teamPermissionDeniedCrm: "You do not have permission to view CRM",
      teamPermissionDeniedPublish: "You do not have permission to publish this quiz",
      teamPermissionDeniedSettings: "You do not have permission to open this settings section",
      teamPermissionDeniedOpenQuiz: "You do not have available actions for this quiz",
      teamAccessDeniedTitle: "Section unavailable",
      teamAccessDeniedDescription: "You do not have permission for this action. Ask the project owner to grant access",
      teamPermissionDeniedDefault: "You do not have permission for this action",
      teamQuizzesWithoutProject: "Quizzes without project",
      quickInviteTitle: "Teammitglied einladen",
      quickInviteEmailLabel: "E-Mail",
      quickInviteQuizzesLabel: "Quizze zum Teilen",
      quickInviteLoadingQuizzes: "Quizze werden geladen…",
      quickInviteLoadQuizzesError: "Quizze konnten nicht geladen werden.",
      quickInviteRetry: "Erneut versuchen",
      quickInviteNoQuizzes: "Sie haben noch keine Quizze, die Sie teilen können.",
      quickInviteRoleHint: "Die Person erhält die ausgewählte Rolle in den ausgewählten Quizzen. Sie können sie später auf der {link} ändern.",
      quickInviteRoleHintLink: "Team-Seite",
      quickInviteSubmit: "Einladen",
      quickInviteSubmitting: "Wird gesendet…",
      quickInviteSelfError: "Sie können sich nicht selbst einladen",
      quickInviteSelectQuiz: "Wählen Sie mindestens ein Quiz aus",
      quickInviteSuccess: "Einladung gesendet an {email}",
      projectNoQuizzes: "0 Quizze",
      quizzes: "Quizze",
      sharedQuizzes: "Geteilte Quizze",
      sharedQuizzesWithoutProject: "Quizze ohne Projekt",
    },
    PL: {
      tariffLockBadgeLabel: "Pro",
      tariffLockBadgeReadOnlyLabel: "Tylko odczyt",
      tariffLockBadgeQuotaLabel: "Limit wykorzystany",
      tariffLockBadgeAriaLabel: "{label}: funkcja ograniczona przez Twój plan",
      tariffUpgradeActionLabel: "Ulepsz plan",
      tariffLockBadgeOwnerAriaLabel: "{label}: funkcja ograniczona taryfą właściciela quizu",
      tariffOwnerPlanFeatureUnavailableMessage: "Ta funkcja nie jest dostępna w taryfie właściciela quizu. Poproś właściciela o przejście na taryfę, która ją obejmuje.",
      tariffOwnerAccessUnavailableMessage: "Nie udało się sprawdzić taryfy właściciela quizu. Odśwież stronę.",
      tariffGateCollaborationForbiddenMessage: "Nie masz uprawnień do wykonania tej czynności w tym quizie.",
      tariffGateQuotaExhaustedMessage: "Wykorzystałeś limit dostępny w bieżącym planie. Przejdź na plan z wyższym limitem.",
      tariffGateGrandfatheredMessage: "Ta funkcja nie jest dostępna w Twoim bieżącym planie. Istniejące dane pozostają widoczne i można je usunąć, ale dodawanie i edycja są wyłączone. Przejdź na plan, który tę funkcję obejmuje.",
      tariffGateReadOnlyMessage: "Ta funkcja nie jest dostępna w Twoim bieżącym planie i jest wyświetlana w trybie tylko do odczytu. Przejdź na plan, który tę funkcję obejmuje.",
      tariffGateUsageUnavailableMessage: "Nie udało się ustalić wykorzystania tej funkcji. Spróbuj odświeżyć stronę.",
      tariffGateLoadingMessage: "Sprawdzanie dostępu w ramach planu…",
      tariffGateUnavailableMessage: "Ta funkcja nie jest dostępna w Twoim bieżącym planie. Przejdź na plan, który tę funkcję obejmuje.",
      tariffUpgradeModalDescription: "Wybierz plan, który obejmuje tę funkcję.",
      tariffUpgradeModalLoading: "Wczytywanie odpowiednich planów…",
      tariffUpgradeModalError: "Nie udało się wczytać odpowiednich planów. Spróbuj ponownie.",
      tariffUpgradeModalEmpty: "Subskrypcje roczne będą dostępne już wkrótce.",
      tariffUpgradeModalRecommended: "Polecany",
      tariffUsageUnlimitedLabel: "Bez limitu",
      tariffUsageUsedOfLimitLabel: "Wykorzystano {used} z {limit}",
      tariffUsageUnavailableLabel: "Wykorzystanie niedostępne",
      tariffUsageLoadingLabel: "Wczytywanie wykorzystania…",
      tariffUsageUnknownLabel: "Wykorzystanie nieznane",
      notFoundEyebrow: 'Nie znaleziono strony',
      notFoundTitle: 'Wygląda na to, że ten quiz się zgubił',
      notFoundDescription: 'Link może być nieprawidłowy albo strona została przeniesiona. Wróć do panelu roboczego i kontynuuj tworzenie quizów.',
      notFoundPrimaryAction: 'Do strony głównej',
      notFoundSecondaryAction: 'Wstecz',
      serverErrorEyebrow: 'Błąd serwera',
      serverErrorTitle: 'Coś poszło nie tak',
      serverErrorDescription: 'Nie martw się, już nad tym pracujemy. Odśwież stronę albo wróć do swojego workboardu.',
      serverErrorPrimaryAction: 'Odśwież stronę',
      serverErrorSecondaryAction: 'Strona główna',
      acceptedFileSize:"Maksymalny rozmiar:",
      acceptedFileSizeMeasure:"MB",
      acceptedFileType:"Akceptowane formaty:",
      quizLoaderLoadingQuiz: "Ładujemy quiz...",
      quizLoaderPreparingQuestions: "Przygotowujemy pytania osobiste...",
      quizLoaderSettingInterface: "Konfigurujemy interfejs...",
      quizLoaderAlmostReady: "Prawie gotowe...",
      additionalCheckbox:"Dodatkowy Checkbox",
      addNewSectionCard:"Karty ze zdjęciami",
      addNewSectionCustom:"Pole wprowadzania",
      addNewSectionMultiInput: "Wielokrotny input",
      addNewSectionUploadFile: "Przesyłanie pliku",
      addNewSectionHeader:"Dodaj nową sekcję",
      addNewSectionList:"Lista",
      addNewSectionSlider:"Suwak",
      addNewSectionTags:"Tagi",
      addNewSectionWithEmoji:"Lista z emoji",
      adminAvarageUsed:"Średnia ilość miesięcy użytkowania",
      adminEditorForPartnership:"Redaktor programu partnerskiego",
      adminLeadsForOne:"Na jednego użytkownika",
      adminLTV:"LTV",
      adminMadeQuiz:"Stworzono quizów",
      adminNewUsers:"Nowi użytkownicy za miesiąc",
      adminProAccounts:"Konta PRO",
      adminProfitAlltime:"Stworzono za cały czas",
      adminProfitMonth:"Stworzono za miesiąc",
      adminQuizForOne:"Na jednego użytkownika",
      adminReciveLeads:"Otrzymano aplikacji",
      adminSharePro:"PRO w stosunku do wszystkich",
      adminUsersList:"Baza użytkowników",
      adminUsersReg:"Użytkownicy w systemie",
      allAnd:"і",
      allOr:"lub",
      allstepsBack:"Wstecz",
      allstepsButtonText:"Tekst przycisku",
      allstepsChangePhoto:"Zmień zdjęcie",
      allstepsCustomInput:"Własna wersja",
      allstepsCustomInputOn:"Włącz",
      allstepsCustomPlaceholder:"Własna wersja",
      allstepsDeletePhoto:"Usuń zdjęcie",
      allstepsDescription:"Opis.",
      allstepsIsSaveBeforeRoute:"Zapisać dane przed przełączeniem?",
      allstepsOtherSettings:"Więcej ustawień",
      allstepsPhotoAdaptation:"Dostosowywanie zdjęć do urządzeń",
      allstepsPhotoFit:"Proporcje",
      allstepsPhotoMustBeLess:"Zdjęcie powinno być mniejsze",
      allstepsPhotoTooBig:"Plik jest za duży!",
      allstepsPlaceholder:"Placeholder",
      allstepsResetInHeader:"Reset",
      allstepsTitle:"Tytuł",
      allstepsUpploadPhoto:"Pobierz zdjęcie",
      unsplashSelectorButtonText:"Wybierz z Unsplash",
      unsplashSelectorTitle:"Prześlij obraz",
      unsplashSelectorDragImage:"Przeciągnij obraz tutaj lub",
      unsplashSelectorUploadFile:"prześlij plik",
      unsplashSelectorSearchPlaceholder:"Szukaj obrazu w Unsplash",
      unsplashSelectorLoadingImages:"Ładowanie obrazów...",
      unsplashSelectorLoadingMoreImages:"Ładowanie kolejnych obrazów...",
      unsplashSelectorNoImagesFound:"Nie znaleziono obrazów",
      unsplashSelectorUnavailable: "Unsplash jest obecnie niedostępny. Możesz przesłać plik.",
      unsplashSelectorClose:"Zamknij",
      almondCrayola:"Rafa koralowa",
      alreadyHaveAccount:"Masz już konto?",
      autoInternationalPrefix:"Wykryj kraj automatycznie",
      azureBlue:"Zimowa noc",
      azureBlueWhite:"Standard",
      billingAcordeonPayHistory:"Historia transakcji",
      billingAcordeonPaymentInfoCancelSubscription:"Anuluj subskrypcję",
      billingAcordeonPaymentInfoFormat:"Format",
      billingAcordeonPaymentInfoPay:"Płatność",
      billingAcordeonPaymentInfoPayMethod:"Metoda płatności",
      billingAcordeonPaymentInfoSubscription:"Subskrypcja",
      billingAcordeonPaymentInfoTitle:"Informacje o płatności",
      billingAcordeonPromocode:"Kod promocyjny",
      billingAcordeonPromocodeLabel:"Wprowadź kod promocyjny",
      billingBillings:"Płatności",
      billingBonusesActivated:"Kod promocyjny został aktywowany!",
      billingBonusesAlreadyActivated:"Ten kupon jest nieważny",
      billingBonusesBtn:"Aktywuj",
      billingBonusesDescription:"Wprowadź otrzymany kod promocyjny w polu obok.",
      billingBonusesInvalid:"Nieprawidłowy kod promocyjny",
      billingBonusesLeadIncreased:"Ilość dostępnych leadów została zwiększona.",
      billingBonusesNotAvailable:"Ten kod promocyjny został już wykorzystany",
      billingBonusesPlaceholder:"Kod promocyjny",
      billingBonusesTitle:"Kod promocyjny",
      billingBtnChangeToPro:"Przejdź do",
      billingBtnRenewPro:"Aktualizacja",
      billingChangeData:"Zmień dane",
      billingChangePlan:"Zmień plan",
      billingChangePlanDescription:"Cena zostanie dostosowana do żądanej ilości leadów ze wszystkich quizów na koncie.",
      billingChangePlanDescriptionImportant:"Ważne:",
      billingChangePlanDescriptionImportantMonth:"Leady mogą być używane przez 1 miesiąc po zakupie",
      billingChangePlanDescriptionImportantMonthAfterBuy:"po zakupie.",
      billingChangePlanPay:"Kaufen",
      billingChangePlanWarning:"Zakupione leady będą",
      billingDeletePayMethod:"Usuń",
      billingFreeLeads:"Brak bezpłatnych leadów",
      billingGeneralAllTarifExpired:"Taryfy wygasły",
      billingGeneralBonus: "Leady bonusowe",
      billingGeneralCost:"Koszt",
      billingGeneralExpired:"Ważne do",
      billingGeneralLeadsFromOtherTarifs: "Leady z innych taryf",
      billingGeneralNoActiveTariff: "Brak aktywnej taryfy",
      billingLeadsAvailableLabel: "Dostępne leady",
      billingLeadsTariffSourceLabel: "Taryfa",
      billingLeadsRemainingOfLabel: "{remaining} / {total} pozostało",
      planUsageTeamMembersLabel: "Członkowie zespołu",
      planUsageManagePlanLabel: "Zarządzaj planem",
      billingGeneralLeadsLeft:"Zostało się  leadów",
      billingGeneralName:"Twoja taryfa",
      billingInfinity:"nieograniczony",
      billingLeads:"leady",
      billingModalDeleteCancel:"Anuluj",
      billingModalDeleteOk:"Usuń",
      billingModalDeleteShure:"Czy naprawdę chcesz usunąć tę metodę płatności?",
      billingModalDeleteSuccess:"Karta została pomyślnie usunięta",
      billingModalRegularPaymentDeleteOk:"OK",
      billingModalRegularPaymentDeleteSuccess:"Regularne płatności zostały anulowane",
      billingMonth:"miesiąc",
      billingOtherTariffFree:"Free.",
      billingOtherTariffPro:"Pro.",
      billingPaymentCard:"Karta",
      billingPaymentInfoChangeTarrif:"Zmiana taryfy",
      billingPaymentInfoDescription:"Płacąc za dowolną płatną taryfę, otrzymujesz określoną liczbę leadów zawartych w wybranym pakiecie. Leady  te są dostępne przez miesiąc. Jeśli nie wykorzystasz swojej liczby leadów w ciągu miesiąca od dokonania płatności, takie dane zostaną anulowane.",
      billingPaymentInfoTitle:"Informacje o taryfie",
      billingPaymentsMethod:"Metoda płatności",
      billingSelectPeriod:"Wybierz okres",
      billingTariffEndData:"Data wygaśnięcia taryfy",
      billingTariffFreeDescription:"Nieograniczona liczba nowych quizów (stron internetowych). Możliwość wygenerowania do 300 leadów",
      billingTariffMonth:"miesiąc",
      billingTariffProDescription:"Nieograniczone tworzenie nowych quizów (stron internetowych). Możliwość wygenerowania",
      billingTariffProDescriptionBold:"ponad 300 leadów",
      billingTariffRenewData:"Data aktualizacji taryfy",
      billingYorFree:"Bezpłatne",
      billingYouHasFreeLeads:"Zostało bezpłatnych leadów",
      billingYouHasLeads:"Zostało leadów",
      billingYouHaveNotBillings:"Nie masz jeszcze żadnych płatności",
      billingYouHavePro:"Obecnie korzystasz z wersji Pro. Dlaczego robisz krok w tył?",
      billingYourFutureTariff:"Twój przyszły plan",
      billingYourMonthPlan:"Twój plan miesięczny",
      billingYourPro:"Pro",
      billingYourTariff:"Twój obecny plan",
      billingYourTariffShortForm: "Twój plan",
      blackPearlescentOpal:"Popiół",
      blueLilac:"Ciemna lawenda",
      cancel:"Anuluj",
      cancelAllAction:"Anuluj",
      cardPanUnspecified:"Nie określono",
      cdesignColorTheme:"Schemat kolorów",
      cdesignCustomTheme:"Stwórz własny schemat kolorów",
      cdesignDefaultThemes:"Gotowe schematy kolorów",
      cdesignShapeDesign:"Kształt designu",
      cdesignShapeRound:"Zaokrąglony",
      cdesignShapeSquare:"Kątowy",
      cdesignShapeRectangle: "Prostokąt",
      cdesignShapeCircle: "Koło",
      cdesignPositionLeft: "Po lewej",
      cdesignPositionMiddle: "Środek",
      cdesignPositionRight: "Po prawej",
      cdesignPositionTop: "Na górze",
      cdesignPositionBottom: "Na dole",
      cdesignThemeDark:"Ciemny",
      cdesignThemeGradient:"Gradient",
      cdesignThemeNud:"Nude",
      cdesignThemeStandart:"Standardowy",
      cfinishAddImage:"Dodaj obrazek",
      cfinishButtonText:"Tekst przycisku",
      cfinishCheckDataIsCorrect:"Sprawdź poprawność wprowadzonego identyfikatora",
      cfinishDescription:"Opis.",
      cfinishFbWhichCorrect:"Wprowadź identyfikator (pseudonim) bez adresu. Na przykład: some.name",
      cfinishFinishPageDataUpdated:"Dane strony finałowej zostały zaktualizowane",
      cfinishFinishPageHiddenUpdated:"Strona finałowa jest ukryta.",
      cfinishFinishPageHiddenUpdatedGoContact:"Przejdź do strony Formularze kontaktowe",
      cfinishFinishPageHiddenUpdatedSetRedirect:"i skonfiguruj przekierowanie po przesłaniu danych",
      cfinishFinishPageTitle:"Strona finałowa ",
      cfinishIgWhichCorrect:"Wprowadź identyfikator (pseudonim) bez adresu. Na przykład: some.name",
      cfinishImageAdded:"Obrazek dodany",
      cfinishInsertNikname:"Wstaw tutaj swój pseudonim",
      cfinishText:"Tekst.",
      cfinishTgWhichCorrect:"Wprowadź identyfikator (pseudonim) bez adresu. Na przykład: some.name",
      cfinishURL:"URL",
      cfirstAddBonus:"Dodaj bonus",
      cfirstAddMediafile:"Dodaj plik multimedialny (zdjęcie)",
      cfirstBonus:"Bonus",
      cfirstBonusAvailable:"Dostępny",
      cfirstBonusDisabled:"Niedostępny",
      cfirstFormat:"Format",
      cfirstHeaderStartText:"Twój nagłówek powinien znaleźć się tutaj. Zmotywuj użytkowników do ukończenia quizu ",
      cfirstStartPageBonusPhotoUpdated:"Zaktualizowano zdjęcie bonusowe",
      cfirstStartPageDataUpdated:"Zaktualizowano dane strony startowej",
      cfirstStartPagePhotoUpdated:"Zaktualizowano zdjęcie strony głównej",
      cformActionAfterContactRecive:"Działania po otrzymaniu kontaktów",
      cformActionAfterContactRedirect:"Przekierowanie",
      cformActionAfterContactThankyou:"Strona z podziękowaniem",
      cformAdditionalSettings:"Dodatkowe ustawienia",
      cformDataContactsPageUpdated:"Zaktualizowano dane strony kontaktowej",
      cformForm:"Formularz",
      cformInputAvailable:"Dostępny",
      cformInputDisabled:"Wyłączony",
      Disabled: "Wyłączony",
      cformRedirectURL:"URL",
      cformRequiredInput:"Wymagane",
      cformValueEmail:"E-mail",
      cformValueName:"Nazwa",
      cformValuePhone:"Numer telefonu",
      cformValueSurname:"Nazwisko",
      cintegrationAccesToken:"ACCES TOKEN",
      cintegrationAddEmail:"Dodaj e-mail",
      cintegrationAddIntegration:"Dodaj integrację",
      cintegrationAddWH:"Dodaj Web-hook",
      cintegrationApixDriveWHInstruction1Description1:"Link",
      cintegrationApixDriveWHInstruction1Description2:"dla rejestracji z bonusem.",
      cintegrationApixDriveWHInstruction1Title:"1. Zarejestruj się lub otwórz konto ApixDrive:",
      cintegrationApixDriveWHInstruction2Description1:"Przejdź do ustawień wymaganego połączenia i skopiuj adres, aby wysłać webhook:",
      cintegrationApixDriveWHInstruction2Description2:"Możesz utworzyć nowe połączenie, klikając przycisk „Utwórz połączenie” i wybierz „ADSQuiz” w kroku wyboru systemu.",
      cintegrationApixDriveWHInstruction2Title:"2. Uzyskaj adres URL elementu webhook:",
      cintegrationApixDriveWHInstruction3Description:"Wklej adres URL elementu webhook dostarczonego przez ApixDrive do pola wprowadzania.",
      cintegrationApixDriveWHInstruction3Title:"3. Wklej adres URL elementu webhook:",
      cintegrationApixDriveWHInstruction4Description:'Kliknij przycisk "Zapisz zmiany", aby zapisać ustawienia elementu webhook.',
      cintegrationApixDriveWHInstruction4Title:"4. Zapisz zmiany:",
      cintegrationApixDriveWHInstruction5Description:"Twój webhook jest teraz skonfigurowany do wysyłania danych do ApixDrive.",
      cintegrationApixDriveWHInstruction5Title:"5. Zakończ:",
      cintegrationApixDriveWHInstructionAdditional:"Dane będą wysyłane do webhooka za każdym razem, gdy otrzymasz lead. Metoda wysyłania - POST. Przykład danych, które zostaną wysłane to",
      cintegrationApixDriveWHInstructionAdditionalLink:"tutaj",
      cintegrationApixDriveWHInstructionShort:"Możesz powiadamiać ApixDrive o przychodzących leadach. Aby to zrobić, określ adres URL, na który zostanie wysłany webhook.",
      cintegrationApixDriveWHInstructionShort1:"Podczas rejestracji przez",
      cintegrationApixDriveWHInstructionShort2:"ten link",
      cintegrationApixDriveWHInstructionShort3:"nasi użytkownicy otrzymują bonus - 10 000 darmowych działań dla każdej integracji.",
      cintegrationApixDriveWHInstructionVideo:"Szczegółowa instrukcja wideo",
      cintegrationCheckDomenIsCorrect:"Sprawdź, czy wprowadzona domena jest poprawna",
      cintegrationComonWHInstruction1Description:"Wklej adres URL webhooka dostarczonego przez twoją usługę lub aplikację do pola wprowadzania.",
      cintegrationComonWHInstruction1Title:"1. Wklej adres URL elementu webhook w polu wprowadzania:",
      cintegrationComonWHInstruction2Description:"Kliknij przycisk Zapisz zmiany, aby zapisać ustawienia webhook.",
      cintegrationComonWHInstruction2Title:"2. Zapisz zmiany:",
      cintegrationComonWHInstruction3Description:"Twój webhook jest teraz skonfigurowany do wysyłania danych do wybranej usługi.",
      cintegrationComonWHInstruction3Title:"3. Zakończ:",
      cintegrationComonWHInstructionAdditional:"Dane będą wysyłane do webhooka za każdym razem, gdy otrzymasz lead. Metodą wysyłania jest POST. Przykład danych, które zostaną wysłane, można znaleźć",
      cintegrationComonWHInstructionAdditionalLink:"tutaj",
      cintegrationComonWHInstructionShort:"Możesz powiadamiać inne aplikacje o przychodzących leadach. Wpisz adres URL elementu webhook, do którego mają być wysyłane dane.",
      cintegrationComonWHInstructionVideo:"Szczegółowa instrukcja wideo",
      cintegrationConnectOweDomain:"Podłączenie własnej domeny",
      cintegrationDataFBSaved:"Dane piksela FB zostały  zostały zapisane ",
      cintegrationDataGASaved:"Dane Google Analytics zostały  zapisane ",
      cintegrationDataGTMSaved:"Dane Google Tag Manager zostały  zapisane ",
      cintegrationDataTGSaved:"Dane integracji Telegram zostały  zapisane ",
      cintegrationDataTTSaved:"Dane TT piksel zostały zapisane",
      cintegrationDocsDataSaved:"Linki do Twoich dokumentów zostały zapisane",
      cintegrationDomain:"Domena",
      cintegrationDomainDataSaved:"Dane domeny zostały zapisane",
      cintegrationDomainWhichCorrect:"Wprowadź domenę bez protokołów. np: some.site.com",
      cintegrationEmailDeleted:"Usunięto dane integracji poczty e-mail",
      cintegrationEmailInstruction:"Wprowadź wymagany adres e-mail, na który chcesz wysłać informacje w polu poniżej. Każde lead z tego quizu zostanie zduplikowany na podany adres e-mail.",
      cintegrationEmailSaved:"Dane e-mail integracji zostały zapisane",
      cintegrationFBInstruction:"Zdarzeniem, dla którego należy skonfigurować konwersję jest „Lead”. To zdarzenie zostanie uruchomione, gdy tylko użytkownik pomyślnie wyśli dane do quizu.  ",
      cintegrationFBInstruction1:"Przejdź do swojego konta Facebook Ads i skopiuj identyfikator piksela Facebooka w sekcji Event Manager.",
      cintegrationFBInstruction2:"Nie kopiuj całego kodu, tylko 15-16 cyfrowy identyfikator.",
      cintegrationFBInstruction3:"Skopiuj go i wklej w polu poniżej.",
      cintegrationGAInstruction:"Po otrzymaniu danych w quizie, zdarzenie „generate_lead” zostanie uruchomione w Google Analytics.",
      cintegrationFBInstructionTextTitle: "Lista wszystkich wysyłanych zdarzeń:",
      cintegrationFBInstructionTextTextStart: " – odwiedziny strony startowej;",
      cintegrationFBInstructionTextQuestionN: " – odwiedziny kroku N;",
      cintegrationFBInstructionTextOpenContactPage: " – odwiedziny strony kontaktowej;",
      cintegrationFBInstructionTextLead: " – pomyślne wysłanie formularza kontaktowego;",
      cintegrationFBInstructionTextThankYou: " – odwiedziny strony końcowej.",
      bold_adsquiz_Start: "adsquiz_Start",
      bold_adsquiz_QuestionN: "Question_N",
      bold_adsquiz_OpenContactPage: "Open_Contact-Page",
      bold_adsquiz_Lead: "Lead",
      bold_adsquiz_ThankYou: "adsquiz_ThankYou",
      cintegrationGAInstructionDescription:"Dowiedz się, jak ludzie znajdują i wchodzą w interakcję z Twoim quizem. Uzyskaj dane potrzebne do analizy kampanii, poprawy konwersji i nie tylko.",
      cintegrationGTMInstruction:"Skopiuj identyfikator Google Tag Manager i wklej go w poniższe pole.",
      cintegrationGTMInstructionDescription:"Opis dla Google Tag Manager (nieużywany)",
      cintegrationHowReciveTGLeadBot:"Jak mogę otrzymywać leady (dane) do bota Telegram?",
      cintegrationHowReciveTGLeadChat:"Jak mogę otrzymywać leady (dane) w czat Telegram?",
      cintegrationIDFolow:"ID śledzenia",
      cintegrationIDPixel:"Pixel ID",
      cintegrationInputEmail:"Wprowadź swój adres e-mail",
      cintegrationInputID:"Wprowadź ID pixela",
      cintegrationInputIDPixel:"Wprowadź ID piksela",
      cintegrationInputTGToken:"Wprowadź token telegramu dla chatbota",
      cintegrationInputWHUrl:"Wprowadź adres webhook",
      cintegrationInputYourDomain:"Wprowadź swoją domenę",
      cintegrationInsertedDefaultDomain:"Domena jest ustawiona domyślnie",
      cintegrationInstruction:"Instrukcje",
      cintegrationInstructionDetail:"Szczegóły",
      cintegrationIntegration:"Integracje",
      cintegrationOweDomainInstruction1:"1. Aby umieścić quiz w wymaganej domenie, zaloguj się na swoje konto hostingowe. Przejdź do ustawień DNS i utwórz A-rekord z parametrem IP: 185.25.117.21",
      cintegrationOweDomainInstruction2:"2. W powyższym polu określ domenę i zapisz quiz.",
      cintegrationOweDomainInstructionImportant:"Ważne: Adres na koncie hostingowym i w polu poniżej musi się zgadzać. Czas na zastosowanie zmian w ustawieniach DNS i wydanie certyfikatu SSL wynosi do 3 godzin od zapisania.",
      cintegrationOweDomainInstructionVideo:"Obejrzyj instrukcję wideo",
      cintegrationPrivacyPolicy:"Polityka prywatności.",
      cintegrationPrivacyPolicyAdventage:"Wyjaśni to potencjalnym klientom, w jaki sposób wykorzystujesz otrzymane dane kontaktowe. Jest to również wymagane przez niektóre platformy reklamowe.",
      cintegrationPrivacyPolicyByDefault:"Domyślnie używamy naszej standardowej polityki prywatności. Zalecamy dodanie własnej polityki prywatności, która jest odpowiednia dla Twojej firmy.",
      cintegrationPrivacyPolicyInputYourDocsLink:"Wstaw link do Twoich dokumentów",
      cintegrationPrivacyPolicyUrl:"Link do Twoich dokumentów",
      cintegrationPublishAfterEdit:"Zapisz quiz po edycji",
      cintegrationSendNewLeadsTo:"Wysyłaj powiadomienia o nowych leadach do:",
      cintegrationShareLeads:"Przeniesienie leadów",
      cintegrationTGBotLink:"link do chatbota",
      cintegrationTGInstructionBot1:"1. Skopiuj token w polu poniżej.",
      cintegrationTGInstructionBot2:"2. Podążaj za linkiem do bota, kliknij przycisk „START”.",
      cintegrationTGInstructionBot3:"3. Wyślij skopiowany token do naszego bota za pośrednictwem wiadomości.",
      cintegrationTGInstructionChat1:"1. Dodaj naszego bota do wybranego czatu i ustaw bota na status administratora.",
      cintegrationTGInstructionChat2:"2. Skopiuj token w polu poniżej i wyślij go do wybranego czatu.",
      cintegrationTGInstructionChat3:"3. Poczekaj na odpowiedź OK! Your quiz token was saved!`",
      cintegrationTGInstructionChat4:"4. Teraz dane będą wysyłane do tego czatu.",
      cintegrationTGInstructionWarning:"Ważne:",
      cintegrationTGInstructionWarningText:"Należy pamiętać, że powinna to być grupa, a nie kanał Telegram. Dane nie będą wysywać się do kanalu Telegram.",
      cintegrationTGTitleToken:"TOKEN",
      cintegrationTitleEmail:"E-MAIL",
      cintegrationTitleFB:"Piksel FB",
      cintegrationTitleGA:"Google Analytics",
      cintegrationTitleGTM:"Google Tag Manager",
      cintegrationTitleTG:"Telegram",
      cintegrationTitleTT:"Piksel TT",
      cintegrationTitleWH:"WebHook",
      cintegrationTTInstruction:"Aby śledzić zdarzenia na koncie Tik-Tok Ads, skopiuj identyfikator piksela i wklej go w poniższe pole.",
      cintegrationWHDataSaved:"WebHook dane zostały zapisane",
      cintegrationWHInstruction1:"Możesz powiadamiać inne aplikacje o przychodzących danych. Aby to zrobić, wpropwadź adres URL, na który zostanie wysłany WebHook.",
      cintegrationWHInstruction10:"dla rejestracji z bonusem.",
      cintegrationWHInstruction2:"Przygotowaliśmy",
      cintegrationWHInstruction3:"wideo instrukcja ",
      cintegrationWHInstruction4:"ze szczegółowym opisem tej funkcjonalności.",
      cintegrationWHInstruction5:"Obejrzyj wideo.",
      cintegrationWHInstruction6:"W tym filmie omówimy wysyłanie huka w oparciu o wysyłanie danych do arkusza Google i wysyłanie danych do systemu Trello CRM.",
      cintegrationWHInstruction7:"Zalecamy korzystanie dla tego serwisui",
      cintegrationWHInstruction8:"Rejestrując się za pomocą tego linku, nasi użytkownicy otrzymują bonus - 10 000 darmowych leadów dla dowolnej integracji.",
      cintegrationWHInstruction9:"Link",
      cintegrationWHUrl:"Adres webhooka",
      completeUserDataUpdate:"Dane użytkownika zostały zaktualizowane",
      confirmAllAction:"Potwierdź",
      fieldDataTypeLabel: "Typ danych w polu",
      conjunctionAnd:"i",
      constructorBack:"Wstecz",
      constructorCancel:"Anuluj",
      constructorDesignSaved:"Design quizu został pomyślnie zapisany",
      constructorextraNavContact:"C",
      constructorextraNavFinish:"F",
      constructorextraNavStart:"S",
      constructorGetLink:"Link",
      constructorLink:"link",
      constructorLinkCopied:"Skopiowany do schowka:",
      constructorNavDesign:"Design",
      constructorNavSettings:"Ustawienia",
      constructorNavSteps:"Kroki",
      constructorSave:"Zapisz",
      constructorSaveChanges:"Zapisz",
      constructorCreateIntegrations:"Utwórz integrację",
      constructorStep:"krok",
      constructorStepsSaved:"Wszystkie dane quizu zostały pomyślnie zapisane",
      constructorYouHideStep:"Ten krok został ukryty",
      contactAgreeAgreementAdditionalWord:"",
      contactFillRequiredInput: "Wypełnij wymagane pola",
      contactAgreeAnd:"i",
      contactAgreeIAgreeWith:"Zgadzam się z",
      contactAgreePolicy:"polityką prywatności",
      contactAgreeTermsOfUse:"warunki użytkowania",
      contactPrivacyPolicyCheckbox:"Pole wyboru umowy o ochronie prywatności",
      createNewGroup:"Utwórz nową grupę",
      createQuizCPButton:"Gotowe!",
      createQuizCPDescription:"Wypełnij poniższy formularz",
      createQuizCPTitle:"Jak możemy się z Tobą skontaktować?",
      createQuizFPButton:"Pokaż mi coś!",
      createQuizFPDescription:"Teraz znajdziemy najlepsze rozwiązanie dla Ciebie!",
      createQuizFPTitle:"Dziękujemy!",
      createQuizSPDescription:"To jest miejsce na krótki opis",
      csanyAddAnswer:"Dodać",
      csanyTitleForModalConfirm: "Ta akcja jest nieodwracalna!",
      csanyQuestionForModalConfirm: "Czy na pewno chcesz usunąć to pytanie?",
      csanyAlowMultiple:"Zezwalaj na wiele odpowiedzi",
      csanyAnswerOrderSaved:"Kolejność odpowiedzi jest zapisywana",
      csanyAnswers:"Odpowiedzi",
      csanyAnswerType:"Typ pytania",
      csanyATCard:"karta",
      csanyATCustom:"wolne pole",
      csanyATList:"lista",
      csanyAutoRedirect:"Automatycznie przejdź dalej",
      csanyDataStepUpdated:"Dane strony z pytaniami zostały zaktualizowane",
      csanyQuestion:"Pytania",
      csanyQuestionLogic:"Konfigurowanie logiki pytań",
      csanyRequiredStep:"Wymagany krok",
      cSettingDataSaved:"Ustawienia dodatkowe zostały zapisane",
      csettingsAdmin:"Ustawienia dla administratorów",
      cSettingsCustomThemeAdditionalColor:"Kolor tekstu",
      cSettingsCustomThemeButtonTextColor:"Tekst w przyciskach",
      cSettingsCustomThemeModeDark:"Ciemny",
      cSettingsCustomThemeModeLight:"Jasny",
      cSettingsCustomThemePrimaryColor:"Kolor akcentu",
      cSettingsCustomThemeSecondaryColor:"Kolor tła",
      csettingsDocs:"Dokumenty prawne",
      csettingsIntegration:"Integracje",
      csettingsIntegrationAbout:"Szczegóły",
      csettingsIntegrationADAbout:"Coś o APIxDrive",
      csettingsIntegrationApixDrive:"Integracja - APIxDrive",
      csettingsIntegrationEmail:"Integracja - E-mail",
      csettingsIntegrationEmailAbout:"Aktywuj wiadomość e-mail dla respondenta i poinformuj o tym swój zespół. Współpracuj ze swoim zespołem.",
      csettingsIntegrationFB:"Integracja - Piksel Facebooka",
      csettingsIntegrationFBAbout:"Przejdź do swojego konta Facebook Ads i skopiuj identyfikator Facebook Pixel w sekcji Event Manager. Skopiuj tylko identyfikator, a nie cały kod, i wklej go w polu poniżej.",
      csettingsIntegrationGA:"Integracja - Google Analytics",
      csettingsIntegrationGAAbout:"Skopiuj identyfikator Google Analytics i wklej go w polu poniżej.",
      csettingsIntegrationGTM:"Integracja - Google Tag Manager",
      csettingsIntegrationGTMAbout:"Skopiuj identyfikator  Google Tag Manager i wklej go w polu poniżej.",
      cSettingsIntegrationNeedHelp:"Potrzebujesz pomocy?",
      cSettingsIntegrationRefreshToken:"Zaktualizuj swój token",
      csettingsIntegrationTG:"Integracja - Telegram",
      csettingsIntegrationTGAbout:"Ważne: Należy pamiętać, że powinna to być grupa, a nie kanał w Telegramie. Leady nie będą wysyłane na kanał Telegram.",
      csettingsIntegrationTT:"Integracja - TikTok",
      csettingsIntegrationTTAbout:"Przejdź do menedżera reklam TikTok Ads i skopiuj identyfikator piksela TikTok w sekcji „Event”. Skopiuj tylko identyfikator i wklej go w poniższe pole.",
      csettingsIntegrationWH:"Integracja - WebHook",
      csettingsIntegrationWHAbout1:"Możesz powiadamiać inne aplikacje o przychodzących leadach. Aby to zrobić, wprowadź adres URL, na który zostanie wysłany webhook. Zalecamy korzystanie z tej usługi.",
      csettingsIntegrationWHAbout2:"Rejestrując się za pomocą tego linku, nasi użytkownicy otrzymują bonus - 10 000 darmowych akcji dla każdej integracji.",
      csettingsIntegrationWHAboutApix:"Apix-Drive",
      csettingsOweDomain:"Podłącz własną domenę",
      csettingsSettingASettings:"Dodatkowe ustawienia",
      cSettingsSettingQuizBackButtonDescription:"Możesz włączyć lub wyłączyć przycisk powrotu do poprzedniego kroku. Umożliwi to zmianę udzielonej wcześniej odpowiedzi.",
      cSettingsSettingQuizBackButtonTitle:"Przycisk Wstecz",
      cSettingsSettingQuizHideLabelDescription:"Włączając tę opcję, będziesz mógł cieszyć się interfejsem „made by adsquiz”, pozwalając Tobie i Twoim odwiedzającym skupić się wyłącznie na pytaniach.",
      cSettingsSettingQuizHideLabelTitle:"Ukryj tag",
      cSettingsSettingQuizLangDescription:"Aby zapewnić jak najlepsze wrażenia, wybierz preferowany język quizu z poniższych opcji. Język ten będzie używany do wyświetlania powiadomień systemowych i niektórych innych niezmienionych tekstów podczas quizu.",
      cSettingsSettingQuizLangTitle:"Język quizu",
      cstepsAddSection:"Dodaj sekcję",
      cstepsContactPage:"Formularz kontaktowy",
      cstepsDeleteStep:"Usuń krok",
      cstepsEdit:"Edytuj",
      cstepsFinishPage:"Strona finałowa",
      cstepsHiddenStep:"Ukryj krok",
      cstepNo_animation: "Bez animacji",
      cstepAnimation: "Animacja",
      cstepKick_animation: "Uderzenie",
      cstepFlip_animation: "Obrót",
      cstepBlur_animation: "Rozmycie",
      cstepsMove:"Przesuń",
      cstepsQuestionsOrderSaved:"Kolejność pytań została zapisana",
      cstepsSection:"Sekcje",
      cstepsShowStep:"Pokaż krok",
      cstepsStartPage:"Strona początkowa",
      defaultBtnText:"Rozpocznij",
      defaultNewQuestion:"Nowe pytanie",
      defaultNewQuestionDescription:"Tutaj można wstawić krótki opis pytania (do 80 znaków).",
      defaultNewVariant:"Nowa opcja",
      developmentPage:"Sekcja jest w trakcie opracowywania",
      discount:"Zniżka do",
      dontHaveAccount:"Nie masz konta?",
      haveQuestions: "Masz pytania?",
      dovnloadCsvCancel:"Anuluj",
      dovnloadCsvExport:"Eksportuj do",
      domainEmpty: "Wprowadź domenę",
      domainInvalid: "Wprowadź prawidłową domenę, na przykład: example.com",
      domainAlreadyExists: "Ta domena jest już na liście",
      domainAdded: "Domena została pomyślnie dodana",
      domainAdd: "Dodaj domenę",
      domainAddFailed: "Nie udało się dodać domeny",
      domainRemoved: "Domena została pomyślnie usunięta",
      domainRemoveFailed: "Nie udało się usunąć domeny",
      dovnloadCsvSelectAllPeriod:"Wybierz dla całego okresu",
      dovnloadCsvTitle:"Eksportuj dane dla wybranego okresu",
      dustyBlue:"Tiffany",
      enterYourEmail:"Wprowadź swój adres e-mail",
      enterYourName:"Wprowadź swoje imię i nazwisko",
      enterYourPassword:"Wprowadź hasło",
      enterYourPhone:"Wprowadź swój numer telefonu",
      errorUserDataUpdate:"Błąd podczas aktualizacji danych: ",
      exportInfo:"Eksportowanie leadów",
      falseDoesNotContainForbiddenSubstrings:"Domena nie może zawierać niedozwolonych podciągów.",
      falseDoesNotHaveConsecutiveSameChar:"Domena nie może zawierać trzech lub więcej następujących po sobie identycznych znaków.",
      falseDoesNotHaveConsecutiveSpecialChar:"Domena nie może zawierać dwóch lub więcej następujących po sobie znaków specjalnych.",
      falseDoesNotStartOrEndWithSpecialChar:"Domena nie może zaczynać się ani kończyć znakiem specjalnym.",
      falseHasValidCharacters:"Nieprawidłowe znaki w domenie. Prawidłowe znaki to litery alfabetu łacińskiego, cyfry i myślniki.",
      falseHasValidLength:"Długość domeny musi wynosić od 6 do 20 znaków alfanumerycznych.",
      footerContactUs:"Masz jakieś pytania? Skontaktuj się z nami:",
      generateDomainDescription:"Jest to unikalny adres, pod którym Twoja strona będzie dostępna. Możesz zmienić adres lub dodać własny w dowolnym momencie.",
      generateDomainDomainNameLabel:"Nazwa domeny",
      generateDomainTaken:"Ta domena jest już zajęta. Wypróbuj inną",
      generateDomainTitle:"Wprowadź nazwę domeny",
      generateCodeForEmbedQuiz: "Wygeneruj kod",
      getBackAccount:"Powrót do konta",
      getLeads:"Kup leady",
      helloHeader:"Cześć",
      inMinutes:"za minutę",
      jazzJam:"Jazz",
      langDE:"Niemiecki",
      langEN:"angielski",
      langIT:"włoski",
      langKK:"Kazachski",
      langPL:"polski",
      langRU:"rosyjski",
      langSP:"hiszpański",
      langUA:"ukraiński",
      langSV:"szwedzki",
      lavender:"Kosmos",
      leadHide:"Ukryć",
      leadShowMore:"Więcej",
      leadsLeft:"Pozostały leady",
      leadsTable:"Lista leadów",
      loginBtnValue:"Zaloguj się",
      loginEmailPlaceholder:"E-mail",
      loginHeader:"Zaloguj się",
      loginHeader2Part:"aby kontynuować",
      loginPasswordlPlaceholder:"○ ○ ○ ○ ○ ○ ○ ○ ○",
      loginSignup:"Zarejestruj konto",
      loginWith:"Zaloguj się za pomocą",
      madeInUkr:"wyprodukowano na Ukrainie",
      modalSureUnsavedChangesDescription:"Przed opuszczeniem bieżącej strony zdecyduj, co zrobić z niezapisanymi zmianami",
      modalSureUnsavedChangesDontSave:"Nie zapisuj",
      modalSureUnsavedChangesSave:"Zapisz",
      modalSuggestIdeaNotificationSuccess: "Sukces! Dziękujemy za Twój pomysł",
      modalSuggestIdeaNotificationUnsuccess: "Ups! Coś poszło nie tak. Proszę spróbuj ponownie później.",
      embedQuizTitleGetLinkModal: "Umieść quiz na stronie jako:",
      QRCodeTitleGetLinkModal: "Użyj kodu QR:",
      modalSureUnsavedChangesTitle:"Masz niezapisane zmiany",
      moderatePurplishRed:"Czerwony aksamit",
      multiInputPlaceholderLink: "https:",
      multiInputPlaceholderName: "Imię lub pełne imię",
      multiInputAddInput: "Dodaj pole",
      multiInputPlaceholderAddress: "Adres",
      multiInputPlaceholderNumbers: "Wypełnienie (tylko cyfry)",
      month:"0 miesięcy |{n} miesiąc |{n} miesiąc |{n} miesiąc",
      navBillings:"Płatności",
      navPartnership:"Program partnerski",
      navProfile:"Profil",
      navTariffs: "Taryfy",
      holidayBannerTitleLastOffer: "Finałowa oferta roku:",
      holidayBannerDefaultTitle: "Oferta limitowana",
      holidayBannerFrom: "od",
      holidayBannerTo: "do",
      holidayBannerCta: "Odbierz zniżkę",
      holidayBannerAuthTitle: "Zaloguj się, aby odebrać zniżkę",
      holidayBannerAuthText: "Zaloguj się, aby skorzystać z tej oferty i powiązać ją ze swoim kontem.",
      holidayBannerAuthAction: "Rozumiem",
      holidayBannerClose: "Zamknij baner",
      nonBillingsYet:"Nie masz jeszcze historii płatności.",
      notificationAgreePrivacyPolicy:"Prosimy o zaakceptowanie polityki prywatności",
      notificationCheckInputEmail:"Sprawdź poprawność adresu e-mail",
      notificationCheckInputEmailOrUserNotFound: "Sprawdź poprawność adresu e-mail. Nie znaleziono użytkownika",
      notificationCheckInputPhone:"Sprawdź, czy Twój numer telefonu jest poprawny",
      notificationErrorLogin:"Wystąpił błąd autoryzacji:",
      notificationInputAllInputs:"Wypełnij wszystkie pola, aby się zarejestrować",
      notificationInputLoginData:"Wprowadź dane logowania",
      notificationLogin:"Zaloguj się...",
      notificationNetworkError:"Sprawdź połączenie internetowe",
      notificationSuccess:"sukces!",
      notificationOnlyEmailMask: "Dozwolony jest tylko prawidłowy adres e-mail.",
      notificationOnlyNumbersMask: "Dozwolone są tylko cyfry i spacje.",
      notificationOnlyLinkMask: "Dozwolone są tylko bezpieczne linki (https, http lub mailto).",
      notificationOnlyLettersMask: "Dozwolone są tylko litery, spacje, łączniki, apostrofy i podkreślenia.",
      notificationSuccessDeleteAccount:"Twoje konto zostało pomyślnie usunięte! Użyj nowego hasła, aby się zalogować",
      notificationSuccessDeletePhoto: "Zdjęcie zostało pomyślnie usunięte",
      notificationSuccessChangePhoto: "Zdjęcie zostało pomyślnie zmienione",
      notificationErrorChangePhoto: "Wystąpił błąd podczas zmiany zdjęcia",
      notificationErrorRemovePhoto: "Wystąpił błąd podczas usuwania zdjęcia",
      notificationWarnLimitText: "Przekroczono limit znaków. Nie można dodać więcej znaków.",
      notificationSuccessSaveAccount:"Twoje hasło zostało pomyślnie zmienione! Użyj nowego hasła, aby się zalogować",
      notificationWrongLoginData:"Nieprawidłowe dane logowania",
      notificationLoginAccountBlocked: "Twoje konto zosta?o zablokowane",
      notificationCanContactSupport: "Mo?esz skontaktowa? si? z pomoc? techniczn?",
      notificationEmailExistsMessage: "Konto z tym adresem e-mail jest już zarejestrowane",
      ok:"Dobrze",
      opalGreen:"Karpacki las",
      openPopupQuizText:"Rozpocznij zadanie",
      passwordAreForgetPassword:"Zapomniałeś hasła?",
      passwordChangePassword:"Zmień hasło",
      passwordConfirmPassword:"Potwierdź hasło",
      passwordCreatePassword: "Utwórz hasło",
      passwordDoNotCoincidence:"Hasła nie pasują",
      passwordDoNotCoincidenceAgain:"Spróbuj ponownie",
      passwordGoToWorkboard:"Zaloguj się do swojego konta",
      passwordInputNewPassword:"Wprowadź nowe hasło",
      passwordResetedPasswordCompleted:"Twoje hasło zostało pomyślnie zmienione!",
      passwordResetPassword:"Odzyskiwanie hasła",
      passwordResetPasswordHeader:"Odzyskiwanie hasła",
      passwordWeSentReset:"Link do resetowania hasła został wysłany pocztą e-mail.",
      paymentAllTarifInactive:"taryfa jest nieaktywna",
      paymentPlanRenew:"Data odnowienia taryfy:",
      paymentPlanLeadsLeft:"Pozostało leadów:",
      paymentPlanLeadsLimit:"Limit leadów na miesiąc:",
      paymentPlanLeadsLimitForTest:"Twój limit leadów testowych:",
      paymentPlanPrice:"Cena:",
      paymentSwitchToProDescription:"Znajdź plan odpowiedni dla siebie! Uaktualnij lub obniż plan w dowolnym momencie - ułatwiamy wybór odpowiedniego planu dla Ciebie.",
      RateSymbolForDropdown: "Symbol stawki",
      NumberOfSymbolsForDropdown: "Liczba znaków",
      optionIconLabelForDropdown_thumbnail: "Kciuk w górę",
      optionIconLabelForDropdown_stars: "Gwiazdy",
      optionIconLabelForDropdown_flags: "Flagi",
      optionIconLabelForDropdown_smiley_faces: "Buźki",
      labelTextYesNoPack1: "Tak/Nie Pakiet - 1",
      labelTextYesNoPack2: "Tak/Nie Pakiet - 2",
      labelTextYesNoPack3: "Tak/Nie Pakiet - 3",
      labelTextYesNoEmojiPack: "Tak/Nie Emoji Pakiet",
      labelTextEmojiPackage1: "Pakiet Emoji - 1",
      labelTextEmojiPackage2: "Pakiet Emoji - 2",
      labelTextEmojiPackage3: "Pakiet Emoji - 3",
      labelTextNumberPack1: "Pakiet Liczb - 1",
      labelTextNumberPack2: "Pakiet Liczb - 2",
      labelTextClassicNumbers1: "Klasyczne Liczby - 1",
      labelTextClassicNumbers2: "Klasyczne Liczby - 2",
      labelTextRatingMarkers: "Markery Oceny",
      textPackagePlaceholder: "Pakiet ...",
      labelEmojiNumberSets: "Zestawy emoji i liczb",
      labelSelectCountForSymbols: "Wybierz zakres od 1 do",
      labelButtonColorButtonText: "Kolor przycisku i tekst przycisku",
      color: "Kolor",
      paymentSwitchToProHeader:"Aktualizacja do Pro",
      paymentYourCurrentPlan:"Twój obecny plan:",
      paymentYourFuturePlan:"Twój nowy plan:",
      billingCurrentPlanLeadLimit: "Miesięczny limit leadów",
      billingCurrentPlanLeadsRemaining: "Pozostało leadów",
      billingSpecialOffersHeading: "Oferty specjalne",
      billingAllPlansHeading: "Wszystkie plany",
      billingBillingPeriodToggleAria: "Okres rozliczeniowy",
      billingPeriodMonthly: "Miesięcznie",
      billingPeriodYearly: "Rocznie",
      billingPaymentUnavailableNotification: "Płatność za ten plan jest obecnie niedostępna. Spróbuj ponownie później lub skontaktuj się z nami.",
      billingRequisitesButton: "Dane do przelewu",
      billingPayAsBusiness: "Zapłać jako firma",
      billingIbanModalTitle: "Dane do przelewu",
      billingIbanModalMethodTitle: "Przelew bankowy IBAN",
      billingIbanModalDisclaimer: "Aby otrzymać fakturę do zapłaty, napisz na czacie pomocy technicznej.",
      billingIbanModalRecipient: "Odbiorca",
      billingIbanModalRecipientCode: "Kod odbiorcy",
      billingIbanModalIban: "IBAN",
      billingIbanModalBankName: "Nazwa banku",
      billingIbanModalCopy: "Skopiuj IBAN",
      billingIbanModalClose: "Zamknij",
      billingIbanCopyAllButton: "Skopiuj dane do przelewu",
      billingIbanCopiedNotification: "Skopiowano IBAN do schowka",
      billingIbanAllCopiedNotification: "Skopiowano dane do przelewu do schowka",
      billingWhatsIncluded: "Co jest zawarte",
      billingComparePlans: "Porównaj plany",
      billingComparePlanA: "Plan A do porównania",
      billingComparePlanB: "Plan B do porównania",
      billingFeatureSectionMain: "Podstawowe",
      billingFeatureSectionAdvanced: "Zaawansowane",
      billingFeatureSectionIntegrations: "Integracje",
      billingAnalyticsRowLabel: "Analityka",
      billingLeadsRowLabel: "Leady",
      billingFeatureProjectsRowLabel: "Projekty",
      billingFeatureCustomDomainRowLabel: "Własna domena",
      billingFeatureAnalyticsRowLabel: "Analityka",
      billingFeatureSiteInstallRowLabel: "Instalacja na stronie",
      billingFeatureAiBuilderRowLabel: "Kreator AI",
      billingFeatureRedirectRowLabel: "Przekierowanie",
      billingFeatureUtmTrackingRowLabel: "Śledzenie UTM",
      billingFeatureFaviconRowLabel: "Favicon",
      billingFeatureLogicRowLabel: "Logika",
      billingFeatureResultPageRowLabel: "Strona wyników",
      billingFeaturePointsRowLabel: "Punkty",
      billingFeatureFileUploadRowLabel: "Przesyłanie plików",
      billingFeatureNotYetAvailableLabel: "Wkrótce",
      billingFeatureTeamRowLabel: "Zespół",
      billingFeatureCrmRowLabel: "CRM",
      billingPartnershipOfferHeading: "Oferta partnerska",
      pearlescentGentianBlue:"Sapphire",
      periwinkleCrayolaAqua:"Cynevir",
      periwinkleCrayolaLilac:"Liliowy",
      placeholderText:"Wprowadź tutaj",
      poperBillings:"Płatności",
      poperLogout:"Wyloguj",
      poperTeam: "Zespół",
      teamDelegatedAccessTitle: 'Przekazał dostęp dalej',
      teamAccessTreeRootLabel: 'Źródło dostępu',
      teamAccessVia: 'przez',
      teamNoQuizNamesAvailable: 'Nazwy quizów są niedostępne',
      teamSharedShareTargetPrefix: 'Udostępnione przez',
      teamSharedOwnerFallback: 'właściciel',
      teamMembersTab: 'Komu nadałem dostęp',
      teamAccessSourceTab: 'Kto nadał mi dostęp',
      teamAccessSourceTitle: 'Kto nadał mi dostęp',
      teamAccessTreeTab: 'Łańcuchy dostępu',
      teamAccessTreeTitle: 'Łańcuchy dostępu',
      teamAccessTreeDescription: 'Pokazuje ścieżkę dostępu: właściciel → zapraszający → Ty → osoby, którym przekazałeś dostęp',
      teamAccessOwnerLabel: 'Właściciel',
      teamAccessInviterLabel: 'Udostępnił',
      teamAccessPath: 'Ścieżka dostępu',
      teamAccessYouLabel: 'ty',
      teamSharedByYou: 'Udostępnione przez Ciebie',
      teamCanReshare: 'Może udostępniać dalej',
      teamCannotReshare: 'Nie może udostępniać dalej',
      teamPartialReshare: 'Może udostępniać częściowo',
      teamMixedRoles: 'Mieszane role',
      teamNoAccessTree: 'Łańcuchy pojawią się, gdy przekażesz dostęp dalej',
      poperIdea: "Zaproponuj pomysł",
      poperIdeaTitle: "Masz pomysł na ulepszenie platformy?",
      poperIdeaText: "Podziel się nim z nami! Twoje sugestie pomagają nam się rozwijać i tworzyć lepsze doświadczenia dla Ciebie.",
      poperIdeaTextPlaceholder: "Szczegółowo opisz swój pomysł",
      poperIdeaSendButton: "Wyślij propozycję",
      poperPartnership:"Program partnerski",
      poperProfile:"Profil",
      poperTemplates:"Szablony",
      poperTrashcan:"Koszyk",
      profileChangePassword:"Zmiana hasła",
      profileDeleteAccount:"Usuń konto",
      profileDeleteAccountCheckedWord:"USUŃ",
      profileDeleteAccountPopupDescription:'Czy na pewno chcesz usunąć swoje konto? Tej czynności nie można anulować. Aby potwierdzić usunięcie, wpisz słowo "USUŃ" w polu poniżej.',
      profileDeleteAccountPopupHeader:"Chcesz usunąć swoje konto?",
      profileDeleteAccountPopupPlaceholder:"Wpisz tutaj",
      profileEmail:"E-mail",
      profileEmailCurent:"Aktualny adres e-mail",
      profileEmailNew:"Nowy adres e-mail",
      profileName:"Imię",
      profileNameFirst:"Imię",
      profileNameLast:"Nazwisko",
      profileChangePhoto: "Zmień zdjęcie",
      profileRemovePhoto: "Usuń",
      profileNewPassword:"Nowe hasło",
      profileNewPasswordConfirm:"Potwierdź nowe hasło",
      profilePassword:"Hasło",
      profilePhone:"Numer telefonu",
      profileSaveNewData:"Zaktualizuj dane",
      workboardStartTooltip: "Tutaj możesz utworzyć swój pierwszy quiz",
      profileStatus:"Status",
      profileStatusAgency:"Agencja",
      profileStatusBuisines:"Właściciel firmy",
      profileStatusFreelancer:"Freelancer",
      profileStatusPlaceholder:"Wybierz to, co najlepiej Cię opisuje",
      questionLogicAddConditionBtn:"Dodaj warunek",
      questionLogicAllMandatory:"Wszystkie poniższe warunki są wymagane",
      questionLogicConditionTitle:"Warunek.",
      questionLogicNotAvailable:"Ustawienia logiki nie są dostępne dla pierwszego pytania",
      pointsSettingsNotAvailableForQuestionType: "W przypadku tego typu pytań nie ma konieczności punktowania odpowiedzi",
      questionLogicQuestion:"Pytanie.",
      questionLogicSaved:"Ustawienia logiki wyświetlania kroków są zapisane",
      questionLogicDeleteAll: "Usuń logikę",
      questionLogicDeleted: "Logika wyświetlania kroku została usunięta",
      questionLogicRatingSelectedLeftBtn: "lewy przycisk",
      questionLogicRatingSelectedRightBtn: "prawy przycisk",
      QR_code: "QR code",
      QRCodeDownloadPdf: "Pobierz Pdf",
      QRCodeDownloadPng: "Pobierz Png",
      qrGenerateTitle: "Wygeneruj kod QR",
      qrGenerateDescription: "Wygeneruj spersonalizowany kod QR z tagami UTM, aby łatwo śledzić źródła ruchu. Po zeskanowaniu kodu użytkownicy zostaną przekierowani do Twojego quizu z zachowaniem parametrów kampanii dla dokładnej analityki.",
      qrUtmSource: "Źródło (np. google, newsletter)",
      qrUtmMedium: "Medium marketingowe (np. cpc, banner, email)",
      qrUtmCampaign: "Produkt, kod promocyjny lub slogan (np. spring_sale). Wymagana jest nazwa kampanii lub jej identyfikator.",
      qrUtmTerm: "Identyfikacja płatnych słów kluczowych",
      qrUtmContent: "Używane do rozróżniania reklam",
      questionLogicSetupAnswer:"Odpowiedź.",
      questionLogicSetupAnswerDisableOption:"Wybierz typ warunku",
      questionLogicSetupCustomContains:"Zawiera",
      questionLogicSetupCustomEqual:"Jest równy",
      questionLogicSetupCustomNotContains:"Nie zawiera",
      questionLogicSetupDescription:"Dodaj warunki, aby dostosować ankietę do każdego respondenta i zebrać dokładniejsze dane.",
      questionLogicSetupExpectedAnswer:"Oczekiwane odpowiedzi",
      questionLogicSetupLogicType:"Typ.",
      questionLogicSetupPlaceholder:"Wpisz tutaj",
      questionLogicSetupQuestionDisableOption:"Wybierz pytanie",
      questionLogicSetupRangeRatingBetween:"Pomiędzy",
      questionLogicSetupRangeRatingEqualTo:"Równy",
      questionLogicSetupRangeRatingFrom:"Od",
      questionLogicSetupRangeRatingLess:"Mniej niż",
      questionLogicSetupRangeRatingMore:"Więcej niż",
      questionLogicSetupRangeRatingTo:"Do",
      questionLogicSetupRangeRatingValue:"Wartość",
      questionLogicSetupTitle:"Konfigurowanie logiki pytań",
      questionLogicSetupVariantAll:"Wszystkie",
      questionLogicSetupVariantAny:"Wybrana jest jedna z poniższych wartości",
      questionLogicSetupVariantNot:"Żadne z wybranych",
      quizSlotDeletedData:"Usunięto",
      quizSlotLastEdit:"Ostatnia zmiana",
      QuizTemplateSelect:"Wybierz",
      QuizTemplatesReadyTemplates:"Gotowe szablony",
      QuizTemplatesSearchBtn:"Wyszukiwanie",
      QuizTemplatesSearchInput:"Nazwa szablonu i/lub kategorii",
      QuizTemplateView:"Podgląd",
      quizzesTemplatesAllTags:"Wszystkie szablony",
      rangeIsRange:"Zakres",
      rangeIsRangeFalse:"Wyłączone",
      rangeIsRangeTrue:"Włączone",
      rangeMax:"Maks.",
      rangeMin:"Min",
      rangePositionEnd:"Pozycja końcowa",
      rangePositionStart:"Pozycja początkowa",
      rangeStep:"Krok",
      reciveEmailCheckbox:"Pole wyboru odbierania wiadomości e-mail",
      recivePromotionNewsletter:"Otrzymywanie wiadomości e-mail z newsletterem",
      resetPasswordTip:"W przypadku dalszych wątpliwości lub pytań prosimy o kontakt z naszym zespołem obsługi klienta. Jesteśmy tutaj, aby pomóc.",
      restoreQuizSendedDescription:"W zależności od liczby leadów w quizie, przywrócenie quizu może potrwać od kilku sekund do 2 minut. Po przywróceniu lead pojawi się na Workboardzie.",
      restoreQuizSendedTitle:"Zadanie odzyskiwania jest w toku",
      restoreSuizSendedImportant:"Ważne",
      sapphireBlue:"Ciemny szafir",
      saveMoney:"Abonament na rok",
      secondReduction:"sek",
      selectInternationalPrefix:"Wybierz format międzynarodowy",
      selectOption:"Wybierz opcję",
      selectQuizLanguage:"Wybierz język quizu",
      signupAgreeIAgreeWith:"Przeczytałem i zgadzam się z",
      signupAgreePolicy:"polityka prywatności",
      signupAgreeAnd:"oraz",
      signupAgreeOffer:"warunkami użytkowania",
      signupAgreeService:"serwisu",
      signupBtnValue:"Utwórz konto",
      signupEmailPlaceholder:"E-mail",
      signupHeader:"Zarejestruj konto",
      signupHeader2Part:"aby kontynuować",
      signupLogin:"Zaloguj się do mojego konta",
      signupNamePlaceholder:"Alexander",
      signupPasswordlPlaceholder:"○ ○ ○ ○ ○ ○ ○ ○ ○",
      signupPhonePlaceholder:"numer telefonu",
      signupTariffFree:"Bezpłatnie.",
      signupTariffFreeDescription:"Nieograniczone tworzenie nowych quizów (stron internetowych). Możliwość wygenerowania do 300 leadów miesięcznie za darmo.",
      signupTariffHeader:"Taryfy",
      signupTariffPro:"Pro.",
      signupTariffProDescription:"Nieograniczone tworzenie nowych quizów (stron internetowych). Możliwość wygenerowania ",
      signupTariffProDescriptionBold:"ponad 300 leadów.",
      signupTariffProPrice:"$20 / miesiąc",
      signupWith:"Zarejestruj się w",
      slateGrayBlue:"Mgla",
      subscriptionCanceledTitle:"Subskrypcja została anulowana",
      subscriptionIsNotDeleteDescription:"Prosimy o kontakt z obsługą klienta",
      subscriptionIsNotDeleteTitle:"Subskrypcja nie została anulowana",
      subscriptionTariffLable:"Zapisz się na naszą automatyczną subskrypcję.",
      subscriptionUnsubscribeModalDescription:"Czy na pewno chcesz zrezygnować z subskrypcji? Leady zgromadzone w ramach subskrypcji będzie można wykorzystać w ciągu miesiąca od daty ostatniego rozliczenia.",
      subscriptionUnsubscribeModalTitle:"Rezygnacja z subskrypcji",
      telegramTokenCopied:"Token quizu został skopiowany do schowka",
      templatesBackToQuiz:"Powrót do Workboard",
      temporarilyUnavailable:"Tymczasowo niedostępne",
      trashcanClearAll:"Wyczyść wszystko",
      trashcanDescription:"Quiz zostanie automatycznie usunięty na stałe w ciągu 30 dni po przeniesieniu go do koszyka.",
      trashcanImportant:"Ważne!",
      trashcanTitle:"Koszyk",
      turquoiseBlueCrayola:"Działanie",
      upProVersion:"Przełącz na PRO",
      upProVersionDesktop:"Przełącz na PRO",
      upProVersionMobile:"Do PRO",
      userAccountInfo:"Informacje o koncie",
      userBackToQuiz:"Powrót do Workboard",
      userBackToSettings:"Powrót do ustawień",
      learningCenterTitle:"Centrum nauki",
      learningCenterTraining:"Szkolenie",
      learningCenterIntroText:"Obejrzyj wszystkie wymagane przewodniki wideo po kolei, potwierdź każdą lekcję po zakończeniu i poproś o certyfikat po ukończeniu ostatniej lekcji.",
      learningCenterVideoUnsupported:"Twoja przeglądarka nie obsługuje wideo HTML5.",
      learningCenterAvailable:"Dostępne",
      learningCenterLessonsComplete:"Ukończone lekcje",
      learningCenterBackToLearningCenter:"Powrót do Learning center",
      learningCenterCertificate:"Certyfikat",
      learningCenterCourseCompleted:"Kurs ukończony",
      learningCenterCertificateSentText:"Wszystkie lekcje są ukończone. Żądanie certyfikatu zostało wysłane do backendu.",
      learningCenterCertificateLabel:"Adsquiz Learning Center",
      learningCenterCertificateOfCompletion:"Certyfikat ukończenia",
      learningCenterDownloadCertificate:"Pobierz certyfikat",
      learningCenterDownloadUnavailable:"Pobieranie jeszcze niedostępne",
      learningCenterOpenCertificate:"Otwórz certyfikat",
      learningCenterAbout:"O lekcji",
      learningCenterOpenFallbackLink:"Otwórz link zapasowy",
      learningCenterBack:"Wstecz",
      learningCenterCompleted:"Ukończono",
      learningCenterWatchVideoToEnd:"Obejrzyj wideo do końca",
      learningCenterSaving:"Zapisywanie...",
      learningCenterMarkAsCompleted:"Oznacz jako ukończone",
      learningCenterWatchedPercent:"{percent}% obejrzano",
      learningCenterDefaultUserName:"Użytkownik Adsquiz",
      learningCenterCertificateReadyMessage:"Backend zwrócił plik certyfikatu. Użyj przycisku powyżej, aby go otworzyć.",
      learningCenterCertificatePendingMessage:"Żądanie certyfikatu zostało wysłane. Dodaj URL pobierania z backendu, gdy będzie dostępny.",
      learningCenterCertificateNoUrlMessage:"Żądanie certyfikatu zostało zakończone, ale URL pliku nie został jeszcze zwrócony.",
      learningCenterCertificateErrorMessage:"Nie udało się jeszcze potwierdzić żądania certyfikatu przez backend. Lokalne ukończenie zostało zapisane.",
      learningCenterSectionGeneral:"Ogólne",
      learningCenterSectionIterationsIntro:"Wprowadzenie do iteracji",
      learningCenterSectionIterationIntro:"Wprowadzenie do iteracji",
      userBillingsCost:"Koszt",
      userBillingsDate:"Data",
      userBillingsId:"ID",
      userBillingsMethod:"Metoda płatności",
      userGeneralInfoDescription1:"Profil użytkownika umożliwia zarządzanie kontem i ustawieniami.",
      userGeneralInfoDescription2:"Zaktualizuj swoje dane osobowe, zmień hasło i dostosuj informacje o powiadomieniach.",
      userGeneralInfoHeader:"Informacje ogólne",
      userSecuritySettingsDescription:"Aby zmienić hasło, wystarczy dwukrotnie wprowadzić nowe hasło w celu potwierdzenia.",
      userSecuritySettingsHeader:"Ustawienia zabezpieczeń",
      videoInstruction:"Wideo instrukcja ",
      violetBlueCrayola:"Zimowa bryza",
      welcomeBack:"Witamy ponownie!",
      wetRainforest:"Letni klon",
      widgetButtonBgColor:"Kolor przycisku",
      widgetButtonCornerRound:"Zaokrąglenie przycisku",
      widgetButtonInsertBeforeAfterBody:"Wstaw kod quizu tuż po tagu otwierającym `<body>` lub tuż przed tagiem zamykającym `</body>`.",
      widgetButtonInstruction0:"Możesz umieścić quiz na swojej stronie internetowej, który zostanie otwarty po kliknięciu przycisku.",
      widgetButtonInstruction1:"Dodaj zaokrąglenie, cień i tekst przycisku. Możesz także zmienić kolor przycisku i tekstu wewnątrz.",
      widgetButtonInstruction2:"Skopiuj skrypt znajdujący się w pierwszym polu kodu i wklej go przed tagiem zamykającym `</head>`.",
      widgetButtonInstruction3:"Skopiuj wygenerowany kod przycisku z drugiego pola kodu i wklej go w dowolnym miejscu na swojej stronie internetowej.",
      widgetButtonInstruction4:'Możesz pominąć kod z drugiego pola przycisku i po prostu dodać `id="button_open_quiz_popup"` do dowolnego elementu `<input type="button">` lub `<button></button>` na stronie internetowej.',
      widgetButtonShadow:"Cień przycisku",
      widgetButtonTextColor:"Kolor tekstu",
      widgetButtonTextValue:"Tekst przycisku",
      widgetEmbedVidgetButton:"Konstruktor przycisku",
      widgetEmbedVidgetChat:"Przycisk quizu",
      widgetEmbedVidgetInProgres:"W opracowaniu",
      widgetEmbedVidgetPopup:"Wyskakujące okienko",
      widgetEmbedVidgetSelectEmbedVariant:"Wybierz opcję integracji",
      EmbedQuizCardLabelStandard: "Standardowy",
      EmbedSettingsPreviewPopupHint: "Kliknij przycisk, aby zobaczyć swoje wyskakujące okno w akcji",
      EmbedQuizCardLabelPopup: "Okno wyskakujące",
      EmbedQuizCardLabelChatButton: "Przycisk czatu",
      EmbedQuizCardLabelFullscreen: "Pełny ekran",
      EmbedQuizCardLabelFeedback: "Informacja zwrotna",
      EmbedQuizCardLabelSidebar: "Panel boczny",
      EmbedStandardSettingsTitle: "Ustaw wymiary (opcjonalnie)",
      tipStandardEmbedQuizStepHead:
          "1. Skopiuj kod dla <head> i wklej go przed zamykającym tagiem </head>.",
      tipStandardEmbedQuizStepBody:
          "2. Skopiuj drugi kod i wklej div <div id=\"adsquiz_embed_standard_ .... dokładnie w tym miejscu strony, gdzie powinien wyświetlać się quiz.",
      tipStandardEmbedQuizParent:
          "3. Rozmiar quizu zależy od rozmiarów bloku nadrzędnego. Jeśli element nadrzędny nie ma ustawionej wysokości, quiz będzie automatycznie wyświetlany w formacie responsywnym.",
      tipStandardEmbedQuizPercent:
          "4. Width i height w % działają względem rozmiarów bloku nadrzędnego.",
      EmbedStandardSettingsTooltip: `
      Szerokość i wysokość — określają rozmiar quizu (px, %, auto).

      Auto — quiz jest responsywny, wysokość ustalana automatycznie.

      Pełny ekran — quiz zajmuje 100% szerokości w proporcji 16:9. Szerokość i wysokość są ignorowane.

      Wysokość:
      • auto / 0 → proporcja 16:9
      • wartość → stała wysokość

      Szerokość:
      • auto / 0 → 100% szerokości
      • wartość → w granicach kontenera

      Promień — odpowiada za zaokrąglenie rogów.

      Wewnętrzny odstęp — dodaje przestrzeń wewnątrz kontenera.

      Desktop / Urządzenie mobilne — określa, gdzie quiz jest wyświetlany.
      Jeśli wyłączone — quiz nie będzie widoczny na tym urządzeniu.
      `,
      EmbedFeedbackSettingsTooltip: `
      Rozmiar okna ustawia preset:
  • S → 360 × 520
  • M → 480 × 640
  • L → 640 × 760
  • XL → 780 × 860
  
  Kształt okna:
  • angular → kanciasty
  • rounded → zaokrąglony
  
  Szerokość:
  • auto / 0 / puste → preset
  • wartość → nadpisuje
  
  Wysokość:
  • auto / 0 / puste → preset
  • wartość → nadpisuje
  
  Rozmiar przycisku ustawia preset.
  
  Kształt przycisku:
  • angular → kanciasty
  • rounded → zaokrąglony
  
  Pozycja:
  • left → lewo
  • right → prawo
  • top → góra
  • bottom → dół
  
  Tekst przycisku — zmienia tekst.
  
  Ikona — wybór ikony.
  
  Kolor przycisku — tło.
  
  Kolor tekstu — tekst.
  
  Kolor ikony — ikona.
  
  Zablokuj zamknięcie przed ukończeniem quizu — jeśli włączone, użytkownik nie może zamknąć okna przed zakończeniem.
  
  Przestań wyświetlać po ukończeniu — po ukończeniu quizu przycisk i okno nie będą już pokazywane ponownie.
  
  Desktop / Mobile — gdzie wyświetlany jest widget.
  `,
      EmbedPopupSettingsTooltip: `
        Szerokość i wysokość określają rozmiar popupu.
        
        Rozmiar okna ustawia domyślny preset:
        • S → 360 × 520
        • M → 480 × 640
        • L → 640 × 760
        • XL → 780 × 860
        
        Szerokość i wysokość mogą nadpisać preset.
        
        Szerokość:
        • auto / 0 / puste → używana jest wartość z presetu
        • wartość → nadpisuje preset
        
        Wysokość:
        • auto / 0 / puste → używana jest wartość z presetu
        • wartość → nadpisuje preset
        
        Warunek wyświetlania określa, kiedy popup się pojawia:
        • Kliknięcie przycisku
        • Przy wyjściu ze strony
        • Po załadowaniu strony
        • Po opóźnieniu
        
        Sekundy pojawiają się tylko przy opóźnieniu.
        
        Tekst przycisku, rozmiar, kształt, pozycja, auto kolor (szablon), kolor przycisku i tekstu działają tylko dla kliknięcia.
        
        Rozmiar przycisku ustawia preset wielkości.
        
        Auto kolor:
        • włączony — używa kolorów szablonu
        • przy ręcznych kolorach wyłącza się
        
        Zablokuj zamknięcie przed ukończeniem quizu — jeśli włączone, użytkownik nie może zamknąć okna przed zakończeniem.
  
        Przestań wyświetlać po ukończeniu — po ukończeniu quizu przycisk i okno nie będą już pokazywane ponownie.
        
        Desktop / Mobile — gdzie popup jest widoczny.
        `,
      EmbedChatButtonSettingsTooltip: `
      Szerokość i wysokość określają rozmiar okna czatu.

      Rozmiar okna ustawia domyślny preset rozmiaru:
      • S → 360 × 520
      • M → 480 × 640
      • L → 640 × 760
      • XL → 780 × 860

      Szerokość i wysokość mogą nadpisać wybrany preset Rozmiaru okna.

      Szerokość:
      • auto / 0 / puste → używana jest szerokość z Rozmiaru okna
      • wartość → własna szerokość nadpisuje preset

      Wysokość:
      • auto / 0 / puste → używana jest wysokość z Rozmiaru okna
      • wartość → własna wysokość nadpisuje preset

      Kształt okna określa, czy okno czatu ma ostre czy zaokrąglone rogi.

      Rozmiar przycisku ustawia preset rozmiaru przycisku otwierającego czat.

      Kształt przycisku określa styl przycisku:
      • prostokątny
      • okrągły

      Pozycja przycisku określa, gdzie będzie wyświetlany przycisk:
      • po lewej
      • po prawej

      Ikony pozwalają wybrać ikonę przycisku czatu.

      Kolor przycisku ustawia kolor tła przycisku.

      Kolor ikony ustawia kolor ikony wewnątrz przycisku.

      Zablokuj zamknięcie przed ukończeniem quizu — jeśli włączone, użytkownik nie może zamknąć okna przed zakończeniem.
  
      Przestań wyświetlać po ukończeniu — po ukończeniu quizu przycisk i okno nie będą już pokazywane ponownie.

      Komputer / Urządzenie mobilne — określa, gdzie pokazywany jest przycisk czatu i samo okno.
      Jeśli wyłączone — przycisk czatu nie będzie wyświetlany na tym urządzeniu.
      `,
      EmbedSidebarSettingsTooltip: `
      Szerokość i wysokość określają rozmiar panelu bocznego.
      
      Rozmiar okna ustawia preset:
      • S → 360 × 520
      • M → 480 × 640
      • L → 640 × 760
      • XL → 780 × 860
      
      Pozycja:
      • left → lewo
      • right → prawo
      
      Szerokość:
      • auto / 0 / puste → preset
      • wartość → nadpisuje
      
      Wysokość:
      • auto / 0 / puste → preset
      • wartość → nadpisuje
      
      Warunek wyświetlania:
      • Kliknięcie — otwiera po kliknięciu
      • Exit intent — przy opuszczaniu strony
      • Po załadowaniu — od razu
      • Opóźnienie — po czasie
      
      Pole sekund tylko dla opóźnienia.
      
      Ustawienia przycisku działają tylko dla kliknięcia.
      
      Rozmiar przycisku ustawia preset.
      
      Kształt:
      • angular → kanciasty
      • rounded → zaokrąglony
      
      Pozycja:
      • left → lewo
      • middle → środek
      • right → prawo
      
      Kolor przycisku — tło.
      
      Kolor tekstu — tekst.
      
      Zablokuj zamknięcie до ukończenia quizu — jeśli włączone, użytkownik nie może zamknąć panelu przed zakończeniem.
      
      Przestań wyświetlać po ukończeniu — po ukończeniu quizu przycisk i panel nie będą już ponownie pokazywane.
      
      Desktop / Mobile — gdzie wyświetlać.
      `,
      EmbedModalStandardInstruction: `
      Skopiuj kod Head i wklej przed </head>.
      
      Skopiuj kod Body i wklej w miejscu wyświetlania quizu.
      
      Jak działa:
      • Quiz osadza się w stronie
      • Dopasowuje się do kontenera
      
      Na co uważać:
      • Sprawdź szerokość kontenera
      • Ustaw wysokość jeśli potrzeba
      • Tryb responsywny dostosowuje wysokość
      • Sprawdź style CSS
      
      Po instalacji:
      1. Zapisz
      2. Odśwież
      3. Sprawdź działanie
      `,
      EmbedModalPopupInstruction: `
      Wklej Head przed </head>.
      
      Wklej Body przed </body> lub gdziekolwiek.
      
      Jak działa:
      • Quiz otwiera się jako popup
      • Może otwierać się automatycznie lub po kliknięciu
      
      Na co uważać:
      • Przycisk pojawi się w miejscu wklejenia
      • Auto tryb otwiera popup sam
      • Sprawdź ustawienia urządzeń
      • Dostosuj rozmiar jeśli trzeba
      
      Po instalacji:
      1. Zapisz
      2. Odśwież
      3. Sprawdź popup
      `,
      EmbedSettingsWindowSize: "Rozmiar okna",
      EmbedPreviewFallbackTitle: "Podgląd ładuje się dłużej niż oczekiwano",
      EmbedPreviewFallbackDescription: "Podgląd quizu nie mógł jeszcze zostać wyświetlony. Spróbuj ponownie otworzyć podgląd lub przeładować ramkę.",
      EmbedPreviewFallbackReasonsTitle: "Możliwe przyczyny:",
      EmbedPreviewFallbackReasonDomain: "Wybrana domena może być niedostępna lub wpisana nieprawidłowo.",
      EmbedPreviewFallbackReasonDomainSettings: "Sprawdź ustawienia domeny i upewnij się, że domena jest poprawnie podłączona.",
      EmbedPreviewFallbackReasonSlow: "Strona quizu może się jeszcze ładować lub odpowiadać z opóźnieniem.",
      EmbedPreviewFallbackReasonBlocked: "Podgląd może być blokowany przez przeglądarkę lub środowisko sieciowe.",
      EmbedPreviewFallbackReload: "Przeładuj podgląd",
      EmbedSizePresetDisabledHint: "Preset rozmiaru jest niedostępny, gdy ustawiono własną szerokość lub wysokość.",
      EmbedPopupSettingsTitleButton: "Rozmiar przycisku",
      EmbedStandardSettingsHeightLabel: "Wysokość",
      EmbedStandardSettingsWidthLabel: "Szerokość",
      EmbedStandardSettingsRadiusLabel: "Promień",
      EmbedStandardSettingsPaddingLabel: "Wewnętrzny odstęp",
      EmbedStandardSettingsFullscreenToggle: "Pełny ekran",
      EmbedStandardSettingsDesktopToggle: "Komputer",
      EmbedPopupSettingsTextColorToggle: "Kolor tekstu",
      EmbedPopupSettingsButtonColorToggle: "Kolor przycisku",
      EmbedSettingsIconColor: "Kolor ikony",
      EmbedPopupSettingsAutoColorToggle: "Automatyczny kolor (szablon)",
      EmbedPopupSettingsCloseOnCompletionToggle: "Zablokować zamknięcie до ukończenia quizu",
      EmbedStandardSettingsMobileToggle: "Urządzenie mobilne",
      EmbedSettingsAutoOpenToggle: "Automatyczne otwieranie",
      EmbedSettingsPreviewDelayHint: "Wyskakujące okno pojawi się po ",
      EmbedSettingsPreviewOpenAgain: "Otwórz podgląd wyskakującego okna",
      EmbedReOpenSettingsMobileToggle: "Otwórz podgląd",
      widgetEmbedVidgetSitecode:"W kodzie strony",
      widgetEmbedVidgetToSite:"Umieszczenie quizu na stronie internetowej",
      widgetEmbedVidgetToSiteCode:"Umieszczenie quizu na stronie internetowej",
      widgetPopupCopyToBody:"Skopiuj i wklej kod przed tagiem zamykającym `</footer>`.",
      widgetPopupCopyToHead:"Skopiuj i wklej do `<head>` swojej strony internetowej.",
      widgetPopupInstruction0:"Aby umieścić quiz na swojej stronie internetowej, dodaj kod z pola kodu do tagu `<head>` na swojej stronie internetowej lub do Google Tag Manager, jeśli jest on zintegrowany z Twoją stroną internetową. Jeśli zmienisz domenę quizu lub open triggers (procent przewijania lub timing) po umieszczeniu quizu na swojej stronie internetowej, będziesz musiał zaktualizować kod integracji na swojej stronie internetowej.",
      widgetPopupInstruction1:"Tuż przed zamknięciem tagu `</footer>' wklej kod z drugiego pola.",
      widgetPopupInstruction2:"Dla programistów lub zaawansowanych użytkowników",
      widgetPopupInstruction3:"Jeśli z jakiegoś powodu nie czujesz się komfortowo z umieszczaniem quizu przed zamykającym tagiem `</footer>`, możesz wstawić kod z drugiego pola w dowolnym dogodnym miejscu, ale pamiętaj, że kontener, w którym wstawiasz kod z drugiego pola, powinien znajdować się na górze wszystkich okien i, najlepiej, powinien mieć maksymalną możliwą wysokość i szerokość wyświetlania.",
      widgetPopupScrollClarification:"Wyskakujące okienko pojawi się po określonym powyżej procencie przewijania strony internetowej",
      widgetPopupScrollToOpen:"Procent przewijania strony internetowej",
      widgetPopupTimeClarification:"Wyskakujące okienko pojawi się po upływie powyższego zaznaczonego czasu w sekundach",
      widgetPopupTimeToOpen:"Przedział czasu",
      widgetRealTimeChange:"Możesz zobaczyć zmiany w czasie rzeczywistym po prawej stronie ekranu.",
      widgetSiteCodeCopyButton:"Wklej kod przycisku w dowolnym miejscu na swojej stronie internetowej ",
      widgetSiteCodeCopyToBody:"Wklej kod w miejscu, w którym chcesz umieścić przycisk",
      widgetSiteCodeCopyToHead:"Skopiuj i wklej do `<head>` swojej strony internetowej.",
      widgetSiteCodeInstruction0:"Aby umieścić quiz na swojej stronie internetowej, dodaj kod z pola kodu do tagu `<head>` na swojej stronie internetowej lub do Google Tag Manager, jeśli jest on zintegrowany z Twoją stroną internetową. Jeśli zmienisz domenę quizu na swojej stronie internetowej, będziesz musiał zaktualizować kod integracji na swojej stronie internetowej.",
      widgetSiteCodeInstruction1:"Wklej kod z drugiego pola w miejscu, w którym chcesz zintegrować quiz.",
      widgetSiteCodeInstruction2:"Quiz można zintegrować z kontenerem o dowolnym rozmiarze, nawet z sidebarem! Maksymalny rozmiar quizu, jak również w przypadku uruchomienia w oddzielnej domenie, wynosi 900x552 pikseli. Można go dodać do kontenerów o większym rozmiarze, w tym przypadku quiz zostanie wyśrodkowany.",
      widgetSiteCodeInstruction3:"Nie wahaj się eksperymentować!",
      workboardAddNewQuiz:"Stwórz projekt",
      workboardAlertGiveAnyName:"Wprowadź przynajmniej nazwę",
      workboardAlertNextTimeAddQuiz:"Cóż, następnym razem odważ się:)",
      workboardChangeQuizName:"Zmień nazwę",
      workboardCopyQuiz:"Skopiować cytat",
      workboardDeleteQuiz:"Usuń",
      workboardTransferQuizPlaceholderInput: "Wprowadź adres e-mail użytkownika",
      workboardTextAllQuizes: "Wszystkie quizy",
      workboardTextProjects: "Projekty",
      workboardTransferQuiz: "Przenieś quiz na inne konto",
      workboardTransferProject: "Dodaj do projektu",
      workboardTransferQuizCancel: "Anuluj",
      workboardTransferQuizLabel: "Nazwa quizu",
      workboardTransferQuizTitle: "Sprawdź swoją wiedzę o ochronie środowiska!",
      workboardTransferQuizHintTitle: "Podczas przenoszenia quizu wszystkie zgłoszenia zostaną przeniesione razem z nim.",
      workboardTransferQuizHintTitleSecond: "Aby przenieść quiz z odpowiedziami, jeden z użytkowników musi mieć dowolny ",
      workboardTransferQuizHintTitleSecondLink: "https://app.adsquiz.io/tariffs",
      workboardTransferQuizHintTitleSecondLinkText: "płatny pakiet.",
      workboardTransferQuizConfirm: "Przenieś",
      workboardTransferQuizNoValidEmail: "Nieprawidłowy adres e-mail",
      workboardTransferQuizStatus200: "Quiz został pomyślnie przeniesiony na:",
      workboardTransferQuizStatus401: "Nieautoryzowany — Użytkownik nie jest uwierzytelniony.",
      workboardTransferQuizStatus403: "Zabronione — Nie masz dostępu do przeniesienia tego quizu.",
      workboardTransferQuizStatus404: "Nie znaleziono — Quiz lub użytkownik odbiorca nie został znaleziony.",
      workboardTransferQuizStatus422: "Nieprzetwarzalny podmiot — Przynajmniej jeden użytkownik musi mieć płatne konto.",
      workboardTransferQuizStatusError: "Nieoczekiwany status błędu",
      workboardDuplicate:"Duplikować",
      workboardEditQuiz:"Edytuj",
      workboardLeads:"Leady",
      filterOptionLabelCreatedDesc: "od nowych do starych",
      filterOptionLabelCreatedAsc: "od starych do nowych",
      filterOptionLabelLeadsDesc: "Według leadów (malejąco)",
      filterOptionLabelLeadsAsc: "Według leadów (rosnąco)",
      filterOptionLabelWithProject: "Quizy w projektach",
      filterOptionLabelWithoutProject: "Quizy bez projektu",
      workboardModalAddQuizHeader:"Stwórz nowy quiz",
      workboardModalDeleteQuizCancel:"Anuluj",
      workboardModalDeleteQuizDelete:"Usuń",
      workboardModalRemoveQuizTrash: "Ten quiz zostanie przeniesiony do kosza i trwale usunięty po 1 miesiącu.",
      workboardModalRemoveQuizSure: "Czy na pewno chcesz przenieść ten quiz do kosza?",
      workboardModalRemoveProjectTrash: "Projekt i wszystkie jego quizy zostaną trwale usunięte.",
      workboardModalRemoveProjectSure: "Czy na pewno chcesz usunąć ten projekt?",
      workboardModalDeleteQuizSure:"Czy na pewno chcesz usunąć ten quiz?",
      workboardModalGiveQuizName:"Nadaj quizu nazwę",
      workboardModalGiveQuizNameAndMethod:"Wymyśl nazwę dla swojego quizu i wybierz preferowaną metodę tworzenia.",
      workboardModalLeadsAnswersCount:"Odpowiedzi na zapytania",
      workboardModalLeadsHaveNotSended:"Masz nieodebrane leady",
      workboardModalLeadsLeadActions:"Działania",
      workboardModalLeadsLeadAnswerScipped:"Nieodebrane",
      workboardModalLeadsLeadDate:"Data",
      workboardModalLeadsLeadEmail:"E-mail",
      workboardModalLeadsLeadEmailCopied:"Email skopiowany do bufora",
      workboardModalLeadsLeadHideMore:"Ukryć",
      workboardModalLeadsLeadLimit:"Osiągnięto limit leadów",
      workboardModalLeadsLeadLimitInstruction1:"Aby zobaczyć leadów,",
      workboardModalLeadsLeadLimitInstruction2:"przełącz się na inny plan",
      workboardModalLeadsLeadLimitInstruction3:"uaktualnić bieżący plan",
      workboardModalLeadsLeadLimitInstruction4:'(nie dotyczy "Test") lub poczekaj na aktualizację planu, jeśli masz włączone automatyczne odnawianie planu.',
      workboardModalLeadsLeadLimitNewText: "Masz nieodebrane leady, do których nie masz dostępu z powodu limitu w obecnym pakiecie. Aby uzyskać do nich dostęp, kup lub zaktualizuj swój pakiet.",
      workboardModalLeadsLeadName:"Nazwa",
      workboardModalLeadsLeadPhone:"Numer telefonu",
      workboardModalLeadsLeadPoints: "Punkty",
      workboardModalLeadsLeadPhoneCopied:"Numer telefonu jest kopiowany do bufora",
      workboardModalLeadsLeadReferrer:"Niezdefiniowany",
      workboardEditTitle: "Edytuj nazwę",
      workboardEditIcon: "Edytuj ikonę",
      workboardSaveChange: "Zapisz zmiany",
      workboardModalLeadsLeadReferrerClarification:"Dane źródła przełączenia są zablokowane lub niezdefiniowane",
      workboardModalLeadsLeadReload:"Odbierz",
      workboardModalLeadsLeadReloaded:"Jeśli pozostały jakieś leady, nieodebrane leady zostaną załadowane na górze listy. Zostaną one również wysłane do dodanych integracji",
      workboardModalLeadsLeadReloadedTitle:"Wniosek został przyjęty",
      workboardModalLeadsLeadSerial:"№",
      workboardModalLeadsLeadShowMore:"Więcej",
      workboardModalNewQuizBtnValue:"dodać",
      workboardModalNewQuizFromStart:"Stwórz od 0",
      workboardModalNewQuizFromTemplates:"Gotowe szablony",
      workboardModalNoLeads:"Nie ma jeszcze żadnych leadów",
      workboardModalQuizDeleteOk:"OK",
      workboardModalQuizNamePlaceholder:"Nowy quiz",
      workboardQuizCopied:"Quiz został pomyślnie skopiowany",
      workboardQuizLink:"link",
      workboardQuizLinkCopied:"Link został skopiowany do bufora",
      workboardQuizzesTitle:"Moje quizy",
      workboardStatsTitle:"Statystyki",
      youCanChangePlan:'Możesz zmienić swój obecny plan, klikając przycisk "Przełącz na PRO"',




      csettingsIntegrationSendPulse: "Integracja - Send Pulse",
      csettingsIntegrationMailchimp: "Integracja - Mailchimp",
      csettingsIntegrationMake: "Integracja - Make",
      csettingsIntegrationZapier: "Integracja - Zapier",
      csettingsIntegrationCRMBitrix: "Integracja - CRM Bitrix",
      csettingsIntegrationPipeDrive: "Integracja - Pipe Drive",
      csettingsIntegrationRemOnline: "Integracja - Rem Online",
      csettingsIntegrationKeyCRM: "Integracja - Key CRM",
      csettingsIntegrationGoogleSpreadsheets: "Integracja - Google Spreadsheets",
      csettingsIntegrationKeepinCrm: "Integracja - KeepinCRM",
      csettingsIntegrationZapierAbout: "Wklej adres URL wysyłania danych dostarczony przez Zapier do pola wejściowego.",
      csettingsIntegrationMakeAbout: "Wklej adres URL wysyłania danych dostarczony przez Make do pola wejściowego.",
      csettingsIntegrationMakeAboutTextStep1: "Aby skonfigurować integrację z",
      csettingsIntegrationMakeAboutTextStep2: ", obejrzyj",
      csettingsIntegrationMakeAboutTextStep3: "Aby ją skonfigurować, wybierz “Webhooks” spośród integracji w Make, a następnie “Custom webhook”.",
      csettingsIntegrationMakeAboutTextStep4: "Skopiuj wygenerowany link i wklej go w polu poniżej w ADS Quiz.",
      csettingsIntegrationMakeAboutTextStep5: "Aby przetestować, wróć do Make, kliknij “Run” i wypełnij quiz, wysyłając zgłoszenie.",
      csettingsIntegrationMakeAboutTextStep6: "Jeśli test zakończy się pomyślnie, zapisz integrację i nie zapomnij aktywować aktualizacji.",
      csettingsIntegrationMakeAboutLink: "https://www.make.com/en/register?pc=adschool",
      csettingsIntegrationCRMBitrixAbout: "Wklej adres URL wysyłania danych dostarczony przez CRM Bitrix do pola wejściowego.",

      csettingsIntegrationSendPulseAboutStart: "Możesz skonfigurować integrację z usługą ",
      csettingsIntegrationSendPulseAboutMiddle: ". Aby to zrobić, przejdź do ustawień swojego konta i otwórz zakładkę ",
      csettingsIntegrationSendPulseAboutEnd: ". Skopiuj wartości parametrów 'ID' i 'Secret', a następnie wklej je w odpowiednie pola w usłudze ADS Quiz (w pola poniżej). Następnie musisz wkleić ID książki adresowej. Aby to zrobić, przejdź do odpowiedniej książki adresowej i skopiuj z adresu URL strony wartość po id/. Potrzebne są tylko cyfry, bez dodatkowych znaków. Zapisz zmiany. Bardziej szczegółowa instrukcja znajduje się w ",
      csettingsIntegrationSendPulseAboutLinkSendPulse: "https://sendpulse.com/en/#60c9ccfd55f4b",
      csettingsIntegrationSendPulseAboutLinkAPI: "https://login.sendpulse.com/login/#api",
      csettingsIntegrationSendPulseAboutLinkVideo: "https://www.youtube.com/watch?v=4mnhpbKkePs",
      csettingsIntegrationSendPulseAboutLinkVideoText: "wideo",

      csettingsIntegrationKeyCRMAbout: "Wklej klucz API i identyfikator potoku do odpowiednich pól wejściowych.",
      csettingsIntegrationPipeDriveAbout: "Wklej token i domenę firmy do odpowiednich pól wejściowych.",
      csettingsIntegrationRemOnlineAbout: "Wklej klucz API Rem Online do odpowiedniego pola wejściowego.",
      csettingsIntegrationGoogleSheetsAbout: "Zaloguj się do Google Sheets (jeśli Twoje konto jest zarejestrowane przy użyciu adresu Gmail, możesz połączyć tylko to konto Gmail; próba połączenia innego konta spowoduje błąd), wybierz arkusz i zmapuj pola, aby rozpocząć przesyłanie danych.",
      csettingsIntegrationMailchimpAbout: "Połącz Mailchimp, wybierz odbiorców i w razie potrzeby zmapuj pola.",
      csettingsIntegrationKeepinCrmAbout: "Wklej klucz API KeepinCRM, wybierz lejek, status, menedżera i źródło. W razie potrzeby włącz mapowanie pól.",
      csettingsIntegrationActiveIntegration: "Aktywna integracja",
      cintegrationIntegrationData: "Dane integracji",
      cintegrationMailchimpAudience: "Odbiorcy",
      cintegrationMailchimpAudiencePlaceholder: "Wybierz odbiorców",
      cintegrationMailchimpStatus: "Status subskrypcji",
      cintegrationMailchimpStatusOptionSubscribed: "subscribed (Subskrybowany)",
      cintegrationMailchimpStatusOptionPending: "pending (Oczekuje potwierdzenia)",
      cintegrationMailchimpStatusOptionUnsubscribed: "unsubscribed (Wypisany)",
      cintegrationMailchimpStatusOptionCleaned: "cleaned (Usunięty)",
      cintegrationMailchimpStatusOptionTransactional: "transactional (Tylko transakcyjne)",
      cintegrationMailchimpStatusDescriptionSubscribed: "kontakt będzie otrzymywać Twoje newslettery.",
      cintegrationMailchimpStatusDescriptionPending: "użytkownik nie potwierdził jeszcze subskrypcji przez email.",
      cintegrationMailchimpStatusDescriptionUnsubscribed: "kontakt zrezygnował z newsletterów.",
      cintegrationMailchimpStatusDescriptionCleaned: "wiadomości nie mogą zostać dostarczone.",
      cintegrationMailchimpStatusDescriptionTransactional: "używane tylko do wiadomości serwisowych, nie do marketingu.",
      cintegrationMailchimpConnect: "Połącz Mailchimp",
      cintegrationMailchimpConnectTo: "Połącz Mailchimp",
      cintegrationMailchimpConnectedTo: "Połączono z Mailchimp",
      cintegrationMailchimpUseMapping: "Ustawienia pól",
      cintegrationMailchimpDataSaved: "Dane integracji Mailchimp zapisane",
      cintegrationDataMailchimpError: "Wybierz odbiorców Mailchimp",
      cintegrationMailchimpMappingError: "Uzupełnij mapowanie pól",
      cintegrationMailchimpNoTags: "Mailchimp nie ma tagów",
      cintegrationIntegrationUrl: "URL integracji",
      cintegrationWriteUrl: "Wprowadź URL",
      cintegrationDataFBError: "Nieprawidłowy identyfikator piksela",
      cintegrationDataWebHookError: "Nieprawidłowy adres webhooka",
      cintegrationZapierDataSaved: "Dane integracji Zapier zapisane",
      cintegrationDataZapierError: "Nieprawidłowy adres integracji",
      cintegrationAPIxDriveDataSaved: "Dane integracji APIxDrive zapisane",
      cintegrationDataAPIxDriveError: "Ciąg nie jest adresem integracji APIxDrive",
      cintegrationMakeDataSaved: "Dane integracji Make zapisane",
      cintegrationDataMakeError: "Nieprawidłowy adres integracji",
      cintegrationSendPulseDataSaved: "Dane integracji SendPulse zapisane",
      cintegrationDataSendPulseError: "Nieprawidłowe lub puste dane integracji",
      cintegrationPipeDriveDataSaved: "Dane integracji PipeDrive zapisane",
      cintegrationDataPipeDriveError: "Nieprawidłowe lub puste dane integracji",
      cintegrationRemOnlineDataSaved: "Dane integracji RemOnline zapisane",
      cintegrationDataRemOnlineError: "Nieprawidłowe lub puste dane integracji",
      cintegrationKeyCRMDataSaved: "Dane integracji KeyCRM zapisane",
      cintegrationDataKeyCRMError: "Nieprawidłowe lub puste dane integracji",
      cintegrationInputEmailUrl: "Wprowadź e-mail",
      cintegrationEmailDataSaved: "E-mail zapisany",
      cintegrationDataEmailError: "Wprowadzony ciąg nie jest adresem e-mail",
      cintegrationCRMBitrixDataSaved: "E-mail zapisany",
      cintegrationDataCRMBitrixError: "Wprowadzony ciąg nie jest adresem e-mail",
      cintegrationTelegramBotDataSaved: "Ustawienia integracji z Telegram zapisane",
      cintegrationDataTelegramBotError: "Błąd zapisu",
      cintegrationGTMDataSaved: "Zapisany identyfikator Google Tag Manager",
      cintegrationDataGTMError: "Nieprawidłowy identyfikator",
      cintegrationDataGTMErrorDescription: "Identyfikator powinien mieć format GTM-XXXXXX",
      cintegrationGoogleAnalyticsDataSaved: "Zapisany identyfikator Google Analytics",
      cintegrationDataGoogleAnalyticsError: "Nieprawidłowy identyfikator",
      cintegrationDataGoogleAnalyticsErrorDescription: 'Identyfikator powinien mieć format "UA-XXXXXXX-X" lub "G-XXXXXXXXXX-XX"',
      cintegrationTikTokDataSaved: "Piksel Tik-Tok zapisany",
      cintegrationDataTikTokError: "Wprowadzony ciąg nie jest pikselem Tik-Tok",
      cintegrationIntegrationToken: "Token integracji",
      cintegrationWriteToken: "Wprowadź token integracji",
      cintegrationDataYourAPIKey: "Wprowadź swój klucz API",
      cintegrationDataLeadTypeId: "Wprowadź identyfikator kanału",
      send_utm: "Wyślij znaczniki UTM",
      send_quiz: "Wyślij dane quizu",
      send_answers: "Wyślij odpowiedzi",
      csettingsIntegrationKeyCrm: "Integracja KeyCRM",
      cintegrationSendPulseClientId: "Identyfikator klienta",
      cintegrationSendPulseClientSecret: "Sekret",
      cintegrationSendPulseAddressBookId: "Identyfikator książki adresowej",
      cintegrationSendPulseAction: "Działanie z kontaktem",
      sendpulseActionAddContact: "Dodaj kontakt",
      sendpulseActionDeleteContact: "Usuń kontakt",
      cintegrationPipeDriveToken: "Token API",
      cintegrationPipeDriveDomain: "Twój unikalny subdomena",
      cintegrationKeyCrmApiKey: "Klucz API",
      cintegrationKeyCrmPipelineId: "Identyfikator potoku",
      cintegrationMenuGoogleTagManager:"Menadżer tagów Google",
      cintegrationMenuGoogleAnalytics:"Google Analytics",
      cintegrationMenuGoogleSpreadsheets:"Google Spreadsheets",
      cintegrationMenuKeepinCRM:"KeepinCRM",
      cintegrationMenuFacebookPixel:"Piksel Facebooka",
      cintegrationMenuTikTokPixel:"Piksel TikTok",
      cintegrationMenuWebHook:"Webhook",
      cintegrationMenuZapier:"Zapier",
      cintegrationMenuAPIxDrive:"APIx Drive",
      cintegrationMenuMake:"Make",
      cintegrationMenuSendPulse:"Send Pulse",
      cintegrationMenuMailchimp:"Mailchimp",
      cintegrationMenuEmail:"E-mail",
      cintegrationMenuTelegramBot:"Bot Telegram",
      cintegrationMenuPipeDrive:"PipeDrive",
      cintegrationMenuRemOnline:"Rem Online",
      cintegrationMenuKeyCRM:"Key CRM",
      cintegrationMenuCRMBitrix:"CRM Bitrix",
      googleSignIn: "Zaloguj się przez Google",
      googleSignInHint: "Zaloguj się, aby kontynuować konfigurację integracji.",
      cintegrationGoogleSpreadsheetID: "ID arkusza",
      cintegrationGoogleSheetName: "Nazwa arkusza",
      googleSheetNameTip: "Użyj nazwy arkusza dokładnie tak, jak w Google Sheets.",
      googleSheetsMappingTitle: "Mapowanie pól",
      cintegrationGoogleSheetsSaved: "Dane Google Spreadsheets zapisane",
      googleSheetsSelectSheet: "Wybierz arkusz",
      googleSheetsSelectSheetPlaceholder: "Wybierz arkusz",
      googleSheetsSelectSheetFirst: "Najpierw wybierz arkusz, aby skonfigurować mapowanie",
      cintegrationKeepinPipelineId: "Lejek",
      cintegrationKeepinPipelineIdPlaceholder: "Wybierz lejek",
      cintegrationKeepinStatusId: "Status",
      cintegrationKeepinStatusIdPlaceholder: "Wybierz status",
      cintegrationKeepinManagerId: "Menedżer",
      cintegrationKeepinManagerIdPlaceholder: "Wybierz menedżera",
      cintegrationKeepinSourceId: "Źródło",
      cintegrationKeepinSourceIdPlaceholder: "Wybierz źródło",
      cintegrationKeepinUseMapping: "Użyj mapowania pól",
      cintegrationKeepinDataSaved: "Dane KeepinCRM zapisane",
      trashcanRestoreQuiz: "Przywróć quiz",
      cformValuePromotionAccepted: "Zgadzam się na newsletter",


      constructorAddIntegration: "Dodaj nową integrację",
      cintegrationKeyCrmSourceId: "Identyfikator źródła (opcjonalnie)",
      cintegrationKeyCrmManagerId: "Identyfikator menedżera (opcjonalnie)",
      cSettingsSettingQuizSpamFilterTitle: "Ochrona przed spamem",
      cSettingsSettingQuizSpamFilterDescription: "Funkcja jest domyślnie wyłączona. Jeśli napotkasz problem spamowych leadów, włącz ochronę. Po tym jeden użytkownik nie będzie mógł przesłać więcej niż określona liczba leadów dla tego quizu.",
      cSettingsSettingQuizSpamFilterLimitPlaceholder: "Liczba leadów",
      langNO: "Norweski",
      loadMoreLeads: "Zobacz więcej leadów",
      userAdditionalSettingsHeader: "Zaawansowane ustawienia",
      userAdditionalSettingsDescription1: "Tutaj możesz skonfigurować nowe zaawansowane ustawienia profilu.",
      userAdditionalSettingsPagination: "Paginacja na pulpicie roboczym",

      benefitType: "Typ bonusu",
      benefitLabelPlaceholder: "Tekst bonusu",
      benefitDescriptionPlaceholderDiscount: "Kod promocyjny lub instrukcja",
      benefitDescriptionPlaceholderVideo: "Link do wideo",
      benefitDescriptionPlaceholderTextfile: "Link do pliku tekstowego",
      benefitDescriptionPlaceholderGift: "Opis bonusu",
      benefitDescriptionPlaceholderPDF: "Link do PDF",
      benefitDescriptionPlaceholderLink: "Link",
      benefitDescriptionPlaceholderFile: "Link do pliku",
      benefitDescriptionPlaceholderCustom: "Link",
      benefitLabelDiscount: "Zniżka",
      benefitLabelVideo: "Wideo",
      benefitLabelTextfile: "Plik tekstowy",
      benefitLabelGift: "Prezent",
      benefitLabelPDF: "Plik PDF",
      benefitLabelLink: "Link",
      benefitLabelFile: "Plik",
      benefitLabelCustom: "Indywidualny bonus",
      addBenefit: "Dodaj bonus",
      saveBenefit: "Zapisz bonus",
      cfinishSocialNetworks: "Media społecznościowe",
      
      saveSocialNet: "Zapisz sieć społecznościową",
      networkLabelFacebook: "Facebook",
      networkLabelInstagram: "Instagram",
      networkLabelTelegram: "Telegram",
      networkLabelTiktok: "Tik-Tok",
      networkLabelYoutube: "Youtube",
      networkLabelLinkedin: "LinkedIn",
      networkLabelWhatsapp: "WhatsApp",
      socialNetDescriptionPlaceholderFacebook: "nazwa_profilu",
      socialNetDescriptionPlaceholderInstagram: "nazwa_profilu",
      socialNetDescriptionPlaceholderTelegram: "nazwa_profilu/kanalu",
      socialNetDescriptionPlaceholderTiktok: "nazwa_profilu",
      socialNetDescriptionPlaceholderYoutube: "nazwa_kanalu",
      socialNetDescriptionPlaceholderLinkedin: '"in/name" lub "company/name"',
      socialNetDescriptionPlaceholderWhatsapp: "+15555551234",

      addNewSectionEmptyPage: "Strona tekstowa",
      csanyMakeImpasse: "Zrób ślepy zaułek",
      impaseIsImpaseTrue: "Włączony",
      impaseIsImpaseFalse: "Wyłączony",
      defaultNewEmptyQuestionDescription: "Tutaj możesz wklejać i formatować długi tekst (nie zalecamy wklejania tekstu dłuższego niż 3000 znaków).",
      cSettingsSettingQuizTimezoneTitle: "Strefa czasowa quizu",
      cSettingsSettingQuizTimezoneDescription: "Wprowadź strefę czasową, według której będzie rejestrowany czas wypełniania leadów. Jest to szczególnie przydatne, gdy Ty znajdujesz się w jednej strefie czasowej, a klient w innej. W takim przypadku możesz ustawić strefę czasową klienta, a w leadach, które otrzymasz, czas będzie podawany zgodnie z jego strefą czasową.",
      cSettingsSettingQuizTimezonePlaceholder: "Strefa czasowa",
      userAdditionalSettingsTimezone: "Strefa czasowa użytkownika",
      userAdditionalSettingsTimezonePlaceholder: "Strefa czasowa",
      langHE: "Hebrajski",
      langCS: "Czeski",
      cintegrationCAPIFBInstruction: "Aby skonfigurować integrację z Facebook Conversion API, należy wprowadzić identyfikator piksela i token dostępu. Te dane można uzyskać w ustawieniach Facebook Business Manager. Po wprowadzeniu wymaganych informacji zapisz integrację.",
      cintegrationCAPIFBInstructionTextTitle: "Nazwy zdarzeń dla FB Conversions:",
      cintegrationCAPIFBInstructionTextStart: " – odwiedziny strony startowej;",
      cintegrationCAPIFBInstructionTextQuestionN: " – odwiedziny kroku N (numer kroku jest wstawiany dynamicznie);",
      cintegrationCAPIFBInstructionTextOpenContactPage: " – odwiedziny strony kontaktowej;",
      cintegrationCAPIFBInstructionTextLead: " – pomyślne wysłanie formularza kontaktowego;",
      cintegrationCAPIFBInstructionTextThankYou: " – odwiedziny strony końcowej.",
      cintegrationCAPIFBInstructionTextOptimizationAdvice: "Zalecamy uruchamianie reklam zoptymalizowanych pod zdarzenie",
      cintegrationCAPIFBInstructionTextLeadTriggerCondition: "To zdarzenie jest wysyłane",
      bold_capi_adsquiz_Start: "capi_adsquiz_Start",
      bold_capi_adsquiz_QuestionN: "capi_adsquiz_Question-N",
      bold_capi_adsquiz_OpenContactPage: "capi_adsquiz_OpenContactPage",
      bold_capi_adsquiz_Lead: "capi_adsquiz_Lead",
      bold_capi_adsquiz_ThankYou: "capi_adsquiz_ThankYou",
      bold_capi_adsquiz_OptimizationAdvice: "“capi_adsquiz_Lead”.",
      bold_capi_adsquiz_LeadTriggerCondition: " tylko wtedy, gdy użytkownik pomyślnie prześle zgłoszenie.",
      csettingsIntegrationFbCapiAbout: "Integracja z Facebook Conversion API umożliwia przesyłanie danych o interakcjach użytkowników bezpośrednio do Facebooka w celu zwiększenia skuteczności kampanii reklamowych.",
      cintegrationInputCapiAccessToken: "Wprowadź token dostępu",
      cintegrationInputCapiCustomparameter: "Wprowadź niestandardowe parametry zdarzeń",
      cintegrationDataFbCapiSaved: "Integracja z Facebook Conversion API została pomyślnie zapisana",
      cintegrationComonRenovateHubInstructionTitle: "Instrukcja konfiguracji integracji z «Міністерство Ремонту»",
      cintegrationComonRenovateHubInstructionDescription1: "Aby skonfigurować integrację z „Ministerstvo Remontu”, podaj URL webhooka, na który będą wysyłane dane.",
      cintegrationComonRenovateHubInstructionDescription2: "W tym celu przejdź do „Panelu administracyjnego”, następnie otwórz sekcję „Integracje” i wybierz ADS Quiz. Kliknij „Utwórz webhook URL”, skopiuj go i wklej w polu wprowadzania poniżej w usłudze ADS Quiz.",
      cintegrationComonRenovateHubInstructionDescription3: "Następnie przejdź quiz w celu testowania lub wyślij testowy lead za pomocą przycisku „Test”.",
      cintegrationComonRenovateHubInstructionDescription4: "Na końcu zapisz i aktywuj integrację. Wszystkie leady będą trafiać do „Ministerstvo Remontu” w sekcji „Zapytania”.",
      cintegrationComonRenovateHubInstructionShort: "Integracja z «Міністерство Ремонту» pozwala na przesyłanie danych do CRM przez webhook w celu automatyzacji procesów.",
      cintegrationRenovateHubUrl: "Wprowadź URL «Міністерство Ремонту»",
      cintegrationInputRenovateHubUrl: "Podaj URL webhooka dla «Міністерство Ремонту»",
      cintegrationRenovateHubDataSaved: "Integracja z «Міністерство Ремонту» została pomyślnie zapisana",
      cintegrationDataRenovateHubError: "Błąd podczas zapisywania integracji z «Міністерство Ремонту». Sprawdź poprawność wprowadzonych danych.",
      cintegrationMenuFacebookConvAPI: "Facebook Conversions API",
      cintegrationMenuRenovateHub: "Міністерство Ремонту",
      csettingsIntegrationRenovateHub: "Integracja z «Міністерство Ремонту»",
      csettingsIntegrationCAPIFB: "Integracja Facebook Conversions API",
      paymentPlanEnd: "Data wygaśnięcia taryfy",
      paymentPlanNextPayment: "Następna płatność",
      paymentPlanLeadsLimitForYear:"Limit leadów na rok:",
      paymentPlanLeadsLimitForPeriod:"Limit leadów na okres:",
      EditTags: "Edytuj tagi",
      quizzesTemplatesNoTags: "Brak tagów",

      Monday: "Poniedziałek",
      Tuesday: "Wtorek",
      Wednesday: "Środa",
      Thursday: "Czwartek",
      Friday: "Piątek",
      Saturday: "Sobota",
      Sunday: "Niedziela",
      datetimeDisplayMode: "Typ wybierania",
      datetimeDisplayModeSelect: "Wybierz typ",
      datetimeDisplayModeDate: "Data",
      datetimeDisplayModeTime: "Godzina",
      datetimeDisplayModeDatetime: "Data i godzina",
      datetimeMinDate: "Min. data",
      datetimeMinDateCustom: "Wybierz min. datę",
      datetimeMaxDate: "Maks. data",
      datetimeMaxDateCustom: "Wybierz maks. datę",
      datetimeProhibitDaysOfWeek: "Zablokuj dni",
      datetimeIsRange: "Włącz zakres",
      datetimeIsRangeTrue: "Zakres włączony",
      datetimeIsRangeFalse: "Zakres wyłączony",
      datetimeMinTime: "Min. godzina",
      datetimeMaxTime: "Maks. godzina",
      datetimeIs24: "Format 24 godz.",
      datetimeIs24True: "24 godz. włączone",
      datetimeIs24False: "24 godz. wyłączone",
      csanyIsExactDate: "Jak chcesz ustawić datę",
      csanyIsExactDateTrue: "Dokładna data",
      csanyIsExactDateFalse: "Data względna",
      csanyDatetimeMinMaxNotExactPlaceholder: '"x" lub "-x" dni od dzisiaj',
      addNewSectionDatetime: "Data/godzina",
      tariffsPromo: "Oferty promocyjne",
      pricingComparisonEyebrow: 'Cennik Adsquiz',
      pricingComparisonTitle: 'Wybierz jeden z naszych planów',
      pricingComparisonMobileHint: 'Przewiń karty planów i wybierz dwa poniżej, aby je porównać.',
      pricingComparisonTableAria: 'Pricing plans comparison table',
      pricingComparisonMonthShort: 'miesiąc',
      billingPromoPeriodYearly: "rok",
      billingPromoPeriodMonths: "{count} miesięcy",
      billingPromoDescription: "Bez ograniczeń w quizach i funkcjach",
      pricingComparisonTryFree: 'Wypróbuj za darmo',
      pricingComparisonGetStarted: 'Ulepsz',
      pricingComparisonCurrentPlan: 'Twój plan',
      pricingComparisonBuyAgain: 'Kup ponownie',
      pricingComparisonLeadsPerMonth: '{count} leadów /miesiąc',
      pricingComparisonUnlimited: 'Bez limitu',
      pricingComparisonTeamUsers: '+{n} użytkownik | +{n} użytkowników',
      pricingComparisonRequired: 'Wymagane',
      pricingComparisonOptional: 'Opcjonalnie',
      tariffsMonth: "Miesięczny",
      tariffsAnual: "Rocznie",
      leadsOn1Month: "na miesiąc",
      leadsOn2Month: "na 2 miesiące",
      leadsOn3Month: "na 3 miesiące",
      leadsOn4Month: "na 4 miesiące",
      leadsOn5Month: "na 5 miesięcy",
      leadsOn6Month: "na 6 miesięcy",
      leadsOn7Month: "na 7 miesięcy",
      leadsOn8Month: "na 8 miesięcy",
      leadsOn9Month: "na 9 miesięcy",
      leadsOn10Month: "na 10 miesięcy",
      leadsOn11Month: "na 11 miesięcy",
      leadsOn12Month: "na rok",
      leadsOn24Month: "na 2 lata",
      leads: "leadów",
      tariffsWordPrice: "Cena",
      tariffsNoLimits: "Brak ograniczeń",
      tariffsNoLimitsQuizzes: "dotyczących quizów",
      tariffsAndFunctions: "i funkcjonalności",
      billingTariffYear: "rok",
      billingChangePlanSubscribe: "Zapisać się",
      paymentAllTariffInactive: "Taryfa nie jest aktywna",
      subscriptionTariffLableOnly: "Dostępne wyłącznie w ramach subskrypcji",
      notExactBeforeYear: "rok temu",
      notExactBeforeHalfYear: "pół roku temu",
      notExactBeforeQuarter: "kwartał temu",
      notExactBeforeMonth: "miesiąc temu",
      notExactBeforeWeek: "tydzień temu",
      notExactBeforeYesterday: "przedwczoraj",
      notExactYesterday: "wczoraj",
      notExactToday: "dzisiaj",
      notExactTomorrow: "jutro",
      notExactAfterTomorrow: "pojutrze",
      notExactAfterWeek: "za tydzień",
      notExactAfterMonth: "za miesiąc",
      notExactAfterQuarter: "za kwartał",
      notExactAfterHalfYear: "za pół roku",
      notExactAfterYear: "za rok",
      tipDefaultDateHeader: "Domyślnie",
      tipDefaultDateText: "Jeśli oba przełączniki 'Dokładna data' i 'Data względna' są wyłączone, kalendarz pozwoli na wybór dat w zakresie od roku 1800 do 2200 domyślnie.",
      tipExactDateHeader: "Przełącznik dokładnej daty",
      tipExactDateText: "Włączenie tego przełącznika ograniczy kalendarz do stałego zakresu dat zdefiniowanego przez daty wybrane w poniższych polach wejściowych.",
      tipRelativeDateHeader: "Przełącznik daty względnej",
      tipRelativeDateText: "Włączenie tego przełącznika dynamicznie ustawi ograniczenia kalendarza na podstawie dat względnych obliczanych w momencie ładowania strony. Te ograniczenia są personalizowane i obliczane na nowo dla każdego użytkownika indywidualnie.",
      langPT: "Portugalski",
      placeholderCompanyContactText: 'Na przykład: "Telefon: +480993322211"',
      integrationConnectService: "Połącz",
      Connect: "Połącz",
      Connected: "Połączono",
      Disconnect: "Rozłącz",
      cintegrationOauthDisconnectModalTitle: "Rozłączyć {provider}?",
      cintegrationOauthDisconnectModalDescription: "Rozłączenie {provider} odłączy tę integrację od WSZYSTKICH quizów. Jeśli chcesz wyłączyć ją tylko w tym quizie, usuń integrację poniżej.",
      cintegrationOauthDisconnectModalDescriptionBase: "Rozłączenie {provider} odłączy tę integrację od WSZYSTKICH quizów.",
      cintegrationOauthDisconnectModalDescriptionDeleteHint: "Jeśli chcesz wyłączyć ją tylko w tym quizie, usuń integrację poniżej.",
      cintegrationOauthDisconnectDeleteQuizOnly: "Usuń tylko w tym quizie",
      cintegrationOauthDisconnectAllQuizzes: "Rozłącz we wszystkich quizach",
      leadtype_id: "Typ akcji",
      selectVariant: "Wybierz",
      sfirstAddCompanyContacts: "Tekst z kontaktami",
      addNewSectionTextarea: "Duże pole tekstowe",
      allstepsVariantView: "Format obrazu",
      tariffsDiscountSave: "Zaoszczędź",
      cAdminSettingsTitle: "Ustawienia administracyjne",
      cAdminSettingsInstruction: "Wpisz w polu poniżej tagi dla quizu. Tagi mogą składać się z kilku słów, każdy tag oddzielany jest przecinkiem. Tagi 'Usługi' i 'usługi' to różne tagi. Warto używać tagów rozpoczynających się wielką literą. Można również wykluczyć quiz z listy szablonów.",
      cAdminSettingsIsTemplate: "Czy to jest szablon",
      cIsTemplateStateAreSaved: "Stan szablonu został zapisany",
      sfirstAddLogotype: "Dodaj logo",
      logotypeSizeTip: "Logo zostanie wstawione w rzeczywistym rozmiarze, ale nie większym niż 120 pikseli po dłuższym boku.",
      cfirstLogotypeUpdated: "Logo zostało dodane",
      cfirstLogotypeDeleted: "Logo zostało pomyślnie usunięte!",


      cOffersPageSettings: "Ustawienia",
      offerPageTitlePlaceholder: "Wprowadź tytuł",
      offerPageDescriptionPlaceholder: "Wprowadź opis strony",
      offerPageButtonTextPlaceholder: "Wprowadź tekst przycisku (opcjonalnie)",
      allstepsOffers: "Lista ofert",
      offerProposalHeader: "Oferta",
      offerAttachAddImg: "Dodaj obraz",
      offerAttachAddVideo: "Dodaj wideo",
      offerItemImg: "Obraz",
      offerItemTitle: "Tytuł oferty",
      offerTitlePlaceholder: "Wprowadź tytuł tutaj",
      offerItemSubtitle: "Podtytuł (np. cena)",
      offerSubtitlePlaceholder: "Wprowadź tekst tutaj",
      offerItemDescription: "Opis oferty",
      offerDescriptionPlaceholder: "Wprowadź opis tutaj",
      offerItemButtonText: "Tekst przycisku oferty",
      offerBtnTextPlaceholder: "Wprowadź tekst przycisku",
      offerItemButtonLink: "Link do przycisku",
      offerBtnLinkPlaceholder: "Link powinien zaczynać się od https://",
      csanyOfferLogic: "Logika wyświetlania",
      offerAddNewOffer: "Dodaj nową ofertę",
      offerLogicSetupTitle: "Ustawienia logiki",
      OfferLogicSetupDescription: "Tutaj możesz ustawić, które odpowiedzi wyświetlają określone oferty",
      cstepsOffersPage: "Strona wyników",
      addNewSectionResultsByLogic: "Oferty",
      cformActionAfterContactOffersOr: "Strona z ofertami / ",
      tolltipOffersAfterContact: "Jeśli po ukończeniu quizu zostanie spełniona logika wyświetlania przynajmniej jednej oferty, zostanie wyświetlona strona z ofertami, w przeciwnym razie - strona podziękowania.",
      videoCircleTextQuestion: "Instrukcja wideo",
      offerPhotoOptimalRatio: "Aby uzyskać optymalne wyświetlanie obrazu, zalecamy stosowanie proporcji 16:9.",
      tolltipThankYouAfterContact: "Po zakończeniu quizu zostanie wyświetlona strona podziękowania.",
      cformActionAfterContactOffers: "Strona wyników",
      addOfferPageInContact: "Włącz stronę wyników",
      offerPageHeader: "Nagłówek dla strony ofert",
      pumkinOrange: "Pomarańczowy",
      invalidSocialNetworkURL: "Nieprawidłowy link", 
      itMustBeFullLink: 'Sprawdź poprawność wprowadzonego linku. Powinien zaczynać się od protokołu "https://" i odpowiadać zapisanej sieci społecznościowej.',
      addSocialLinks: "Dodaj linki społecznościowe",
      questionAttachAddImg: "Zdjęcie",
      questionAttachAddVideo: "Wideo",
      questionChooseLineInput: "Linia",
      questionChooseClassicInput: "Klasyczne",
      questionChooseOneColumn: "1 kolumna",
      questionChooseTwoColumns: "2 kolumny",
      allStepsVideoUrl: "Link do wideo",
      allStepsPhotoHeader: "Zdjęcie",
      cintegrationMenuSalesDrive: "SalesDrive",
      csettingsIntegrationSalesDrive: "Integracja - SalesDrive",
      csettingsIntegrationSalesDriveAbout: "Możesz wysyłać leady do CRM SalesDrive",
      cintegrationSalesDriveApiKey: "Wstaw klucz API",
      cintegrationSalesDriveDomain: "Wstaw domenę dostarczoną przez SalesDrive",
      cintegrationSalesDriveDataSaved: "Integracja z SalesDrive została zapisana",
      send_offers: "Wysyłaj oferty wyświetlone odwiedzającemu",
      cformShowConsultant: "Pokaż konsultanta",
      consultantPhoto: "Zdjęcie konsultanta",
      consultantName: "Imię konsultanta",
      consultantJobTitle: "Stanowisko konsultanta lub inne informacje",
      consultantRating: "Ocena konsultanta",
      signinIWouldLikeReciveEmail: "Chcę otrzymywać wiadomości i oferty specjalne od ADS QUIZ (Możesz zrezygnować z tych wiadomości w dowolnym momencie).",
      acceptedFileSizeUpTo: "do",
      customDesignColorTags: "Tagi",
      customDesignColorActiveButton: "Kolor aktywnego elementu",
      customDesignColorInactiveButton: "Kolor nieaktywnego elementu",
      customDesignColorActiveText: "Kolor aktywnego tekstu",
      customDesignColorInactiveText: "Kolor nieaktywnego tekstu",
      addNewSectionDropdown: "Dropdown",
      addNewSectionRatePage: "Strona ocen",
      langFR: "Francuski",
      bold_adsquiz_Offers_page: "adsquiz_Open-Offers-Page",
      cintegrationFBInstructionTextOffersPage: "Przejdź do strony ofert",
      defaultNewQuestionDropdownPlaceholder: "Kliknij tutaj, aby otworzyć listę opcji",
      allStepsVideoUrlPlaceholder: "https://youtube, vimeo lub wistia",
      addListOfAnswersButton: "Dodaj wiele",
      addListOfAnswersTitle: "Masowe dodawanie opcji odpowiedzi",
      addListOfAnswersInstruction: "Wklej listę opcji odpowiedzi do tego pola, aby je dodać. Opcje mogą być oddzielone nowymi liniami [↵], średnikami [;], przecinkami [,] lub spacjami [ ]. Podział następuje według separatora o najwyższym priorytecie: [↵] → [;] → [,] → [ ].",
      addListOfAnswersPlaceholder1: "Odpowiedź 1",
      addListOfAnswersPlaceholder2: "Odpowiedź 2",
      addListOfAnswersSendButton: "Dodaj",
      addNewPerson: "Dodaj uczestnika",
      cfirstGradientOverlay: "Nakładka gradientowa tła",
      cfirstGradientOverlayTip: "Nakładka gradientowa tła jest przydatna, jeśli obraz tła ma słaby kontrast z kolorem tekstu.",
      cfirstContentBorder: "Oddzielająca ramka treści",
      workboardDuplicateToOthers: "Skopiuj na inne konto",
      workboardDuplicateAndTransferQuiz: "Duplikuj quiz na inne konto",
      workboardDuplicateAndTransferQuizHintTitle: "Podczas duplikowania quizu zostanie on skopiowany na konto odbiorcy jako szablon.",
      workboardDuplicateAndTransferQuizHintTitleSecond: "Quiz na koncie odbiorcy będzie pusty, bez leadów i integracji. Aktualny quiz pozostanie bez zmian. Aby skopiować quiz na inne konto, jeden z użytkowników musi mieć dowolne ",
      workboardDuplicateAndTransferQuizConfirm: "Duplikuj",
      workboardDuplicateAndTransferQuizStatus200: "Quiz został pomyślnie skopiowany na konto:",
      delOffersPageQuestionForModalConfirm: "Czy na pewno chcesz usunąć stronę z ofertami?",
      offerPageDefaultDescription: "Wpisz tutaj opis strony z wynikami",
      offerPageDefaultButtonText: "Zakończ",
      cintegrationMenuKommo: "Kommo",
      csettingsIntegrationKommo: "Integracja - Kommo",
      csettingsIntegrationKommoAbout: "Możesz wysyłać leady do CRM Kommo",
      cintegrationKommoToken: 'Wstaw "Long-lived Token"',
      cintegrationKommoDomain: "Wstaw swój subdomenę",
      cintegrationKommoDataSaved: "Integracja Kommo została zapisana",
      cintegrationKommoPipelineId: "Wstaw PipelineID",
      cintegrationKommoPipelineIdPlaceholder: "Wybierz lejek",
      cintegrationKommoStatusID: "Wstaw StatusID",
      cintegrationKommoStatusIDPlaceholder: "Wybierz status nowego leada (opcjonalnie)",
      cintegrationKommoTagId: "Wstaw TagID",
      cintegrationKommoTagIdPlaceholder: "Wybierz tag dla nowego leada (opcjonalnie)",
      cintegrationKommoError: "Błąd podczas zapisywania integracji Kommo. Sprawdź poprawność wprowadzonych danych.",
      cintegrationKommoDeleted: "Integracja Kommo została usunięta",
      cintegrationKommoDeletedError: "Błąd podczas usuwania integracji Kommo",
      cintegrationKommoCreateNote: "Tworzyć notatkę z odpowiedziami",
      cintegrationKommoUseMapping: "Używać mapowania pól",
      mappingValue: "Pole w CRM",
      mappingValueMailchimp: "Pole w Mailchimp",
      mappingKey: "Pole w leadzie",
      addMappingRow: "Dodaj powiązanie pól",
      DELETE: "Usuń",
      mappingAnswer: "Odpowiedź na pytanie",
      testIntegration: "Test",
      testIntegrationLast10Leads: "Test integracji (ostatnie 10 leadów)",
      testIntegrationNeedRealLeadTooltip: "Test jest dostępny tylko wtedy, gdy quiz ma co najmniej jednego prawdziwego leada.",
      loading: "Ładowanie...",
      sentAt: "Wysłano",
      phone: "Telefon",
      email: "Email",
      action: "Działanie",
      send: "Wyślij",
      sending: "Wysyłanie...",
      success: "Sukces",
      failed: "Niepowodzenie",
      error: "Błąd",
      displayCondition: "Warunek wyświetlania",
      selectDisplayCondition: "Wybierz warunek wyświetlania",
      seconds: "Sekundy",
      button: "Przycisk",
      buttonContainerSelector: "Selektor kontenera przycisku",
      buttonContainerSelectorPlaceholder: ".quiz-buttons lub #quiz-button-place",
      clickHere: "Kliknij tutaj",
      buttonClick: "Kliknięcie przycisku",
      clickOnWidget: "Kliknięcie widżetu",
      exitIntent: "Przy opuszczeniu strony",
      pageLoad: "Po załadowaniu strony",
      delay: "Po pewnym czasie",
      resultPageSectionTitle: "Wyniki według punktów",
      resultPageSectionAccordion: "Strona wyników według punktów",
      resultPageShowCondition: "Pokaż warunek",
      resultPageShowCollectedPoints: "Pokaż zdobyte punkty",
      resultPageShowMaxPoints: "Pokaż maksymalne punkty",
      resultPageShowProgressBar: "Pokaż pasek postępu",
      resultPageSelectFormat: "Wybierz format wyniku",
      resultPageScenarios: "Scenariusze",
      resultPageAddScenario: "Dodaj scenariusz",
      resultPageScenarioPhoto: "Dodaj zdjęcie",
      resultPageScenarioTitle: "Tytuł",
      resultPageScenarioTitlePlaceholder: "Wpisz tytuł scenariusza",
      resultPageScenarioDescription: "Opis",
      resultPageScenarioDescriptionPlaceholder: "Wpisz opis scenariusza",
      resultPageScenarioUrlPlaceholder: "Link (https://)",
      resultPageScenarioButtonText: "Tekst przycisku",
      resultPageScenarioButtonTextPlaceholder: "Wpisz tekst przycisku",
      resultPagePointsCondition: "Warunek wyświetlania według punktów",
      resultPagePointsBetween: "Pomiędzy",
      resultPagePointsMoreThan: "Więcej niż",
      resultPagePointsLessThan: "Mniej niż",
      resultPagePointsEqual: "Równe",
      resultPageErrorAddNewScenario: "Nie udało się dodać scenariusza",
      resultPageErrorRangeExplanation: "Dodaj więcej punktów lub rozdziel je między scenariusze",
      resultPageErrorFullRange: "Wszystkie zakresy punktów są już pokryte",
      resultPageErrorOutOfRange: "Punkty są poza dozwolonym zakresem",
      resultPageErrorSaving: "Błąd zapisywania scenariuszy",
      resultPageErrorOverlap: "Punkty w scenariuszach nie mogą się nakładać",
      resultPageAutoRedirectWarningTitle: "Automatyczne przekierowanie wyłączone",
      resultPageAutoRedirectWarningText: "Aby włączyć automatyczne przekierowanie, dodaj URL w każdym scenariuszu wyniku.",
      resultPageAutoRedirectWarningButton: "OK",
      AddTags: "Dodaj tagi",
      resultPageModalDescription: "Przypisz punkty za każdą odpowiedź",
      resultPageYourOptions: "Twoje opcje",
      placeholderDefaultValue: "Wartość",
      resultPageByPointsTitle: "Wyniki według punktów",
      resultPageConditionSettingsButton: "Logika punktów",
      resultPageConditionSettingsSaved: "Zapisano",
      resultPageConditionSettingsUnsaved: "Zapisz",
      resultPagePlaceholderScenarioTitle: "Tytuł scenariusza",
      resultPagePlaceholderScenarioDescription: "Tutaj możesz wprowadzić krótki opis wyników",
      resultPageLabelScenarioCti: "Wezwanie do działania",
      resultPagePlaceholderScenarioCti: "Tekst przycisku",
      resultPagePlaceholderScenarioUrl: "Link przycisku",
      resultPagePlaceholderRedirectUrl: "Link przekierowania",
      resultPageScenarioSaveChanges: "Zapisz zmiany",
      resultPageScenarioSaveChangesComplete: "Zmiany zapisane",
      resultPageConditionSettingsTitle: "Ustawienia wyników według punktów",
      resultPageConditionSettingsDescription: "Ustaw zakres punktów dla każdego scenariusza",
      resultPageConditionResultsColumn: "Wyniki",
      resultPageConditionRangeSummary: "Maksymalny zakres punktów:",
      addNewSectionSubHeaderChoise: "Wprowadzanie/wybór odpowiedzi",
      addNewSectionSubHeaderResults: "Wyniki",
      noTeamRole: "-",
      viewerTeamRole: "Podglądający",
      noAccessTeamRole: "Brak działań",
      editorTeamRole: "Edytor",
      managerTeamRole: "Menedżer",
      adminTeamRole: "Administrator",
      teamRoleGuideTitle: "Co oznaczają role",
      teamRoleGuideDescription: "Rola automatycznie włącza zestaw uprawnień. Po wyborze rola od razu aktualizuje się w interfejsie, a Send wysyła wybrany dostęp.",
      teamRoleGuideFlowOwner: "Właściciel",
      teamRoleGuideFlowOwnerText: "przyznaje dostęp",
      teamRoleGuideFlowRole: "Rola",
      teamRoleGuideFlowRoleText: "wybiera szablon",
      teamRoleGuideFlowPermissions: "Uprawnienia",
      teamRoleGuideFlowPermissionsText: "włączają akcje",
      teamRoleGuideFlowResult: "Dostępny interfejs",
      teamRoleGuideFlowResultText: "odblokowuje elementy",
      teamRoleGuideViewerDescription: "Może przeglądać leady i odpowiedzi w wybranych quizach.",
      teamRoleGuideEditorDescription: "Może edytować quiz, kopiować go i zarządzać publikacją.",
      teamRoleGuideManagerDescription: "Może edytować quiz, widzieć CRM, zarządzać integracjami i dalej udostępniać dostęp.",
      teamRoleGuideAdminDescription: "Otrzymuje wszystkie uprawnienia: zarządzanie, integracje, CRM, dostępy, transfer, usuwanie i publikację.",
      canViewLeadsLabel: "Podgląd leadów",
      canViewLeadsDescription: "Może przeglądać zgłoszenia, odpowiedzi i kontakty",
      canCopyQuizLabel: "Kopiowanie quizu",
      canCopyQuizDescription: "Może tworzyć kopie wybranego quizu",
      canManageQuestionsLabel: "Edycja quizu",
      canManageQuestionsDescription: "Może edytować quiz, strony, pytania, warianty, konsultantów, benefity, pola kontaktowe, sieci społecznościowe i options",
      canManageIntegrationsLabel: "Integracje",
      canManageIntegrationsDescription: "Może zarządzać integracjami, kluczami i webhookami",
      canManageSettingsLabel: "Ustawienia",
      canManageSettingsDescription: "Może zmieniać domeny, strony i pola kontaktowe",
      canShareLabel: "Dostępy",
      canShareDescription: "Może zapraszać innych użytkowników",
      canTransferLabel: "Przekazanie quizu",
      canTransferDescription: "Może przekazać quiz innemu użytkownikowi",
      canDeleteLabel: "Usuwanie",
      canDeleteDescription: "Może usuwać i przywracać quiz",
      canPublishLabel: "Publikacja",
      canPublishDescription: "Może zarządzać publikacją i domenami",
      descriptionTeamView: "Dodaj uczestników i skonfiguruj dostępy do projektów oraz quizów",
      addedUserInTeam: "W zespole",
      teamAccessGivenTab: "Członkowie zespołu",
      teamAccessReceivedTab: "Źródło dostępu",
      teamAccessReceivedTitle: "Dostęp przyznany Tobie",
      teamAccessSharedBy: "Właściciel",
      teamAccessInvitedBy: "Zaprosił",
      teamAccessRoleLabel: "Rola",
      teamAccessScopeLabel: "Dostęp",
      teamNoReceivedAccess: "Nikt jeszcze nie dał Ci dostępu",
      teamNoGivenAccess: "Nie przyznałeś jeszcze nikomu dostępu",
      teamAccessFrozen: "Dostęp zamrożony",
      teamFreezeAccess: "Zamroź dostęp",
      teamUnfreezeAccess: "Odmroź dostęp",
      teamPermissionDeniedTransfer: "You do not have permission to move this quiz",
      teamPermissionDeniedDelete: "You do not have permission to delete or restore this quiz",
      teamPermissionDeniedShare: "You do not have permission to manage sharing",
      teamPermissionDeniedManageQuiz: "You do not have permission to edit this quiz",
      teamPermissionDeniedCopy: "You do not have permission to copy this quiz",
      teamPermissionDeniedIntegrations: "You do not have permission to manage integrations",
      teamPermissionDeniedCrm: "You do not have permission to view CRM",
      teamPermissionDeniedPublish: "You do not have permission to publish this quiz",
      teamPermissionDeniedSettings: "You do not have permission to open this settings section",
      teamPermissionDeniedOpenQuiz: "You do not have available actions for this quiz",
      teamAccessDeniedTitle: "Section unavailable",
      teamAccessDeniedDescription: "You do not have permission for this action. Ask the project owner to grant access",
      teamPermissionDeniedDefault: "You do not have permission for this action",
      teamQuizzesWithoutProject: "Quizzes without project",
      quickInviteTitle: "Zaproś członka zespołu",
      quickInviteEmailLabel: "E-mail",
      quickInviteQuizzesLabel: "Quizy do udostępnienia",
      quickInviteLoadingQuizzes: "Ładowanie quizów…",
      quickInviteLoadQuizzesError: "Nie udało się załadować quizów.",
      quickInviteRetry: "Spróbuj ponownie",
      quickInviteNoQuizzes: "Nie masz jeszcze quizów, które możesz udostępnić.",
      quickInviteRoleHint: "Osoba otrzyma wybraną rolę w wybranych quizach. Możesz ją później zmienić na {link}.",
      quickInviteRoleHintLink: "stronie Zespół",
      quickInviteSubmit: "Zaproś",
      quickInviteSubmitting: "Wysyłanie…",
      quickInviteSelfError: "Nie możesz zaprosić samego siebie",
      quickInviteSelectQuiz: "Wybierz co najmniej jeden quiz",
      quickInviteSuccess: "Zaproszenie wysłane do {email}",
      projectNoQuizzes: "0 quizów",
      quizzes: "quizów",
      sharedQuizzes: "Udostępnione quizy",
      sharedQuizzesWithoutProject: "Quizy bez projektu",
    },
    ES: {
      tariffLockBadgeLabel: "Pro",
      tariffLockBadgeReadOnlyLabel: "Solo lectura",
      tariffLockBadgeQuotaLabel: "Límite alcanzado",
      tariffLockBadgeAriaLabel: "{label}: función restringida por tu plan",
      tariffUpgradeActionLabel: "Mejorar plan",
      tariffLockBadgeOwnerAriaLabel: "{label}: función restringida por el plan del propietario del quiz",
      tariffOwnerPlanFeatureUnavailableMessage: "Esta función no está disponible en el plan del propietario del quiz. Pide al propietario que cambie a un plan que la incluya.",
      tariffOwnerAccessUnavailableMessage: "No pudimos comprobar el plan del propietario del quiz. Actualiza la página.",
      tariffGateCollaborationForbiddenMessage: "No tienes permiso para realizar esta acción en este quiz.",
      tariffGateQuotaExhaustedMessage: "Has agotado el límite incluido en tu plan actual. Mejora a un plan con mayor límite.",
      tariffGateGrandfatheredMessage: "Esta función no está disponible en tu plan actual. Los datos existentes siguen visibles y se pueden eliminar, pero añadir o editar está deshabilitado. Mejora a un plan que la incluya.",
      tariffGateReadOnlyMessage: "Esta función no está disponible en tu plan actual y se muestra en modo solo lectura. Mejora a un plan que la incluya.",
      tariffGateUsageUnavailableMessage: "No pudimos determinar el uso de esta función. Intenta actualizar la página.",
      tariffGateLoadingMessage: "Comprobando el acceso de tu plan…",
      tariffGateUnavailableMessage: "Esta función no está disponible en tu plan actual. Mejora a un plan que la incluya.",
      tariffUpgradeModalDescription: "Elige un plan que incluya esta función.",
      tariffUpgradeModalLoading: "Cargando planes adecuados…",
      tariffUpgradeModalError: "No se pudieron cargar los planes adecuados. Inténtalo de nuevo.",
      tariffUpgradeModalEmpty: "Las suscripciones anuales estarán disponibles próximamente.",
      tariffUpgradeModalRecommended: "Recomendado",
      tariffUsageUnlimitedLabel: "Ilimitado",
      tariffUsageUsedOfLimitLabel: "{used} de {limit} usados",
      tariffUsageUnavailableLabel: "Uso no disponible",
      tariffUsageLoadingLabel: "Cargando uso…",
      tariffUsageUnknownLabel: "Uso desconocido",
      notFoundEyebrow: 'Página no encontrada',
      notFoundTitle: 'Parece que este quiz se perdió',
      notFoundDescription: 'Puede que el enlace sea incorrecto o que la página se haya movido. Vuelve al panel de trabajo y sigue creando quizzes.',
      notFoundPrimaryAction: 'Ir al inicio',
      notFoundSecondaryAction: 'Volver',
      serverErrorEyebrow: 'Error del servidor',
      serverErrorTitle: 'Algo salió mal',
      serverErrorDescription: 'No te preocupes, ya estamos trabajando en ello. Intenta actualizar la página o vuelve a tu panel de trabajo.',
      serverErrorPrimaryAction: 'Actualizar página',
      serverErrorSecondaryAction: 'Ir al inicio',
      madeInUkr: "Hecho en Ucrania",
      upProVersion: "Cambiar a PRO",
      getLeads: "Obtener clientes potenciales",
      poperBillings: "Facturación",
      poperTemplates: "Plantillas",
      poperPartnership: "Colaboración",
      poperProfile: "Perfil",
      poperLogout: "Cerrar sesión",
      poperTeam: "Equipo",
      teamDelegatedAccessTitle: 'Compartió el acceso después',
      teamAccessTreeRootLabel: 'Fuente de acceso',
      teamAccessVia: 'vía',
      teamNoQuizNamesAvailable: 'Los nombres de los quizzes no están disponibles',
      teamSharedShareTargetPrefix: 'Compartido por',
      teamSharedOwnerFallback: 'propietario',
      teamMembersTab: 'Acceso que concedí',
      teamAccessSourceTab: 'Acceso concedido a mí',
      teamAccessSourceTitle: 'Acceso concedido a mí',
      teamAccessTreeTab: 'Cadenas de acceso',
      teamAccessTreeTitle: 'Cadenas de acceso',
      teamAccessTreeDescription: 'Muestra la ruta de acceso: propietario → quien invita → tú → personas con las que compartiste',
      teamAccessOwnerLabel: 'Propietario',
      teamAccessInviterLabel: 'Compartido por',
      teamAccessPath: 'Ruta de acceso',
      teamAccessYouLabel: 'tú',
      teamSharedByYou: 'Compartido por ti',
      teamCanReshare: 'Puede compartir de nuevo',
      teamCannotReshare: 'No puede compartir de nuevo',
      teamPartialReshare: 'Puede compartir parcialmente',
      teamMixedRoles: 'Roles mixtos',
      teamNoAccessTree: 'Las cadenas aparecerán cuando compartas el acceso',
      poperIdea: "Proponer una idea",
      poperIdeaTitle: "¿Tiene una idea para mejorar la plataforma?",
      poperIdeaText: "¡Compártala con nosotros! Sus sugerencias nos ayudan a mejorar y a ofrecerle una mejor experiencia.",
      poperIdeaTextPlaceholder: "Describa su idea en detalle",
      poperIdeaSendButton: "Enviar propuesta",
      defaultNewQuestion: "Nueva pregunta",
      defaultNewQuestionDescription: "Aquí puede insertar una breve descripción de la pregunta (hasta 80 caracteres)",
      defaultNewVariant: "Nueva opción",
      defaultBtnText: "Comenzar",
      navBillings: "Facturación",
      navPartnership: "Colaboración",
      navProfile: "Perfil",
      navTariffs: "Planes",
      holidayBannerTitleLastOffer: "Oferta final del año:",
      holidayBannerDefaultTitle: "Oferta limitada",
      holidayBannerFrom: "del",
      holidayBannerTo: "al",
      holidayBannerCta: "Obtener descuento",
      holidayBannerAuthTitle: "Inicia sesión para obtener el descuento",
      holidayBannerAuthText: "Accede para aprovechar esta oferta y asociarla a tu cuenta.",
      holidayBannerAuthAction: "Entendido",
      holidayBannerClose: "Cerrar banner",
      welcomeBack: "¡Bienvenido de nuevo!",
      loginHeader: "Iniciar sesión",
      loginHeader2Part: "para continuar",
      loginEmailPlaceholder: "Correo electrónico",
      loginPasswordlPlaceholder: "○ ○ ○ ○ ○ ○ ○ ○ ○",
      loginBtnValue: "Iniciar sesión",
      loginWith: "Iniciar sesión con",
      passwordAreForgetPassword: "¿Olvidaste tu contraseña?",
      passwordResetPasswordHeader: "Restablecimiento de contraseña",
      passwordResetPassword: "Restablecer contraseña",
      passwordWeSentReset: "Siga las instrucciones en el correo que le enviamos para restablecer su contraseña",
      passwordInputNewPassword: "Ingrese una nueva contraseña",
      passwordConfirmPassword: "Confirmar contraseña",
      passwordCreatePassword: "Crear contraseña",
      passwordChangePassword: "Guardar contraseña",
      passwordResetedPasswordCompleted: "¡Su contraseña se ha cambiado con éxito!",
      passwordGoToWorkboard: "Ir al tablero de trabajo",
      loginSignup: "Registrarse",
      helloHeader: "¡Hola!",
      signupHeader: "Registrarse",
      signupHeader2Part: "para continuar",
      signupNamePlaceholder: "Oleksander",
      signupPhonePlaceholder: "número de teléfono",
      signupEmailPlaceholder: "Correo electrónico",
      signupPasswordlPlaceholder: "○ ○ ○ ○ ○ ○ ○ ○ ○",
      signupBtnValue: "Crear una cuenta",
      signupWith: "Registrarse con",
      signupLogin: "Iniciar sesión en una cuenta",
      signupTariffHeader: "Tarifa",
      signupTariffFree: "Gratis.",
      signupTariffPro: "Pro.",
      signupTariffFreeDescription: "Número ilimitado de creación de nuevos cuestionarios (páginas web). Capacidad de generar hasta 300 aplicaciones por mes de forma gratuita.",
      signupTariffProPrice: "$20/mes",
      signupTariffProDescription: "Número ilimitado de creación de nuevos cuestionarios (páginas web). Capacidad de generar ",
      signupTariffProDescriptionBold: "hasta 300 aplicaciones por mes.",
      userBackToQuiz: "Volver al tablero de trabajo",
      userBackToSettings: "Volver a Configuración",
      learningCenterTitle: "Centro de aprendizaje",
      learningCenterTraining: "Formación",
      learningCenterIntroText: "Mire todas las guías de video requeridas en orden, confirme cada lección cuando termine y solicite su certificado después de completar la última lección.",
      learningCenterVideoUnsupported: "Su navegador no admite video HTML5.",
      learningCenterAvailable: "Disponible",
      learningCenterLessonsComplete: "Lecciones completadas",
      learningCenterBackToLearningCenter: "Volver a Learning center",
      learningCenterCertificate: "Certificado",
      learningCenterCourseCompleted: "Curso completado",
      learningCenterCertificateSentText: "Todas las lecciones están completadas. La solicitud de certificado se envió al backend.",
      learningCenterCertificateLabel: "Adsquiz Learning Center",
      learningCenterCertificateOfCompletion: "Certificado de finalización",
      learningCenterDownloadCertificate: "Descargar certificado",
      learningCenterDownloadUnavailable: "Descarga aún no disponible",
      learningCenterOpenCertificate: "Abrir certificado",
      learningCenterAbout: "Sobre la lección",
      learningCenterOpenFallbackLink: "Abrir enlace alternativo",
      learningCenterBack: "Atrás",
      learningCenterCompleted: "Completado",
      learningCenterWatchVideoToEnd: "Mire el video hasta el final",
      learningCenterSaving: "Guardando...",
      learningCenterMarkAsCompleted: "Marcar como completado",
      learningCenterWatchedPercent: "{percent}% visto",
      learningCenterDefaultUserName: "Usuario de Adsquiz",
      learningCenterCertificateReadyMessage: "El backend devolvió un archivo de certificado. Use el botón de arriba para abrirlo.",
      learningCenterCertificatePendingMessage: "La solicitud de certificado fue enviada. Agregue la URL de descarga del backend cuando esté disponible.",
      learningCenterCertificateNoUrlMessage: "La solicitud de certificado se completó, pero aún no se devolvió ninguna URL de archivo.",
      learningCenterCertificateErrorMessage: "La solicitud de certificado aún no pudo confirmarse por el backend. La finalización local está guardada.",
      learningCenterSectionGeneral: "General",
      learningCenterSectionIterationsIntro: "Introducción a iteraciones",
      learningCenterSectionIterationIntro: "Introducción a la iteración",
      billingYourTariff: "Su plan",
      billingYourTariffShortForm: "Su plan",
      billingYourPro: "Pro",
      billingYorFree: "Gratis",
      billingFreeLeads: "Clientes potenciales gratuitos",
      billingInfinity: "ilimitado",
      billingTariffRenewData: "Fecha de renovación de tarifa",
      billingTariffEndData: "Fecha de finalización del plan",
      billingOtherTariffFree: "Gratis.",
      billingOtherTariffPro: "Pro.",
      billingTariffFreeDescription: "Número ilimitado de creación de nuevos cuestionarios (páginas web). Capacidad de generar hasta 300 aplicaciones por mes de forma gratuita.",
      billingYouHavePro: "Si actualmente estás en la versión Pro, ¿por qué dar un paso atrás?",
      billingYouHasFreeLeads: "Clientes potenciales gratuitos",
      billingYouHasLeads: "Leads restantes",
      billingTariffProDescription: "Número ilimitado de nuevos cuestionarios (páginas web). Capacidad de generar ",
      billingTariffProDescriptionBold: "más de 300 aplicaciones.",
      billingYourFutureTariff: "Su plan futuro",
      billingBtnChangeToPro: "cambiar a ",
      billingBtnRenewPro: "Renovar",
      billingBillings: "Facturación",
      billingYouHaveNotBillings: "Aún no tienes pagos",
      billingPaymentsMethod: "Método de pago",
      billingPaymentCard: "Tarjeta",
      billingChangeData: "Cambiar datos",
      billingDeletePayMethod: "Eliminar",
      billingModalDeleteShure: "¿Está seguro de que desea eliminar este método de pago?",
      billingModalDeleteCancel: "Cancelar",
      billingModalDeleteOk: "Eliminar",
      billingModalDeleteSuccess: "Ha eliminado su tarjeta con éxito",
      billingModalRegularPaymentDeleteSuccess: "Los pagos regulares han sido cancelados",
      billingModalRegularPaymentDeleteOk: "Aceptar",
      billingYourMonthPlan: "Su tarifa mensual",
      billingLeads: "clientes potenciales",
      billingChangePlan: "Cambiar la tarifa",
      billingChangePlanDescription: "El precio corresponderá al número deseado de aplicaciones de todos los cuestionarios en su cuenta.",
      billingSelectPeriod: "Seleccionar período",
      billingChangePlanDescriptionImportant: "Importante:",
      billingChangePlanDescriptionImportantMonth: "Los clientes potenciales se pueden usar 1 mes después de la compra.",
      subscriptionTarifLable: "Suscríbase a nuestra suscripción mensual automática. Puede cambiar su plan en cualquier momento.",
      billingChangePlanWarning: "",
      billingTariffMonth: "mes.",
      billingChangePlanPay: "Cambiar el plan",
      profileName: "Nombre",
      profilePhone: "Número de teléfono",
      profileEmail: "Correo electrónico",
      profileStatus: "Estado",
      profileStatusAgency: "Agencia",
      profileStatusPlaceholder: "¿Qué te describe mejor?",
      profileStatusFreelancer: "Freelancer",
      profileStatusBuisines: "Propietario de negocio",
      profilePassword: "Contraseña",
      profileChangePassword: "Cambiar contraseña",
      profileNewPassword: "Nueva contraseña",
      profileSaveNewData: "Actualizar datos",
      workboardStartTooltip: "Aquí puedes crear tu primer cuestionario",
      workboardAddNewQuiz: "Crear proyecto",
      workboardModalGiveQuizName: "Dar un nombre al cuestionario",
      workboardModalQuizNamePlaceholder: "Nuevo cuestionario",
      workboardModalNewQuizBtnValue: "agregar",
      workboardAlertGiveAnyName: "Ingrese cualquier nombre",
      workboardAlertNextTimeAddQuiz: "Bueno, la próxima vez, atrévete)",
      workboardChangeQuizName: "Cambiar el nombre",
      workboardQuizLink: "enlace",
      workboardQuizLinkCopied: "El enlace se copió al portapapeles",
      workboardEditQuiz: "Editar",
      workboardCopyQuiz: "Copiar el cuestionario",
      workboardQuizCopied: "Cuestionario copiado con éxito",
      workboardDeleteQuiz: "Eliminar",
      workboardTransferQuizPlaceholderInput: "Introduce la dirección de correo del usuario",
      workboardTextAllQuizes: "Todos los cuestionarios",
      workboardTextProjects: "Proyectos",
      workboardTransferQuiz: "Transferir el cuestionario a otra cuenta",
      workboardTransferProject: "Agregar al proyecto",
      workboardTransferQuizCancel: "Cancelar",
      workboardTransferQuizLabel: "Título del cuestionario",
      workboardTransferQuizTitle: "¡Pon a prueba tus conocimientos sobre la protección del medio ambiente!",
      workboardTransferQuizHintTitle: "Al transferir el cuestionario, todas las solicitudes se moverán con él.",
      workboardTransferQuizHintTitleSecond: "Para transferir el cuestionario con las solicitudes, uno de los usuarios debe tener cualquier ",
      workboardTransferQuizHintTitleSecondLink: "https://app.adsquiz.io/tariffs",
      workboardTransferQuizHintTitleSecondLinkText: "plan de pago.",
      workboardTransferQuizConfirm: "Transferir",
      workboardTransferQuizNoValidEmail: "Dirección de correo electrónico no válida",
      workboardTransferQuizStatus200: "El cuestionario se ha transferido con éxito a:",
      workboardTransferQuizStatus401: "No autorizado — El usuario no está autenticado.",
      workboardTransferQuizStatus403: "Prohibido — No tienes acceso para transferir este cuestionario.",
      workboardTransferQuizStatus404: "No encontrado — Cuestionario o usuario destinatario no encontrado.",
      workboardTransferQuizStatus422: "Entidad no procesable — Al menos un usuario debe tener una cuenta de pago.",
      workboardTransferQuizStatusError: "Estado de error inesperado",
      workboardModalRemoveQuizTrash: "Este cuestionario se moverá a la papelera y se eliminará permanentemente después de 1 mes.",
      workboardModalRemoveQuizSure: "¿Estás seguro de que quieres mover este cuestionario a la papelera?",
      workboardModalRemoveProjectTrash: "El proyecto y todos sus cuestionarios serán eliminados permanentemente.",
      workboardModalRemoveProjectSure: "¿Está seguro de que desea eliminar este proyecto?",
      workboardModalDeleteQuizCancel: "Cancelar",
      workboardModalDeleteQuizDelete: "Eliminar",
      workboardModalDeleteQuizSuccess: "Ha eliminado este cuestionario con éxito",
      workboardModalDeleteProjectSuccess: "El proyecto se eliminó correctamente",
      workboardModalQuizDeleteOk: "Aceptar",
      workboardStatsTitle: "Estadísticas",
      workboardModalLeadsAnswersCount: "Respuestas a las preguntas",
      workboardModalLeadsLeadSerial: "№",
      workboardModalLeadsLeadDate: "Fecha",
      workboardModalLeadsLeadEmail: "Correo electrónico",
      workboardModalLeadsLeadName: "Nombre",
      workboardModalLeadsLeadPhone: "Teléfono",
      workboardModalLeadsLeadPoints: "Puntos",
      workboardModalLeadsLeadActions: "Acciones",
      workboardModalLeadsLeadShowMore: "Ver más",
      workboardModalLeadsLeadHideMore: "Ocultar",
      workboardModalLeadsLeadAnswerScipped: "Omitido",
      workboardModalNoLeads: "Aún no hay clientes potenciales",
      constructorLink: "enlace",
      constructorLinkCopied: "Copiado al portapapeles:",
      constructorNavSteps: "Pasos",
      constructorNavDesign: "Diseño",
      constructorNavSettings: "Configuración",
      constructorStep: "Paso",
      cancel: "Cancelar",
      constructorCancel: "Cancelar",
      constructorSave: "Guardar",
      constructorextraNavStart: "S",
      constructorextraNavContact: "C",
      constructorextraNavFinish: "F",
      cstepsSection: "Secciones",
      cstepsStartPage: "Página de inicio",
      cstepsContactPage: "Formulario de contacto",
      cstepsFinishPage: "Página final",
      cstepsEdit: "Editar",
      cstepsMove: "Mover",
      cstepsDeleteStep: "Eliminar paso",
      cstepsAddSection: "Agregar sección",
      cdesignColorTheme: "Tema de color",
      cdesignCustomTheme: "Tema de color personalizado",
      cdesignDefaultThemes: "Nuestros temas de color",
      cdesignThemeStandart: "Predeterminado",
      cdesignThemeDark: "Oscuro",
      cdesignThemeNud: "Nude",
      cdesignThemeGradient: "Gradiente",
      cdesignShapeDesign: "Diseño de formulario",
      cdesignShapeRound: "Redondeado",
      cdesignShapeSquare: "Angular",
      cdesignShapeRectangle: "Rectángulo",
      cdesignShapeCircle: "Círculo",
      cdesignPositionLeft: "Izquierda",
      cdesignPositionMiddle: "Medio",
      cdesignPositionRight: "Derecha",
      cdesignPositionTop: "Arriba",
      cdesignPositionBottom: "Abajo",
      csettingsIntegration: "Integración",
      csettingsOweDomain: "Conexión de dominio propio",
      csettingsDocs: "Documentos legales",
      cintegrationIntegration: "Integración",
      cintegrationShareLeads: "Compartir clientes potenciales",
      cintegrationTitleEmail: "CORREO ELECTRÓNICO",
      cintegrationInstruction: "Instrucción",
      cintegrationInstructionDetail: "Detalles",
      cintegrationEmailInstruction: "Envía un correo electrónico a tu encuestado y notifica a tu equipo. Colabora con tu equipo.",
      cintegrationPublishAfterEdit: "Guarde el cuestionario después de editar",
      cintegrationSendNewLeadsTo: "Enviar mensajes sobre nuevos clientes potenciales a:",
      cintegrationInputEmail: "Ingrese correo electrónico",
      cintegrationAddEmail: "Agregar correo electrónico",
      cintegrationEmailSaved: "Correo electrónico guardado",
      cintegrationEmailDeleted: "Correo electrónico eliminado",
      cintegrationTitleFB: "Píxel de FB",
      cintegrationIDPixel: "ID de píxel",
      cintegrationFBInstruction1: "Vaya al administrador de anuncios de Facebook y copie el ID del píxel en la sección del Administrador de Eventos.",
      cintegrationFBInstruction2: "No copie todo el código, solo el ID de 15-16 dígitos.",
      cintegrationFBInstruction3: "Copie y pegue en la casilla de abajo.",
      cintegrationFBInstruction: "El evento para el cual necesita configurar la conversión es 'Lead'. Este evento se activará tan pronto como el usuario envíe una solicitud en el cuestionario.",
      cintegrationFBInstructionTextTitle: "Lista de todos los eventos que enviamos:",
      cintegrationFBInstructionTextTextStart: " – visita a la página de inicio;",
      cintegrationFBInstructionTextQuestionN: " – visita al paso N;",
      cintegrationFBInstructionTextOpenContactPage: " – visita a la página de contacto;",
      cintegrationFBInstructionTextLead: " – envío exitoso del formulario de contacto;",
      cintegrationFBInstructionTextThankYou: " – visita a la página final.",
      bold_adsquiz_Start: "adsquiz_Start",
      bold_adsquiz_QuestionN: "Question_N",
      bold_adsquiz_OpenContactPage: "Open_Contact-Page",
      bold_adsquiz_Lead: "Lead",
      bold_adsquiz_ThankYou: "adsquiz_ThankYou",
      cintegrationInputIDPixel: "Ingrese el ID de píxel",
      cintegrationDataFBSaved: "Datos del píxel de FB guardados",
      cintegrationAccesToken: "TOKEN DE ACCESO",
      cintegrationTitleGA: "Google analytics",
      cintegrationGAInstructionDescription: "Aprenda cómo la gente encuentra e interactúa con su cuestionario. Obtenga los datos que necesita para analizar campañas, mejorar conversiones y más.",
      cintegrationGAInstruction: "Cuando se recibe una aplicación de cuestionario en Google Analytics, se activará el evento 'generate_lead'.",
      cintegrationIDFolow: "ID de seguimiento",
      cintegrationInputID: "Ingrese ID",
      cintegrationDataGASaved: "Datos de Google Analytics guardados",
      cintegrationTitleGTM: "Administrador de etiquetas de Google",
      cintegrationGTMInstructionDescription: "Descripción para el Administrador de etiquetas de Google.",
      cintegrationGTMInstruction: "Copie el ID del Administrador de etiquetas de Google y péguelo en el campo a continuación.",
      cintegrationDataGTMSaved: "Datos del Administrador de etiquetas de Google guardados",
      cintegrationTitleTG: "Telegram",
      cintegrationHowReciveTGLeadBot: "¿Cómo obtener clientes potenciales en Telegram?",
      cintegrationTGInstructionBot1: "1. Copie el token en la entrada de abajo.",
      cintegrationTGInstructionBot2: '2. Siga el enlace al bot y haga clic en el botón "START".',
      cintegrationTGInstructionBot3: "3. Envíe el token copiado como mensaje a nuestro bot.",
      cintegrationHowReciveTGLeadChat: "¿Cómo obtener aplicaciones en el chat de Telegram?",
      cintegrationTGInstructionChat1: "1. Agregue nuestro bot al chat deseado y configúrelo como administrador.",
      cintegrationTGInstructionChat2: "2. Copie el token en el campo de abajo y envíelo al chat deseado.",
      cintegrationTGInstructionChat3: "3. Espere la respuesta `OK! Su token de cuestionario fue guardado!”",
      cintegrationTGInstructionChat4: "4. Los clientes potenciales ahora se enviarán a este chat.",
      cintegrationTGInstructionWarning: "Importante:",
      cintegrationTGInstructionWarningText: "Tenga en cuenta que esto debe ser un grupo, no un canal de Telegram. Los clientes potenciales no se enviarán al canal de Telegram.",
      cintegrationTGBotLink: "enlace del chatbot",
      cintegrationTGTitleToken: "TOKEN",
      cintegrationInputTGToken: "Ingrese el token del chatbot de Telegram",
      cintegrationAddIntegration: "Agregar integración",
      cintegrationDataTGSaved: "Datos de integración de Telegram guardados",
      cintegrationTitleTT: "Píxel de TT",
      cintegrationTTInstruction: "Para rastrear eventos en su cuenta de anuncios de Tik-Tok, copie el ID del píxel y péguelo en el cuadro de abajo.",
      cintegrationDataTTSaved: "Datos del píxel de TT guardados",
      cintegrationTitleWH: "WebHook",
      cintegrationWHInstruction1: "Puede notificar a aplicaciones de terceros sobre los clientes potenciales entrantes. Para hacer esto, especifique la URL a la que se enviará el WebHook.",
      cintegrationWHInstruction2: "Hemos preparado",
      cintegrationWHInstruction3: "instrucción en video",
      cintegrationWHInstruction4: "con una descripción detallada de esta funcionalidad.",
      cintegrationWHInstruction5: "Ver video.",
      cintegrationWHInstruction6: "En este video, veremos cómo pasar un hook basado en enviar datos a una hoja de cálculo de Google y enviar datos a un sistema CRM de Trello.",
      cintegrationWHInstruction7: "Recomendamos utilizar el servicio para este propósito.",
      cintegrationWHInstruction8: "Al registrarse utilizando este enlace, nuestros usuarios obtienen un bono de 10,000 acciones gratuitas para cualquier integración.",
      cintegrationWHInstruction9: "Enlace",
      cintegrationWHInstruction10: "para registrarse con un bono.",
      cintegrationWHUrl: "Las URL del WebHook",
      cintegrationInputWHUrl: "Ingrese la URL del WebHook",
      cintegrationAddWH: "Agregar un WebHook",
      cintegrationWebHookDataSaved: "Datos del WebHook guardados",
      cintegrationComonWHInstructionShort: "Puede notificar a aplicaciones de terceros sobre los clientes potenciales entrantes. Especifique la URL del WebHook para la transmisión de datos.",
      cintegrationComonWHInstruction1Title: "1. Inserte la URL del WebHook en el campo de entrada:",
      cintegrationComonWHInstruction1Description: "Pegue la URL del WebHook proporcionada por su servicio o aplicación en el campo de entrada.",
      cintegrationComonWHInstruction2Title: "2. Guardar cambios:",
      cintegrationComonWHInstruction2Description: 'Haga clic en el botón "Guardar cambios" para guardar la configuración del WebHook.',
      cintegrationComonWHInstruction3Title: "3. Hecho:",
      cintegrationComonWHInstruction3Description: "Ahora su WebHook está configurado para enviar datos al servicio que ha seleccionado.",
      cintegrationComonWHInstructionAdditional: "Los datos se enviarán al WebHook con cada cliente potencial recibido. El método POST se utiliza para la transmisión. Un ejemplo de los datos que se enviarán se encuentra ",
      cintegrationComonWHInstructionAdditionalLink: "aquí",
      cintegrationComonWHInstructionVideo: "Instrucción en video detallada",
      cintegrationApixDriveWHInstructionShort: "Puede notificar a ApixDrive sobre los clientes potenciales entrantes. Para hacer esto, especifique la URL a la que se enviará el WebHook.",
      cintegrationApixDriveWHInstructionShort1: "Al registrarse a través de ",
      cintegrationApixDriveWHInstructionShort2: "este enlace",
      cintegrationApixDriveWHInstructionShort3: " nuestros usuarios reciben un bono de 10,000 acciones gratuitas para cualquier integración.",
      cintegrationApixDriveWHInstruction1Title: "1. Regístrese o abra su cuenta de ApixDrive:",
      cintegrationApixDriveWHInstruction1Description1: "Enlace ",
      cintegrationApixDriveWHInstruction1Description2: "para registrarse con un bono.",
      cintegrationApixDriveWHInstruction2Title: "2. Obtenga la dirección URL para el WebHook:",
      cintegrationApixDriveWHInstruction2Description1: "Vaya a la configuración de la conexión necesaria y copie la dirección para enviar el WebHook:",
      cintegrationApixDriveWHInstruction2Description2: 'Puede crear una nueva conexión haciendo clic en el botón "Crear conexión" y en el paso de selección de sistema, elija "ADSQuiz".',
      cintegrationApixDriveWHInstruction3Title: "3. Inserte la URL del WebHook:",
      cintegrationApixDriveWHInstruction3Description: "Pegue la URL del WebHook proporcionada por ApixDrive en el campo de entrada.",
      cintegrationApixDriveWHInstruction4Title: "4. Guardar cambios:",
      cintegrationApixDriveWHInstruction4Description: 'Haga clic en el botón "Guardar cambios" para guardar la configuración del WebHook.',
      cintegrationApixDriveWHInstruction5Title: "5. Hecho:",
      cintegrationApixDriveWHInstruction5Description: "Ahora su WebHook está configurado para enviar datos a ApixDrive.",
      cintegrationApixDriveWHInstructionAdditional: "Los datos se enviarán al WebHook con cada cliente potencial recibido. El método POST se utiliza para la transmisión. Un ejemplo de los datos que se enviarán se encuentra ",
      cintegrationApixDriveWHInstructionAdditionalLink: "aquí",
      cintegrationApixDriveWHInstructionVideo: "Instrucción en video detallada",
      cintegrationConnectOweDomain: "Conectando su propio dominio",
      cintegrationOweDomainInstruction1: "1. Para colocar su cuestionario en el dominio requerido, inicie sesión en su cuenta de hosting. Vaya a la configuración de DNS y cree un registro A con el parámetro de IP: 185.25.117.21",
      cintegrationOweDomainInstruction2: "2. Ingrese su dominio arriba y guarde el cuestionario.",
      cintegrationDomain: "Dominio",
      cintegrationInputYourDomain: "Ingrese su dominio",
      cintegrationCheckDomenIsCorrect: "Verifique que el dominio ingresado sea correcto",
      cintegrationDomainWhichCorrect: "Ingrese un dominio sin protocolos. Por ejemplo: some.site.com",
      cintegrationInsertedDefaultDomain: "El dominio se establece por defecto",
      cintegrationDomainDataSaved: "Datos del dominio guardados",
      cintegrationPrivacyPolicy: "Política de privacidad",
      cintegrationPrivacyPolicyByDefault: "Por defecto, utilizamos nuestra política de privacidad estándar. Recomendamos agregar su política de privacidad que sea relevante para su negocio.",
      cintegrationPrivacyPolicyAdventage: "Esto dejará claro a sus clientes potenciales cómo utiliza la información de contacto recibida. Esto también es requerido por algunas plataformas de publicidad.",
      cintegrationPrivacyPolicyUrl: "Enlace a los documentos",
      cintegrationPrivacyPolicyInputYourDocsLink: "Insertar enlace a los documentos",
      cintegrationDocsDataSaved: "Enlace a sus documentos guardado",
      allstepsUpploadPhoto: "Subir una imagen",
      unsplashSelectorButtonText: "Elegir de Unsplash",
      unsplashSelectorTitle: "Subir imagen",
      unsplashSelectorDragImage: "Arrastra una imagen aquí o",
      unsplashSelectorUploadFile: "sube un archivo",
      unsplashSelectorSearchPlaceholder: "Buscar imagen en Unsplash",
      unsplashSelectorLoadingImages: "Cargando imágenes...",
      unsplashSelectorLoadingMoreImages: "Cargando más imágenes...",
      unsplashSelectorNoImagesFound: "No se encontraron imágenes",
      unsplashSelectorUnavailable: "Unsplash no está disponible en este momento. Puedes subir un archivo.",
      unsplashSelectorClose: "Cerrar",
      allstepsChangePhoto: "Cambiar la imagen",
      allstepsDeletePhoto: "Eliminar imagen",
      allstepsTitle: "Título",
      allstepsDescription: "Descripción",
      allstepsButtonText: "Texto del botón",
      allstepsOtherSettings: "Otras configuraciones",
      allstepsIsSaveBeforeRoute: "¿Guardar datos antes de cambiar la ruta?",
      cfirstFormat: "Formato",
      cfirstHeaderStartText: "Su encabezado debe estar aquí. Motive a los usuarios a completar el cuestionario hasta el final",
      cfirstAddMediafile: "Agregar medios (imagen)",
      cfirstBonus: "Bono",
      cfirstAddBonus: "Agregar bono",
      cfirstStartPageDataUpdated: "Los datos de la página de inicio han sido actualizados",
      csanyAnswerType: "Tipo de pregunta",
      csanyATCard: "tarjeta",
      csanyATList: "lista",
      csanyATCustom: "campo libre",
      csanyQuestion: "Pregunta",
      csanyAnswers: "Respuestas",
      csanyAddAnswer: "Agregar opción",
      csanyTitleForModalConfirm: "¡Esta acción es irreversible!",
      csanyQuestionForModalConfirm: "¿Estás seguro de que quieres eliminar esta pregunta?",
      csanyRequiredStep: "Paso requerido",
      csanyAlowMultiple: "Permitir múltiples respuestas",
      csanyAutoRedirect: "Pregunta siguiente automática",
      csanyQuestionLogic: "Configuración de lógica de la pregunta",
      csanyDataStepUpdated: "Paso de datos actualizado",
      cformForm: "Formulario",
      cformValueName: "Nombre",
      cformValueSurname: "Apellido",
      cformValuePhone: "Número de teléfono",
      cformValueEmail: "Correo electrónico",
      cformDataContactsPageUpdated: "Página de contactos de datos actualizada",
      cformRequiredInput: "Obligatorio",
      cfinishFinishPageTitle: "Página de finalización",
      cfinishText: "Texto",
      cfinishDescription: "Descripción",
      cfinishAddImage: "Agregar una imagen",
      cfinishImageAdded: "Imagen agregada",
      cfinishURL: "URL",
      cfinishButtonText: "Texto del botón",
      cfinishInsertNikname: "Insertar apodo",
      cfinishCheckDataIsCorrect: "Verifique que el ID ingresado sea correcto",
      cfinishFbWhichCorrect: "Ingrese un ID sin otra dirección. Por ejemplo: some.name",
      cfinishIgWhichCorrect: "Ingrese un ID sin otra dirección. Por ejemplo: some.name",
      cfinishTgWhichCorrect: "Ingrese un ID sin otra dirección. Por ejemplo: some.name",
      cfinishFinishPageDataUpdated: "Los datos de la página de finalización se han actualizado",
      adminUsersReg: "Usuarios en el sistema",
      adminNewUsers: "Nuevos usuarios por mes",
      adminProAccounts: "Cuentas PRO",
      adminLTV: "LTV",
      adminSharePro: "PRO relativo a todos",
      adminReciveLeads: "Leads recibidos",
      adminLeadsForOne: "Leads por usuario",
      adminMadeQuiz: "Cuestionarios creados",
      adminQuizForOne: "Cuestionarios por usuario",
      adminAvarageUsed: "Meses promedio de uso",
      adminProfitMonth: "Mes de beneficios",
      adminProfitAlltime: "Ganancias de todos los tiempos",
      adminUsersList: "Base de usuarios",
      notificationErrorLogin: "Error de autorización:",
      notificationLogin: "Iniciar sesión...",
      notificationWrongLoginData: "Detalles de inicio de sesión incorrectos",
      notificationLoginAccountBlocked: "Tu cuenta ha sido bloqueada",
      notificationCanContactSupport: "Puedes contactar con soporte",
      notificationEmailExistsMessage: "Una cuenta con este correo electrónico ya está registrada",
      notificationNetworkError: "Verifique su conexión a Internet",
      notificationInputLoginData: "Ingresar datos de inicio de sesión",
      notificationCheckInputEmail: "Verifique que su dirección de correo electrónico sea correcta",
      notificationCheckInputEmailOrUserNotFound: "Comprueba que el correo electrónico sea correcto. Usuario no encontrado",
      notificationCheckInputPhone: "Verifique que el número de teléfono sea correcto",
      notificationInputAllInputs: "Complete todos los campos para registrarse",
      notificationAgreePrivacyPolicy: "Aceptar la política de privacidad",
      adminEditorForPartnership: "Editor de programa de afiliados",
      developmentPage: "La sección está en desarrollo",
      signupAgreeIAgreeWith: "He leído y acepto",
      signupAgreePolicy: "la política de privacidad",
      signupAgreeAnd: "y",
      signupAgreeOffer: "los términos de uso",
      signupAgreeService: "del servicio",
      workboardModalLeadsLeadReferrer: "Poco claro",
      workboardEditTitle: "Editar título",
      workboardEditIcon: "Editar icono",
      workboardSaveChange: "Guardar cambios",
      workboardModalLeadsLeadReferrerClarification: "Datos del referente bloqueados por la fuente o no definidos",
      workboardModalLeadsLeadEmailCopied: "Correo electrónico copiado al portapapeles",
      workboardModalLeadsLeadPhoneCopied: "Teléfono copiado al portapapeles",
      workboardModalLeadsHaveNotSended: "Tienes los leads no enviados",
      workboardModalLeadsLeadReload: "Recibir",
      workboardModalLeadsLeadReloadedTitle: "Solicitud recibida",
      workboardModalLeadsLeadReloaded: "",
      cfirstStartPagePhotoUpdated: "La foto de la página de inicio se ha actualizado",
      allstepsPhotoTooBig: "¡El archivo es demasiado grande!",
      allstepsPhotoMustBeLess: "Debe ser menor que",
      cfirstStartPageBonusPhotoUpdated: "La foto del bono ha sido actualizada",
      cstepsQuestionsOrderSaved: "Orden de las preguntas guardado",
      csanyAnswerOrderSaved: "Orden de las respuestas guardado",
      allstepsPhotoAdaptation: "Adaptación de la foto para dispositivos",
      allstepsPhotoFit: "Relación de aspecto",
      constructorYouHideStep: "Este paso está oculto",
      cstepsHiddenStep: "Ocultar paso",
      cstepNo_animation: "Sin animación",
      cstepAnimation: "Animación",
      cstepKick_animation: "Impulso",
      cstepFlip_animation: "Giro",
      cstepBlur_animation: "Desenfoque",
      cstepsShowStep: "Mostrar paso",
      cfinishFinishPageHiddenUpdated: "La página final está oculta.",
      cfinishFinishPageHiddenUpdatedGoContact: "Vaya a la página del formulario de contacto",
      cfinishFinishPageHiddenUpdatedSetRedirect: "y configure el redireccionamiento después de enviar los datos",
      cformActionAfterContactRecive: "Seguimiento de la información de contacto",
      cformActionAfterContactThankyou: "Página de agradecimiento",
      cformActionAfterContactRedirect: "Redirigir",
      cformAdditionalSettings: "Configuraciones adicionales",
      cformRedirectURL: "URL",
      cintegrationOweDomainInstructionImportant: "Importante: O endereço na sua conta de hospedagem e o campo acima devem coincidir. O tempo de aplicação das mudanças nas configurações de DNS e extração do certificado SSL é de até 3 horas após salvar.",
      cintegrationOweDomainInstructionVideo: "Ver instrucción en video",
      workboardModalLeadsLeadLimit: "Se ha alcanzado el límite de leads.",
      workboardModalLeadsLeadLimitInstruction1: "Para ver nuevos leads,",
      workboardModalLeadsLeadLimitInstruction2: "cambiar a otra tarifa",
      workboardModalLeadsLeadLimitInstruction3: "renovar la tarifa actual",
      workboardModalLeadsLeadLimitInstruction4: '(no se aplica a "Gratis") o espere a que se actualice la tarifa si tiene renovación automática de la tarifa activada',
      workboardModalLeadsLeadLimitNewText: "Tienes leads no recibidos a los que no puedes acceder debido al límite de tu paquete actual. Para acceder a estos leads, compra o actualiza tu paquete.",
      billingBonusesTitle: 'Código promocional',
      billingBonusesDescription: 'Ingrese el código promocional que recibió en el siguiente campo',
      billingBonusesPlaceholder: 'Código promocional',
      billingBonusesBtn: 'Activar',
      billingBonusesActivated: '¡Código promocional activado!',
      billingBonusesLeadIncreased: 'El número de leads disponibles ha aumentado.',
      billingBonusesInvalid: 'Código promocional incorrecto',
      billingBonusesNotAvailable: 'El código promocional ya no está disponible',
      billingBonusesAlreadyActivated: 'Este cupón no es válido',
      createQuizSPDescription: "Hay espacio para la descripción breve",
      createQuizCPTitle: "¿Cómo podemos contactarlo?",
      createQuizCPDescription: "Por favor, complete el formulario a continuación",
      createQuizCPButton: "¡Hecho!",
      createQuizFPTitle: "¡Gracias!",
      createQuizFPDescription: "¡Ahora estamos buscando la mejor solución para usted!",
      createQuizFPButton: "¡Muéstrame algo!",
      selectInternationalPrefix: "Seleccione prefijo internacional",
      autoInternationalPrefix: "Determinar el país automáticamente",
      dovnloadCsvTitle: "Exportar datos para el período seleccionado",
      dovnloadCsvSelectAllPeriod: "Elegir para todo el período",
      dovnloadCsvCancel: "Cancelar",
      dovnloadCsvExport: "Exportar",
      domainEmpty: "Por favor, introduce un dominio",
      domainInvalid: "Introduce un dominio válido, por ejemplo: example.com",
      domainAlreadyExists: "Este dominio ya está en la lista",
      domainAdded: "Dominio añadido correctamente",
      domainAdd: "Agregar dominio",
      domainAddFailed: "No se pudo añadir el dominio",
      domainRemoved: "Dominio eliminado correctamente",
      domainRemoveFailed: "No se pudo eliminar el dominio",
      widgetEmbedVidgetToSite: "Incrustar cuestionario en su propio sitio web",
      widgetEmbedVidgetSelectEmbedVariant: "Seleccione variante de incrustación",
      EmbedQuizCardLabelStandard: "Estándar",
      EmbedSettingsPreviewPopupHint: "Haz clic en el botón para ver tu ventana emergente en acción",
      EmbedQuizCardLabelPopup: "Ventana emergente",
      EmbedQuizCardLabelChatButton: "Botón de chat",
      EmbedQuizCardLabelFullscreen: "Pantalla completa",
      EmbedQuizCardLabelFeedback: "Retroalimentación",
      EmbedQuizCardLabelSidebar: "Barra lateral",
      EmbedStandardSettingsTitle: "Establecer dimensiones (opcional)",
      tipStandardEmbedQuizStepHead:
          "1. Copia el código para <head> y pégalo antes de la etiqueta de cierre </head>.",
      tipStandardEmbedQuizStepBody:
          "2. Copia el segundo código y pega el div <div id=\"adsquiz_embed_standard_ .... exactamente en el lugar de la página donde debe aparecer el quiz.",
      tipStandardEmbedQuizParent:
          "3. El tamaño del quiz depende de las dimensiones del bloque padre. Si el elemento padre no tiene una altura definida, el quiz se mostrará automáticamente en un formato adaptable.",
      tipStandardEmbedQuizPercent:
          "4. Width y height en % funcionan en relación con el tamaño del bloque padre.",
      EmbedStandardSettingsTooltip: `
       Ancho y altura — controlan el tamaño del quiz (px, %, auto).

      Auto — el quiz es adaptable, la altura se calcula automáticamente.

      Pantalla completa — el quiz ocupa el 100% del ancho con proporción 16:9. El ancho y alto se ignoran.

      Altura:
      • auto / 0 → proporción 16:9
      • valor → altura fija

      Ancho:
      • auto / 0 → 100% del ancho
      • valor → dentro del contenedor

      Radio — controla el redondeo de las esquinas.

      Espaciado interno — añade espacio dentro del contenedor.

      Escritorio / Dispositivo móvil — controla dónde se muestra el quiz.
      Si está desactivado — el quiz no se mostrará en ese dispositivo.
      `,
      EmbedFeedbackSettingsTooltip: `
   El tamaño de la ventana establece un preset base:
  • S → 360 × 520
  • M → 480 × 640
  • L → 640 × 760
  • XL → 780 × 860
  
  Forma de la ventana:
  • angular → esquinas rectas
  • rounded → esquinas redondeadas
  
  Ancho:
  • auto / 0 / vacío → se usa el preset
  • valor → sobrescribe el preset
  
  Altura:
  • auto / 0 / vacío → se usa el preset
  • valor → sobrescribe el preset
  
  El tamaño del botón define el preset del botón de apertura.
  
  Forma del botón:
  • angular → esquinas rectas
  • rounded → esquinas redondeadas
  
  Posición del botón:
  • left → izquierda
  • right → derecha
  • top → arriba
  • bottom → abajo
  
  Texto del botón — cambia el texto.
  
  Icono — selección del icono.
  
  Color del botón — fondo del botón.
  
  Color del texto — color del texto.
  
  Color del icono — color del icono.
  
  Evitar cierre antes de completar el cuestionario — si está activado, el usuario no podrá cerrar la ventana hasta completar el cuestionario.
  
  Dejar de mostrar después de completar — después de completar el cuestionario, el botón y la ventana no volverán a mostrarse.
  
  Escritorio / Móvil — dónde se muestra el widget.
  `,
      EmbedPopupSettingsTooltip: `
        El ancho y la altura definen el tamaño del popup.
        
        El tamaño de ventana establece un preset:
        • S → 360 × 520
        • M → 480 × 640
        • L → 640 × 760
        • XL → 780 × 860
        
        El ancho y la altura pueden sobrescribir el preset.
        
        Ancho:
        • auto / 0 / vacío → se usa el preset
        • valor → sobrescribe
        
        Altura:
        • auto / 0 / vacío → se usa el preset
        • valor → sobrescribe
        
        Condición de visualización:
        • Clic en botón
        • Salida de página
        • Carga de página
        • Con retraso
        
        Los segundos aparecen solo en retraso.
        
        Texto del botón, tamaño, forma, posición, color automático y manual solo funcionan con clic.
        
        El tamaño del botón define su preset.
        
        Color automático:
        • activo — usa colores del template
        • manual — desactiva automático
        
        Evitar cierre antes de completar el cuestionario — si está activado, el usuario no podrá cerrar la ventana hasta completar el cuestionario.
  
        Dejar de mostrar después de completar — después de completar el cuestionario, el botón y la ventana no volverán a mostrarse.
        
        Desktop / Mobile — controla visibilidad.
        `,
      EmbedChatButtonSettingsTooltip: `
      El ancho y la altura definen el tamaño de la ventana de chat.

      El tamaño de la ventana establece el preset base:
      • S → 360 × 520
      • M → 480 × 640
      • L → 640 × 760
      • XL → 780 × 860

      El ancho y la altura pueden sobrescribir el preset seleccionado de Tamaño de la ventana.

      Ancho:
      • auto / 0 / vacío → se usa el ancho del Tamaño de la ventana
      • valor → un ancho personalizado sobrescribe el preset

      Altura:
      • auto / 0 / vacío → se usa la altura del Tamaño de la ventana
      • valor → una altura personalizada sobrescribe el preset

      La forma de la ventana define si la ventana de chat tendrá esquinas rectas o redondeadas.

      El tamaño del botón establece el preset del botón que abre el chat.

      La forma del botón define el estilo del botón:
      • rectangular
      • circular

      La posición del botón define dónde se mostrará el botón:
      • izquierda
      • derecha

      Los iconos permiten elegir el icono del botón de chat.

      El color del botón establece el color de fondo del botón.

      El color del icono establece el color del icono dentro del botón.

    Evitar cierre antes de completar el cuestionario — si está activado, el usuario no podrá cerrar la ventana hasta completar el cuestionario.
  
      Dejar de mostrar después de completar — después de completar el cuestionario, el botón y la ventana no volverán a mostrarse.

      Escritorio / Dispositivo móvil — controla dónde se muestran el botón de chat y la ventana de chat.
      Si está desactivado — el botón de chat no se mostrará en ese dispositivo.
      `,
      EmbedSidebarSettingsTooltip: `
        El tamaño de la ventana establece un preset base:
  • S → 360 × 520
  • M → 480 × 640
  • L → 640 × 760
  • XL → 780 × 860
  
  Posición del panel:
  • left → izquierda
  • right → derecha
  
  Ancho:
  • auto / 0 / vacío → se usa el valor del preset
  • valor → sobrescribe el preset
  
  Altura:
  • auto / 0 / vacío → se usa el valor del preset
  • valor → sobrescribe el preset
  
  Condición de visualización:
  • Clic en el botón — se abre al hacer clic
  • Al salir de la página — se abre cuando el usuario abandona la página
  • Al cargar la página — se abre inmediatamente después de la carga
  • Con retraso — se abre después del número de segundos seleccionado
  
  El campo de segundos aparece solo para “Con retraso”.
  
  Texto del botón, tamaño, forma, posición, color del botón y color del texto funcionan solo para “Clic en el botón”.
  
  El tamaño del botón define el preset del botón de apertura.
  
  Forma del botón:
  • angular → esquinas rectas
  • rounded → esquinas redondeadas
  
  Posición del botón:
  • left → izquierda
  • middle → centro
  • right → derecha
  
  Color del botón — fondo del botón.
  
  Color del texto — color del texto del botón.
  
  Evitar cierre antes de completar el cuestionario — si está activado, el usuario no podrá cerrar el panel hasta terminar el cuestionario.
  
  Dejar de mostrar después de completar — después de finalizar el cuestionario, el botón y el panel no volverán a mostrarse.
  
  En escritorio / En móvil — define dónde se muestra el panel lateral.
  Si está desactivado — no se mostrará en ese dispositivo.
      `,
      EmbedModalStandardInstruction: `
      Copia el código Head y pégalo antes de </head>.
      
      Copia el Body donde debe mostrarse el quiz.
      
      Cómo funciona:
      • El quiz se integra en la página
      • Se adapta al contenedor
      
      Atención:
      • Revisa el ancho del contenedor
      • Ajusta la altura si es necesario
      • Modo responsive ajusta altura automáticamente
      • Revisa CSS
      
      Después:
      1. Guarda
      2. Recarga
      3. Verifica
      `,
      EmbedModalPopupInstruction: `
      Pega Head antes de </head>.
      
      Pega Body antes de </body> o donde quieras.
      
      Cómo funciona:
      • Se abre como popup
      • Automático o por clic
      
      Atención:
      • Botón aparece donde insertes
      • Auto abre solo
      • Revisa dispositivos
      • Ajusta tamaño
      
      Después:
      1. Guarda
      2. Recarga
      3. Verifica popup
      `,
      EmbedSettingsWindowSize: "Tamaño de la ventana",
      EmbedPreviewFallbackTitle: "La vista previa está tardando más de lo esperado",
      EmbedPreviewFallbackDescription: "La vista previa del cuestionario aún no pudo mostrarse. Intenta volver a abrir la vista previa o recargar el marco.",
      EmbedPreviewFallbackReasonsTitle: "Posibles razones:",
      EmbedPreviewFallbackReasonDomain: "Es posible que el dominio seleccionado no esté disponible o se haya introducido incorrectamente.",
      EmbedPreviewFallbackReasonDomainSettings: "Por favor, revisa la configuración de tu dominio y asegúrate de que el dominio esté conectado correctamente.",
      EmbedPreviewFallbackReasonSlow: "Es posible que la página del cuestionario todavía se esté cargando o responda lentamente.",
      EmbedPreviewFallbackReasonBlocked: "Es posible que la vista previa esté bloqueada por tu navegador o entorno de red.",
      EmbedPreviewFallbackReload: "Recargar vista previa",
      EmbedSizePresetDisabledHint: "El tamaño predefinido no está disponible mientras se establezca un ancho o alto personalizado.",
      EmbedPopupSettingsTitleButton: "Tamaño del botón",
      EmbedStandardSettingsHeightLabel: "Altura",
      EmbedStandardSettingsWidthLabel: "Ancho",
      EmbedStandardSettingsRadiusLabel: "Radio",
      EmbedStandardSettingsPaddingLabel: "Espaciado interno",
      EmbedStandardSettingsFullscreenToggle: "Pantalla completa",
      EmbedStandardSettingsDesktopToggle: "Escritorio",
      EmbedPopupSettingsTextColorToggle: "Color del texto",
      EmbedPopupSettingsButtonColorToggle: "Color del botón",
      EmbedSettingsIconColor: "Color del icono",
      EmbedPopupSettingsAutoColorToggle: "Color automático (plantilla)",
      EmbedPopupSettingsCloseOnCompletionToggle: "Impedir el cierre antes de completar el cuestionario",
      EmbedSettingsStopShowing: "Dejar de mostrar después de completar",
      EmbedStandardSettingsMobileToggle: "Dispositivo móvil",
      EmbedSettingsAutoOpenToggle: "Apertura automática",
      EmbedSettingsPreviewDelayHint: "La ventana emergente aparecerá después de ",
      EmbedSettingsPreviewOpenAgain: "Abrir vista previa de la ventana emergente",
      EmbedReOpenSettingsMobileToggle: "Abrir vista previa",
      widgetEmbedVidgetSitecode: "En el código del sitio",
      widgetEmbedVidgetPopup: "Pop-up",
      widgetEmbedVidgetChat: "Botón de cuestionario",
      widgetEmbedVidgetInProgres: "En desarrollo",
      widgetEmbedVidgetToSiteCode: "Incrustar cuestionario en el sitio web",
      widgetSiteCodeInstruction0: "Para incrustar el cuestionario en su sitio, agregue el código del primer campo en la etiqueta <head> de su sitio o en Google Tag Manager si está integrado en su sitio. Si después de haber incrustado el cuestionario en su sitio cambia el dominio del cuestionario, necesitará actualizar el código de integración en su sitio.",
      widgetSiteCodeInstruction1: "En el lugar donde desea integrar el cuestionario, inserte el código del segundo campo.",
      widgetSiteCodeInstruction2: "El cuestionario se puede integrar en un contenedor de cualquier tamaño, ¡incluso en barras laterales! El tamaño máximo del cuestionario, al igual que en un dominio separado, es de 900x552 píxeles. Se puede agregar a contenedores más grandes, en cuyo caso el cuestionario se centrará.",
      widgetSiteCodeInstruction3: "¡No sea tímido - experimente!",
      widgetSiteCodeCopyToHead: "Copie y pegue en el <head> de su sitio",
      widgetSiteCodeCopyToBody: "Pegue el código donde debería estar el cuestionario",
      workboardModalAddQuizHeader: "Crear nuevo cuestionario",
      workboardModalGiveQuizNameAndMethod: "Piense en un nombre para su cuestionario y elija cómo desea crearlo",
      workboardModalNewQuizFromStart: "Crear desde cero",
      workboardModalNewQuizFromTemplates: "Plantillas listas",
      QuizTemplatesSearchInput: "Nombre de la plantilla y/o categorías",
      QuizTemplatesSearchBtn: "Buscar",
      QuizTemplatesReadyTemplates: "Plantillas listas",
      QuizTemplateView: "Ver",
      QuizTemplateSelect: "Elegir",
      widgetPopupInstruction0: "Para instalar un cuestionario en su sitio, agregue el código de la caja de códigos en la etiqueta <head> de su sitio o en Google Tag Manager si está integrado en su sitio. Si, después de haber insertado un cuestionario en su sitio, cambia el dominio del cuestionario o los disparadores (porcentaje de desplazamiento o tiempo), deberá actualizar el código de integración en su sitio.",
      widgetPopupInstruction1: "Justo antes de la etiqueta de cierre </footer>, pegue el código del segundo campo.",
      widgetPopupInstruction2: "Para programadores o usuarios avanzados",
      widgetPopupInstruction3: "Si, por alguna razón, se siente incómodo insertando un cuestionario antes de la etiqueta de cierre </footer>, puede pegar el código del segundo campo en cualquier lugar conveniente, pero tenga en cuenta que el contenedor en el que pega el código del segundo campo debe estar encima de todas las ventanas y, de preferencia, debe tener la altura y anchura máximas posibles para la visualización.",
      widgetPopupCopyToHead: "Copie y pegue en el <head> de su sitio",
      widgetPopupCopyToBody: "Pegue el código antes de la etiqueta de cierre </footer>",
      widgetPopupTimeToOpen: "Un período de tiempo",
      secondReduction: "seg",
      widgetPopupTimeClarification: "El popup aparecerá con un retraso del tiempo mencionado en segundos",
      widgetPopupScrollToOpen: "Porcentaje de desplazamiento del sitio",
      widgetPopupScrollClarification: "El popup aparecerá después del porcentaje de desplazamiento de su sitio especificado arriba",
      quizzesTemplatesAllTags: "Todas las plantillas",
      widgetEmbedVidgetButton: "Constructor de botones",
      widgetButtonInstruction0: "Puede configurar un cuestionario en su sitio web que se abrirá cuando haga clic en el botón.",
      widgetButtonInstruction1: "Agregue un borde, sombra y texto al botón. También puede cambiar el color del botón y el texto dentro.",
      widgetButtonInstruction2: "Copie el script colocado en la primera caja de código y péguelo antes de la etiqueta de cierre </head>.",
      widgetButtonInstruction3: "Copie el código de botón generado en el segundo campo de código y péguelo en cualquier lugar de su sitio.",
      widgetButtonInstruction4: 'Puede omitir el código del segundo campo de botón y simplemente agregar id="button_open_quiz_popup" a cualquier elemento <input type="button"> o <button></button> en el sitio.',
      widgetRealTimeChange: "Puede ver los cambios en tiempo real en el lado derecho de la pantalla",
      widgetButtonCornerRound: "Redondeo de esquinas del botón",
      widgetButtonShadow: "Sombra del botón",
      widgetButtonBgColor: "Color del botón",
      widgetButtonTextColor: "Color del texto",
      widgetButtonTextValue: "Texto del botón",
      openPopupQuizText: "Iniciar cuestionario",
      widgetButtonInsertBeforeAfterBody: "Inserte el código del cuestionario inmediatamente después de la etiqueta de apertura <body> o inmediatamente antes de la etiqueta de cierre </body>",
      widgetSiteCodeCopyButton: "Pegue el código del botón en cualquier lugar del sitio",
      footerContactUs: "¿Tiene preguntas? No dude en contactarnos:",
      enterYourName: "Ingrese su nombre",
      enterYourPhone: "Ingrese su número de teléfono",
      enterYourEmail: "Ingrese su correo electrónico",
      enterYourPassword: "Ingrese su contraseña",
      selectOption: "Seleccione opción",
      createNewGroup: "Crear nuevo grupo",
      dontHaveAccount: "¿No tiene una cuenta?",
      haveQuestions: "¿Tiene alguna pregunta?",
      resetPasswordTip: "Si tiene algún problema o pregunta adicional, no dude en ponerse en contacto con nuestro equipo de soporte al cliente. Estamos aquí para ayudar.",
      getBackAccount: "Volver a su cuenta",
      inMinutes: "en minutos",
      alreadyHaveAccount: "¿Ya tiene una cuenta?",
      quizSlotLastEdit: "Última edición",
      workboardQuizzesTitle: "Mis cuestionarios",
      allstepsBack: "Atrás",
      constructorGetLink: "Compartir",
      allOr: "o",
      allAnd: "y",
      acceptedFileType: "Formatos aceptados: ",
      quizLoaderLoadingQuiz: "Cargando quiz...",
      quizLoaderPreparingQuestions: "Preparando preguntas personales...",
      quizLoaderSettingInterface: "Configurando la interfaz...",
      quizLoaderAlmostReady: "Casi listo...",
      conjunctionAnd: "y",
      acceptedFileSize: "Tamaño máximo: ",
      acceptedFileSizeMeasure: "MB",
      cfirstBonusDisabled: "Deshabilitado",
      cfirstBonusAvailable: "Disponible",
      allstepsResetInHeader: "Restablecer",
      placeholderText: "Escriba aquí",
      constructorSaveChanges: "Guardar",
      constructorCreateIntegrations: "Crear integración",
      cformInputAvailable: "Disponible",
      cformInputDisabled: "Deshabilitado",
      Disabled: "Desactivado",
      constructorBack: "Atrás",
      videoInstruction: "Instrucción en video",
      csettingsIntegrationFB: "Integración - Facebook Pixel",
      csettingsIntegrationTT: "Integración - TikTok",
      csettingsIntegrationGA: "Integración - Google Analytics",
      csettingsIntegrationGTM: "Integración - Google Tag Manager",
      csettingsIntegrationWH: "Integración - WebHook",
      csettingsIntegrationTG: "Integración - Telegram",
      csettingsIntegrationApixDrive: "Integración - APIxDrive",
      csettingsIntegrationEmail: "Integración - Correo Electrónico",
      csettingsIntegrationAbout: "Acerca de",
      csettingsIntegrationFBAbout: "Vaya al gabinete de publicidad de Facebook Ads y copie el ID de Facebook Pixel en la sección de Event Manager. No copie el código completo, solo el ID. Copie y pegue en la caja a continuación.",
      csettingsIntegrationTTAbout: "Ve al administrador de anuncios de TikTok Ads y copia el identificador del TikTok Pixel en la sección \"Event\". Copia solo el identificador y pégalo en el campo de abajo.",
      csettingsIntegrationGAAbout: "Copie el ID de Google Analytics y péguelo en el campo a continuación.",
      csettingsIntegrationGTMAbout: "Copie el ID de Google Tag Manager y péguelo en el campo a continuación.",
      csettingsIntegrationWHAbout1: "Puede notificar a aplicaciones de terceros sobre los leads entrantes. Para hacerlo, especifique la URL a la que se enviará el WebHook. Recomendamos usar el servicio para este propósito.",
      csettingsIntegrationWHAboutApix: "Apix-Drive",
      csettingsIntegrationWHAbout2: "Al registrarse utilizando este enlace, nuestros usuarios reciben un bono - 10,000 acciones gratuitas para cualquier integración.",
      csettingsIntegrationTGAbout: "Importante: Tenga en cuenta que esto debe ser un grupo, no un canal de Telegram. Los leads no se enviarán al canal de Telegram.",
      csettingsIntegrationADAbout: "Algo sobre APIxDrive",
      csettingsIntegrationEmailAbout: "Envía un correo electrónico a su respondiente y notifica a su equipo. Colabore con su equipo.",
      cSettingsIntegrationNeedHelp: "¿Necesita ayuda?",
      cSettingsIntegrationRefreshToken: "Actualizar token",
      csettingsSettingASettings: "Configuración avanzada",
      cSettingsSettingQuizLangTitle: "Idioma del cuestionario",
      cSettingsSettingQuizLangDescription: "Para asegurarle la mejor experiencia, seleccione su idioma deseado para el cuestionario de las opciones a continuación. Las notificaciones del sistema y otros textos constantes se mostrarán en este idioma al completar el cuestionario.",
      selectQuizLanguage: "Seleccionar idioma del cuestionario",
      cSettingsSettingQuizHideLabelTitle: "Ocultar etiqueta",
      cSettingsSettingQuizHideLabelDescription: 'Al habilitar esta opción, puede disfrutar de una interfaz sin la etiqueta "hecho por adsquiz", lo que le permite a usted y a sus visitantes centrarse únicamente en las preguntas.',
      cSettingDataSaved: "Configuración adicional guardada",
      userAccountInfo: "Información de cuenta",
      userGeneralInfoHeader: "Información general",
      userGeneralInfoDescription1: "Su perfil de usuario es donde puede administrar su cuenta y configuraciones.",
      userGeneralInfoDescription2: "Actualice su información personal, cambie su contraseña y ajuste sus preferencias de notificación.",
      profileNameFirst: "Nombre",
      profileNameLast: "Apellido",
      profileChangePhoto: "Cambiar foto",
      profileRemovePhoto: "Eliminar",
      userSecuritySettingsHeader: "Configuración de seguridad",
      userSecuritySettingsDescription: "Para cambiar su contraseña, simplemente ingrese su nueva contraseña dos veces para confirmar.",
      profileEmailCurent: "Dirección de correo electrónico actual",
      profileEmailNew: "Nueva dirección de correo electrónico",
      profileNewPasswordConfirm: "Confirmar nueva contraseña",
      profileDeleteAccount: "Eliminar cuenta",
      profileDeleteAccountPopupHeader: "¿Eliminar cuenta?",
      profileDeleteAccountPopupDescription: '¿Está seguro de que desea eliminar su cuenta? Esta acción no se puede deshacer. Para confirmar la eliminación, escriba la palabra "ELIMINAR" en el campo a continuación.',
      profileDeleteAccountCheckedWord: "ELIMINAR",
      profileDeleteAccountPopupPlaceholder: "Escriba aquí",
      notificationSuccess: "¡Éxito!",
      notificationSuccessSaveAccount: "¡Su contraseña se ha cambiado exitosamente! Use una nueva contraseña para iniciar sesión nuevamente",
      notificationOnlyEmailMask: "Solo se permite una dirección de correo electrónico válida.",
      notificationOnlyNumbersMask: "Solo se permiten números y espacios.",
      notificationOnlyLinkMask: "Solo se permiten enlaces seguros (https, http o mailto).",
      notificationOnlyLettersMask: "Solo se permiten letras, espacios, guiones, apóstrofos y guiones bajos.",
      notificationSuccessDeleteAccount: "¡Su contraseña se ha cambiado exitosamente! Use una nueva contraseña para iniciar sesión nuevamente",
      notificationSuccessDeletePhoto: "Foto eliminada con éxito",
      notificationSuccessChangePhoto: "Foto cambiada con éxito",
      notificationErrorChangePhoto: "Ocurrió un error al cambiar la foto",
      notificationErrorRemovePhoto: "Ocurrió un error al eliminar la foto",
      notificationWarnLimitText: "Se ha superado el límite de caracteres. No puedes añadir más caracteres.",
      cardPanUnspecified: "No especificado",
      userBillingsDate: "Fecha",
      userBillingsCost: "Costo",
      userBillingsId: "ID",
      userBillingsMethod: "Método de pago",
      RateSymbolForDropdown: "Símbolo de tasa",
      NumberOfSymbolsForDropdown: "Número de símbolos",
      optionIconLabelForDropdown_thumbnail: "Pulgar arriba",
      optionIconLabelForDropdown_stars: "Estrellas",
      optionIconLabelForDropdown_flags: "Banderas",
      optionIconLabelForDropdown_smiley_faces: "Caritas felices",
      labelTextYesNoPack1: "Sí/No Paquete - 1",
      labelTextYesNoPack2: "Sí/No Paquete - 2",
      labelTextYesNoPack3: "Sí/No Paquete - 3",
      labelTextYesNoEmojiPack: "Sí/No Paquete de Emoji",
      labelTextEmojiPackage1: "Paquete de Emoji - 1",
      labelTextEmojiPackage2: "Paquete de Emoji - 2",
      labelTextEmojiPackage3: "Paquete de Emoji - 3",
      labelTextNumberPack1: "Paquete de Números - 1",
      labelTextNumberPack2: "Paquete de Números - 2",
      labelTextClassicNumbers1: "Números Clásicos - 1",
      labelTextClassicNumbers2: "Números Clásicos - 2",
      labelTextRatingMarkers: "Marcadores de Calificación",
      textPackagePlaceholder: "Paquete ...",
      labelEmojiNumberSets: "Conjuntos de emojis y números",
      labelSelectCountForSymbols: "Selecciona un rango de 1 a",
      labelButtonColorButtonText: "Color del botón y texto del botón",
      color: "Color",
      paymentSwitchToProHeader: "Cambiar a Pro",
      paymentSwitchToProDescription: "¡Encuentra el plan adecuado para ti! Mejora o reduce en cualquier momento; facilitamos la obtención del plan que necesitas.",
      paymentYourCurrentPlan: "Su plan actual:",
      paymentYourFuturePlan: "Su nuevo plan:",
      billingCurrentPlanLeadLimit: "Límite de leads mensual",
      billingCurrentPlanLeadsRemaining: "Leads restantes",
      billingSpecialOffersHeading: "Ofertas especiales",
      billingAllPlansHeading: "Todos los planes",
      billingBillingPeriodToggleAria: "Periodo de facturación",
      billingPeriodMonthly: "Mensual",
      billingPeriodYearly: "Anual",
      billingPaymentUnavailableNotification: "El pago de este plan no está disponible en este momento. Inténtalo de nuevo más tarde o contáctanos.",
      billingRequisitesButton: "Datos bancarios",
      billingPayAsBusiness: "Pagar como empresa",
      billingIbanModalTitle: "Datos bancarios",
      billingIbanModalMethodTitle: "Transferencia bancaria IBAN",
      billingIbanModalDisclaimer: "Para recibir una factura, escríbanos en el chat de soporte técnico.",
      billingIbanModalRecipient: "Beneficiario",
      billingIbanModalRecipientCode: "Código del beneficiario",
      billingIbanModalIban: "IBAN",
      billingIbanModalBankName: "Nombre del banco",
      billingIbanModalCopy: "Copiar IBAN",
      billingIbanModalClose: "Cerrar",
      billingIbanCopyAllButton: "Copiar datos bancarios",
      billingIbanCopiedNotification: "IBAN copiado al portapapeles",
      billingIbanAllCopiedNotification: "Datos bancarios copiados al portapapeles",
      billingWhatsIncluded: "Qué incluye",
      billingComparePlans: "Comparar planes",
      billingComparePlanA: "Plan A a comparar",
      billingComparePlanB: "Plan B a comparar",
      billingFeatureSectionMain: "Principal",
      billingFeatureSectionAdvanced: "Avanzado",
      billingFeatureSectionIntegrations: "Integraciones",
      billingAnalyticsRowLabel: "Analítica",
      billingLeadsRowLabel: "Leads",
      billingFeatureProjectsRowLabel: "Proyectos",
      billingFeatureCustomDomainRowLabel: "Dominio personalizado",
      billingFeatureAnalyticsRowLabel: "Analítica",
      billingFeatureSiteInstallRowLabel: "Instalación en el sitio",
      billingFeatureAiBuilderRowLabel: "Creador de IA",
      billingFeatureRedirectRowLabel: "Redirección",
      billingFeatureUtmTrackingRowLabel: "Seguimiento UTM",
      billingFeatureFaviconRowLabel: "Favicon",
      billingFeatureLogicRowLabel: "Lógica",
      billingFeatureResultPageRowLabel: "Página de resultados",
      billingFeaturePointsRowLabel: "Puntos",
      billingFeatureFileUploadRowLabel: "Carga de archivos",
      billingFeatureNotYetAvailableLabel: "Próximamente",
      billingFeatureTeamRowLabel: "Equipo",
      billingFeatureCrmRowLabel: "CRM",
      billingPartnershipOfferHeading: "Oferta de asociación",
      paymentPlanLeadsLimit: "Límite de leads por mes:",
      paymentPlanLeadsLimitForTest: "Límite de pruebas de su cuestionario:",
      paymentPlanLeadsLeft: "Leads restantes:",
      paymentPlanPrice: "Precio:",
      paymentPlanRenew: "Fecha de renovación de tarifa:",
      addNewSectionHeader: "Agregar nueva sección",
      addNewSectionList: "Lista",
      addNewSectionCustom: "Campo de entrada",
      addNewSectionMultiInput: "Entrada múltiple",
      addNewSectionUploadFile: "Subida de archivo",
      addNewSectionCard: "Tarjetas con fotos",
      addNewSectionWithEmoji: "Lista con emoji",
      addNewSectionTags: "Etiquetas",
      addNewSectionSlider: "Deslizador",
      templatesBackToQuiz: "Volver al tablero de trabajo",
      constructorStepsSaved: "Todos los datos del cuestionario se han guardado exitosamente",
      constructorDesignSaved: "El diseño del cuestionario se ha guardado exitosamente",
      azureBlueWhite: "Estándar",
      azureBlue: "Noche de invierno",
      moderatePurplishRed: "Terciopelo rojo",
      multiInputPlaceholderLink: "https:",
      multiInputPlaceholderName: "Nombre o nombre completo",
      multiInputAddInput: "Agregar campo",
      multiInputPlaceholderAddress: "Dirección",
      multiInputPlaceholderNumbers: "Marcador de posición (solo números)",
      violetBlueCrayola: "Brisa de invierno",
      wetRainforest: "Arce de verano",
      lavender: "Espacio",
      blueLilac: "Lavanda oscura",
      opalGreen: "Bosque de los Cárpatos",
      dustyBlue: "Tiffany",
      almondCrayola: "Arrecife de coral",
      periwinkleCrayolaLilac: "Lila",
      periwinkleCrayolaAqua: "Synevir",
      jazzJam: "Jazz",
      slateGrayBlue: "Niebla",
      turquoiseBlueCrayola: "Diia",
      blackPearlescentOpal: "Ceniza",
      pearlescentGentianBlue: "Zafiro",
      sapphireBlue: "Zafiro oscuro",
      errorUserDataUpdate: "Error en los datos actualizados: ",
      completeUserDataUpdate: "Datos de usuario actualizados",
      passwordDoNotCoincidence: "Las contraseñas no coinciden",
      passwordDoNotCoincidenceAgain: "Inténtelo de nuevo",
      nonBillingsYet: "Aún no tiene historial de facturación.",
      youCanChangePlan: "Puede cambiar el plan actual haciendo clic en el botón “Cambiar a PRO”",
      rangeMin: "Mín",
      rangeMax: "Máx",
      rangePositionStart: "Inicio de posición",
      rangePositionEnd: "Fin de posición",
      rangeStep: "Paso",
      rangeIsRange: "Rango",
      rangeIsRangeTrue: "Disponible",
      rangeIsRangeFalse: "Deshabilitar",
      recivePromotionNewsletter: "Recibir boletines por correo electrónico",
      reciveEmailCheckbox: "Casilla de recibir correo electrónico",
      additionalCheckbox: "Casilla adicional",
      contactPrivacyPolicyCheckbox: "Casilla de política de privacidad de contacto",
      contactAgreeIAgreeWith: "Estoy de acuerdo con",
      contactAgreePolicy: "la política de privacidad",
      contactAgreeAnd: "y",
      contactAgreeTermsOfUse: "los términos de uso",
      contactAgreeAgreementAdditionalWord: "",
      contactFillRequiredInput: "Complete los campos requeridos",
      langDE: "Alemán",
      langEN: "Inglés",
      langIT: "Italiano",
      langKK: "Kazajo",
      langPL: "Polaco",
      langRU: "Ruso",
      langSP: "Español",
      langUA: "Ucraniano",
      langSV: "Sueco",
      langLT: "Lituano",
      langLV: "Letón",
      langET: "Estonio",
      langRO: "Rumano",
      leadsLeft: "Leads restantes",
      generateDomainTitle: "Ingrese el nombre de dominio",
      generateCodeForEmbedQuiz: "Generar código",
      generateDomainDescription: "Esta es la dirección única donde su página estará accesible. Puede cambiar la dirección en cualquier momento o conectar su propia.",
      generateDomainDomainNameLabel: "Nombre de dominio",
      cancelAllAction: "Cancelar",
      confirmAllAction: "Confirmar",
      fieldDataTypeLabel: "Tipo de datos en el campo",
      falseHasValidCharacters: "Caracteres no válidos en el dominio. Los caracteres válidos son letras, números y guiones.",
      falseHasValidLength: "La longitud del dominio debe estar entre 6 y 20 caracteres alfanuméricos.",
      falseDoesNotStartOrEndWithSpecialChar: "El dominio no debe comenzar ni terminar con un carácter especial.",
      falseDoesNotHaveConsecutiveSpecialChar: "El dominio no debe contener dos o más caracteres especiales consecutivos.",
      falseDoesNotHaveConsecutiveSameChar: "El dominio no debe contener tres o más caracteres idénticos consecutivos.",
      falseDoesNotContainForbiddenSubstrings: "El dominio no debe contener subcadenas prohibidas.",
      generateDomainTaken: "Este dominio ya está tomado. Pruebe otro",
      temporarilyUnavailable: "Temporalmente no disponible",
      csettingsAdmin: "Configuración para administradores",
      questionLogicSetupTitle: "Configuración de lógica de preguntas",
      questionLogicSetupDescription: "Agregue condiciones para personalizar la encuesta para cada encuestado y recopilar datos más precisos.",
      questionLogicConditionTitle: "Condición",
      questionLogicQuestion: "Pregunta",
      questionLogicSetupQuestionDisableOption: "Seleccione pregunta",
      questionLogicSetupAnswer: "Respuesta",
      questionLogicSetupLogicType: "Tipo",
      questionLogicSetupAnswerDisableOption: "Seleccione tipo de condición",
      questionLogicSetupRangeRatingBetween: "Entre",
      questionLogicSetupRangeRatingLess: "Menos",
      questionLogicSetupRangeRatingMore: "Más",
      questionLogicSetupRangeRatingEqualTo: "Igual a",
      questionLogicSetupRangeRatingFrom: "Desde",
      questionLogicSetupRangeRatingTo: "Hasta",
      questionLogicSetupVariantAll: "Todos",
      questionLogicSetupVariantAny: "Cualquiera",
      questionLogicSetupVariantNot: "Ninguno",
      questionLogicSetupCustomEqual: "Igual",
      questionLogicSetupCustomContains: "Contiene",
      questionLogicSetupCustomNotContains: "No contiene",
      questionLogicSetupRangeRatingValue: "Valor",
      questionLogicSetupExpectedAnswer: "Respuestas esperadas",
      questionLogicSetupPlaceholder: "Escribe aquí",
      questionLogicAllMandatory: "Todas las condiciones anteriores son obligatorias",
      questionLogicAddConditionBtn: "Añadir condición",
      questionLogicNotAvailable: "La configuración de lógica no está disponible para la primera pregunta",
      pointsSettingsNotAvailableForQuestionType: "Este tipo de pregunta no implica la puntuación de las respuestas",
      questionLogicSaved: "La configuración de la lógica de visualización de pasos ha sido guardada",
      questionLogicDeleteAll: "Eliminar lógica",
      questionLogicDeleted: "La lógica de visualización del paso ha sido eliminada",
      questionLogicRatingSelectedLeftBtn: "botón izquierdo",
      questionLogicRatingSelectedRightBtn: "botón derecho",
      QR_code: "QR code",
      QRCodeDownloadPdf: "Descargar Pdf",
      QRCodeDownloadPng: "Descargar Png",
      qrGenerateTitle: "Generar código QR",
      qrGenerateDescription: "Genere un código QR personalizado con etiquetas UTM para rastrear fácilmente las fuentes de tráfico. Cuando los usuarios escaneen el código, serán dirigidos a su cuestionario con los parámetros de campaña preservados para una analítica precisa.",
      qrUtmSource: "Fuente (por ejemplo, google, newsletter)",
      qrUtmMedium: "Medio de marketing (por ejemplo, cpc, banner, email)",
      qrUtmCampaign: "Producto, código promocional o eslogan (por ejemplo, spring_sale). Se requiere el nombre o el ID de la campaña.",
      qrUtmTerm: "Identificar las palabras clave de pago",
      qrUtmContent: "Usar para diferenciar anuncios",
      billingPaymentInfoTitle: "Información de tarifa",
      billingPaymentInfoChangeTarrif: "Cambiar tarifa",
      billingPaymentInfoDescription: "Cuando paga por cualquier tarifa, recibe una cierta cantidad de leads incluidos en el paquete que ha elegido. Estos leads se proporcionan por un mes. Si no ha usado sus leads dentro de un mes desde el momento del pago, serán cancelados.",
      billingGeneralName: "Su tarifa",
      billingGeneralCost: "Costo",
      billingMonth: "mes",
      billingGeneralExpired: "Válido hasta",
      billingGeneralLeadsLeft: "Leads restantes",
      billingGeneralAllTarifExpired: "Fecha de vencimiento de la tarifa",
      billingGeneralBonus: "Leads de bonificación",
      billingGeneralLeadsFromOtherTarifs: "Leads de otras tarifas",
      billingGeneralNoActiveTariff: "Sin tarifa activa",
      billingLeadsAvailableLabel: "Leads disponibles",
      billingLeadsTariffSourceLabel: "Tarifa",
      billingLeadsRemainingOfLabel: "{remaining} / {total} restantes",
      planUsageTeamMembersLabel: "Miembros del equipo",
      planUsageManagePlanLabel: "Gestionar plan",
      billingAcordeonPaymentInfoTitle: "Información de pago",
      billingAcordeonPaymentInfoFormat: "Formato",
      billingAcordeonPaymentInfoSubscription: "Suscripción",
      billingAcordeonPaymentInfoPay: "Pago",
      billingAcordeonPaymentInfoPayMethod: "Método de pago",
      billingAcordeonPaymentInfoCancelSubscription: "Cancelar suscripción",
      billingAcordeonPromocode: "Código promocional",
      billingAcordeonPromocodeLabel: "Ingrese el código promocional",
      billingAcordeonPayHistory: "Historial de transacciones",
      paymentAllTarifInactive: "la tarifa está inactiva",
      subscriptionUnsubscribeModalTitle: "Darse de baja",
      subscriptionUnsubscribeModalDescription: "¿Está seguro de que desea darse de baja? Los leads acumulados para la suscripción estarán disponibles durante un mes desde la última fecha de facturación.",
      subscriptionIsNotDeleteTitle: "Suscripción no cancelada",
      subscriptionIsNotDeleteDescription: "Por favor, póngase en contacto con el soporte al cliente",
      subscriptionCanceledTitle: "Suscripción cancelada",
      embedQuizTitleGetLinkModal: "Insertar el quiz en el sitio web como:",
      QRCodeTitleGetLinkModal: "Usar código QR:",
      modalSureUnsavedChangesTitle: "Tiene cambios sin guardar",
      modalSureUnsavedChangesDescription: "Antes de salir de la página actual, decida qué hacer con los cambios sin guardar",
      modalSureUnsavedChangesDontSave: "No guardar",
      modalSureUnsavedChangesSave: "Guardar",
      modalSuggestIdeaNotificationSuccess: "¡Éxito! Gracias por tu idea",
      modalSuggestIdeaNotificationUnsuccess: "¡Ups! Algo salió mal. Por favor, inténtalo de nuevo más tarde.",
      telegramTokenCopied: "El token del quiz ha sido copiado al portapapeles",
      cSettingsSettingQuizBackButtonTitle: "Botón de retroceso",
      cSettingsSettingQuizBackButtonDescription: "Puede habilitar o deshabilitar el botón de retroceso. Esto permitirá cambiar la respuesta dada anteriormente.",
      cSettingsCustomThemePrimaryColor: "Color de acentos",
      cSettingsCustomThemeSecondaryColor: "Color de fondo",
      cSettingsCustomThemeAdditionalColor: "Color de texto",
      cSettingsCustomThemeButtonTextColor: "Texto en el botón",
      cSettingsCustomThemeModeDark: "Oscuro",
      cSettingsCustomThemeModeLight: "Claro",
      allstepsPlaceholder: "Marcador de posición",
      allstepsCustomInput: "Entrada personalizada",
      allstepsCustomInputOn: "Disponible",
      allstepsCustomPlaceholder: "Otro",
      trashcanTitle: "Papelera",
      trashcanImportant: "¡Importante!",
      trashcanDescription: "El quiz se eliminará automáticamente de forma permanente 30 días después de ser movido a la papelera.",
      trashcanClearAll: "Borrar todo",
      quizSlotDeletedData: "Eliminado el",
      workboardLeads: "Leads",
      filterOptionLabelCreatedDesc: "de nuevos a antiguos",
      filterOptionLabelCreatedAsc: "de antiguos a nuevos",
      filterOptionLabelLeadsDesc: "Por leads (descendente)",
      filterOptionLabelLeadsAsc: "Por leads (ascendente)",
      filterOptionLabelWithProject: "Cuestionarios en proyectos",
      filterOptionLabelWithoutProject: "Cuestionarios sin proyecto",
      workboardDuplicate: "Duplicar",
      leadsTable: "Lista de Leads",
      exportInfo: "Exportar Leads",
      leadHide: "Ocultar",
      leadShowMore: "Mostrar más",
      poperTrashcan: "Papelera",
      restoreQuizSendedTitle: "Una tarea de recuperación está en curso",
      restoreSuizSendedImportant: "Importante",
      restoreQuizSendedDescription: "Dependiendo de cuántos leads haya en su quiz, la restauración puede tardar de unos segundos a 2 minutos. Después de la restauración, el quiz aparecerá en su tablero principal.",
      ok: "De acuerdo",
      month: "{n} month",
      discount: "Descuento de hasta",
      saveMoney: "Suscripción por un año",
      upProVersionMobile: "A PRO",
      upProVersionDesktop: "Cambiar a PRO",
      csettingsIntegrationSendPulse: "Integración - Send Pulse",
      csettingsIntegrationMailchimp: "Integración - Mailchimp",
      csettingsIntegrationMake: "Integración - Make",
      csettingsIntegrationZapier: "Integración - Zapier",
      csettingsIntegrationCRMBitrix: "Integración - CRM Bitrix",
      csettingsIntegrationPipeDrive: "Integración - Pipe Drive",
      csettingsIntegrationRemOnline: "Integración - Rem Online",
      csettingsIntegrationKeyCRM: "Integración - Key CRM",
      csettingsIntegrationGoogleSpreadsheets: "Integración - Google Spreadsheets",
      csettingsIntegrationKeepinCrm: "Integración - KeepinCRM",
      csettingsIntegrationZapierAbout: "Pegue la URL de envío de datos proporcionada por Zapier en el campo de entrada.",
      csettingsIntegrationMakeAbout: "Pegue la URL de envío de datos proporcionada por Make en el campo de entrada.",
      csettingsIntegrationMakeAboutTextStep1: "Para configurar la integración con",
      csettingsIntegrationMakeAboutTextStep2: ", vea e",
      csettingsIntegrationMakeAboutTextStep3: "Para configurarlo, seleccione “Webhooks” entre las integraciones en Make, luego elija “Custom webhook”.",
      csettingsIntegrationMakeAboutTextStep4: "Copie el enlace generado y péguelo en el campo de abajo en ADS Quiz.",
      csettingsIntegrationMakeAboutTextStep5: "Para probar, vuelva a Make, haga clic en “Run” y complete el quiz enviando un lead.",
      csettingsIntegrationMakeAboutTextStep6: "Si la prueba es exitosa, guarde la integración y no olvide activar las actualizaciones.",
      csettingsIntegrationMakeAboutLinkVideoText: "video",
      csettingsIntegrationCRMBitrixAbout: "Pegue la URL de envío de datos proporcionada por CRM Bitrix en el campo de entrada.",

      csettingsIntegrationSendPulseAboutStart: "Puedes configurar la integración con el servicio ",
      csettingsIntegrationSendPulseAboutMiddle: ". Para hacerlo, ve a la configuración de tu cuenta y abre la pestaña ",
      csettingsIntegrationSendPulseAboutEnd: ". Copia los valores de los parámetros 'ID' y 'Secret', y pégalos en los campos correspondientes en el servicio ADS Quiz (en los campos a continuación). Luego, debes ingresar el ID del libro de direcciones. Para hacer esto, accede al libro de direcciones deseado y copia del URL el valor después de id/. Solo se necesitan números, sin caracteres adicionales. Guarda los cambios. Una guía más detallada está disponible en el ",
      csettingsIntegrationSendPulseAboutLinkSendPulse: "https://sendpulse.com/latam#60c9ccfd55f4b'",
      csettingsIntegrationSendPulseAboutLinkAPI: "https://login.sendpulse.com/login/#api",
      csettingsIntegrationSendPulseAboutLinkVideo: "https://www.youtube.com/watch?v=4mnhpbKkePs",
      csettingsIntegrationSendPulseAboutLinkVideoText: "video",

      csettingsIntegrationKeyCRMAbout: "Pegue la clave API y el PipelineID en los campos correspondientes.",
      csettingsIntegrationPipeDriveAbout: "Pegue el token y el dominio de la empresa en los campos correspondientes.",
      csettingsIntegrationRemOnlineAbout: "Pegue la clave API de Rem Online en el campo correspondiente.",
      csettingsIntegrationGoogleSheetsAbout: "Inicie sesión en Google Sheets (si su cuenta está registrada con una dirección de Gmail, solo puede conectar esa cuenta de Gmail; si intenta conectar una cuenta diferente, se producirá un error), seleccione la hoja y asigne los campos para empezar a transferir datos.",
      csettingsIntegrationMailchimpAbout: "Conecta Mailchimp, elige una audiencia y asigna los campos si es necesario.",
      csettingsIntegrationKeepinCrmAbout: "Pegue la clave API de KeepinCRM, elija pipeline, estado, gerente y fuente, y habilite el mapeo de campos si es necesario.",
      csettingsIntegrationActiveIntegration: "Integración activa",
      cintegrationIntegrationData: "Datos de integración",
      cintegrationMailchimpAudience: "Audiencia",
      cintegrationMailchimpAudiencePlaceholder: "Selecciona audiencia",
      cintegrationMailchimpStatus: "Estado de suscripción",
      cintegrationMailchimpStatusOptionSubscribed: "subscribed (Suscrito)",
      cintegrationMailchimpStatusOptionPending: "pending (Pendiente de confirmación)",
      cintegrationMailchimpStatusOptionUnsubscribed: "unsubscribed (Dado de baja)",
      cintegrationMailchimpStatusOptionCleaned: "cleaned (Eliminado)",
      cintegrationMailchimpStatusOptionTransactional: "transactional (Solo transaccionales)",
      cintegrationMailchimpStatusDescriptionSubscribed: "el contacto podrá recibir tus boletines.",
      cintegrationMailchimpStatusDescriptionPending: "el usuario aún no ha confirmado la suscripción por email.",
      cintegrationMailchimpStatusDescriptionUnsubscribed: "el contacto se ha dado de baja de los boletines.",
      cintegrationMailchimpStatusDescriptionCleaned: "los correos no se pueden entregar.",
      cintegrationMailchimpStatusDescriptionTransactional: "se usa solo para correos de servicio, no para marketing.",
      cintegrationMailchimpConnect: "Conectar Mailchimp",
      cintegrationMailchimpConnectTo: "Conecta Mailchimp",
      cintegrationMailchimpConnectedTo: "Conectado a Mailchimp",
      cintegrationMailchimpUseMapping: "Configuración de campos",
      cintegrationMailchimpDataSaved: "Datos de integración de Mailchimp guardados",
      cintegrationDataMailchimpError: "Selecciona una audiencia de Mailchimp",
      cintegrationMailchimpMappingError: "Completa el mapeo de campos",
      cintegrationMailchimpNoTags: "Mailchimp no tiene etiquetas",
      cintegrationIntegrationUrl: "URL de integración",
      cintegrationWriteUrl: "Ingresar URL",
      cintegrationDataFBError: "Identificador de píxel incorrecto",
      cintegrationDataWebHookError: "Dirección de webhook no válida",
      cintegrationZapierDataSaved: "Datos de integración de Zapier guardados",
      cintegrationDataZapierError: "Dirección de integración no válida",
      cintegrationAPIxDriveDataSaved: "Datos de integración de APIxDrive guardados",
      cintegrationDataAPIxDriveError: "La cadena no es una dirección de integración de APIxDrive",
      cintegrationMakeDataSaved: "Datos de integración de Make guardados",
      cintegrationDataMakeError: "Dirección de integración no válida",
      cintegrationSendPulseDataSaved: "Datos de integración de SendPulse guardados",
      cintegrationDataSendPulseError: "Datos de integración no válidos o vacíos",
      cintegrationPipeDriveDataSaved: "Datos de integración de PipeDrive guardados",
      cintegrationDataPipeDriveError: "Datos de integración no válidos o vacíos",
      cintegrationRemOnlineDataSaved: "Datos de integración de RemOnline guardados",
      cintegrationDataRemOnlineError: "Datos de integración no válidos o vacíos",
      cintegrationKeyCRMDataSaved: "Datos de integración de KeyCRM guardados",
      cintegrationDataKeyCRMError: "Datos de integración no válidos o vacíos",
      cintegrationInputEmailUrl: "Ingrese el correo electrónico",
      cintegrationEmailDataSaved: "Correo electrónico guardado",
      cintegrationDataEmailError: "La cadena ingresada no es un correo electrónico",
      cintegrationCRMBitrixDataSaved: "Correo electrónico guardado",
      cintegrationDataCRMBitrixError: "La cadena ingresada no es un correo electrónico",
      cintegrationTelegramBotDataSaved: "Configuración de integración de Telegram guardada",
      cintegrationDataTelegramBotError: "Error al guardar",
      cintegrationGTMDataSaved: "ID de Google Tag Manager guardado",
      cintegrationDataGTMError: "ID no válido",
      cintegrationDataGTMErrorDescription: "El ID debe tener el formato GTM-XXXXXX",
      cintegrationGoogleAnalyticsDataSaved: "ID de Google Analytics guardado",
      cintegrationDataGoogleAnalyticsError: "ID incorrecto",
      cintegrationDataGoogleAnalyticsErrorDescription: 'El ID debe tener el formato "UA-XXXXXXX-X" o "G-XXXXXXXXXX-XX"',
      cintegrationTikTokDataSaved: "Píxel de Tik-Tok guardado",
      cintegrationDataTikTokError: "La cadena ingresada no es un píxel de Tik-Tok",
      cintegrationIntegrationToken: "Token de integración",
      cintegrationWriteToken: "Ingrese el token de integración",
      cintegrationDataYourAPIKey: "Ingrese su clave API",
      viewQuizInMobile: "Ver Quiz",
      notificationCSRFTokenMismatch: "Incompatibilidad de token CSRF",
      notificationReloadPage: "Por favor, recargue la página e intente nuevamente",
      csettingsIntegrationKeyRemOnline: "Pegue el token y el ID del canal en los campos correspondientes",
      cintegrationDataYourIntegrationToken: "Clave API",
      cintegrationDataLeadTypeId: "ID del canal",
      send_utm: "Enviar etiquetas UTM",
      send_quiz: "Enviar datos del quiz",
      send_answers: "Enviar respuestas",
      csettingsIntegrationKeyCrm: "Integración KeyCRM",
      cintegrationSendPulseClientId: "ID del cliente",
      cintegrationSendPulseClientSecret: "Secreto",
      cintegrationSendPulseAddressBookId: "ID de la libreta de direcciones",
      cintegrationSendPulseAction: "Acción con contacto",
      sendpulseActionAddContact: "Agregar contacto",
      sendpulseActionDeleteContact: "Eliminar contacto",
      cintegrationPipeDriveToken: "Token API",
      cintegrationPipeDriveDomain: "Su subdominio único",
      cintegrationKeyCrmApiKey: "Clave API",
      cintegrationKeyCrmPipelineId: "ID del pipeline",
      cintegrationMenuGoogleTagManager: "Google Tag Manager",
      cintegrationMenuGoogleAnalytics: "Google Analytics",
      cintegrationMenuFacebookPixel: "Píxel de Facebook",
      cintegrationMenuTikTokPixel: "Píxel de TikTok",
      cintegrationMenuWebHook: "Webhook",
      cintegrationMenuZapier: "Zapier",
      cintegrationMenuAPIxDrive: "APIx Drive",
      cintegrationMenuMake: "Make",
      cintegrationMenuSendPulse: "Send Pulse",
      cintegrationMenuMailchimp: "Mailchimp",
      cintegrationMenuEmail: "Correo electrónico",
      cintegrationMenuTelegramBot: "Bot de Telegram",
      cintegrationMenuPipeDrive: "PipeDrive",
      cintegrationMenuRemOnline: "Rem Online",
      cintegrationMenuKeyCRM: "Key CRM",
      cintegrationMenuCRMBitrix: "CRM Bitrix",
      cintegrationMenuGoogleSpreadsheets: "Google Spreadsheets",
      cintegrationMenuKeepinCRM: "KeepinCRM",
      googleSignIn: "Iniciar sesión con Google",
      googleSignInHint: "Autorícese para continuar configurando la integración.",
      cintegrationGoogleSpreadsheetID: "ID de la hoja de cálculo",
      cintegrationGoogleSheetName: "Nombre de la hoja",
      googleSheetNameTip: "Usa el nombre de la hoja exactamente como aparece en Google Sheets.",
      googleSheetsMappingTitle: "Asignación de campos",
      cintegrationGoogleSheetsSaved: "Datos de Google Spreadsheets guardados",
      googleSheetsSelectSheet: "Seleccione una hoja",
      googleSheetsSelectSheetPlaceholder: "Seleccione una hoja",
      googleSheetsSelectSheetFirst: "Seleccione primero la hoja para configurar el mapeo",
      cintegrationKeepinPipelineId: "Pipeline",
      cintegrationKeepinPipelineIdPlaceholder: "Seleccione pipeline",
      cintegrationKeepinStatusId: "Estado",
      cintegrationKeepinStatusIdPlaceholder: "Seleccione estado",
      cintegrationKeepinManagerId: "Gerente",
      cintegrationKeepinManagerIdPlaceholder: "Seleccione gerente",
      cintegrationKeepinSourceId: "Fuente",
      cintegrationKeepinSourceIdPlaceholder: "Seleccione fuente",
      cintegrationKeepinUseMapping: "Usar mapeo de campos",
      cintegrationKeepinDataSaved: "Datos de KeepinCRM guardados",
      trashcanRestoreQuiz: "Restaurar Quiz",
      cformValuePromotionAccepted: "Acepto el boletín de correo electrónico",
      constructorAddIntegration: "Agregar una nueva integración",
      cintegrationKeyCrmSourceId: "ID de fuente (opcional)",
      cintegrationKeyCrmManagerId: "ID del gerente (opcional)",
      cSettingsSettingQuizSpamFilterTitle: "Protección contra spam",
      cSettingsSettingQuizSpamFilterDescription: "Esta función está desactivada por defecto. Si encuentra leads de spam, active la protección. Después de eso, un solo usuario no podrá enviar más del número especificado de leads para este quiz.",
      cSettingsSettingQuizSpamFilterLimitPlaceholder: "Número de leads",
      langNO: "Noruego",
      loadMoreLeads: "Ver más leads",
      userAdditionalSettingsHeader: "Ajustes adicionales",
      userAdditionalSettingsDescription1: "Aquí puede configurar nuevas configuraciones avanzadas de perfil.",
      userAdditionalSettingsPagination: "Paginación en el tablero",
      benefitType: "Tipo de beneficio",
      benefitLabelPlaceholder: "Texto de bono",
      benefitDescriptionPlaceholderDiscount: "Código promocional o instrucción",
      benefitDescriptionPlaceholderVideo: "Enlace al video",
      benefitDescriptionPlaceholderTextfile: "Enlace al archivo de texto",
      benefitDescriptionPlaceholderGift: "Descripción del bono",
      benefitDescriptionPlaceholderPDF: "Enlace al PDF",
      benefitDescriptionPlaceholderLink: "Enlace",
      benefitDescriptionPlaceholderFile: "Enlace al archivo",
      benefitDescriptionPlaceholderCustom: "Enlace",
      benefitLabelDiscount: "Descuento",
      benefitLabelVideo: "Video",
      benefitLabelTextfile: "Archivo de texto",
      benefitLabelGift: "Regalo",
      benefitLabelPDF: "Archivo PDF",
      benefitLabelLink: "Enlace",
      benefitLabelFile: "Archivo",
      benefitLabelCustom: "Bono personalizado",
      addBenefit: "Agregar beneficio",
      saveBenefit: "Guardar bono",
      cfinishSocialNetworks: "Redes sociales",
      saveSocialNet: "Guardar red social",
      networkLabelFacebook: "Facebook",
      networkLabelInstagram: "Instagram",
      networkLabelTelegram: "Telegram",
      networkLabelTiktok: "Tik-Tok",
      networkLabelYoutube: "YouTube",
      networkLabelLinkedin: "LinkedIn",
      networkLabelWhatsapp: "WhatsApp",
      socialNetDescriptionPlaceholderFacebook: "perfil_nikname",
      socialNetDescriptionPlaceholderInstagram: "perfil_nikname",
      socialNetDescriptionPlaceholderTelegram: "perfil/canal_nikname",
      socialNetDescriptionPlaceholderTiktok: "perfil_nikname",
      socialNetDescriptionPlaceholderYoutube: "nombre_del_canal",
      socialNetDescriptionPlaceholderLinkedin: '"in/name" o "company/name"',
      socialNetDescriptionPlaceholderWhatsapp: "+15555551234",
      addNewSectionEmptyPage: "Página de texto simple",
      csanyMakeImpasse: "Impasse",
      impaseIsImpaseTrue: "Encendido",
      impaseIsImpaseFalse: "Apagado",
      defaultNewEmptyQuestionDescription: "Puede pegar y formatear texto largo aquí (no recomendamos pegar más de 3000 caracteres).",
      cSettingsSettingQuizTimezoneTitle: "Zona horaria del quiz",
      cSettingsSettingQuizTimezoneDescription: "Ingrese la zona horaria en la que se registrará el tiempo de envío de leads. Esto es útil especialmente si usted y el cliente están en diferentes zonas.",
      cSettingsSettingQuizTimezonePlaceholder: "Zona horaria",
      userAdditionalSettingsTimezone: "Zona horaria del usuario",
      userAdditionalSettingsTimezonePlaceholder: "Zona horaria",
      langHE: "Hebreo",
      langCS: "Checo",
      cintegrationCAPIFBInstruction: "Para configurar la integración con la API de Conversión de Facebook, debe ingresar el ID de píxel y el token de acceso. Estos datos se obtienen en la configuración de Facebook Business Manager. Después de ingresar la información requerida, guarde la integración.",
      cintegrationCAPIFBInstructionTextTitle: "Nombres de eventos para FB Conversions:",
      cintegrationCAPIFBInstructionTextStart: " – visita a la página de inicio;",
      cintegrationCAPIFBInstructionTextQuestionN: " – visita al paso N (el número del paso se inserta dinámicamente);",
      cintegrationCAPIFBInstructionTextOpenContactPage: " – visita a la página de contacto;",
      cintegrationCAPIFBInstructionTextLead: " – envío exitoso del formulario de contacto;",
      cintegrationCAPIFBInstructionTextThankYou: " – visita a la página final.",
      cintegrationCAPIFBInstructionTextOptimizationAdvice: "Recomendamos ejecutar anuncios optimizados para el evento",
      cintegrationCAPIFBInstructionTextLeadTriggerCondition: "Este evento se activa",
      bold_capi_adsquiz_Start: "capi_adsquiz_Start",
      bold_capi_adsquiz_QuestionN: "capi_adsquiz_Question-N",
      bold_capi_adsquiz_OpenContactPage: "capi_adsquiz_OpenContactPage",
      bold_capi_adsquiz_Lead: "capi_adsquiz_Lead",
      bold_capi_adsquiz_ThankYou: "capi_adsquiz_ThankYou",
      bold_capi_adsquiz_OptimizationAdvice: "“capi_adsquiz_Lead”.",
      bold_capi_adsquiz_LeadTriggerCondition: "solo cuando un usuario envía un lead con éxito.",
      csettingsIntegrationFbCapiAbout: "La integración con la API de Conversión de Facebook le permite enviar datos de interacción del usuario directamente a Facebook para mejorar la efectividad de las campañas publicitarias.",
      cintegrationInputCapiAccessToken: "Ingrese el token de acceso",
      cintegrationInputCapiCustomparameter: "Ingrese los parámetros de evento personalizado",
      cintegrationDataFbCapiSaved: "Integración con la API de Conversión de Facebook guardada exitosamente",
      cintegrationComonRenovateHubInstructionTitle: "Instrucciones para configurar la integración con «Міністерство Ремонту»",
      cintegrationComonRenovateHubInstructionDescription1: "Para configurar la integración con «Ministerstvo Remontu», indique la URL del webhook a la que se enviarán los datos.",
      cintegrationComonRenovateHubInstructionDescription2: "Para ello, vaya al «Panel de administración», luego abra la sección «Integraciones» y seleccione ADS Quiz. Haga clic en «Crear webhook URL», cópielo y péguelo en el campo de entrada a continuación en el servicio ADS Quiz.",
      cintegrationComonRenovateHubInstructionDescription3: "Después, complete el quiz para probar o envíe un lead de prueba usando el botón «Test».",
      cintegrationComonRenovateHubInstructionDescription4: "Luego guarde y active la integración. Todos los leads se enviarán a «Ministerstvo Remontu» en la sección «Solicitudes».",
      cintegrationComonRenovateHubInstructionShort: "La integración con «Міністерство Ремонту» le permite enviar datos al CRM a través de un webhook para la automatización de procesos.",
      cintegrationRenovateHubUrl: "Ingrese la URL de «Міністерство Ремонту»",
      cintegrationInputRenovateHubUrl: "Especifique la URL del webhook para «Міністерство Ремонту»",
      cintegrationRenovateHubDataSaved: "Integración con «Міністерство Ремонту» guardada exitosamente",
      cintegrationDataRenovateHubError: "Error al guardar la integración con «Міністерство Ремонту». Por favor, verifique que los datos ingresados sean correctos.",
      cintegrationMenuFacebookConvAPI: "API de Conversiones de Facebook",
      cintegrationMenuRenovateHub: "Міністерство Ремонту",
      csettingsIntegrationRenovateHub: "Integración de «Міністерство Ремонту»",
      csettingsIntegrationCAPIFB: "Integración de la API de Conversiones de Facebook",
      paymentPlanEnd: "Fecha de finalización del plan",
      paymentPlanNextPayment: "Próximo pago",
      paymentPlanLeadsLimitForYear: "Límite de leads por año:",
      paymentPlanLeadsLimitForPeriod: "Límite de leads por período:",
      EditTags: "Editar etiquetas",
      quizzesTemplatesNoTags: "Sin etiquetas",
      Monday: "Lunes",
      Tuesday: "Martes",
      Wednesday: "Miércoles",
      Thursday: "Jueves",
      Friday: "Viernes",
      Saturday: "Sábado",
      Sunday: "Domingo",
      datetimeDisplayMode: "Tipo de selector",
      datetimeDisplayModeSelect: "Seleccionar tipo",
      datetimeDisplayModeDate: "Fecha",
      datetimeDisplayModeTime: "Hora",
      datetimeDisplayModeDatetime: "Fecha y Hora",
      datetimeMinDate: "Fecha mínima",
      datetimeMinDateCustom: "Seleccione la fecha mínima",
      datetimeMaxDate: "Fecha máxima",
      datetimeMaxDateCustom: "Seleccione la fecha máxima",
      datetimeProhibitDaysOfWeek: "Restringir días",
      datetimeIsRange: "Habilitar rango",
      datetimeIsRangeTrue: "Rango habilitado",
      datetimeIsRangeFalse: "Rango deshabilitado",
      datetimeMinTime: "Hora mínima",
      datetimeMaxTime: "Hora máxima",
      datetimeIs24: "Formato de 24 horas",
      datetimeIs24True: "Formato de 24 horas habilitado",
      datetimeIs24False: "Formato de 24 horas deshabilitado",
      csanyIsExactDate: "¿Cómo le gustaría establecer la fecha?",
      csanyIsExactDateTrue: "Fecha exacta",
      csanyIsExactDateFalse: "Fecha relativa",
      csanyDatetimeMinMaxNotExactPlaceholder:'"x" o "-x" días desde hoy',
      addNewSectionDatetime: "Fecha/Hora",
      tariffsPromo: "Ofertas especiales",
      pricingComparisonEyebrow: 'Precios de Adsquiz',
      pricingComparisonTitle: 'Elige uno de nuestros planes',
      pricingComparisonMobileHint: 'Desliza las tarjetas de planes y elige dos abajo para compararlos.',
      pricingComparisonTableAria: 'Pricing plans comparison table',
      pricingComparisonMonthShort: 'mes',
      billingPromoPeriodYearly: "año",
      billingPromoPeriodMonths: "{count} meses",
      billingPromoDescription: "Sin límites en quizzes ni funciones",
      pricingComparisonTryFree: 'Probar gratis',
      pricingComparisonGetStarted: 'Mejorar',
      pricingComparisonCurrentPlan: 'Tu plan actual',
      pricingComparisonBuyAgain: 'Comprar de nuevo',
      pricingComparisonLeadsPerMonth: '{count} leads /mes',
      pricingComparisonUnlimited: 'Ilimitado',
      pricingComparisonTeamUsers: '+{n} usuario | +{n} usuarios',
      pricingComparisonRequired: 'Obligatorio',
      pricingComparisonOptional: 'Opcional',
      tariffsMonth: "Mensualmente",
      tariffsAnual: "Anualmente",
      leadsOn1Month: "por mes",
      leadsOn2Month: "por 2 meses",
      leadsOn3Month: "por 3 meses",
      leadsOn4Month: "por 4 meses",
      leadsOn5Month: "por 5 meses",
      leadsOn6Month: "por 6 meses",
      leadsOn7Month: "por 7 meses",
      leadsOn8Month: "por 8 meses",
      leadsOn9Month: "por 9 meses",
      leadsOn10Month: "por 10 meses",
      leadsOn11Month: "por 11 meses",
      leadsOn12Month: "por año",
      leadsOn24Month: "por 2 años",
      leads: "prospectos",
      tariffsWordPrice: "Precio",
      tariffsNoLimits: "Sin límites",
      tariffsNoLimitsQuizzes: "en encuestas",
      tariffsAndFunctions: "y funcionalidades",
      billingTariffYear: "año",
      billingChangePlanSubscribe: "Suscribirse",
      paymentAllTariffInactive: "Tarifa no activa",
      subscriptionTariffLableOnly: "Disponible solo para suscripción",
      notExactBeforeYear: "hace un año",
      notExactBeforeHalfYear: "hace medio año",
      notExactBeforeQuarter: "hace un cuarto de año",
      notExactBeforeMonth: "hace un mes",
      notExactBeforeWeek: "hace una semana",
      notExactBeforeYesterday: "anteayer",
      notExactYesterday: "ayer",
      notExactToday: "hoy",
      notExactTomorrow: "mañana",
      notExactAfterTomorrow: "pasado mañana",
      notExactAfterWeek: "en una semana",
      notExactAfterMonth: "en un mes",
      notExactAfterQuarter: "en un cuarto de año",
      notExactAfterHalfYear: "en medio año",
      notExactAfterYear: "en un año",
      tipDefaultDateHeader: "Por defecto",
      tipDefaultDateText: "Si los interruptores de 'Fecha Exacta' y 'Fecha Relativa' están desactivados, el calendario permitirá seleccionar fechas desde el año 1800 hasta el 2200 de manera predeterminada.",
      tipExactDateHeader: "Interruptor de fecha exacta",
      tipExactDateText: "Activar este interruptor limitará el calendario a un rango de fechas fijo definido por la(s) fecha(s) exacta(s) seleccionada(s) en los campos de entrada a continuación.",
      tipRelativeDateHeader: "Interruptor de fecha relativa",
      tipRelativeDateText: "Activar este interruptor establecerá dinámicamente los límites del calendario según las fechas relativas calculadas en el momento de cargar la página. Estos límites son personalizados y se recalculan individualmente para cada usuario.",
      langPT: "Portugués",
      placeholderCompanyContactText: 'Por ejemplo: "Teléfono de la empresa: +34993322211"',
      integrationConnectService: "Conectar",
      Connect: "Conectar",
      Connected: "Conectado",
      Disconnect: "Desconectar",
      cintegrationOauthDisconnectModalTitle: "¿Desconectar {provider}?",
      cintegrationOauthDisconnectModalDescription: "Al desconectar {provider}, esta integración se desconectará de TODOS los cuestionarios. Si solo deseas desactivarla en este cuestionario, elimina la integración a continuación.",
      cintegrationOauthDisconnectModalDescriptionBase: "Al desconectar {provider}, esta integración se desconectará de TODOS los cuestionarios.",
      cintegrationOauthDisconnectModalDescriptionDeleteHint: "Si solo deseas desactivarla en este cuestionario, elimina la integración a continuación.",
      cintegrationOauthDisconnectDeleteQuizOnly: "Eliminar solo en este cuestionario",
      cintegrationOauthDisconnectAllQuizzes: "Desconectar en todos los cuestionarios",
      leadtype_id: "Tipo de acción",
      selectVariant: "Seleccionar",
      sfirstAddCompanyContacts: "Texto con contactos",
      addNewSectionTextarea: "Campo de texto grande",
      allstepsVariantView: "Formato de aislamiento",
      tariffsDiscountSave: "Ahorra",
      cAdminSettingsTitle: "Configuraciones administrativas",
      cAdminSettingsInstruction: "Ingrese las etiquetas para el cuestionario en el campo a continuación. Las etiquetas pueden consistir en varias palabras, cada etiqueta se separa con una coma. Las etiquetas 'Servicios' y 'servicios' son etiquetas diferentes. Se recomienda usar etiquetas que comiencen con una letra mayúscula. También puede excluir el cuestionario de la lista de plantillas.",
      cAdminSettingsIsTemplate: "Es una plantilla",
      cIsTemplateStateAreSaved: "El estado de la plantilla se ha guardado",
      sfirstAddLogotype: "Añade un logotipo",
      logotypeSizeTip: "El logotipo se insertará en su tamaño real, pero no será mayor de 120 píxeles en el lado más largo.",
      cfirstLogotypeUpdated: "El logotipo ha sido añadido",
      cfirstLogotypeDeleted: "¡El logotipo ha sido eliminado con éxito!",


      cOffersPageSettings: "Configuraciones",
      offerPageTitlePlaceholder: "Ingrese el título",
      offerPageDescriptionPlaceholder: "Ingrese la descripción de la página",
      offerPageButtonTextPlaceholder: "Ingrese el texto del botón (opcional)",
      allstepsOffers: "Lista de ofertas",
      offerProposalHeader: "Oferta",
      offerAttachAddImg: "Agregar imagen",
      offerAttachAddVideo: "Agregar video",
      offerItemImg: "Imagen",
      offerItemTitle: "Título de la oferta",
      offerTitlePlaceholder: "Ingrese el título aquí",
      offerItemSubtitle: "Subtítulo (ej. precio)",
      offerSubtitlePlaceholder: "Ingrese el texto aquí",
      offerItemDescription: "Descripción de la oferta",
      offerDescriptionPlaceholder: "Ingrese la descripción aquí",
      offerItemButtonText: "Texto del botón de la oferta",
      offerBtnTextPlaceholder: "Ingrese el texto del botón",
      offerItemButtonLink: "Enlace del botón",
      offerBtnLinkPlaceholder: "El enlace debe comenzar con https://",
      csanyOfferLogic: "Lógica de visualización",
      offerAddNewOffer: "Agregar nueva oferta",
      offerLogicSetupTitle: "Configuración de lógica",
      OfferLogicSetupDescription: "Aquí puedes configurar qué respuestas mostrarán ciertas ofertas",
      cstepsOffersPage: "Página de resultados",
      addNewSectionResultsByLogic: "Ofertas",
      cformActionAfterContactOffersOr: "Página de ofertas / ",
      tolltipOffersAfterContact: "Si después de completar el cuestionario se cumple la lógica para mostrar al menos una oferta, se mostrará la página de ofertas; de lo contrario, se mostrará la página de agradecimiento.",
      videoCircleTextQuestion: "Instrucción en video",
      offerPhotoOptimalRatio: "Para una visualización óptima de la imagen, recomendamos usar una proporción de 16:9.",
      tolltipThankYouAfterContact: "Después de completar el cuestionario, se mostrará una página de agradecimiento.",
      cformActionAfterContactOffers: "Página de resultados",
      addOfferPageInContact: "Habilitar página de resultados",
      offerPageHeader: "Encabezado para la página de ofertas",
      pumkinOrange: "Naranja",
      invalidSocialNetworkURL: "Enlace no válido", 
      itMustBeFullLink: 'Verifique que el enlace ingresado sea correcto. Debe comenzar con el protocolo "https://" y coincidir con la red social almacenada.',
      addSocialLinks: "Agregar enlaces sociales",
      questionAttachAddImg: "Foto",
      questionAttachAddVideo: "Vídeo",
      questionChooseLineInput: "En línea",
      questionChooseClassicInput: "Clásico",
      questionChooseOneColumn: "1 columna",
      questionChooseTwoColumns: "2 columnas",
      allStepsVideoUrl: "Enlace al vídeo",
      allStepsPhotoHeader: "Foto",
      cintegrationMenuSalesDrive: "SalesDrive",
      csettingsIntegrationSalesDrive: "Integración - SalesDrive",
      csettingsIntegrationSalesDriveAbout: "Puedes enviar leads al CRM SalesDrive",
      cintegrationSalesDriveApiKey: "Insertar clave API",
      cintegrationSalesDriveDomain: "Insertar el dominio proporcionado por SalesDrive",
      cintegrationSalesDriveDataSaved: "Integración con SalesDrive guardada",
      send_offers: "Enviar ofertas mostradas al visitante",
      cformShowConsultant: "Mostrar al consultor",
      consultantPhoto: "Foto del consultor",
      consultantName: "Nombre del consultor",
      consultantJobTitle: "Puesto del consultor u otra información",
      consultantRating: "Valoración del consultor",
      signinIWouldLikeReciveEmail: "Deseo recibir noticias y ofertas especiales de ADS QUIZ (Puede darse de baja de estas comunicaciones en cualquier momento).",
      acceptedFileSizeUpTo: "hasta",
      customDesignColorTags: "Etiquetas",
      customDesignColorActiveButton: "Color del elemento activo",
      customDesignColorInactiveButton: "Color del elemento inactivo",
      customDesignColorActiveText: "Color del texto activo",
      customDesignColorInactiveText: "Color del texto inactivo",
      addNewSectionDropdown: "Dropdown",
      langFR: "Francés",
      addNewSectionRatePage: "Página de calificación",
      bold_adsquiz_Offers_page: "adsquiz_Open-Offers-Page",
      cintegrationFBInstructionTextOffersPage: "Ir a la página de ofertas",
      defaultNewQuestionDropdownPlaceholder: "Haz clic aquí para ver la lista de opciones",
      allStepsVideoUrlPlaceholder: "https://youtube, vimeo o wistia",
      addListOfAnswersButton: "Agregar múltiples",
      addListOfAnswersTitle: "Agregar múltiples opciones de respuesta",
      addListOfAnswersInstruction: "Pega la lista de opciones de respuesta en este campo para agregarlas. Las opciones pueden estar separadas por saltos de línea [↵], punto y coma [;], comas [,] o espacios [ ]. La separación se realiza utilizando el separador de mayor prioridad: [↵] → [;] → [,] → [ ].",
      addListOfAnswersPlaceholder1: "Respuesta 1",
      addListOfAnswersPlaceholder2: "Respuesta 2",
      addListOfAnswersSendButton: "Agregar",
      addNewPerson: "Añadir participante",
      cfirstGradientOverlay: "Superposición de fondo con gradiente",
      cfirstGradientOverlayTip: "La superposición de fondo con gradiente es útil si la imagen de fondo tiene poco contraste con el color del texto.",
      cfirstContentBorder: "Borde divisor del contenido",
      workboardDuplicateToOthers: "Copiar a otra cuenta",
      workboardDuplicateAndTransferQuiz: "Duplicar cuestionario a otra cuenta",
      workboardDuplicateAndTransferQuizHintTitle: "Al duplicar un cuestionario, se copiará a la cuenta del destinatario como plantilla.",
      workboardDuplicateAndTransferQuizHintTitleSecond: "El cuestionario en la cuenta del destinatario estará vacío, sin clientes potenciales ni integraciones. El cuestionario actual permanecerá sin cambios. Para copiar un cuestionario a otra cuenta, uno de los usuarios debe tener cualquier ",
      workboardDuplicateAndTransferQuizConfirm: "Duplicar",
      workboardDuplicateAndTransferQuizStatus200: "Cuestionario copiado con éxito a la cuenta:",
      delOffersPageQuestionForModalConfirm: "¿Está seguro de que desea eliminar la página de ofertas?",
      offerPageDefaultDescription: "Ingrese aquí la descripción de la página de resultados",
      offerPageDefaultButtonText: "Finalizar",
      cintegrationMenuKommo: "Kommo",
      csettingsIntegrationKommo: "Integración - Kommo",
      csettingsIntegrationKommoAbout: "Puedes enviar leads al CRM Kommo",
      cintegrationKommoToken: 'Inserta el "Long-lived Token"',
      cintegrationKommoDomain: "Inserta tu subdominio",
      cintegrationKommoDataSaved: "Integración de Kommo guardada",
      cintegrationKommoPipelineId: "Inserta PipelineID",
      cintegrationKommoPipelineIdPlaceholder: "Selecciona embudo",
      cintegrationKommoStatusID: "Inserta StatusID",
      cintegrationKommoStatusIDPlaceholder: "Selecciona el estado del nuevo lead (opcional)",
      cintegrationKommoTagId: "Inserta TagID",
      cintegrationKommoTagIdPlaceholder: "Selecciona la etiqueta para el nuevo lead (opcional)",
      cintegrationKommoError: "Error al guardar la integración de Kommo. Verifica los datos ingresados.",
      cintegrationKommoDeleted: "Integración de Kommo eliminada",
      cintegrationKommoDeletedError: "Error al eliminar la integración de Kommo",
      cintegrationKommoCreateNote: "Crear una nota con las respuestas",
      cintegrationKommoUseMapping: "Usar mapeo de campos",
      mappingValue: "Campo en CRM",
      mappingValueMailchimp: "Campo en Mailchimp",
      mappingKey: "Campo en el lead",
      addMappingRow: "Agregar enlace de campos",
      DELETE: "Eliminar",
      mappingAnswer: "Respuesta a la pregunta",
      testIntegration: "Prueba",
      testIntegrationLast10Leads: "Prueba de integración (últimos 10 leads)",
      testIntegrationNeedRealLeadTooltip: "La prueba está disponible solo si el cuestionario tiene al menos un lead real.",
      loading: "Cargando...",
      sentAt: "Enviado",
      phone: "Teléfono",
      email: "Correo electrónico",
      action: "Acción",
      send: "Enviar",
      sending: "Enviando...",
      success: "Éxito",
      failed: "Fallo",
      error: "Error",
      displayCondition: "Condición de visualización",
      selectDisplayCondition: "Seleccionar condición de visualización",
      seconds: "Segundos",
      button: "Botón",
      buttonContainerSelector: "Selector del contenedor del botón",
      buttonContainerSelectorPlaceholder: ".quiz-buttons o #quiz-button-place",
      clickHere: "Haz clic aquí",
      buttonClick: "Clic en el botón",
      clickOnWidget: "Clic en el widget",
      exitIntent: "Al salir de la página",
      pageLoad: "Después de cargar la página",
      delay: "Después de un tiempo",
      resultPageSectionTitle: "Resultados por puntos",
      resultPageSectionAccordion: "Página de resultados por puntos",
      resultPageShowCondition: "Mostrar condición",
      resultPageShowCollectedPoints: "Mostrar puntos obtenidos",
      resultPageShowMaxPoints: "Mostrar puntos máximos",
      resultPageShowProgressBar: "Mostrar barra de progreso",
      resultPageSelectFormat: "Seleccionar formato de resultado",
      resultPageScenarios: "Escenarios",
      resultPageAddScenario: "Agregar escenario",
      resultPageScenarioPhoto: "Agregar foto",
      resultPageScenarioTitle: "Título",
      resultPageScenarioTitlePlaceholder: "Introduce el título del escenario",
      resultPageScenarioDescription: "Descripción",
      resultPageScenarioDescriptionPlaceholder: "Introduce la descripción del escenario",
      resultPageScenarioUrlPlaceholder: "Enlace (https://)",
      resultPageScenarioButtonText: "Texto del botón",
      resultPageScenarioButtonTextPlaceholder: "Introduce el texto del botón",
      resultPagePointsCondition: "Condición de visualización por puntos",
      resultPagePointsBetween: "Entre",
      resultPagePointsMoreThan: "Más que",
      resultPagePointsLessThan: "Menos que",
      resultPagePointsEqual: "Igual a",
      resultPageErrorAddNewScenario: "No se pudo agregar el escenario",
      resultPageErrorRangeExplanation: "Agrega más puntos o redistribúyelos entre los escenarios",
      resultPageErrorFullRange: "Todos los rangos de puntos ya están cubiertos",
      resultPageErrorOutOfRange: "Los puntos están fuera del rango permitido",
      resultPageErrorSaving: "Error al guardar los escenarios",
      resultPageErrorOverlap: "Los puntos en los escenarios no deben superponerse",
      resultPageAutoRedirectWarningTitle: "Redirección automática desactivada",
      resultPageAutoRedirectWarningText: "Para activar la redirección automática, agrega una URL en cada escenario de resultados.",
      resultPageAutoRedirectWarningButton: "OK",
      AddTags: "Agregar etiquetas",
      resultPageModalDescription: "Asigna puntos a cada respuesta.",
      resultPageYourOptions: "Sus opciones",
      placeholderDefaultValue: "Valor",
      resultPageByPointsTitle: "Resultados por puntos",
      resultPageConditionSettingsButton: "Lógica por puntos",
      resultPageConditionSettingsSaved: "Guardado",
      resultPageConditionSettingsUnsaved: "Guardar",
      resultPagePlaceholderScenarioTitle: "Título del escenario",
      resultPagePlaceholderScenarioDescription: "Aquí puedes ingresar una breve descripción de los resultados",
      resultPageLabelScenarioCti: "Llamado a la acción",
      resultPagePlaceholderScenarioCti: "Texto del botón",
      resultPagePlaceholderScenarioUrl: "Enlace del botón",
      resultPagePlaceholderRedirectUrl: "Enlace de redirección",
      resultPageScenarioSaveChanges: "Guardar cambios",
      resultPageScenarioSaveChangesComplete: "Cambios guardados",
      resultPageConditionSettingsTitle: "Configuración de resultados por puntos",
      resultPageConditionSettingsDescription: "Define un rango de puntos para cada escenario",
      resultPageConditionResultsColumn: "Resultados",
      resultPageConditionRangeSummary: "Rango máximo de puntos:",
      addNewSectionSubHeaderChoise: "Introducción/selección de respuesta",
      addNewSectionSubHeaderResults: "Resultados",
      noTeamRole: "-",
      viewerTeamRole: "Espectador",
      noAccessTeamRole: "Sin acciones",
      editorTeamRole: "Editor",
      managerTeamRole: "Gerente",
      adminTeamRole: "Administrador",
      teamRoleGuideTitle: "Qué significan los roles",
      teamRoleGuideDescription: "Un rol activa automáticamente un conjunto de permisos. Después de elegirlo, el rol se actualiza en la interfaz inmediatamente y Send envía el acceso seleccionado.",
      teamRoleGuideFlowOwner: "Propietario",
      teamRoleGuideFlowOwnerText: "otorga acceso",
      teamRoleGuideFlowRole: "Rol",
      teamRoleGuideFlowRoleText: "elige una plantilla",
      teamRoleGuideFlowPermissions: "Permisos",
      teamRoleGuideFlowPermissionsText: "habilitan acciones",
      teamRoleGuideFlowResult: "Interfaz disponible",
      teamRoleGuideFlowResultText: "muestra controles",
      teamRoleGuideViewerDescription: "Puede ver leads y respuestas de los cuestionarios seleccionados.",
      teamRoleGuideEditorDescription: "Puede editar el cuestionario, copiarlo y gestionar la publicación.",
      teamRoleGuideManagerDescription: "Puede editar el cuestionario, ver CRM, gestionar integraciones y compartir acceso.",
      teamRoleGuideAdminDescription: "Obtiene todos los permisos: gestión, integraciones, CRM, accesos, transferencia, eliminación y publicación.",
      canViewLeadsLabel: "Ver leads",
      canViewLeadsDescription: "Puede ver solicitudes, respuestas y contactos",
      canCopyQuizLabel: "Copiar cuestionario",
      canCopyQuizDescription: "Puede crear copias del cuestionario seleccionado",
      canManageQuestionsLabel: "Edición del cuestionario",
      canManageQuestionsDescription: "Puede editar el cuestionario, páginas, preguntas, variantes, consultores, beneficios, campos de contacto, redes sociales y opciones",
      canManageIntegrationsLabel: "Integraciones",
      canManageIntegrationsDescription: "Puede gestionar integraciones, claves y webhooks",
      canManageSettingsLabel: "Configuración",
      canManageSettingsDescription: "Puede cambiar dominios, páginas y campos de contacto",
      canShareLabel: "Accesos",
      canShareDescription: "Puede invitar a otros usuarios",
      canTransferLabel: "Transferencia del quiz",
      canTransferDescription: "Puede transferir el quiz a otro usuario",
      canDeleteLabel: "Eliminación",
      canDeleteDescription: "Puede eliminar y restaurar el quiz",
      canPublishLabel: "Publicación",
      canPublishDescription: "Puede gestionar la publicación y los dominios",
      descriptionTeamView: "Añade participantes y configura los accesos a proyectos y quizzes",
      addedUserInTeam: "En el equipo",
      teamAccessGivenTab: "Miembros del equipo",
      teamAccessReceivedTab: "Fuente de acceso",
      teamAccessReceivedTitle: "Acceso que te dieron",
      teamAccessSharedBy: "Propietario",
      teamAccessInvitedBy: "Invitado por",
      teamAccessRoleLabel: "Rol",
      teamAccessScopeLabel: "Acceso",
      teamNoReceivedAccess: "Nadie te ha dado acceso todavía",
      teamNoGivenAccess: "Todavía no has dado acceso a nadie",
      teamAccessFrozen: "Acceso congelado",
      teamFreezeAccess: "Congelar acceso",
      teamUnfreezeAccess: "Descongelar acceso",
      teamPermissionDeniedTransfer: "You do not have permission to move this quiz",
      teamPermissionDeniedDelete: "You do not have permission to delete or restore this quiz",
      teamPermissionDeniedShare: "You do not have permission to manage sharing",
      teamPermissionDeniedManageQuiz: "You do not have permission to edit this quiz",
      teamPermissionDeniedCopy: "You do not have permission to copy this quiz",
      teamPermissionDeniedIntegrations: "You do not have permission to manage integrations",
      teamPermissionDeniedCrm: "You do not have permission to view CRM",
      teamPermissionDeniedPublish: "You do not have permission to publish this quiz",
      teamPermissionDeniedSettings: "You do not have permission to open this settings section",
      teamPermissionDeniedOpenQuiz: "You do not have available actions for this quiz",
      teamAccessDeniedTitle: "Section unavailable",
      teamAccessDeniedDescription: "You do not have permission for this action. Ask the project owner to grant access",
      teamPermissionDeniedDefault: "You do not have permission for this action",
      teamQuizzesWithoutProject: "Quizzes without project",
      quickInviteTitle: "Invitar a un miembro del equipo",
      quickInviteEmailLabel: "Correo electrónico",
      quickInviteQuizzesLabel: "Cuestionarios para compartir",
      quickInviteLoadingQuizzes: "Cargando cuestionarios…",
      quickInviteLoadQuizzesError: "No se pudieron cargar los cuestionarios.",
      quickInviteRetry: "Reintentar",
      quickInviteNoQuizzes: "Aún no tienes cuestionarios que puedas compartir.",
      quickInviteRoleHint: "Recibirá el rol seleccionado en los cuestionarios seleccionados. Puedes cambiarlo más tarde en la {link}.",
      quickInviteRoleHintLink: "página Equipo",
      quickInviteSubmit: "Invitar",
      quickInviteSubmitting: "Enviando…",
      quickInviteSelfError: "No puedes invitarte a ti mismo",
      quickInviteSelectQuiz: "Selecciona al menos un cuestionario",
      quickInviteSuccess: "Invitación enviada a {email}",
      projectNoQuizzes: "0 cuestionarios",
      quizzes: "cuestionarios",
      sharedQuizzes: "Cuestionarios compartidos",
      sharedQuizzesWithoutProject: "Cuestionarios sin proyecto",
    },
    PT: {
      tariffLockBadgeLabel: "Pro",
      tariffLockBadgeReadOnlyLabel: "Somente leitura",
      tariffLockBadgeQuotaLabel: "Limite atingido",
      tariffLockBadgeAriaLabel: "{label}: funcionalidade restrita pelo seu plano",
      tariffUpgradeActionLabel: "Melhorar plano",
      tariffLockBadgeOwnerAriaLabel: "{label}: recurso restrito pelo plano do proprietário do quiz",
      tariffOwnerPlanFeatureUnavailableMessage: "Este recurso não está disponível no plano do proprietário do quiz. Peça ao proprietário para mudar para um plano que o inclua.",
      tariffOwnerAccessUnavailableMessage: "Não foi possível verificar o plano do proprietário do quiz. Atualize a página.",
      tariffGateCollaborationForbiddenMessage: "Você não tem permissão para esta ação neste quiz.",
      tariffGateQuotaExhaustedMessage: "Você usou todo o limite incluído no seu plano atual. Mude para um plano com limite maior.",
      tariffGateGrandfatheredMessage: "Esta funcionalidade não está disponível no seu plano atual. Os dados existentes continuam visíveis e podem ser excluídos, mas adicionar ou editar está desativado. Mude para um plano que a inclua.",
      tariffGateReadOnlyMessage: "Esta funcionalidade não está disponível no seu plano atual e é exibida em modo somente leitura. Mude para um plano que a inclua.",
      tariffGateUsageUnavailableMessage: "Não foi possível determinar o uso desta funcionalidade. Tente atualizar a página.",
      tariffGateLoadingMessage: "Verificando o acesso do seu plano…",
      tariffGateUnavailableMessage: "Esta funcionalidade não está disponível no seu plano atual. Mude para um plano que a inclua.",
      tariffUpgradeModalDescription: "Escolha um plano que inclua esta funcionalidade.",
      tariffUpgradeModalLoading: "Carregando planos adequados…",
      tariffUpgradeModalError: "Não foi possível carregar planos adequados. Tente novamente.",
      tariffUpgradeModalEmpty: "As assinaturas anuais estarão disponíveis em breve.",
      tariffUpgradeModalRecommended: "Recomendado",
      tariffUsageUnlimitedLabel: "Ilimitado",
      tariffUsageUsedOfLimitLabel: "{used} de {limit} usados",
      tariffUsageUnavailableLabel: "Uso indisponível",
      tariffUsageLoadingLabel: "Carregando uso…",
      tariffUsageUnknownLabel: "Uso desconhecido",
      notFoundEyebrow: 'Página não encontrada',
      notFoundTitle: 'Parece que este quiz se perdeu',
      notFoundDescription: 'O link pode estar incorreto ou a página foi movida. Volte ao painel de trabalho e continue criando questionários.',
      notFoundPrimaryAction: 'Ir para o início',
      notFoundSecondaryAction: 'Voltar',
      serverErrorEyebrow: 'Erro do servidor',
      serverErrorTitle: 'Algo deu errado',
      serverErrorDescription: 'Não se preocupe, já estamos trabalhando nisso. Tente atualizar a página ou volte para o seu workboard.',
      serverErrorPrimaryAction: 'Atualizar página',
      serverErrorSecondaryAction: 'Ir para o início',
      madeInUkr: "Feito na Ucrânia",
      upProVersion: "Mudar para PRO",
      getLeads: "Obter leads",
      poperBillings: "Faturamento",
      poperTemplates: "Modelos",
      poperPartnership: "Parceria",
      poperProfile: "Perfil",
      poperLogout: "Sair",
      poperTeam: "Equipe",
      teamDelegatedAccessTitle: 'Compartilhou o acesso adiante',
      teamAccessTreeRootLabel: 'Origem do acesso',
      teamAccessVia: 'via',
      teamNoQuizNamesAvailable: 'Os nomes dos quizzes não estão disponíveis',
      teamSharedShareTargetPrefix: 'Compartilhado por',
      teamSharedOwnerFallback: 'proprietário',
      teamMembersTab: 'Acesso que concedi',
      teamAccessSourceTab: 'Acesso concedido a mim',
      teamAccessSourceTitle: 'Acesso concedido a mim',
      teamAccessTreeTab: 'Cadeias de acesso',
      teamAccessTreeTitle: 'Cadeias de acesso',
      teamAccessTreeDescription: 'Mostra o caminho de acesso: proprietário → quem convidou → você → pessoas com quem compartilhou',
      teamAccessOwnerLabel: 'Proprietário',
      teamAccessInviterLabel: 'Compartilhado por',
      teamAccessPath: 'Caminho de acesso',
      teamAccessYouLabel: 'você',
      teamSharedByYou: 'Compartilhado por você',
      teamCanReshare: 'Pode recompartilhar',
      teamCannotReshare: 'Não pode recompartilhar',
      teamPartialReshare: 'Pode recompartilhar parcialmente',
      teamMixedRoles: 'Funções mistas',
      teamNoAccessTree: 'As cadeias aparecerão quando você compartilhar o acesso',
      poperIdea: "Sugerir uma ideia",
      poperIdeaTitle: "Tem uma ideia para melhorar a plataforma?",
      poperIdeaText: "Partilhe connosco! As suas sugestões ajudam-nos a crescer e a criar uma melhor experiência para si.",
      poperIdeaTextPlaceholder: "Descreva a sua ideia em detalhe",
      poperIdeaSendButton: "Enviar sugestão",
      defaultNewQuestion: "Nova pergunta",
      defaultNewQuestionDescription: "Aqui você pode inserir uma breve descrição da pergunta (até 80 caracteres)",
      defaultNewVariant: "Nova opção",
      defaultBtnText: "Iniciar",
      navBillings: "Faturamento",
      navPartnership: "Parceria",
      navProfile: "Perfil",
      navTariffs: "Planos",
      holidayBannerTitleLastOffer: "Oferta final do ano:",
      holidayBannerDefaultTitle: "Oferta limitada",
      holidayBannerFrom: "de",
      holidayBannerTo: "até",
      holidayBannerCta: "Receber desconto",
      holidayBannerAuthTitle: "Faça login para receber o desconto",
      holidayBannerAuthText: "Entre na sua conta para aproveitar esta oferta e mantê-la vinculada a você.",
      holidayBannerAuthAction: "Entendi",
      holidayBannerClose: "Fechar banner",
      welcomeBack: "Bem-vindo de volta!",
      loginHeader: "Entrar",
      loginHeader2Part: "para continuar",
      loginEmailPlaceholder: "E-mail",
      loginPasswordlPlaceholder: "○ ○ ○ ○ ○ ○ ○ ○ ○"	,
      loginBtnValue: "Entrar",
      loginWith: "Entrar com",
      passwordAreForgetPassword: "Esqueceu sua senha?",
      passwordResetPasswordHeader: "Redefinição de senha",
      passwordResetPassword: "Redefinir senha",
      passwordWeSentReset: "Siga as instruções no e-mail que enviamos para redefinir sua senha",
      passwordInputNewPassword: "Digite uma nova senha",
      passwordConfirmPassword: "Confirmar senha",
      passwordCreatePassword: "Criar senha",
      passwordChangePassword: "Salvar senha",
      passwordResetedPasswordCompleted: "Sua senha foi alterada com sucesso!",
      passwordGoToWorkboard: "Ir para o painel de trabalho",
      loginSignup: "Cadastrar-se",
      helloHeader: "Olá!",
      signupHeader: "Cadastrar-se",
      signupHeader2Part: "para continuar",
      signupNamePlaceholder: "Oleksander",
      signupPhonePlaceholder: "número de telefone",
      signupEmailPlaceholder: "E-mail",
      signupPasswordlPlaceholder: "○ ○ ○ ○ ○ ○ ○ ○ ○"	,
      signupBtnValue: "Criar uma conta",
      signupWith: "Cadastrar-se com",
      signupLogin: "Entrar em uma conta",
      signupTariffHeader: "Tarifa",
      signupTariffFree: "Grátis.",
      signupTariffPro: "Pro."	,
      signupTariffFreeDescription: "Número ilimitado de criação de novos questionários (páginas da web). Capacidade de gerar até 300 aplicações por mês gratuitamente.",
      signupTariffProPrice: "$20/mês",
      signupTariffProDescription: "Número ilimitado de criação de novos questionários (páginas da web). Capacidade de gerar ",
      signupTariffProDescriptionBold: "até 300 aplicações por mês.",
      userBackToQuiz: "Voltar para o painel de trabalho",
      userBackToSettings: "Voltar para Configurações",
      learningCenterTitle: "Centro de aprendizagem",
      learningCenterTraining: "Treinamento",
      learningCenterIntroText: "Assista a todos os guias em vídeo obrigatórios em ordem, confirme cada lição após o fim e solicite seu certificado depois que a última lição for concluída.",
      learningCenterVideoUnsupported: "Seu navegador não suporta vídeo HTML5.",
      learningCenterAvailable: "Disponível",
      learningCenterLessonsComplete: "Lições concluídas",
      learningCenterBackToLearningCenter: "Voltar ao Learning center",
      learningCenterCertificate: "Certificado",
      learningCenterCourseCompleted: "Curso concluído",
      learningCenterCertificateSentText: "Todas as lições foram concluídas. A solicitação do certificado foi enviada ao backend.",
      learningCenterCertificateLabel: "Adsquiz Learning Center",
      learningCenterCertificateOfCompletion: "Certificado de conclusão",
      learningCenterDownloadCertificate: "Baixar certificado",
      learningCenterDownloadUnavailable: "Download ainda indisponível",
      learningCenterOpenCertificate: "Abrir certificado",
      learningCenterAbout: "Sobre a lição",
      learningCenterOpenFallbackLink: "Abrir link alternativo",
      learningCenterBack: "Voltar",
      learningCenterCompleted: "Concluído",
      learningCenterWatchVideoToEnd: "Assista ao vídeo até o fim",
      learningCenterSaving: "Salvando...",
      learningCenterMarkAsCompleted: "Marcar como concluído",
      learningCenterWatchedPercent: "{percent}% assistido",
      learningCenterDefaultUserName: "Usuário Adsquiz",
      learningCenterCertificateReadyMessage: "O backend retornou um arquivo de certificado. Use o botão acima para abri-lo.",
      learningCenterCertificatePendingMessage: "A solicitação do certificado foi enviada. Adicione a URL de download do backend quando ela estiver disponível.",
      learningCenterCertificateNoUrlMessage: "A solicitação do certificado foi concluída, mas nenhuma URL de arquivo foi retornada ainda.",
      learningCenterCertificateErrorMessage: "A solicitação do certificado ainda não pôde ser confirmada pelo backend. A conclusão local foi salva.",
      learningCenterSectionGeneral: "Geral",
      learningCenterSectionIterationsIntro: "Introdução às iterações",
      learningCenterSectionIterationIntro: "Introdução à iteração",
      billingYourTariff: "Seu plano",
      billingYourTariffShortForm: "Seu plano",
      billingYourPro: "Pro",
      billingYorFree: "Grátis",
      billingFreeLeads: "Leads gratuitos",
      billingInfinity: "ilimitado",
      billingTariffRenewData: "Data de renovação da tarifa",
      billingTariffEndData: "Data de término do plano",
      billingOtherTariffFree: "Grátis.",
      billingOtherTariffPro: "Pro."	,
      billingTariffFreeDescription: "Número ilimitado de criação de novos questionários (páginas da web). Capacidade de gerar até 300 aplicações por mês gratuitamente.",
      billingYouHavePro: "Se você está atualmente na versão Pro, por que dar um passo para trás?",
      billingYouHasFreeLeads: "Leads gratuitos",
      billingYouHasLeads: "Leads restantes",
      billingTariffProDescription: "Número ilimitado de novos questionários (páginas da web). Capacidade de gerar ",
      billingTariffProDescriptionBold: "mais de 300 aplicações.",
      billingYourFutureTariff: "Seu plano futuro",
      billingBtnChangeToPro: "mudar para ",
      billingBtnRenewPro: "Renovar",
      billingBillings: "Faturamento",
      billingYouHaveNotBillings: "Você ainda não tem pagamentos",
      billingPaymentsMethod: "Método de pagamento",
      billingPaymentCard: "Cartão",
      billingChangeData: "Alterar dados",
      billingDeletePayMethod: "Excluir",
      billingModalDeleteShure: "Tem certeza de que deseja remover este método de pagamento?",
      billingModalDeleteCancel: "Cancelar",
      billingModalDeleteOk: "Excluir",
      billingModalDeleteSuccess: "Você excluiu seu cartão com sucesso",
      billingModalRegularPaymentDeleteSuccess: "Pagamentos regulares foram cancelados",
      billingModalRegularPaymentDeleteOk: "OK",
      billingYourMonthPlan: "Sua tarifa mensal",
      billingLeads: "leads",
      billingChangePlan: "Alterar a tarifa",
      billingChangePlanDescription: "O preço corresponderá ao número desejado de aplicativos de todos os questionários em sua conta.",
      billingSelectPeriod: "Selecionar período",
      billingChangePlanDescriptionImportant: "Importante:",
      billingChangePlanDescriptionImportantMonth: "Leads podem ser usados 1 mês após a compra.",
      subscriptionTarifLable: "Assine nossa assinatura mensal automática. Você pode mudar seu plano a qualquer momento.",
      billingChangePlanWarning: "",
      billingTariffMonth: "mês.",
      billingChangePlanPay: "Mudar o plano",
      profileName: "Nome",
      profilePhone: "Número de telefone",
      profileEmail: "E-mail",
      profileStatus: "Status",
      profileStatusAgency: "Agência",
      profileStatusPlaceholder: "Qual te descreve melhor?",
      profileStatusFreelancer: "Freelancer",
      profileStatusBuisines: "Dono de negócio",
      profilePassword: "Senha",
      profileChangePassword: "Alterar senha",
      profileNewPassword: "Nova senha",
      profileSaveNewData: "Atualizar dados",
      workboardStartTooltip: "Aqui você pode ver todos os questionários que criou",
      workboardAddNewQuiz: "Criar projeto",
      workboardModalGiveQuizName: "Dê um nome ao questionário",
      workboardModalQuizNamePlaceholder: "Novo questionário",
      workboardModalNewQuizBtnValue: "adicionar",
      workboardAlertGiveAnyName: "Insira qualquer nome",
      workboardAlertNextTimeAddQuiz: "Bem, na próxima vez, atreva-se)",
      workboardChangeQuizName: "Mudar o nome",
      workboardQuizLink: "link",
      workboardQuizLinkCopied: "O link foi copiado para a área de transferência",
      workboardEditQuiz: "Editar",
      workboardCopyQuiz: "Copiar o questionário",
      workboardQuizCopied: "Questionário copiado com sucesso",
      workboardDeleteQuiz: "Excluir",
      workboardTransferQuizPlaceholderInput: "Digite o e-mail do usuário",
      workboardTextAllQuizes: "Todos os questionários",
      workboardTextProjects: "Projetos",
      workboardTransferQuiz: "Transferir o quiz para outra conta",
      workboardTransferProject: "Adicionar ao projeto",
      workboardTransferQuizCancel: "Cancelar",
      workboardTransferQuizLabel: "Título do quiz",
      workboardTransferQuizTitle: "Teste seus conhecimentos sobre preservação ambiental!",
      workboardTransferQuizHintTitle: "Ao transferir o quiz, todas as solicitações serão transferidas junto com ele.",
      workboardTransferQuizHintTitleSecond: "Para transferir o quiz com os envios, um dos usuários deve ter qualquer ",
      workboardTransferQuizHintTitleSecondLink: "https://app.adsquiz.io/tariffs",
      workboardTransferQuizHintTitleSecondLinkText: "plano pago.",
      workboardTransferQuizConfirm: "Transferir",
      workboardTransferQuizNoValidEmail: "Endereço de e-mail inválido",
      workboardTransferQuizStatus200: "O quiz foi transferido com sucesso para:",
      workboardTransferQuizStatus401: "Não autorizado — O usuário não está autenticado.",
      workboardTransferQuizStatus403: "Proibido — Você não tem acesso para transferir este quiz.",
      workboardTransferQuizStatus404: "Não encontrado — Quiz ou usuário destinatário não encontrado.",
      workboardTransferQuizStatus422: "Entidade não processável — Pelo menos um usuário deve ter uma conta paga.",
      workboardTransferQuizStatusError: "Status de erro inesperado",
      workboardModalRemoveQuizTrash: "Este questionário será movido para a lixeira e excluído permanentemente após 1 mês.",
      workboardModalRemoveQuizSure: "Tem certeza de que deseja mover este questionário para a lixeira?",
      workboardModalRemoveProjectTrash: "O projeto e todos os seus questionários serão excluídos permanentemente.",
      workboardModalRemoveProjectSure: "Tem certeza de que deseja excluir este projeto?",
      workboardModalDeleteQuizCancel: "Cancelar",
      workboardModalDeleteQuizDelete: "Excluir",
      workboardModalDeleteQuizSuccess: "Você excluiu este questionário com sucesso",
      workboardModalDeleteProjectSuccess: "O projeto foi excluído com sucesso",
      workboardModalQuizDeleteOk: "OK",
      workboardStatsTitle: "Estatísticas",
      workboardModalLeadsAnswersCount: "Respostas às perguntas",
      workboardModalLeadsLeadSerial: "№",
      workboardModalLeadsLeadDate: "Data",
      workboardModalLeadsLeadEmail: "E-mail",
      workboardModalLeadsLeadName: "Nome",
      workboardModalLeadsLeadPhone: "Telefone",
      workboardModalLeadsLeadPoints: "Pontos",
      workboardModalLeadsLeadActions: "Ações",
      workboardModalLeadsLeadShowMore: "Ver mais",
      workboardModalLeadsLeadHideMore: "Ocultar",
      workboardModalLeadsLeadAnswerScipped: "Ignorado",
      workboardModalNoLeads: "Ainda não há leads",
      constructorLink: "link",
      constructorLinkCopied: "Copiado para a área de transferência:",
      constructorNavSteps: "Passos",
      constructorNavDesign: "Design",
      constructorNavSettings: "Configurações",
      constructorStep: "Etapa",
      cancel: "Cancelar",
      constructorCancel: "Cancelar",
      constructorSave: "Salvar",
      constructorextraNavStart: "S",
      constructorextraNavContact: "C",
      constructorextraNavFinish: "F",
      cstepsSection: "Seções",
      cstepsStartPage: "Página inicial",
      cstepsContactPage: "Formulário de contato",
      cstepsFinishPage: "Página final",
      cstepsEdit: "Editar",
      cstepsMove: "Mover",
      cstepsDeleteStep: "Excluir etapa",
      cstepsAddSection: "Adicionar seção",
      cdesignColorTheme: "Tema de cor",
      cdesignCustomTheme: "Tema de cor personalizado",
      cdesignDefaultThemes: "Nossos temas de cor",
      cdesignThemeStandart: "Padrão",
      cdesignThemeDark: "Escuro",
      cdesignThemeNud: "Nude",
      cdesignThemeGradient: "Gradiente",
      cdesignShapeDesign: "Design de formulário",
      cdesignShapeRound: "Arredondado",
      cdesignShapeSquare: "Angular",
      cdesignShapeRectangle: "Retângulo",
      cdesignShapeCircle: "Círculo",
      cdesignPositionLeft: "Esquerda",
      cdesignPositionMiddle: "Meio",
      cdesignPositionRight: "Direita",
      cdesignPositionTop: "Em cima",
      cdesignPositionBottom: "Em baixo",
      csettingsIntegration: "Integração",
      csettingsOweDomain: "Conectando domínio próprio",
      csettingsDocs: "Documentos legais",
      cintegrationIntegration: "Integração",
      cintegrationShareLeads: "Compartilhar leads",
      cintegrationTitleEmail: "E-MAIL",
      cintegrationInstruction: "Instrução",
      cintegrationInstructionDetail: "Detalhes",
      cintegrationEmailInstruction: "Dispare um e-mail para o respondente e notifique sua equipe. Colabore com sua equipe.",
      cintegrationPublishAfterEdit: "Salve o questionário após a edição",
      cintegrationSendNewLeadsTo: "Enviar mensagens sobre novos leads para:",
      cintegrationInputEmail: "Insira o e-mail",
      cintegrationAddEmail: "Adicionar e-mail",
      cintegrationEmailSaved: "E-mail salvo",
      cintegrationEmailDeleted: "E-mail excluído",
      cintegrationTitleFB: "Pixel FB",
      cintegrationIDPixel: "ID de pixel",
      cintegrationFBInstruction1: "Vá para o gerenciador de anúncios do Facebook e copie o ID do pixel na seção Gerenciador de Eventos.",
      cintegrationFBInstruction2: "Não copie o código inteiro, apenas o ID de 15-16 dígitos.",
      cintegrationFBInstruction3: "Copie e cole na caixa abaixo.",
      cintegrationFBInstruction: "O evento para o qual você precisa configurar a conversão é 'Lead'. Este evento será acionado assim que o usuário enviar uma aplicação no questionário.",
      cintegrationFBInstructionTextTitle: "Lista de todos os eventos que enviamos:",
      cintegrationFBInstructionTextTextStart: " – visita à página inicial;",
      cintegrationFBInstructionTextQuestionN: " – visita à etapa N;",
      cintegrationFBInstructionTextOpenContactPage: " – visita à página de contatos;",
      cintegrationFBInstructionTextLead: " – envio bem-sucedido do formulário de contato;",
      cintegrationFBInstructionTextThankYou: " – visita à página final.",
      bold_adsquiz_Start: "adsquiz_Start",
      bold_adsquiz_QuestionN: "Question_N",
      bold_adsquiz_OpenContactPage: "Open_Contact-Page",
      bold_adsquiz_Lead: "Lead",
      bold_adsquiz_ThankYou: "adsquiz_ThankYou",
      cintegrationInputIDPixel: "Insira o ID do pixel",
      cintegrationDataFBSaved: "Dados do pixel FB salvos",
      cintegrationAccesToken: "TOKEN DE ACESSO",
      cintegrationTitleGA: "Google analytics",
      cintegrationGAInstructionDescription: "Aprenda como as pessoas estão encontrando e interagindo com seu questionário. Obtenha os dados necessários para analisar campanhas, melhorar conversões e muito mais.",
      cintegrationGAInstruction: "Quando uma aplicação de questionário é recebida no Google Analytics, o evento 'generate_lead' será acionado.",
      cintegrationIDFolow: "ID de acompanhamento",
      cintegrationInputID: "Insira o ID",
      cintegrationDataGASaved: "Dados do Google Analytics salvos",
      cintegrationTitleGTM: "Gerenciador de tags do Google",
      cintegrationGTMInstructionDescription: "Descrição para o Gerenciador de tags do Google.",
      cintegrationGTMInstruction: "Copie o ID do Gerenciador de tags do Google e cole no campo abaixo.",
      cintegrationDataGTMSaved: "Dados do Gerenciador de tags do Google salvos",
      cintegrationTitleTG: "Telegram",
      cintegrationHowReciveTGLeadBot: "Como obter leads no Telegram?",
      cintegrationTGInstructionBot1: "1. Copie o token no campo abaixo.",
      cintegrationTGInstructionBot2: '2. Siga o link para o bot e clique no botão "START".',
      cintegrationTGInstructionBot3: "3. Envie o token copiado como mensagem para o nosso bot.",
      cintegrationHowReciveTGLeadChat: "Como obter aplicações no chat do Telegram?",
      cintegrationTGInstructionChat1: "1. Adicione nosso bot ao chat desejado e defina o status de administrador.",
      cintegrationTGInstructionChat2: "2. Copie o token no campo abaixo e envie para o chat desejado.",
      cintegrationTGInstructionChat3: "3. Aguarde a resposta `OK! Seu token de quiz foi salvo!”",
      cintegrationTGInstructionChat4: "4. Os leads agora serão enviados para este chat.",
      cintegrationTGInstructionWarning: "Importante:",
      cintegrationTGInstructionWarningText: "Observe que este deve ser um grupo, não um canal do Telegram. Os leads não serão enviados para o canal do Telegram.",
      cintegrationTGBotLink: "link do chatbot",
      cintegrationTGTitleToken: "TOKEN",
      cintegrationInputTGToken: "Insira o token do chatbot do Telegram",
      cintegrationAddIntegration: "Adicionar integração",
      cintegrationDataTGSaved: "Dados de integração do Telegram salvos",
      cintegrationTitleTT: "Pixel TT",
      cintegrationTTInstruction: "Para rastrear eventos na sua conta de anúncios do Tik-Tok, copie o ID do pixel e cole no campo abaixo.",
      cintegrationDataTTSaved: "Dados do pixel TT salvos",
      cintegrationTitleWH: "WebHook",
      cintegrationWHInstruction1: "Você pode notificar aplicativos de terceiros sobre leads recebidos. Para fazer isso, especifique o URL para o qual o WebHook será enviado.",
      cintegrationWHInstruction2: "Preparamos",
      cintegrationWHInstruction3: "instrução em vídeo",
      cintegrationWHInstruction4: "com uma descrição detalhada desta funcionalidade.",
      cintegrationWHInstruction5: "Ver vídeo.",
      cintegrationWHInstruction6: "Neste vídeo, veremos como passar um hook com base no envio de dados para uma planilha do Google e enviar dados para um sistema CRM do Trello.",
      cintegrationWHInstruction7: "Recomendamos o uso do serviço para este propósito.",
      cintegrationWHInstruction8: "Ao se registrar usando este link, nossos usuários recebem um bônus de 10.000 ações gratuitas para qualquer integração.",
      cintegrationWHInstruction9: "Link",
      cintegrationWHInstruction10: "para se registrar com um bônus.",
      cintegrationWHUrl: "As URLs do WebHook",
      cintegrationInputWHUrl: "Insira o URL do WebHook",
      cintegrationAddWH: "Adicionar um WebHook",
      cintegrationWebHookDataSaved: "Dados do WebHook salvos",
      cintegrationComonWHInstructionShort: "Você pode notificar aplicativos de terceiros sobre os leads recebidos. Especifique o URL do WebHook para transmissão de dados.",
      cintegrationComonWHInstruction1Title: "1. Insira o URL do WebHook no campo de entrada:",
      cintegrationComonWHInstruction1Description: "Cole o URL do WebHook fornecido pelo seu serviço ou aplicativo no campo de entrada.",
      cintegrationComonWHInstruction2Title: "2. Salvar alterações:",
      cintegrationComonWHInstruction2Description: 'Clique no botão "Salvar alterações" para salvar as configurações do WebHook.',
      cintegrationComonWHInstruction3Title: "3. Concluído:",
      cintegrationComonWHInstruction3Description: "Agora seu WebHook está configurado para enviar dados ao serviço selecionado.",
      cintegrationComonWHInstructionAdditional: "Os dados serão enviados ao WebHook com cada lead recebido. O método POST é usado para a transmissão. Um exemplo dos dados que serão enviados está localizado ",
      cintegrationComonWHInstructionAdditionalLink: "aqui",
      cintegrationComonWHInstructionVideo: "Instrução em vídeo detalhada",
      cintegrationApixDriveWHInstructionShort: "Você pode notificar o ApixDrive sobre os leads recebidos. Para fazer isso, especifique o URL para o qual o WebHook será enviado.",
      cintegrationApixDriveWHInstructionShort1: "Ao se registrar através de ",
      cintegrationApixDriveWHInstructionShort2: "este link",
      cintegrationApixDriveWHInstructionShort3: " nossos usuários recebem um bônus de 10.000 ações gratuitas para qualquer integração.",
      cintegrationApixDriveWHInstruction1Title: "1. Registre-se ou abra sua conta ApixDrive:",
      cintegrationApixDriveWHInstruction1Description1: "Link ",
      cintegrationApixDriveWHInstruction1Description2: "para se registrar com um bônus.",
      cintegrationApixDriveWHInstruction2Title: "2. Obtenha o endereço URL para o WebHook:",
      cintegrationApixDriveWHInstruction2Description1: "Vá para as configurações da conexão necessária e copie o endereço para o envio do WebHook:",
      cintegrationApixDriveWHInstruction2Description2: 'Você pode criar uma nova conexão clicando no botão "Criar Conexão" e na etapa de seleção do sistema, escolha "ADSQuiz".',
      cintegrationApixDriveWHInstruction3Title: "3. Insira o URL do WebHook:",
      cintegrationApixDriveWHInstruction3Description: "Cole o URL do WebHook fornecido pelo ApixDrive no campo de entrada.",
      cintegrationApixDriveWHInstruction4Title: "4. Salvar alterações:",
      cintegrationApixDriveWHInstruction4Description: 'Clique no botão "Salvar alterações" para salvar as configurações do WebHook.',
      cintegrationApixDriveWHInstruction5Title: "5. Concluído:",
      cintegrationApixDriveWHInstruction5Description: "Agora seu WebHook está configurado para enviar dados ao ApixDrive.",
      cintegrationApixDriveWHInstructionAdditional: "Os dados serão enviados ao WebHook com cada lead recebido. O método POST é usado para a transmissão. Um exemplo dos dados que serão enviados está localizado ",
      cintegrationApixDriveWHInstructionAdditionalLink: "aqui",
      cintegrationApixDriveWHInstructionVideo: "Instrução em vídeo detalhada",
      cintegrationConnectOweDomain: "Conectando seu próprio domínio",
      cintegrationOweDomainInstruction1: "1. Para colocar seu quiz no domínio necessário, faça login na sua conta de hospedagem. Vá para as configurações de DNS e crie um registro A com o parâmetro IP: 185.25.117.21",
      cintegrationOweDomainInstruction2: "2. Insira seu domínio acima e salve o quiz.",
      cintegrationDomain: "Domínio",
      cintegrationInputYourDomain: "Insira seu domínio",
      cintegrationCheckDomenIsCorrect: "Verifique se o domínio inserido está correto",
      cintegrationDomainWhichCorrect: "Insira um domínio sem protocolos. Por exemplo: some.site.com",
      cintegrationInsertedDefaultDomain: "O domínio é definido por padrão",
      cintegrationDomainDataSaved: "Dados do domínio salvos",
      cintegrationPrivacyPolicy: "Política de privacidade",
      cintegrationPrivacyPolicyByDefault: "Por padrão, usamos nossa política de privacidade padrão. Recomendamos adicionar sua política de privacidade relevante para o seu negócio.",
      cintegrationPrivacyPolicyAdventage: "Isso deixará claro para seus clientes potenciais como você usa as informações de contato recebidas. Isso também é exigido por algumas plataformas de publicidade.",
      cintegrationPrivacyPolicyUrl: "Link para documentos",
      cintegrationPrivacyPolicyInputYourDocsLink: "Inserir link para documentos",
      cintegrationDocsDataSaved: "Link para seus documentos salvo",
      allstepsUpploadPhoto: "Carregar uma imagem",
      unsplashSelectorButtonText: "Escolher do Unsplash",
      unsplashSelectorTitle: "Carregar imagem",
      unsplashSelectorDragImage: "Arraste uma imagem aqui ou",
      unsplashSelectorUploadFile: "carregue um arquivo",
      unsplashSelectorSearchPlaceholder: "Pesquisar imagem no Unsplash",
      unsplashSelectorLoadingImages: "Carregando imagens...",
      unsplashSelectorLoadingMoreImages: "Carregando mais imagens...",
      unsplashSelectorNoImagesFound: "Nenhuma imagem encontrada",
      unsplashSelectorUnavailable: "O Unsplash está indisponível no momento. Você pode enviar um arquivo.",
      unsplashSelectorClose: "Fechar",
      allstepsChangePhoto: "Alterar a imagem",
      allstepsDeletePhoto: "Excluir imagem",
      allstepsTitle: "Título",
      allstepsDescription: "Descrição",
      allstepsButtonText: "Texto do botão",
      allstepsOtherSettings: "Outras configurações",
      allstepsIsSaveBeforeRoute: "Salvar dados antes de mudar a rota?",
      cfirstFormat: "Formato",
      cfirstHeaderStartText: "Seu título deve estar aqui. Motive os usuários a completar o quiz até o final",
      cfirstAddMediafile: "Adicionar mídia (imagem)",
      cfirstBonus: "Bônus",
      cfirstAddBonus: "Adicionar bônus",
      cfirstStartPageDataUpdated: "Os dados da página inicial foram atualizados",
      csanyAnswerType: "Tipo de pergunta",
      csanyATCard: "cartão",
      csanyATList: "lista",
      csanyATCustom: "campo livre",
      csanyQuestion: "Pergunta",
      csanyAnswers: "Respostas",
      csanyAddAnswer: "Adicionar opção",
      csanyTitleForModalConfirm: "Esta ação é irreversível!",
      csanyQuestionForModalConfirm: "Você tem certeza de que deseja excluir esta pergunta?",
      csanyRequiredStep: "Etapa obrigatória",
      csanyAlowMultiple: "Permitir várias respostas",
      csanyAutoRedirect: "Próxima pergunta automática",
      csanyQuestionLogic: "Configuração de lógica da pergunta",
      csanyDataStepUpdated: "Etapa de dados atualizada",
      cformForm: "Formulário",
      cformValueName: "Nome",
      cformValueSurname: "Sobrenome",
      cformValuePhone: "Número de telefone",
      cformValueEmail: "E-mail",
      cformDataContactsPageUpdated: "Página de contatos de dados atualizada",
      cformRequiredInput: "Obrigatório",
      cfinishFinishPageTitle: "Página de conclusão",
      cfinishText: "Texto",
      cfinishDescription: "Descrição",
      cfinishAddImage: "Adicionar uma imagem",
      cfinishImageAdded: "Imagem adicionada",
      cfinishURL: "URL",
      cfinishButtonText: "Texto do botão",
      cfinishInsertNikname: "Inserir apelido",
      cfinishCheckDataIsCorrect: "Verifique se o ID inserido está correto",
      cfinishFbWhichCorrect: "Insira um ID sem outro endereço. Por exemplo: some.name",
      cfinishIgWhichCorrect: "Insira um ID sem outro endereço. Por exemplo: some.name",
      cfinishTgWhichCorrect: "Insira um ID sem outro endereço. Por exemplo: some.name",
      cfinishFinishPageDataUpdated: "Os dados da página de conclusão foram atualizados",
      adminUsersReg: "Usuários no sistema",
      adminNewUsers: "Novos usuários por mês",
      adminProAccounts: "Contas PRO",
      adminLTV: "LTV",
      adminSharePro: "PRO em relação a todos",
      adminReciveLeads: "Leads recebidos",
      adminLeadsForOne: "Leads por usuário",
      adminMadeQuiz: "Quizzes criados",
      adminQuizForOne: "Quiz por usuário",
      adminAvarageUsed: "Média de meses de uso",
      adminProfitMonth: "Mês de lucro",
      adminProfitAlltime: "Ganho de todos os tempos",
      adminUsersList: "Base de usuários",
      notificationErrorLogin: "Erro de autorização:",
      notificationLogin: "Entrar...",
      notificationWrongLoginData: "Detalhes de login incorretos",
      notificationLoginAccountBlocked: "Sua conta foi bloqueada",
      notificationCanContactSupport: "Voc? pode entrar em contato com o suporte",
      notificationEmailExistsMessage: "Uma conta com este e-mail já está registrada",
      notificationNetworkError: "Verifique sua conexão com a internet",
      notificationInputLoginData: "Inserir dados de login",
      notificationCheckInputEmail: "Verifique se o endereço de e-mail está correto",
      notificationCheckInputEmailOrUserNotFound: "Verifique se o e-mail está correto. Usuário não encontrado",
      notificationCheckInputPhone: "Verifique se o número de telefone está correto",
      notificationInputAllInputs: "Preencha todos os campos para registro",
      notificationAgreePrivacyPolicy: "Aceitar a política de privacidade",
      adminEditorForPartnership: "Editor do programa de afiliados",
      developmentPage: "A seção está em desenvolvimento",
      signupAgreeIAgreeWith: "Li e concordo com",
      signupAgreePolicy: "a política de privacidade",
      signupAgreeAnd: "e",
      signupAgreeOffer: "os termos de uso",
      signupAgreeService: "do serviço",
      workboardModalLeadsLeadReferrer: "Poco claro",
      workboardEditTitle: "Editar título",
      workboardEditIcon: "Editar ícone",
      workboardSaveChange: "Salvar alterações",
      workboardModalLeadsLeadReferrerClarification: "Dados de referência bloqueados pela fonte ou indefinidos",
      workboardModalLeadsLeadEmailCopied: "E-mail copiado para a área de transferência",
      workboardModalLeadsLeadPhoneCopied: "Telefone copiado para a área de transferência",
      workboardModalLeadsHaveNotSended: "Você tem leads não enviados",
      workboardModalLeadsLeadReload: "Receber",
      workboardModalLeadsLeadReloadedTitle: "Solicitação recebida",
      workboardModalLeadsLeadReloaded: "",
      cfirstStartPagePhotoUpdated: "A foto da página inicial foi atualizada",
      allstepsPhotoTooBig: "O arquivo é muito grande!",
      allstepsPhotoMustBeLess: "Deve ser menor que",
      cfirstStartPageBonusPhotoUpdated: "A foto do bônus foi atualizada",
      cstepsQuestionsOrderSaved: "Ordem das perguntas salva",
      csanyAnswerOrderSaved: "Ordem das respostas salva",
      allstepsPhotoAdaptation: "Adaptação da foto para dispositivos",
      allstepsPhotoFit: "Proporção da imagem",
      constructorYouHideStep: "Você ocultou essa etapa",
      cstepsHiddenStep: "Ocultar etapa",
      cstepNo_animation: "Sem animação",
      cstepAnimation: "Animação",
      cstepKick_animation: "Impulso",
      cstepFlip_animation: "Giro",
      cstepBlur_animation: "Desfoque",
      cstepsShowStep: "Mostrar etapa",
      cfinishFinishPageHiddenUpdated: "A página de finalização está oculta.",
      cfinishFinishPageHiddenUpdatedGoContact: "Vá para a página do formulário de contato",
      cfinishFinishPageHiddenUpdatedSetRedirect: "e configure o redirecionamento após o envio dos dados",
      cformActionAfterContactRecive: "Acompanhamento das informações de contato",
      cformActionAfterContactThankyou: "Página de agradecimento",
      cformActionAfterContactRedirect: "Redirecionar",
      cformAdditionalSettings: "Configurações adicionais",
      cformRedirectURL: "URL",
      cintegrationOweDomainInstructionImportant: "Importante: O endereço na sua conta de hospedagem e o campo acima devem coincidir. O tempo de aplicação das mudanças nas configurações de DNS e extração do certificado SSL é de até 3 horas após salvar.",
      cintegrationOweDomainInstructionVideo: "Assistir instrução em vídeo",
      workboardModalLeadsLeadLimit: "Seu limite de leads foi atingido.",
      workboardModalLeadsLeadLimitInstruction1: "Para ver novos leads,",
      workboardModalLeadsLeadLimitInstruction2: "mude para outra tarifa",
      workboardModalLeadsLeadLimitInstruction3: "renove a tarifa atual",
      workboardModalLeadsLeadLimitInstruction4: '(não se aplica a "Grátis") ou espere que a tarifa seja atualizada se você tiver a renovação automática conectada',
      workboardModalLeadsLeadLimitNewText: "Você tem leads não recebidos que estão inacessíveis devido ao limite do seu pacote atual. Para acessá-los, compre ou atualize seu pacote.",
      billingBonusesTitle: 'Código promocional',
      billingBonusesDescription: 'Digite o código promocional que você recebeu no próximo campo',
      billingBonusesPlaceholder: 'Código promocional',
      billingBonusesBtn: 'Ativar',
      billingBonusesActivated: 'Código promocional ativado!',
      billingBonusesLeadIncreased: 'O número de leads disponíveis foi aumentado.',
      billingBonusesInvalid: 'Código promocional incorreto',
      billingBonusesNotAvailable: 'O código promocional não está mais disponível',
      billingBonusesAlreadyActivated: 'Este cupom é inválido',
      createQuizSPDescription: "Há espaço para a descrição curta",
      createQuizCPTitle: "Como podemos entrar em contato com você?",
      createQuizCPDescription: "Por favor, preencha o formulário abaixo",
      createQuizCPButton: "Feito!",
      createQuizFPTitle: "Obrigado!",
      createQuizFPDescription: "Agora estamos procurando a melhor solução para você!",
      createQuizFPButton: "Mostre-me algo!",
      selectInternationalPrefix: "Selecione o prefixo internacional",
      autoInternationalPrefix: "Determinar o país automaticamente",
      dovnloadCsvTitle: "Exportar dados para o período selecionado",
      dovnloadCsvSelectAllPeriod: "Escolher para todo o período",
      dovnloadCsvCancel: "Cancelar",
      dovnloadCsvExport: "Exportar",
      domainEmpty: "Por favor, insira um domínio",
      domainInvalid: "Insira um domínio válido, por exemplo: example.com",
      domainAlreadyExists: "Este domínio já está na lista",
      domainAdded: "Domínio adicionado com sucesso",
      domainAdd: "Adicionar domínio",
      domainAddFailed: "Não foi possível adicionar o domínio",
      domainRemoved: "Domínio removido com sucesso",
      domainRemoveFailed: "Não foi possível remover o domínio",
      widgetEmbedVidgetToSite: "Incorporar quiz no próprio site",
      widgetEmbedVidgetSelectEmbedVariant: "Selecione a variante de incorporação",
      EmbedQuizCardLabelStandard: "Padrão",
      EmbedSettingsPreviewPopupHint: "Clique no botão para ver o seu pop-up em ação",
      EmbedQuizCardLabelPopup: "Janela pop-up",
      EmbedQuizCardLabelChatButton: "Botão de chat",
      EmbedQuizCardLabelFullscreen: "Tela cheia",
      EmbedQuizCardLabelFeedback: "Feedback",
      EmbedQuizCardLabelSidebar: "Barra lateral",
      EmbedStandardSettingsTitle: "Definir dimensões (opcional)",
      tipStandardEmbedQuizStepHead:
          "1. Copie o código para <head> e cole-o antes da tag de fechamento </head>.",
      tipStandardEmbedQuizStepBody:
          "2. Copie o segundo código e cole a div <div id=\"adsquiz_embed_standard_ .... exatamente no local da página onde o quiz deve aparecer.",
      tipStandardEmbedQuizParent:
          "3. O tamanho do quiz depende das dimensões do bloco pai. Se o elemento pai não tiver uma altura definida, o quiz será exibido automaticamente em um formato responsivo.",
      tipStandardEmbedQuizPercent:
          "4. Width e height em % funcionam em relação ao tamanho do bloco pai.",
      EmbedStandardSettingsTooltip: `
        Largura e altura — controlam o tamanho do quiz (px, %, auto).

      Auto — o quiz é responsivo, a altura é ajustada automaticamente.

      Tela cheia — o quiz ocupa 100% da largura com proporção 16:9. Largura e altura são ignoradas.

      Altura:
      • auto / 0 → proporção 16:9
      • valor → altura fixa

      Largura:
      • auto / 0 → 100% da largura
      • valor → dentro do container

      Raio — controla o arredondamento dos cantos.

      Espaçamento interno — adiciona espaço dentro do container.

      Desktop / Dispositivo móvel — controla onde o quiz é exibido.
      Se desativado — o quiz não será mostrado nesse dispositivo.
      `,
      EmbedFeedbackSettingsTooltip: `
   O tamanho da janela define um preset base:
  • S → 360 × 520
  • M → 480 × 640
  • L → 640 × 760
  • XL → 780 × 860
  
  Forma da janela:
  • angular → cantos retos
  • rounded → cantos arredondados
  
  Largura:
  • auto / 0 / vazio → usa o preset
  • valor → substitui o preset
  
  Altura:
  • auto / 0 / vazio → usa o preset
  • valor → substitui o preset
  
  O tamanho do botão define o preset do botão de abertura.
  
  Forma do botão:
  • angular → cantos retos
  • rounded → cantos arredondados
  
  Posição do botão:
  • left → esquerda
  • right → direita
  • top → topo
  • bottom → base
  
  Texto do botão — altera o texto.
  
  Ícone — seleção do ícone.
  
  Cor do botão — fundo do botão.
  
  Cor do texto — cor do texto.
  
  Cor do ícone — cor do ícone.
  
  Impedir o fechamento antes de concluir o quiz — se ativado, o usuário não poderá fechar a janela até concluir o quiz.
  
  Parar de mostrar após a conclusão — após concluir o quiz, o botão e a janela não serão exibidos novamente.
  
  Desktop / Mobile — onde o widget é exibido.
  `,
      EmbedPopupSettingsTooltip: `
      Largura e altura definem o tamanho do popup.
      
      O tamanho da janela define um preset:
      • S → 360 × 520
      • M → 480 × 640
      • L → 640 × 760
      • XL → 780 × 860
      
      Largura e altura podem sobrescrever o preset.
      
      Largura:
      • auto / 0 / vazio → usa o preset
      • valor → sobrescreve
      
      Altura:
      • auto / 0 / vazio → usa o preset
      • valor → sobrescreve
      
      Condição de exibição:
      • Clique no botão
      • Saída da página
      • Carregamento da página
      • Com atraso
      
      Segundos aparecem apenas com atraso.
      
      Texto, tamanho, forma, posição, auto cor e cores manuais funcionam só com clique.
      
      Tamanho do botão define o preset.
      
      Auto cor:
      • ativa — usa template
      • manual — desativa automático
      
      Cores manuais:
      • ativam ambas
      • ao desligar volta auto
      
      Sem botão — cores resetam.
      
      Fechar popup após conclusão — permite fechar.
      
      Desktop / Mobile — controla exibição.
      `,
      EmbedChatButtonSettingsTooltip: `
      A largura e a altura definem o tamanho da janela de chat.

      O tamanho da janela define o preset base:
      • S → 360 × 520
      • M → 480 × 640
      • L → 640 × 760
      • XL → 780 × 860

      A largura e a altura podem sobrescrever o preset selecionado de Tamanho da janela.

      Largura:
      • auto / 0 / vazio → usa a largura de Tamanho da janela
      • valor → uma largura personalizada sobrescreve o preset

      Altura:
      • auto / 0 / vazio → usa a altura de Tamanho da janela
      • valor → uma altura personalizada sobrescreve o preset

      A forma da janela define se a janela de chat terá cantos retos ou arredondados.

      O tamanho do botão define o preset do botão que abre o chat.

      A forma do botão define o estilo do botão:
      • retangular
      • circular

      A posição do botão define onde o botão será exibido:
      • esquerda
      • direita

      Os ícones permitem escolher o ícone do botão de chat.

     Impedir o fechamento antes de concluir o quiz — se ativado, o usuário não poderá fechar a janela até concluir o quiz.
  
      Parar de mostrar após a conclusão — após concluir o quiz, o botão e a janela não serão exibidos novamente.

      Desktop / Dispositivo móvel — controla onde o botão de chat e a janela de chat são exibidos.
      Se desativado — o botão de chat não será mostrado nesse dispositivo.
      `,
      EmbedSidebarSettingsTooltip: `
       O tamanho da janela define um preset base:
  • S → 360 × 520
  • M → 480 × 640
  • L → 640 × 760
  • XL → 780 × 860
  
  Posição do painel:
  • left → esquerda
  • right → direita
  
  Largura:
  • auto / 0 / vazio → usa o valor do preset
  • valor → substitui o preset
  
  Altura:
  • auto / 0 / vazio → usa o valor do preset
  • valor → substitui o preset
  
  Condição de exibição:
  • Clique no botão — abre ao clicar
  • Ao sair da página — abre quando o usuário está saindo da página
  • Ao carregar a página — abre imediatamente após o carregamento
  • Com atraso — abre após o número de segundos selecionado
  
  O campo de segundos aparece apenas para “Com atraso”.
  
  Texto do botão, tamanho, forma, posição, cor do botão e cor do texto funcionam apenas para “Clique no botão”.
  
  O tamanho do botão define o preset do botão de abertura.
  
  Forma do botão:
  • angular → cantos retos
  • rounded → cantos arredondados
  
  Posição do botão:
  • left → esquerda
  • middle → centro
  • right → direita
  
  Cor do botão — fundo do botão.
  
  Cor do texto — cor do texto do botão.
  
Impedir o fechamento antes de concluir o quiz — se ativado, o usuário não poderá fechar a janela até concluir o quiz.
  
  Parar de mostrar após a conclusão — após concluir o quiz, o botão e a janela não serão exibidos novamente.
  
  No desktop / No mobile — define onde o painel é exibido.
  Se desativado — não será mostrado nesse dispositivo.
  `,
      EmbedModalStandardInstruction: `
      Copie o Head e cole antes de </head>.
      
      Cole o Body onde o quiz aparecerá.
      
      Como funciona:
      • O quiz é embutido na página
      • Adapta ao container
      
      Atenção:
      • Verifique largura do container
      • Ajuste altura se necessário
      • Modo responsivo ajusta altura
      • Verifique CSS
      
      Depois:
      1. Salve
      2. Atualize
      3. Teste
      `,
      EmbedModalPopupInstruction: `
      Cole Head antes de </head>.
      
      Cole Body antes de </body> ou onde quiser.
      
      Como funciona:
      • Abre como popup
      • Automático ou por clique
      
      Atenção:
      • Botão aparece no local
      • Auto abre sozinho
      • Verifique dispositivos
      • Ajuste tamanho
      
      Depois:
      1. Salve
      2. Atualize
      3. Teste popup
      `,
      EmbedSettingsWindowSize: "Tamanho da janela",
      EmbedPreviewFallbackTitle: "A pré-visualização está demorando mais do que o esperado",
      EmbedPreviewFallbackDescription: "A pré-visualização do quiz ainda não pôde ser exibida. Tente reabrir a pré-visualização ou recarregar o frame.",
      EmbedPreviewFallbackReasonsTitle: "Possíveis motivos:",
      EmbedPreviewFallbackReasonDomain: "O domínio selecionado pode estar indisponível ou ter sido inserido incorretamente.",
      EmbedPreviewFallbackReasonDomainSettings: "Verifique as configurações do domínio e certifique-se de que ele esteja conectado corretamente.",
      EmbedPreviewFallbackReasonSlow: "A página do quiz ainda pode estar carregando ou respondendo lentamente.",
      EmbedPreviewFallbackReasonBlocked: "A pré-visualização pode estar sendo bloqueada pelo seu navegador ou ambiente de rede.",
      EmbedPreviewFallbackReload: "Recarregar pré-visualização",
      EmbedSizePresetDisabledHint: "O tamanho predefinido não está disponível enquanto uma largura ou altura personalizada estiver definida.",
      EmbedPopupSettingsTitleButton: "Tamanho do botão",
      EmbedStandardSettingsHeightLabel: "Altura",
      EmbedStandardSettingsWidthLabel: "Largura",
      EmbedStandardSettingsRadiusLabel: "Raio",
      EmbedStandardSettingsPaddingLabel: "Espaçamento interno",
      EmbedStandardSettingsFullscreenToggle: "Tela cheia",
      EmbedStandardSettingsDesktopToggle: "Desktop",
      EmbedPopupSettingsTextColorToggle: "Cor do texto",
      EmbedPopupSettingsButtonColorToggle: "Cor do botão",
      EmbedSettingsIconColor: "Cor do ícone",
      EmbedPopupSettingsAutoColorToggle: "Cor automática (modelo)",
      EmbedPopupSettingsCloseOnCompletionToggle: "Impedir o fechamento antes de concluir o quiz",
      EmbedSettingsStopShowing: "Parar de mostrar após a conclusão",
      EmbedStandardSettingsMobileToggle: "Dispositivo móvel",
      EmbedSettingsAutoOpenToggle: "Abertura automática",
      EmbedSettingsPreviewDelayHint: "O pop-up aparecerá após ",
      EmbedSettingsPreviewOpenAgain: "Abrir pré-visualização do pop-up",
      EmbedReOpenSettingsMobileToggle: "Abrir pré-visualização",
      widgetEmbedVidgetSitecode: "No código do site",
      widgetEmbedVidgetPopup: "Pop-up",
      widgetEmbedVidgetChat: "Botão do quiz",
      widgetEmbedVidgetInProgres: "Em desenvolvimento",
      widgetEmbedVidgetToSiteCode: "Incorporar quiz no site",
      widgetSiteCodeInstruction0: "Para incorporar o quiz no seu site, adicione o código do primeiro campo na tag <head> do seu site ou no Google Tag Manager se estiver integrado no seu site. Se após incorporar o quiz no seu site você mudar o domínio do quiz, precisará atualizar o código de integração no site.",
      widgetSiteCodeInstruction1: "No local onde deseja integrar o quiz, insira o código do segundo campo.",
      widgetSiteCodeInstruction2: "O quiz pode ser incorporado em um contêiner de qualquer tamanho, até mesmo em barras laterais! O tamanho máximo do quiz, bem como em um domínio separado, é de 900x552 pixels. Pode ser adicionado a contêineres maiores, caso em que o quiz será centralizado.",
      widgetSiteCodeInstruction3: "Não seja tímido - experimente!",
      widgetSiteCodeCopyToHead: "Copie e cole no <head> do seu site",
      widgetSiteCodeCopyToBody: "Cole o código onde o quiz deve estar",
      workboardModalAddQuizHeader: "Criar novo quiz",
      workboardModalGiveQuizNameAndMethod: "Crie um nome para o seu quiz e escolha como deseja criá-lo",
      workboardModalNewQuizFromStart: "Criar do zero",
      workboardModalNewQuizFromTemplates: "Modelos prontos",
      QuizTemplatesSearchInput: "Nome do modelo e/ou categorias",
      QuizTemplatesSearchBtn: "Buscar",
      QuizTemplatesReadyTemplates: "Modelos prontos",
      QuizTemplateView: "Ver",
      QuizTemplateSelect: "Escolher",
      widgetPopupInstruction0: "Para instalar o quiz no seu site, adicione o código da caixa de código na tag <head> do seu site ou no Google Tag Manager se estiver integrado no site. Se, depois de já ter inserido um quiz no seu site, você alterar o domínio do quiz ou abrir os gatilhos (percentual de rolagem ou temporização), será necessário atualizar o código de integração no site.",
      widgetPopupInstruction1: "Logo antes da tag de fechamento </footer>, cole o código do segundo campo.",
      widgetPopupInstruction2: "Para programadores ou usuários avançados",
      widgetPopupInstruction3: "Se, por algum motivo, você não se sentir confortável em inserir um quiz antes da tag de fechamento </footer>, poderá colar o código do segundo campo em qualquer lugar conveniente, mas tenha em mente que o contêiner no qual você cola o código do segundo campo deve estar no topo de todas as janelas e, de preferência, ter a altura e largura máximas possíveis para a exibição.",
      widgetPopupCopyToHead: "Copie e cole no <head> do seu site",
      widgetPopupCopyToBody: "Cole o código antes da tag de fechamento </footer>",
      widgetPopupTimeToOpen: "Um período de tempo",
      secondReduction: "seg",
      widgetPopupTimeClarification: "O popup aparecerá com um atraso do tempo acima em segundos",
      widgetPopupScrollToOpen: "Porcentagem de rolagem do site",
      widgetPopupScrollClarification: "O popup aparecerá após o percentual de rolagem do seu site especificado acima",
      quizzesTemplatesAllTags: "Todos os modelos",
      widgetEmbedVidgetButton: "Construtor de botões",
      widgetButtonInstruction0: "Você pode configurar um quiz no seu site que abrirá quando você clicar no botão.",
      widgetButtonInstruction1: "Adicione uma borda, sombra e texto ao botão. Você também pode alterar a cor do botão e o texto interno.",
      widgetButtonInstruction2: "Copie o script colocado na primeira caixa de código e cole antes da tag de fechamento </head>.",
      widgetButtonInstruction3: "Copie o código do botão gerado no segundo campo de código e cole em qualquer lugar do seu site.",
      widgetButtonInstruction4: 'Você pode pular o código do segundo campo de botão e simplesmente adicionar id="button_open_quiz_popup" a qualquer elemento <input type="button"> ou <button></button> no site.',
      widgetRealTimeChange: "Você pode ver as alterações em tempo real no lado direito da tela",
      widgetButtonCornerRound: "Arredondamento de cantos do botão",
      widgetButtonShadow: "Sombra do botão",
      widgetButtonBgColor: "Cor do botão",
      widgetButtonTextColor: "Cor do texto",
      widgetButtonTextValue: "Texto do botão",
      openPopupQuizText: "Iniciar quiz",
      widgetButtonInsertBeforeAfterBody: "Insira o código do quiz imediatamente após a tag de abertura <body> ou imediatamente antes da tag de fechamento </body>",
      widgetSiteCodeCopyButton: "Cole o código do botão em qualquer lugar do site",
      footerContactUs: "Tem perguntas? Fique à vontade para nos contatar:",
      enterYourName: "Insira seu nome",
      enterYourPhone: "Insira seu número de telefone",
      enterYourEmail: "Insira seu e-mail",
      enterYourPassword: "Insira sua senha",
      selectOption: "Selecione a opção",
      createNewGroup: "Criar novo grupo",
      dontHaveAccount: "Não tem uma conta?",
      haveQuestions: "Tem alguma pergunta?",
      resetPasswordTip: "Se você tiver algum problema ou pergunta adicional, não hesite em contatar nossa equipe de suporte ao cliente. Estamos aqui para ajudar.",
      getBackAccount: "Voltar para sua conta",
      inMinutes: "em minutos",
      alreadyHaveAccount: "Já tem uma conta?",
      quizSlotLastEdit: "Última edição",
      workboardQuizzesTitle: "Meus quizzes",
      allstepsBack: "Voltar",
      constructorGetLink: "Link",
      allOr: "ou",
      allAnd: "e",
      acceptedFileType: "Formatos aceitos: ",
      quizLoaderLoadingQuiz: "Carregando quiz...",
      quizLoaderPreparingQuestions: "Preparando perguntas pessoais...",
      quizLoaderSettingInterface: "Configurando a interface...",
      quizLoaderAlmostReady: "Quase pronto...",
      conjunctionAnd: "e",
      acceptedFileSize: "Tamanho máximo: ",
      acceptedFileSizeMeasure: "MB",
      cfirstBonusDisabled: "Desabilitado",
      cfirstBonusAvailable: "Disponível",
      allstepsResetInHeader: "Redefinir",
      placeholderText: "Digite aqui",
      constructorSaveChanges: "Salvar",
      constructorCreateIntegrations: "Criar integração",
      cformInputAvailable: "Disponível",
      cformInputDisabled: "Desabilitado",
      Disabled: "Desativado",
      constructorBack: "Voltar",
      videoInstruction: "Instrução em vídeo",
      csettingsIntegrationFB: "Integração - Facebook Pixel",
      csettingsIntegrationTT: "Integração - TikTok",
      csettingsIntegrationGA: "Integração - Google Analytics",
      csettingsIntegrationGTM: "Integração - Google Tag Manager",
      csettingsIntegrationWH: "Integração - WebHook",
      csettingsIntegrationTG: "Integração - Telegram",
      csettingsIntegrationApixDrive: "Integração - APIxDrive",
      csettingsIntegrationEmail: "Integração - Email",
      csettingsIntegrationAbout: "Sobre",
      csettingsIntegrationFBAbout: "Vá para o gabinete de publicidade do Facebook Ads e copie o ID do Facebook Pixel na seção de Gerenciador de Eventos. Não copie o código completo, apenas o ID. Copie e cole na caixa abaixo.",
      csettingsIntegrationTTAbout: "Acesse a conta de anúncios do TikTok Ads e copie o identificador do TikTok Pixel na seção \"Event\". Copie apenas o identificador e cole-o no campo abaixo.",
      csettingsIntegrationGAAbout: "Copie o ID do Google Analytics e cole no campo abaixo.",
      csettingsIntegrationGTMAbout: "Copie o ID do Google Tag Manager e cole no campo abaixo.",
      csettingsIntegrationWHAbout1: "Você pode notificar aplicativos de terceiros sobre leads recebidos. Para isso, especifique a URL para a qual o WebHook será enviado. Recomendamos o uso do serviço para este fim.",
      csettingsIntegrationWHAboutApix: "Apix-Drive",
      csettingsIntegrationWHAbout2: "Ao se registrar usando este link, nossos usuários recebem um bônus - 10.000 ações gratuitas para qualquer integração.",
      csettingsIntegrationTGAbout: "Importante: Observe que isso deve ser um grupo, não um canal do Telegram. Os leads não serão enviados para o canal do Telegram.",
      csettingsIntegrationADAbout: "Algo sobre APIxDrive",
      csettingsIntegrationEmailAbout: "Dispare um e-mail para o seu respondente e notifique sua equipe. Colabore com sua equipe.",
      cSettingsIntegrationNeedHelp: "Precisa de ajuda?",
      cSettingsIntegrationRefreshToken: "Atualizar token",
      csettingsSettingASettings: "Configurações avançadas",
      cSettingsSettingQuizLangTitle: "Idioma do quiz",
      cSettingsSettingQuizLangDescription: "Para garantir a melhor experiência, selecione o idioma desejado para o quiz nas opções abaixo. As notificações do sistema e outros textos constantes serão exibidos neste idioma ao completar o quiz.",
      selectQuizLanguage: "Selecionar idioma do quiz",
      cSettingsSettingQuizHideLabelTitle: "Ocultar rótulo",
      cSettingsSettingQuizHideLabelDescription: 'Ao habilitar esta opção, você pode desfrutar de uma interface sem o rótulo "feito por adsquiz", permitindo que você e seus visitantes foquem apenas nas perguntas.',
      cSettingDataSaved: "Configurações adicionais salvas",
      userAccountInfo: "Informações da conta",
      userGeneralInfoHeader: "Informações gerais",
      userGeneralInfoDescription1: "Seu perfil de usuário é onde você pode gerenciar sua conta e configurações.",
      userGeneralInfoDescription2: "Atualize suas informações pessoais, altere sua senha e ajuste suas preferências de notificação.",
      profileNameFirst: "Nome",
      profileNameLast: "Sobrenome",
      profileChangePhoto: "Alterar foto",
      profileRemovePhoto: "Remover",
      userSecuritySettingsHeader: "Configurações de segurança",
      userSecuritySettingsDescription: "Para alterar sua senha, basta inserir sua nova senha duas vezes para confirmar.",
      profileEmailCurent: "Endereço de e-mail atual",
      profileEmailNew: "Novo endereço de e-mail",
      profileNewPasswordConfirm: "Confirmar nova senha",
      profileDeleteAccount: "Excluir conta",
      profileDeleteAccountPopupHeader: "Excluir conta?",
      profileDeleteAccountPopupDescription: 'Tem certeza de que deseja excluir sua conta? Esta ação não pode ser desfeita. Para confirmar a exclusão, digite a palavra "EXCLUIR" no campo abaixo.',
      profileDeleteAccountCheckedWord: "EXCLUIR",
      profileDeleteAccountPopupPlaceholder: "Digite aqui",
      notificationSuccess: "Sucesso!",
      notificationSuccessSaveAccount: "Sua senha foi alterada com sucesso! Use uma nova senha para fazer login novamente",
      notificationOnlyEmailMask: "Apenas um endereço de e-mail válido é permitido.",
      notificationOnlyNumbersMask: "Somente números e espaços são permitidos.",
      notificationOnlyLinkMask: "Apenas links seguros são permitidos (https, http ou mailto).",
      notificationOnlyLettersMask: "Somente letras, espaços, hífens, apóstrofos e sublinhados são permitidos.",
      notificationSuccessDeleteAccount: "Sua senha foi alterada com sucesso! Use uma nova senha para fazer login novamente",
      notificationSuccessDeletePhoto: "Foto excluída com sucesso",
      notificationSuccessChangePhoto: "Foto alterada com sucesso",
      notificationErrorChangePhoto: "Ocorreu um erro ao alterar a foto",
      notificationErrorRemovePhoto: "Ocorreu um erro ao remover a foto",
      notificationWarnLimitText: "Limite de caracteres excedido. Você não pode adicionar mais caracteres.",
      cardPanUnspecified: "Não especificado",
      userBillingsDate: "Data",
      userBillingsCost: "Custo",
      userBillingsId: "ID",
      userBillingsMethod: "Método de pagamento",
      RateSymbolForDropdown: "Símbolo da taxa",
      NumberOfSymbolsForDropdown: "Número de símbolos",
      optionIconLabelForDropdown_thumbnail: "Polegar para cima",
      optionIconLabelForDropdown_stars: "Estrelas",
      optionIconLabelForDropdown_flags: "Bandeiras",
      optionIconLabelForDropdown_smiley_faces: "Carinhas sorridentes",
      labelTextYesNoPack1: "Sim/Não Pacote - 1",
      labelTextYesNoPack2: "Sim/Não Pacote - 2",
      labelTextYesNoPack3: "Sim/Não Pacote - 3",
      labelTextYesNoEmojiPack: "Sim/Não Pacote de Emoji",
      labelTextEmojiPackage1: "Pacote de Emoji - 1",
      labelTextEmojiPackage2: "Pacote de Emoji - 2",
      labelTextEmojiPackage3: "Pacote de Emoji - 3",
      labelTextNumberPack1: "Pacote de Números - 1",
      labelTextNumberPack2: "Pacote de Números - 2",
      labelTextClassicNumbers1: "Números Clássicos - 1",
      labelTextClassicNumbers2: "Números Clássicos - 2",
      labelTextRatingMarkers: "Marcadores de Avaliação",
      textPackagePlaceholder: "Pacote ...",
      labelEmojiNumberSets: "Conjuntos de emojis e números",
      labelSelectCountForSymbols: "Selecione um intervalo de 1 a",
      labelButtonColorButtonText: "Cor do botão e texto do botão",
      color: "Cor",
      paymentSwitchToProHeader: "Mudar para Pro",
      paymentSwitchToProDescription: "Encontre o plano certo para você! Atualize ou faça downgrade a qualquer momento - facilitamos para você obter o plano que precisa.",
      paymentYourCurrentPlan: "Seu plano atual:",
      paymentYourFuturePlan: "Seu novo plano:",
      billingCurrentPlanLeadLimit: "Limite mensal de leads",
      billingCurrentPlanLeadsRemaining: "Leads restantes",
      billingSpecialOffersHeading: "Ofertas especiais",
      billingAllPlansHeading: "Todos os planos",
      billingBillingPeriodToggleAria: "Período de cobrança",
      billingPeriodMonthly: "Mensal",
      billingPeriodYearly: "Anual",
      billingPaymentUnavailableNotification: "O pagamento deste plano não está disponível no momento. Tente novamente mais tarde ou entre em contato conosco.",
      billingRequisitesButton: "Dados bancários",
      billingPayAsBusiness: "Pagar como empresa",
      billingIbanModalTitle: "Dados bancários",
      billingIbanModalMethodTitle: "Transferência bancária IBAN",
      billingIbanModalDisclaimer: "Para receber uma fatura, escreva-nos no chat do suporte técnico.",
      billingIbanModalRecipient: "Beneficiário",
      billingIbanModalRecipientCode: "Código do beneficiário",
      billingIbanModalIban: "IBAN",
      billingIbanModalBankName: "Nome do banco",
      billingIbanModalCopy: "Copiar IBAN",
      billingIbanModalClose: "Fechar",
      billingIbanCopyAllButton: "Copiar dados bancários",
      billingIbanCopiedNotification: "IBAN copiado para a área de transferência",
      billingIbanAllCopiedNotification: "Dados bancários copiados para a área de transferência",
      billingWhatsIncluded: "O que está incluído",
      billingComparePlans: "Comparar planos",
      billingComparePlanA: "Plano A para comparar",
      billingComparePlanB: "Plano B para comparar",
      billingFeatureSectionMain: "Principal",
      billingFeatureSectionAdvanced: "Avançado",
      billingFeatureSectionIntegrations: "Integrações",
      billingAnalyticsRowLabel: "Analítica",
      billingLeadsRowLabel: "Leads",
      billingFeatureProjectsRowLabel: "Projetos",
      billingFeatureCustomDomainRowLabel: "Domínio personalizado",
      billingFeatureAnalyticsRowLabel: "Análise",
      billingFeatureSiteInstallRowLabel: "Instalação no site",
      billingFeatureAiBuilderRowLabel: "Criador de IA",
      billingFeatureRedirectRowLabel: "Redirecionamento",
      billingFeatureUtmTrackingRowLabel: "Rastreamento UTM",
      billingFeatureFaviconRowLabel: "Favicon",
      billingFeatureLogicRowLabel: "Lógica",
      billingFeatureResultPageRowLabel: "Página de resultados",
      billingFeaturePointsRowLabel: "Pontos",
      billingFeatureFileUploadRowLabel: "Upload de arquivo",
      billingFeatureNotYetAvailableLabel: "Em breve",
      billingFeatureTeamRowLabel: "Equipe",
      billingFeatureCrmRowLabel: "CRM",
      billingPartnershipOfferHeading: "Oferta de parceria",
      paymentPlanLeadsLimit: "Limite de leads por mês:",
      paymentPlanLeadsLimitForTest: "Limite de teste do seu quiz:",
      paymentPlanLeadsLeft: "Leads restantes:",
      paymentPlanPrice: "Preço:",
      paymentPlanRenew: "Data de renovação de tarifa:",
      addNewSectionHeader: "Adicionar nova seção",
      addNewSectionList: "Lista",
      addNewSectionCustom: "Campo de entrada",
      addNewSectionMultiInput: "Entrada múltipla",
      addNewSectionUploadFile: "Envio de arquivo",
      addNewSectionCard: "Cartões com fotos",
      addNewSectionWithEmoji: "Lista com emoji",
      addNewSectionTags: "Tags",
      addNewSectionSlider: "Slider",
      templatesBackToQuiz: "Voltar ao quadro de trabalho",
      constructorStepsSaved: "Todos os dados do quiz foram salvos com sucesso",
      constructorDesignSaved: "O design do quiz foi salvo com sucesso",
      azureBlueWhite: "Padrão",
      azureBlue: "Noite de inverno",
      moderatePurplishRed: "Veludo vermelho",
      multiInputPlaceholderLink: "https:",
      multiInputPlaceholderName: "Nome ou nome completo",
      multiInputAddInput: "Adicionar campo",
      multiInputPlaceholderAddress: "Endereço",
      multiInputPlaceholderNumbers: "Espaço reservado (apenas números)",
      violetBlueCrayola: "Brisa de inverno",
      wetRainforest: "Bordo de verão",
      lavender: "Espaço",
      blueLilac: "Lavanda escura",
      opalGreen: "Floresta dos Cárpatos",
      dustyBlue: "Tiffany",
      almondCrayola: "Recife de coral",
      periwinkleCrayolaLilac: "Lilás",
      periwinkleCrayolaAqua: "Synevir",
      jazzJam: "Jazz",
      slateGrayBlue: "Névoa",
      turquoiseBlueCrayola: "Diia",
      blackPearlescentOpal: "Cinza",
      pearlescentGentianBlue: "Safira",
      sapphireBlue: "Safira escura",
      errorUserDataUpdate: "Erro nos dados atualizados: ",
      completeUserDataUpdate: "Dados do usuário atualizados",
      passwordDoNotCoincidence: "As senhas não coincidem",
      passwordDoNotCoincidenceAgain: "Tente novamente",
      nonBillingsYet: "Você ainda não tem histórico de faturamento.",
      youCanChangePlan: "Você pode mudar o plano atual clicando no botão “Mudar para PRO”",
      rangeMin: "Mín",
      rangeMax: "Máx",
      rangePositionStart: "Início da posição",
      rangePositionEnd: "Fim da posição",
      rangeStep: "Passo",
      rangeIsRange: "Intervalo",
      rangeIsRangeTrue: "Disponível",
      rangeIsRangeFalse: "Desativar",
      recivePromotionNewsletter: "Receber newsletters por e-mail",
      reciveEmailCheckbox: "Caixa de receber e-mail",
      additionalCheckbox: "Caixa adicional",
      contactPrivacyPolicyCheckbox: "Caixa de política de privacidade de contato",
      contactAgreeIAgreeWith: "Eu concordo com",
      contactAgreePolicy: "a política de privacidade",
      contactAgreeAnd: "e",
      contactAgreeTermsOfUse: "os termos de uso",
      contactAgreeAgreementAdditionalWord: "",
      contactFillRequiredInput: "Preencha os campos obrigatórios",
      langDE: "Alemão",
      langEN: "Inglês",
      langIT: "Italiano",
      langKK: "Cazaque",
      langPL: "Polonês",
      langRU: "Russo",
      langSP: "Espanhol",
      langUA: "Ucraniano",
      langSV: "Sueco",
      langLT: "Lituano",
      langLV: "Letão",
      langET: "Estoniano",
      langRO: "Romeno",
      leadsLeft: "Leads restantes",
      generateDomainTitle: "Insira o nome de domínio",
      generateCodeForEmbedQuiz: "Gerar código",
      generateDomainDescription: "Este é o endereço exclusivo onde sua página estará acessível. Você pode alterar o endereço a qualquer momento ou conectar o seu próprio.",
      generateDomainDomainNameLabel: "Nome de domínio",
      cancelAllAction: "Cancelar",
      confirmAllAction: "Confirmar",
      fieldDataTypeLabel: "Tipo de dados no campo",
      falseHasValidCharacters: "Caracteres inválidos no domínio. Os caracteres válidos são letras, números e hífens.",
      falseHasValidLength: "O comprimento do domínio deve estar entre 6 e 20 caracteres alfanuméricos.",
      falseDoesNotStartOrEndWithSpecialChar: "O domínio não deve começar ou terminar com um caractere especial.",
      falseDoesNotHaveConsecutiveSpecialChar: "O domínio não deve conter dois ou mais caracteres especiais consecutivos.",
      falseDoesNotHaveConsecutiveSameChar: "O domínio não deve conter três ou mais caracteres idênticos consecutivos.",
      falseDoesNotContainForbiddenSubstrings: "O domínio não deve conter substrings proibidas.",
      generateDomainTaken: "Este domínio já está em uso. Tente outro",
      temporarilyUnavailable: "Temporariamente indisponível",
      csettingsAdmin: "Configurações para administradores",
      questionLogicSetupTitle: "Configuração de lógica de perguntas",
      questionLogicSetupDescription: "Adicione condições para ajudar a personalizar a pesquisa para cada respondente e coletar dados mais precisos.",
      questionLogicConditionTitle: "Condição",
      questionLogicQuestion: "Pergunta",
      questionLogicSetupQuestionDisableOption: "Selecione a pergunta",
      questionLogicSetupAnswer: "Resposta",
      questionLogicSetupLogicType: "Tipo",
      questionLogicSetupAnswerDisableOption: "Selecione o tipo de condição",
      questionLogicSetupRangeRatingBetween: "Entre",
      questionLogicSetupRangeRatingLess: "Menor",
      questionLogicSetupRangeRatingMore: "Mais",
      questionLogicSetupRangeRatingEqualTo: "Igual a",
      questionLogicSetupRangeRatingFrom: "De",
      questionLogicSetupRangeRatingTo: "Até",
      questionLogicSetupVariantAll: "Todos",
      questionLogicSetupVariantAny: "Qualquer",
      questionLogicSetupVariantNot: "Nenhum",
      questionLogicSetupCustomEqual: "Igual",
      questionLogicSetupCustomContains: "Contém",
      questionLogicSetupCustomNotContains: "Não contém",
      questionLogicSetupRangeRatingValue: "Valor",
      questionLogicSetupExpectedAnswer: "Respostas esperadas",
      questionLogicSetupPlaceholder: "Digite aqui",
      questionLogicAllMandatory: "Todas as condições acima são obrigatórias",
      questionLogicAddConditionBtn: "Adicionar condição",
      questionLogicNotAvailable: "As configurações de lógica não estão disponíveis para a primeira pergunta",
      pointsSettingsNotAvailableForQuestionType: "Este tipo de questões não envolve pontuação de respostas",
      questionLogicSaved: "As configurações de lógica de exibição de etapas foram salvas",
      questionLogicDeleteAll: "Excluir lógica",
      questionLogicDeleted: "A lógica de exibição da etapa foi excluída",
      questionLogicRatingSelectedLeftBtn: "botão esquerdo",
      questionLogicRatingSelectedRightBtn: "botão direito",
      QR_code: "QR code",
      QRCodeDownloadPdf: "Baixar Pdf",
      QRCodeDownloadPng: "Baixar Png",
      qrGenerateTitle: "Gerar código QR",
      qrGenerateDescription: "Gere um código QR personalizado com tags UTM para rastrear facilmente as fontes de tráfego. Quando os usuários escanearem o código, serão direcionados ao seu quiz com os parâmetros da campanha preservados para análises precisas.",
      qrUtmSource: "Fonte (ex.: google, newsletter)",
      qrUtmMedium: "Meio de marketing (ex.: cpc, banner, email)",
      qrUtmCampaign: "Produto, código promocional ou slogan (ex.: spring_sale). É necessário o nome ou o ID da campanha.",
      qrUtmTerm: "Identificar palavras-chave pagas",
      qrUtmContent: "Usar para diferenciar anúncios",
      billingPaymentInfoTitle: "Informações de tarifa",
      billingPaymentInfoChangeTarrif: "Mudar tarifa",
      billingPaymentInfoDescription: "Quando você paga por qualquer tarifa, recebe um certo número de leads incluídos no pacote escolhido. Esses leads são fornecidos por um mês. Se você não usar seus leads dentro de um mês a partir do momento do pagamento, eles serão cancelados.",
      billingGeneralName: "Sua tarifa",
      billingGeneralCost: "Custo",
      billingMonth: "mês",
      billingGeneralExpired: "Válido até",
      billingGeneralLeadsLeft: "Leads restantes",
      billingGeneralAllTarifExpired: "Data de expiração da tarifa",
      billingGeneralBonus: "Leads de bônus",
      billingGeneralLeadsFromOtherTarifs: "Leads de outras tarifas",
      billingGeneralNoActiveTariff: "Nenhuma tarifa ativa",
      billingLeadsAvailableLabel: "Leads disponíveis",
      billingLeadsTariffSourceLabel: "Tarifa",
      billingLeadsRemainingOfLabel: "{remaining} / {total} restantes",
      planUsageTeamMembersLabel: "Membros da equipe",
      planUsageManagePlanLabel: "Gerenciar plano",
      billingAcordeonPaymentInfoTitle: "Informações de pagamento",
      billingAcordeonPaymentInfoFormat: "Formato",
      billingAcordeonPaymentInfoSubscription: "Assinatura",
      billingAcordeonPaymentInfoPay: "Pagamento",
      billingAcordeonPaymentInfoPayMethod: "Método de pagamento",
      billingAcordeonPaymentInfoCancelSubscription: "Cancelar assinatura",
      billingAcordeonPromocode: "Código promocional",
      billingAcordeonPromocodeLabel: "Insira o código promocional",
      billingAcordeonPayHistory: "Histórico de transações",
      paymentAllTarifInactive: "a tarifa está inativa",
      subscriptionUnsubscribeModalTitle: "Cancelar assinatura",
      subscriptionUnsubscribeModalDescription: "Tem certeza de que deseja cancelar a assinatura? Os leads acumulados para a assinatura estarão disponíveis por um mês a partir da última data de faturamento.",
      subscriptionIsNotDeleteTitle: "Assinatura não cancelada",
      subscriptionIsNotDeleteDescription: "Por favor, entre em contato com o suporte ao cliente",
      subscriptionCanceledTitle: "Assinatura cancelada",
      embedQuizTitleGetLinkModal: "Inserir o quiz no site como:",
      QRCodeTitleGetLinkModal: "Usar código QR:",
      modalSureUnsavedChangesTitle: "Você tem alterações não salvas",
      modalSureUnsavedChangesDescription: "Antes de sair da página atual, decida o que fazer com as alterações não salvas",
      modalSureUnsavedChangesDontSave: "Não salvar",
      modalSureUnsavedChangesSave: "Salvar",
      modalSuggestIdeaNotificationSuccess: "Sucesso! Obrigado pela sua ideia",
      modalSuggestIdeaNotificationUnsuccess: "Ops! Algo deu errado. Por favor, tente novamente mais tarde.",
      telegramTokenCopied: "O token do quiz foi copiado para a área de transferência",
      cSettingsSettingQuizBackButtonTitle: "Botão de voltar",
      cSettingsSettingQuizBackButtonDescription: "Você pode ativar ou desativar o botão de voltar. Isso permitirá alterar a resposta dada anteriormente.",
      cSettingsCustomThemePrimaryColor: "Cor dos acentos",
      cSettingsCustomThemeSecondaryColor: "Cor de fundo",
      cSettingsCustomThemeAdditionalColor: "Cor do texto",
      cSettingsCustomThemeButtonTextColor: "Texto no botão",
      cSettingsCustomThemeModeDark: "Escuro",
      cSettingsCustomThemeModeLight: "Claro",
      allstepsPlaceholder: "Espaço reservado",
      allstepsCustomInput: "Entrada personalizada",
      allstepsCustomInputOn: "Disponível",
      allstepsCustomPlaceholder: "Outro",
      trashcanTitle: "Lixeira",
      trashcanImportant: "Importante!",
      trashcanDescription: "O quiz será excluído permanentemente 30 dias após ser movido para a lixeira.",
      trashcanClearAll: "Limpar tudo",
      quizSlotDeletedData: "Excluído em",
      workboardLeads: "Leads",
      filterOptionLabelCreatedDesc: "de novo para antigo",
      filterOptionLabelCreatedAsc: "de antigo para novo",
      filterOptionLabelLeadsDesc: "Por leads (decrescente)",
      filterOptionLabelLeadsAsc: "Por leads (crescente)",
      filterOptionLabelWithProject: "Quizzes em projetos",
      filterOptionLabelWithoutProject: "Quizzes sem projeto",
      workboardDuplicate: "Duplicar",
      leadsTable: "Lista de Leads",
      exportInfo: "Exportar Leads",
      leadHide: "Ocultar",
      leadShowMore: "Mostrar mais",
      poperTrashcan: "Lixeira",
      restoreQuizSendedTitle: "Uma tarefa de recuperação está em andamento",
      restoreSuizSendedImportant: "Importante",
      restoreQuizSendedDescription: "Dependendo de quantos leads havia no seu quiz, a restauração pode levar de alguns segundos a 2 minutos. Após a restauração, o quiz aparecerá em seu painel principal.",
      ok: "Ok",
      month: "{n} months",
      discount: "Desconto de até",
      saveMoney: "Assinatura por um ano",
      upProVersionMobile: "Para PRO",
      upProVersionDesktop: "Mudar para PRO",
      csettingsIntegrationSendPulse: "Integração - Send Pulse",
      csettingsIntegrationMailchimp: "Integração - Mailchimp",
      csettingsIntegrationMake: "Integração - Make",
      csettingsIntegrationZapier: "Integração - Zapier",
      csettingsIntegrationCRMBitrix: "Integração - CRM Bitrix",
      csettingsIntegrationPipeDrive: "Integração - Pipe Drive",
      csettingsIntegrationRemOnline: "Integração - Rem Online",
      csettingsIntegrationKeyCRM: "Integração - Key CRM",
      csettingsIntegrationGoogleSpreadsheets: "Integração - Google Spreadsheets",
      csettingsIntegrationKeepinCrm: "Integração - KeepinCRM",
      csettingsIntegrationZapierAbout: "Cole a URL de envio de dados fornecida pelo Zapier no campo de entrada.",
      csettingsIntegrationMakeAbout: "Cole a URL de envio de dados fornecida pelo Make no campo de entrada.",
      csettingsIntegrationMakeAboutTextStep1: "Para configurar a integração com",
      csettingsIntegrationMakeAboutTextStep2: ", assista ao",
      csettingsIntegrationMakeAboutTextStep3: "Para a configuração, selecione “Webhooks” entre as integrações no Make, depois escolha “Custom webhook”.",
      csettingsIntegrationMakeAboutTextStep4: "Copie o link gerado e cole no campo abaixo no ADS Quiz.",
      csettingsIntegrationMakeAboutTextStep5: "Para testar, volte ao Make, clique em “Run” e complete o quiz enviando um lead.",
      csettingsIntegrationMakeAboutTextStep6: "Se o teste for bem-sucedido, salve a integração e não se esqueça de ativar as atualizações.",
      csettingsIntegrationMakeAboutLinkVideoText: "vídeo",
      csettingsIntegrationCRMBitrixAbout: "Cole a URL de envio de dados fornecida pelo CRM Bitrix no campo de entrada.",

      csettingsIntegrationSendPulseAboutStart: "Você pode configurar a integração com o serviço ",
      csettingsIntegrationSendPulseAboutMiddle: ". Para isso, vá até as configurações da sua conta e abra a aba ",
      csettingsIntegrationSendPulseAboutEnd: ". Copie os valores dos parâmetros 'ID' e 'Secret', e depois cole-os nos campos correspondentes no serviço ADS Quiz (nos campos abaixo). Em seguida, você precisa inserir o ID do livro de endereços. Para isso, acesse o livro de endereços desejado e copie do URL o valor que aparece após id/. Apenas números são necessários, sem caracteres adicionais. Salve as alterações. Um guia mais detalhado está disponível no ",
      csettingsIntegrationSendPulseAboutLinkSendPulse: "https://sendpulse.com/br#60c9ccfd55f4b",
      csettingsIntegrationSendPulseAboutLinkAPI: "https://login.sendpulse.com/login/#api",
      csettingsIntegrationSendPulseAboutLinkVideo: "https://www.youtube.com/watch?v=4mnhpbKkePs",
      csettingsIntegrationSendPulseAboutLinkVideoText: "vídeo",

      csettingsIntegrationKeyCRMAbout: "Cole a chave API e o PipelineID nos respectivos campos.",
      csettingsIntegrationPipeDriveAbout: "Cole o token e o domínio da empresa nos respectivos campos.",
      csettingsIntegrationRemOnlineAbout: "Cole a chave API do Rem Online no campo correspondente.",
      csettingsIntegrationGoogleSheetsAbout: "Faça login no Google Sheets (se sua conta estiver registrada com um endereço do Gmail, você só poderá conectar essa conta do Gmail; tentar conectar uma conta diferente resultará em um erro), selecione a planilha e mapeie os campos para começar a transferir dados.",
      csettingsIntegrationMailchimpAbout: "Conecte o Mailchimp, escolha um público e mapeie os campos se necessário.",
      csettingsIntegrationKeepinCrmAbout: "Cole a chave API do KeepinCRM, escolha pipeline, status, gerente e origem e ative o mapeamento de campos, se necessário.",
      csettingsIntegrationActiveIntegration: "Integração ativa",
      cintegrationIntegrationData: "Dados de integração",
      cintegrationMailchimpAudience: "Público",
      cintegrationMailchimpAudiencePlaceholder: "Selecione o público",
      cintegrationMailchimpStatus: "Status de assinatura",
      cintegrationMailchimpStatusOptionSubscribed: "subscribed (Inscrito)",
      cintegrationMailchimpStatusOptionPending: "pending (Aguardando confirmação)",
      cintegrationMailchimpStatusOptionUnsubscribed: "unsubscribed (Cancelado)",
      cintegrationMailchimpStatusOptionCleaned: "cleaned (Removido)",
      cintegrationMailchimpStatusOptionTransactional: "transactional (Somente transacionais)",
      cintegrationMailchimpStatusDescriptionSubscribed: "o contato poderá receber suas newsletters.",
      cintegrationMailchimpStatusDescriptionPending: "o usuário ainda não confirmou a inscrição por email.",
      cintegrationMailchimpStatusDescriptionUnsubscribed: "o contato cancelou o recebimento das newsletters.",
      cintegrationMailchimpStatusDescriptionCleaned: "os emails não podem ser entregues.",
      cintegrationMailchimpStatusDescriptionTransactional: "usado apenas para emails de serviço, não para marketing.",
      cintegrationMailchimpConnect: "Conectar Mailchimp",
      cintegrationMailchimpConnectTo: "Conecte o Mailchimp",
      cintegrationMailchimpConnectedTo: "Conectado ao Mailchimp",
      cintegrationMailchimpUseMapping: "Configuração de campos",
      cintegrationMailchimpDataSaved: "Dados da integração do Mailchimp salvos",
      cintegrationDataMailchimpError: "Selecione um público do Mailchimp",
      cintegrationMailchimpMappingError: "Preencha o mapeamento de campos",
      cintegrationMailchimpNoTags: "O Mailchimp não tem tags",
      cintegrationIntegrationUrl: "URL de integração",
      cintegrationWriteUrl: "Inserir URL",
      cintegrationDataFBError: "Identificador de pixel incorreto",
      cintegrationDataWebHookError: "Endereço de webhook inválido",
      cintegrationZapierDataSaved: "Dados de integração do Zapier salvos",
      cintegrationDataZapierError: "Endereço de integração inválido",
      cintegrationAPIxDriveDataSaved: "Dados de integração do APIxDrive salvos",
      cintegrationDataAPIxDriveError: "A sequência não é um endereço de integração do APIxDrive",
      cintegrationMakeDataSaved: "Dados de integração do Make salvos",
      cintegrationDataMakeError: "Endereço de integração inválido",
      cintegrationSendPulseDataSaved: "Dados de integração do SendPulse salvos",
      cintegrationDataSendPulseError: "Dados de integração inválidos ou vazios",
      cintegrationPipeDriveDataSaved: "Dados de integração do PipeDrive salvos",
      cintegrationDataPipeDriveError: "Dados de integração inválidos ou vazios",
      cintegrationRemOnlineDataSaved: "Dados de integração do RemOnline salvos",
      cintegrationDataRemOnlineError: "Dados de integração inválidos ou vazios",
      cintegrationKeyCRMDataSaved: "Dados de integração do KeyCRM salvos",
      cintegrationDataKeyCRMError: "Dados de integração inválidos ou vazios",
      cintegrationInputEmailUrl: "Insira o e-mail",
      cintegrationEmailDataSaved: "E-mail salvo",
      cintegrationDataEmailError: "A sequência inserida não é um e-mail",
      cintegrationCRMBitrixDataSaved: "E-mail salvo",
      cintegrationDataCRMBitrixError: "A sequência inserida não é um e-mail",
      cintegrationTelegramBotDataSaved: "Configurações de integração do Telegram salvas",
      cintegrationDataTelegramBotError: "Erro ao salvar",
      cintegrationGTMDataSaved: "ID do Google Tag Manager salvo",
      cintegrationDataGTMError: "ID inválido",
      cintegrationDataGTMErrorDescription: "O ID deve ter o formato GTM-XXXXXX",
      cintegrationGoogleAnalyticsDataSaved: "ID do Google Analytics salvo",
      cintegrationDataGoogleAnalyticsError: "ID incorreto",
      cintegrationDataGoogleAnalyticsErrorDescription: 'O ID deve ter o formato "UA-XXXXXXX-X" ou "G-XXXXXXXXXX-XX"',
      cintegrationTikTokDataSaved: "Pixel do Tik-Tok salvo",
      cintegrationDataTikTokError: "A sequência inserida não é um pixel do Tik-Tok",
      cintegrationIntegrationToken: "Token de integração",
      cintegrationWriteToken: "Insira o token de integração",
      cintegrationDataYourAPIKey: "Insira sua chave API",
      viewQuizInMobile: "Ver Quiz",
      notificationCSRFTokenMismatch: "Incompatibilidade de token CSRF",
      notificationReloadPage: "Por favor, recarregue a página e tente novamente",
      csettingsIntegrationKeyRemOnline: "Cole o token e o ID do canal nos campos apropriados",
      cintegrationDataYourIntegrationToken: "Chave API",
      cintegrationDataLeadTypeId: "ID do canal",
      send_utm: "Enviar tags UTM",
      send_quiz: "Enviar dados do quiz",
      send_answers: "Enviar respostas",
      csettingsIntegrationKeyCrm: "Integração KeyCRM",
      cintegrationSendPulseClientId: "ID do cliente",
      cintegrationSendPulseClientSecret: "Segredo",
      cintegrationSendPulseAddressBookId: "ID da lista de contatos",
      cintegrationSendPulseAction: "Ação com contato",
      sendpulseActionAddContact: "Adicionar contato",
      sendpulseActionDeleteContact: "Excluir contato",
      cintegrationPipeDriveToken: "Token API",
      cintegrationPipeDriveDomain: "Seu subdomínio único",
      cintegrationKeyCrmApiKey: "Chave API",
      cintegrationKeyCrmPipelineId: "ID do pipeline",
      cintegrationMenuGoogleTagManager: "Google Tag Manager",
      cintegrationMenuGoogleAnalytics: "Google Analytics",
      cintegrationMenuFacebookPixel: "Pixel do Facebook",
      cintegrationMenuTikTokPixel: "Pixel do TikTok",
      cintegrationMenuWebHook: "Webhook",
      cintegrationMenuZapier: "Zapier",
      cintegrationMenuAPIxDrive: "APIx Drive",
      cintegrationMenuMake: "Make",
      cintegrationMenuSendPulse: "Send Pulse",
      cintegrationMenuMailchimp: "Mailchimp",
      cintegrationMenuEmail: "E-mail",
      cintegrationMenuTelegramBot: "Bot do Telegram",
      cintegrationMenuPipeDrive: "PipeDrive",
      cintegrationMenuRemOnline: "Rem Online",
      cintegrationMenuKeyCRM: "Key CRM",
      cintegrationMenuCRMBitrix: "CRM Bitrix",
      cintegrationMenuGoogleSpreadsheets: "Google Spreadsheets",
      cintegrationMenuKeepinCRM: "KeepinCRM",
      googleSignIn: "Entrar com Google",
      googleSignInHint: "Autorize-se para continuar configurando a integração.",
      cintegrationGoogleSpreadsheetID: "ID da planilha",
      cintegrationGoogleSheetName: "Nome da aba",
      googleSheetNameTip: "Use o nome da aba exatamente como está no Google Sheets.",
      googleSheetsMappingTitle: "Mapeamento de campos",
      cintegrationGoogleSheetsSaved: "Dados do Google Spreadsheets salvos",
      googleSheetsSelectSheet: "Selecione uma aba",
      googleSheetsSelectSheetPlaceholder: "Selecione a aba",
      googleSheetsSelectSheetFirst: "Selecione a aba primeiro para configurar o mapeamento",
      cintegrationKeepinPipelineId: "Pipeline",
      cintegrationKeepinPipelineIdPlaceholder: "Selecione o pipeline",
      cintegrationKeepinStatusId: "Status",
      cintegrationKeepinStatusIdPlaceholder: "Selecione o status",
      cintegrationKeepinManagerId: "Gerente",
      cintegrationKeepinManagerIdPlaceholder: "Selecione o gerente",
      cintegrationKeepinSourceId: "Origem",
      cintegrationKeepinSourceIdPlaceholder: "Selecione a origem",
      cintegrationKeepinUseMapping: "Usar mapeamento de campos",
      cintegrationKeepinDataSaved: "Dados do KeepinCRM salvos",
      trashcanRestoreQuiz: "Restaurar Quiz",
      cformValuePromotionAccepted: "Aceito o boletim informativo por e-mail",
      constructorAddIntegration: "Adicionar uma nova integração",
      cintegrationKeyCrmSourceId: "ID de fonte (opcional)",
      cintegrationKeyCrmManagerId: "ID do gerente (opcional)",
      cSettingsSettingQuizSpamFilterTitle: "Proteção contra spam",
      cSettingsSettingQuizSpamFilterDescription: "Este recurso está desativado por padrão. Se você encontrar leads de spam, ative a proteção. Depois disso, um único usuário não poderá enviar mais do que o número especificado de leads para este quiz.",
      cSettingsSettingQuizSpamFilterLimitPlaceholder: "Número de leads",
      langNO: "Norueguês",
      loadMoreLeads: "Ver mais leads",
      userAdditionalSettingsHeader: "Configurações adicionais",
      userAdditionalSettingsDescription1: "Aqui você pode configurar novas configurações avançadas de perfil.",
      userAdditionalSettingsPagination: "Paginação no painel de trabalho",
      benefitType: "Tipo de benefício",
      benefitLabelPlaceholder: "Texto de bônus",
      benefitDescriptionPlaceholderDiscount: "Código promocional ou instrução",
      benefitDescriptionPlaceholderVideo: "Link para o vídeo",
      benefitDescriptionPlaceholderTextfile: "Link para o arquivo de texto",
      benefitDescriptionPlaceholderGift: "Descrição do bônus",
      benefitDescriptionPlaceholderPDF: "Link para o PDF",
      benefitDescriptionPlaceholderLink: "Link",
      benefitDescriptionPlaceholderFile: "Link para o arquivo",
      benefitDescriptionPlaceholderCustom: "Link",
      benefitLabelDiscount: "Desconto",
      benefitLabelVideo: "Vídeo",
      benefitLabelTextfile: "Arquivo de texto",
      benefitLabelGift: "Presente",
      benefitLabelPDF: "Arquivo PDF",
      benefitLabelLink: "Link",
      benefitLabelFile: "Arquivo",
      benefitLabelCustom: "Bônus personalizado",
      addBenefit: "Adicionar benefício",
      saveBenefit: "Salvar bônus",
      cfinishSocialNetworks: "Redes sociais",
      saveSocialNet: "Salvar rede social",
      networkLabelFacebook: "Facebook",
      networkLabelInstagram: "Instagram",
      networkLabelTelegram: "Telegram",
      networkLabelTiktok: "Tik-Tok",
      networkLabelYoutube: "YouTube",
      networkLabelLinkedin: "LinkedIn",
      networkLabelWhatsapp: "WhatsApp",
      socialNetDescriptionPlaceholderFacebook: "perfil_nikname",
      socialNetDescriptionPlaceholderInstagram: "perfil_nikname",
      socialNetDescriptionPlaceholderTelegram: "perfil/canal_nikname",
      socialNetDescriptionPlaceholderTiktok: "perfil_nikname",
      socialNetDescriptionPlaceholderYoutube: "nome_do_canal",
      socialNetDescriptionPlaceholderLinkedin: '"in/nome" ou "company/nome_empresa"',
      socialNetDescriptionPlaceholderWhatsapp: "+15555551234",
      addNewSectionEmptyPage: "Página de texto simples",
      csanyMakeImpasse: "Impass",
      impaseIsImpaseTrue: "Ligado",
      impaseIsImpaseFalse: "Desligado",
      defaultNewEmptyQuestionDescription: "Você pode colar e formatar texto longo aqui (não recomendamos colar mais de 3000 caracteres).",
      cSettingsSettingQuizTimezoneTitle: "Fuso horário do quiz",
      cSettingsSettingQuizTimezoneDescription: "Insira o fuso horário no qual o horário de envio de leads será registrado. Isso é especialmente útil se você e o cliente estiverem em fusos diferentes.",
      cSettingsSettingQuizTimezonePlaceholder: "Fuso horário",
      userAdditionalSettingsTimezone: "Fuso horário do usuário",
      userAdditionalSettingsTimezonePlaceholder: "Fuso horário",
      langHE: "Hebraico",
      langCS: "Tcheco",
      cintegrationCAPIFBInstruction: "Para configurar a integração com a API de Conversão do Facebook, é necessário inserir o ID do pixel e o token de acesso. Esses dados estão nas configurações do Facebook Business Manager. Após inserir as informações necessárias, salve a integração.",
      cintegrationCAPIFBInstructionTextTitle: "Nomes de eventos para FB Conversions:",
      cintegrationCAPIFBInstructionTextStart: " – visita à página inicial;",
      cintegrationCAPIFBInstructionTextQuestionN: " – visita à etapa N (o número da etapa é inserido dinamicamente);",
      cintegrationCAPIFBInstructionTextOpenContactPage: " – visita à página de contatos;",
      cintegrationCAPIFBInstructionTextLead: " – envio bem-sucedido do formulário de contato;",
      cintegrationCAPIFBInstructionTextThankYou: " – visita à página final.",
      cintegrationCAPIFBInstructionTextOptimizationAdvice: "Recomendamos executar anúncios otimizados para o evento",
      cintegrationCAPIFBInstructionTextLeadTriggerCondition: "Este evento é acionado",
      bold_capi_adsquiz_Start: "capi_adsquiz_Start",
      bold_capi_adsquiz_QuestionN: "capi_adsquiz_Question-N",
      bold_capi_adsquiz_OpenContactPage: "capi_adsquiz_OpenContactPage",
      bold_capi_adsquiz_Lead: "capi_adsquiz_Lead",
      bold_capi_adsquiz_ThankYou: "capi_adsquiz_ThankYou",
      bold_capi_adsquiz_OptimizationAdvice: "“capi_adsquiz_Lead”.",
      bold_capi_adsquiz_LeadTriggerCondition: "somente quando um lead é enviado com sucesso pelo usuário.",
      csettingsIntegrationFbCapiAbout: "A integração com a API de Conversão do Facebook permite enviar dados de interação do usuário diretamente para o Facebook para melhorar a eficácia das campanhas publicitárias.",
      cintegrationInputCapiAccessToken: "Insira o token de acesso",
      cintegrationInputCapiCustomparameter: "Insira os parâmetros de evento personalizado",
      cintegrationDataFbCapiSaved: "Integração com a API de Conversão do Facebook salva com sucesso",
      cintegrationComonRenovateHubInstructionTitle: "Instruções para configurar a integração com «Міністерство Ремонту»",
      cintegrationComonRenovateHubInstructionDescription1: "Para configurar a integração com “Ministerstvo Remontu”, especifique a URL do webhook para a qual os dados serão enviados.",
      cintegrationComonRenovateHubInstructionDescription2: "Para isso, acesse o “Painel de Administração”, depois abra a seção “Integrações” e selecione o ADS Quiz. Clique em “Criar webhook URL”, copie-o e cole no campo de entrada abaixo no serviço ADS Quiz.",
      cintegrationComonRenovateHubInstructionDescription3: "Em seguida, faça o quiz para teste ou envie um lead de teste usando o botão “Teste”.",
      cintegrationComonRenovateHubInstructionDescription4: "Depois, salve e ative a integração. Todos os leads serão enviados para “Ministerstvo Remontu” na seção “Solicitações”.",
      cintegrationComonRenovateHubInstructionShort: "A integração com «Міністерство Ремонту» permite enviar dados para o CRM através de um webhook para automação de processos.",
      cintegrationRenovateHubUrl: "Insira o URL de «Міністерство Ремонту»",
      cintegrationInputRenovateHubUrl: "Especifique o URL do webhook para «Міністерство Ремонту»",
      cintegrationRenovateHubDataSaved: "Integração com «Міністерство Ремонту» salva com sucesso",
      cintegrationDataRenovateHubError: "Erro ao salvar a integração com «Міністерство Ремонту». Verifique os dados inseridos para precisão.",
      cintegrationMenuFacebookConvAPI: "API de Conversões do Facebook",
      cintegrationMenuRenovateHub: "Міністерство Ремонту",
      csettingsIntegrationRenovateHub: "Integração com «Міністерство Ремонту»",
      csettingsIntegrationCAPIFB: "Integração com a API de Conversões do Facebook",
      paymentPlanEnd: "Data de término do plano",
      paymentPlanNextPayment: "Próximo pagamento",
      paymentPlanLeadsLimitForYear: "Limite de leads por ano:",
      paymentPlanLeadsLimitForPeriod: "Limite de leads por período:",
      EditTags: "Editar tags",
      quizzesTemplatesNoTags: "Sem tags",
      Monday: "Segunda-feira",
      Tuesday: "Terça-feira",
      Wednesday: "Quarta-feira",
      Thursday: "Quinta-feira",
      Friday: "Sexta-feira",
      Saturday: "Sábado",
      Sunday: "Domingo",
      datetimeDisplayMode: "Tipo de seletor",
      datetimeDisplayModeSelect: "Selecionar tipo",
      datetimeDisplayModeDate: "Data",
      datetimeDisplayModeTime: "Hora",
      datetimeDisplayModeDatetime: "Data e Hora",
      datetimeMinDate: "Data mínima",
      datetimeMinDateCustom: "Selecione a data mínima",
      datetimeMaxDate: "Data máxima",
      datetimeMaxDateCustom: "Selecione a data máxima",
      datetimeProhibitDaysOfWeek: "Restringir dias",
      datetimeIsRange: "Habilitar intervalo",
      datetimeIsRangeTrue: "Intervalo habilitado",
      datetimeIsRangeFalse: "Intervalo desabilitado",
      datetimeMinTime: "Hora mínima",
      datetimeMaxTime: "Hora máxima",
      datetimeIs24: "Formato de 24 horas",
      datetimeIs24True: "Formato de 24 horas ativado",
      datetimeIs24False: "Formato de 24 horas desativado",
      csanyIsExactDate: "Como você gostaria de definir a data?",
      csanyIsExactDateTrue: "Data exata",
      csanyIsExactDateFalse: "Data relativa",
      csanyDatetimeMinMaxNotExactPlaceholder: '"x" ou "-x" dias a partir de hoje',
      addNewSectionDatetime: "Data/Hora",
      tariffsPromo: "Ofertas especiais",
      pricingComparisonEyebrow: 'Preços Adsquiz',
      pricingComparisonTitle: 'Escolha um dos nossos planos',
      pricingComparisonMobileHint: 'Deslize pelos cartões de planos e escolha dois abaixo para comparar.',
      pricingComparisonTableAria: 'Pricing plans comparison table',
      pricingComparisonMonthShort: 'mês',
      billingPromoPeriodYearly: "ano",
      billingPromoPeriodMonths: "{count} meses",
      billingPromoDescription: "Sem limites em quizzes ou funcionalidades",
      pricingComparisonTryFree: 'Testar grátis',
      pricingComparisonGetStarted: 'Melhorar',
      pricingComparisonCurrentPlan: 'Seu plano atual',
      pricingComparisonBuyAgain: 'Comprar novamente',
      pricingComparisonLeadsPerMonth: '{count} leads /mês',
      pricingComparisonUnlimited: 'Ilimitado',
      pricingComparisonTeamUsers: '+{n} usuário | +{n} usuários',
      pricingComparisonRequired: 'Obrigatório',
      pricingComparisonOptional: 'Opcional',
      tariffsMonth: "Mensalmente",
      tariffsAnual: "Anualmente",
      leadsOn1Month: "por mês",
      leadsOn2Month: "por 2 meses",
      leadsOn3Month: "por 3 meses",
      leadsOn4Month: "por 4 meses",
      leadsOn5Month: "por 5 meses",
      leadsOn6Month: "por 6 meses",
      leadsOn7Month: "por 7 meses",
      leadsOn8Month: "por 8 meses",
      leadsOn9Month: "por 9 meses",
      leadsOn10Month: "por 10 meses",
      leadsOn11Month: "por 11 meses",
      leadsOn12Month: "por ano",
      leadsOn24Month: "por 2 anos",
      leads: "leads",
      tariffsWordPrice: "Preço",
      tariffsNoLimits: "Sem limites",
      tariffsNoLimitsQuizzes: "em quizzes",
      tariffsAndFunctions: "e funcionalidades",
      billingTariffYear: "ano",
      billingChangePlanSubscribe: "Assinar",
      paymentAllTariffInactive: "Tarifa não ativa",
      subscriptionTariffLableOnly: "Disponível apenas para assinatura",
      notExactBeforeYear: "há um ano",
      notExactBeforeHalfYear: "há meio ano",
      notExactBeforeQuarter: "há um quarto de ano",
      notExactBeforeMonth: "há um mês",
      notExactBeforeWeek: "há uma semana",
      notExactBeforeYesterday: "anteontem",
      notExactYesterday: "ontem",
      notExactToday: "hoje",
      notExactTomorrow: "amanhã",
      notExactAfterTomorrow: "depois de amanhã",
      notExactAfterWeek: "em uma semana",
      notExactAfterMonth: "em um mês",
      notExactAfterQuarter: "em um quarto de ano",
      notExactAfterHalfYear: "em meio ano",
      notExactAfterYear: "em um ano",
      tipDefaultDateHeader: "Por padrão",
      tipDefaultDateText: "Se as opções 'Data Exata' e 'Data Relativa' estiverem desativadas, o calendário permitirá a seleção de datas entre os anos 1800 e 2200 por padrão.",
      tipExactDateHeader: "Interruptor de data exata",
      tipExactDateText: "Ativar esta opção limitará o calendário a um intervalo de datas fixo definido pela(s) data(s) exata(s) selecionada(s) nos campos abaixo.",
      tipRelativeDateHeader: "Interruptor de data relativa",
      tipRelativeDateText: "Ativar esta opção definirá dinamicamente os limites do calendário com base em datas relativas calculadas no momento do carregamento da página. Esses limites são personalizados e recalculados individualmente para cada usuário.",
      langPT: "Português",
      placeholderCompanyContactText: 'Por exemplo: "Telefone da empresa: +351993322211"',
      integrationConnectService: "Conectar",
      Connect: "Conectar",
      Connected: "Conectado",
      Disconnect: "Desconectar",
      cintegrationOauthDisconnectModalTitle: "Desconectar {provider}?",
      cintegrationOauthDisconnectModalDescription: "Ao desconectar {provider}, esta integração será desconectada de TODOS os quizzes. Se você quiser desativá-la apenas neste quiz, exclua a integração abaixo.",
      cintegrationOauthDisconnectModalDescriptionBase: "Ao desconectar {provider}, esta integração será desconectada de TODOS os quizzes.",
      cintegrationOauthDisconnectModalDescriptionDeleteHint: "Se você quiser desativá-la apenas neste quiz, exclua a integração abaixo.",
      cintegrationOauthDisconnectDeleteQuizOnly: "Excluir apenas neste quiz",
      cintegrationOauthDisconnectAllQuizzes: "Desconectar em todos os quizzes",
      leadtype_id: "Tipo de ação",
      selectVariant: "Selecionar",
      sfirstAddCompanyContacts: "Texto com contatos",
      addNewSectionTextarea: "Campo de entrada grande",
      allstepsVariantView: "Formato de isolamento",
      tariffsDiscountSave: "Economize",
      cAdminSettingsTitle: "Configurações administrativas",
      cAdminSettingsInstruction: "Insira as tags para o questionário no campo abaixo. As tags podem consistir em várias palavras, cada tag é separada por uma vírgula. As tags 'Serviços' e 'serviços' são diferentes. Recomenda-se usar tags que comecem com letra maiúscula. Também é possível excluir o questionário da lista de modelos.",
      cAdminSettingsIsTemplate: "É um modelo",
      cIsTemplateStateAreSaved: "O status do modelo foi salvo",
      sfirstAddLogotype: "Adicione um logotipo",
      logotypeSizeTip: "O logotipo será inserido no tamanho real, mas não maior que 120 pixels no lado mais longo.",
      cfirstLogotypeUpdated: "O logotipo foi adicionado",
      cfirstLogotypeDeleted: "O logotipo foi excluído com sucesso!",


      cOffersPageSettings: "Configurações",
      offerPageTitlePlaceholder: "Digite o título",
      offerPageDescriptionPlaceholder: "Digite a descrição da página",
      offerPageButtonTextPlaceholder: "Digite o texto do botão (opcional)",
      allstepsOffers: "Lista de ofertas",
      offerProposalHeader: "Oferta",
      offerAttachAddImg: "Adicionar imagem",
      offerAttachAddVideo: "Adicionar vídeo",
      offerItemImg: "Imagem",
      offerItemTitle: "Título da oferta",
      offerTitlePlaceholder: "Digite o título aqui",
      offerItemSubtitle: "Legenda (ex. preço)",
      offerSubtitlePlaceholder: "Digite o texto aqui",
      offerItemDescription: "Descrição da oferta",
      offerDescriptionPlaceholder: "Digite a descrição aqui",
      offerItemButtonText: "Texto do botão da oferta",
      offerBtnTextPlaceholder: "Digite o texto do botão",
      offerItemButtonLink: "Link do botão",
      offerBtnLinkPlaceholder: "O link deve começar com https://",
      csanyOfferLogic: "Lógica de exibição",
      offerAddNewOffer: "Adicionar nova oferta",
      offerLogicSetupTitle: "Configuração da lógica",
      OfferLogicSetupDescription: "Aqui você pode configurar quais respostas exibirão ofertas específicas",
      cstepsOffersPage: "Página de resultados",
      addNewSectionResultsByLogic: "Ofertas",
      cformActionAfterContactOffersOr: "Página de ofertas / ",
      tolltipOffersAfterContact: "Se, após concluir o quiz, a lógica de exibição de pelo menos uma oferta for atendida, a página de ofertas será exibida; caso contrário, a página de agradecimento será mostrada.",
      videoCircleTextQuestion: "Instrução em vídeo",
      offerPhotoOptimalRatio: "Para uma exibição ideal da imagem, recomendamos o uso da proporção 16:9.",
      tolltipThankYouAfterContact: "Após concluir o questionário, uma página de agradecimento será exibida.",
      cformActionAfterContactOffers: "Página de resultados",
      addOfferPageInContact: "Ativar página de resultados",
      offerPageHeader: "Cabeçalho para a página de ofertas",
      pumkinOrange: "Laranja",
      invalidSocialNetworkURL: "Link inválido", 
      itMustBeFullLink: 'Verifique se o link inserido está correto. Deve começar com o protocolo "https://" e corresponder à rede social armazenada.',
      addSocialLinks: "Adicione links sociais",
      questionAttachAddImg: "Foto",
      questionAttachAddVideo: "Video",
      questionChooseLineInput: "Em linha",
      questionChooseClassicInput: "Clássico",
      questionChooseOneColumn: "1 coluna",
      questionChooseTwoColumns: "2 colunas",
      allStepsVideoUrl: "Link al video",
      allStepsPhotoHeader: "Foto",
      cintegrationMenuSalesDrive: "SalesDrive",
      csettingsIntegrationSalesDrive: "Integração - SalesDrive",
      csettingsIntegrationSalesDriveAbout: "Você pode enviar leads para o CRM SalesDrive",
      cintegrationSalesDriveApiKey: "Insira a chave da API",
      cintegrationSalesDriveDomain: "Insira o domínio fornecido pelo SalesDrive",
      cintegrationSalesDriveDataSaved: "Integração com o SalesDrive salva",
      send_offers: "Enviar ofertas mostradas ao visitante",
      cformShowConsultant: "Mostrar consultor",
      consultantPhoto: "Foto do consultor",
      consultantName: "Nome do consultor",
      consultantJobTitle: "Cargo do consultor ou outras informações",
      consultantRating: "Avaliação do consultor",
      signinIWouldLikeReciveEmail: "Gostaria de receber novidades e ofertas especiais da ADS QUIZ (Você pode cancelar a subscrição dessas comunicações a qualquer momento).",
      acceptedFileSizeUpTo: "até",
      customDesignColorTags: "Tags",
      customDesignColorActiveButton: "Cor do elemento ativo",
      customDesignColorInactiveButton: "Cor do elemento inativo",
      customDesignColorActiveText: "Cor do texto ativo",
      customDesignColorInactiveText: "Cor do texto inativo",
      addNewSectionDropdown: "Dropdown",
      langFR: "Francês",
      addNewSectionRatePage: "Página de avaliação",
      bold_adsquiz_Offers_page: "adsquiz_Open-Offers-Page",
      cintegrationFBInstructionTextOffersPage: "Ir para a página de ofertas",
      defaultNewQuestionDropdownPlaceholder: "Clique aqui para abrir a lista de opções",
      allStepsVideoUrlPlaceholder: "https://youtube, vimeo ou wistia",
      addListOfAnswersButton: "Adicionar múltiplas",
      addListOfAnswersTitle: "Adição em massa de opções de resposta",
      addListOfAnswersInstruction: "Cole a lista de opções de resposta neste campo para adicioná-las. As opções podem ser separadas por quebras de linha [↵], ponto e vírgula [;], vírgulas [,] ou espaços [ ]. A separação ocorre pelo separador com a maior prioridade: [↵] → [;] → [,] → [ ].",
      addListOfAnswersPlaceholder1: "Resposta 1",
      addListOfAnswersPlaceholder2: "Resposta 2",
      addListOfAnswersSendButton: "Adicionar",
      addNewPerson: "Adicionar participante",
      cfirstGradientOverlay: "Sobreposição de fundo em gradiente",
      cfirstGradientOverlayTip: "A sobreposição de fundo em gradiente é útil se a imagem de fundo tiver pouco contraste com a cor do texto.",
      cfirstContentBorder: "Borda divisória do conteúdo",
      workboardDuplicateToOthers: "Copiar para outra conta",
      workboardDuplicateAndTransferQuiz: "Duplicar quiz para outra conta",
      workboardDuplicateAndTransferQuizHintTitle: "Ao duplicar um quiz, ele será copiado para a conta do destinatário como um modelo.",
      workboardDuplicateAndTransferQuizHintTitleSecond: "O quiz na conta do destinatário estará limpo, sem leads e integrações. O quiz atual permanecerá inalterado. Para copiar um quiz para outra conta, um dos usuários deve ter qualquer ",
      workboardDuplicateAndTransferQuizConfirm: "Duplicar",
      workboardDuplicateAndTransferQuizStatus200: "Quiz copiado com sucesso para a conta:",
      delOffersPageQuestionForModalConfirm: "Tem certeza de que deseja excluir a página de ofertas?",
      offerPageDefaultDescription: "Insira aqui a descrição da página de resultados",
      offerPageDefaultButtonText: "Concluir",
      cintegrationMenuKommo: "Kommo",
      csettingsIntegrationKommo: "Integracja - Kommo",
      csettingsIntegrationKommoAbout: "Możesz wysyłać leady do CRM Kommo",
      cintegrationKommoToken: 'Wstaw "Long-lived Token"',
      cintegrationKommoDomain: "Wstaw swój subdomenę",
      cintegrationKommoDataSaved: "Integracja Kommo została zapisana",
      cintegrationKommoPipelineId: "Wstaw PipelineID",
      cintegrationKommoPipelineIdPlaceholder: "Wybierz lejek",
      cintegrationKommoStatusID: "Wstaw StatusID",
      cintegrationKommoStatusIDPlaceholder: "Wybierz status nowego leada (opcjonalnie)",
      cintegrationKommoTagId: "Wstaw TagID",
      cintegrationKommoTagIdPlaceholder: "Wybierz tag dla nowego leada (opcjonalnie)",
      cintegrationKommoError: "Błąd podczas zapisywania integracji Kommo. Sprawdź poprawność wprowadzonych danych.",
      cintegrationKommoDeleted: "Integracja Kommo została usunięta",
      cintegrationKommoDeletedError: "Błąd podczas usuwania integracji Kommo. Spróbuj ponownie później.",
      cintegrationKommoCreateNote: "Tworzyć notatkę z odpowiedziami",
      cintegrationKommoUseMapping: "Używać mapowania pól",
      mappingValue: "Pole w CRM",
      mappingValueMailchimp: "Campo no Mailchimp",
      mappingKey: "Pole w leadzie",
      addMappingRow: "Dodaj powiązanie pól",
      DELETE: "Usuń",
      mappingAnswer: "Odpowiedź na pytanie",
      testIntegration: "Test",
      testIntegrationLast10Leads: "Test integracji (ostatnie 10 leadów)",
      testIntegrationNeedRealLeadTooltip: "O teste está disponível apenas se o quiz tiver pelo menos um lead real.",
      loading: "Ładowanie...",
      sentAt: "Wysłano",
      phone: "Telefon",
      email: "Email",
      action: "Działanie",
      send: "Wyślij",
      sending: "Wysyłanie...",
      success: "Sukces",
      failed: "Niepowodzenie",
      error: "Błąd",
      displayCondition: "Condição de exibição",
      selectDisplayCondition: "Selecionar condição de exibição",
      seconds: "Segundos",
      button: "Botão",
      buttonContainerSelector: "Seletor do contêiner do botão",
      buttonContainerSelectorPlaceholder: ".quiz-buttons ou #quiz-button-place",
      clickHere: "Clique aqui",
      buttonClick: "Clique no botão",
      clickOnWidget: "Clique no widget",
      exitIntent: "Ao sair da página",
      pageLoad: "Após o carregamento da página",
      delay: "Após algum tempo",
      resultPageSectionTitle: "Resultados por pontuação",
      resultPageSectionAccordion: "Página de resultados por pontuação",
      resultPageShowCondition: "Mostrar condição",
      resultPageShowCollectedPoints: "Mostrar pontos obtidos",
      resultPageShowMaxPoints: "Mostrar pontos máximos",
      resultPageShowProgressBar: "Mostrar barra de progresso",
      resultPageSelectFormat: "Selecionar formato de resultado",
      resultPageScenarios: "Cenários",
      resultPageAddScenario: "Adicionar cenário",
      resultPageScenarioPhoto: "Adicionar foto",
      resultPageScenarioTitle: "Título",
      resultPageScenarioTitlePlaceholder: "Insira o título do cenário",
      resultPageScenarioDescription: "Descrição",
      resultPageScenarioDescriptionPlaceholder: "Insira a descrição do cenário",
      resultPageScenarioUrlPlaceholder: "Link (https://)",
      resultPageScenarioButtonText: "Texto do botão",
      resultPageScenarioButtonTextPlaceholder: "Insira o texto do botão",
      resultPagePointsCondition: "Condição de exibição por pontos",
      resultPagePointsBetween: "Entre",
      resultPagePointsMoreThan: "Mais que",
      resultPagePointsLessThan: "Menos que",
      resultPagePointsEqual: "Igual a",
      resultPageErrorAddNewScenario: "Não foi possível adicionar o cenário",
      resultPageErrorRangeExplanation: "Adicione mais pontos ou redistribua-os entre os cenários",
      resultPageErrorFullRange: "Todos os intervalos de pontos já estão cobertos",
      resultPageErrorOutOfRange: "Os pontos estão fora do intervalo permitido",
      resultPageErrorSaving: "Błąd zapisywania scenariuszy",
      resultPageErrorOverlap: "Punkty w scenariuszach nie mogą się nakładać",
      resultPageAutoRedirectWarningTitle: "Redirecionamento automático desativado",
      resultPageAutoRedirectWarningText: "Para ativar o redirecionamento automático, adicione um URL em cada cenário de resultado.",
      resultPageAutoRedirectWarningButton: "OK",
      AddTags: "Adicionar etiquetas",
      resultPageModalDescription: "Atribua pontos a cada resposta.",
      resultPageYourOptions: "As suas opções",
      placeholderDefaultValue: "Valor",
      resultPageByPointsTitle: "Resultados por pontuação",
      resultPageConditionSettingsButton: "Lógica de pontuação",
      resultPageConditionSettingsSaved: "Salvo",
      resultPageConditionSettingsUnsaved: "Guardar",
      resultPagePlaceholderScenarioTitle: "Título do cenário",
      resultPagePlaceholderScenarioDescription: "Insira aqui uma breve descrição dos resultados",
      resultPageLabelScenarioCti: "Chamada à ação",
      resultPagePlaceholderScenarioCti: "Texto do botão",
      resultPagePlaceholderScenarioUrl: "Link do botão",
      resultPagePlaceholderRedirectUrl: "Link de redireccionamento",
      resultPageScenarioSaveChanges: "Guardar alterações",
      resultPageScenarioSaveChangesComplete: "Alterações guardadas",
      resultPageConditionSettingsTitle: "Definições de resultados por pontuação",
      resultPageConditionSettingsDescription: "Definir o intervalo de pontuação para cada cenário",
      resultPageConditionResultsColumn: "Resultados",
      resultPageConditionRangeSummary: "Intervalo máximo de pontuação:",
      addNewSectionSubHeaderChoise: "Inserção/seleção de resposta",
      addNewSectionSubHeaderResults: "Resultados",
      noTeamRole: "-",
      viewerTeamRole: "Visualizador",
      noAccessTeamRole: "Sem ações",
      editorTeamRole: "Editor",
      managerTeamRole: "Gerente",
      adminTeamRole: "Administrador",
      teamRoleGuideTitle: "O que significam os papéis",
      teamRoleGuideDescription: "Um papel ativa automaticamente um conjunto de permissões. Depois da escolha, o papel é atualizado na interface imediatamente e Send envia o acesso selecionado.",
      teamRoleGuideFlowOwner: "Proprietário",
      teamRoleGuideFlowOwnerText: "concede acesso",
      teamRoleGuideFlowRole: "Papel",
      teamRoleGuideFlowRoleText: "escolhe um modelo",
      teamRoleGuideFlowPermissions: "Permissões",
      teamRoleGuideFlowPermissionsText: "ativam ações",
      teamRoleGuideFlowResult: "Interface disponível",
      teamRoleGuideFlowResultText: "mostra controles",
      teamRoleGuideViewerDescription: "Pode ver leads e respostas dos quizzes selecionados.",
      teamRoleGuideEditorDescription: "Pode editar o quiz, copiá-lo e gerir a publicação.",
      teamRoleGuideManagerDescription: "Pode editar o quiz, ver CRM, gerir integrações e compartilhar acesso.",
      teamRoleGuideAdminDescription: "Recebe todas as permissões: gestão, integrações, CRM, acessos, transferência, exclusão e publicação.",
      canViewLeadsLabel: "Visualizar leads",
      canViewLeadsDescription: "Pode visualizar envios, respostas e contatos",
      canCopyQuizLabel: "Copiar quiz",
      canCopyQuizDescription: "Pode criar cópias do quiz selecionado",
      canManageQuestionsLabel: "Edição do quiz",
      canManageQuestionsDescription: "Pode editar o quiz, páginas, perguntas, variantes, consultores, benefícios, campos de contato, redes sociais e opções",
      canManageIntegrationsLabel: "Integrações",
      canManageIntegrationsDescription: "Pode gerenciar integrações, chaves e webhooks",
      canManageSettingsLabel: "Configurações",
      canManageSettingsDescription: "Pode alterar domínios, páginas e campos de contato",
      canShareLabel: "Acessos",
      canShareDescription: "Pode convidar outros usuários",
      canTransferLabel: "Transferência do quiz",
      canTransferDescription: "Pode transferir o quiz para outro usuário",
      canDeleteLabel: "Exclusão",
      canDeleteDescription: "Pode excluir e restaurar o quiz",
      canPublishLabel: "Publicação",
      canPublishDescription: "Pode gerenciar publicação e domínios",
      descriptionTeamView: "Adicione participantes e configure os acessos a projetos e quizzes",
      addedUserInTeam: "Na equipe",
      teamAccessGivenTab: "Membros da equipe",
      teamAccessReceivedTab: "Origem do acesso",
      teamAccessReceivedTitle: "Acesso concedido a você",
      teamAccessSharedBy: "Proprietário",
      teamAccessInvitedBy: "Convidado por",
      teamAccessRoleLabel: "Função",
      teamAccessScopeLabel: "Acesso",
      teamNoReceivedAccess: "Ninguém concedeu acesso a você ainda",
      teamNoGivenAccess: "Você ainda não concedeu acesso a ninguém",
      teamAccessFrozen: "Acesso congelado",
      teamFreezeAccess: "Congelar acesso",
      teamUnfreezeAccess: "Descongelar acesso",
      teamPermissionDeniedTransfer: "You do not have permission to move this quiz",
      teamPermissionDeniedDelete: "You do not have permission to delete or restore this quiz",
      teamPermissionDeniedShare: "You do not have permission to manage sharing",
      teamPermissionDeniedManageQuiz: "You do not have permission to edit this quiz",
      teamPermissionDeniedCopy: "You do not have permission to copy this quiz",
      teamPermissionDeniedIntegrations: "You do not have permission to manage integrations",
      teamPermissionDeniedCrm: "You do not have permission to view CRM",
      teamPermissionDeniedPublish: "You do not have permission to publish this quiz",
      teamPermissionDeniedSettings: "You do not have permission to open this settings section",
      teamPermissionDeniedOpenQuiz: "You do not have available actions for this quiz",
      teamAccessDeniedTitle: "Section unavailable",
      teamAccessDeniedDescription: "You do not have permission for this action. Ask the project owner to grant access",
      teamPermissionDeniedDefault: "You do not have permission for this action",
      teamQuizzesWithoutProject: "Quizzes without project",
      quickInviteTitle: "Convidar membro da equipe",
      quickInviteEmailLabel: "E-mail",
      quickInviteQuizzesLabel: "Questionários para compartilhar",
      quickInviteLoadingQuizzes: "Carregando questionários…",
      quickInviteLoadQuizzesError: "Não foi possível carregar os questionários.",
      quickInviteRetry: "Tentar novamente",
      quickInviteNoQuizzes: "Você ainda não tem questionários que possa compartilhar.",
      quickInviteRoleHint: "A pessoa receberá a função selecionada nos questionários selecionados. Você pode alterá-la depois na {link}.",
      quickInviteRoleHintLink: "página Equipe",
      quickInviteSubmit: "Convidar",
      quickInviteSubmitting: "Enviando…",
      quickInviteSelfError: "Você não pode convidar a si mesmo",
      quickInviteSelectQuiz: "Selecione pelo menos um questionário",
      quickInviteSuccess: "Convite enviado para {email}",
      projectNoQuizzes: "0 questionários",
      quizzes: "questionários",
      sharedQuizzes: "Questionários compartilhados",
      sharedQuizzesWithoutProject: "Questionários sem projeto",

    }
  },
})
export default i18n
